import { __decorate, __metadata } from 'tslib';
import { HttpParams, HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Optional, EventEmitter, Component, ChangeDetectionStrategy, Output, Directive, Input, HostListener, HostBinding, ViewChild, ChangeDetectorRef, Renderer2, ElementRef, TemplateRef, ContentChild, KeyValueDiffers, forwardRef, ContentChildren, ViewEncapsulation, ApplicationRef, ViewChildren, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@mobilize/angularclient';
import { WebMapService, NotifyChange, WebMapUtils, WMConstants, WebMapModule } from '@mobilize/angularclient';
import * as i3 from '@mobilize/base-components';
import { EventData as EventData$1, ValidateObject, FilterObject, serverEvent, dataTransfer, BringTopService, ContainerComponent, TypeResolver, RemoveAmpersand, BaseComponentsModule } from '@mobilize/base-components';
import { Subject, of } from 'rxjs';
import { WMLogger } from '@mobilize/logging';
import * as i10 from '@progress/kendo-angular-tooltip';
import { TooltipDirective, TooltipModule } from '@progress/kendo-angular-tooltip';
import { isSafePattern } from 'redos-detector';
import { Dictionary, Events, ExceptionHandlerClass, ErrorCodes, RequestConfig, ActionModelV5, SendV5 } from '@mobilize/webmap-core';
import * as i7 from '@progress/kendo-angular-dialog';
import { WindowComponent, DialogComponent, DialogsModule } from '@progress/kendo-angular-dialog';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@angular/forms';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import * as i6$1 from '@progress/kendo-angular-dateinputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import * as i6$2 from '@progress/kendo-angular-buttons';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import * as i4 from '@progress/kendo-angular-charts';
import { ChartsModule } from '@progress/kendo-angular-charts';
import * as i8 from '@progress/kendo-angular-inputs';
import { TextBoxComponent as TextBoxComponent$1, InputsModule } from '@progress/kendo-angular-inputs';
import * as i8$1 from '@progress/kendo-angular-dropdowns';
import { AutoCompleteComponent, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import * as i8$2 from '@progress/kendo-angular-label';
import { LabelModule } from '@progress/kendo-angular-label';
import * as i5$1 from 'angular-draggable-droppable';
import { DragAndDropModule } from 'angular-draggable-droppable';
import { process } from '@progress/kendo-data-query';
import * as i7$1 from '@progress/kendo-angular-grid';
import { GridModule } from '@progress/kendo-angular-grid';
import * as i3$3 from '@progress/kendo-angular-intl';
import { formatDate, IntlService } from '@progress/kendo-angular-intl';
import { map, debounceTime } from 'rxjs/operators';
import * as i3$1 from '@progress/kendo-angular-menu';
import { MenuModule } from '@progress/kendo-angular-menu';
import * as i8$3 from '@progress/kendo-angular-toolbar';
import { ToolBarToolComponent, ToolBarModule } from '@progress/kendo-angular-toolbar';
import * as i6$3 from '@progress/kendo-angular-layout';
import { SelectEvent, LayoutModule } from '@progress/kendo-angular-layout';
import * as i7$2 from '@progress/kendo-angular-treeview';
import { TreeViewComponent as TreeViewComponent$1, TreeViewModule } from '@progress/kendo-angular-treeview';
import * as i3$2 from '@progress/kendo-angular-popup';
import { PopupService, PopupModule } from '@progress/kendo-angular-popup';
import * as i1$1 from '@angular/platform-browser';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import * as i6$4 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import { isAligned, alignCenterRules, alignRightRules } from '@progress/kendo-editor-common';
import * as i6$5 from '@progress/kendo-angular-progressbar';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import '@progress/kendo-ui';

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Decorates a Property Setter to call markForCheck if CodeSeparationFeature is true.
 */
function MarkForCheck() {
    return function (target, key, descriptor) {
        const originalMethod = descriptor.set;
        descriptor.set = function (newVal) {
            originalMethod.apply(this, [newVal]);
            if (WebMapService &&
                WebMapService.currentService &&
                WebMapService.currentService.config &&
                WebMapService.currentService.config.CodeSeparationFeature) {
                this.markForCheck();
            }
        };
        return descriptor;
    };
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class ContainerInteractionService {
    constructor() {
        this.eventEmitted = new Subject();
    }
    /**
     * Gets event emitted notification
     */
    get EventEmittedNotification() {
        return this.eventEmitted.asObservable();
    }
    /**
     * Notifies an event to the container
     * component
     * @param event The current event data
     */
    notifyEvent(event) {
        this.eventEmitted.next(event);
    }
}
ContainerInteractionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerInteractionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ContainerInteractionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerInteractionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerInteractionService, decorators: [{
            type: Injectable
        }] });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Dock style enum.
 */
var DockStyle;
(function (DockStyle) {
    //
    // Summary:
    //     The control is not docked.
    DockStyle[DockStyle["None"] = 0] = "None";
    //
    // Summary:
    //     The control's top edge is docked to the top of its containing control.
    DockStyle[DockStyle["Top"] = 1] = "Top";
    //
    // Summary:
    //     The control's bottom edge is docked to the bottom of its containing control.
    DockStyle[DockStyle["Bottom"] = 2] = "Bottom";
    //
    // Summary:
    //     The control's left edge is docked to the left edge of its containing control.
    DockStyle[DockStyle["Left"] = 3] = "Left";
    //
    // Summary:
    //     The control's right edge is docked to the right edge of its containing control.
    DockStyle[DockStyle["Right"] = 4] = "Right";
    //
    // Summary:
    //     All the control's edges are docked to the all edges of its containing control
    //     and sized appropriately.
    DockStyle[DockStyle["Fill"] = 5] = "Fill";
})(DockStyle || (DockStyle = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 *Specifies how a control will behave when the AnchorStyles is set
 * Using bitwise declarations to allow multiple styles at once
 */
var AnchorStyles;
(function (AnchorStyles) {
    //
    // Summary:
    //     The control is not anchored to any edges of its container.
    AnchorStyles[AnchorStyles["None"] = 0] = "None";
    //
    // Summary:
    //     The control is anchored to the top edge of its container.
    AnchorStyles[AnchorStyles["Top"] = 1] = "Top";
    //
    // Summary:
    //     The control is anchored to the bottom edge of its container.
    AnchorStyles[AnchorStyles["Bottom"] = 2] = "Bottom";
    //
    // Summary:
    //     The control is anchored to the left edge of its container.
    AnchorStyles[AnchorStyles["Left"] = 4] = "Left";
    //
    // Summary:
    //     The control is anchored to the right edge of its container.
    AnchorStyles[AnchorStyles["Right"] = 8] = "Right"; // 1000 - 8
})(AnchorStyles || (AnchorStyles = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class AnchorService {
    /**
     * Applies anchor to component
     * Verifies the current component anchor property to set the values that should fix the component's
     * position in the screen according to the anchor expected behavior of winforms platform
     * @param component the current component instance
     */
    applyAnchorToComponent(component, parentComponent) {
        this.applyAnchorToChildren(component);
        if (((component.anchorApplied !== component.anchor &&
            IsAnchorStyle(component, AnchorStyles.Bottom)) ||
            IsAnchorStyle(component, AnchorStyles.Right)) &&
            !component.useCss) {
            component.anchorApplied = component.anchor;
            let specialDockHeight;
            let specialDockWidth;
            if (parentComponent && parentComponent.specialDock) {
                const offsets = { top: 0, bottom: 0, left: 0, right: 0 };
                const size = {
                    width: getComputedValue(parentComponent.displayElement, 'width', 0),
                    height: getComputedValue(parentComponent.displayElement, 'height', 0)
                };
                const newValues = parentComponent.processSpecialDock(component, size, offsets);
                specialDockHeight =
                    newValues.size.height -
                        newValues.offsets.top -
                        newValues.offsets.bottom;
                specialDockWidth =
                    newValues.size.width -
                        newValues.offsets.left -
                        newValues.offsets.right;
            }
            applyBottomAnchor(component, specialDockHeight, parentComponent);
            applyRightAnchor(component, specialDockWidth, parentComponent);
        }
    }
    applyAnchorToChildren(component) {
        for (const child of component.children) {
            this.applyAnchorToComponent(child, component);
        }
    }
}
AnchorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AnchorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AnchorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AnchorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AnchorService, decorators: [{
            type: Injectable
        }] });
/**
 * Determines whether component anchor contains a determinate anchor style
 * @param component the current component anchor is being applied
 * @param style the current style that is being verified
 * @returns true if anchor style is in the anchor property.
 */
function IsAnchorStyle(component, style) {
    return (component.anchor & style) === style;
}
/**
 * Applies the difference in case is greater or equal than 0,
 * this depending on wich AnchorStyle is in use.
 * @param component the current component anchor is being applied
 * @param style the current style that is being used
 * @param difference the difference between the measures of the component.
 */
function applyDifferenceCase(component, style, difference) {
    /* c8 ignore else*/
    if (difference >= 0 && component.displayElement) {
        if (style === AnchorStyles.Bottom) {
            component['renderer'].setStyle(component.displayElement, 'bottom', `${difference}px`);
            updateComponentStyle(component, 'bottom', `${difference}px`);
            const args = IsAnchorStyle(component, AnchorStyles.Top)
                ? ['height', 'auto']
                : ['top', 'auto'];
            component['renderer'].setStyle(component.displayElement, args[0], args[1]);
            updateComponentStyle(component, args[0], args[1]);
        }
        else {
            component['renderer'].setStyle(component.displayElement, 'right', `${difference}px`);
            updateComponentStyle(component, 'right', `${difference}px`);
            const args = IsAnchorStyle(component, AnchorStyles.Left)
                ? ['width', 'auto']
                : ['left', 'auto'];
            component['renderer'].setStyle(component.displayElement, args[0], args[1]);
            updateComponentStyle(component, args[0], args[1]);
        }
    }
}
/**
 * Updates component style
 * Updates style object for dynamically created components
 * @param component the component instance
 * @param style the property to update
 * @param value the value to update
 */
function updateComponentStyle(component, style, value) {
    /* c8 ignore else */
    if (component.model.Style) {
        const nameCapitalized = style.charAt(0).toUpperCase() + style.slice(1);
        component.model.Style[nameCapitalized] = value;
    }
}
function getStyleValue(component, property) {
    if (!component.isComponentReady() && component.style) {
        return parseInt(component.style[property], 10) || 0;
    }
    return (parseInt(getComputedStyle(component.displayElement)[property], 10) || 0);
}
function applyBottomAnchor(component, specialDockHeight, parentComponent) {
    if (IsAnchorStyle(component, AnchorStyles.Bottom)) {
        const componentY = getStyleValue(component, 'top');
        const componentMargins = getStyleValue(component, 'margin-top') +
            getStyleValue(component, 'margin-bottom');
        const componentHeight = getStyleValue(component, 'height') ||
            getComputedValue(component.displayElement, 'height', 0);
        const parentHeight = specialDockHeight ||
            parentComponent.originalHeight ||
            getComputedValue(parentComponent.displayElement, 'bottom', 0);
        const componentBottom = componentY + componentMargins + componentHeight;
        const bottomDifference = parentHeight - componentBottom;
        applyDifferenceCase(component, AnchorStyles.Bottom, bottomDifference);
    }
}
function applyRightAnchor(component, specialDockWidth, parentComponent) {
    if (IsAnchorStyle(component, AnchorStyles.Right)) {
        const componentX = getStyleValue(component, 'left');
        const componentMargins = getStyleValue(component, 'margin-right') +
            getStyleValue(component, 'margin-left');
        const componentWidth = getStyleValue(component, 'width') ||
            getComputedValue(component.displayElement, 'width', 0);
        const parentWidth = specialDockWidth ||
            parentComponent.originalWidth ||
            getComputedValue(parentComponent.displayElement, 'width', 0);
        const componentRight = componentX + componentMargins + componentWidth;
        const rightDifference = parentWidth - componentRight;
        applyDifferenceCase(component, AnchorStyles.Right, rightDifference);
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Constants
 */
const boxSizing = 'box-sizing';
const borderBox = 'border-box';
class WebComponentsService {
    constructor(anchorService) {
        this.anchorService = anchorService;
        this.pendingParentsCollection = [];
        /**
         * Delay of buffer calls for the startDocking
         */
        this.delay = 150;
        /**
         * Forms called from the components detectChanges or syncCompleted event.
         * see more in the ngOnInit of any
         */
        this.formsCalled = {};
        /**
         * Anchor called of web components service
         * To keep tracking of anchored forms
         */
        this.anchorCalled = {};
        this.componentsCollection = {};
    }
    /**
     * Registers each component of the app in the componentsCollection.
     * Each component should be register by the ngOnInit lifecycle.
     * The control-container-winforms-base.component and control-winforms-base.component call this method
     * @param component Angular Component to register.
     */
    registerComponent(component) {
        this.componentsCollection[component.id] = component;
        if (this.isParentCandidate(component)) {
            this.processPendingParentCollection();
        }
        if (component.parent != null) {
            const parentInstance = this.getParent(component);
            if (parentInstance) {
                this.processDockInRegisterComponent(component, parentInstance);
                this.processChildrenCollection(parentInstance, component);
            }
            else {
                this.processOrphanComponent(component);
            }
        }
        else if (component.model && !component.model.IsForm) {
            WMLogger.instance().warn(`the component id: ${component.id}, name:${component.name} does not have a parent reference`);
        }
    }
    /**
     * Process orphan component, when the component have a parent but the parent is not ready yet.
     * @param component component to process
     */
    processOrphanComponent(component) {
        this.pendingParentsCollection.push(component);
        WMLogger.instance().warn(`The parentInstance of ${component.id} is null for: ${component}`);
    }
    /**
     * Process children collection for the component's parent
     * @param parentInstance parent of the component
     * @param component the component to process
     */
    processChildrenCollection(parentInstance, component) {
        const childIndex = parentInstance.children.findIndex((el) => el.id === component.id);
        /* c8 ignore else */
        if (childIndex === -1) {
            parentInstance.children.push(component);
            // When new children are included we need to trigger the autosizing feature again
            parentInstance.autoSizeApplied = false;
        }
    }
    /**
     * Process dock when the component is registering
     * @param component component to process
     * @param parentInstance parent of the component
     */
    processDockInRegisterComponent(component, parentInstance) {
        /* c8 ignore else */
        if (component.defaultDock) {
            // we need to put the top first, then the bottom and the rest at the end.
            if (component.dock === DockStyle.Top) {
                parentInstance.defaultControls.splice(0, 0, component);
            }
            else if (component.dock === DockStyle.Bottom) {
                const dockIndex = parentInstance.defaultControls.findIndex((el) => el.dock > DockStyle.Top);
                if (dockIndex !== -1) {
                    parentInstance.defaultControls.splice(dockIndex, 0, component);
                }
                else {
                    parentInstance.defaultControls.push(component);
                }
            }
            else {
                parentInstance.defaultControls.push(component);
            }
        }
    }
    /**
     * Process pending parent collection
     * Includes pending to assign parent collected items in
     * the controls collection
     */
    processPendingParentCollection() {
        const pending = [];
        this.pendingParentsCollection.forEach((component) => {
            const parentInstance = this.getParent(component);
            if (parentInstance) {
                parentInstance.children.push(component);
                component.resolvePendingTabSubscriptions();
            }
            else {
                pending.push(component);
            }
        });
        this.pendingParentsCollection = pending;
    }
    /**
     * unregister the component from the collection.
     * first remove the references from the parent,
     * the remove the references from the componentsCollection
     * @param component
     */
    unRegisterComponent(component) {
        const parentInstance = this.getParent(component);
        /* c8 ignore else */
        if (parentInstance != null && parentInstance.dockingOrder) {
            const index = parentInstance.dockingOrder.findIndex((id) => id === component.id);
            /* c8 ignore else */
            if (WebMapService.currentService) {
                const validModel = WebMapService.currentService.core.getModel(component.id);
                /* c8 ignore else */
                if (index !== -1 && !validModel) {
                    parentInstance.dockingOrder.splice(index, 1);
                }
            }
        }
        /* c8 ignore else */
        if (this.componentsCollection[component.id]) {
            delete this.componentsCollection[component.id];
        }
        /* c8 ignore else */
        if (this.anchorCalled[component.id]) {
            delete this.anchorCalled[component.id];
        }
    }
    /**
     * Starts docking from the form. use the throttling process to avoid process each time the dock.
     * @param component form to execute the dock process
     */
    startDocking(component) {
        /* c8 ignore else */
        if (!this.formsCalled[component.id] && !component.useCss) {
            this.formsCalled[component.id] = component;
            setTimeout(() => {
                for (const componentId in this.formsCalled) {
                    /* c8 ignore else */
                    if (this.formsCalled.hasOwnProperty(componentId)) {
                        WMLogger.instance().info(`Start Docking process calculatePosition for : ${this.formsCalled[componentId].name}`);
                        this.calculatePosition(this.formsCalled[componentId]);
                        WMLogger.instance().info(`End Docking process calculatePosition for : ${this.formsCalled[componentId].name}`);
                        delete this.formsCalled[componentId];
                    }
                }
            }, this.delay);
        }
    }
    /**
     * Applies anchor to component
     * According to the anchor value in the component
     * this function should call the anchor service to apply
     * the expected transformation.
     * @param component the current component
     */
    applyAnchorToComponent(component) {
        /* c8 ignore else */
        if (!this.anchorCalled[component.id] && this.anchorService) {
            const parentInstance = this.getParent(component);
            this.anchorService.applyAnchorToComponent(component, parentInstance);
            this.anchorCalled[component.id] = true;
        }
    }
    /**
     * Saves initial values.
     * used to keep the initial position of the control in case the dock return to none.
     * try to get from the model or computed position by the browser.
     * @param component
     */
    saveInitialValues(component) {
        component['initial'] = {};
        component['initial'].width = component.width
            ? component.width
            : getComputedValue(component.displayElement, 'width', -1);
        component['initial'].height = component.height
            ? component.height
            : getComputedValue(component.displayElement, 'height', -1);
        component['initial'].top = component.top
            ? component.top
            : component.displayElement.offsetTop;
        component['initial'].left = component.left
            ? component.left
            : component.displayElement.offsetLeft;
    }
    /**
     * calls when a component changes the value of the dock or when is called explicitly
     * @param component component with the new value of dock
     */
    dockChange(component) {
        const parentInstance = this.getParent(component);
        // if the parent is null or empty, we cannot calculate the dock for the component.
        // the mechanism needs to know the container of the control at all times.
        if (parentInstance) {
            this.calculatePosition(parentInstance);
        }
        else {
            WMLogger.instance().warn(`component: ${component}, ParentId: ${component.model.Parent}`);
        }
    }
    /**
     * Calculates position foreach component in the order list
     * @param component component with the change in the dock property
     */
    calculatePosition(parentInstance) {
        // Refresh destroyed components references
        parentInstance =
            parentInstance && parentInstance.ref && parentInstance.ref.destroyed
                ? this.componentsCollection[parentInstance.id]
                : parentInstance;
        /* c8 ignore else */
        if (!parentInstance) {
            return;
        }
        /* c8 ignore else */
        if (parentInstance.dockingOrder &&
            parentInstance.defaultControls &&
            (parentInstance.dockingOrder.length > 0 ||
                parentInstance.defaultControls.length > 0)) {
            parentInstance.order = [];
            if (parentInstance.defaultControls.length > 0) {
                this.createOrderArrayForComponent(parentInstance);
            }
            else {
                this.createOrderArrayForComponentWithoutDefaultControls(parentInstance);
            }
            parentInstance.setDisplayElementOriginalDimensions();
            this.processDock(parentInstance);
        }
        // process each child order collection in order to adjust the new position for the children
        for (const currentComponent of parentInstance.children) {
            /* c8 ignore else */
            if (!currentComponent.children.find((child) => {
                return child.id === currentComponent.parent;
            })) {
                this.calculatePosition(currentComponent);
            }
        }
    }
    /**
     * Creates order array for component without exclude the default controls.
     * @param parentInstance the parent component for the current component
     */
    createOrderArrayForComponentWithoutDefaultControls(parentInstance) {
        const newOrder = [];
        parentInstance.dockingOrder.forEach((id) => {
            const currentComponent = this.componentsCollection[id];
            if (currentComponent != null) {
                newOrder.push(currentComponent);
                parentInstance.order = newOrder;
            }
            else {
                WMLogger.instance().warn(`this component is not found: ${id}`);
            }
        });
    }
    /**
     * Creates order array for component excluding the defaultControls
     * @param parentInstance the parent component for the current component
     */
    createOrderArrayForComponent(parentInstance) {
        const newOrder = [];
        parentInstance.dockingOrder.forEach((id) => {
            const currentComponent = this.componentsCollection[id];
            if (currentComponent != null) {
                // ignore any defaultControl from the dockingOrder, because the defaultControls should be processed first.
                const index = parentInstance.defaultControls.findIndex((element) => element.id === currentComponent.id);
                /* c8 ignore else */
                if (index === -1) {
                    newOrder.push(currentComponent);
                    parentInstance.order = newOrder;
                }
            }
            else {
                WMLogger.instance().warn('this component is not found: ', id);
            }
        });
    }
    /**
     * Process the dock property for each children of the parentInstance.
     * get the parent size, and keep the offset after render the control in the container.
     * @param parentInstance Parent whose children will be processed.
     */
    processDock(parentInstance) {
        /* c8 ignore else */
        if (parentInstance.order) {
            /* c8 ignore else */
            if (parentInstance.displayElement && !parentInstance.useCss) {
                // this line is here, because we need to fix the size before we get it.
                parentInstance['renderer'].setStyle(parentInstance.displayElement, boxSizing, borderBox);
            }
            // the fillComponents should be processed after others have finished. Array to keep the fill components.
            const fillComponents = [];
            const offsets = { top: 0, bottom: 0, left: 0, right: 0 };
            const size = {
                width: getComputedValue(parentInstance.displayElement, 'width', 0),
                height: getComputedValue(parentInstance.displayElement, 'height', 0)
            };
            const components = parentInstance.defaultControls.concat(parentInstance.order);
            this.processComponents(components, parentInstance, size, offsets, fillComponents);
            this.processFillDockAfterOtherDock(fillComponents, parentInstance, size, offsets);
        }
    }
    processComponents(components, parentInstance, size, offsets, fillComponents) {
        let index = 0;
        // When a component change from any dock to none, should be deleted from the collection.
        // Please review if it is need it with the new dockingOrder.
        const elementToDelete = [];
        for (const currentComponent of components) {
            if (!currentComponent.useCss) {
                /* c8 ignore else */
                if (!currentComponent.isComponentReady()) {
                    WMLogger.instance().info(`The component is not Ready in the DOM: ${currentComponent.name}`);
                    index++;
                    continue;
                }
                // save the initial position of the component
                /* c8 ignore else */
                if (currentComponent['initial'] === undefined) {
                    this.saveInitialValues(currentComponent);
                }
                // special case for process the dock, you can reset the size of the parent and the offsets for the children
                /* c8 ignore else */
                if (parentInstance.specialDock &&
                    currentComponent.dock !== DockStyle.Fill) {
                    const newValues = parentInstance.processSpecialDock(currentComponent, size, offsets);
                    size = newValues.size;
                    offsets = newValues.offsets;
                }
                offsets = this.processDockCases(currentComponent, offsets, size, fillComponents, elementToDelete, index);
                currentComponent.specialStyle();
                index++;
            }
        }
    }
    /**
     * Process fill dock after other dock properties.
     * @param fillComponents array with the components to process.
     * @param parentInstance parent of the components.
     * @param size the parent size used.
     * @param offsets offsets of the other components.
     */
    processFillDockAfterOtherDock(fillComponents, parentInstance, size, offsets) {
        for (const currentComponent of fillComponents) {
            if (!currentComponent.useCss) {
                if (parentInstance.specialDock) {
                    const newValues = parentInstance.processSpecialDock(currentComponent, size, offsets);
                    this.processFill(newValues.size, currentComponent, newValues.offsets);
                }
                else {
                    this.processFill(size, currentComponent, offsets);
                }
                currentComponent.specialStyle();
            }
        }
    }
    /**
     * Process dock cases for each case
     * @param currentComponent component to process
     * @param offsets keep the space between components
     * @param size parent size
     * @param fillComponents collection of components that are with dock = fill
     * @param elementToDelete element that are with the dock = none to delete
     * @param index index of the order array
     * @returns returns the new offsets with the new element located
     */
    processDockCases(currentComponent, offsets, size, fillComponents, elementToDelete, index) {
        // should be currentComponent.dock, but we need to add dock in control first.
        const dock = currentComponent.dock != null ? currentComponent.dock : DockStyle.None;
        switch (dock) {
            case DockStyle.Top:
                offsets = this.processTop(size, currentComponent, offsets);
                break;
            case DockStyle.Bottom:
                offsets = this.processBottom(size, currentComponent, offsets);
                break;
            case DockStyle.Left:
                offsets = this.processLeft(size, currentComponent, offsets);
                break;
            case DockStyle.Right:
                offsets = this.processRight(size, currentComponent, offsets);
                break;
            case DockStyle.Fill:
                fillComponents.push(currentComponent);
                break;
            default:
                this.processNone(currentComponent);
                elementToDelete.push(index);
                break;
        }
        return offsets;
    }
    /**
     * Process none dock. should return to the initial position.
     * @param currentComponent component to process
     */
    processNone(currentComponent) {
        const element = currentComponent.displayElement;
        currentComponent['renderer'].setStyle(element, 'width', `${currentComponent['initial'].width}px`);
        currentComponent['renderer'].setStyle(element, 'height', `${currentComponent['initial'].height}px`);
        currentComponent['renderer'].setStyle(element, 'top', `${currentComponent['initial'].top}px`);
        currentComponent['renderer'].setStyle(element, 'left', `${currentComponent['initial'].left}px`);
    }
    /**
     * Process bottom dock. Should change the width and keep the height
     * @param size container size
     * @param component component to process
     * @param offsets object that save the restrictions of area.
     * @returns the new offset
     */
    processBottom(size, component, offsets) {
        const newWidth = size.width - offsets.left - offsets.right;
        const element = component.displayElement;
        component['renderer'].setStyle(element, 'position', 'absolute');
        component['renderer'].setStyle(element, 'width', `${newWidth}px`);
        component['renderer'].setStyle(element, 'height', `${component['initial'].height}px`);
        component['renderer'].setStyle(element, 'bottom', `${offsets.bottom}px`);
        component['renderer'].setStyle(element, 'right', `${offsets.right}px`);
        component['renderer'].setStyle(element, 'left', `${offsets.left}px`);
        component['renderer'].setStyle(element, 'top', 'unset');
        component['renderer'].setStyle(element, 'padding', '0');
        component['renderer'].setStyle(element, 'margin', '0');
        component['renderer'].setStyle(element, boxSizing, borderBox);
        offsets.bottom += getComputedValue(element, 'height', 0);
        return offsets;
    }
    /**
     * Process Fill dock. Should change the width and/or the height
     * @param size container size
     * @param component component to process
     * @param offsets object that save the restrictions of area.
     * @returns the new offset
     */
    processFill(size, component, offsets) {
        let newHeight = size.height - offsets.top - offsets.bottom;
        let newWidth = size.width - offsets.left - offsets.right;
        newHeight = newHeight > 0 ? newHeight : 0;
        newWidth = newWidth > 0 ? newWidth : 0;
        const element = component.displayElement;
        component['renderer'].setStyle(element, 'position', 'absolute');
        component['renderer'].setStyle(element, 'height', `${newHeight}px`);
        component['renderer'].setStyle(element, 'width', `${newWidth}px`);
        component['renderer'].setStyle(element, 'top', `${offsets.top}px`);
        component['renderer'].setStyle(element, 'left', `${offsets.left}px`);
        component['renderer'].setStyle(element, 'right', `${offsets.right}px`);
        component['renderer'].setStyle(element, 'bottom', `${offsets.bottom}px`);
        component['renderer'].setStyle(element, 'padding', '0');
        component['renderer'].setStyle(element, boxSizing, borderBox);
        component['renderer'].setStyle(element, 'margin', '0');
    }
    /**
     * Process left dock. Should change the height and keep the width
     * @param size container size
     * @param component component to process
     * @param offsets object that save the restrictions of area.
     * @returns the new offset
     */
    processLeft(size, component, offsets) {
        const newHeight = size.height - offsets.top - offsets.bottom;
        const element = component.displayElement;
        component['renderer'].setStyle(element, 'position', 'absolute');
        component['renderer'].setStyle(element, 'height', `${newHeight}px`);
        component['renderer'].setStyle(element, 'width', `${component['initial'].width}px`);
        component['renderer'].setStyle(element, 'top', `${offsets.top}px`);
        component['renderer'].setStyle(element, 'left', `${offsets.left}px`);
        component['renderer'].setStyle(element, 'right', 'unset');
        component['renderer'].setStyle(element, 'padding', '0');
        component['renderer'].setStyle(element, 'margin', '0');
        component['renderer'].setStyle(element, boxSizing, borderBox);
        offsets.left += getComputedValue(element, 'width', 0);
        return offsets;
    }
    /**
     * Process right dock. Should change the height and keep the width
     * @param size container size
     * @param component component to process
     * @param offsets object that save the restrictions of area.
     * @returns the new offset
     */
    processRight(size, component, offsets) {
        const newHeight = size.height - offsets.top - offsets.bottom;
        const element = component.displayElement;
        component['renderer'].setStyle(element, 'position', 'absolute');
        component['renderer'].setStyle(element, 'height', `${newHeight}px`);
        component['renderer'].setStyle(element, 'width', `${component['initial'].width}px`);
        component['renderer'].setStyle(element, 'top', `${offsets.top}px`);
        component['renderer'].setStyle(element, 'right', `${offsets.right}px`);
        component['renderer'].setStyle(element, 'left', 'unset');
        component['renderer'].setStyle(element, 'padding', '0');
        component['renderer'].setStyle(element, 'margin', '0');
        component['renderer'].setStyle(element, boxSizing, borderBox);
        offsets.right += getComputedValue(element, 'width', 0);
        return offsets;
    }
    /**
     * Process top dock. Should change the width and keep the height
     * @param size container size
     * @param component component to process
     * @param offsets object that save the restrictions of area.
     * @returns the new offset
     */
    processTop(size, component, offsets) {
        const newWidth = size.width - offsets.left - offsets.right;
        const element = component.displayElement;
        component['renderer'].setStyle(element, 'position', 'absolute');
        component['renderer'].setStyle(element, 'width', `${newWidth}px`);
        component['renderer'].setStyle(element, 'height', `${component['initial'].height}px`);
        component['renderer'].setStyle(element, 'top', `${offsets.top}px`);
        component['renderer'].setStyle(element, 'right', `${offsets.right}px`);
        component['renderer'].setStyle(element, 'left', `${offsets.left}px`);
        component['renderer'].setStyle(element, 'bottom', 'unset');
        component['renderer'].setStyle(element, 'padding', '0');
        component['renderer'].setStyle(element, 'margin', '0');
        component['renderer'].setStyle(element, boxSizing, borderBox);
        offsets.top += getComputedValue(element, 'height', 0);
        return offsets;
    }
    /**
     * Gets parent from the model
     * @param component to get the parent instance that should be in the componentsCollection
     * @returns parent Instance or null
     */
    getParent(component) {
        const parentIdString = component.model.Parent;
        return this.componentsCollection[parentIdString];
    }
    /**
     * Determines if component received as parameter is parent candidate
     * @param component Component reference
     * @returns True if component is a parent
     */
    isParentCandidate(component) {
        return (component.isContainer || component.isUserControl() || component.isForm);
    }
}
WebComponentsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebComponentsService, deps: [{ token: AnchorService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
WebComponentsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebComponentsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebComponentsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AnchorService, decorators: [{
                    type: Optional
                }] }]; } });
/**
 * Gets computed value
 * @param nativeElement DOM element
 * @param property property to search
 * @param defaultValue default value if item value cannot be obtained
 * @returns a valid value to be process
 */
function getComputedValue(nativeElement, property, defaultValue) {
    /* c8 ignore else */
    if (nativeElement && nativeElement.getBoundingClientRect) {
        const elementValue = nativeElement.getBoundingClientRect()[property];
        return !isNaN(elementValue) ? elementValue : defaultValue;
    }
    return defaultValue;
}

// Summary:
// Specifies the state of a control, such as a check box.
var CheckState$1;
(function (CheckState) {
    // Summary:
    // The control is unchecked.
    CheckState[CheckState["Unchecked"] = 0] = "Unchecked";
    // Summary:
    // The control is checked.
    CheckState[CheckState["Checked"] = 1] = "Checked";
    // Summary:
    // The control is indeterminate. An indeterminate control generally has a shaded appearance
    CheckState[CheckState["Indeterminate"] = 2] = "Indeterminate";
})(CheckState$1 || (CheckState$1 = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * TextAlignEnum
 */
var TextAlignEnum;
(function (TextAlignEnum) {
    TextAlignEnum[TextAlignEnum["Default"] = 0] = "Default";
    TextAlignEnum[TextAlignEnum["Left"] = 1] = "Left";
    TextAlignEnum[TextAlignEnum["Center"] = 2] = "Center";
    TextAlignEnum[TextAlignEnum["Right"] = 3] = "Right";
})(TextAlignEnum || (TextAlignEnum = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * TextDecorationEnum
 */
var TextDecorationEnum;
(function (TextDecorationEnum) {
    TextDecorationEnum[TextDecorationEnum["linethrough"] = 8] = "linethrough";
    TextDecorationEnum[TextDecorationEnum["underline"] = 4] = "underline";
})(TextDecorationEnum || (TextDecorationEnum = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Constants
 */
const textAlignField = 'text-align';
const textDecorationField = 'text-decoration';
class Style {
    constructor() {
        this['background-color'] = null;
        this['background-image'] = null;
        this['color'] = null;
        this['font-family'] = null;
        this['top'] = null;
        this['left'] = null;
        this['right'] = null;
        this['bottom'] = null;
        this['width'] = null;
        this['height'] = null;
        this['position'] = null;
        this['font-size'] = null;
        this.textDecorationField = null;
        this.textAlignField = null;
    }
    setPosition() {
        /* c8 ignore else */
        if (this.top || this.left) {
            this.position = 'absolute';
        }
    }
    setBackgroundColor(value) {
        setStyleProperty(this, value, 'background-color');
    }
    setBackgroundImage(value) {
        setStyleProperty(this, value, 'background-image');
    }
    setColor(value) {
        setStyleProperty(this, value, 'color');
    }
    setFontFamily(value) {
        setStyleProperty(this, value, 'font-family');
    }
    setFontSize(value) {
        setStyleProperty(this, value, 'font-size');
    }
    setTop(value) {
        setStyleProperty(this, value, 'top');
    }
    setLeft(value) {
        setStyleProperty(this, value, 'left');
    }
    setRight(value) {
        setStyleProperty(this, value, 'right');
    }
    setBottom(value) {
        setStyleProperty(this, value, 'bottom');
    }
    setWidth(value) {
        setStyleProperty(this, value, 'width');
    }
    setHeight(value) {
        setStyleProperty(this, value, 'height');
    }
    /**
     * Sets the TextAlign property to the control
     * @param value the value for the text alignment
     */
    setTextAlign(value) {
        switch (value) {
            case TextAlignEnum.Right:
                setStyleProperty(this, 'right', textAlignField);
                break;
            case TextAlignEnum.Center:
                setStyleProperty(this, 'center', textAlignField);
                break;
            case TextAlignEnum.Left:
            case TextAlignEnum.Default:
                setStyleProperty(this, 'left', textAlignField);
                break;
            default:
                setStyleProperty(this, null, textAlignField);
        }
    }
    /**
     * Sets the TextDecoration property to the control
     * @param value the value for the text decoration
     */
    setTextDecoration(value) {
        switch (value) {
            case TextDecorationEnum.linethrough:
                setStyleProperty(this, 'line-through', textDecorationField);
                break;
            case TextDecorationEnum.underline:
                setStyleProperty(this, 'underline', textDecorationField);
                break;
            default:
                setStyleProperty(this, null, textDecorationField);
        }
    }
    update(style) {
        this.setBackgroundColor(style.BackColor);
        this.setBackgroundImage(style.BackgroundImage);
        this.setColor(style.ForeColor);
        this.setFontFamily(style.Font);
        this.setFontSize(style.FontSize);
        this.setTextDecoration(style.TextDecoration);
        this.setTop(style.Top);
        this.setLeft(style.Left);
        this.setRight(style.Right);
        this.setBottom(style.Bottom);
        this.setWidth(style.Width);
        this.setHeight(style.Height);
        this.setTextAlign(style.TextAlign);
        this.setPosition();
    }
}
function setStyleProperty(context, value, property) {
    if (value !== undefined && value !== context[property]) {
        context[property] = value;
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 *Specifies how a control will behave when the AutoSize property is on
 */
var AutoSizeMode;
(function (AutoSizeMode) {
    /**
     * Control grows or shrink to fits its contents
     */
    AutoSizeMode[AutoSizeMode["GrowAndShrink"] = 0] = "GrowAndShrink";
    /**
     * Grows as much as necessary to fits its contents but not smaller than the value of its Size
     */
    AutoSizeMode[AutoSizeMode["GrowOnly"] = 1] = "GrowOnly";
})(AutoSizeMode || (AutoSizeMode = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class ControlComponentBaseComponent {
    constructor() {
        /**
         * Special dock of control component.
         * Mark to process the dock with special values
         */
        this.specialDock = false;
        /**
         * Current dock of control component
         */
        this.currentDock = 0;
        /**
         * Current docking order of control component.
         * Array of children ids
         */
        this.currentDockingOrder = [];
        /**
         * After first call of control component.
         * Flag used to know if the control have been called in the ngAfterViewInit
         */
        this.afterFirstCall = false;
        /**
         * Default controls of control component.
         * Internal array of the child with special docking
         */
        this.defaultControls = [];
        /**
         * Controls  of control component
         * Array of controls that are children of this component
         */
        this.children = [];
        /**
         * Auto size applied of control component
         */
        this.autoSizeApplied = false;
        /**
         * Anchor applied of control component
         * Holds the currently applied anchor property
         * -1 otherwise.
         */
        this.anchorApplied = -1;
        /**
         * Current auto size mode of control component
         */
        this.currentAutoSizeMode = -1;
        /**
         * Last zIndex of control component
         */
        this.lastZIndex = 0;
        this.Resize = new EventEmitter();
        this.GotFocus = new EventEmitter();
        this.LostFocus = new EventEmitter();
        this.TextChanged = new EventEmitter();
        this.KeyPress = new EventEmitter();
        this.MouseMove = new EventEmitter();
        this.KeyDown = new EventEmitter();
        this.KeyUp = new EventEmitter();
        this.Leave = new EventEmitter();
        this.Enter = new EventEmitter();
        this.ContextMenu = new EventEmitter();
        this.DragDrop = new EventEmitter();
        this.Validating = new EventEmitter();
        this.Validated = new EventEmitter();
        /**
         * Custom control property obtains the value when is calculated in ngAfterViewInit,
         * it determines if it is a component rendered inside of a custom control column of WFNETC1
         * WE SHOULD TRY TO REMOVE THIS PROPERTY, WINFORMS COMPONENTS SHOULD NOT KNOW THAT A COMPONENT
         * FROM WFNETC1 EXISTS.
         */
        this.customControl = false;
        /**
         * Last error provider message of control component base component to cached value and
         * avoid multiple unnecessary function calls
         */
        this.lastErrorProviderMessage = undefined;
    }
}
ControlComponentBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ControlComponentBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ControlComponentBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ControlComponentBaseComponent, selector: "ng-component", outputs: { Resize: "Resize", GotFocus: "GotFocus", LostFocus: "LostFocus", TextChanged: "TextChanged", KeyPress: "KeyPress", MouseMove: "MouseMove", KeyDown: "KeyDown", KeyUp: "KeyUp", Leave: "Leave", Enter: "Enter", ContextMenu: "ContextMenu", DragDrop: "DragDrop", Validating: "Validating", Validated: "Validated" }, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ControlComponentBaseComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], propDecorators: { Resize: [{
                type: Output
            }], GotFocus: [{
                type: Output
            }], LostFocus: [{
                type: Output
            }], TextChanged: [{
                type: Output
            }], KeyPress: [{
                type: Output
            }], MouseMove: [{
                type: Output
            }], KeyDown: [{
                type: Output
            }], KeyUp: [{
                type: Output
            }], Leave: [{
                type: Output
            }], Enter: [{
                type: Output
            }], ContextMenu: [{
                type: Output
            }], DragDrop: [{
                type: Output
            }], Validating: [{
                type: Output
            }], Validated: [{
                type: Output
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Represents the font family object.
 */
class FontFamily {
    /**
     * Initis a new font family.
     * @param name Name of the font.
     */
    constructor(name) {
        this._name = name;
    }
    /**
     * Set the current model.
     */
    set model(value) {
        this._model = value;
        this.updateName();
    }
    /**
     * Get the namer of the font.
     */
    get name() {
        return this._model.Style.Font;
    }
    /**
     * Set the name of the current font.
     */
    updateName() {
        if (this._name) {
            this._model.Style.Font = this._name;
            this._model.Style.Dirty = true;
            WebMapService.currentService.notifyChange(this._model, 'Style.Font');
        }
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Represent the font object managed through the model.
 */
class Font {
    /**
     * Initialize the Font object.
     * @param model The model to be managed.
     */
    constructor(fontFamily, size, style) {
        this._fontFamily = fontFamily;
        this._style = style;
    }
    /**
     * Sets the model
     */
    set model(value) {
        this._model = value;
        /* c8 ignore else */
        if (this._fontFamily) {
            this.fontFamily.model = value;
        }
        this.UpdateSyle();
    }
    /**
     * Get the current font family object.
     */
    get fontFamily() {
        /* c8 ignore else */
        if (!this._fontFamily) {
            this._fontFamily = new FontFamily();
            this._fontFamily.model = this._model;
        }
        return this._fontFamily;
    }
    /**
     * Get the namer of the font.
     */
    get name() {
        return this._model.Style.Font;
    }
    /**
     * Get the style value.
     */
    get style() {
        /* c8 ignore else */
        if (this._model.Style &&
            this._model.Style.TextDecoration &&
            this._model.Style.textDecoration != 0) {
            return this._model.Style.TextDecoration;
        }
        return undefined;
    }
    UpdateSyle() {
        /* c8 ignore else */
        if (this._style) {
            this._model.Style.TextDecoration = this._style;
            this._model.Style.Dirty = true;
            WebMapService.currentService.notifyChange(this._model, 'Style.TextDecoration');
        }
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE=  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ******************************************************************************/
var Keys;
(function (Keys) {
    //
    // summary=
    //     the bitmask to extract modifiers from a key value.
    Keys[Keys["modifiers"] = -65536] = "modifiers";
    //
    // summary=
    //     no key pressed.
    Keys[Keys["none"] = 0] = "none";
    //
    // summary=
    //     the left mouse button.
    Keys[Keys["lbutton"] = 1] = "lbutton";
    //
    // summary=
    //     the right mouse button.
    Keys[Keys["rbutton"] = 2] = "rbutton";
    //
    // summary=
    //     the cancel key.
    Keys[Keys["cancel"] = 3] = "cancel";
    //
    // summary=
    //     the middle mouse button (three-button mouse).
    Keys[Keys["mbutton"] = 4] = "mbutton";
    //
    // summary=
    //     the first x mouse button (five-button mouse).
    Keys[Keys["xbutton1"] = 5] = "xbutton1";
    //
    // summary=
    //     the second x mouse button (five-button mouse).
    Keys[Keys["xbutton2"] = 6] = "xbutton2";
    //
    // summary=
    //     the backspace key.
    Keys[Keys["back"] = 8] = "back";
    //
    // summary=
    //     the tab key.
    Keys[Keys["tab"] = 9] = "tab";
    //
    // summary=
    //     the linefeed key.
    Keys[Keys["linefeed"] = 10] = "linefeed";
    //
    // summary=
    //     the clear key.
    Keys[Keys["clear"] = 12] = "clear";
    //
    // summary=
    //     the return key.
    Keys[Keys["return"] = 13] = "return";
    //
    // summary=
    //     the enter key.
    Keys[Keys["enter"] = 13] = "enter";
    //
    // summary=
    //     the shift key.
    Keys[Keys["shiftkey"] = 16] = "shiftkey";
    //
    // summary=
    //     the ctrl key.
    Keys[Keys["controlkey"] = 17] = "controlkey";
    //
    // summary=
    //     the alt key.
    Keys[Keys["menu"] = 18] = "menu";
    //
    // summary=
    //     the pause key.
    Keys[Keys["pause"] = 19] = "pause";
    //
    // summary=
    //     the caps lock key.
    Keys[Keys["capital"] = 20] = "capital";
    //
    // summary=
    //     the caps lock key.
    Keys[Keys["capslock"] = 20] = "capslock";
    //
    // summary=
    //     the ime kana mode key.
    Keys[Keys["kanamode"] = 21] = "kanamode";
    //
    // summary=
    //     the ime hanguel mode key. (maintained for compatibility; use hangulmode)
    Keys[Keys["hanguelmode"] = 21] = "hanguelmode";
    //
    // summary=
    //     the ime hangul mode key.
    Keys[Keys["hangulmode"] = 21] = "hangulmode";
    //
    // summary=
    //     the ime junja mode key.
    Keys[Keys["junjamode"] = 23] = "junjamode";
    //
    // summary=
    //     the ime final mode key.
    Keys[Keys["finalmode"] = 24] = "finalmode";
    //
    // summary=
    //     the ime hanja mode key.
    Keys[Keys["hanjamode"] = 25] = "hanjamode";
    //
    // summary=
    //     the ime kanji mode key.
    Keys[Keys["kanjimode"] = 25] = "kanjimode";
    //
    // summary=
    //     the esc key.
    Keys[Keys["escape"] = 27] = "escape";
    //
    // summary=
    //     the ime convert key.
    Keys[Keys["imeconvert"] = 28] = "imeconvert";
    //
    // summary=
    //     the ime nonconvert key.
    Keys[Keys["imenonconvert"] = 29] = "imenonconvert";
    //
    // summary=
    //     the ime accept key, replaces system.windows.forms.keys.imeaceept.
    Keys[Keys["imeaccept"] = 30] = "imeaccept";
    //
    // summary=
    //     the ime accept key. obsolete, use system.windows.forms.keys.imeaccept instead.
    Keys[Keys["imeaceept"] = 30] = "imeaceept";
    //
    // summary=
    //     the ime mode change key.
    Keys[Keys["imemodechange"] = 31] = "imemodechange";
    //
    // summary=
    //     the spacebar key.
    Keys[Keys["space"] = 32] = "space";
    //
    // summary=
    //     the page up key.
    Keys[Keys["prior"] = 33] = "prior";
    //
    // summary=
    //     the page up key.
    Keys[Keys["pageup"] = 33] = "pageup";
    //
    // summary=
    //     the page down key.
    Keys[Keys["next"] = 34] = "next";
    //
    // summary=
    //     the page down key.
    Keys[Keys["pagedown"] = 34] = "pagedown";
    //
    // summary=
    //     the end key.
    Keys[Keys["end"] = 35] = "end";
    //
    // summary=
    //     the home key.
    Keys[Keys["home"] = 36] = "home";
    //
    // summary=
    //     the left arrow key.
    Keys[Keys["left"] = 37] = "left";
    //
    // summary=
    //     the up arrow key.
    Keys[Keys["up"] = 38] = "up";
    //
    // summary=
    //     the right arrow key.
    Keys[Keys["right"] = 39] = "right";
    //
    // summary=
    //     the down arrow key.
    Keys[Keys["down"] = 40] = "down";
    //
    // summary=
    //     the select key.
    Keys[Keys["select"] = 41] = "select";
    //
    // summary=
    //     the print key.
    Keys[Keys["print"] = 42] = "print";
    //
    // summary=
    //     the execute key.
    Keys[Keys["execute"] = 43] = "execute";
    //
    // summary=
    //     the print screen key.
    Keys[Keys["snapshot"] = 44] = "snapshot";
    //
    // summary=
    //     the print screen key.
    Keys[Keys["printscreen"] = 44] = "printscreen";
    //
    // summary=
    //     the ins key.
    Keys[Keys["insert"] = 45] = "insert";
    //
    // summary=
    //     the del key.
    Keys[Keys["delete"] = 46] = "delete";
    //
    // summary=
    //     the help key.
    Keys[Keys["help"] = 47] = "help";
    //
    // summary=
    //     the 0 key.
    Keys[Keys["d0"] = 48] = "d0";
    //
    // summary=
    //     the 1 key.
    Keys[Keys["d1"] = 49] = "d1";
    //
    // summary=
    //     the 2 key.
    Keys[Keys["d2"] = 50] = "d2";
    //
    // summary=
    //     the 3 key.
    Keys[Keys["d3"] = 51] = "d3";
    //
    // summary=
    //     the 4 key.
    Keys[Keys["d4"] = 52] = "d4";
    //
    // summary=
    //     the 5 key.
    Keys[Keys["d5"] = 53] = "d5";
    //
    // summary=
    //     the 6 key.
    Keys[Keys["d6"] = 54] = "d6";
    //
    // summary=
    //     the 7 key.
    Keys[Keys["d7"] = 55] = "d7";
    //
    // summary=
    //     the 8 key.
    Keys[Keys["d8"] = 56] = "d8";
    //
    // summary=
    //     the 9 key.
    Keys[Keys["d9"] = 57] = "d9";
    //
    // summary=
    //     the a key.
    Keys[Keys["a"] = 65] = "a";
    //
    // summary=
    //     the b key.
    Keys[Keys["b"] = 66] = "b";
    //
    // summary=
    //     the c key.
    Keys[Keys["c"] = 67] = "c";
    //
    // summary=
    //     the d key.
    Keys[Keys["d"] = 68] = "d";
    //
    // summary=
    //     the e key.
    Keys[Keys["e"] = 69] = "e";
    //
    // summary=
    //     the f key.
    Keys[Keys["f"] = 70] = "f";
    //
    // summary=
    //     the g key.
    Keys[Keys["g"] = 71] = "g";
    //
    // summary=
    //     the h key.
    Keys[Keys["h"] = 72] = "h";
    //
    // summary=
    //     the i key.
    Keys[Keys["i"] = 73] = "i";
    //
    // summary=
    //     the j key.
    Keys[Keys["j"] = 74] = "j";
    //
    // summary=
    //     the k key.
    Keys[Keys["k"] = 75] = "k";
    //
    // summary=
    //     the l key.
    Keys[Keys["l"] = 76] = "l";
    //
    // summary=
    //     the m key.
    Keys[Keys["m"] = 77] = "m";
    //
    // summary=
    //     the n key.
    Keys[Keys["n"] = 78] = "n";
    //
    // summary=
    //     the o key.
    Keys[Keys["o"] = 79] = "o";
    //
    // summary=
    //     the p key.
    Keys[Keys["p"] = 80] = "p";
    //
    // summary=
    //     the q key.
    Keys[Keys["q"] = 81] = "q";
    //
    // summary=
    //     the r key.
    Keys[Keys["r"] = 82] = "r";
    //
    // summary=
    //     the s key.
    Keys[Keys["s"] = 83] = "s";
    //
    // summary=
    //     the t key.
    Keys[Keys["t"] = 84] = "t";
    //
    // summary=
    //     the u key.
    Keys[Keys["u"] = 85] = "u";
    //
    // summary=
    //     the v key.
    Keys[Keys["v"] = 86] = "v";
    //
    // summary=
    //     the w key.
    Keys[Keys["w"] = 87] = "w";
    //
    // summary=
    //     the x key.
    Keys[Keys["x"] = 88] = "x";
    //
    // summary=
    //     the y key.
    Keys[Keys["y"] = 89] = "y";
    //
    // summary=
    //     the z key.
    Keys[Keys["z"] = 90] = "z";
    //
    // summary=
    //     the left windows logo key (microsoft natural keyboard).
    Keys[Keys["lwin"] = 91] = "lwin";
    //
    // summary=
    //     the right windows logo key (microsoft natural keyboard).
    Keys[Keys["rwin"] = 92] = "rwin";
    //
    // summary=
    //     the application key (microsoft natural keyboard).
    Keys[Keys["apps"] = 93] = "apps";
    //
    // summary=
    //     the computer sleep key.
    Keys[Keys["sleep"] = 95] = "sleep";
    //
    // summary=
    //     the 0 key on the numeric keypad.
    Keys[Keys["numpad0"] = 96] = "numpad0";
    //
    // summary=
    //     the 1 key on the numeric keypad.
    Keys[Keys["numpad1"] = 97] = "numpad1";
    //
    // summary=
    //     the 2 key on the numeric keypad.
    Keys[Keys["numpad2"] = 98] = "numpad2";
    //
    // summary=
    //     the 3 key on the numeric keypad.
    Keys[Keys["numpad3"] = 99] = "numpad3";
    //
    // summary=
    //     the 4 key on the numeric keypad.
    Keys[Keys["numpad4"] = 100] = "numpad4";
    //
    // summary=
    //     the 5 key on the numeric keypad.
    Keys[Keys["numpad5"] = 101] = "numpad5";
    //
    // summary=
    //     the 6 key on the numeric keypad.
    Keys[Keys["numpad6"] = 102] = "numpad6";
    //
    // summary=
    //     the 7 key on the numeric keypad.
    Keys[Keys["numpad7"] = 103] = "numpad7";
    //
    // summary=
    //     the 8 key on the numeric keypad.
    Keys[Keys["numpad8"] = 104] = "numpad8";
    //
    // summary=
    //     the 9 key on the numeric keypad.
    Keys[Keys["numpad9"] = 105] = "numpad9";
    //
    // summary=
    //     the multiply key.
    Keys[Keys["multiply"] = 106] = "multiply";
    //
    // summary=
    //     the add key.
    Keys[Keys["add"] = 107] = "add";
    //
    // summary=
    //     the separator key.
    Keys[Keys["separator"] = 108] = "separator";
    //
    // summary=
    //     the subtract key.
    Keys[Keys["subtract"] = 109] = "subtract";
    //
    // summary=
    //     the decimal key.
    Keys[Keys["decimal"] = 110] = "decimal";
    //
    // summary=
    //     the divide key.
    Keys[Keys["divide"] = 111] = "divide";
    //
    // summary=
    //     the f1 key.
    Keys[Keys["f1"] = 112] = "f1";
    //
    // summary=
    //     the f2 key.
    Keys[Keys["f2"] = 113] = "f2";
    //
    // summary=
    //     the f3 key.
    Keys[Keys["f3"] = 114] = "f3";
    //
    // summary=
    //     the f4 key.
    Keys[Keys["f4"] = 115] = "f4";
    //
    // summary=
    //     the f5 key.
    Keys[Keys["f5"] = 116] = "f5";
    //
    // summary=
    //     the f6 key.
    Keys[Keys["f6"] = 117] = "f6";
    //
    // summary=
    //     the f7 key.
    Keys[Keys["f7"] = 118] = "f7";
    //
    // summary=
    //     the f8 key.
    Keys[Keys["f8"] = 119] = "f8";
    //
    // summary=
    //     the f9 key.
    Keys[Keys["f9"] = 120] = "f9";
    //
    // summary=
    //     the f10 key.
    Keys[Keys["f10"] = 121] = "f10";
    //
    // summary=
    //     the f11 key.
    Keys[Keys["f11"] = 122] = "f11";
    //
    // summary=
    //     the f12 key.
    Keys[Keys["f12"] = 123] = "f12";
    //
    // summary=
    //     the f13 key.
    Keys[Keys["f13"] = 124] = "f13";
    //
    // summary=
    //     the f14 key.
    Keys[Keys["f14"] = 125] = "f14";
    //
    // summary=
    //     the f15 key.
    Keys[Keys["f15"] = 126] = "f15";
    //
    // summary=
    //     the f16 key.
    Keys[Keys["f16"] = 127] = "f16";
    //
    // summary=
    //     the f17 key.
    Keys[Keys["f17"] = 128] = "f17";
    //
    // summary=
    //     the f18 key.
    Keys[Keys["f18"] = 129] = "f18";
    //
    // summary=
    //     the f19 key.
    Keys[Keys["f19"] = 130] = "f19";
    //
    // summary=
    //     the f20 key.
    Keys[Keys["f20"] = 131] = "f20";
    //
    // summary=
    //     the f21 key.
    Keys[Keys["f21"] = 132] = "f21";
    //
    // summary=
    //     the f22 key.
    Keys[Keys["f22"] = 133] = "f22";
    //
    // summary=
    //     the f23 key.
    Keys[Keys["f23"] = 134] = "f23";
    //
    // summary=
    //     the f24 key.
    Keys[Keys["f24"] = 135] = "f24";
    //
    // summary=
    //     the num lock key.
    Keys[Keys["numlock"] = 144] = "numlock";
    //
    // summary=
    //     the scroll lock key.
    Keys[Keys["scroll"] = 145] = "scroll";
    //
    // summary=
    //     the left shift key.
    Keys[Keys["lshiftkey"] = 160] = "lshiftkey";
    //
    // summary=
    //     the right shift key.
    Keys[Keys["rshiftkey"] = 161] = "rshiftkey";
    //
    // summary=
    //     the left ctrl key.
    Keys[Keys["lcontrolkey"] = 162] = "lcontrolkey";
    //
    // summary=
    //     the right ctrl key.
    Keys[Keys["rcontrolkey"] = 163] = "rcontrolkey";
    //
    // summary=
    //     the left alt key.
    Keys[Keys["lmenu"] = 164] = "lmenu";
    //
    // summary=
    //     the right alt key.
    Keys[Keys["rmenu"] = 165] = "rmenu";
    //
    // summary=
    //     the browser back key (windows 2000 or later).
    Keys[Keys["browserback"] = 166] = "browserback";
    //
    // summary=
    //     the browser forward key (windows 2000 or later).
    Keys[Keys["browserforward"] = 167] = "browserforward";
    //
    // summary=
    //     the browser refresh key (windows 2000 or later).
    Keys[Keys["browserrefresh"] = 168] = "browserrefresh";
    //
    // summary=
    //     the browser stop key (windows 2000 or later).
    Keys[Keys["browserstop"] = 169] = "browserstop";
    //
    // summary=
    //     the browser search key (windows 2000 or later).
    Keys[Keys["browsersearch"] = 170] = "browsersearch";
    //
    // summary=
    //     the browser favorites key (windows 2000 or later).
    Keys[Keys["browserfavorites"] = 171] = "browserfavorites";
    //
    // summary=
    //     the browser home key (windows 2000 or later).
    Keys[Keys["browserhome"] = 172] = "browserhome";
    //
    // summary=
    //     the volume mute key (windows 2000 or later).
    Keys[Keys["volumemute"] = 173] = "volumemute";
    //
    // summary=
    //     the volume down key (windows 2000 or later).
    Keys[Keys["volumedown"] = 174] = "volumedown";
    //
    // summary=
    //     the volume up key (windows 2000 or later).
    Keys[Keys["volumeup"] = 175] = "volumeup";
    //
    // summary=
    //     the media next track key (windows 2000 or later).
    Keys[Keys["medianexttrack"] = 176] = "medianexttrack";
    //
    // summary=
    //     the media previous track key (windows 2000 or later).
    Keys[Keys["mediaprevioustrack"] = 177] = "mediaprevioustrack";
    //
    // summary=
    //     the media stop key (windows 2000 or later).
    Keys[Keys["mediastop"] = 178] = "mediastop";
    //
    // summary=
    //     the media play pause key (windows 2000 or later).
    Keys[Keys["mediaplaypause"] = 179] = "mediaplaypause";
    //
    // summary=
    //     the launch mail key (windows 2000 or later).
    Keys[Keys["launchmail"] = 180] = "launchmail";
    //
    // summary=
    //     the select media key (windows 2000 or later).
    Keys[Keys["selectmedia"] = 181] = "selectmedia";
    //
    // summary=
    //     the start application one key (windows 2000 or later).
    Keys[Keys["launchapplication1"] = 182] = "launchapplication1";
    //
    // summary=
    //     the start application two key (windows 2000 or later).
    Keys[Keys["launchapplication2"] = 183] = "launchapplication2";
    //
    // summary=
    //     the oem semicolon key on a us standard keyboard (windows 2000 or later).
    Keys[Keys["oemsemicolon"] = 186] = "oemsemicolon";
    //
    // summary=
    //     the oem 1 key.
    Keys[Keys["oem1"] = 186] = "oem1";
    //
    // summary=
    //     the oem plus key on any country/region keyboard (windows 2000 or later).
    Keys[Keys["oemplus"] = 187] = "oemplus";
    //
    // summary=
    //     the oem comma key on any country/region keyboard (windows 2000 or later).
    Keys[Keys["oemcomma"] = 188] = "oemcomma";
    //
    // summary=
    //     the oem minus key on any country/region keyboard (windows 2000 or later).
    Keys[Keys["oemminus"] = 189] = "oemminus";
    //
    // summary=
    //     the oem period key on any country/region keyboard (windows 2000 or later).
    Keys[Keys["oemperiod"] = 190] = "oemperiod";
    //
    // summary=
    //     the oem question mark key on a us standard keyboard (windows 2000 or later).
    Keys[Keys["oemquestion"] = 191] = "oemquestion";
    //
    // summary=
    //     the oem 2 key.
    Keys[Keys["oem2"] = 191] = "oem2";
    //
    // summary=
    //     the oem tilde key on a us standard keyboard (windows 2000 or later).
    Keys[Keys["oemtilde"] = 192] = "oemtilde";
    //
    // summary=
    //     the oem 3 key.
    Keys[Keys["oem3"] = 192] = "oem3";
    //
    // summary=
    //     the oem open bracket key on a us standard keyboard (windows 2000 or later).
    Keys[Keys["oemopenbrackets"] = 219] = "oemopenbrackets";
    //
    // summary=
    //     the oem 4 key.
    Keys[Keys["oem4"] = 219] = "oem4";
    //
    // summary=
    //     the oem pipe key on a us standard keyboard (windows 2000 or later).
    Keys[Keys["oempipe"] = 220] = "oempipe";
    //
    // summary=
    //     the oem 5 key.
    Keys[Keys["oem5"] = 220] = "oem5";
    //
    // summary=
    //     the oem close bracket key on a us standard keyboard (windows 2000 or later).
    Keys[Keys["oemclosebrackets"] = 221] = "oemclosebrackets";
    //
    // summary=
    //     the oem 6 key.
    Keys[Keys["oem6"] = 221] = "oem6";
    //
    // summary=
    //     the oem singled/double quote key on a us standard keyboard (windows 2000 or later).
    Keys[Keys["oemquotes"] = 222] = "oemquotes";
    //
    // summary=
    //     the oem 7 key.
    Keys[Keys["oem7"] = 222] = "oem7";
    //
    // summary=
    //     the oem 8 key.
    Keys[Keys["oem8"] = 223] = "oem8";
    //
    // summary=
    //     the oem angle bracket or backslash key on the rt 102 key keyboard (windows 2000
    //     or later).
    Keys[Keys["oembackslash"] = 226] = "oembackslash";
    //
    // summary=
    //     the oem 102 key.
    Keys[Keys["oem102"] = 226] = "oem102";
    //
    // summary=
    //     the process key key.
    Keys[Keys["processkey"] = 229] = "processkey";
    //
    // summary=
    //     used to pass unicode characters as if they were keystrokes. the packet key value
    //     is the low word of a 32-bit virtual-key value used for non-keyboard input methods.
    Keys[Keys["packet"] = 231] = "packet";
    //
    // summary=
    //     the attn key.
    Keys[Keys["attn"] = 246] = "attn";
    //
    // summary=
    //     the crsel key.
    Keys[Keys["crsel"] = 247] = "crsel";
    //
    // summary=
    //     the exsel key.
    Keys[Keys["exsel"] = 248] = "exsel";
    //
    // summary=
    //     the erase eof key.
    Keys[Keys["eraseeof"] = 249] = "eraseeof";
    //
    // summary=
    //     the play key.
    Keys[Keys["play"] = 250] = "play";
    //
    // summary=
    //     the zoom key.
    Keys[Keys["zoom"] = 251] = "zoom";
    //
    // summary=
    //     a constant reserved for future use.
    Keys[Keys["noname"] = 252] = "noname";
    //
    // summary=
    //     the pa1 key.
    Keys[Keys["pa1"] = 253] = "pa1";
    //
    // summary=
    //     the clear key.
    Keys[Keys["oemclear"] = 254] = "oemclear";
    //
    // summary=
    //     the bitmask to extract a key code from a key value.
    Keys[Keys["keycode"] = 65535] = "keycode";
    //
    // summary=
    //     the shift modifier key.
    Keys[Keys["shift"] = 65536] = "shift";
    //
    // summary=
    //     the ctrl modifier key.
    Keys[Keys["control"] = 131072] = "control";
    //
    // summary=
    //     the alt modifier key.
    Keys[Keys["alt"] = 262144] = "alt";
})(Keys || (Keys = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
// Provides data for MouseEvents
class MouseEventArgs extends EventData$1 {
    constructor(event, Id, target, mapperId) {
        super(event, Id, mapperId);
        // the event.button from js and winforms is different, we use a indexer to keep a relation each other
        // relation is  js --> winforms
        this.buttonsValueFromJs = {
            0: 0,
            1: 1048576,
            2: 2097152,
            4: 4194304,
            8: 8388608,
            16: 16777216
        };
        this.target = target;
        this.x = event.clientX;
        this.y = event.clientY;
        this._button = this.buttonsValueFromJs[event.buttons];
    }
    /**
     * Set the  x-coordinate
     * @param value  coordinate X od the mouse
     */
    set x(value) {
        this._x = value;
    }
    /**
     *  Gets the x-coordinate of the mouse during the
     * generating mouse event.
     */
    get x() {
        return this._x;
    }
    /**
       Set the  y-coordinate
      * @param value  coordinate y od the mouse
      */
    set y(value) {
        this._y = value;
    }
    /**
     *  Gets the y-coordinate of the mouse during the
     * generating mouse event.
     */
    get y() {
        return this._y;
    }
    /**
     * Gets which mouse button was pressed.
     *
     * @readonly
     * @type {MouseButtons}
     * @memberof MouseEventArgs
     */
    get button() {
        return this._button;
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Keyboard utilities.
 *
 * @export
 * @class KeyUtils
 */
class KeyUtils {
    /**
     * Returns the keyData from the event.
     * This is a combination of the pressed keys made with the Keys enum.
     *
     * @static
     * @param {*} event
     * @return {*}  {Keys}
     * @memberof Utils
     */
    static getKeyData(event) {
        let result = Keys.none;
        /* c8 ignore else */
        if (event.key !== 'Alt' &&
            event.key !== 'Shift' &&
            event.key !== 'Control') {
            result =
                Keys[event.key?.toLowerCase()] ?? Keys[event.which]
                    ? event.which
                    : Keys.none;
        }
        /* c8 ignore else */
        if (event.altKey) {
            result += Keys.alt;
        }
        /* c8 ignore else */
        if (event.ctrlKey) {
            result += Keys.control;
        }
        /* c8 ignore else */
        if (event.shiftKey) {
            result += Keys.shift;
        }
        return result;
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class KeyEventArgs extends EventData$1 {
    /* c8 ignore start */
    constructor(event, Id, target, mapperId) {
        super(event, Id, mapperId);
        this._target = target;
        this._keyCode = event.keyCode;
        this._keyData = KeyUtils.getKeyData(event);
        this._keyValue = event.keyCode;
        this._alt = event.altKey;
        this._control = event.ctrlKey;
        this._shift = event.shiftKey;
        this._modifiers = Keys.none;
        this.event = event;
    }
    /* c8 ignore stop */
    /**
     * return the keyData for Every key press.
     * @readonly
     * @type {*}
     * @memberof keyEventArgs
     */
    get keyData() {
        return this._keyData;
    }
    /**
     * return the keyCode for Every key press.
     * @readonly
     * @type {*}
     * @memberof keyEventArgs
     */
    /* c8 ignore next */
    get keyCode() {
        return this._keyCode;
    }
    /**
     * return the Controlkey for Every key press.
     *
     * @readonly
     * @type {boolean}
     * @memberof KeyEventArgs
     */
    /* c8 ignore next */
    get control() {
        return this._control;
    }
    /**
     * return the Altkey for Every key press.
     *
     * @readonly
     * @type {boolean}
     * @memberof KeyEventArgs
     */
    /* c8 ignore next */
    get alt() {
        return this._alt;
    }
    /**
     * return the Shifkey for Every key press.
     *
     * @readonly
     * @type {boolean}
     * @memberof KeyEventArgs
     */
    /* c8 ignore next */
    get shift() {
        return this._shift;
    }
    /**
     * return the KeyValue for Every key press.
     *
     * @readonly
     * @type {Keys}
     * @memberof KeyEventArgs
     */
    /* c8 ignore next */
    get keyValue() {
        return this._keyValue;
    }
    /**
     * return the Modfiers for Every key press.
     *
     * @readonly
     * @type {Keys}
     * @memberof KeyEventArgs
     */
    /* c8 ignore next */
    get Modifiers() {
        return this._modifiers;
    }
    /**
     * Get a value indicating whether the event was handled.
     * @type {boolean}
     * @memberof keyEventArgs
     */
    /* c8 ignore next */
    get handled() {
        /* c8 ignore else */
        if (this._handled === undefined) {
            this._handled = false;
        }
        return this._handled;
    }
    /**
     * sets a value indicating whether the event was handled
     * The preventDefault() is for cancel the next key event.
     * @memberof keyEventArgs
     */
    /* c8 ignore next */
    set handled(cancelEvent) {
        const cancelable = this.event.cancelable;
        if (cancelable && cancelEvent) {
            this.event.preventDefault();
            this._handled = true;
        }
        else {
            this._handled = false;
        }
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class ErrorProvider {
    constructor() { }
    /**
     * Method to notify other controls that an errorProvider has been rendered.
     *
     * @static
     * @param {EventData} event
     * @memberof ErrorProvider
     */
    static notifyErrorProviderRendered(event) {
        ErrorProvider.errorProviderRendered.next(event);
    }
}
/**
 * The errorProviderRendered subject
 *
 * @static
 * @type {Subject<EventData>}
 * @memberof ErrorProvider
 */
ErrorProvider.errorProviderRendered = new Subject();

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
class Color {
}
Color.Yellow = '#FFFF00';
Color.Red = '#FF0000';
Color.Blue = '#0000FF';
Color.Green = '#008000';
Color.Teal = '#008080';
Color.Salmon = '#FA8072';
Color.IndianRed = '#CD5C5C';
Color.LightGray = '#D3D3D3';
Color.White = '#FFFFFF';
Color.MediumAquamarine = '#66CDAA';
Color.Black = '#000000';

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
class DatesUtils {
    /**
     * Normalize date ignoring the local timezone
     * This is when the date is setted from the client side
     * Example: on setter to model
     * @param {Date} date
     * @return {*}  {Date}
     * @memberof DatesUtils
     */
    static normalizeDateFromClient(date) {
        const timeZoneOffSet = date.getTimezoneOffset() * 60000;
        // To test this, needed to change the local timezone for the test
        /* c8 ignore next */
        const dateValue = timeZoneOffSet < 0
            ? date.getTime() + Math.abs(timeZoneOffSet)
            : date.getTime() - Math.abs(timeZoneOffSet);
        return new Date(dateValue);
    }
    /**
     * Normalize date ignoring the local timezone
     * This is when the date is setted from the server side
     * Example: on getter from model
     * @param {Date} date
     * @return {*}  {Date}
     * @memberof DatesUtils
     */
    static normalizeDateFromServer(date) {
        const timeZoneOffSet = date.getTimezoneOffset() * 60000;
        // To test this, needed to change the local timezone for the test
        /* c8 ignore next */
        const dateValue = timeZoneOffSet < 0
            ? date.getTime() - Math.abs(timeZoneOffSet)
            : date.getTime() + Math.abs(timeZoneOffSet);
        return new Date(dateValue);
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
var MouseButtons;
(function (MouseButtons) {
    /**
     * The left mouse button was pressed.
     */
    MouseButtons[MouseButtons["Left"] = 1048576] = "Left";
    /**
     * The middle mouse button was pressed.
     */
    MouseButtons[MouseButtons["Middle"] = 4194304] = "Middle";
    /**
     * No mouse button was pressed.
     */
    MouseButtons[MouseButtons["None"] = 0] = "None";
    /**
     * The right mouse button was pressed.
     */
    MouseButtons[MouseButtons["Right"] = 2097152] = "Right";
    /**
     * The first XButton (XBUTTON1) on Microsoft IntelliMouse Explorer was pressed.
     */
    MouseButtons[MouseButtons["XButton1"] = 8388608] = "XButton1";
    /**
     * The second XButton (XBUTTON2) on Microsoft IntelliMouse Explorer was pressed.
     */
    MouseButtons[MouseButtons["XButton2"] = 16777216] = "XButton2";
})(MouseButtons || (MouseButtons = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class FocusManagerService {
    /**
     * This line is required to access the non static elements of the class
     */
    constructor() {
        FocusManagerService.current = this;
    }
    /**
     * Focus focus manager service
     * @param component The new focused component
     * @param event The current javascript event
     */
    focus(component, event) {
        // Update old references
        this.oldActiveComponent = this.activeComponent
            ? this.activeComponent
            : component;
        this.activeComponent = component;
        if (this.oldActiveComponent.id !== this.activeComponent.id) {
            this.oldActiveComponent.focused = false;
        }
        this.activeComponent.focused = true;
        this.triggerLeaveEvents(event);
        notifyContainerEvent(this.activeComponent, 'focus', event);
    }
    /**
     * Triggers leave events
     * If the component is inside a container that subscribes
     * the leave event then the event will be raised if the
     * new focused component is in another container
     */
    triggerLeaveEvents(event) {
        /* c8 ignore else */
        if (getContainerContext(this.oldActiveComponent) !==
            getContainerContext(this.activeComponent)) {
            notifyContainerEvent(this.oldActiveComponent, 'leave', event);
        }
        this.oldActiveComponent.checkDetectChangesAfterLeave?.();
    }
}
/**
 * Gives access to the FocusManagerService service
 * without instance
 * @memberof FocusManagerService
 */
FocusManagerService.current = null;
FocusManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FocusManagerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FocusManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FocusManagerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FocusManagerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });
/**
 * Triggers leave container context
 * Notifies the container that the focus is moved to another
 * control
 * @param component the current child component that leaves the focus
 */
function notifyContainerEvent(component, eventString, event) {
    /* c8 ignore else */
    if (component['containerInteraction']) {
        component.notifyEvent(eventString, event);
    }
}
/**
 * Gets container context
 * @param component currentComponent to validate
 */
function getContainerContext(component) {
    const containerInteraction = component['containerInteraction'];
    return containerInteraction
        ? containerInteraction.currentContainerId
        : undefined;
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * This service is to give support the SendKeys Class,
 * (provides methods for sending keystrokes to an application)
 */
class SendKeysService {
    /**
     * This method is used to receive a key
     * and do the action according to the key
     * @param key string: The key to send
     */
    static send(key) {
        const activeElement = FocusManagerService.current?.activeComponent;
        switch (key) {
            case '\t':
            case '{TAB}': {
                this.dispatchKeyboardEvent(activeElement, 'Tab');
                break;
            }
            default:
                // pending  implementation
                break;
        }
    }
    /**
     * This method is used to receive a key
     * and do the action according to the key
     * @param key string: The key to send
     */
    static sendWait(key) {
        this.send(key);
    }
    /**
     * This method is used to dispatch an event in the
     * activeElement according to the key that receive
     * @param activeElement : ControlComponent
     * @param key string: The key to send
     */
    static dispatchKeyboardEvent(activeElement, key) {
        const keyboardEvent = new KeyboardEvent('keydown', {
            code: key,
            key
        });
        setTimeout(() => activeElement.displayElement.dispatchEvent(keyboardEvent));
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * This class is to access the SendKeysService methods
 */
class SendKeys {
    static send(key) {
        SendKeysService.send(key);
    }
    static sendWait(key) {
        SendKeysService.sendWait(key);
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
// Translate colors
class ColorTranslator {
    /**
     * It takes a hex color string and returns it as OLE color.
     * @param {string} hex - string - The hex color to convert to OLE.
     * @returns The hex value is being returned as a number.
     */
    static toOle(hex) {
        if (this.validateHexColor(hex)) {
            const color = this.groupEachTwo(this.sliceHex(hex)).reverse().join('');
            return parseInt(color, 16);
        }
        return null;
    }
    /**
     * It returns true if the string is a valid hex color, otherwise it returns false.
     * @param {string} colorHex - The hex color string to validate.
     * @returns A boolean value.
     */
    static validateHexColor(colorHex) {
        const regexp = new RegExp(/^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/);
        return regexp.test(colorHex);
    }
    /**
     * It takes a hex string and returns the last 6 characters of it.
     * @param {string} hex - The hexadecimal color code.
     * @returns The last 6 characters of the hex string.
     */
    static sliceHex(hex) {
        return hex.slice(hex.length - 6, hex.length);
    }
    /**
     * It takes a string of hexadecimal characters and returns an array of strings, each of which is a
     * pair of hexadecimal characters.
     * @param {string} hex - The hex string.
     * @returns An array of strings.
     */
    static groupEachTwo(hex) {
        const res = [];
        while (hex.length > 0) {
            const tmp = hex.slice(0, 2);
            res.push(tmp);
            hex = hex.slice(2, hex.length);
        }
        return res;
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
class Utils {
    /**
     * Method prevents propagation of the same event from being called outside.
     * @param event object with the information
     * Use shouldAllowPreventDefault to enable the preventDefault behavior
     */
    static preventPropagation(event) {
        if (event && event.preventDefault && !event.shouldAllowPreventDefault) {
            event.preventDefault();
        }
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
    }
    /**
     * Returns the default value of the property if it is null or undefined.
     * @param property property to be evaluated.
     * @param defaultValue default value of the property.
     */
    static isDefaultValue(property, defaultValue) {
        return property === undefined || property === null
            ? defaultValue
            : property;
    }
    /**
     * Removes ampersand entiti
     *
     * @static
     * @param {string} value
     * @param {boolean} [underline]
     * @return {*}  {string}
     * @memberof Utils
     */
    static removeLabelSpecial(value, underline) {
        const replace = underline ? '<u>$1</u>' : '$1';
        return value ? value.replace(/&amp;(.|$)/g, replace) : value;
    }
    /**
     * Return a new string where the white space and < and > is replaced for the html entities
     * @param text string with values to replace
     * @returns new string with entities
     */
    static toHtmlEntities(text) {
        return text
            .replace(/&/gm, '&amp;')
            .replaceAll(' ', '&nbsp;')
            .replace(/</gm, '&lt;')
            .replace(/>/gm, '&gt;')
            .replace(/"/gm, '&quot;');
    }
    static fromHtmlEntities(text) {
        return text
            .replace(/&amp;/gm, '&')
            .replaceAll(/&nbsp;/gm, ' ')
            .replace(/&lt;/gm, '<')
            .replace(/&gt;/gm, '>')
            .replace(/&quot;/gm, '"');
    }
    /**
     * Return a new string where the new line characters are replaced with the <br> HTML element.
     * @param text string with values to replace
     * @returns new string with replaced characters
     */
    static replaceNewLines(text) {
        return text.replaceAll('\n', '<br>');
    }
    /**
     * Calls the event preventDefault if the key combination is a browser shortcut.
     *
     * @static
     * @param {*} event
     * @memberof Utils
     */
    static preventDefaultBrowserShortcuts(event) {
        /* c8 ignore else */
        if (this.browserShortcutsOverridden.includes(KeyUtils.getKeyData(event))) {
            event.preventDefault();
        }
    }
    /**
     * Replace mask rules for respective regex representation.
     *
     * @private
     * @param regex Mask regex to be replaced with regex representation of mask rules.
     * @memberof Utils
     */
    static regexReDosReplaceMaskRules(regex) {
        let regexRulesReplaced = regex.replace(/(?<!\\)[09]/g, '[0-9]');
        regexRulesReplaced = regexRulesReplaced.replace(/(?<!\\)[aA]/g, '[a-zA-Z0-9]');
        regexRulesReplaced = regexRulesReplaced.replace(/(?<!\\)#/g, '[d()-+\\s]');
        regexRulesReplaced = regexRulesReplaced.replace(/(?<!\\)L/g, '[a-zA-Z]');
        regexRulesReplaced = regexRulesReplaced.replace(/(?<!\\)\?/g, '[a-zA-Z\\s]');
        return regexRulesReplaced;
    }
    /**
     * Validates if regex could produce a ReDoS vulnerability and generate performance degradation.
     *
     * @static
     * @param regex Regular expression to be validated of DoS could be produced.
     * @param isMask Boolean value used to apply a mask rules replaced to represent a regex.
     * @memberof Utils
     */
    static regexReDosValidation(regex, isMask) {
        let safeRegex;
        if (isMask) {
            regex = this.regexReDosReplaceMaskRules(regex);
        }
        if (regex instanceof RegExp) {
            safeRegex = isSafePattern(regex.source);
        }
        else {
            safeRegex = isSafePattern(regex);
        }
        if (!safeRegex.safe) {
            WMLogger.instance().warn(
            /* c8 ignore next */
            `Regular expression could lead to a Denial of Service (DoS) within your application: ${regex ? regex.toString() : ''}, error: ${safeRegex.error}`);
        }
    }
    /**
     * Executes the given function inside the setTimeout.
     * You can specify the timeout value, the default is 0.
     *
     * @static
     * @param {() => any} functionToExecute
     * @param {number} [timeout=0]
     * @return {*} Returns the timeoutId.
     * @memberof Utils
     */
    static setTimeoutFunctionExecution(functionToExecute, timeout = 0) {
        return setTimeout(() => {
            functionToExecute();
        }, timeout);
    }
    /**
     * Validates TabIndex model property and tabindex input to
     * determine TabOrder value
     * @param model Component model
     * @param tabIndexInput Tab index Angular input
     * @returns tab order if it exists in model or angular input,
     * returns -1 if both values are undefined
     */
    static validateTabOrder(model, tabIndexInput) {
        if (model.TabIndex != null) {
            return model.TabIndex + 1;
        }
        if (tabIndexInput != null) {
            return parseInt(tabIndexInput) + 1;
        }
        return -1;
    }
}
/**
 * List of browser shortcuts that need to be overridden.
 *
 * @static
 * @type {Keys[]}
 * @memberof Utils
 */
Utils.browserShortcutsOverridden = [
    Keys.control + Keys.k,
    Keys.control + Keys.shift + Keys.p
];

/* c8 ignore next */
class MockService {
    constructor(service, items, resultPostCall, customFunction) {
        this.config = {
            useDynamicServerEvents: true,
            usePercentage: false,
            webMapVersion: "v5",
        };
        this.forms = { formdialog: "86c8eebf-6e27-4ddb-8eca-6e68c096ca70" };
        this.result = "";
        this.enabledServerEvents = true;
        this.core = {
            getEvent() {
                return {
                    publish: (event, data) => { },
                    subscribe: (event, lambda) => "token",
                    unSubscribe: (token) => false,
                };
            },
        };
        this.currentService = this;
        this.serviceModel = service;
        this.itemstoFetch = items;
        this.postResult = resultPostCall;
        this.customFunction = customFunction;
    }
    sendCommand(command, callback) {
        this.result = "Done";
    }
    fetch(url, id) {
        return {
            subscribe: (callback) => {
                callback(this.customFunction ? this.customFunction(url) : this.itemstoFetch);
            },
        };
    }
    post(url, data) {
        return {
            subscribe: (callback) => {
                callback(this.postResult);
            },
        };
    }
    getModel(Id) {
        return new Promise((resolve) => {
            return resolve(this.serviceModel);
        });
    }
    invoke(arg) {
        this.result = "Done";
    }
    notifyChange(mode, property) { }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class EventData {
    /**
     * Creates a new EventData object that keeps
     * information about the executed event and
     * the sender component
     * @param event The original javascript event object
     * @param Id The sender component id
     * @param mapperId The sender component mapperId
     */
    constructor(event, Id, mapperId) {
        /* c8 ignore next */
        this.event = event;
        this.Id = Id;
        this.mapperId = mapperId;
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Represents an ordered pair of integer x- and y-coordinates.
 *
 * @export
 * @class Point
 */
/* c8 ignore next */
class Point {
    /**
     * Creates an instance of Point.
     * @param {number} [x=0]
     * @param {number} [y=0]
     * @memberof Point
     */
    constructor(x = 0, y = 0) {
        this._x = x;
        this._y = y;
    }
    /**
     * Gets the y-coordinate of this Point.
     *
     * @readonly
     * @type {number}
     * @memberof Point
     */
    get y() {
        return this._y;
    }
    /**
     * Sets the y-coordinate of this Point.
     *
     * @memberof Point
     */
    set y(y) {
        this._y = y;
    }
    /**
     * Gets the x-coordinate of this Point.
     *
     * @readonly
     * @type {number}
     * @memberof Point
     */
    get x() {
        return this._x;
    }
    /**
     * Sets the x-coordinate of this Point.
     *
     * @memberof Point
     */
    set x(x) {
        this._x = x;
    }
    /**
     * Gets a value indicating whether this Point is empty.
     *
     * @readonly
     * @type {boolean}
     * @memberof Point
     */
    get isEmpty() {
        return this.x === 0 && this.y === 0;
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Service that allows the shortcuts feature to work in the window component
 *
 * @export
 * @class ShortcutsService
 */
class ShortcutsService {
    constructor() {
        /**
         * Components instances dictionary of accelerator service
         */
        this.componentsInstances = new Dictionary();
        /**
         * The triggerShortcutUnderline subject.
         * This is used to notify all buttons with shortcuts to apply the underline style to the character after the ampersand
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof ShortcutsService
         */
        this.triggerShortcutUnderline = new Subject();
    }
    get shortcutUnderlineEmitted() {
        return this.triggerShortcutUnderline.asObservable();
    }
    /**
     * Registers the instance pass as parameter when ngOnInit
     * cycle is called by the component.
     * @param componentInstance The component instance to be added to
     * componentInstance dictionary
     */
    registerInstance(componentInstance) {
        const shortcut = this.retrieveComponentShortCut(componentInstance);
        if (shortcut &&
            !this.isRegister(shortcut) &&
            componentInstance.useMnemonic) {
            componentInstance.shortcut = shortcut;
            this.componentsInstances.add(shortcut, componentInstance);
        }
    }
    /**
     * Unregisters the instance pass as parameter when ngOnDestroy
     * cycle is called by the component.
     * @param componentInstance The component instance to be removed of
     * componentInstances dictionary
     */
    unregisterInstance(componentInstance) {
        if (this.isRegister(componentInstance.shortcut)) {
            this.componentsInstances.remove(componentInstance.shortcut);
        }
    }
    /**
     * Resolves short cut pass as parameter.
     * @param key The key part of combination of alt + 'key'
     * @param event Event data of key combination event
     */
    resolveShortCut(event, tabOService) {
        const key = this.obtainEventKeyCombination(event);
        if (key && this.isRegister(key)) {
            const component = this.componentsInstances.value(key);
            if (component.enabled && component.visible) {
                if (component.getType() === 'LabelComponent') {
                    tabOService.resolveTab(component.tabNodeReference, false, {});
                    return true;
                }
                if (component.getType() === 'CheckBoxComponent' ||
                    component.getType() === 'RadiobuttonComponent') {
                    Object.defineProperty(event, 'target', {
                        writable: false,
                        value: component.focusableElement
                    });
                    event.target.checked = true;
                    component.applyFocus();
                }
                component['click']
                    ? component['click'](event)
                    : component['change'](event);
                return true;
            }
            return false;
        }
        return false;
    }
    /**
     * Determines whether component is register or not in the
     * componentInstances dictionary.
     * @param key The key part of combination of alt + 'key'
     * @returns true if register
     */
    isRegister(key) {
        return this.componentsInstances.containsKey(key);
    }
    /**
     * Retrieves component shortcut if it exists.
     * @param componentInstance The component instance to be check.
     * @returns component shortcut.
     */
    retrieveComponentShortCut(componentInstance) {
        if (componentInstance) {
            const text = componentInstance.model.Text;
            const regex = new RegExp(/&{1}([^& ]|$)/, 'g');
            const result = regex.exec(text);
            return result && result.length > 0 ? result[1].toUpperCase() : '';
        }
        return '';
    }
    /**
     * Obtains event key combination
     * @param event Event parameter to extract key combination
     * @returns event key combination
     */
    obtainEventKeyCombination(event) {
        const keyCode = event.keyCode;
        // Excludes function key codes
        return keyCode && (keyCode < 112 || keyCode > 123)
            ? String.fromCharCode(keyCode).toUpperCase()
            : null;
    }
    /**
     * Emits a true value to trigger the underline in all shortcuts
     */
    triggerUnderline() {
        this.triggerShortcutUnderline.next(true);
    }
}
ShortcutsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShortcutsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ShortcutsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShortcutsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShortcutsService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class TabNode {
    constructor(myInstance) {
        this.currentInstance = myInstance;
        this.nextTabNode = null;
        this.previousTabNode = null;
        this.idInstance = this.currentInstance.model.id;
    }
    set next(tabNode) {
        this.nextTabNode = tabNode;
    }
    get next() {
        return this.nextTabNode;
    }
    set previous(tabNode) {
        this.previousTabNode = tabNode;
    }
    get previous() {
        return this.previousTabNode;
    }
    set current(currentInstance) {
        this.currentInstance = currentInstance;
    }
    get current() {
        return this.currentInstance;
    }
    get id() {
        return this.idInstance;
    }
    get tabOrder() {
        return this.currentInstance.tabOrder;
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Dictionary used to identify the containers that should gain focus before trigger
 * the enterContainer
 * @type {*} */
const focusableContainers = { TabControl: true };
class MainTabOrderService {
    constructor() {
        // Dictionary with ItabOrder
        this.nodesInstances = new Dictionary();
    }
    /**
     * Length  of main tab order service
     */
    get length() {
        return this.nodesInstances.length;
    }
    /**
     * Method to register the Window or Container provider of the tab service
     *
     * @param {any} control
     * @memberof MainTabOrderService
     */
    registerContainerParentInstance(control) {
        this.containerParentInstance = control;
    }
    /**
     * Register a component instance into the service component list
     * @param componentInstance
     */
    registerInstance(componentInstance) {
        /* c8 ignore else */
        if (componentInstance.isControlComponent &&
            componentInstance.tabOrder > -1 &&
            this.containerParentInstance?.id === componentInstance.parent) {
            if (!this.nodesInstances.containsKey(componentInstance.model.id)) {
                // Creates a new node instance and adds it to the dictionary
                const nodeInstance = new TabNode(componentInstance);
                componentInstance.tabNodeReference = nodeInstance;
                this.insertSort(nodeInstance);
                this.nodesInstances.add(componentInstance.model.id, nodeInstance);
            }
            else {
                // Updates the current instance of the node if it exists in the Dictionary
                const nodeInstance = this.nodesInstances.value(componentInstance.model.id);
                nodeInstance.current = componentInstance;
                componentInstance.tabNodeReference = nodeInstance;
            }
        }
    }
    /**
     * Gets the head node.
     */
    getHead() {
        return this.head;
    }
    unregisterInstance(componentInstance, id) {
        // The next line is wrong, it must be the
        // sentence nodeInstances.value(componentInstance.model.id) but it
        // generates a LGC bug. Pending research Bug #352891
        const idToRemove = id ?? componentInstance.model.id;
        const nodeInstance = this.nodesInstances.value(idToRemove);
        /* c8 ignore else */
        if (nodeInstance) {
            /* c8 ignore else */
            if (this.nodesInstances.length === 1) {
                this.head = null;
                this.tail = null;
            }
            else {
                if (nodeInstance === this.head) {
                    this.head = nodeInstance.nextTabNode;
                }
                if (nodeInstance === this.tail) {
                    this.tail = nodeInstance.previousTabNode;
                }
                nodeInstance.previousTabNode.nextTabNode = nodeInstance.nextTabNode;
                nodeInstance.nextTabNode.previousTabNode = nodeInstance.previousTabNode;
            }
            this.nodesInstances.remove(id);
        }
    }
    /**
     * This method is used to insert sort nodes in to a double linked circular list
     * @param newNode Tab node component
     */
    insertSort(newNode) {
        // Basic scenario when there is no rootNode.
        // Assign start and end Node
        if (this.head == null) {
            this.assignEmptyStartEndNodes(newNode);
        }
        else {
            // scenario when node is at the end of the list
            if (newNode.tabOrder >= this.tail.tabOrder) {
                this.insertEnd(newNode);
            }
            else {
                // scenario when node is at the beginning of the list
                this.insertNodeFirstOrMiddle(newNode);
            }
        }
    }
    /**
     * Handle tab interaction
     * @param tabNodeReference the current tabnode
     * @param isShiftPressed to detect if is reverse tab
     * @param event the current javascript event object
     */
    resolveTab(tabNodeReference, isShiftPressed, event) {
        /* c8 ignore else */
        if (tabNodeReference) {
            const evaluateNextOrPrevious = isShiftPressed
                ? tabNodeReference.previous
                : tabNodeReference.next;
            if (event.HeadNode === evaluateNextOrPrevious) {
                return;
            }
            const availableComponent = this.availableNextNode(evaluateNextOrPrevious, isShiftPressed, 1, this.isRadioButtonComponent(tabNodeReference));
            if (event.HeadNode === availableComponent) {
                return;
            }
            this.applyFocusToAvailableComponent(availableComponent, isShiftPressed, event);
        }
    }
    /**
     * Determines if a tabNode is a radioButtonComponent
     * @param tabNodeReference The tabNode
     * @returns True if it is a radioButton otherwise false
     */
    isRadioButtonComponent(tabNodeReference) {
        return (tabNodeReference &&
            tabNodeReference.currentInstance.getType() === 'RadiobuttonComponent');
    }
    /**
     * Determines if a tabNode is a labelComponent
     * @param tabNodeReference The tabNode
     * @returns True if it is a label otherwise false
     */
    isLabelComponent(tabNodeReference) {
        return (tabNodeReference &&
            tabNodeReference.currentInstance.getType() === 'LabelComponent');
    }
    /**
     * Apply focus to all components in a window, gives a special treatment to dataManager controls and userObjects
     * @param availableComponent  Tab node component
     * @param isDmTabNode Is data manager control tab node
     * @param event The current javascript event
     */
    applyFocusToAvailableComponent(availableComponent, isShiftPressed, event) {
        if (availableComponent.currentInstance.isContainer &&
            availableComponent.currentInstance.containerTabOrderService &&
            !this.isFocusableContainer(availableComponent)) {
            availableComponent.currentInstance.containerTabOrderService.enterContainer(isShiftPressed, event, this.isRadioButtonComponent(availableComponent));
        }
        else {
            availableComponent.currentInstance.applyFocus();
        }
    }
    /**
     * Availables next node
     * @param tabNodeReference The current tabnode reference
     * @param isShiftPressed to detect if shift was pressed
     * @param event the current javascript event
     * @param length the component list length
     * @returns next node
     */
    availableNextNode(tabNodeReference, isShiftPressed, length, isTabNodeReferenceRadioButton) {
        let currentTabNode = tabNodeReference;
        // Getting the selected radioButton because the focus will be applied to this element
        const selectedRadio = this.getSelectedRadioButton(tabNodeReference);
        let selectedRadioNode = selectedRadio.length > 0 ? selectedRadio[0] : null;
        // if there is no-selected radioButton and the shift key was pressed then we should find the
        // radiobutton reference (if exists otherwise the returned value will be null) that has
        // the lower tabOrder value
        /* c8 ignore else */
        if (selectedRadioNode === null && isShiftPressed) {
            const lowerTabIdxRadio = this.getLowerTabIndexRadioButton();
            selectedRadioNode = lowerTabIdxRadio;
        }
        while (this.isValidTabNode(currentTabNode, isTabNodeReferenceRadioButton, selectedRadioNode) === false) {
            if (length !== this.length) {
                currentTabNode = isShiftPressed
                    ? currentTabNode.previous
                    : currentTabNode.next;
                length = length + 1;
            }
            else {
                break;
            }
        }
        return currentTabNode;
    }
    /**
     * Determines whether a node instance is valid
     * @param tabNodeReference The tabNode
     * @param isTabNodeReferenceRadioButton Determines if the tabbed control is a radiobutton
     * @param selectedRadioButton Contains the selected radioButton for the current container
     * @returns true if valid tab node
     */
    isValidTabNode(tabNodeReference, isTabNodeReferenceRadioButton, selectedRadioButton) {
        return (this.isReferenceAlive(tabNodeReference) &&
            tabNodeReference.tabOrder > 0 &&
            tabNodeReference.currentInstance.enabled &&
            tabNodeReference.currentInstance.visible &&
            !this.isLabelComponent(tabNodeReference) &&
            this.validateRadioButtons(tabNodeReference, isTabNodeReferenceRadioButton, selectedRadioButton) &&
            (!tabNodeReference.currentInstance.isContainer ||
                tabNodeReference.currentInstance.containerTabOrderService.length > 0));
    }
    /**
     * Validates if the tabNode is valid radioButton to receive the focus
     * @param tabNodeReference The tabNode
     * @param isTabNodeReferenceRadioButton Determines if the tabbed control is a radiobutton
     * @param selectedRadioButton Contains the selected radioButton for the current container
     * @returns True if it is valid otherwise false
     */
    validateRadioButtons(tabNodeReference, isTabNodeReferenceRadioButton, selectedRadioButton) {
        /* c8 ignore else */
        if (this.isRadioButtonComponent(tabNodeReference) &&
            ((selectedRadioButton !== null &&
                tabNodeReference.idInstance !== selectedRadioButton.idInstance) ||
                (selectedRadioButton === null && isTabNodeReferenceRadioButton))) {
            return false;
        }
        return true;
    }
    /**
     * Gets the selected radiobutton for the current container
     * @param tabNodeReference The tabNode
     * @returns The selected radiobutton if there is at least one
     */
    getSelectedRadioButton(tabNodeReference) {
        return this.nodesInstances
            .values()
            .filter((x) => x.currentInstance.checked &&
            x.currentInstance.getType() === 'RadiobuttonComponent' &&
            x.idInstance !== tabNodeReference.idInstance);
    }
    /**
     * Gets the radiobutton component that has the lower TabOrder value
     * @returns The nodeInstance for the radioButton if applies otherwise null
     */
    getLowerTabIndexRadioButton() {
        const tmp = this.nodesInstances
            .values()
            .filter((x) => x.currentInstance.getType() === 'RadiobuttonComponent');
        /* c8 ignore else */
        if (tmp.length > 0) {
            return tmp.reduce((a, b) => (a.tabOrder < b.tabOrder ? a : b));
        }
        return null;
    }
    /**
     * Returns true if the reference is alive otherwise false
     * @param tabNodeReference The tab node refernced
     */
    isReferenceAlive(tabNodeReference) {
        return !tabNodeReference.currentInstance.ref['destroyed'];
    }
    /**
     * Method used by insert sort when there is no root node at the list
     * @param newNode Tab Node component
     */
    assignEmptyStartEndNodes(newNode) {
        const newNodeFlag = newNode;
        newNodeFlag.next = newNodeFlag;
        newNodeFlag.previous = newNodeFlag;
        this.head = newNodeFlag;
        this.tail = this.head;
    }
    /**
     * Insert a new node at the end of the list and updates end Node reference
     * @param newNode Tab Node component
     */
    insertEnd(newNode) {
        newNode.next = this.head;
        this.head.previous = newNode;
        this.tail.next = newNode;
        newNode.previous = this.tail;
        this.tail = newNode;
    }
    /**
     * Insert a new node at the beginning of the list and updates start Node reference
     * @param newNode Tab Node component
     */
    insertStart(newNode) {
        this.head.previous = newNode;
        newNode.next = this.head;
        newNode.previous = this.tail;
        this.tail.next = newNode;
        this.head = newNode;
    }
    /**
     * Insert a new node at the middle of the list
     * @param newNode Tab Node component
     */
    insertBetweenNodes(firstNode, secondNode, newNode) {
        secondNode.previous = newNode;
        newNode.next = secondNode;
        newNode.previous = firstNode;
        firstNode.next = newNode;
    }
    /**
     * Gets a component by id
     * @param id The WebMap id used to find the component
     * @returns A component instance
     */
    getComponentById(id) {
        const node = this.nodesInstances.value(id);
        return node ? node.current : null;
    }
    /**
     * Insert the node when is not in the last position
     */
    insertNodeFirstOrMiddle(newNode) {
        let endFlag;
        let previousEndFlag;
        if (newNode.tabOrder <= this.head.tabOrder) {
            this.insertStart(newNode);
        }
        else {
            // scenario when node is somewhere in the middle
            endFlag = this.tail;
            previousEndFlag = this.tail.previous;
            this.validatePosition(previousEndFlag, newNode, endFlag);
        }
    }
    /**
     * Validate the position of the node
     */
    validatePosition(previousEndFlag, newNode, endFlag) {
        while (previousEndFlag != null) {
            // validates the right position of the newNode
            if (newNode.tabOrder <= endFlag.tabOrder &&
                newNode.tabOrder >= previousEndFlag.tabOrder) {
                this.insertBetweenNodes(previousEndFlag, endFlag, newNode);
                break;
            }
            else {
                // moves to the previous value.
                endFlag = previousEndFlag;
                previousEndFlag = previousEndFlag.previous;
            }
        }
    }
    /**
     * Method to know if specifics container can gain focus and not only execute the enterContainer mechanism
     * Is important for containers with this behavior to be registered on the focusableContainers dictionary
     * and use the ContainerDirective to manage the tab behavior.
     *
     * Example: TabControl component
     *
     * @param {TabNode} tabNodeReference
     * @return {*}  {boolean}
     * @memberof MainTabOrderService
     */
    isFocusableContainer(tabNodeReference) {
        const stringType = tabNodeReference.currentInstance.getType() ?? '';
        return !!(tabNodeReference.currentInstance.isContainer &&
            focusableContainers[stringType]);
    }
}
MainTabOrderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MainTabOrderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
MainTabOrderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MainTabOrderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MainTabOrderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
class ContainerTabOrderService extends MainTabOrderService {
    constructor() {
        super(...arguments);
        /**
         * Leave subject to subscribe out action of tab page control service
         */
        this.leaveSubject = new Subject();
    }
    /**
     * leaveContainer
     * Sends a notification to change the current tab order service
     * @param evt the current event
     */
    leaveContainer(evt) {
        this.leaveSubject.next(evt);
    }
    /**
     * Gets leave subject to allow external subscription
     */
    get leaveContainerSubscription() {
        return this.leaveSubject.asObservable();
    }
    /**
     * Gets start tab node of the list
     */
    get startTabNode() {
        return this.head;
    }
    /**
     * Gets end tab node of the list
     */
    get endTabNode() {
        return this.tail;
    }
    /**
     * Resolves tab
     * @param tabNodeReference Current component node
     * @param isShiftPressed shift key pressed
     * @param event the current keyboard event
     */
    resolveTab(tabNodeReference, isShiftPressed, event) {
        const availableComponent = this.availableNextNode(isShiftPressed ? tabNodeReference.previous : tabNodeReference.next, isShiftPressed, 1, this.isRadioButtonComponent(tabNodeReference));
        if (this.shouldLeaveContext(tabNodeReference, availableComponent, isShiftPressed)) {
            this.leaveContainer(event);
            return;
        }
        this.applyFocusToAvailableComponent(availableComponent, isShiftPressed, event);
    }
    /**
     * Applies focus to a selectable element in user control. It triggers dom
     * element focus().
     * If first element is also a user control pass responsability to
     * internal service
     * @param isShiftPressed If shift key is pressed
     * @param evt Event
     * @param isTabNodeReferenceRadioButton Determines if the tabbed cntrol is a radiobutton
     * @param [leave] Determines whether the method should or should not leave container.
     * Default value false indicates that method should leaves container.
     */
    enterContainer(isShiftPressed, evt, isTabNodeReferenceRadioButton, leave) {
        const tabNode = !isShiftPressed ? this.startTabNode : this.endTabNode;
        if (tabNode) {
            const selectedRadio = this.getSelectedRadioButton(tabNode);
            const selectedRadioNode = selectedRadio.length > 0 ? selectedRadio[0] : null;
            const availableTabNode = this.availableNextNode(tabNode, isShiftPressed, 1, isTabNodeReferenceRadioButton);
            /* c8 ignore else */
            if (availableTabNode &&
                this.isValidTabNode(availableTabNode, isTabNodeReferenceRadioButton, selectedRadioNode)) {
                this.applyFocusToAvailableComponent(availableTabNode, isShiftPressed, evt);
                return;
            }
        }
        if (!leave) {
            this.leaveContainer(evt);
        }
    }
    /**
     * Should leave context
     * @param tabNodeReference Current component node
     * @param availableComponent Next/Previous available and valid component node
     * @param isShiftPressed  Shift key pressed
     * @returns true if leave the current context
     */
    shouldLeaveContext(tabNodeReference, availableComponent, isShiftPressed) {
        return (tabNodeReference === availableComponent ||
            (!isShiftPressed &&
                tabNodeReference.tabOrder > availableComponent.tabOrder) ||
            (isShiftPressed &&
                tabNodeReference.tabOrder < availableComponent.tabOrder) ||
            (!isShiftPressed && tabNodeReference.id === this.endTabNode.id) ||
            (isShiftPressed && tabNodeReference.id === this.startTabNode.id));
    }
    /**
     * Register a component instance into the service component list
     * @param componentInstance
     */
    registerInstance(componentInstance) {
        /* c8 ignore else */
        if (componentInstance.isControlComponent &&
            componentInstance.tabOrder > -1) {
            if (!this.nodesInstances.containsKey(componentInstance.model.id)) {
                // Creates a new node instance and adds it to the dictionary
                const nodeInstance = new TabNode(componentInstance);
                componentInstance.tabNodeReference = nodeInstance;
                this.insertSort(nodeInstance);
                this.nodesInstances.add(componentInstance.model.id, nodeInstance);
            }
            else {
                // Updates the current instance of the node if it exists in the Dictionary
                const nodeInstance = this.nodesInstances.value(componentInstance.model.id);
                nodeInstance.current = componentInstance;
                componentInstance.tabNodeReference = nodeInstance;
            }
        }
    }
}
ContainerTabOrderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerTabOrderService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ContainerTabOrderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerTabOrderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerTabOrderService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Class TabDirective manage events and property bindings for container controls.
 */
class TabDirective {
    constructor(tabOrderService, containerTabOrderService, webComponentsService, loadingStateService) {
        this.tabOrderService = tabOrderService;
        this.containerTabOrderService = containerTabOrderService;
        this.webComponentsService = webComponentsService;
        this.loadingStateService = loadingStateService;
    }
    reverseTab(e) {
        this.tabKeyHandler(e);
    }
    tabHandler(e) {
        this.tabKeyHandler(e);
    }
    get component() {
        return this.hostComponent;
    }
    /**
     * Register the component in the currentTabService
     */
    ngAfterViewInit() {
        /* c8 ignore else */
        if (this.component && !this.component.registerManually) {
            this.registerComponent();
        }
    }
    /**
     * after view checked
     */
    ngAfterViewChecked() {
        if (this.hostComponent &&
            this.hostComponent.shouldApplyFocus() &&
            this.hostComponent.focusableElement != null &&
            !this.hostComponent.bringToTop &&
            this.isLoadingHidden()) {
            this.hostComponent.isFocused = false;
            this.hostComponent.applyFocus();
            this.hostComponent.markForCheck();
        }
    }
    /**
     * Verifies if the loading component is hidden using the loadingState service.
     *
     * @return {*}  {boolean}
     * @memberof TabDirective
     */
    isLoadingHidden() {
        return this.loadingStateService?.isLoadingHidden;
    }
    /**
     * Unregister the current component from the tabOrderService
     */
    ngOnDestroy() {
        /* c8 ignore else */
        if (this.currentTabService && this.component) {
            this.currentTabService.unregisterInstance(this.component);
        }
    }
    /**
     * do check
     * Verifies changes in tabIndex
     */
    ngDoCheck() {
        this.tabIndexUpdate();
    }
    registerComponent() {
        const parent = this.webComponentsService.getParent(this.component);
        if (this.containerTabOrderService &&
            !this.component.isContainer &&
            parent &&
            parent.isForm !== true) {
            this.registerTabService(this.containerTabOrderService);
            return;
        }
        if (this.containerTabOrderService && this.component.isContainer) {
            this.component.containerTabOrderService = this.containerTabOrderService;
            if (parent) {
                if (this.registerWmUserContrl(parent)) {
                    return;
                }
                if (parent.containerTabOrderService) {
                    this.registerTabService(parent.containerTabOrderService);
                    return;
                }
            }
        }
        /* c8 ignore else */
        if (this.tabOrderService) {
            this.registerTabService(this.tabOrderService);
        }
    }
    registerWmUserContrl(parent) {
        if (parent.isUserControl()) {
            const wmParent = parent.innerWmControl;
            if (wmParent) {
                this.registerTabService(wmParent.containerTOrderService);
                return true;
            }
        }
        return false;
    }
    registerTabService(containerTabService) {
        this.component.internalTabOrder = this.component.tabOrder;
        containerTabService.registerInstance(this.component);
        this.registerLeaveContainer(containerTabService);
        this.currentTabService = containerTabService;
    }
    /**
     * Tab key handler to manage tab behavior.
     * MainTabOrder service determines which action
     * should be performed after a tab key event.
     * @param event TabKey event.
     */
    tabKeyHandler(event) {
        Utils.preventPropagation(event);
        // This section was added to manage very specific cases were the tab services are
        // not necessary or are overriden by an specific behavior
        if (this.component && this.component.customTabAction) {
            this.component.customTabAction(this.component.tabNodeReference, event.shiftKey, event);
        }
        else if (this.component && this.currentTabService) {
            this.currentTabService.resolveTab(this.component.tabNodeReference, event.shiftKey, event);
        }
    }
    /**
     * Tabs index update
     */
    tabIndexUpdate() {
        /* c8 ignore else */
        if (this.component.internalTabOrder != null &&
            this.component.internalTabOrder !== this.component.tabOrder) {
            this.component.internalTabOrder = this.component.tabOrder;
            this.currentTabService.unregisterInstance(this.component);
            if (this.component.tabOrder >= 0) {
                this.currentTabService.registerInstance(this.component);
            }
        }
    }
    /**
     * Register current component instance in ContainerTabOrderService
     */
    registerLeaveContainer(parentService) {
        /* c8 ignore else */
        if (this.component.isContainer && this.containerTabOrderService) {
            this.containerTabOrderService.leaveContainerSubscription.subscribe((evt) => {
                if (evt) {
                    Utils.preventPropagation(evt);
                    parentService.resolveTab(this.component.tabNodeReference, evt.shiftKey, evt);
                }
            });
        }
    }
}
TabDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TabDirective, deps: [{ token: MainTabOrderService, optional: true }, { token: ContainerTabOrderService, optional: true }, { token: WebComponentsService, optional: true }, { token: i3.LoadingStateService, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
TabDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: TabDirective, selector: "[wmTab]", inputs: { hostComponent: "hostComponent" }, host: { listeners: { "keydown.shift.tab": "reverseTab($event)", "keydown.tab": "tabHandler($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TabDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[wmTab]'
                }]
        }], ctorParameters: function () { return [{ type: MainTabOrderService, decorators: [{
                    type: Optional
                }] }, { type: ContainerTabOrderService, decorators: [{
                    type: Optional
                }] }, { type: WebComponentsService, decorators: [{
                    type: Optional
                }] }, { type: i3.LoadingStateService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { hostComponent: [{
                type: Input
            }], reverseTab: [{
                type: HostListener,
                args: ['keydown.shift.tab', ['$event']]
            }], tabHandler: [{
                type: HostListener,
                args: ['keydown.tab', ['$event']]
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * AjaxInteractionBaseService used to communicate any control with the AjaxComponents on WebForms
 *
 * @export
 * @class AjaxCalendarService
 */
class AjaxInteractionBaseService {
    /**
     * Gets the notification for the click emit
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof AjaxInteractionBaseService
     */
    get ClickEmittedNotification() {
        return {};
    }
    /**
     * Notifies the click to the subscribed control
     *
     * @param {EventData} event
     * @memberof AjaxInteractionBaseService
     */
    notifyClick(event) { }
}
AjaxInteractionBaseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxInteractionBaseService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AjaxInteractionBaseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxInteractionBaseService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxInteractionBaseService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class WMWindowService {
    constructor() {
        /**
         * The acceptButtonCreated subject
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof WindowService
         */
        this.acceptButtonCreated = new Subject();
        /**
         * The buttonFakeFocus subject
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof WindowService
         */
        this.buttonFakeFocus = new Subject();
        /**
         * The keyDown subject
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof WindowService
         */
        this.keyDown = new Subject();
        /**
         * The keyUp subject
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof WindowService
         */
        this.keyUp = new Subject();
        /**
         * The windowButtonAction subject
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof WMWindowService
         */
        this.windowButtonAction = new Subject();
        /**
         * The windowButtonFocused subject
         * This is used to notify to the service from the button which button has been focused
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof WMWindowService
         */
        this.windowButtonFocused = new Subject();
        /**
         * Subject to remove the fakeFocus from button
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof WMWindowService
         */
        this.removeFakeFocus = new Subject();
        /**
         * Subject to apply the fakeFocus to a button
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof WMWindowService
         */
        this.applyFakeFocus = new Subject();
    }
    /**
     * Gets the acceptButtonCreated notification
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof WMWindowService
     */
    get acceptButtonCreatedEmitted() {
        return this.acceptButtonCreated.asObservable();
    }
    /**
     * Gets the buttonFakeFocus notification
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof WindowService
     */
    get buttonFakeFocusEmitted() {
        return this.buttonFakeFocus.asObservable();
    }
    /**
     * Gets the keyPress notification
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof WindowService
     */
    get keyDownEmitted() {
        return this.keyDown.asObservable();
    }
    /**
     * Gets the keyPress notification
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof WindowService
     */
    get keyUpEmitted() {
        return this.keyUp.asObservable();
    }
    /**
     * Gets the windowButtonAction notification
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof WMWindowService
     */
    get windowButtonActionEmitted() {
        return this.windowButtonAction.asObservable();
    }
    /**
     * Gets the windowButtonFocused notification
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof WMWindowService
     */
    get windowButtonFocusedEmitted() {
        return this.windowButtonFocused.asObservable();
    }
    /**
     * Gets the removeFakeFocus notification
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof WMWindowService
     */
    get removeFakeFocusEmitted() {
        return this.removeFakeFocus.asObservable();
    }
    get applyFakeFocusEmitted() {
        return this.applyFakeFocus.asObservable();
    }
    /**
     * Method to notify to the accept button of window has been created
     *
     * @memberof WindowService
     */
    notifyAcceptButtonCreated(event) {
        this.acceptButtonCreated.next(event);
    }
    /**
     * Method to notify to the accept button of window to have a fake focus
     *
     * @memberof WindowService
     */
    notifyButtonFakeFocusAcceptButton(event) {
        this.buttonFakeFocus.next(event);
    }
    /**
     * Method to notify which button should trigger its click by pressing a key on the window
     *
     * @param {EventData} event
     * @memberof WMWindowService
     */
    notifyWindowButtonAction(event) {
        this.windowButtonAction.next(event);
    }
    /**
     * Method to notify from the button thah has been focused
     *
     * @param {EventData} event
     * @memberof WMWindowService
     */
    notifyWindowButtonFocused(event) {
        this.windowButtonFocused.next(event);
    }
    /**
     * Method to notify a button to remove the fakeFocus
     *
     * @param {EventData} event
     * @memberof WMWindowService
     */
    notifyRemoveFakeFocus(event) {
        this.removeFakeFocus.next(event);
    }
    /**
     * Method to notify a button to apply the fakeFocus
     *
     * @param {EventData} event
     * @memberof WMWindowService
     */
    notifyApplyFakeFocus(event) {
        this.applyFakeFocus.next(event);
    }
    /**
     * Method to notify a window to apply the key¨Press
     *
     * @param {EventData} event
     * @memberof WMWindowService
     */
    notifyKeyDown(event) {
        this.keyDown.next(event);
    }
    /**
     * Method to notify a window to apply the key¨Press
     *
     * @param {EventData} event
     * @memberof WMWindowService
     */
    notifyKeyUp(event) {
        this.keyUp.next(event);
    }
}
WMWindowService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WMWindowService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
WMWindowService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WMWindowService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WMWindowService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Service to notify to controls inside grid cells some events and interactions
 *
 * @export
 * @class GridCustomEditorInteractionService
 */
class GridCustomEditorInteractionService {
    constructor() {
        /**
         * The custom cell closed subject
         *
         * @protected
         * @type {Subject<EventData>}
         * @memberof GridCustomEditorInteractionService
         */
        this.customCellClosed = new Subject();
    }
    /**
     * The custom cell closed notification
     *
     * @return {*}  {*}
     * @memberof GridCustomEditorInteractionService
     */
    get customCellClosedNotification() {
        return this.customCellClosed.asObservable();
    }
    /**
     * Method to notify when a custom cell is closed
     *
     * @param {EventData} event
     * @memberof GridCustomEditorInteractionService
     */
    notifyCustomCellClosed(event) {
        this.customCellClosed.next(event);
    }
}
GridCustomEditorInteractionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GridCustomEditorInteractionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GridCustomEditorInteractionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GridCustomEditorInteractionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GridCustomEditorInteractionService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Class ControlsDirective manage events and property bindings for all controls.
 */
class ControlsDirective extends TabDirective {
    constructor(element, view, focusManager, tabOService, containerTabOService, webCompService, ajaxInteractionBaseService, wmWindowService, loadingStService, gridCustomEditorInteractionService) {
        super(tabOService, containerTabOService, webCompService, loadingStService);
        this.element = element;
        this.view = view;
        this.focusManager = focusManager;
        this.tabOService = tabOService;
        this.containerTabOService = containerTabOService;
        this.webCompService = webCompService;
        this.ajaxInteractionBaseService = ajaxInteractionBaseService;
        this.wmWindowService = wmWindowService;
        this.loadingStService = loadingStService;
        this.gridCustomEditorInteractionService = gridCustomEditorInteractionService;
        /**
         * This is to know if a controls is inside any grid that provides the GridCustomEditorInteractionService and the edition of the cell is being closed
         *
         * @memberof ControlsDirective
         */
        this.customColumnOnGridClosed = false;
    }
    /**
     * The AfterViewInit
     *
     * @memberof ControlsDirective
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        // Subscription for when a component is inside a grid cell and the cell is closed
        /* c8 ignore start */
        this.customColumnOnGridSubscription =
            this.gridCustomEditorInteractionService?.customCellClosedNotification.subscribe((evt) => {
                if (evt.Id === this.component.id) {
                    this.customColumnOnGridClosed = true;
                    this.blur(evt.event);
                }
            });
        /* c8 ignore stop */
    }
    /**
     * The ngOnDestroy method
     *
     * @memberof ControlsDirective
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        /* c8 ignore next */
        if (this.customColumnOnGridSubscription) {
            this.customColumnOnGridSubscription.unsubscribe();
        }
        /* c8 ignore stop */
    }
    get tooltip() {
        return this.callAttr('tooltip');
    }
    focus(e) {
        if (this.focusManager) {
            this.focusManager.focus(this.component, e);
        }
        this.callEvent('enter', e);
        this.callEvent('focus', e);
        this.callEvent('notifyWindowToBringTop', e);
    }
    blur(e) {
        // This is to avoid the leave events for the component until the grid cell is completely closed
        if (this.component.isInsideGridCell && !this.customColumnOnGridClosed) {
            return;
        }
        this.callEvent('blur', e);
        this.callEvent('leaveEventsHandler', e);
        this.customColumnOnGridClosed = false;
    }
    keyPress(e) {
        this.callEvent('keyPress', e);
    }
    keyDown(e) {
        Utils.preventDefaultBrowserShortcuts(e);
        /* c8 ignore else */
        if (!e.isNotified) {
            this.wmWindowService?.notifyKeyDown(e);
            e.isNotified = true;
        }
        /* c8 ignore else */
        if (this.hostComponent.getType?.() !== 'WMWindowComponent') {
            this.callEvent('keyDown', e);
        }
    }
    keyUp(e) {
        /* c8 ignore else */
        if (!e.isNotified) {
            this.wmWindowService?.notifyKeyUp(e);
            e.isNotified = true;
        }
        /* c8 ignore else */
        if (this.hostComponent.getType?.() !== 'WMWindowComponent') {
            this.callEvent('keyUp', e);
        }
    }
    textChanged(e) {
        this.callEvent('change', e);
    }
    mouseOver(e) {
        this.callEvent('mouseEnter', e);
    }
    mouseMove(e) {
        this.callEvent('mouseMove', e);
    }
    mouseLeave(e) {
        this.callEvent('mouseLeave', e);
    }
    contextMenu(e) {
        this.callEvent('contextMenu', e);
    }
    notifyWindowBringTop(e) {
        this.callEvent('notifyWindowToBringTop', e);
        this.ajaxInteractionBaseService?.notifyClick(new EventData$1(e, this.component.id));
    }
    get display() {
        if (this.callAttr('visible') || this.callAttr('isInsideGridCell')) {
            return this.component.getStyleDisplay();
        }
        else {
            return 'none';
        }
    }
    callEvent(eventName, e) {
        const component = this.hostComponent;
        /* c8 ignore else */
        if (component && component[eventName]) {
            component[eventName](e);
        }
    }
    callAttr(attrName) {
        const component = this.hostComponent;
        return component[attrName];
    }
}
ControlsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ControlsDirective, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: FocusManagerService, optional: true }, { token: MainTabOrderService, optional: true }, { token: ContainerTabOrderService, optional: true }, { token: WebComponentsService, optional: true }, { token: AjaxInteractionBaseService, optional: true }, { token: WMWindowService, optional: true }, { token: i3.LoadingStateService, optional: true }, { token: GridCustomEditorInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
ControlsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: ControlsDirective, selector: "[wmControls]", host: { listeners: { "focus": "focus($event)", "blur": "blur($event)", "keypress": "keyPress($event)", "keydown": "keyDown($event)", "keyup": "keyUp($event)", "change": "textChanged($event)", "mouseenter": "mouseOver($event)", "mousemove": "mouseMove($event)", "mouseleave": "mouseLeave($event)", "contextmenu": "contextMenu($event)", "click": "notifyWindowBringTop($event)" }, properties: { "title": "this.tooltip", "style.display": "this.display" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ControlsDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[wmControls]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: FocusManagerService, decorators: [{
                    type: Optional
                }] }, { type: MainTabOrderService, decorators: [{
                    type: Optional
                }] }, { type: ContainerTabOrderService, decorators: [{
                    type: Optional
                }] }, { type: WebComponentsService, decorators: [{
                    type: Optional
                }] }, { type: AjaxInteractionBaseService, decorators: [{
                    type: Optional
                }] }, { type: WMWindowService, decorators: [{
                    type: Optional
                }] }, { type: i3.LoadingStateService, decorators: [{
                    type: Optional
                }] }, { type: GridCustomEditorInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { tooltip: [{
                type: HostBinding,
                args: ['title']
            }], focus: [{
                type: HostListener,
                args: ['focus', ['$event']]
            }], blur: [{
                type: HostListener,
                args: ['blur', ['$event']]
            }], keyPress: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }], keyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], keyUp: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }], textChanged: [{
                type: HostListener,
                args: ['change', ['$event']]
            }], mouseOver: [{
                type: HostListener,
                args: ['mouseenter', ['$event']]
            }], mouseMove: [{
                type: HostListener,
                args: ['mousemove', ['$event']]
            }], mouseLeave: [{
                type: HostListener,
                args: ['mouseleave', ['$event']]
            }], contextMenu: [{
                type: HostListener,
                args: ['contextmenu', ['$event']]
            }], notifyWindowBringTop: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], display: [{
                type: HostBinding,
                args: ['style.display']
            }] } });

/**
 * Array containing the classes that need to subscribe to the underlineObservable
 */
const underlineSubscriptionComponents = [
    'ButtonComponent',
    'CheckBoxComponent',
    'LabelComponent',
    'RadiobuttonComponent',
    'ToolStripDropdownButtonComponent',
    'ToolStripMenuItemComponent'
];
class ControlComponent extends ControlComponentBaseComponent {
    /**
     * Gets dock from model
     */
    get dock() {
        return this.model ? this.model.Dock : DockStyle.None;
    }
    /**
     * Sets dock to the model
     */
    set dock(value) {
        this.model.Dock = value;
    }
    /**
     * Gets docking order from the model.
     */
    get dockingOrder() {
        return this.model && this.model.DockingOrder != null
            ? this.model.DockingOrder
            : [];
    }
    get parent() {
        return this.model?.Parent;
    }
    /**
     * Gets default dock to add in first place for the dock property
     */
    get defaultDock() {
        return false;
    }
    /**
     * Gets the distance, in pixels, between the top edge of the control and the top edge of its container's client area.
     */
    get top() {
        return this.model && this.model.Top ? this.model.Top : null;
    }
    /**
     * Sets the distance, in pixels, between the top edge of the control and the top edge of its container's client area.
     */
    set top(value) {
        if (this.model.Style) {
            this.model.Style.Top = value ? `${value}px` : null;
            this.model.Style.Dirty = true;
        }
        this.model.Top = value;
    }
    get bottom() {
        return this.model ? this.model.Bottom : null;
    }
    get right() {
        return this.model.Right;
    }
    /**
     * Gets the distance, in pixels, between the left edge of the control and the left edge of its container's client area.
     */
    get left() {
        return this.model.Left ? this.model.Left : null;
    }
    /**
     * Sets the distance, in pixels, between the left edge of the control and the left edge of its container's client area.
     */
    set left(value) {
        if (this.model.Style) {
            this.model.Style.Left = value ? `${value}px` : null;
            this.model.Style.Dirty = true;
        }
        this.model.Left = value;
    }
    get model() {
        return this._model;
    }
    set model(value) {
        this._model = value;
    }
    get id() {
        return this.model ? this.model.UniqueID : '';
    }
    set id(value) {
        this.model.UniqueID = value;
    }
    get events() {
        return this.model ? this.model.events : [];
    }
    set events(value) {
        this.model.events = value;
    }
    set name(value) {
        this.model.Name = value;
    }
    get name() {
        return this.model ? this.model.Name : '';
    }
    get text() {
        return this.model ? this.model.Text : '';
    }
    set text(value) {
        this.model.Text = value;
    }
    /**
     * Current instance of the static WebMapService
     *
     * @return {*}  {*}
     * @memberof ControlComponent
     */
    currentWebMapService() {
        return WebMapService.currentService;
    }
    /**
     * Returns a subscription if the component is part of the underlineSubscriptionComponents
     * and the text of the model includes an ampersand
     * If not, it returns null
     * @readonly
     * @type {(Subscription | null)}
     * @memberof ControlComponent
     */
    get UnderlineSubscription() {
        return underlineSubscriptionComponents.some((className) => this.getType() === className) &&
            this.model.Text &&
            this.model.Text.includes('&')
            ? this.shortcutsService?.shortcutUnderlineEmitted.subscribe((showUnderline) => {
                this.showUnderline = showUnderline;
                this.detectChangesExecution();
                if (this.triggerShortcutUnderlineSubscription) {
                    this.triggerShortcutUnderlineSubscription.unsubscribe();
                }
            })
            : null;
    }
    /**
     * Gets enabled property according my value and the value of my parent
     */
    get enabled() {
        const isEnabled = this.model.Enabled;
        const parent = WebMapService.currentService?.core?.getModel(this.model.Parent);
        if (isEnabled && parent) {
            return parent.Enabled;
        }
        return isEnabled;
    }
    /**
     * Set enable property for component and their children
     * Property EnabledInternal: is used to check the original enabled state of any control.
     * IMPORTANT: This property is modify only when the component is modified by himself
     * its parent can't modify it
     * @memberof ControlComponent
     */
    set enabled(value) {
        const parent = WebMapService.currentService?.core?.getModel(this.model.Parent);
        if (value && parent && !parent.Enabled) {
            return;
        }
        this.model.Enabled = value;
        this.model.EnabledInternal = value;
        WebMapService.currentService?.notifyChange(this.model, 'EnabledInternal');
        const children = this.model.Children;
        if (children === undefined || children.length <= 0) {
            return;
        }
        this.changeChildEnableStatus(this.model, value);
    }
    /**
     * Gets IsForm property
     */
    get isForm() {
        return this.model.IsForm;
    }
    /**
     * Property EnabledInternal: is used to check the original enabled state of any control.
     * IMPORTANT: This property is modify only when the component is modified by himself
     * its parent can't modify it
     *
     * @param {boolean} value
     * @memberof ControlComponent
     */
    changeChildEnableStatus(parent, value) {
        if (!parent || !parent.EnabledInternal) {
            return;
        }
        parent.Enabled = value;
        WebMapService.currentService?.notifyChange(parent, 'Enabled');
        const children = parent.Children;
        if (children && children.length > 0) {
            for (const child of children) {
                const modelChild = WebMapService.currentService?.core?.getModel(child);
                this.changeChildEnableStatus(modelChild, value);
            }
        }
    }
    get visible() {
        // Check if it is a custom control, if so, return True to make the control visible.
        if (this.customControl) {
            return true;
        }
        else {
            return this.model && this.model.Visible;
        }
    }
    set visible(value) {
        this.model.Visible = value;
    }
    get width() {
        return this.model.Width ? this.model.Width : null;
    }
    set width(value) {
        if (this.model.Style) {
            this.model.Style.Width = value ? `${value}px` : null;
            this.model.Style.Dirty = true;
        }
        this.model.Width = value;
        this.resize(null);
    }
    get backColor() {
        return this.model.Style.BackColor ? this.model.Style.BackColor : null;
    }
    set backColor(value) {
        this.model.Style.BackColor = value;
        this.model.Style.Dirty = true;
    }
    set foreColor(value) {
        this.model.Style.ForeColor = value;
        this.model.Style.Dirty = true;
    }
    get foreColor() {
        return this.model.Style.ForeColor ? this.model.Style.ForeColor : null;
    }
    get height() {
        return this.model.Height ? this.model.Height : null;
    }
    set height(value) {
        if (this.model.Style) {
            this.model.Style.Height = value ? `${value}px` : null;
            this.model.Style.Dirty = true;
        }
        this.model.Height = value;
        this.resize(null);
    }
    get tooltip() {
        return this.model?.Tooltip ? this.model.Tooltip : '';
    }
    set tooltip(value) {
        this.model.Tooltip = value;
    }
    get allowDrop() {
        return !!this.model?.AllowDrop;
    }
    /**
     * Gets autosize
     */
    get autosize() {
        return !!this.model?.AutoSize;
    }
    /**
     * Gets autosizemode
     */
    get autosizemode() {
        return this.model ? this.model.AutoSizeMode : AutoSizeMode.GrowAndShrink;
    }
    /**
     * Gets bring top internal
     * Gets the previous applied value for this component bringTop property
     */
    get bringTopInternal() {
        return this.model && this.model.BringTopInternal;
    }
    /**
     * Sets bring top internal
     * Preserves in the model the previous applied value of the bringTop property
     * It is saved in the model to be available in components that are created dinamically
     */
    set bringTopInternal(value) {
        /* c8 ignore else */
        if (this.model) {
            this.model.BringTopInternal = value;
        }
    }
    /**
     * @description
     * Gets the value of the bringTop property
     * @param value The new value to set model property.
     */
    get bringTop() {
        return this.model && this.model.BringTop;
    }
    /**
     * @description
     * Sets the value of the bringTop property
     * @param value The new value to set model property.
     */
    set bringTop(value) {
        /* c8 ignore else */
        if (this.model) {
            this.model.BringTop = value;
        }
    }
    get disabled() {
        if (this.model.Enabled !== undefined && !this.model.Enabled) {
            return true;
        }
        return null;
    }
    /**
     * Gets anchor value for the current
     * component
     */
    get anchor() {
        return this.model ? this.model.Anchor : AnchorStyles.None;
    }
    /**
     * Gets context menu strip
     */
    get contextMenuStrip() {
        return this.model.ContextMenuStrip;
    }
    /**
     * Returns the value of the isFocused flag that is changed using the
     * CHANGE_FOCUSED_CONTROL to apply focus to the component
     */
    get isFocused() {
        return !!this.model?.isFocused;
    }
    /**
     * Sets isFocused flag to sent notification to back-end indicating that focus
     * was applied to angular component successfully
     */
    set isFocused(value) {
        this.model.isFocused = value;
    }
    /**
     * get the font object.
     */
    get font() {
        if (!this._font) {
            this._font = new Font();
            this._font.model = this.model;
        }
        return this._font;
    }
    /**
     * set the current font object.
     */
    set font(value) {
        this._font = value;
        this._font.model = this.model;
    }
    /**
     * Gets focused property indicating that the control is focus
     */
    get focused() {
        return !!this.model?.Focused;
    }
    /**
     * Sets focused property to mark control as focused
     */
    set focused(value) {
        this.model.Focused = value;
    }
    /**
     * Gets z index
     */
    get zIndex() {
        return this.model?.zIndex;
    }
    /**
     * Sets z index
     */
    set zIndex(zIndex) {
        this.model.zIndex = zIndex;
    }
    /*
     * Gets show tooltip
     */
    get showTooltip() {
        return this.model?.ShowTooltip;
    }
    /**
     * Returns the element (input, textbox, textarea, button, label, etc)
     * that is going to receive the focus.
     */
    get focusableElement() {
        return this.displayElement;
    }
    /**
     * Gets tab order
     */
    get tabOrder() {
        return this.calculateTabOrder();
    }
    /**
     * This object contains the style information for the component. It is clean,
     * smooth and ready to be bound to HTML
     */
    get boundStyle() {
        return this.model.BoundStyle;
    }
    set boundStyle(value) {
        this.model.BoundStyle = value;
    }
    /**
     * This property allows the control to use shortcuts or not using the & in the text property.
     *
     * @type {*}
     * @memberof ControlComponent
     */
    get useMnemonic() {
        return this.model.UseMnemonic ?? true;
    }
    set useMnemonic(value) {
        this.model.UseMnemonic = value;
    }
    /**
     * Gets refresh property
     */
    get refresh() {
        return this.model.Refresh;
    }
    /**
     * Sets refresh property
     */
    set refresh(value) {
        this.model.Refresh = value;
    }
    /**
     * Gets the display element
     *
     * @memberof ControlComponent
     */
    get displayElement() {
        return this.displayElementInner;
    }
    /**
     * Sets the display element
     *
     * @memberof ControlComponent
     * @param {HTMLElement} value
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * @param event event to call
     * @param component component used to get the id.
     */
    static keyPressEventArgsExtractor(event, component) {
        const charCode = event.charCode;
        return [
            { Id: component.id, MapperId: component.model.mapperId },
            { MapperId: 'keyPressEvntArgs', KeyChar: charCode }
        ];
    }
    static keyEventArgsExtractor(event, component) {
        return [
            { Id: component.id, MapperId: component.model.mapperId },
            {
                MapperId: 'keyEventArgs',
                KeyCode: event.keyCode,
                KeyData: KeyUtils.getKeyData(event),
                AltKey: event.altKey,
                CtrlKey: event.ctrlKey,
                ShiftKey: event.shiftKey
            }
        ];
    }
    static keyEditEventArgsExtractor(event, component) {
        return [
            { Id: component.id, MapperId: component.model.mapperId },
            {
                Row: component.model.Row,
                Col: component.model.Col,
                MapperId: 'kyDtVntRgs',
                KeyCode: event.keyCode,
                KeyData: KeyUtils.getKeyData(event),
                AltKey: event.altKey,
                CtrlKey: event.ctrlKey,
                ShiftKey: event.shiftKey
            }
        ];
    }
    static EnterEventArgsExtractor(event, component) {
        return [{ Id: component.id, MapperId: component.model.mapperId }, null];
    }
    static dragDropEventArgsExtractor(event, component) {
        return [{ Id: event.Id, MapperId: event.MapperId }, null];
    }
    /* c8 ignore start */
    constructor(ref, renderer, el, webComponents = null, bringTopService = null, containerInteraction, shortcutsService) {
        super();
        this.ref = ref;
        this.renderer = renderer;
        this.el = el;
        this.webComponents = webComponents;
        this.bringTopService = bringTopService;
        this.containerInteraction = containerInteraction;
        this.shortcutsService = shortcutsService;
        /**
         * The controlFlag help us to avoid twice calls.
         *
         * @memberof ControlComponent
         */
        this.controlFlag = true;
        /**
         * This flag allows the controller to display the errorProvider.
         */
        this.errorIsShowed = false;
        /**
         * This flag lets the controller know if the error provider has been rendered.
         */
        this.errorIsRendered = false;
        /**
         * Flag indicating whether the control has the error provider subscription.
         */
        this.hasErrorProviderSubscription = false;
        /**
         * A reference for managing component registration manually
         */
        this.registerManually = false;
        /**
         * Property to know if the inline styles should not be applied.
         *
         * @memberof ControlComponent
         */
        this.useCss = false;
        /**
         * Property to trigger the underline of the shortcuts
         *
         * @memberof ControlComponent
         */
        this.showUnderline = false;
        /**
         * Validate the component inherits from controlComponent or is an instance of controlComponent
         * @returns type
         */
        this.isControlComponent = true;
        ref.markForCheck();
    }
    /**
     * Process special dock for the current Control.
     * you should override the method in the specify control.
     * @param component child component
     * @param size parentSize
     * @param offset offset for the current child
     * @returns special dock. new size and offset for the dock context.
     */
    processSpecialDock(component, size, offsets) {
        return { size, offsets };
    }
    /**
     * Gets the new Style
     */
    getStyle() {
        return new Style();
    }
    /**
     * Gets the wrapper element of the control in the DOM.
     */
    getWrapperElement() {
        return null;
    }
    /**
     * Gets the extra element affecting the position of the error provider.
     */
    getExtraElement() {
        return null;
    }
    /**
     * Gets if is usercontrol or not
     */
    isUserControl() {
        return false;
    }
    /**
     * Specials style.
     * Override this method if you want to handle special style for the dock
     * @returns style
     */
    specialStyle() {
        return;
    }
    /**
     * This function should be overridden on the components that need the detectChanges()
     * function to be called on the subscription of the detect changes
     */
    detectChangesExecution() {
        // This function should be overridden if the components need to execute something
        // when the detect changes subscription is executed
        this.detectChanges();
    }
    ngOnInit() {
        this.detectChangesSubscribe();
        this.style = new Style();
        this.originalVisibility = this.visible;
        if (this.webComponents && this.model) {
            this.webComponents.registerComponent(this);
        }
        if (this.canSubscribeToErrorProvider()) {
            this.subscribeErrorProvider();
        }
        /* c8 ignore next */
        this.triggerShortcutUnderlineSubscription = this.UnderlineSubscription;
    }
    ngAfterViewChecked() {
        if (this.webComponents && this.model) {
            this.updateDockProperty();
            this.applyAutoSizeProperty();
            if (this.originalVisibility !== this.visible) {
                setTimeout(() => {
                    this.notifyParentAutoSize();
                }, 10);
                this.originalVisibility = this.visible;
            }
        }
    }
    ngOnDestroy() {
        /* istabul ignore else */
        if (this.webComponents) {
            this.webComponents.unRegisterComponent(this);
        }
        if (WebMapService.currentService) {
            WebMapService.currentService.core
                .getEvent()
                .unSubscribe(this.detectChangesSubscription);
            WebMapService.currentService.core
                .getEvent()
                .unSubscribe(this.syncCompleteSubscription);
        }
    }
    ngAfterViewInit() {
        this.class = this.isInsideGridCell ? '' : this.class;
        if (!!this.class) {
            const classes = this.class.split(' ');
            classes.forEach((element) => {
                if (!!element) {
                    this.renderer.removeClass(this.el.nativeElement, element);
                }
            });
        }
        if (!!this.tabindex) {
            this.renderer.removeAttribute(this.el.nativeElement, 'tabindex');
        }
        if (this.displayElement != null &&
            getComputedStyle(this.displayElement).width !== '') {
            this.afterFirstCall = true;
            this.setDisplayElementOriginalDimensions();
            delete this.webComponents.anchorCalled[this.id];
            this.startAnchorProcess();
            this.updateDockProperty();
        }
        else {
            /* this interval is used to get the element from the DOM.
               there is not way to know when the element is already render in the DOM,
                so I create this interval to check it until the element is render.
             */
            const interval = setInterval(() => {
                if (this.isComponentReady()) {
                    clearInterval(interval);
                    this.setDisplayElementOriginalDimensions();
                    this.afterFirstCall = true;
                    this.startAnchorProcess();
                    this.updateDockProperty();
                }
            }, 100);
        }
        // CustomControl initialization.
        this.customControl = this.isCustomControl();
    }
    /**
     * Each component that have the isForm as true should implement this method
     *
     * @memberof ControlComponent
     */
    /* c8 ignore next */
    detectChangesSubscribe() {
        if (WebMapService.currentService) {
            this.detectChangesSubscription = WebMapService.currentService.core
                .getEvent()
                .subscribe('detectChanges', 
            /* c8 ignore next */
            (url) => {
                if (this.id === url || url?.BE2FEUpdate) {
                    this.detectChangesExecution();
                }
            });
        }
    }
    /**
     * Determines whether component is ready in the DOM
     * @returns true if component ready
     */
    isComponentReady() {
        return (this.displayElement != null &&
            getComputedStyle(this.displayElement).width !== '');
    }
    /**
     * It is necessary to check continuously if the Control has an error,
     * for that reason the function checkErrorProvider must be call on the ngDoCheck
     */
    ngDoCheck() {
        if (!this.hasErrorProviderSubscription &&
            this.canSubscribeToErrorProvider()) {
            this.subscribeErrorProvider();
        }
        if (this.shouldValidateErrorProvider()) {
            this.checkErrorProvider();
        }
        this.bringToFrontService();
        this.setChildIndex();
        this.tooltipHandler();
    }
    /**
     * Triggers a detect change action
     */
    detectChanges() {
        /* c8 ignore else */
        if (!this.ref['destroyed']) {
            this.ref.detectChanges();
            // This is to force the ngDoCheck because some changes on model should be checked to apply logic to the control
            // This happens because the detectChanges is only triggered when changes comes from model to specific controls that have that changes
            this.markForCheck();
        }
    }
    /**
     * Marks for check
     * Marks component to be checked by the next
     * detect changes action
     */
    markForCheck() {
        /* c8 ignore else */
        if (!this.ref['destroyed']) {
            this.ref.markForCheck();
        }
    }
    /**
     * Indicates if an event is binded in the server or not.
     * @param event The name of the event in the server.
     */
    isBindedEvent(event) {
        return this.events && this.events[event];
    }
    /**
     * Method to allow each component to manage its own
     * display property
     * Example : {display: 'block'}
     */
    getStyleDisplay() {
        return '';
    }
    /**
     * Trigger the event resize defined through the output member.
     * @param event The event object.
     */
    resize(event) {
        this.Resize.emit(new EventData$1(event, this.id));
    }
    focus(event) {
        this.GotFocus.emit(new EventData$1(event, this.id));
    }
    blur(event) {
        this.LostFocus.emit(new EventData$1(event, this.id));
    }
    change(event) {
        this.TextChanged.emit(new EventData$1(event, this.id));
    }
    keyPress(event) {
        this.KeyPress.emit(new EventData$1(event, this.id));
    }
    keyDown(event) {
        this.addModifierKey(event.keyCode);
        // Use the controlFlag to avoid twice calls on c1flexgridDefault.
        if (this.controlFlag) {
            this.KeyDown.emit(new KeyEventArgs(event, this.id, this));
        }
    }
    keyUp(event) {
        this.removeModifierKey(event.keyCode);
        //Use the controlFlag to avoid twice calls on c1flexgridDefault.
        if (this.controlFlag) {
            this.KeyUp.emit(new KeyEventArgs(event, this.id, this));
        }
    }
    /**
     * Triggers the leave-validating-validated events in the correct order.
     *
     * @param {*} event
     * @memberof ControlComponent
     */
    leaveEventsHandler(event) {
        this.leave(event);
        this.validating(event);
        this.validated(event);
    }
    leave(event) {
        this.Leave.emit(new EventData$1(event, this.id));
    }
    validating(event) {
        this.Validating.emit(new EventData$1(event, this.id));
    }
    validated(event) {
        this.Validated.emit(new EventData$1(event, this.id));
    }
    enter(event) {
        // Use the controlFlag to avoid twice calls on c1flexgridDefault.
        if (this.controlFlag) {
            this.Enter.emit(new EventData$1(event, this.id));
        }
    }
    /**
     * Handles the dragdrop event.
     * Should stop server propagation if allowdrop is false;
     * @param event the drop data
     */
    dragDrop(event) {
        if (this.allowDrop) {
            this.DragDrop.emit(new EventData$1(event, this.id));
        }
        else {
            return true; // Cancel Execution
        }
        return false; // Continue Execution
    }
    contextMenu(event) {
        const evtData = new EventData$1(event, this.id);
        evtData.event['ctxId'] = this.contextMenuStrip;
        this.ContextMenu.emit(evtData);
        if (WebMapService.currentService) {
            WebMapService.currentService.core.getEvent().publish('ctxMenu', evtData);
        }
    }
    /**
     * Determines whether applyFocus method should be called.
     * @returns true if apply focus
     */
    shouldApplyFocus() {
        return this.isFocused;
    }
    /**
     * Applies focus to input or selectable element in
     * component. It triggers dom element focus()
     */
    applyFocus() {
        if (this.focusableElement) {
            this.isApplyingFocus = true;
            this.focusableElement.focus();
            this.isApplyingFocus = false;
        }
    }
    /**
     * Mouses enter
     * Shows tooltip if need it
     * @param event the current js event object
     */
    mouseEnter(event) {
        /* c8 ignore else */
        if (this.showTooltip === undefined) {
            this.showTooltipDirective();
        }
    }
    /**
     * MouseMove event
     * emit the data for every mouseMove event
     * @param {*} event
     * @memberof ControlComponent
     */
    mouseMove(event) {
        const data = new MouseEventArgs(event, this.id, this);
        this.MouseMove.emit(data);
    }
    /**
     * Mouses leave
     * Hides tooltip if need it
     * @param event the current js event object
     */
    mouseLeave(event) {
        /* c8 ignore else */
        if (this.showTooltip === undefined) {
            this.hideToolTipDirective();
        }
    }
    /**
     * Notifies the window to bring top
     * When a control is clicked or focused in the screen
     * @param event The current javascript event
     */
    notifyWindowToBringTop(event) {
        if (this.bringTopService) {
            this.bringTopService.notifyWindowBringToFront(event);
        }
    }
    /**
     * Returns a valid style object to
     * be applied according to the styling information set in the
     * control's model
     */
    setMyStyle() {
        if (!this.useCss) {
            // This is to validate if a control is only a leaf of inheritance controls. This is for the approach used for inherit controls
            const validateIsLeafOrSimpleComponent = this.el?.nativeElement?.id === this.name ||
                this.class === this.name ||
                this.el?.nativeElement?.className?.includes(this.name);
            if (this.model.Style &&
                validateIsLeafOrSimpleComponent &&
                !ValidateObject.isEmptyObject(this.model.Style) &&
                this.model.Style.Dirty) {
                // It has been found that sometimes this.style is undefined
                if (!this.style) {
                    this.style = this.getStyle();
                }
                this.style.update(this.model.Style);
                this.model.Style.Dirty = false;
                this.boundStyle = FilterObject.cleanCopy(this.style);
            }
            return this.boundStyle;
        }
    }
    /**
     * Auxiliary function that returns values in some especial cases, this to reduce
     * the cognitive complexity of the function checkErrorProvider
     */
    /* c8 ignore start */
    errorValueAux() {
        if (this.model &&
            this.model.ErrorProviderMessage != null &&
            this.displayElement) {
            if (this.model.ErrorProviderMessage.length > 0 &&
                !this.errorIsShowed &&
                this.model.Visible) {
                return 1;
            }
            else if ((this.model.ErrorProviderMessage.length === 0 || !this.model.Visible) &&
                this.errorIsShowed) {
                return 2;
            }
            else if (this.model.ErrorProviderMessage.length > 0 &&
                this.errorIsShowed &&
                this.model.Visible) {
                return 3;
            }
        }
        return 0;
    }
    /* c8 ignore stop */
    /**
     * Auxiliary function notifying that the errorProvider has been rendered, this to reduce
     * the cognitive complexity of the function checkErrorProvider
     */
    notifyErrorProvider() {
        const eventData = new EventData$1({}, this.model.id);
        ErrorProvider.notifyErrorProviderRendered(eventData);
        this.errorIsShowed = true;
    }
    /**
     * Auxiliary function that creates the image of the errorProvider, this to reduce
     * the cognitive complexity of the function checkErrorProvider
     */
    createErrorProvider() {
        /* c8 ignore if */
        if (this.isUserControl() && this.errorIsRendered) {
            // If the error has occurred, it is not necessary to display it again.
            this.notifyErrorProvider();
        }
        else if (this.displayElement && this.displayElement.offsetWidth > 0) {
            const element = this.displayElement;
            const img = this.renderer.createElement('img');
            this.renderer.setAttribute(img, 'title', this.model.ErrorProviderMessage);
            this.renderer.setAttribute(img, 'src', this.model.ErrorProviderImage);
            this.renderer.setAttribute(img, 'style', this.getElementErrorProviderStyle(element));
            this.renderer.appendChild(this.getElementErrorProvider(element), img);
            this.notifyErrorProvider();
            this.errorProviderIconWasCreated = true;
        }
        else {
            this.errorProviderIconWasCreated = false;
        }
    }
    /**
     * This function handles the subscription to the ErrorProvider.
     */
    subscribeErrorProvider() {
        ErrorProvider.errorProviderRendered
            .asObservable()
            .subscribe((event) => {
            this.verifyErrorProvider(event);
        });
        this.hasErrorProviderSubscription = true;
    }
    /**
     * Returns true if the control is ready to subscribe to the ErroProvider.
     */
    canSubscribeToErrorProvider() {
        return this.model && this.model.ErrorProviderImage;
    }
    /**
     * This function handles the ErrorProvider for each component
     */
    checkErrorProvider() {
        switch (this.errorValueAux()) {
            case 1:
                this.createErrorProvider();
                break;
            case 2:
                const lastChild = this.getElementErrorProvider(this.displayElement).lastChild;
                /* c8 ignore start */
                if (lastChild.tagName !== 'IMG') {
                    return;
                }
                /* c8 ignore stop */
                this.renderer.removeChild(this.getElementErrorProvider(this.displayElement), this.getElementErrorProvider(this.displayElement).lastChild);
                this.errorIsShowed = false;
                this.errorIsRendered = false;
                break;
            case 3:
                const img = this.getElementErrorProvider(this.displayElement).lastChild;
                /* c8 ignore start */
                if (img.tagName !== 'IMG') {
                    return;
                }
                /* c8 ignore stop */
                if (img.title !== this.model.ErrorProviderMessage) {
                    img.title = this.model.ErrorProviderMessage;
                }
                /* c8 ignore else */
                if (img.src !== this.model.ErrorProviderImage) {
                    img.src = this.model.ErrorProviderImage;
                }
                break;
            default:
                break;
        }
    }
    /**
     * Function that verifies that another component does not duplicate the same errorProvider
     *
     * @param {EventData} event
     * @memberof ControlComponent
     */
    verifyErrorProvider(event) {
        /**
         *  errorIsRendered is set if another component with the same id
         *  has already displayed the error
         */
        if (this.model.id == event.Id) {
            if (!this.errorIsRendered)
                this.errorIsRendered = true;
            else {
                /**
                 * If the component is a user control, the error must be eliminated to avoid multiple rendered images.
                 */
                /* c8 ignore next */
                if (this.isUserControl()) {
                    const element = this.getElementErrorProvider(this.displayElement);
                    if (element.lastChild.tagName == 'IMG')
                        this.renderer.removeChild(element, element.lastChild);
                }
            }
        }
    }
    /**
     * Get the corresponding element depending of the TagName
     * @param element The current element
     */
    getElementErrorProvider(element) {
        return element.tagName === ControlComponent.DIV_TAG
            ? element
            : element.parentElement;
    }
    /**
     * Get the corresponding Style depending of the TagName
     * @param element The current element
     */
    getElementErrorProviderStyle(element) {
        const top = element.offsetTop;
        const left = element.offsetLeft;
        const width = this.getElementsWidth();
        let providerStyle;
        if (this.getExtraElement() !== null) {
            providerStyle = `position: absolute;top: 3px;left:calc(100% + ${this.getExtraElement().offsetWidth + 4}px);width: 16px;height: 16px;z-index: 1;`;
        }
        else {
            providerStyle =
                element.tagName === ControlComponent.DIV_TAG
                    ? `position: absolute;top: 3px;left:${width + 2}px;width: 16px;height: 16px;z-index: 1;`
                    : `position: absolute;top:${top + 3}px;left:${left + width + 4}px;width: 16px;height: 16px;z-index: 1;`;
        }
        return providerStyle;
    }
    /**
     *Calculate the total width, including all siblings elements.
     */
    getElementsWidth() {
        let width = 0;
        const el = this.getWrapperElement() !== null
            ? this.getWrapperElement()
            : this.displayElement;
        /* c8 ignore next */
        if (el.parentElement?.childElementCount > 1) {
            const elements = el.parentElement.children;
            for (const item of elements) {
                width += item.offsetWidth;
            }
        }
        else {
            width = el.offsetWidth;
        }
        return width;
    }
    /**
     * Applies auto size property
     * Fix the current control dimensions to fit its content
     * according to the autosize and autosizemode properties
     */
    applyAutoSizeProperty() {
        if (!this.autoSizeApplied &&
            this.afterFirstCall &&
            this.autosize &&
            this.autosizemode != null &&
            !this.useCss &&
            this.displayElement) {
            const newPos = this.getNewPositions();
            this.currentAutoSizeMode = this.autosizemode;
            if (this.autosizemode === AutoSizeMode.GrowAndShrink) {
                this.renderer.setStyle(this.displayElement, 'width', `${newPos.maxLeft}px`);
                this.renderer.setStyle(this.displayElement, 'height', `${newPos.maxTop}px`);
                this.removeStyleProperty('Height');
                this.removeStyleProperty('Width');
            }
            else {
                const controlWidth = getComputedValue(this.displayElement, 'width', 0);
                const controlHeight = getComputedValue(this.displayElement, 'height', 0);
                if (newPos.maxLeft > controlWidth) {
                    this.renderer.setStyle(this.displayElement, 'width', `${newPos.maxLeft}px`);
                }
                if (newPos.maxTop > controlHeight) {
                    this.renderer.setStyle(this.displayElement, 'height', `${newPos.maxTop}px`);
                }
            }
            this.notifyParentAutoSize();
            this.autoSizeApplied = true;
        }
    }
    /**
     * Applies anchor property
     */
    applyAnchorProperty() {
        if (this.webComponents && this.afterFirstCall && this.model?.IsForm) {
            this.webComponents.applyAnchorToComponent(this);
            this.anchorApplied = this.anchor;
        }
    }
    /**
     * Bring to the front the current control.
     */
    bringToFront() {
        if (this.bringTopService.lastTopElement) {
            this.bringTopService.restoreTopElement(this.bringTopService.lastTopElement);
        }
        this.bringTopService.bringElementTop(this.el);
        // In order to avoid a call to bring to top in ng do check.
        this.bringTop = this.bringTopInternal = true;
    }
    /**
     * Notifies leave
     * @param event the current event
     */
    notifyEvent(eventName, event) {
        if (this.containerInteraction) {
            const eventData = new EventData$1(event, this.id);
            eventData.args = eventName;
            this.containerInteraction.notifyEvent(eventData);
        }
    }
    /**
     * Sets display element original dimensions
     */
    setDisplayElementOriginalDimensions() {
        this.originalHeight = getComputedValue(this.displayElement, 'height', 0);
        this.originalWidth = getComputedValue(this.displayElement, 'width', 0);
    }
    /**
     * Gets string indicating the type
     * @returns type
     */
    getType() {
        return 'ControlComponent';
    }
    /**
     * Resolves pending tab subscriptions for components that were resolved as
     * pending parent
     * @param component Component to subscribe
     */
    resolvePendingTabSubscriptions() {
        this.tabDirective?.registerComponent();
    }
    /**
     * compare if the dock is different and call the dockChange
     */
    updateDockProperty() {
        if (this.currentDockingOrder !== this.dockingOrder &&
            this.dockingOrder.length > 0) {
            this.currentDockingOrder = this.dockingOrder;
        }
        if (this.afterFirstCall &&
            this.currentDock !== this.dock &&
            this.dock != null) {
            this.currentDock = this.dock;
        }
    }
    /**
     * Gets new positions
     * Analyze the children components and get the new sizes for
     * this control with the autoSizeMode
     * @returns new positions
     */
    getNewPositions() {
        let maxLeft = 0;
        let maxTop = 0;
        this.children.forEach((element) => {
            /* c8 ignore else */
            if (element.displayElement) {
                const currentLeft = getComputedValue(element.displayElement, 'right', 0);
                maxLeft = maxLeft < currentLeft ? currentLeft : maxLeft;
                const currentTop = getComputedValue(element.displayElement, 'bottom', 0);
                maxTop = maxTop < currentTop ? currentTop : maxTop;
            }
        });
        const controlRectTop = getComputedValue(this.displayElement, 'top', 0);
        const controlRectLeft = getComputedValue(this.displayElement, 'left', 0);
        return {
            maxTop: maxTop - controlRectTop,
            maxLeft: maxLeft - controlRectLeft
        };
    }
    /**
     * Notifies parent auto size
     */
    notifyParentAutoSize() {
        /* c8 ignore else */
        if (this.webComponents) {
            const parent = this.webComponents.getParent(this);
            if (parent) {
                parent.autoSizeApplied = false;
            }
        }
    }
    /**
     * Sets child index to HTML zindex property
     */
    setChildIndex() {
        if (this.zIndex && this.lastZIndex !== this.zIndex) {
            this.renderer.setStyle(this.el.nativeElement, 'z-index', this.zIndex);
            this.renderer.setStyle(this.el.nativeElement, 'position', 'absolute');
            this.lastZIndex = this.zIndex;
            this.markForCheck();
        }
    }
    /**
     * Calculates tab order according to model value and TabStop
     * @returns tab order
     */
    calculateTabOrder() {
        if (this.model.TabStop === false) {
            return -1;
        }
        return Utils.validateTabOrder(this.model, this.tabindex);
    }
    /**
     * Check if this control is a custom editor for the c1flexgrid component.
     * @returns {boolean} Returns True if the control is within a custom editor column,
     * otherwise it returns False.
     */
    /* c8 ignore next */
    isCustomControl() {
        // WINFORMS COMPONENTS SHOULD NOT KNOW THAT WM-CUSTOM-EDITOR-COLUMN EXISTS, IT BELONGS TO WFNETC1
        // We should try to remove this function or replace with something more generic
        const customEditorColumn = this.el?.nativeElement?.closest('wm-custom-editor-column');
        if (customEditorColumn) {
            return ((this.model && this.model.VisibleInternal) || // add the new flag to check what control must be showing inside the cell
                this.el.nativeElement.tagName === 'WM-USERCONTROL' // if not exist visibleInternal but the control is wm-usercontrol return true
            );
        }
        else {
            return false;
        }
    }
    /**
     * Add a modifier key if it applies.
     * @param key The key to be added to modifier key.
     */
    addModifierKey(keyCode) {
        if (keyCode) {
            if (keyCode === 18) {
                ControlComponent.modifierKeys |= Keys.alt;
            }
            else if (keyCode === 17) {
                ControlComponent.modifierKeys |= Keys.control;
            }
            else if (keyCode === 16) {
                ControlComponent.modifierKeys |= Keys.shift;
            }
        }
    }
    /**
     * Remove a modifier key if it applies.
     * @param key The key to be removed.
     */
    removeModifierKey(keyCode) {
        if (keyCode) {
            if (keyCode == 18) {
                ControlComponent.modifierKeys &= ~Keys.alt;
            }
            else if (keyCode == 17) {
                ControlComponent.modifierKeys &= ~Keys.control;
            }
            else if (keyCode == 16) {
                ControlComponent.modifierKeys &= ~Keys.shift;
            }
        }
    }
    /**
     * Tooltips handler
     */
    tooltipHandler() {
        if (this.showTooltip &&
            (!this.tooltipDisplayed || this.originalTooltipText !== this.tooltip)) {
            this.showTooltipDirective();
            this.originalTooltipText = this.tooltip;
            this.tooltipDisplayed = true;
        }
        else if (this.showTooltip === false) {
            this.hideToolTipDirective();
            this.tooltipDisplayed = false;
        }
    }
    /**
     * Shows tooltip directive
     */
    showTooltipDirective() {
        if (this.tooltipDir && this.tooltip) {
            this.tooltipDir.show(this.displayElement);
        }
    }
    /**
     * Hides tool tip directive
     */
    hideToolTipDirective() {
        if (this.tooltipDir && this.tooltip) {
            this.tooltipDir.hide();
        }
    }
    /**
     * Bring to front service
     */
    bringToFrontService() {
        if (this.bringTop !== this.bringTopInternal && this.bringTopService) {
            if (this.bringTop) {
                this.bringTopService.bringElementTop(this.el);
            }
            else {
                this.bringTopService.restoreTopElement(this.el);
            }
            this.bringTopInternal = this.bringTop;
        }
    }
    /**
     * Starts anchor process
     * After rendering a new window the anchor process is triggered
     * before the docking process to ensure that the measure to edges are
     * correct and the anchor distances are calculated properly
     */
    startAnchorProcess() {
        setTimeout(() => {
            this.applyAnchorProperty();
            this.webComponents.startDocking(this);
        }, this.webComponents.delay);
    }
    /**
     * Sets style property
     * Updates model values for Style
     * @param property current property to update
     * @param value value
     */
    removeStyleProperty(property) {
        /* c8 ignore else */
        if (this.model.Style) {
            delete this.model.Style[property];
        }
    }
    /**
     * Determines if error provider should be validated
     * @returns true if it has to validate error provider
     */
    shouldValidateErrorProvider() {
        if (this.model &&
            (this.model.ErrorProviderMessage !== this.lastErrorProviderMessage ||
                !this.errorProviderIconWasCreated) &&
            this.model.Visible &&
            this.isComponentReady()) {
            this.lastErrorProviderMessage = this.model.ErrorProviderMessage;
            return true;
        }
        return false;
    }
    /**
     * Over ride if the component need to check for changes after losses focus
     */
    checkDetectChangesAfterLeave() { }
}
ControlComponent.DIV_TAG = 'DIV';
ControlComponent.modifierKeys = Keys.none;
ControlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ControlComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService, optional: true }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: ShortcutsService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ControlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ControlComponent, selector: "ng-component", inputs: { model: "model", tooltip: "tooltip", class: "class", tabindex: "tabindex", useCss: "useCss" }, viewQueries: [{ propertyName: "tooltipDir", first: true, predicate: TooltipDirective, descendants: true }, { propertyName: "tabDirective", first: true, predicate: ControlsDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ControlComponent.prototype, "dock", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Style.Top'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ControlComponent.prototype, "top", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Style.Left'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ControlComponent.prototype, "left", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Text'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ControlComponent.prototype, "text", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Enabled'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ControlComponent.prototype, "enabled", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Visible'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ControlComponent.prototype, "visible", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Style.Width'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ControlComponent.prototype, "width", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Style.BackColor'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ControlComponent.prototype, "backColor", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Style.ForeColor'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ControlComponent.prototype, "foreColor", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Style.Height'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ControlComponent.prototype, "height", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ControlComponent.prototype, "tooltip", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ControlComponent.prototype, "bringTopInternal", null);
__decorate([
    MarkForCheck(),
    NotifyChange('BringTop'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ControlComponent.prototype, "bringTop", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Focused'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ControlComponent.prototype, "focused", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ControlComponent.prototype, "zIndex", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Refresh'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ControlComponent.prototype, "refresh", null);
__decorate([
    serverEvent('Resize'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "resize", null);
__decorate([
    serverEvent('GotFocus'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "focus", null);
__decorate([
    serverEvent('LostFocus'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "blur", null);
__decorate([
    serverEvent('TextChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "change", null);
__decorate([
    serverEvent('KeyPress', ControlComponent.keyPressEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "keyPress", null);
__decorate([
    serverEvent('KeyDown', ControlComponent.keyEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "keyDown", null);
__decorate([
    serverEvent('KeyUp', ControlComponent.keyEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "keyUp", null);
__decorate([
    serverEvent('Leave'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "leave", null);
__decorate([
    serverEvent('Validating'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "validating", null);
__decorate([
    serverEvent('Validated'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "validated", null);
__decorate([
    serverEvent('Enter', ControlComponent.EnterEventArgsExtractor, null),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ControlComponent.prototype, "enter", null);
__decorate([
    serverEvent('DragDrop', ControlComponent.dragDropEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Boolean)
], ControlComponent.prototype, "dragDrop", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ControlComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { dock: [], top: [], left: [], model: [{
                type: Input
            }], text: [], enabled: [], visible: [], width: [], backColor: [], foreColor: [], height: [], tooltip: [{
                type: Input
            }], bringTopInternal: [], bringTop: [], focused: [], zIndex: [], refresh: [], tooltipDir: [{
                type: ViewChild,
                args: [TooltipDirective]
            }], tabDirective: [{
                type: ViewChild,
                args: [ControlsDirective, { static: false }]
            }], class: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], useCss: [{
                type: Input
            }], resize: [], focus: [], blur: [], change: [], keyPress: [], keyDown: [], keyUp: [], leave: [], validating: [], validated: [], enter: [], dragDrop: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Specifies alignment of content on the drawing surface.
 */
var ContentAlignment;
(function (ContentAlignment) {
    //
    // Summary:
    //     Content is vertically aligned at the top, and horizontally aligned on the left.
    ContentAlignment[ContentAlignment["TopLeft"] = 1] = "TopLeft";
    //
    // Summary:
    //     Content is vertically aligned at the top, and horizontally aligned at the center.
    ContentAlignment[ContentAlignment["TopCenter"] = 2] = "TopCenter";
    //
    // Summary:
    //     Content is vertically aligned at the top, and horizontally aligned on the right.
    ContentAlignment[ContentAlignment["TopRight"] = 4] = "TopRight";
    //
    // Summary:
    //     Content is vertically aligned in the middle, and horizontally aligned on the
    //     left.
    ContentAlignment[ContentAlignment["MiddleLeft"] = 16] = "MiddleLeft";
    //
    // Summary:
    //     Content is vertically aligned in the middle, and horizontally aligned at the
    //     center.
    ContentAlignment[ContentAlignment["MiddleCenter"] = 32] = "MiddleCenter";
    //
    // Summary:
    //     Content is vertically aligned in the middle, and horizontally aligned on the
    //     right.
    ContentAlignment[ContentAlignment["MiddleRight"] = 64] = "MiddleRight";
    //
    // Summary:
    //     Content is vertically aligned at the bottom, and horizontally aligned on the
    //     left.
    ContentAlignment[ContentAlignment["BottomLeft"] = 256] = "BottomLeft";
    //
    // Summary:
    //     Content is vertically aligned at the bottom, and horizontally aligned at the
    //     center.
    ContentAlignment[ContentAlignment["BottomCenter"] = 512] = "BottomCenter";
    //
    // Summary:
    //     Content is vertically aligned at the bottom, and horizontally aligned on the
    //     right.
    ContentAlignment[ContentAlignment["BottomRight"] = 1024] = "BottomRight";
})(ContentAlignment || (ContentAlignment = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Chart color enum
 */
var ChartColor;
(function (ChartColor) {
    ChartColor["SteelBlue"] = "#418CF0";
    ChartColor["DarkGoldenrod"] = "#FCB441";
    ChartColor["TerraCotta"] = "#E0400A";
    ChartColor["DarkBlue"] = "#056492";
    ChartColor["Gray"] = "#BFBFBF";
    ChartColor["MidnightBlue"] = "#1A3B69";
    ChartColor["LightYellow"] = "#FFE382";
    ChartColor["DodgerBlue"] = "#129CDD";
    ChartColor["Copper"] = "#CA6B4B";
    ChartColor["MediumBlue"] = "#005CDB";
    ChartColor["Khaki"] = "#F3D288";
    ChartColor["SlateGray"] = "#506381";
    ChartColor["MistyRose"] = "#F1B9A8";
    ChartColor["DarkOrange"] = "#E0830A";
    ChartColor["LightSteelBlue"] = "#7893BE";
})(ChartColor || (ChartColor = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Chart type enum
 *
 * Read the documentations to add more types of charts:
 * https://learn.microsoft.com/es-es/dotnet/api/system.windows.forms.datavisualization.charting.seriescharttype?view=netframework-4.8.1
 * https://www.telerik.com/kendo-angular-ui/components/charts/series-types/
 */
var ChartType;
(function (ChartType) {
    ChartType[ChartType["line"] = 3] = "line";
    ChartType[ChartType["bar"] = 7] = "bar";
    ChartType[ChartType["column"] = 10] = "column";
    ChartType[ChartType["area"] = 13] = "area";
    ChartType[ChartType["pie"] = 17] = "pie";
    ChartType[ChartType["radarLine"] = 25] = "radarLine";
})(ChartType || (ChartType = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Check state enum
 */
var CheckState;
(function (CheckState) {
    CheckState[CheckState["Unchecked"] = 0] = "Unchecked";
    CheckState[CheckState["Checked"] = 1] = "Checked";
    CheckState[CheckState["Indeterminate"] = 2] = "Indeterminate";
})(CheckState || (CheckState = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Specifies the border style of a cell in a table layout control.
 */
var TableLayoutPanelCellBorderStyle;
(function (TableLayoutPanelCellBorderStyle) {
    //
    // Summary:
    //     No borders.
    TableLayoutPanelCellBorderStyle[TableLayoutPanelCellBorderStyle["None"] = 0] = "None";
    //
    // Summary:
    //     A single-line border.
    TableLayoutPanelCellBorderStyle[TableLayoutPanelCellBorderStyle["Single"] = 1] = "Single";
    //
    // Summary:
    //     A single-line sunken border.
    TableLayoutPanelCellBorderStyle[TableLayoutPanelCellBorderStyle["Inset"] = 2] = "Inset";
    //
    // Summary:
    //     A double-line sunken border.
    TableLayoutPanelCellBorderStyle[TableLayoutPanelCellBorderStyle["InsetDouble"] = 3] = "InsetDouble";
    //
    // Summary:
    //     A single-line raised border.
    TableLayoutPanelCellBorderStyle[TableLayoutPanelCellBorderStyle["Outset"] = 4] = "Outset";
    //
    // Summary:
    //     A double-line raised border.
    TableLayoutPanelCellBorderStyle[TableLayoutPanelCellBorderStyle["OutsetDouble"] = 5] = "OutsetDouble";
    //
    // Summary:
    //     A single-line border containing a raised portion.
    TableLayoutPanelCellBorderStyle[TableLayoutPanelCellBorderStyle["OutsetPartial"] = 6] = "OutsetPartial";
})(TableLayoutPanelCellBorderStyle || (TableLayoutPanelCellBorderStyle = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Horizontal Alignment enum.
 *
 * @export
 * @enum {number}
 */
var HorizontalAlignment;
(function (HorizontalAlignment) {
    /**
     * The object or text is aligned on the left of the control element.
     */
    HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
    /**
     * The object or text is aligned on the right of the control element.
     */
    HorizontalAlignment[HorizontalAlignment["Right"] = 1] = "Right";
    /**
     * The object or text is aligned in the center of the control element.
     */
    HorizontalAlignment[HorizontalAlignment["Center"] = 2] = "Center";
})(HorizontalAlignment || (HorizontalAlignment = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Specifies the border style for a control.
 *
 * @export
 * @enum {number}
 */
var BorderStyle;
(function (BorderStyle) {
    /**
     * No border.
     */
    BorderStyle[BorderStyle["None"] = 0] = "None";
    /**
     * A single-line border.
     */
    BorderStyle[BorderStyle["FixedSingle"] = 1] = "FixedSingle";
    /**
     * A three-dimensional border.
     */
    BorderStyle[BorderStyle["Fixed3D"] = 2] = "Fixed3D";
})(BorderStyle || (BorderStyle = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Specifies the type of scroll bars to display in a RichTextBox control.
 *
 * @export
 * @enum {number}
 */
var RichTextBoxScrollBars;
(function (RichTextBoxScrollBars) {
    /**
     * No scroll bars are displayed.
     */
    RichTextBoxScrollBars[RichTextBoxScrollBars["None"] = 0] = "None";
    /**
     * Display a horizontal scroll bar only when text is longer than the width of the control.
     */
    RichTextBoxScrollBars[RichTextBoxScrollBars["Horizontal"] = 1] = "Horizontal";
    /**
     * Display a vertical scroll bar only when text is longer than the height of the control.
     */
    RichTextBoxScrollBars[RichTextBoxScrollBars["Vertical"] = 2] = "Vertical";
    /**
     * Display both a horizontal and a vertical scroll bar when needed.
     */
    RichTextBoxScrollBars[RichTextBoxScrollBars["Both"] = 3] = "Both";
    /**
     * Always display a horizontal scroll bar.
     */
    RichTextBoxScrollBars[RichTextBoxScrollBars["ForcedHorizontal"] = 17] = "ForcedHorizontal";
    /**
     * Always display a vertical scroll bar.
     */
    RichTextBoxScrollBars[RichTextBoxScrollBars["ForcedVertical"] = 18] = "ForcedVertical";
    /**
     * Always display both a horizontal and a vertical scroll bar.
     */
    RichTextBoxScrollBars[RichTextBoxScrollBars["ForcedBoth"] = 19] = "ForcedBoth";
})(RichTextBoxScrollBars || (RichTextBoxScrollBars = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * DropDownStyle enum
 */
var DropDownStyle;
(function (DropDownStyle) {
    DropDownStyle["DropDown"] = "DropDown";
    DropDownStyle["DropDownList"] = "DropDownList";
})(DropDownStyle || (DropDownStyle = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
var KendoEditorCommand;
(function (KendoEditorCommand) {
    KendoEditorCommand["bold"] = "bold";
    KendoEditorCommand["italic"] = "italic";
    KendoEditorCommand["strikethrough"] = "strikethrough";
    KendoEditorCommand["subscript"] = "subscript";
    KendoEditorCommand["superscript"] = "superscript";
    KendoEditorCommand["underline"] = "underline";
    KendoEditorCommand["alignCenter"] = "alignCenter";
    KendoEditorCommand["alignJustify"] = "alignJustify";
    KendoEditorCommand["alignLeft"] = "alignLeft";
    KendoEditorCommand["alignRight"] = "alignRight";
    KendoEditorCommand["foreColor"] = "foreColor";
    KendoEditorCommand["fontFamily"] = "fontFamily";
    KendoEditorCommand["fontSize"] = "fontSize";
})(KendoEditorCommand || (KendoEditorCommand = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Specifies the styles of the column headers in a ListView control.
 *
 * @export
 * @enum {number}
 */
var ColumnHeaderStyle;
(function (ColumnHeaderStyle) {
    /**
     * The column header is not displayed in report view.
     */
    ColumnHeaderStyle[ColumnHeaderStyle["None"] = 0] = "None";
    /**
     * The column headers do not respond to the click of a mouse.
     */
    ColumnHeaderStyle[ColumnHeaderStyle["Nonclickable"] = 1] = "Nonclickable";
    /**
     * The column headers function like buttons and can carry out an action, such as sorting, when clicked.
     */
    ColumnHeaderStyle[ColumnHeaderStyle["Clickable"] = 2] = "Clickable";
})(ColumnHeaderStyle || (ColumnHeaderStyle = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Specifies the mode for the automatic completion feature used in the ComboBox and TextBox controls.
 *
 * @export
 * @enum {number}
 */
var AutoCompleteMode;
(function (AutoCompleteMode) {
    /**
     * Disables the automatic completion feature.
     */
    AutoCompleteMode[AutoCompleteMode["None"] = 0] = "None";
    /**
     * Displays the auxiliary drop-down list associated with the edit control.
     * This drop-down is populated with one or more suggested completion strings.
     */
    AutoCompleteMode[AutoCompleteMode["Suggest"] = 1] = "Suggest";
    /**
     * Appends the remainder of the most likely candidate string to the existing characters,
     *  highlighting the appended characters.
     */
    AutoCompleteMode[AutoCompleteMode["Append"] = 2] = "Append";
    /**
     * Applies both Suggest and Append options.
     */
    AutoCompleteMode[AutoCompleteMode["SuggestAppend"] = 3] = "SuggestAppend";
})(AutoCompleteMode || (AutoCompleteMode = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Specifies the source for ComboBox and TextBox automatic completion functionality.
 *
 * @export
 * @enum {number}
 */
var AutoCompleteSource;
(function (AutoCompleteSource) {
    /**
     * Sets the file system as a source.
     */
    AutoCompleteSource[AutoCompleteSource["FileSystem"] = 1] = "FileSystem";
    /**
     * Uses the history UTRs list as source.
     */
    AutoCompleteSource[AutoCompleteSource["HistoryList"] = 2] = "HistoryList";
    /**
     * Uses the most recently used URLs as source.
     */
    AutoCompleteSource[AutoCompleteSource["RecentlyUsedList"] = 4] = "RecentlyUsedList";
    /**
     * Uses both history and recent URL as source.
     */
    AutoCompleteSource[AutoCompleteSource["AllUrl"] = 6] = "AllUrl";
    /**
     * Uses file system and All URLs as source.
     */
    AutoCompleteSource[AutoCompleteSource["AllSystemSources"] = 7] = "AllSystemSources";
    /**
     * Uses directory names as source.
     */
    AutoCompleteSource[AutoCompleteSource["FileSystemDirectories"] = 32] = "FileSystemDirectories";
    /**
     *  Uses a defined string list as source.
     */
    AutoCompleteSource[AutoCompleteSource["CustomSource"] = 64] = "CustomSource";
    /**
     * No source is currently being used.
     */
    AutoCompleteSource[AutoCompleteSource["None"] = 128] = "None";
    /**
     * Uses Mobilize.Web.Combobox as source.
     */
    AutoCompleteSource[AutoCompleteSource["ListItems"] = 256] = "ListItems";
})(AutoCompleteSource || (AutoCompleteSource = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Specifies the user action that is required to activate items in a list view control
 * and the feedback that is given as the user moves the mouse pointer over an item.
 *
 * @export
 * @enum {number}
 */
var ItemActivation;
(function (ItemActivation) {
    /**
     * The user must double-click to activate items.
     * No feedback is given as the user moves the mouse pointer over an item.
     */
    ItemActivation[ItemActivation["Standard"] = 0] = "Standard";
    /**
     * The user must single-click to activate items. The cursor changes to a hand pointer
     * cursor, and the item text changes color as the user moves the mouse pointer over the item.
     */
    ItemActivation[ItemActivation["OneClick"] = 1] = "OneClick";
    /**
     * The user must click an item twice to activate it. This is different from the
     * standard double-click because the two clicks can have any duration between them.
     * The item text changes color as the user moves the mouse pointer over the item.
     */
    ItemActivation[ItemActivation["TwoClick"] = 2] = "TwoClick";
})(ItemActivation || (ItemActivation = {}));

var ListViewBaseComponent_1;
/**
 * ListBox Component this is an Angular Kendo jquery component .
 */
let ListViewBaseComponent = ListViewBaseComponent_1 = class ListViewBaseComponent extends ControlComponent {
    static getItemByIndexClick(event, component) {
        /* c8 ignore else */
        if (event && event.listViewItem) {
            return [
                {
                    Id: component.id,
                    MapperId: ListViewBaseComponent_1.listViewMapperId
                },
                {
                    MapperId: 'lstvwtmclckctnvntrgs',
                    References: {
                        ListViewItem: event.listViewItem
                    }
                }
            ];
        }
        return undefined;
    }
    static getItemByIndexCheck(event, component) {
        return [
            {
                Id: component.getIdByCheckedIndex(event.index),
                MapperId: ListViewBaseComponent_1.listViewMapperId
            },
            {
                MapperId: 'ItemCheckEventArgs',
                Index: event.index,
                CurrentValue: !event.checked
                    ? CheckState$1.Checked
                    : CheckState$1.Unchecked,
                NewValue: event.checked ? CheckState$1.Checked : CheckState$1.Unchecked
            }
        ];
    }
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.service = service;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.ItemSelectionChanged = new EventEmitter();
        this.ItemClick = new EventEmitter();
        this.ItemCheck = new EventEmitter();
        this.ItemActive = new EventEmitter();
        this.DoubleClick = new EventEmitter();
        this.SelectedIndexChanged = new EventEmitter();
        /* selIdxInternalObj Object used to store the selected indexes internally. */
        this.selIdxInternalObj = {};
        /* checkedInxInternalObj Object used to store the selected indexes internally. */
        this.checkedInxInternalObj = {};
        this.defaultDataUrl = 'api/listview';
        /* constant used to define the key of he column used to group the kendogrid data */
        this.GroupingColumnName = 'MobilizeLVGrouping';
        this.fetchItemsUrl = `${this.defaultDataUrl}/FetchItems`;
        this.focusedItemUrl = `${this.defaultDataUrl}/FocusItem`;
        this.checkItemUrl = `${this.defaultDataUrl}/CheckItem`;
        /**
         * Url to get the listview's Columns set
         */
        this.getColumnsUrl = `${this.defaultDataUrl}/GetColumns`;
        /**
         * Url to get the listview's Groups set
         */
        this.getGroupsUrl = `${this.defaultDataUrl}/GetGroups`;
        /**
         * property used to store the grouping definition used by the kendogrid
         */
        this.groups = [{ field: this.GroupingColumnName }];
    }
    ngOnInit() {
        super.ngOnInit();
        this.loadGroups();
        this.refreshGroups = false;
        this.loadColumns();
        this.refresh = false;
        this.fetchItems();
    }
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore next */
        if (this.refreshGroups) {
            this.loadGroups();
            this.loadColumns();
            this.refreshGroups = false;
            this.refresh = true;
        }
        /* c8 ignore next */
        if (this.refresh) {
            this.fetchItems();
            this.refresh = false;
        }
        /* c8 ignore else */
        if (this.selectedChanged) {
            this.changeDetector.detectChanges();
            this.selectedChanged = false;
        }
    }
    detectChanges() {
        super.detectChanges();
        this.changeDetector.detectChanges();
    }
    /**
     * Gets the HotTracking property from the model
     *
     * @readonly
     * @type {boolean}
     * @memberof ListViewBaseComponent
     */
    get hotTracking() {
        return !!this.model?.HotTracking;
    }
    /**
     * Gets the Activation property from the model.
     *
     * @readonly
     * @type {ItemActivation}
     * @memberof ListViewBaseComponent
     */
    get activation() {
        return this.model.Activation !== undefined
            ? this.model.Activation
            : ItemActivation.Standard;
    }
    /**
     * Gets view
     */
    get view() {
        return this.model.View;
    }
    /**
     * Sets view
     */
    set view(value) {
        this.model.View = value;
    }
    /**
     * Boolean value which tells if the listview's groups have been changed in the server side
     */
    get refreshGroups() {
        return this.model.RefreshGroups;
    }
    /**
     * Boolean value which tells if the listview's groups have been changed in the server side
     */
    set refreshGroups(value) {
        this.model.RefreshGroups = value;
    }
    /**
     * Gets selected changed
     */
    get selectedChanged() {
        return this.model.SelectedChanged;
    }
    /**
     * Sets selected changed
     */
    set selectedChanged(value) {
        this.model.SelectedChanged = value;
    }
    /**
     * Gets checkboxes
     */
    get checkboxes() {
        return this.model.CheckBoxes !== undefined ? this.model.CheckBoxes : false;
    }
    /**
     * Sets checkboxes
     */
    set checkboxes(value) {
        this.model.CheckBoxes = value;
    }
    /**
     * Boolean value which tells if the listview need to apply grouping to the kendogrid
     */
    get hasGroups() {
        return this.model.HasGroups;
    }
    /**
     * Get/sets the the header style property.
     *
     * @type {ColumnHeaderStyle}
     * @memberof ListViewBaseComponent
     */
    get headerStyle() {
        return this.model.HeaderStyle;
    }
    set headerStyle(value) {
        this.model.HeaderStyle = value;
    }
    set selectedIndices(indexes) {
        this.model.SelectedIndices = indexes;
    }
    /**
     * Gets selected indices
     */
    get selectedIndices() {
        return this.model.SelectedIndices;
    }
    set checkedIndices(indexes) {
        this.model.CheckedIndices = indexes;
    }
    /**
     * Gets selected indices
     */
    get checkedIndices() {
        return this.model.CheckedIndices;
    }
    /**
     * Gets the HoverSelection property from the model
     *
     * @readonly
     * @type {boolean}
     * @memberof ListViewBaseComponent
     */
    get hoverSelection() {
        return !!this.model?.HoverSelection;
    }
    /**
     * Fetchs items definition method
     */
    fetchItems() { }
    /**
     * Loads groups method definition
     */
    loadGroups() { }
    /**
     * Loads columns method definition
     */
    loadColumns() { }
    /**
     * Retrieve an array SelectedIndices
     */
    getSelectedIndices(obj) {
        const currentIndices = this.selIdxInternalObj;
        /* c8 ignore else */
        if (obj.selectedRows.length !== 0) {
            obj.selectedRows.forEach(function (value) {
                currentIndices[value.index] = value.index;
            });
        }
        /* c8 ignore else */
        if (obj.deselectedRows.length !== 0) {
            obj.deselectedRows.forEach(function (value) {
                delete currentIndices[value.index];
            });
        }
        this.selectedIndices = Object.keys(currentIndices).map(function (idx) {
            return currentIndices[idx];
        });
        this.selIdxInternalObj = currentIndices;
    }
    getCheckedIndices(event, checked) {
        const currentIndices = this.checkedInxInternalObj;
        if (checked) {
            currentIndices[event.index] = event.index;
        }
        else {
            delete currentIndices[event.index];
        }
        this.checkedIndices = Object.keys(currentIndices).map(function (idx) {
            return currentIndices[idx];
        });
        this.checkedInxInternalObj = currentIndices;
    }
    /**
     * Determines whether row selected is
     * @param e
     * @returns true if row selected
     */
    isRowSelected(e) {
        return this.selectedIndices !== undefined
            ? this.selectedIndices.indexOf(e.index) >= 0
            : false;
    }
    /**
     * Verifies if the grid header should be hidden.
     *
     * @readonly
     * @type {boolean}
     * @memberof ListViewBaseComponent
     */
    get hideHeaders() {
        return this.headerStyle === ColumnHeaderStyle.None;
    }
    /**
     * Get the index from cheked event.
     * @param event
     * @returns  the event index
     */
    getCheckedIndex(event) {
        /* c8 ignore next */
        if (event.deselectedRows?.length > 0) {
            return event.deselectedRows[0].index;
        }
        else if (event.selectedRows?.length > 0) {
            return event.selectedRows[0].index;
        }
        return -1;
    }
    /**
     * Get the item by index
     * @param index
     * @returns DataTransferObject with the item
     */
    getIdByCheckedIndex(index) {
        /* c8 ignore next */
        if (index >= 0 && this.itemsId && this.itemsId[index]) {
            return this.itemsId[index].Id;
        }
        else {
            return undefined;
        }
    }
    /**
     * Set the params for the api call in ItemCheck
     * @param event
     * @returns The HttpParams for the api call
     */
    /* c8 ignore next */
    getParams(event) {
        let params = new HttpParams();
        params = params.set('check', event.checked);
        return params;
    }
    /**
     * Method which receives the key that corresponds to a group and returns the header of the group
     */
    getGroupHeader(groupKey) {
        /* c8 ignore else */
        if (this.groupsData) {
            for (const item of this.groupsData) {
                /* c8 ignore else */
                if (item.name === groupKey) {
                    return item.header;
                }
            }
            return 'Default';
        }
        return '';
    }
    itemSelectionChanged(event) {
        this.selectedIndexChanged(event);
        this.ItemSelectionChanged.emit(new EventData$1(event, this.id));
    }
    itemClick(event) {
        this.ItemClick.emit(event);
    }
    itemCheck(event, rowIndex) {
        event.stopPropagation();
        event.index = rowIndex;
        event.checked = this.checkedInxInternalObj?.[rowIndex] == null;
        this.getCheckedIndices(event, event.checked);
        this.ItemCheck.emit(new EventData$1(event, this.id));
    }
    /**
     * doubleClick event
     * @param eventData
     */
    doubleClick(eventData) {
        this.DoubleClick.emit(eventData);
    }
    /**
     * itemActive event
     * @param event
     */
    itemActive(event, rowIndex) {
        const item = this.itemsId[rowIndex];
        /* c8 ignore next */
        if (item) {
            this.service
                .fetch(this.focusedItemUrl, item.Id)
                .subscribe((data) => { });
        }
        this.ItemActive.emit(event);
    }
    /**
     * selectedIndexChanged event
     * @param event
     * @returns index changed
     */
    selectedIndexChanged(event) {
        /* c8 ignore else */
        if (!this.refresh && !this.hoverSelection) {
            this.getSelectedIndices(event);
            this.SelectedIndexChanged.emit(new EventData$1(event, this.id));
        }
    }
    /**
     * click event
     * @param event
     */
    click(event) {
        this.Enter.emit(new EventData$1(event, this.id));
    }
    /**
     * Method to determine if a row should show the text as hyperlink with underline
     *
     * @param {number} rowIndex
     * @return {*}  {*}
     * @memberof ListViewDetailsComponent
     */
    hasHotTrackingAndSelected(rowIndex) {
        return (this.hotTracking &&
            this.hoverSelection &&
            this.selectedIndices.findIndex((el) => el === rowIndex) >= 0);
    }
    /**
     * Handles the ItemActivate event validations.
     *
     * @param {*} event
     * @param {number} rowIndex
     * @param {boolean} [isFromDblCLick=false]
     * @memberof ListViewBaseComponent
     */
    itemActivationHandler(event, rowIndex, isFromDblCLick = false) {
        /* c8 ignore else */
        if ((isFromDblCLick && this.hasStandardItemActivation(event)) ||
            (!isFromDblCLick && this.hasOneClickItemActivation(event))) {
            this.itemActive(event, rowIndex);
        }
    }
    /**
     * Verifies if the activation has the standard validations correctly.
     *
     * @return {*}  {boolean}
     * @memberof ListViewBaseComponent
     */
    hasStandardItemActivation(event) {
        return ((this.activation === ItemActivation.Standard && !this.hotTracking) ||
            event?.currentTarget?.nodeName === 'A');
    }
    /**
     * Verifies if the activation has the oneClick validations correctly.
     *
     * @param {*} event
     * @return {*}  {boolean}
     * @memberof ListViewBaseComponent
     */
    hasOneClickItemActivation(eventData) {
        const event = eventData.originalEvent ?? eventData;
        return ((this.activation === ItemActivation.OneClick || this.hotTracking) &&
            event?.detail !== undefined &&
            event.detail > 0 &&
            event.detail % 2 === 1);
    }
    /**
     * Returns the pointer cursor class if the listview has oneClick activation.
     *
     * @return {*}  {string}
     * @memberof ListViewBaseComponent
     */
    getPointerClass() {
        return this.activation === ItemActivation.OneClick || this.hotTracking
            ? 'pointerCursor'
            : '';
    }
};
ListViewBaseComponent.listViewMapperId = 'lstVw';
ListViewBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListViewBaseComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ListViewBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ListViewBaseComponent, selector: "ng-component", inputs: { dataUrl: "dataUrl" }, outputs: { ItemSelectionChanged: "ItemSelectionChanged", ItemClick: "ItemClick", ItemCheck: "ItemCheck", ItemActive: "ItemActive", DoubleClick: "DoubleClick", SelectedIndexChanged: "SelectedIndexChanged" }, usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('SelectedIndices'),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], ListViewBaseComponent.prototype, "selectedIndices", null);
__decorate([
    MarkForCheck(),
    NotifyChange('CheckedIndices'),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], ListViewBaseComponent.prototype, "checkedIndices", null);
__decorate([
    serverEvent('ItemSelectionChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ListViewBaseComponent.prototype, "itemSelectionChanged", null);
__decorate([
    serverEvent('ListViewItemClickAction', ListViewBaseComponent_1.getItemByIndexClick),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EventData$1]),
    __metadata("design:returntype", void 0)
], ListViewBaseComponent.prototype, "itemClick", null);
__decorate([
    serverEvent('ItemCheck', ListViewBaseComponent_1.getItemByIndexCheck),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Number]),
    __metadata("design:returntype", void 0)
], ListViewBaseComponent.prototype, "itemCheck", null);
__decorate([
    serverEvent('DoubleClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ListViewBaseComponent.prototype, "doubleClick", null);
__decorate([
    serverEvent('ItemActivate'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Number]),
    __metadata("design:returntype", void 0)
], ListViewBaseComponent.prototype, "itemActive", null);
__decorate([
    serverEvent('SelectedIndexChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], ListViewBaseComponent.prototype, "selectedIndexChanged", null);
__decorate([
    serverEvent('Enter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ListViewBaseComponent.prototype, "click", null);
ListViewBaseComponent = ListViewBaseComponent_1 = __decorate([
    dataTransfer(['lstVw']),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], ListViewBaseComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListViewBaseComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { dataUrl: [{
                type: Input
            }], ItemSelectionChanged: [{
                type: Output
            }], ItemClick: [{
                type: Output
            }], ItemCheck: [{
                type: Output
            }], ItemActive: [{
                type: Output
            }], DoubleClick: [{
                type: Output
            }], SelectedIndexChanged: [{
                type: Output
            }], selectedIndices: [], checkedIndices: [], itemSelectionChanged: [], itemClick: [], itemCheck: [], doubleClick: [], itemActive: [], selectedIndexChanged: [], click: [] } });

/**
 * FormBorderStyles
 */
var FormBorderStyles;
(function (FormBorderStyles) {
    FormBorderStyles[FormBorderStyles["None"] = 0] = "None";
    FormBorderStyles[FormBorderStyles["FixedSingle"] = 1] = "FixedSingle";
    FormBorderStyles[FormBorderStyles["Fixed3D"] = 2] = "Fixed3D";
    FormBorderStyles[FormBorderStyles["FixedDialog"] = 3] = "FixedDialog";
    FormBorderStyles[FormBorderStyles["Sizable"] = 4] = "Sizable";
    FormBorderStyles[FormBorderStyles["FixedToolWindow"] = 5] = "FixedToolWindow";
    FormBorderStyles[FormBorderStyles["SizableToolWindow"] = 6] = "SizableToolWindow";
})(FormBorderStyles || (FormBorderStyles = {}));

class ControlContainerComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(serviceRef, cd, rnd, elref, webComponents = null, bringTService = null, containerInteraction, shortcutsService) {
        super(cd, rnd, elref, webComponents, bringTService, null, shortcutsService);
        this.serviceRef = serviceRef;
        this.cd = cd;
        this.rnd = rnd;
        this.elref = elref;
        this.bringTService = bringTService;
        this.containerInteraction = containerInteraction;
        this.shortcutsService = shortcutsService;
        /**
         * Get all controls url of control container component
         */
        this.getAllControlsUrl = 'api/control/GetAllControls';
    }
    /**
     * Gets z order refresh
     */
    get zIndexRefresh() {
        return this.model?.ZIndexRefresh;
    }
    /**
     * Sets notify change
     */
    set zIndexRefresh(value) {
        this.model.ZIndexRefresh = value;
    }
    ngDoCheck() {
        super.ngDoCheck();
        if (this.zIndexRefresh) {
            this.getAllControls();
            this.zIndexRefresh = false;
        }
    }
    /**
     * on init
     * Register this container in the current service
     * instance
     */
    ngOnInit() {
        super.ngOnInit();
        /* c8 ignore next */
        this.containerInteractionSubscription();
    }
    /**
     * Containers interaction subscription
     * Register the containerInteraction events
     */
    containerInteractionSubscription() {
        if (this.containerInteraction) {
            this.containerInteraction.currentContainerId = this.id;
            this.eventEmitterSubscription =
                this.containerInteraction.EventEmittedNotification.subscribe((evt) => {
                    if (evt.args === 'leave' && evt.Id !== this.id) {
                        this.leaveEventsHandler(evt);
                        this.isComponentFocused = false;
                    }
                    else if (evt.args === 'focus' && evt.Id !== this.id) {
                        /* c8 ignore else */
                        if (!this.isComponentFocused) {
                            this.enter(evt);
                        }
                        this.isComponentFocused = true;
                    }
                });
        }
    }
    /**
     * on destroy
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.eventEmitterSubscription) {
            this.eventEmitterSubscription.unsubscribe();
        }
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    /**
     * Removes the static content from the container control.
     * This is not a normal thing to do in standard angular applications
     * This function only removes the ui element. To destroy the component instance
     * the server should remove the component's model.
     * @param data An Event data that contains the current control and Id that will be removed.
     */
    removeControlHandler(data) {
        /* c8 ignore else */
        // tslint:disable-next-line:no-unused-expression
        if (this.displayElement && this.displayElement.children.length > 0) {
            const elementToRemove = this.getElementToRemove(data.event.name);
            /* c8 ignore else */
            if (elementToRemove && data.Id) {
                this.containerTabOrderService?.unregisterInstance(null, data.Id);
                elementToRemove.remove(); // This doesn't destroy the component instance the model should be removed instead.
            }
        }
    }
    /**
     * Return the element to be removed from the DOM. This is to find the html in a deeper way
     * because the namedItem does not implements a deeper search
     *
     * @param  {string} value The name value or id value to search
     * @returns any The html element if exists otherwise null
     */
    getElementToRemove(value) {
        let tmp = this.displayElement.querySelector(`[id=${value}]`);
        /* c8 ignore else */
        if (tmp === null) {
            tmp = this.displayElement.querySelector(`[name=${value}]`);
        }
        return tmp;
    }
    /**
     * Gets all controls that are contained inside of control container
     */
    getAllControls() {
        this.serviceRef
            .fetch(this.getAllControlsUrl, this.id)
            .subscribe((data) => {
            if (data) {
                this.loadControlModels(data);
            }
        });
    }
    /**
     * Loads control models and sets zIndex value
     * @param controls Controls collection received from API
     */
    loadControlModels(controls) {
        for (let i = 0; i < controls.length; i++) {
            const model = this.serviceRef.core.getModel(controls[i]);
            /* c8 ignore else */
            if (model) {
                model.zIndex = controls.length - i;
            }
        }
    }
    /**
     * Gets tab order
     */
    get tabOrder() {
        return -1;
    }
    /**
     * Applies focus to selectable component.
     * It triggers dom element focus()
     */
    applyFocus() {
        // It should be override by each container according its expected
        // behavior
    }
    /**
     * Calculates tab order according to model value.
     * Since it is a control container, the tabStop property is ignored.
     * @returns tab order
     */
    calculateTabOrder() {
        /* c8 ignore next 3 */
        return Utils.validateTabOrder(this.model, this.tabindex);
    }
}
ControlContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ControlContainerComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService, optional: true }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: ShortcutsService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ControlContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ControlContainerComponent, selector: "ng-component", inputs: { windowModel: "windowModel" }, usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('ZIndexRefresh'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ControlContainerComponent.prototype, "zIndexRefresh", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ControlContainerComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { windowModel: [{
                type: Input
            }], zIndexRefresh: [] } });

class BaseValidatorService {
    /**
     * Base constructor of the service
     *
     * @memberof BaseValidatorService
     */
    constructor() { }
    /**
     * Removes the indicated validator.
     * This method is intended to be overridden.
     *
     * @param validator
     * @memberof BaseValidatorService
     */
    removeValidator(validator) { }
    /**
     * Adds the indicated validator.
     * This method is intended to be overridden.
     *
     * @param validator
     * @memberof BaseValidatorService
     */
    addValidator(validator) { }
    /**
     * Adds a validation summary to the service
     * @param summary
     * @memberof BaseValidatorService
     */
    addValidationSummary(summary) { }
    /**
     * Adds the indicated compare validator.
     * This method is intended to be overridden.
     *
     * @param elementToCompare
     * @param validator
     * @memberof BaseValidatorService
     */
    addCompareValidator(elementToCompare, validator) { }
    /**
     * Check the validators attached to the indicated control.
     * This method is intended to be overridden.
     *
     * @param controlToValidate
     * @param expressionToValidate
     * @memberof BaseValidatorService
     * @returns the results of the validation
     */
    validate(controlToValidate, expressionToValidate) {
        return false;
    }
    /**
     * Checks the results of the validations.
     * This method is intended to be overridden.
     *
     * @memberof BaseValidatorService
     * @returns the summmary of the validators.
     */
    checkValidators(validationGroup) {
        return false;
    }
    /**
     * Shows the validation summaries with the given validation group.
     * This method is intended to be overridden.
     *
     * @param validationGroup
     * @memberof BaseValidatorService
     */
    showValidationSumaries(validationGroup) { }
    /**
     * Collect all the error messages from the invalid validators.
     *
     * @param validationGroup
     * @memberof BaseValidatorService
     * @returns the active error messages.
     */
    getActiveErrorMessages(validationGroup) {
        return [];
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
var EditMaskCharacter;
(function (EditMaskCharacter) {
    EditMaskCharacter["uppercase"] = ">";
    EditMaskCharacter["lowercase"] = "<";
    EditMaskCharacter["placeHolder"] = ";";
    EditMaskCharacter["literal"] = "\\";
})(EditMaskCharacter || (EditMaskCharacter = {}));

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Edit mask rule
 *
 * @export
 * @class EditMaskRule
 */
class EditMaskRule {
    /**
     * Creates an instance of EditMaskRule.
     * @param {number} start
     * @param {number} end
     * @param {string} char
     * @param {() => string} execute
     * @memberof EditMaskRule
     */
    constructor(start, end, char, execute) {
        this.start = start;
        this.end = end;
        this.char = char;
        this.execute = execute;
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Edit mask service.
 * Injected on the mask components.
 *
 * @export
 * @class EditMaskService
 */
class EditMaskService {
    constructor() {
        /**
         * Control's context.
         *
         * @type {*}
         * @memberof EditMaskService
         */
        this.context = {};
        /**
         * Command characters except literal skip
         *
         * @memberof EditMaskService
         */
        this.commandCharacters = [
            EditMaskCharacter.uppercase,
            EditMaskCharacter.lowercase,
            EditMaskCharacter.placeHolder
        ];
        /**
         * Place holder specification
         *
         * @memberof EditMaskService
         */
        this.placeHolderSpecification = '_'; //default placeholder
        /**
         * Whether or not has commandChar
         *
         * @memberof EditMaskService
         */
        this.containsCommandCharacters = false;
        /**
         *  Array with commands order.
         *
         * @type {EditMaskRule[]}
         * @memberof EditMaskService
         */
        this.commandsOrderApply = [];
    }
    /**
     * Initialize handlers to process mask
     *
     * @param {*} context - The component ref.
     * @memberof EditMaskService
     */
    initializeMaskTransformation(context) {
        this.context = context;
        this.currentMask = this.context.modelMask;
        this.validMask = this.context.modelMask;
        this.containsCommandCharacters = false;
        this.commandsOrderApply = [];
        // if mask has commandCharacters should generate rules
        if (this.context.modelMask &&
            this.maskHasCommandCharacters(this.commandCharacters, this.context.modelMask)) {
            this.maskHasPlaceHolderSpecification(this.context.modelMask);
            this.processMaskToCommandChar();
            this.normalizeTransformationIndex();
            this.containsCommandCharacters = true;
        }
    }
    /**
     * ServiceMaskChanged
     *
     * @return {*}  {boolean}
     * @memberof EditMaskService
     */
    serviceMaskChanged() {
        return this.context.modelMask !== this.currentMask;
    }
    /**
     * Verify if mask containsCommandCharacters hasTransformation
     *
     * @param {string} maskedValue
     * @return {*}  {*}
     * @memberof EditMaskService
     */
    verifyTransformation(maskedValue) {
        Utils.regexReDosValidation(this.validMask, true);
        if (this.containsCommandCharacters) {
            return this.applyTransformationRules(maskedValue);
        }
        else {
            return maskedValue;
        }
    }
    /**
     * Apply transformation rules
     *
     * @param {string} maskedValue
     * @return {*}
     * @memberof EditMaskService
     */
    applyTransformationRules(maskedValue) {
        for (const iterator of this.commandsOrderApply) {
            maskedValue = iterator.execute(iterator.start, iterator.end, maskedValue);
        }
        return maskedValue;
    }
    /**
     * Normalize indexes compatible with current valid mask
     *
     * @memberof EditMaskService
     */
    normalizeTransformationIndex() {
        let position = 1;
        for (let i = 0; i < this.commandsOrderApply.length; i++, position++) {
            this.commandsOrderApply[i].start -= i;
            this.commandsOrderApply[i].end -= position;
        }
    }
    /**
     * Evaluates mask to check if a command Character or a place holder identification exist
     *
     * @param {string[]} commandCharacters
     * @param {string} mask
     * @return {*}  {boolean}
     * @memberof EditMaskService
     */
    maskHasCommandCharacters(commandCharacters, mask) {
        let hasAnyCharacter = false;
        for (const iterator of commandCharacters) {
            if (!hasAnyCharacter && mask.includes(iterator)) {
                hasAnyCharacter = true;
                break;
            }
        }
        return hasAnyCharacter;
    }
    /**
     *  Get place holder char and modify validMask
     *
     * @param {string} mask
     * @memberof EditMaskService
     */
    maskHasPlaceHolderSpecification(mask) {
        const placeHolderIndex = mask.indexOf(';');
        if (placeHolderIndex > -1) {
            this.placeHolderSpecification = mask[placeHolderIndex + 1];
            this.validMask = mask.slice(0, placeHolderIndex);
        }
    }
    /**
     * Iterates over every character of the mask  to evaluate them
     *
     * @memberof EditMaskService
     */
    processMaskToCommandChar() {
        const mask = this.context.modelMask;
        for (let i = 0; i < mask.length; i++) {
            this.processCommandCharacters(mask[i], mask, i);
        }
    }
    /**
     * Takes selects chars that applies to be rules
     *
     * @param {string} char char from mask
     * @param {string} mask  model mask
     * @param {number} index apparition index of the char
     * @memberof EditMaskService
     */
    processCommandCharacters(char, mask, index) {
        switch (char) {
            // creates a rule for the upper case scenario
            case EditMaskCharacter.uppercase: {
                this.processCommandRules(mask, index, EditMaskCharacter.uppercase, this.toUpperCase);
                this.generateValidMask(EditMaskCharacter.uppercase);
                break;
            }
            // creates a rule for the lower case scenario
            case EditMaskCharacter.lowercase: {
                this.processCommandRules(mask, index, EditMaskCharacter.lowercase, this.toLowerCase);
                this.generateValidMask(EditMaskCharacter.lowercase);
                break;
            }
            // creates a rule for the literals
            case EditMaskCharacter.literal: {
                this.processCommandRules(mask, index, EditMaskCharacter.literal, this.toScapeLiteral);
                break;
            }
        }
    }
    /** Removes placeholder from string and return a valid text */
    removePlaceholderFromString(valueChanged) {
        const regex = new RegExp(`\\${this.placeHolderSpecification}`, 'g');
        return valueChanged.replace(regex, ' ');
    }
    /**
     * Each time that a command character appears, this should be removed from the valid mask
     *
     * @param {string} char
     * @memberof EditMaskService
     */
    generateValidMask(char) {
        const replaceChar = new RegExp(char, 'g'); // nosemgrep
        this.validMask = this.validMask.replace(replaceChar, '');
    }
    /**
     * Stores all rules in the order that should be applied
     *
     * @param {*} mask
     * @param {*} index
     * @param {*} char
     * @param {*} rule
     * @memberof EditMaskService
     */
    processCommandRules(mask, index, char, rule) {
        const maskRule = new EditMaskRule(index, mask.length, char, rule.bind(this));
        for (let i = index + 1; i < mask.length; i++) {
            if (this.maskHasCommandCharacters(this.commandCharacters, mask[i])) {
                maskRule.end = i;
                break;
            }
        }
        this.addToCommandsOrder(maskRule);
    }
    /**
     * Organizes commands int the order that they should be applied
     *
     * @param {*} charObject
     * @memberof EditMaskService
     */
    addToCommandsOrder(charObject) {
        if (this.commandsOrderApply.length === 0) {
            this.commandsOrderApply.push(charObject);
        }
        else {
            let position = 0;
            for (let i = 0; i < this.commandsOrderApply.length; i++) {
                if (charObject.start > this.commandsOrderApply[i].start) {
                    position = i + 1;
                }
                else {
                    break;
                }
            }
            this.commandsOrderApply.splice(position, 0, charObject);
        }
    }
    /**
     * Converts to uppercase chunk of string
     *
     * @param {number} start start index
     * @param {number} end end index
     * @param {string} text text to be converted
     * @return {string}  {string}
     * @memberof EditMaskService
     */
    toUpperCase(start, end, text) {
        const textAux = text.slice(0, start) +
            text.slice(start, end).toUpperCase() +
            text.slice(end);
        return this.processLiterals(start, end, textAux);
    }
    /**
     * Converts to lowerCase chunk of string
     *
     * @param {number} start start index
     * @param {number} end end index
     * @param {string} text text to be converted
     * @return {*}  {string}
     * @memberof EditMaskService
     */
    toLowerCase(start, end, text) {
        const textAux = text.slice(0, start) +
            text.slice(start, end).toLowerCase() +
            text.slice(end);
        return this.processLiterals(start, end, textAux);
    }
    /**
     * Process literals in the portion of text
     *
     * @param {number} start start index
     * @param {number} end end index
     * @param {string} textAux chunk of string to be evaluated
     * @return {*}  {*}
     * @memberof EditMaskService
     */
    processLiterals(start, end, textAux) {
        const replaceChar = new RegExp('\\\\', 'g');
        const stringOfLiterals = [];
        const matchesLiteral = [...this.validMask.matchAll(replaceChar)];
        for (const element of matchesLiteral) {
            stringOfLiterals.push(this.validMask[element.index + 1]);
        }
        const validMaskAux = this.validMask.replace(replaceChar, '');
        return (textAux.slice(0, start) +
            this.validateLiterals(textAux.slice(start, end), validMaskAux.slice(start, end), stringOfLiterals) +
            textAux.slice(end));
    }
    /**
     * Iterates over currentMask and find literals
     *
     * @param {string} textAux portion of text
     * @param {*} validMask mask
     * @return {string}  {string}
     * @memberof EditMaskService
     */
    validateLiterals(textAux, validMask, stringOfLiterals) {
        let excludingString = 'aALC';
        stringOfLiterals.forEach((element) => {
            excludingString = excludingString.replace(new RegExp(element, 'g'), ''); // nosemgrep
        });
        const regString = new RegExp(`(?![${excludingString}])[a-zA-Z]`, 'g'); // nosemgrep
        let text = textAux;
        // Validate any type of literal except those of the mask rule
        const matches = [...validMask.matchAll(regString)];
        const lastLiteral = 0;
        for (const element of matches) {
            text =
                text.slice(lastLiteral, element.index) +
                    element[0] +
                    text.slice(element.index + 1);
        }
        return text;
    }
    /**
     * Literal rule
     *
     * @param {number} start start index
     * @param {number} end end index
     * @param {string} text text evaluated
     *@return {string}  {string}
     * @memberof EditMaskService
     */
    toScapeLiteral(start, end, text) {
        return text;
    }
}
EditMaskService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EditMaskService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EditMaskService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EditMaskService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EditMaskService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Service to manage the open windows and its last focused control.
 * It has a stack to add each open window, the active window will be the first item in the stack.
 * Each time a window becomes active, the last focused control is saved for the previous window.
 */
class WindowsManagerService {
    /**
     * Creates an instance of the WindowsManagerService
     *
     * @memberof WindowsManagerService
     * @param {FocusManagerService} focusManager
     */
    constructor(focusManager) {
        this.focusManager = focusManager;
        /**
         * Open windows stack
         */
        this.openedWindows = [];
    }
    /**
     * Sets a specific window as active
     *
     * @memberof WindowsManagerService
     * @param {WMWindowComponent} window
     */
    setActiveWindow(window) {
        // Validate window is not null
        if (!window) {
            return;
        }
        // Set the last focused control to the current active window
        const activeWindow = this.getActiveWindow();
        if (activeWindow) {
            activeWindow.lastFocusedControl = this.focusManager.activeComponent;
        }
        // If the window already exists in the stack, it must be deleted
        if (this.openedWindows.includes(window)) {
            this.openedWindows = this.openedWindows.filter((w) => w !== window);
        }
        // Adds the active window to the top of the stack
        this.openedWindows.unshift(window);
    }
    /**
     * Get the current active window
     *
     * @memberof WMWindowComponent
     * @returns {WMWindowComponent}
     */
    getActiveWindow() {
        return this.openedWindows[0] ?? null;
    }
    /**
     * Validate if current window is open.
     *
     * @param {WMWindowComponent} window
     * @return {*}
     * @memberof WindowsManagerService
     */
    isWindowOpened(window) {
        return this.openedWindows.includes(window);
    }
    /**
     * Removes a window from the stack when it is closed
     *
     * @param {WMWindowComponent} window
     */
    removeWindow(window) {
        // Removes the window from the stack
        if (this.isWindowOpened(window)) {
            this.openedWindows = this.openedWindows.filter((w) => w !== window);
        }
        // Applies the focus to the last focused control of the current active window.
        const activeWindow = this.getActiveWindow();
        if (activeWindow && activeWindow.lastFocusedControl) {
            activeWindow.lastFocusedControl.applyFocus();
        }
    }
}
WindowsManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WindowsManagerService, deps: [{ token: FocusManagerService }], target: i0.ɵɵFactoryTarget.Injectable });
WindowsManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WindowsManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WindowsManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: FocusManagerService }]; } });

class ClientCustomUpdateService {
    constructor() {
        /**
         * This is to notify to a specific component that implements api fetch to reload the data
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof ClientCustomUpdateService
         */
        this.refreshComponentData = new Subject();
    }
    /**
     * Returns the refreshComponentData as Observable
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof ClientCustomUpdateService
     */
    get refreshComponentDataNotification() {
        return this.refreshComponentData.asObservable();
    }
    /**
     * Notifies a component to refresh its data
     *
     * @param {EventData} event
     * @memberof ClientCustomUpdateService
     */
    notifyRefreshComponentData(event) {
        this.refreshComponentData.next(event);
    }
}
ClientCustomUpdateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ClientCustomUpdateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ClientCustomUpdateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ClientCustomUpdateService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ClientCustomUpdateService, decorators: [{
            type: Injectable
        }] });

var WMWindowComponent_1;
/**
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/form/form.html</example-url>
 */
let WMWindowComponent = WMWindowComponent_1 = class WMWindowComponent extends ControlContainerComponent {
    static mouseEventArgsExtractor(event, component) {
        return [
            { Id: component.model.id, MapperId: 'frm' },
            {
                MapperId: 'MouseEventArgs',
                Button: event.button,
                X: event.x,
                Y: event.y
            }
        ];
    }
    /**
     * Event args extractor for the RefreshClientCustomChanges event.
     *
     * @static
     * @param {*} event
     * @param {WMWindowComponent} component
     * @return {*}  {*}
     * @memberof WMWindowComponent
     */
    static RefreshClientCustomChangesEventArgsExtractor(event, component) {
        return [
            { Id: component.id, MapperId: component.model.mapperId },
            {
                MapperId: 'RefreshClientCustomChangesEventArgs',
                CustomArgs: event.args.customArgs
            }
        ];
    }
    /* c8 ignore start */
    constructor(webMapService, elementRef, changeDetector, renderer2, webComponents, windowsManager, mainTab, btService, wmWindowService, shortcutsService, refreshClientDataService) {
        super(webMapService, changeDetector, renderer2, elementRef, webComponents, null, null, shortcutsService);
        this.webMapService = webMapService;
        this.elementRef = elementRef;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.windowsManager = windowsManager;
        this.mainTab = mainTab;
        this.btService = btService;
        this.wmWindowService = wmWindowService;
        this.shortcutsService = shortcutsService;
        this.refreshClientDataService = refreshClientDataService;
        this.MouseDown = new EventEmitter();
        this.RefreshClientCustomChanges = new EventEmitter();
        /** Constant defined by convention */
        this.dialogPosition = 501;
        this.initialModalZIndex = 10500;
        this.isDraggable = true;
        this.restoreTop = 0;
        this.restoreLeft = 0;
        this.mdiContentDiv = null;
        this.contentArea = null;
        this.titleArea = null;
        this.lastHeight = 0;
        this.lastWidth = 0;
        this.domElement = null;
        this.Close = new EventEmitter();
        this.mainTab?.registerContainerParentInstance(this);
    }
    /**
     * Gets auto scroll of the window
     */
    get autoScroll() {
        return !!this.model.AutoScroll;
    }
    /* c8 ignore next */
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore else */
        if (this.model && this.kendoWindow && this.bringToTop) {
            this.kendoWindow.bringToFront();
            this.bringToTop = false;
        }
        this.setAcceptButtonWhenIdChanges();
        this.setSameZIndex();
    }
    /**
     * Applies the focus to the start element on the head node.
     */
    applyFocus() {
        this.mainTab.resolveTab(this.mainTab.getHead(), false, {
            HeadNode: this.mainTab.getHead()
        });
        this.isFocused = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.refreshDataSubscription();
        this.windowsManager.setActiveWindow(this);
        this.wmWindowService?.acceptButtonCreatedEmitted.subscribe((event) => {
            /* c8 ignore start */
            if (this.acceptButton && event.Id === this.acceptButton) {
                this.wmWindowService.notifyButtonFakeFocusAcceptButton(new EventData$1({}, this.acceptButton));
            }
            /* c8 ignore stop */
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        /* c8 ignore else */
        if (this.bringTopSubs) {
            this.bringTopSubs.unsubscribe();
        }
        if (this.windowsManager.isWindowOpened(this)) {
            this.windowsManager.removeWindow(this);
        }
        /* c8 ignore next */
        if (this.refreshWindowClientCustomSubscription) {
            this.refreshWindowClientCustomSubscription.unsubscribe();
        }
    }
    /**
     * This method is exclusively to
     *
     * @memberof WMWindowComponent
     */
    refreshDataSubscription() {
        /* c8 ignore start */
        this.refreshWindowClientCustomSubscription =
            this.refreshClientDataService?.refreshComponentDataNotification.subscribe((event) => {
                if (this.clientCustomIdentifier &&
                    event.args['name'] === this.clientCustomIdentifier) {
                    this.refreshComponentData(event);
                }
            });
        /* c8 ignore stop */
    }
    /**
     * Gets the control that matches the id of the accept button.
     */
    getAcceptButtonById(control, acceptButtonId) {
        if (control.model.id == acceptButtonId) {
            return control;
        }
        else if (control.children != null) {
            let element = null;
            for (let i = 0; element == null && i < control.children.length; i++) {
                element = this.getAcceptButtonById(control.children[i], acceptButtonId);
            }
            return element;
        }
        return null;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    ngAfterViewInit() {
        /* c8 ignore next */
        this.wmWindowService?.keyDownEmitted.subscribe((e) => {
            this.keyDown(e);
        });
        this.wmWindowService?.keyUpEmitted.subscribe((e) => {
            this.keyUp(e);
        });
        this.wmWindowService?.windowButtonFocusedEmitted.subscribe((event) => {
            if (this.acceptButton !== event.Id) {
                this.wmWindowService.notifyRemoveFakeFocus(event);
            }
            else {
                this.wmWindowService.notifyApplyFakeFocus(event);
            }
        });
        super.ngAfterViewInit();
        this.setSameZIndex();
        this.defineInitialPosition();
        /* c8 ignore else */
        if (this.windowContent) {
            this.removeCSSHeightWidth();
        }
        /* c8 ignore else */
        if (this.isMdiContainer) {
            this.applyMdiContainerStyle();
        }
        /* c8 ignore else */
        if (this.isMdiChild) {
            this.mdiContentDiv =
                document.documentElement.querySelector('#mdiContentDiv');
            this.defineMdiChildPosition();
        }
        /* c8 ignore else */
        if (this.btService) {
            this.bringTopSubs = this.btService.notificationWindowAction.subscribe((evt) => {
                this.bringToFront();
            });
        }
        this.setOverrideFocusEvent();
        this.overrideKeyDown();
        const firsControlToFocus = this.tabIndexFirstId(this.children);
        /* c8 ignore else */
        if (firsControlToFocus != null) {
            firsControlToFocus.applyFocus();
            if (firsControlToFocus.getType() === 'ButtonComponent') {
                this.lastAcceptButtonControl = firsControlToFocus;
            }
        }
    }
    /**
     * Method to subscribe to the change detection mechanism
     *
     * @memberof WMWindowComponent
     */
    detectChangesSubscribe() {
        super.detectChangesSubscribe();
        if (WebMapService.currentService) {
            // The syncCompleted is called in the end of the WebMap request. Used to execute code after the response has been processed.
            this.syncCompleteSubscription = WebMapService.currentService.core
                .getEvent()
                .subscribe('SyncCompleted', 
            /* c8 ignore next */
            (data) => {
                /* c8 ignore next */
                if (this.webComponents &&
                    this.model &&
                    this.model.IsForm &&
                    this.parent == null) {
                    WMLogger.instance().info(`Call the start docking sync from WebMap response for: ${this.name}`);
                    this.webComponents.startDocking(this);
                }
            });
        }
    }
    /**
     * Reload pending child views when is mdi container
     */
    reloadPendingViews() {
        this.webMapService.core
            .getEvent()
            .publish(Events.ReloadPendingViews, this.id);
        // This flag is used to validate Pending Loads in AngularClient
        this.isPendingViewLoaded = true;
        this.detectChanges();
    }
    /**
     * @description
     * This sets the mdi container window style and creates mdiContentDiv element.
     * If window is not a mdi container, style won't be applied.
     * The mdiContentDiv element is created to calculate container space for mdiChilds.
     */
    applyMdiContainerStyle() {
        let wmContainer = this.elementRef.nativeElement.querySelector('wm-container');
        /* c8 ignore else */
        if (wmContainer) {
            wmContainer = wmContainer.nextSibling;
            /* c8 ignore else */
            if (wmContainer.nextSibling != null && wmContainer.nextSibling.style) {
                wmContainer.nextSibling.style.cssText =
                    'display: flex;flex-flow: column;';
                const node = this.renderer2.createElement('DIV');
                node.id = 'mdiContentDiv';
                node.style.cssText =
                    'flex: 1 1 auto; z-index: 1;display: flex;flex-direction: column;';
                this.renderer2.appendChild(wmContainer.nextSibling, node);
            }
        }
    }
    /**
     * @description
     * This function determines the intial window location (top, left). If model does not has a location
     * defined in model the form will use the location defined in the css class, and finally if css class does not
     * specifies location it will use default center position.
     */
    defineInitialPosition() {
        /* c8 ignore else */
        if (this.element && (!this.class || this.isDefaultPosition(this.element))) {
            /* c8 ignore else */
            if (this.model.Top == null) {
                const top = window.outerHeight / 2 - this.element.offsetHeight / 2;
                this.model.Top = top < 0 ? 0 : top;
            }
            /* c8 ignore else */
            if (this.model.Left == null) {
                const left = window.outerWidth / 2 - this.element.offsetWidth / 2;
                this.model.Left = left < 0 ? 0 : left;
            }
        }
        this.changeDetector.detectChanges();
    }
    /**
     * @description
     * This function determines the intial mdiChild window location (top, left).
     * It will set to the mdiContainer's  top to its top + mdiContainer offset.
     * This will avoid mdiChild window overlapping mdiContainer controls.
     */
    defineMdiChildPosition() {
        const elementNode = this.mdiContentDiv;
        /* c8 ignore else */
        if (this.element && elementNode) {
            this.kendoWindow.setOffset('top', elementNode.offsetTop + this.element.offsetTop);
            this.defineMdiChildLastPosition();
        }
    }
    /**
     * @description
     * This function sets the restoreTop and restoreLeft values.
     * If the window is mdi child, these values will be stored.
     * This method should be called when window is opened/dragged/resize.
     * When window is restored from being maximized, will use these restoreTop and restoreLeft values.
     */
    defineMdiChildLastPosition() {
        /* c8 ignore else */
        if (this.isMdiChild) {
            this.restoreTop = this.element.offsetTop;
            this.restoreLeft = this.element.offsetLeft;
        }
    }
    /**
     * Sets the accept button control when the id changes.
     */
    setAcceptButtonWhenIdChanges() {
        if (this.lastAcceptButtonControl &&
            this.acceptButton &&
            this.acceptButton !== this.lastAcceptButtonControl.id) {
            const eventData = new EventData$1({}, this.lastAcceptButtonControl.id);
            const newAcceptButtonControl = this.getAcceptButtonById(this, this.acceptButton);
            if (newAcceptButtonControl !== null) {
                this.wmWindowService.notifyRemoveFakeFocus(eventData);
                newAcceptButtonControl.applyFocus();
                this.lastAcceptButtonControl = newAcceptButtonControl;
            }
        }
    }
    /**
     * @description
     * This function overrides the focus event implementation in order to avoid the scrolling-top behavior once the form is focused
     */
    setOverrideFocusEvent() {
        /* c8 ignore else */
        if (this.element) {
            this.element.focus = () => {
                this.kendoWindow.focused = true;
                this.detectChanges();
            };
        }
    }
    /**
     * @description
     * This function determines the intial window zIndex, it uses the WindowService from KendoUI to
     * determine the top position of windows opened.
     */
    setSameZIndex() {
        /* c8 ignore else */
        if (this.element && this.blockUI) {
            const blockDiv = this.blockUI.nativeElement;
            /* c8 ignore else */
            if (blockDiv) {
                this.applyModalZIndex(this.element, blockDiv);
            }
        }
    }
    applyModalZIndex(form, blockDiv) {
        const formZIndex = Number(form.style.zIndex);
        /* c8 ignore else */
        if (formZIndex < this.initialModalZIndex) {
            form.style.zIndex = formZIndex + this.dialogPosition;
        }
        blockDiv.style.zIndex = form.style.zIndex;
    }
    /**
     * @description
     * This function is used to define if the css class applied to the window has a default position.
     * Any position negative going to be considered as a default position and the window will be
     * positioned at the center of the main window.
     * @param  elem
     * @returns boolean
     */
    isDefaultPosition(elem) {
        const style = window.getComputedStyle(elem);
        return style.top.startsWith('-') || style.left.startsWith('-');
    }
    /**
     * Gets HTML element of current window.
     */
    get element() {
        return this.kendoWindow ? this.kendoWindow.el.nativeElement : null;
    }
    /**
     * @description
     * The window top position. Return NaN if it does not exists in the model.
     * @returns number
     */
    get top() {
        /* c8 ignore else */
        if (this.dock === DockStyle.Fill) {
            return 0;
        }
        return this.model.Top ? this.model.Top : NaN;
    }
    /**
     * @description
     * The window left position. Return NaN if it does not exists in the model.
     * @returns number
     */
    get left() {
        /* c8 ignore else */
        if (this.dock === DockStyle.Fill) {
            return 0;
        }
        return this.model.Left ? this.model.Left : NaN;
    }
    /** Form properties */
    /**
     * Gets the value of property BringToTop that sets
     * the current window as the top view
     */
    get bringToTop() {
        return this.model.BringToTop;
    }
    /**
     * Sets the BringToTop
     */
    set bringToTop(value) {
        this.model.BringToTop = value;
    }
    get icon() {
        return this.model.Icon && this.model.Icon.FileName
            ? this.model.Icon.FileName
            : null;
    }
    get isModal() {
        return this.model.IsModalView;
    }
    set isModal(value) {
        this.model.IsModalView = value;
    }
    /**
     * Get return 'any' type that is 'string'
     * because the set receive 'any' that is 'any',
     * therefore build a consistency and work with
     * same type is importart use 'any' as type in both
     */
    get acceptButton() {
        return this.model.AcceptButtonGUID;
    }
    /**
     * Set receive a parameter 'any' type that is a 'any'
     * because get case return string, therefore build a consistency and work with
     * same type is importart use 'any' as type in both
     *
     * @param control:any
     */
    set acceptButton(control) {
        if (control) {
            const id = control.model.id;
            this.model.AcceptButtonGUID = id;
            control.isFocused = true;
        }
        else {
            this.model.AcceptButtonGUID = '';
        }
    }
    /**
     * Gets cancel button
     */
    get cancelButton() {
        return this.model.CancelButtonGUID;
    }
    /**
     * Get FormBorderStyle property of the form.
     */
    get formBorderStyle() {
        return this.model.FormBorderStyle != null
            ? this.model.FormBorderStyle
            : FormBorderStyles.FixedSingle;
    }
    get hasMaximizeButton() {
        return this.model.MaximizeBox;
    }
    get hasMinimizeButton() {
        return this.model.MinimizeBox;
    }
    get isMdiContainer() {
        return this.model.IsMdiContainer ? this.model.IsMdiContainer : false;
    }
    set isMdiContainer(value) {
        this.model.IsMdiContainer = value;
    }
    get isMdiChild() {
        return this.model.IsMdiChild ? this.model.IsMdiChild : false;
    }
    /**
     * Gets isDraggable property
     */
    get draggable() {
        return this.dock === DockStyle.Fill ? false : this.isDraggable;
    }
    /**
     * Sets isDraggable property
     */
    set draggable(value) {
        this.isDraggable = value;
    }
    /**
     * Gets whether window component has parent;
     */
    get hasParent() {
        return !!this.model.Parent;
    }
    /**
     * Gets dock style of current window component.
     * Default value is None
     */
    get dock() {
        return this.model.Dock != null ? this.model.Dock : DockStyle.None;
    }
    /**
     * Gets height style of current window component.
     */
    get height() {
        return this.model.Height ? this.model.Height : null;
    }
    /**
     * Sets height style of current window component.
     *
     * @remarks
     * If the value is negative, the window going to take the height of parent,
     * if value is zero, the window going to take the minimum height allowed by kendo.
     */
    set height(value) {
        this.model.Height = value;
        this.Resize.emit();
    }
    /**
     * Gets width style of current window component.
     */
    get width() {
        return this.model.Width ? this.model.Width : null;
    }
    /**
     * Sets width style of current window component.
     *
     * @remarks
     * If the value is negative, the window going to take the width of parent,
     * if value is zero, the window going to take the minimum width allowed by kendo.
     */
    set width(value) {
        this.model.Width = value;
        this.Resize.emit();
    }
    /**
     * Gets border property.
     */
    get border() {
        return this.formBorderStyle === FormBorderStyles.None ? 'none' : null;
    }
    /**
     * Gets width property from model size.
     */
    get getWidth() {
        /* c8 ignore else */
        if (this.getSize !== '') {
            const width = this.getSize.split(', ');
            /* c8 ignore else */
            if (width[0]) {
                return parseInt(width[0]);
            }
            return null;
        }
    }
    /**
     * Gets height property from model size.
     */
    get getHeight() {
        /* c8 ignore else */
        if (this.getSize !== '') {
            const height = this.getSize.split(', ');
            /* c8 ignore else */
            if (height[1]) {
                return parseInt(height[1]);
            }
            return null;
        }
    }
    /**
     * Gets size property.
     */
    get getSize() {
        return this.model.Size ? this.model.Size : '';
    }
    get windowState() {
        const currentState = this.model.WindowState;
        switch (currentState) {
            case 1:
                return 'minimized';
            case 2:
                return 'maximized';
            case 0:
            default:
                return 'default';
        }
    }
    set windowState(value) {
        switch (value) {
            case 'minimized':
                this.model.WindowState = 1;
                break;
            case 'maximized':
                this.model.WindowState = 2;
                break;
            default:
                this.model.WindowState = 0;
                break;
        }
    }
    /**
     * Gets buttons
     */
    get buttons() {
        return this.children?.filter((button) => button.getType() === 'ButtonComponent');
    }
    /**
     * Gets IsPendingViewLoaded property value
     *
     * Flag used to check if the ReloadPendingViews event on AngularClient was fired,
     * and therefore, WindowComponent is fully loaded to show child views
     */
    get isPendingViewLoaded() {
        return this.model.IsPendingViewLoaded;
    }
    /**
     * Sets th IsPendingViewLoaded property value
     */
    set isPendingViewLoaded(value) {
        this.model.IsPendingViewLoaded = value;
    }
    /**
     * Returns if window component is a Form
     */
    get isForm() {
        return this.model.IsForm;
    }
    /**
     * Gets tab index first button id
     */
    tabIndexFirstId(controlsCollection) {
        return controlsCollection?.sort((a, b) => parseInt(a.tabindex) - parseInt(b.tabindex))[0];
    }
    /**
     * Handle the browser resizing event to expand
     * the window whenever it modifies its size and the window
     * is in maximized state.
     * @param e the current javascript event
     */
    browserResize(e) {
        /* c8 ignore else */
        if (this.windowState === 'maximized') {
            /* c8 ignore else */
            if (this.browserResizeTO) {
                clearTimeout(this.browserResizeTO);
            }
            this.windowState = 'default';
            this.browserResizeTO = setTimeout(() => {
                this.windowState = 'maximized';
                WebMapService.currentService.core.getEvent().publish('detectChanges');
            }, 0);
        }
    }
    /** Methods */
    close(event) {
        this.Close.emit(new EventData$1(event, this.id));
    }
    contextMenu(event) {
        this.MouseDown.emit(new EventData$1(event, this.id));
        super.contextMenu(event);
    }
    formModeVisible() {
        return this.visible && !this.isModal;
    }
    /**
     * Verify window model exist in dictionary.
     *
     * @return {*}  {boolean}
     * @memberof WMWindowComponent
     */
    isDeleted() {
        return WebMapService?.currentService?.core?.getModel(this.id) == null;
    }
    /**
     * Dialog Mode Visible
     *
     * @return {*}  {boolean}
     * @memberof WMWindowComponent
     */
    dialogModeVisible() {
        if (!this.visible &&
            !this.isModal &&
            this.windowsManager.isWindowOpened(this) &&
            !this.isDeleted()) {
            this.windowsManager.removeWindow(this);
        }
        return this.visible && this.isModal;
    }
    /**
     * Set the current kendo-window element
     * focused.
     */
    bringToFront() {
        /* c8 ignore else */
        if (this.kendoWindow) {
            this.kendoWindow.bringToFront();
        }
        this.windowsManager.setActiveWindow(this);
    }
    /**
     * Set the resizable property for kendo-window by
     * borderStyle.
     */
    isResizable() {
        let result;
        switch (this.formBorderStyle) {
            case FormBorderStyles.None:
            case FormBorderStyles.FixedSingle:
            case FormBorderStyles.Fixed3D:
            case FormBorderStyles.FixedDialog:
            case FormBorderStyles.FixedToolWindow:
                result = false;
                break;
            case FormBorderStyles.Sizable:
            case FormBorderStyles.SizableToolWindow:
                result = true;
                break;
            default:
                result = false;
                break;
        }
        return result;
    }
    /**
     * @description
     * This function sets the style values to the mdi child form when maximizing and restores.
     * Adjusts the size and position of the window to the mdiParent container size and disables draggable when maximizing.
     */
    mdiChildWindowStateChange() {
        /* c8 ignore else */
        if (this.isMdiChild && this.windowState === 'maximized') {
            const elementNode = this.mdiContentDiv;
            /* c8 ignore else */
            if (elementNode && !this.useCss) {
                const mdiChild = this.element;
                this.kendoWindow.setOffset('top', elementNode.offsetTop);
                this.kendoWindow.setOffset('left', 0);
                this.renderer2.setStyle(mdiChild, 'width', 'calc(100% - 2px)');
                this.renderer2.setStyle(mdiChild, 'height', '100%');
                this.draggable = false;
            }
        }
        else if (this.isMdiChild && this.windowState === 'default') {
            this.draggable = true;
            this.kendoWindow.setOffset('top', this.restoreTop);
            this.kendoWindow.setOffset('left', this.restoreLeft);
        }
        if (this.windowState === 'maximized') {
            this.setNewSize();
        }
        else {
            this.removeNewSize();
        }
    }
    /**
     * Removes new size
     */
    removeNewSize() {
        this.heightChangeHandler(this.lastHeight);
        this.widthChangeHandler(this.lastWidth);
    }
    /**
     * Sets new size
     */
    setNewSize() {
        /* c8 ignore else */
        if (this.displayElement &&
            this.contentArea &&
            this.webComponents &&
            !this.useCss) {
            this.lastHeight = getComputedValue(this.displayElement, 'height', 0);
            this.lastWidth = getComputedValue(this.displayElement, 'width', 0);
            const size = {
                width: getComputedValue(this.contentArea, 'width', 0),
                height: getComputedValue(this.contentArea, 'height', 0)
            };
            this.renderer2.setStyle(this.displayElement, 'height', `${size.height}px`);
            this.renderer2.setStyle(this.displayElement, 'width', `${size.width}px`);
            this.webComponents.calculatePosition(this);
        }
    }
    /**
     * Special style for the dock process
     */
    specialStyle() {
        /* c8 ignore else */
        if (!this.autoScroll && this.contentArea) {
            this.renderer2.setStyle(this.contentArea, 'overflow', 'hidden');
        }
        if (this.parent) {
            let height = this.kendoWindow.height;
            let width = this.kendoWindow.width;
            /* c8 ignore else */
            if (this.elementRef && this.elementRef.nativeElement) {
                height =
                    getComputedValue(this.elementRef.nativeElement.firstElementChild, 'height', 0) - getComputedValue(this.titleArea, 'height', 0);
                width = getComputedValue(this.elementRef.nativeElement.firstElementChild, 'width', 0);
            }
            /* c8 ignore else */
            if (this.domElement) {
                this.renderer2.setStyle(this.domElement, 'height', `${height}px`);
                this.renderer2.setStyle(this.domElement, 'width', `${width}px`);
            }
        }
        else {
            this.renderer2.setStyle(this.displayElement, 'position', 'relative');
        }
    }
    /**
     * @description
     * Returns hide-title-bar class
     * @returns { string }
     */
    hideTitleBar() {
        return this.formBorderStyle === FormBorderStyles.None
            ? 'hide-title-bar'
            : null;
    }
    /**
     * Overrides key down
     * Overrides the original kendo keydown event in order to cancel
     * the default closing action when esc key is pressed and there is a cancelbutton defined
     */
    overrideKeyDown() {
        /* c8 ignore else */
        if (this.kendoWindow) {
            const originalKeyDownFn = this.kendoWindow.onComponentKeydown;
            this.kendoWindow.onComponentKeydown = (event) => {
                /* c8 ignore else */
                if (!this.cancelButton) {
                    originalKeyDownFn.apply(this.kendoWindow, [event]);
                }
            };
        }
    }
    /**
     * Handles Key Down event
     */
    onKeyDown(e) {
        if (e.keyCode === 27) {
            this.cancelAction(e);
        }
        else if (this.acceptButton && e.keyCode === 13) {
            this.acceptButtonAction(e);
        }
        else if (e.altKey) {
            this.shortcutAction(e);
        }
    }
    /**
     * Shortcuts action
     * @param e Key down event args
     * @memberof WMWindowComponent
     */
    shortcutAction(e) {
        this.shortcutsService.triggerUnderline();
        e.preventDefault();
        if (e.keyCode !== 18) {
            const key = this.shortcutsService?.obtainEventKeyCombination(e);
            if ((key && this.shortcutsService?.isRegister(key)) ||
                this.isMdiContainer ||
                !this.isMdiChild) {
                e.stopPropagation();
                e.stopImmediatePropagation();
                this.shortcutsService?.resolveShortCut(e, this.mainTab);
            }
        }
    }
    /**
     * Accept button action
     * @param e Key down event args
     * @memberof WMWindowComponent
     */
    acceptButtonAction(e) {
        const eventData = new EventData$1(e, this.acceptButton);
        eventData['args'] = {};
        eventData.args['action'] = 'AcceptButton';
        this.wmWindowService.notifyWindowButtonAction(eventData);
        e.stopPropagation();
        e.preventDefault();
    }
    /**
     * Cancel action
     * @param e Key down event args
     * @memberof WMWindowComponent
     */
    cancelAction(e) {
        if (this.cancelButton) {
            const eventData = new EventData$1(e, this.cancelButton);
            eventData['args'] = {};
            eventData.args['action'] = 'CancelButton';
            this.wmWindowService.notifyWindowButtonAction(eventData);
            e.stopPropagation();
            e.stopImmediatePropagation();
            e.preventDefault();
        }
        else {
            this.close(e);
        }
    }
    /**
     * Accepts button must be triggered
     * @returns true if button must be triggered
     */
    acceptButtonMustBeTrigerred(buttons) {
        for (const button of buttons) {
            /* c8 ignore else */
            if (button.focused && button.id !== this.acceptButton) {
                return false;
            }
        }
        return true;
    }
    /**
     * Heights change handler
     * @param e new height
     */
    heightChangeHandler(e) {
        let titleHeightPx = 0;
        const value = getComputedValue(this.contentArea, 'height', e);
        /* c8 ignore else */
        if (this.titleArea && value === e) {
            titleHeightPx = getComputedValue(this.titleArea, 'height', 0);
        }
        this.setdisplayElementProperty('height', `${value - titleHeightPx}px`);
    }
    /**
     * Widths change handler
     * @param e new width
     */
    widthChangeHandler(e) {
        const value = getComputedValue(this.contentArea, 'width', e);
        this.setdisplayElementProperty('width', `${value}px`);
    }
    setdisplayElementProperty(property, value) {
        /* c8 ignore else */
        if (this.displayElement != null && this.webComponents && !this.useCss) {
            this.renderer2.setStyle(this.displayElement, property, value);
            this.webComponents.calculatePosition(this);
        }
    }
    /**
     *  Overrides the css class of window content to use
     *  width and height values from model
     */
    removeCSSHeightWidth() {
        const element = this.windowContent.nativeElement.childNodes[1];
        /* c8 ignore else */
        if (element && element.nodeName.toLowerCase() === 'div' && !this.useCss) {
            const style = getComputedStyle(element);
            /* c8 ignore else */
            if (style.width !== '' &&
                this.getWidth &&
                `${this.getWidth}px` !== style.width) {
                this.renderer2.setStyle(element, 'width', `${this.getWidth}px`);
            }
            /* c8 ignore else */
            if (style.height !== '' &&
                this.getHeight &&
                `${this.getHeight}px` !== style.height) {
                this.renderer2.setStyle(element, 'height', `${this.getHeight}px`);
            }
        }
    }
    /**
     * Gets string indicating the type
     * @returns type
     */
    getType() {
        return 'WMWindowComponent';
    }
    /**
     * Gets display element depending on what kind of window is rendered (MDI, Child, ...)
     * @returns HTML element that represents the visual element target to receive visual changes
     */
    getDisplayElement() {
        const element = this.formModeVisible() && this.isMdiContainer && this.mdiContainerElement
            ? this.mdiContainerElement.nativeElement
            : this.element;
        /* c8 ignore else */
        if (element) {
            this.domElement = element.querySelector(`.${this.name}`);
            this.contentArea = element.querySelector('.k-window-content');
            this.titleArea = element.querySelector('.k-window-titlebar');
            /* c8 ignore else */
            if (this.parent) {
                return element;
            }
            return this.domElement ? this.domElement : this.contentArea;
        }
        return null;
    }
    /**
     * Triggers the refresh component data event.
     *
     * @param {EventData} clientCustomEventData
     * @memberof WMWindowComponent
     */
    refreshComponentData(clientCustomEventData) {
        this.RefreshClientCustomChanges.emit(new EventData$1(clientCustomEventData?.event, this.id));
    }
};
WMWindowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WMWindowComponent, deps: [{ token: i1.WebMapService }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: WebComponentsService }, { token: WindowsManagerService }, { token: MainTabOrderService }, { token: i3.BringTopService }, { token: WMWindowService }, { token: ShortcutsService, optional: true }, { token: ClientCustomUpdateService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
WMWindowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: WMWindowComponent, selector: "wm-window", inputs: { model: "model", mdiMode: "mdiMode", clientCustomIdentifier: "clientCustomIdentifier" }, outputs: { Close: "Close", MouseDown: "MouseDown", RefreshClientCustomChanges: "RefreshClientCustomChanges" }, host: { listeners: { "window:resize": "browserResize($event)" } }, providers: [
        BringTopService,
        MainTabOrderService,
        WMWindowService,
        ShortcutsService
    ], queries: [{ propertyName: "parentTemplate", first: true, predicate: TemplateRef, descendants: true }], viewQueries: [{ propertyName: "windowContent", first: true, predicate: ["windowContent"], descendants: true }, { propertyName: "blockUI", first: true, predicate: ["blockUI"], descendants: true }, { propertyName: "kendoWindow", first: true, predicate: WindowComponent, descendants: true }, { propertyName: "mdiContainerElement", first: true, predicate: ["mdiContainerElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<!-- Default Window-->\r\n<kendo-window [title]=\"text\" *ngIf=\"formModeVisible() && !isMdiContainer && !mdiMode\" (close)=\"close($event)\"\r\n  [(state)]=\"windowState\" (heightChange)=\"heightChangeHandler($event)\" (widthChange)=\"widthChangeHandler($event)\"\r\n  (stateChange)=\"mdiChildWindowStateChange()\" [ngClass]=\"class\" [attr.disabled]=\"disabled\" [top]=\"top\" [left]=\"left\"\r\n  [resizable]=\"isResizable()\" [draggable]=\"draggable\" (keydown)=\"onKeyDown($event)\" wmControls [hostComponent]=\"this\"\r\n  [style.border]=\"border\" [width]=\"width\"\r\n  [height]=\"height\">\r\n  <kendo-window-titlebar [ngClass]=\"hideTitleBar()\">\r\n    <div class=\"custom-title-bar\" (click)=\"bringToFront()\">\r\n      <img src=\"{{icon}}\" onerror=\"this.style.display='none'\" width=\"18em\">\r\n      <span class=\"k-window-title\">{{text}}</span>\r\n    </div>\r\n    <button *ngIf=\"hasMinimizeButton\" kendoWindowMinimizeAction></button>\r\n    <button *ngIf=\"hasMaximizeButton\" kendoWindowMaximizeAction></button>\r\n    <button kendoWindowCloseAction></button>\r\n    <button kendoWindowRestoreAction></button>\r\n  </kendo-window-titlebar>\r\n  <div id=\"windowContent\" #windowContent class=\"windowContentClass\">\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n    <ng-container *ngTemplateOutlet=\"parentTemplate; context: { $implicit: model }\"></ng-container>\r\n  </div>\r\n</kendo-window>\r\n<!-- Block UI Div-->\r\n<div id=\"blockUI\" #blockUI *ngIf=\"dialogModeVisible()\" class=\"modal-overlay\"></div>\r\n<!-- Dialog Window-->\r\n<kendo-window [title]=\"text\" *ngIf=\"dialogModeVisible() && !isMdiContainer && !mdiMode\" (close)=\"close($event)\"\r\n  [(state)]=\"windowState\" [ngClass]=\"class\" [attr.disabled]=\"disabled\" [top]=\"top\" [left]=\"left\"\r\n  (heightChange)=\"heightChangeHandler($event)\" (widthChange)=\"widthChangeHandler($event)\" [resizable]=\"isResizable()\"\r\n  [style.border]=\"border\" (keydown)=\"onKeyDown($event)\">\r\n  <kendo-window-titlebar [ngClass]=\"hideTitleBar()\">\r\n    <div class=\"custom-title-bar\">\r\n      <img src=\"{{icon}}\" onerror=\"this.style.display='none'\" width=\"18em\">\r\n      <span class=\"k-window-title\">{{text}}</span>\r\n    </div>\r\n    <button *ngIf=\"hasMinimizeButton\" kendoWindowMinimizeAction></button>\r\n    <button *ngIf=\"hasMaximizeButton\" kendoWindowMaximizeAction></button>\r\n    <button kendoWindowCloseAction></button>\r\n    <button kendoWindowRestoreAction></button>\r\n  </kendo-window-titlebar>\r\n  <div id=\"windowContent\" #windowContent class=\"windowContentClass\">\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n    <ng-container *ngTemplateOutlet=\"parentTemplate; context: { $implicit: model }\"></ng-container>\r\n  </div>\r\n</kendo-window>\r\n<!-- MDI Container -->\r\n<div #mdiContainerElement [hostComponent]=\"this\" *ngIf=\"formModeVisible() && (isMdiContainer || mdiMode)\"\r\n  [attr.disabled]=\"disabled\" [ngClass]=\"class\" class=\"mdiForm\" wmControls (keydown)=\"onKeyDown($event)\">\r\n  <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n  <ng-container *ngTemplateOutlet=\"parentTemplate; context: { $implicit: model }\"></ng-container>\r\n  <wm-formscontainer [parentId]=\"id\" (Loaded)=\"reloadPendingViews()\"></wm-formscontainer>\r\n</div>", styles: ["kendo-dialog{position:relative}.mdiForm{position:absolute;top:0;left:0;overflow:auto;width:100%;height:100%}.modal-overlay{width:100%;height:100%;position:absolute;overflow:hidden;top:0;left:0;background:rgba(0,0,0,.5)!important}.custom-title-bar{flex:1;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.hide-title-bar{display:none}.windowContentClass{width:100%;height:100%}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i7.WindowComponent, selector: "kendo-window", inputs: ["autoFocusedElement", "title", "draggable", "resizable", "themeColor", "keepContent", "state", "minWidth", "minHeight", "width", "height", "top", "left"], outputs: ["dragStart", "dragEnd", "resizeStart", "resizeEnd", "close", "widthChange", "heightChange", "topChange", "leftChange", "stateChange"], exportAs: ["kendoWindow"] }, { kind: "component", type: i7.WindowCloseActionDirective, selector: "button[kendoWindowCloseAction]", inputs: ["window"], exportAs: ["kendoWindowCloseAction"] }, { kind: "component", type: i7.WindowMinimizeActionDirective, selector: "button[kendoWindowMinimizeAction]", inputs: ["window"], exportAs: ["kendoWindowMinimizeAction"] }, { kind: "component", type: i7.WindowMaximizeActionDirective, selector: "button[kendoWindowMaximizeAction]", inputs: ["window"], exportAs: ["kendoWindowMaximizeAction"] }, { kind: "component", type: i7.WindowRestoreActionDirective, selector: "button[kendoWindowRestoreAction]", inputs: ["window"], exportAs: ["kendoWindowRestoreAction"] }, { kind: "component", type: i7.WindowTitleBarComponent, selector: "kendo-window-titlebar", inputs: ["template", "id"] }, { kind: "component", type: i3.FormsContainerComponent, selector: "wm-formscontainer", inputs: ["parentId"], outputs: ["Loaded"] }, { kind: "component", type: i3.ContainerComponent, selector: "wm-container", inputs: ["controls"], outputs: ["RemoveControl"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    NotifyChange('AcceptButtonGUID'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], WMWindowComponent.prototype, "acceptButton", null);
__decorate([
    NotifyChange('WindowState'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], WMWindowComponent.prototype, "windowState", null);
__decorate([
    serverEvent('FormClose'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WMWindowComponent.prototype, "close", null);
__decorate([
    serverEvent('MouseDown', WMWindowComponent_1.mouseEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WMWindowComponent.prototype, "contextMenu", null);
__decorate([
    serverEvent('RefreshClientCustomChanges', WMWindowComponent_1.RefreshClientCustomChangesEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EventData$1]),
    __metadata("design:returntype", void 0)
], WMWindowComponent.prototype, "refreshComponentData", null);
WMWindowComponent = WMWindowComponent_1 = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ElementRef,
        ChangeDetectorRef,
        Renderer2,
        WebComponentsService,
        WindowsManagerService,
        MainTabOrderService,
        BringTopService,
        WMWindowService,
        ShortcutsService,
        ClientCustomUpdateService])
], WMWindowComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WMWindowComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-window', providers: [
                        BringTopService,
                        MainTabOrderService,
                        WMWindowService,
                        ShortcutsService
                    ], inputs: ['model'], template: "<!-- Default Window-->\r\n<kendo-window [title]=\"text\" *ngIf=\"formModeVisible() && !isMdiContainer && !mdiMode\" (close)=\"close($event)\"\r\n  [(state)]=\"windowState\" (heightChange)=\"heightChangeHandler($event)\" (widthChange)=\"widthChangeHandler($event)\"\r\n  (stateChange)=\"mdiChildWindowStateChange()\" [ngClass]=\"class\" [attr.disabled]=\"disabled\" [top]=\"top\" [left]=\"left\"\r\n  [resizable]=\"isResizable()\" [draggable]=\"draggable\" (keydown)=\"onKeyDown($event)\" wmControls [hostComponent]=\"this\"\r\n  [style.border]=\"border\" [width]=\"width\"\r\n  [height]=\"height\">\r\n  <kendo-window-titlebar [ngClass]=\"hideTitleBar()\">\r\n    <div class=\"custom-title-bar\" (click)=\"bringToFront()\">\r\n      <img src=\"{{icon}}\" onerror=\"this.style.display='none'\" width=\"18em\">\r\n      <span class=\"k-window-title\">{{text}}</span>\r\n    </div>\r\n    <button *ngIf=\"hasMinimizeButton\" kendoWindowMinimizeAction></button>\r\n    <button *ngIf=\"hasMaximizeButton\" kendoWindowMaximizeAction></button>\r\n    <button kendoWindowCloseAction></button>\r\n    <button kendoWindowRestoreAction></button>\r\n  </kendo-window-titlebar>\r\n  <div id=\"windowContent\" #windowContent class=\"windowContentClass\">\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n    <ng-container *ngTemplateOutlet=\"parentTemplate; context: { $implicit: model }\"></ng-container>\r\n  </div>\r\n</kendo-window>\r\n<!-- Block UI Div-->\r\n<div id=\"blockUI\" #blockUI *ngIf=\"dialogModeVisible()\" class=\"modal-overlay\"></div>\r\n<!-- Dialog Window-->\r\n<kendo-window [title]=\"text\" *ngIf=\"dialogModeVisible() && !isMdiContainer && !mdiMode\" (close)=\"close($event)\"\r\n  [(state)]=\"windowState\" [ngClass]=\"class\" [attr.disabled]=\"disabled\" [top]=\"top\" [left]=\"left\"\r\n  (heightChange)=\"heightChangeHandler($event)\" (widthChange)=\"widthChangeHandler($event)\" [resizable]=\"isResizable()\"\r\n  [style.border]=\"border\" (keydown)=\"onKeyDown($event)\">\r\n  <kendo-window-titlebar [ngClass]=\"hideTitleBar()\">\r\n    <div class=\"custom-title-bar\">\r\n      <img src=\"{{icon}}\" onerror=\"this.style.display='none'\" width=\"18em\">\r\n      <span class=\"k-window-title\">{{text}}</span>\r\n    </div>\r\n    <button *ngIf=\"hasMinimizeButton\" kendoWindowMinimizeAction></button>\r\n    <button *ngIf=\"hasMaximizeButton\" kendoWindowMaximizeAction></button>\r\n    <button kendoWindowCloseAction></button>\r\n    <button kendoWindowRestoreAction></button>\r\n  </kendo-window-titlebar>\r\n  <div id=\"windowContent\" #windowContent class=\"windowContentClass\">\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n    <ng-container *ngTemplateOutlet=\"parentTemplate; context: { $implicit: model }\"></ng-container>\r\n  </div>\r\n</kendo-window>\r\n<!-- MDI Container -->\r\n<div #mdiContainerElement [hostComponent]=\"this\" *ngIf=\"formModeVisible() && (isMdiContainer || mdiMode)\"\r\n  [attr.disabled]=\"disabled\" [ngClass]=\"class\" class=\"mdiForm\" wmControls (keydown)=\"onKeyDown($event)\">\r\n  <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n  <ng-container *ngTemplateOutlet=\"parentTemplate; context: { $implicit: model }\"></ng-container>\r\n  <wm-formscontainer [parentId]=\"id\" (Loaded)=\"reloadPendingViews()\"></wm-formscontainer>\r\n</div>", styles: ["kendo-dialog{position:relative}.mdiForm{position:absolute;top:0;left:0;overflow:auto;width:100%;height:100%}.modal-overlay{width:100%;height:100%;position:absolute;overflow:hidden;top:0;left:0;background:rgba(0,0,0,.5)!important}.custom-title-bar{flex:1;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.hide-title-bar{display:none}.windowContentClass{width:100%;height:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: WebComponentsService }, { type: WindowsManagerService }, { type: MainTabOrderService }, { type: i3.BringTopService }, { type: WMWindowService }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }, { type: ClientCustomUpdateService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { parentTemplate: [{
                type: ContentChild,
                args: [TemplateRef, { static: false }]
            }], windowContent: [{
                type: ViewChild,
                args: ['windowContent', { static: false }]
            }], Close: [{
                type: Output
            }], MouseDown: [{
                type: Output
            }], RefreshClientCustomChanges: [{
                type: Output
            }], blockUI: [{
                type: ViewChild,
                args: ['blockUI', { static: false }]
            }], kendoWindow: [{
                type: ViewChild,
                args: [WindowComponent, { static: false }]
            }], mdiContainerElement: [{
                type: ViewChild,
                args: ['mdiContainerElement', { static: false }]
            }], mdiMode: [{
                type: Input
            }], clientCustomIdentifier: [{
                type: Input
            }], acceptButton: [], windowState: [], browserResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }], close: [], contextMenu: [], refreshComponentData: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class FormComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(webmapService, changeDetector, renderer2, element, webComponents = null) {
        super(changeDetector, renderer2, element, webComponents);
        this.webmapService = webmapService;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
    }
    /**
     * get height value from the current window.
     */
    get height() {
        return this.window?.height;
    }
    /**
     * Set the height value to the current window.
     */
    set height(value) {
        this.window.height = value;
    }
    /**
     * get width value from the current window.
     */
    get width() {
        return this.window?.width;
    }
    /**
     * Set the width value to the current window.
     */
    set width(value) {
        this.window.width = value;
    }
    /**
     * Trigger the focused event in the window component.
     */
    bringToFront() {
        this.window.bringToFront();
    }
    /**
     *Get the acceptButton
     * @type {*}
     * @memberof FormComponent
     */
    get acceptButton() {
        return this.window.acceptButton;
    }
    /**
     *Set the acceptButton
    
     * @memberof FormComponent
     */
    set acceptButton(control) {
        this.window.acceptButton = control;
    }
}
FormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }], target: i0.ɵɵFactoryTarget.Component });
FormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: FormComponent, selector: "ng-component", viewQueries: [{ propertyName: "window", first: true, predicate: WMWindowComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormComponent, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }]; }, propDecorators: { window: [{
                type: ViewChild,
                args: [WMWindowComponent, { static: false }]
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * AlingHorzEnum
 */
var AlignHorzEnum;
(function (AlignHorzEnum) {
    AlignHorzEnum[AlignHorzEnum["General"] = 0] = "General";
    AlignHorzEnum[AlignHorzEnum["Near"] = 1] = "Near";
    AlignHorzEnum[AlignHorzEnum["Center"] = 2] = "Center";
    AlignHorzEnum[AlignHorzEnum["Far"] = 3] = "Far";
    AlignHorzEnum[AlignHorzEnum["Justify"] = 4] = "Justify";
})(AlignHorzEnum || (AlignHorzEnum = {}));
/**
 * FontStyleEnum
 */
var FontStyleEnum;
(function (FontStyleEnum) {
    FontStyleEnum[FontStyleEnum["Normal"] = 32] = "Normal";
    FontStyleEnum[FontStyleEnum["Regular"] = 16] = "Regular";
    FontStyleEnum[FontStyleEnum["Bold"] = 1] = "Bold";
    FontStyleEnum[FontStyleEnum["Italic"] = 2] = "Italic";
    FontStyleEnum[FontStyleEnum["Underline"] = 4] = "Underline";
    FontStyleEnum[FontStyleEnum["Strikeout"] = 8] = "Strikeout";
})(FontStyleEnum || (FontStyleEnum = {}));
/**
 * AlingVertEnum
 */
var AlignVertEnum;
(function (AlignVertEnum) {
    AlignVertEnum[AlignVertEnum["Top"] = 0] = "Top";
    AlignVertEnum[AlignVertEnum["Center"] = 1] = "Center";
    AlignVertEnum[AlignVertEnum["Bottom"] = 2] = "Bottom";
})(AlignVertEnum || (AlignVertEnum = {}));
/**
 * TextWrapping
 */
var TextWrapping;
(function (TextWrapping) {
    TextWrapping[TextWrapping["NoWrap"] = 0] = "NoWrap";
    TextWrapping[TextWrapping["Wrap"] = 1] = "Wrap";
    TextWrapping[TextWrapping["WrapWithOverflow"] = 2] = "WrapWithOverflow";
})(TextWrapping || (TextWrapping = {}));
const backgroundColor$1 = 'background-color';
const color = 'color';
const fontFamily = 'font-family';
const fontweight = 'font-weight';
const fontstyle = 'font-style';
const textdecoration = 'text-decoration';
const textAlign = 'text-align';
const whiteSpace = 'white-space';
const verticalAlign = 'vertical-align';
class GridStyle {
    setBackgroundColor(value) {
        this.setStyleProperty(this.parseColor(value), backgroundColor$1);
    }
    setColor(value) {
        this.setStyleProperty(this.parseColor(value), color);
    }
    setFontFamily(value) {
        this.setStyleProperty(value, fontFamily);
    }
    /* c8 ignore start */
    setTextAlign(value) {
        switch (value) {
            case AlignHorzEnum.Far:
                this[textAlign] = 'right';
                break;
            case AlignHorzEnum.Justify:
                this[textAlign] = 'justify';
                break;
            case AlignHorzEnum.Center:
                this[textAlign] = 'center';
                break;
            case AlignHorzEnum.General:
            case AlignHorzEnum.Near:
            default:
                this[textAlign] = 'left';
        }
    }
    /* c8 ignore stop */
    /* c8 ignore start */
    setVerticalAlign(value) {
        switch (value) {
            case AlignVertEnum.Center:
                this[verticalAlign] = 'middle';
                break;
            case AlignVertEnum.Bottom:
                this[verticalAlign] = 'bottom';
                break;
            case AlignVertEnum.Top:
            default:
                this[verticalAlign] = 'top';
        }
    }
    /* c8 ignore stop */
    /* c8 ignore start */
    setFontStyle(value) {
        switch (value) {
            case FontStyleEnum.Bold:
                this.applyFont('bold', '', '');
                break;
            case FontStyleEnum.Italic:
                this.applyFont('', 'italic', '');
                break;
            case FontStyleEnum.Strikeout:
                this.applyFont('', '', 'line-through');
                break;
            case FontStyleEnum.Underline:
                this.applyFont('', '', 'underline');
                break;
            case FontStyleEnum.Regular:
            case FontStyleEnum.Normal:
            default:
                this.applyFont('', '', '');
        }
    }
    /* c8 ignore stop */
    /* c8 ignore next 3 */
    setWrap(value) {
        this[whiteSpace] = value ? 'normal' : 'nowrap';
    }
    setStyleProperty(value, property) {
        /* c8 ignore else */
        if (value !== this[property]) {
            this[property] = value;
        }
    }
    update(object) {
        /* c8 ignore else */
        if (object) {
            this.setBackgroundColor(object.backcolor);
            this.setColor(object.forecolor);
            this.setFontFamily(object.font);
            this.setFontStyle(object.fontstyle);
            this.setTextAlign(object.horizontalalign);
            this.setVerticalAlign(object.verticalalign);
            this.setWrap(object.wrap);
        }
    }
    applyFont(weight, style, decoration) {
        this[fontweight] = weight;
        this[fontstyle] = style;
        this[textdecoration] = decoration;
    }
    checkRgb(colorString) {
        const rxValidRgb = /\d{1,3}, \d{1,3}, \d{1,3}/;
        return rxValidRgb.test(colorString);
    }
    /* c8 ignore next 3 */
    parseColor(colorString) {
        return this.checkRgb(colorString) ? `rgb(${colorString})` : colorString;
    }
}

class GridComponent extends ControlComponent {
    /* c8 ignore start */
    static EditExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: event.args.MapperId },
            {
                MapperId: GridComponent.editEventArgsMapperId,
                NewValue: event.args.newValue
            }
        ];
    }
    /* c8 ignore stop */
    /* c8 ignore start */
    static SortExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: event.args.MapperId },
            {
                MapperId: GridComponent.sortEventArgsMapperId,
                Field: event.args.field,
                Direction: event.args.direction
            }
        ];
    }
    /* c8 ignore stop */
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, formBuilder, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.service = service;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.formBuilder = formBuilder;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.defaultDataUrl = 'api/grid';
        this.Edit = new EventEmitter();
        this.Sort = new EventEmitter();
        this.skip = 0;
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        this.fetchItems();
        this.setSelectableSettings();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    /**
     * Fetchs items
     * Retrieves the rows collection from the server side
     * @property Rows r
     */
    fetchItems() {
        /* c8 ignore next 4 */
        this.service.fetch(this.url, this.id).subscribe((data) => {
            this.items = data;
            this.detectChanges();
        });
    }
    /**
     * creates form group object used in the grid's edition
     */
    createFormGroup(dataItem) {
        return this.formBuilder.group(dataItem);
    }
    /**
     * inserts a style inside the grid's DOM in order to handle the rowheight
     */
    setRowStyle() {
        /* c8 ignore else */
        if (this.styleContainer && this.styleContainer.nativeElement) {
            this.styleContainer.nativeElement.innerHTML = `<style>.k-grid-container tr {height: ${this.rowHeight}px; }</style>`; // nosemgrep
        }
    }
    /**
     * Gets column headers visible
     */
    get columnHeadersVisible() {
        return this.model && this.model.ColumnHeadersVisible != null
            ? this.model.ColumnHeadersVisible
            : true;
    }
    /**
     * Sets column headers visible
     */
    set columnHeadersVisible(columnHeadersVisible) {
        this.model.ColumnHeadersVisible = columnHeadersVisible;
    }
    get rowHeight() {
        /* c8 ignore else */
        if (this.model.RowHeight && typeof this.model.RowHeight === 'number') {
            return this.model.RowHeight;
        }
        return 35;
    }
    get pageSize() {
        /* c8 ignore else */
        if (this.pageSizeInternal) {
            return this.pageSizeInternal;
        }
        return 100;
    }
    get url() {
        /* c8 ignore else */
        if (this.dataUrl && this.dataUrl.length > 0) {
            return this.dataUrl;
        }
        return this.defaultDataUrl;
    }
    get selectionMode() {
        return this.model.SelectionMode;
    }
    set selectionMode(value) {
        this.model.SelectionMode = value;
    }
    /**
     * Gets the Grid's columns refresh value, which indicates if the columns should be refreshed
     */
    get refreshColumns() {
        return this.model.RefreshColumns;
    }
    /**
     * Sets the Grid's columns refresh value, which indicates if the columns should be refreshed
     */
    set refreshColumns(value) {
        this.model.RefreshColumns = value;
    }
    setSelectableSettings() {
        this.selectableSettings = {
            checkboxOnly: false,
            mode: this.selectionMode === 'FullRowSelect' ? 'multiple' : 'single'
        };
    }
    /**
     * Handles the page change event.
     * @param event The pageChange event object
     */
    pageChange(event) {
        this.skip = event.skip;
        this.loadPage();
    }
    /**
     * Retrieves the data from the backend
     */
    loadPage() { }
    /**
     * Return an HttpParams object with
     * the page data.
     */
    getPageParams() {
        let params = new HttpParams();
        params = params.set('skip', this.skip.toString());
        params = params.set('take', this.pageSize.toString());
        return params;
    }
    editEventHandler(eventData) {
        this.Edit.emit(eventData);
    }
    sortEventHandler(eventData) {
        this.Sort.emit(eventData);
    }
    /**
     * Checks if the user has leave the grid, if so, triggers the leave event
     * @param event the event.
     */
    hasTheGridLostFocus(event) {
        const target = event.relatedTarget ? event.relatedTarget : event.srcElement;
        /* c8 ignore else */
        if (target &&
            !this.isDescendant(this.gridEl.wrapper.nativeElement, target)) {
            const eventData = new EventData$1('Leave', this.id);
            this.leaveEventsHandler(eventData);
        }
    }
    /**
     * Gets the dom elements collections and then binds the onblur event to every element
     */
    bindsFocusOutEventToGrid() {
        /* c8 ignore else */
        if (this.gridEl) {
            const cells = this.gridEl.wrapper.nativeElement.querySelectorAll('td');
            this.bindBlurEventToTableElements(cells);
            const headers = this.gridEl.wrapper.nativeElement.querySelectorAll('th');
            this.bindBlurEventToTableElements(headers);
        }
    }
    moveFrozenRows(maxFrozen) {
        /* c8 ignore else */
        if (this.gridEl && maxFrozen > 0) {
            const header = this.gridEl.wrapper.nativeElement.querySelector('.k-grid-header table thead');
            for (let index = 0; index < maxFrozen + 1; index++) {
                const frozenRow = this.gridEl.wrapper.nativeElement.querySelector(`tr[data-kendo-grid-item-index="${index}"]`);
                /* c8 ignore else */
                if (header && frozenRow) {
                    header.appendChild(frozenRow);
                }
            }
        }
    }
    /**
     * Binds the onblur event to every element in the collection
     * @param elementsCollection the collection of DOM elements.
     */
    bindBlurEventToTableElements(elementsCollection) {
        for (const elem of elementsCollection) {
            /* c8 ignore else */
            if (elem.onblur === null) {
                elem.onblur = this.hasTheGridLostFocus.bind(this);
            }
        }
    }
    /**
     * Checks if an element is descedant of another in the DOM tree
     * @param parent the parent element
     * @param parent the child element to be checked
     */
    isDescendant(parent, child) {
        let node = child.parentNode;
        while (node != null) {
            /* c8 ignore else */
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    }
    /**
     * Calculates the style for a cell and stores it in a temporal structure to avoid calculated it twice
     */
    /* c8 ignore start */
    calculateStyle(rowIndex, columnIndex) {
        const style = new GridStyle();
        const rowStyleArray = this.styles.length === this.items.length
            ? this.styles[rowIndex]
            : undefined;
        if (rowStyleArray) {
            const serverStyle = rowStyleArray.length === 1
                ? rowStyleArray[0]
                : rowStyleArray[columnIndex - 1];
            style.update(serverStyle);
            this.stylesCalculated[rowIndex]
                ? this.stylesCalculated[rowIndex].push(style)
                : this.stylesCalculated.push([style]);
        }
        else {
            this.stylesCalculated.push([style]);
        }
        return style;
    }
    /* c8 ignore stop */
    /**
     * Returns original Style from a cell
     */
    /* c8 ignore start */
    originalStyle(rowIndex, columnIndex) {
        const rowStyleArray = this.styles && this.items && this.styles.length === this.items.length
            ? this.styles[rowIndex]
            : undefined;
        if (rowStyleArray) {
            return rowStyleArray.length === 1
                ? rowStyleArray[0]
                : rowStyleArray[columnIndex - 1];
        }
        return rowStyleArray;
    }
    /* c8 ignore stop */
    /**
     * Checks if the style for a specific cell is already stored in the structure and returns it
     */
    getStoredStyle(rowIndex, columnIndex) {
        let returnValue;
        const rowStyleCalculated = this.stylesCalculated.length > rowIndex
            ? this.stylesCalculated[rowIndex]
            : undefined;
        /* c8 ignore else */
        if (rowStyleCalculated) {
            if (!this.styles[rowIndex] ||
                (this.styles[rowIndex] && this.styles[rowIndex].length === 1)) {
                returnValue = rowStyleCalculated[0];
            }
            else if (rowStyleCalculated.length === this.columns.length) {
                returnValue = rowStyleCalculated[columnIndex - 1];
            }
        }
        return returnValue;
    }
    applyColumnStyle(columnStyle) {
        const style = new GridStyle();
        /* c8 ignore else */
        if (columnStyle) {
            style.update(columnStyle);
        }
        return style;
    }
    /**
     * Apply's the cell style based on row and cell styles
     */
    /* c8 ignore next */
    applyCellStyle(rowIndex, columnIndex) {
        /* c8 ignore else */
        if (this.styles) {
            const logicalRowIndex = rowIndex - this.skip;
            const storedStyle = this.getStoredStyle(logicalRowIndex, columnIndex);
            return storedStyle
                ? storedStyle
                : this.calculateStyle(logicalRowIndex, columnIndex);
        }
        return undefined;
    }
    /**
     * Trys close grid edit
     */
    tryCloseGridEdit() {
        /* c8 ignore else */
        if (this.gridEl.isEditing()) {
            this.gridEl.closeCell();
        }
    }
    /**
     * Applies focus to current row and current column inside of grid
     * component.
     */
    applyFocus() {
        // Apply focus to current cell (row-col position) or to the
        // entire grid component if it is empty
    }
    /**
     * Returns a valid KendoGrid column field value.
     *
     * @param {string} webMapColumnField
     * @return {*}  {string}
     * @memberof GridComponent
     */
    webMapToKendoColField(webMapColumnField) {
        return webMapColumnField.replace(/ /g, '$');
    }
    /**
     * Returns the WebMap column field value based on the kendo column field.
     * This function gets the WebMap value after using the webMapToKendoColField.
     *
     * @param {string} kendoColumnField
     * @return {*}  {string}
     * @memberof GridComponent
     */
    kendoToWebMapColField(kendoColumnField) {
        return kendoColumnField.replace(/\$/g, ' ');
    }
}
GridComponent.editEventArgsMapperId = 'DtVntRgs';
GridComponent.sortEventArgsMapperId = 'SrtVntRgs';
GridComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GridComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i6.UntypedFormBuilder }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
GridComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: GridComponent, selector: "ng-component", inputs: { dataUrl: "dataUrl", pageSizeInternal: "pageSizeInternal" }, outputs: { Edit: "Edit", Sort: "Sort" }, viewQueries: [{ propertyName: "styleContainer", first: true, predicate: ["styleContainer"], descendants: true }, { propertyName: "gridEl", first: true, predicate: ["grid"], descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('ColumnHeadersVisible'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], GridComponent.prototype, "columnHeadersVisible", null);
__decorate([
    MarkForCheck(),
    NotifyChange('RefreshColumns'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], GridComponent.prototype, "refreshColumns", null);
__decorate([
    serverEvent('Edit', GridComponent.EditExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EventData$1]),
    __metadata("design:returntype", void 0)
], GridComponent.prototype, "editEventHandler", null);
__decorate([
    serverEvent('Sort', GridComponent.SortExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EventData$1]),
    __metadata("design:returntype", void 0)
], GridComponent.prototype, "sortEventHandler", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GridComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i6.UntypedFormBuilder }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { dataUrl: [{
                type: Input
            }], pageSizeInternal: [{
                type: Input
            }], Edit: [{
                type: Output
            }], Sort: [{
                type: Output
            }], styleContainer: [{
                type: ViewChild,
                args: ['styleContainer', { static: false }]
            }], gridEl: [{
                type: ViewChild,
                args: ['grid', { static: false }]
            }], columnHeadersVisible: [], refreshColumns: [], editEventHandler: [], sortEventHandler: [] } });

let SessionExpiredComponent = class SessionExpiredComponent {
    constructor() { }
    /**The session expired title */
    get title() {
        return this.model.Title;
    }
    get labelMessage() {
        return this.model.Message;
    }
    ngOnInit() {
        this.visible = true;
    }
    /**
     * Handle the click event
     * Refresh the current page
     * @param event The click event object
     */
    /* c8 ignore next */
    click(event) {
        this.visible = false;
        window.location.reload();
    }
};
SessionExpiredComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SessionExpiredComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SessionExpiredComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SessionExpiredComponent, selector: "wm-session-expired", inputs: { model: "model" }, ngImport: i0, template: "<div *ngIf=\"model\">\r\n  <kendo-dialog [title]=\"title\" *ngIf=\"visible\">\r\n      <i class=\"material-icons warningIcon\">warning</i>\r\n      <p class=\"message\" style=\"margin: 30px; text-align: center;\">{{labelMessage}}</p>\r\n      <kendo-dialog-actions>\r\n          <button class='k-button' (click)=\"click($event)\">Ok</button>\r\n      </kendo-dialog-actions>\r\n  </kendo-dialog>\r\n</div>", styles: ["kendo-dialog{z-index:100000}.warningIcon{color:#b8860b;font-size:25px}.message{font-size:18px}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7.DialogComponent, selector: "kendo-dialog", inputs: ["actions", "actionsLayout", "autoFocusedElement", "title", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "animation", "themeColor"], outputs: ["action", "close"], exportAs: ["kendoDialog"] }, { kind: "component", type: i7.DialogActionsComponent, selector: "kendo-dialog-actions", inputs: ["actions", "layout"], outputs: ["action"] }] });
SessionExpiredComponent = __decorate([
    dataTransfer(['SessionExpired']),
    __metadata("design:paramtypes", [])
], SessionExpiredComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SessionExpiredComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-session-expired', inputs: ['model'], template: "<div *ngIf=\"model\">\r\n  <kendo-dialog [title]=\"title\" *ngIf=\"visible\">\r\n      <i class=\"material-icons warningIcon\">warning</i>\r\n      <p class=\"message\" style=\"margin: 30px; text-align: center;\">{{labelMessage}}</p>\r\n      <kendo-dialog-actions>\r\n          <button class='k-button' (click)=\"click($event)\">Ok</button>\r\n      </kendo-dialog-actions>\r\n  </kendo-dialog>\r\n</div>", styles: ["kendo-dialog{z-index:100000}.warningIcon{color:#b8860b;font-size:25px}.message{font-size:18px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { model: [{
                type: Input
            }] } });

/**
 *
 * @export
 * @class ObjectCollection
 */
class ObjectCollection {
    constructor(data) {
        this.data = data;
        this.data.forEach((value, index) => {
            this[index] = value;
        });
    }
    /**
     * Return the number of items items.count
     * @readonly
     * @type {number}
     * @memberof ObjectCollection
     */
    get count() {
        return this.data.length;
    }
}

/**
 *Allows selecting only one item.
 *Single = 0,
 *Allows selecting multiple items
 *Multiple = 1
 */
var SelectionMode$1;
(function (SelectionMode) {
    SelectionMode[SelectionMode["single"] = 0] = "single";
    SelectionMode[SelectionMode["multiple"] = 1] = "multiple";
})(SelectionMode$1 || (SelectionMode$1 = {}));
/**
 * ListBox Component this is an Angular Kendo jquery component .
 */
class ListBoxBaseComponent extends ControlComponent {
    /**
     * Binded functions are declared here.
     */
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ);
        this.service = service;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /**
         * Emit SelectedIndexChanged event
         */
        this.SelectedIndexChanged = new EventEmitter();
        /**
         * Mouse leave emitter of list box base component
         */
        this.MouseLeave = new EventEmitter();
        this.DoubleClick = new EventEmitter();
        this.defaultDataUrl = 'api/listbox';
        this.fetchItems = this.fetchItems.bind(this);
        this.refreshable = this.refreshable.bind(this);
        this.dataurlable = this.dataurlable.bind(this);
        this.selectableFun = this.selectableFun.bind(this);
        this.disabledKendo = this.disabledKendo.bind(this);
        this.applyVisible = this.applyVisible.bind(this);
        this.selectionChange = this.selectionChange.bind(this);
        this.dblClick = this.dblClick.bind(this);
        changeDetector.markForCheck();
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        this.isInitializing = true;
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    ngAfterViewInit() {
        if (this.listboxEl) {
            this.registerFunctions();
        }
        super.ngAfterViewInit();
        this.fetchItems();
        this.refresh = false;
        this.refreshSelectedIndices = false;
    }
    ngAfterViewChecked() {
        super.ngAfterViewChecked();
    }
    ngDoCheck() {
        super.ngDoCheck();
        if (this.refresh && !this.isInitializing) {
            this.fetchItems();
            this.refresh = false;
            this.refreshSelectedIndices = false;
        }
        if (this.refreshSelectedIndices && !this.isInitializing) {
            this.setSelected();
            this.refreshSelectedIndices = false;
        }
    }
    /**
     * Selectable function .
     * @param selection sel could be single or multiple in order to select listbox items.
     */
    selectableFun() {
        this.listboxEl['widget'].selectable.options.multiple =
            SelectionMode$1[this.selectionMode()];
    }
    /**
     * Disable listbox options.
     */
    disabledKendo() {
        this.listboxEl['widget'].enable('.k-item', this.enabled);
    }
    /**
     * Sets the new dataurl.
     * @param val This variable contains a custom url
     */
    dataurlable(val) {
        this.url = val;
    }
    /**
     * Refresh listbox.
     */
    refreshable() {
        this.fetchItems();
    }
    /**
     * show or hide the control.
     * @param value value from the model.Visible
     */
    applyVisible(value) {
        if (this.listboxEl && this.listboxEl['widget']) {
            if (value) {
                kendo.jQuery(this.listboxEl['widget'].wrapper).show();
            }
            else {
                kendo.jQuery(this.listboxEl['widget'].wrapper).hide();
            }
        }
    }
    /**
     * Fetch listbox items.
     * @property Items r
     */
    fetchItems() {
        this.service
            .fetch(this.url, this.id)
            .subscribe((data) => {
            this.items = new ObjectCollection(data);
            this.listboxEl['widget'].setDataSource(this.items);
            this.disabledKendo();
            this.selectableFun();
            this.setSelected();
            this.isInitializing = false;
        });
    }
    /**
     * return model selectable.
     */
    selectionMode() {
        return SelectionMode$1[this.model.SelectionMode];
    }
    /**
     * Get dataValueField of datasource items.
     */
    get dataValueField() {
        return this.model.DataValueField;
    }
    /**
     * Get dataTextField of datasource items.
     */
    get dataTextField() {
        return this.model.DataTextField;
    }
    /**
     * Get draggable property.
     */
    get draggable() {
        return this.model.Draggable;
    }
    /**
     * Set custom Url.
     * @param url custom url
     */
    set url(url) {
        this.dataUrl = url;
    }
    /**
     * Get custom or default Url.
     */
    get url() {
        if (this.dataUrl && this.dataUrl.length > 0) {
            return this.dataUrl;
        }
        return this.defaultDataUrl;
    }
    get refreshSelectedIndices() {
        return this.model.RefreshSelectedIndices;
    }
    set refreshSelectedIndices(value) {
        this.model.RefreshSelectedIndices = value;
    }
    /**
     * Set the array of SelectedIndices
     * @param indexes The indices
     */
    set selectedIndices(indexes) {
        this.model.SelectedIndices = indexes;
    }
    /**
     * Get the array of SelectedIndices
     */
    get selectedIndices() {
        return this.model.SelectedIndices;
    }
    /**
     *
     * Set the selectedIndex value.
     * @memberof ListBoxBaseComponent
     */
    set selectedIndex(value) {
        this.model.SelectedIndex = value;
        this.selectedIndices = [value];
        this.setSelected();
    }
    /**
     *
     * Get the SelectedIndex
     * @readonly
     * @type {number}
     * @memberof ListBoxBaseComponent
     */
    get selectedIndex() {
        return this.model.SelectedIndex;
    }
    /**
     * Return value used by the serverEvent function in order to determine if the dynamic event triggering should be cancelled
     */
    selectionChange(event) {
        if (!this.refresh && !this.refreshSelectedIndices) {
            this.selectedIndices = this.getSelectedIndexes(event);
            this.SelectedIndexChanged.emit(new EventData$1(event, this.id));
            return this.isInitializing;
        }
        else {
            return true;
        }
    }
    /**
     * Retrieve an array SelectedIndices
     */
    getSelectedIndexes(obj) {
        const itemIds = obj.sender.dataItems().map(function (val) {
            return val.uid;
        });
        return obj.sender
            .select()
            .toArray()
            .map(function (value) {
            return itemIds.indexOf(value.id);
        });
    }
    /*
     * Selects or clears the selection for the specified item in a ListBox.
     */
    setSelected() {
        this.disabledKendo();
        const reference = this.listboxEl['widget'];
        /* c8 ignore else */
        if (this.selectedIndices) {
            reference.clearSelection();
            this.selectedIndices.forEach((element) => {
                reference.select(reference.items()[element]);
            });
        }
    }
    registerFunctions() {
        this.listboxEl['registerFunction']('DataUrl', this.dataurlable);
        this.listboxEl['registerFunction']('Enabled', this.disabledKendo);
        this.listboxEl['registerFunction']('Selectable', this.selectableFun);
        this.listboxEl['registerFunction']('Refresh', this.refreshable);
        this.listboxEl['registerFunction']('Visible', this.applyVisible);
        this.registered = true;
    }
    mouseLeave(event) {
        this.MouseLeave.emit(new EventData$1(event, this.id));
    }
    dblClick(event) {
        this.DoubleClick.emit(new EventData$1(event, this.id));
    }
}
ListBoxBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListBoxBaseComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ListBoxBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ListBoxBaseComponent, selector: "ng-component", inputs: { dataUrl: "dataUrl" }, outputs: { SelectedIndexChanged: "SelectedIndexChanged", MouseLeave: "MouseLeave", DoubleClick: "DoubleClick" }, usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('RefreshSelectedIndices'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ListBoxBaseComponent.prototype, "refreshSelectedIndices", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SelectedIndices'),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], ListBoxBaseComponent.prototype, "selectedIndices", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SelectedIndex'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Object])
], ListBoxBaseComponent.prototype, "selectedIndex", null);
__decorate([
    serverEvent('SelectedIndexChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], ListBoxBaseComponent.prototype, "selectionChange", null);
__decorate([
    serverEvent('MouseLeave'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ListBoxBaseComponent.prototype, "mouseLeave", null);
__decorate([
    serverEvent('DoubleClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ListBoxBaseComponent.prototype, "dblClick", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListBoxBaseComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { SelectedIndexChanged: [{
                type: Output
            }], MouseLeave: [{
                type: Output
            }], DoubleClick: [{
                type: Output
            }], dataUrl: [{
                type: Input
            }], refreshSelectedIndices: [], selectedIndices: [], selectedIndex: [], selectionChange: [], mouseLeave: [], dblClick: [] } });

/**
 * ComboBoxBaseComponent .
 */
class ComboBoxBaseComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(service2, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.service2 = service2;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.SelectedValueChanged = new EventEmitter();
        this.DropDown = new EventEmitter();
        this.DropDownClosed = new EventEmitter();
        changeDetector.markForCheck();
    }
    /**
     * Trigger the selectedValueChanged Event
     */
    valueChange(event) {
        this.SelectedValueChanged.emit(new EventData$1(event, this.id));
    }
    /**
     * Trigger when the dropdownlist is openning
     * @param event parameters sends by the Jquery Component
     */
    open(event) {
        this.DropDown.emit(new EventData$1(event, this.id));
    }
    /**
     * Trigger when the dropdownlist is closing
     * @param event parameters sends by the Jquery Component
     */
    close(event) {
        this.DropDownClosed.emit(new EventData$1(event, this.id));
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
}
ComboBoxBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ComboBoxBaseComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ComboBoxBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ComboBoxBaseComponent, selector: "ng-component", outputs: { SelectedValueChanged: "SelectedValueChanged", DropDown: "DropDown", DropDownClosed: "DropDownClosed" }, usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    serverEvent('SelectedValueChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ComboBoxBaseComponent.prototype, "valueChange", null);
__decorate([
    serverEvent('DropDown'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ComboBoxBaseComponent.prototype, "open", null);
__decorate([
    serverEvent('DropDownClosed'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ComboBoxBaseComponent.prototype, "close", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ComboBoxBaseComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { SelectedValueChanged: [{
                type: Output
            }], DropDown: [{
                type: Output
            }], DropDownClosed: [{
                type: Output
            }], valueChange: [], open: [], close: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class SimpleAutoSizeComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, service, shortcutsService) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, shortcutsService);
        this.renderer2 = renderer2;
        this.containerInteraction = containerInteraction;
        this.service = service;
        this.shortcutsService = shortcutsService;
    }
    /* c8 ignore stop */
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    /**
     * Applies auto size property
     * For components with simple autosize behavior
     * like label, button that applies autosize according to the text inside
     */
    applyAutoSizeProperty() {
        if (!this.autoSizeApplied &&
            this.afterFirstCall &&
            this.autosize &&
            this.displayElement &&
            this.currentAutoSizeMode !== this.autosizemode &&
            !this.useCss) {
            this.currentAutoSizeMode = this.autosizemode;
            if (this.autosizemode === AutoSizeMode.GrowAndShrink) {
                this.renderer2.setStyle(this.displayElement, 'width', 'auto');
                this.renderer2.setStyle(this.displayElement, 'height', 'auto');
            }
            else {
                const currentRect = this.displayElement.getBoundingClientRect();
                this.renderer2.setStyle(this.displayElement, 'width', 'auto');
                this.renderer2.setStyle(this.displayElement, 'height', 'auto');
                const rectAuto = this.displayElement.getBoundingClientRect();
                if (rectAuto.width < this.width || rectAuto.width < currentRect.width) {
                    this.renderer2.setStyle(this.displayElement, 'width', `${this.width}px`);
                }
                if (rectAuto.width < this.height ||
                    rectAuto.height < currentRect.height) {
                    this.renderer2.setStyle(this.displayElement, 'height', `${this.height}px`);
                }
            }
            this.notifyParentAutoSize();
            this.autoSizeApplied = true;
        }
    }
}
SimpleAutoSizeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SimpleAutoSizeComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: i1.WebMapService, optional: true }, { token: ShortcutsService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SimpleAutoSizeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SimpleAutoSizeComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SimpleAutoSizeComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: i1.WebMapService, decorators: [{
                    type: Optional
                }] }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }]; } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class CustomControlContainerComponent extends ContainerComponent {
    /* c8 ignore next 3 */
    constructor(diff, service) {
        super(diff, service);
        this.diff = diff;
        this.service = service;
    }
    /**
     * Adds control
     * Overrides the original functionality
     * to load a generated components
     * Containers are now generated as individual components
     * in the migrated application this component should look up for them
     * and load into the corresponding site automatically.
     * @param id the id of the current tabpage
     */
    addControl(id) {
        this.service.getModel(id).then((model) => {
            this.individualComponent = false;
            const componentDT = this.getComponentKey(model);
            /* c8 ignore else */
            const componentType = TypeResolver.getType(componentDT);
            if (componentType) {
                this.loadComponentCustom(id, componentType, model, this.windowModel);
            }
            else {
                WMLogger.instance().error('Error in container. Component with id %s was missing', id);
            }
        });
    }
    /**
     * Loads the control component to the respective controlcontainer.
     * Similar behavior than the BaseComponents loadComponent. The difference is for the
     * newly individual components who needs the windowModel to be set.
     * @param id control container id
     * @param componentToLoad component to be loaded on control container
     * @param model control container model
     * @param windowModel form-window model
     */
    loadComponentCustom(id, componentToLoad, model, windowModel) {
        const componentRef = this.componentContainer.viewContainerRef.createComponent(componentToLoad);
        componentRef.instance.model = this.individualComponent
            ? windowModel
            : model;
        componentRef.instance.model.Parent = this.containerParent ?? model.Parent;
        componentRef.instance.windowModel = windowModel;
        this.openedComponents[id] = componentRef;
        super.assignIdToWebmapSelector(componentRef, model);
        componentRef.instance.ref.detectChanges();
        componentRef.changeDetectorRef.detectChanges();
    }
    /**
     * Function to return a DataTransfer standard for each different mapperId
     * as needed.
     * @param model control container model.
     */
    getComponentKey(model) {
        let keyId;
        if (!model.FormName) {
            return model.mapperId;
        }
        switch (model.mapperId) {
            case 'pnl':
                keyId = `${model.FormName}.panel.${model.Name}`;
                this.individualComponent = true;
                break;
            case 'tabpage':
                keyId = `${model.FormName}.tabpage.${this.containerParent}.${model.Name}`;
                this.individualComponent = true;
                break;
            default:
                keyId = model.mapperId;
        }
        return keyId;
    }
}
CustomControlContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CustomControlContainerComponent, deps: [{ token: i0.KeyValueDiffers }, { token: i1.WebMapService }], target: i0.ɵɵFactoryTarget.Component });
CustomControlContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: CustomControlContainerComponent, selector: "wm-custom-control-container", inputs: { controls: "controls", containerParent: "containerParent", windowModel: "windowModel", controlType: "controlType" }, usesInheritance: true, ngImport: i0, template: "<ng-container wm-content></ng-container>", styles: [""], dependencies: [{ kind: "directive", type: i3.ContainerDirective, selector: "[wm-content]", inputs: ["hostComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CustomControlContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-custom-control-container', inputs: ['controls'], template: "<ng-container wm-content></ng-container>" }]
        }], ctorParameters: function () { return [{ type: i0.KeyValueDiffers }, { type: i1.WebMapService }]; }, propDecorators: { containerParent: [{
                type: Input
            }], windowModel: [{
                type: Input
            }], controlType: [{
                type: Input
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Represent the current font style.
 */
var FontStyle;
(function (FontStyle) {
    /**
     * The normal style.
     */
    FontStyle[FontStyle["normal"] = 32] = "normal";
    /**
     * The regular style.
     */
    FontStyle[FontStyle["regular"] = 16] = "regular";
    /**
     * The bold style.
     */
    FontStyle[FontStyle["bold"] = 1] = "bold";
    /**
     * The italic style.
     */
    FontStyle[FontStyle["italic"] = 2] = "italic";
    /**
     * The underline style.
     */
    FontStyle[FontStyle["underline"] = 4] = "underline";
    /**
     * The strikeout style.
     */
    FontStyle[FontStyle["strikeout"] = 8] = "strikeout";
})(FontStyle || (FontStyle = {}));

/**
 * Provides data for the Scroll event
 *
 * @export
 * @class ScrollEventArgs
 */
class ScrollEventArgs {
    constructor(value) {
        this.MapperId = 'scrllvntrgs';
        this.NewValue = value.new;
        this.OldValue = value.old;
        this.ScrollOrientation = value.orientation;
        this.Type = value.type;
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Specifies the type of action used to raise the Scroll event.
 *
 * @export
 * @enum {number}
 */
var ScrollEventType;
(function (ScrollEventType) {
    /**
     *  The scroll box was moved a small distance. The user clicked the left(horizontal) or top(vertical) scroll arrow, or pressed the UP ARROW key.
     */
    ScrollEventType[ScrollEventType["SmallDecrement"] = 0] = "SmallDecrement";
    /**
     * The scroll box was moved a small distance. The user clicked the right(horizontal) or bottom(vertical) scroll arrow, or pressed the DOWN ARROW key.
     */
    ScrollEventType[ScrollEventType["SmallIncrement"] = 1] = "SmallIncrement";
    /**
     * The scroll box moved a large distance. The user clicked the scroll bar to the left(horizontal) or above(vertical) the scroll box, or pressed the PAGE UP key.
     */
    ScrollEventType[ScrollEventType["LargeDecrement"] = 2] = "LargeDecrement";
    /**
     * The scroll box moved a large distance. The user clicked the scroll bar to the right(horizontal) or below(vertical) the scroll box, or pressed the PAGE DOWN key.
     */
    ScrollEventType[ScrollEventType["LargeIncrement"] = 3] = "LargeIncrement";
    /**
     * The scroll box was moved.
     */
    ScrollEventType[ScrollEventType["ThumbPosition"] = 4] = "ThumbPosition";
    /**
     * The scroll box is currently being moved.
     */
    ScrollEventType[ScrollEventType["ThumbTrack"] = 5] = "ThumbTrack";
    /**
     * The scroll box was moved to the Minimum position.
     */
    ScrollEventType[ScrollEventType["First"] = 6] = "First";
    /**
     * The scroll box was moved to the Maximum position.
     */
    ScrollEventType[ScrollEventType["Last"] = 7] = "Last";
    /**
     * The scroll box has stopped moving.
     */
    ScrollEventType[ScrollEventType["EndScroll"] = 8] = "EndScroll";
})(ScrollEventType || (ScrollEventType = {}));

/**
 * Constants for the default values of the maximum, minimum and value properties;
 *
 * @memberof ScrollBarComponent
 */
const MinimumDefault = 0;
const MaximumDefault = 100;
const DefaultValue = 0;
const DefaultSmall = 1;
const DefaultLarge = 10;
/**
 * ScrollBar base component for HScrollBar and VScrollBar
 *
 * @export
 * @class ScrollBarComponent
 * @extends {ControlComponent}
 */
class ScrollBarComponent extends ControlComponent {
    /**
     * Creates an instance of ScrollBarComponent.
     * @param {ChangeDetectorRef} refChangeDetector
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} [bringTService]
     * @param {ContainerInteractionService} [contInteraction]
     * @memberof ScrollBarComponent
     */
    /* c8 ignore start */
    constructor(refChangeDetector, render2, elem, webComponents, bringTService, contInteraction) {
        super(refChangeDetector, render2, elem, webComponents, bringTService, contInteraction);
        this.refChangeDetector = refChangeDetector;
        this.render2 = render2;
        this.elem = elem;
        this.bringTService = bringTService;
        this.contInteraction = contInteraction;
        /* c8 ignore stop */
        /**
         * EventEmitter for the Scroll event, it triggers once the value of the component have been changed.
         *
         * @type {EventEmitter<EventData>}
         * @memberof ScrollBarComponent
         */
        this.Scroll = new EventEmitter();
    }
    /**
     * This property allows the control to know what is the value that have been changed.
     *
     * @readonly
     * @type {number}
     * @memberof ScrollBarComponent
     */
    get newValue() {
        return this.value;
    }
    /**
     * Setter of newValue property
     *
     * @memberof ScrollBarComponent
     */
    set newValue(value) {
        this.newValueInternal = value;
    }
    /**
     * A numeric value that is within the Minimum and Maximum range. The default value is 0.
     * It's used to know the place where the scroll bar moves.
     *
     * @readonly
     * @type {number}
     * @memberof ScrollBarComponent
     */
    get value() {
        return this.model.Value ?? DefaultValue;
    }
    /**
     * Setter of Value property
     *
     * @memberof ScrollBarComponent
     */
    set value(value) {
        this.model.Value = value > this.maximum ? this.maximum : value;
        this.model.Value =
            this.model.Value < this.minimum ? this.minimum : this.model.Value;
        this.newValue = this.model.Value;
    }
    /**
     * Gets or sets the value to be added to or subtracted from the Value property when the scroll box is moved a small distance.
     *
     * @readonly
     * @type {number}
     * @memberof ScrollBarComponent
     */
    get smallChange() {
        return this.model.SmallChange ?? DefaultSmall;
    }
    /**
     * Setter of Value property
     *
     * @memberof ScrollBarComponent
     */
    set smallChange(value) {
        this.model.SmallChange = value > 0 ? value : DefaultSmall;
    }
    /**
     * Gets or sets a value to be added to or subtracted from the Value property when the scroll box is moved a large distance.
     *
     * @readonly
     * @type {number}
     * @memberof ScrollBarComponent
     */
    get largeChange() {
        return this.model.largeChange ?? DefaultLarge;
    }
    /**
     * Setter of Value property
     *
     * @memberof ScrollBarComponent
     */
    set largeChange(value) {
        this.model.largeChange = value > 0 ? value : DefaultLarge;
    }
    /**
     * minimum value that the Value property can have, if the model doesnt have a minimum then the default value is 0.
     *
     * @readonly
     * @type {number}
     * @memberof ScrollBarComponent
     */
    get minimum() {
        return this.model.Minimum ?? MinimumDefault;
    }
    /**
     * Setter of the minimum property
     *
     * @memberof ScrollBarComponent
     */
    set minimum(value) {
        this.model.Minimum = value;
    }
    /**
     * Maximum value that the Value property can have, if the model doesnt have a maximum then the default value is 100.
     *
     * @readonly
     * @type {number}
     * @memberof ScrollBarComponent
     */
    get maximum() {
        return this.model.Maximum ?? MaximumDefault;
    }
    /**
     * Setter of the Maximum property
     *
     * @memberof ScrollBarComponent
     */
    set maximum(value) {
        this.model.Maximum = value;
    }
    /**
     * Event that triggers once the Value of the component have been changed.
     *
     * @param {*} event
     * @memberof ScrollBarComponent
     */
    valueChanged(event) {
        const step = Math.abs(this.newValueInternal - this.value);
        const switchVal = this.newValueInternal >= this.value ? 1 : -1;
        const eventValue = {
            new: this.value,
            old: this.value,
            orientation: this.orientation,
            type: 0
        };
        if (step > this.smallChange) {
            this.value = this.value + this.largeChange * switchVal;
            eventValue.type =
                switchVal == 1
                    ? ScrollEventType.LargeIncrement
                    : ScrollEventType.LargeDecrement;
        }
        else {
            this.value = this.newValueInternal;
            eventValue.type =
                switchVal == 1
                    ? ScrollEventType.SmallIncrement
                    : ScrollEventType.SmallDecrement;
        }
        eventValue.new = this.value;
        eventValue.type =
            this.maximum === this.value ? ScrollEventType.Last : eventValue.type;
        eventValue.type =
            this.minimum === this.value ? ScrollEventType.First : eventValue.type;
        this.scrollEventHandler(eventValue);
    }
    /**
     * Extractor for the event args of the Scroll event
     *
     * @static
     * @param {*} event
     * @param {ScrollBarComponent} component
     * @return {*}  {*}
     * @memberof ScrollBarComponent
     */
    static scrollEventArgsExtractor(event, component) {
        return [
            { Id: component.id, MapperId: component.model.mapperId },
            new ScrollEventArgs(event)
        ];
    }
    scrollEventHandler(eventData) {
        this.Scroll.emit(new ScrollEventArgs(eventData));
    }
}
ScrollBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ScrollBarComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ScrollBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ScrollBarComponent, selector: "ng-component", outputs: { Scroll: "Scroll" }, usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ScrollBarComponent.prototype, "value", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SmallChange'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ScrollBarComponent.prototype, "smallChange", null);
__decorate([
    MarkForCheck(),
    NotifyChange('LargeChange'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ScrollBarComponent.prototype, "largeChange", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Minimum'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ScrollBarComponent.prototype, "minimum", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Maximum'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ScrollBarComponent.prototype, "maximum", null);
__decorate([
    serverEvent('ScrollSequenceAction', ScrollBarComponent.scrollEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ScrollBarComponent.prototype, "scrollEventHandler", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ScrollBarComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { Scroll: [{
                type: Output
            }], value: [], smallChange: [], largeChange: [], minimum: [], maximum: [], scrollEventHandler: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * DialogBase Component this is an Angular Kendo jquery component .
 */
class DialogBaseComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(refChangeDetector, render2, elem, webComponents, bringTService, contInteraction) {
        super(refChangeDetector, render2, elem, webComponents, bringTService, contInteraction);
        this.refChangeDetector = refChangeDetector;
        this.render2 = render2;
        this.elem = elem;
        this.bringTService = bringTService;
        this.contInteraction = contInteraction;
    }
    /**
     * Initializes buttonClose field with the DialogBase's close element button.
     */
    initializeButtonCloseElement() {
        /* c8 ignore else */
        if (this.titleBar &&
            this.titleBar.hostElement &&
            this.titleBar.hostElement.nativeElement) {
            this.buttonClose =
                this.titleBar.hostElement.nativeElement.querySelector('.k-dialog-close');
        }
    }
}
DialogBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DialogBaseComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DialogBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DialogBaseComponent, selector: "ng-component", viewQueries: [{ propertyName: "titleBar", first: true, predicate: ["titleBar"], descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DialogBaseComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { titleBar: [{
                type: ViewChild,
                args: ['titleBar']
            }] } });

/**
 * TextBoxBaseComponent for base implementations of TextBoxComponent and MaskedTextBox
 */
class TextBoxBaseComponent extends ControlComponent {
    /**
     * Binded functions are declared here.
     */
    /* c8 ignore start */
    constructor(change12, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(change12, renderer2, element, webComponents, bringTopServ);
        this.change12 = change12;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
    }
    /* c8 ignore stop */
    /**
     * Select all the text in the input
     * Set selectionStart and selectionEnd properties
     */
    selectAll() {
        this.selectionStart = 0;
        this.selectionLength = this.text.length;
    }
    /**
     * Gets the modified property from the model
     *
     * @type {boolean}
     * @memberof TextBoxBaseComponent
     */
    get modified() {
        return !!this.model?.Modified;
    }
    /**
     * Sets the Modified property to the model
     *
     * @memberof TextBoxBaseComponent
     */
    set modified(value) {
        this.model.Modified = value;
    }
    /**
     * Set selectionStart property
     * @param value
     */
    set selectionStart(value) {
        this.model.SelectionStart = value;
    }
    /**
     * Gets selectionStart property
     */
    get selectionStart() {
        return this.model.SelectionStart ? this.model.SelectionStart : 0;
    }
    /**
     * Set selectionLength property
     * @param value
     */
    set selectionLength(value) {
        this.model.SelectionLength = value;
    }
    /**
     * Gets selectionLength property
     */
    get selectionLength() {
        return this.model.SelectionLength ? this.model.SelectionLength : 0;
    }
    /**
     * Gets a value indicating whether text in the text box is read-only.
     */
    get readOnly() {
        return this.model.ReadOnly;
    }
    /**
     * Sets a value indicating whether text in the text box is read-only.
     */
    set readOnly(value) {
        this.model.ReadOnly = value;
    }
    /**
     * Override of the method to include more conditions
     * @returns boolean
     */
    shouldApplyFocus() {
        return (this.isFocused && !(this.focusableElement?.disabled && this.model.Enabled));
    }
    /**
     * return the components classes.
     *
     * @readonly
     * @type {string}
     * @memberof TextBoxBaseComponent
     */
    get textBoxInputClass() {
        return `${this.class} ${this.readOnly ? 'readOnlyClass' : ''}`;
    }
}
TextBoxBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextBoxBaseComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TextBoxBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TextBoxBaseComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    NotifyChange('Modified'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], TextBoxBaseComponent.prototype, "modified", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SelectionStart'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], TextBoxBaseComponent.prototype, "selectionStart", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SelectionLength'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], TextBoxBaseComponent.prototype, "selectionLength", null);
__decorate([
    MarkForCheck(),
    NotifyChange('ReadOnly'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], TextBoxBaseComponent.prototype, "readOnly", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextBoxBaseComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { modified: [], selectionStart: [], selectionLength: [], readOnly: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class BackgroundWorkerComponent {
    /* c8 ignore next */
    constructor(wmService) {
        this.wmService = wmService;
        /**
         * Input  of background worker component url
         */
        this.url = '/bgw';
        this.retries = 2;
        this.MessageReceived = new EventEmitter();
    }
    /**
     * on init
     * Initialize the socket connection for the
     * background worker component
     */
    ngOnInit() {
        this.connection = new HubConnectionBuilder()
            .configureLogging(LogLevel.Information)
            .withUrl(this.url)
            .build();
        setTimeout(() => {
            /* c8 ignore next */
            this.connectionStart();
        }, 1000);
        /* c8 ignore next */
        this.connection.onclose((err) => {
            WMLogger.instance().error(
            /* c8 ignore next */
            `Closed Connection because: ${err ? err.toString() : ''}`);
            this.connectionStart();
        });
        this.InitMessageHandler();
    }
    /**
     * Messages received callback
     * A callback to add a custom handler for the server side response
     * @param response The server side response json
     */
    MessageReceivedCallback(response) {
        /* c8 ignore next */
        this.MessageReceived.emit(response);
    }
    /**
     * Connections start
     * Creates a new open connection
     */
    connectionStart() {
        /* c8 ignore next */
        this.connection
            .start()
            .then(() => {
            /* c8 ignore next */
            this.SendMessageSimpleCommand('BackgroundWorkerStarted', undefined);
        })
            .catch((err) => {
            /* c8 ignore next */
            WMLogger.instance().error(`Failed to connect: ${err ? err.toString() : ''}`);
            /* c8 ignore else */
            if (this.retries > 0) {
                setTimeout(() => {
                    this.connectionStart();
                }, 2000);
                this.retries--;
            }
        });
    }
    /**
     * Inits message handler
     * Adds Handler for the Socket messages
     */
    InitMessageHandler() {
        this.connection.on('BackgroundWorkerDoWork', (parameters) => {
            /* c8 ignore next */
            this.SendMessageSimpleCommand('BackgroundWorkerDoWork', [parameters]);
        });
        this.connection.on('BackgroundWorkerReadyCompleted', (parameters) => {
            /* c8 ignore next */
            this.SendMessageSimpleCommand('BackgroundWorkerCompleted', undefined);
        });
    }
    /**
     * Send socket messages
     */
    SendMessageSimpleCommand(actionName, parameters) {
        const requestConfig = new RequestConfig();
        requestConfig.headers[WebMapUtils.getNewAppHeader] = 'true';
        const id = sessionStorage.getItem(WMConstants.sessionStorageTabIdEntry);
        if (id) {
            requestConfig.headers[WMConstants.multiTabHeader] = id;
        }
        const actionModel = new ActionModelV5('', actionName, '', '', parameters, 
        /* c8 ignore next */
        (response) => this.MessageReceivedCallback(response));
        /* c8 ignore next */
        actionModel.requestConfig =
            requestConfig == null ? actionModel.requestConfig : requestConfig;
        this.wmService.sendAction(actionModel);
    }
}
BackgroundWorkerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BackgroundWorkerComponent, deps: [{ token: i1.WebMapService }], target: i0.ɵɵFactoryTarget.Component });
BackgroundWorkerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BackgroundWorkerComponent, selector: "wm-background-worker", inputs: { url: "url", retries: "retries" }, outputs: { MessageReceived: "MessageReceived" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BackgroundWorkerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'wm-background-worker',
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }]; }, propDecorators: { url: [{
                type: Input
            }], retries: [{
                type: Input
            }], MessageReceived: [{
                type: Output
            }] } });

var MonthCalendarComponent_1;
let MonthCalendarComponent = MonthCalendarComponent_1 = class MonthCalendarComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, service, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.service = service;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /**
         * Output to emit the event DateSelected
         *
         * @type {EventEmitter<EventData>}
         */
        this.DateSelected = new EventEmitter();
        /**
         * Qty of milliseconds in a minute
         */
        this.fixMilliseconds = 60000;
        /**
         * Value change event for backend date selection
         */
        this.focusedDate = new Date();
    }
    /**
     * DateSelected args extractor
     * @param event Event param
     * @param component MonthCalendar Component
     * @returns any
     */
    static DateSelectedExtractor(event, component) {
        return [
            {
                Id: event.id,
                MapperId: MonthCalendarComponent_1.monthCalendarMapperId
            },
            {
                MapperId: 'dtSldVntRgs',
                Start: event.args.start,
                End: event.args.end
            }
        ];
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        this.setCalendarParameters();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    /**
     * DoCheck life-cycle hook
     */
    ngDoCheck() {
        /* c8 ignore else */
        if (this.refresh) {
            this.setCalendarParameters();
            this.refresh = false;
        }
    }
    /**
     * Selection mode for calendar
     */
    get selectionMode() {
        return this.maxSelectionCount === 1 ? 'single' : 'multiple';
    }
    /**
     * Gets the qty of months to be displayed
     */
    get calendarDimensions() {
        /* c8 ignore else */
        if (this.model.CalendarDimensions !== undefined) {
            const calendarDimensions = this.model.CalendarDimensions.split(',');
            /* c8 ignore else */
            if (calendarDimensions.length > 1) {
                this.calendarColumns = parseInt(calendarDimensions[0].trim());
                this.calendarRows = parseInt(calendarDimensions[1].trim());
                return this.calendarColumns;
            }
        }
        return 1;
    }
    /**
     * Gets the enabled value from model
     */
    get enabled() {
        return this.model ? this.model.Enabled !== false : false;
    }
    /**
     * Gets BoldedDates from model
     */
    get boldedDates() {
        return this.model.BoldedDates ? this.model.BoldedDates : [];
    }
    /**
     * Gets the SelectionRange values from model to be applied in the component
     */
    get selectionRange() {
        const start = this.selectionStart !== null ? new Date(this.selectionStart) : null;
        const end = this.selectionEnd !== null ? new Date(this.selectionEnd) : null;
        /* c8 ignore else */
        if (start !== null && end !== null) {
            /* One day in milliseconds. */
            const oneDay = 1000 * 60 * 60 * 24;
            const selectionCount = Math.round((end.valueOf() - start.valueOf()) / oneDay);
            /* c8 ignore else */
            if (selectionCount > this.maxSelectionCount) {
                return { start: null, end: null };
            }
        }
        return { start: start, end: end };
    }
    /**
     * Sets the SelectionStart and SelectionEnd value into the model
     */
    set selectionRange(value) {
        this.selectionStart = value.start === null ? value.end : value.start;
        this.selectionEnd = value.end;
        this.dateSelected();
    }
    /**
     * Gets selection start date from model
     */
    get selectionStart() {
        return this.model.SelectionStart !== undefined &&
            this.model.SelectionStart !== ''
            ? this.model.SelectionStart
            : null;
    }
    /**
     * Sets selection start date from model
     */
    set selectionStart(value) {
        this.model.SelectionStart = value === null ? null : value.toISOString();
    }
    /**
     * Gets selection end date from model
     */
    get selectionEnd() {
        return this.model.SelectionEnd !== undefined &&
            this.model.SelectionEnd !== ''
            ? this.model.SelectionEnd
            : null;
    }
    /**
     * Sets selection end date
     */
    set selectionEnd(value) {
        this.model.SelectionEnd = value === null ? null : value.toISOString();
    }
    /**
     * Gets today date value from model
     */
    get todayDate() {
        return this.model.TodayDate !== undefined
            ? new Date(this.model.TodayDate)
            : new Date();
    }
    /**
     * Gets the minimum date in the calendar
     */
    get minDate() {
        return this.model.MinDate !== undefined
            ? new Date(this.model.MinDate)
            : new Date(1753, 1, 1);
    }
    /**
     * Gets the maximum date in the calendar
     */
    get maxDate() {
        return this.model.MaxDate !== undefined
            ? new Date(this.model.MaxDate)
            : new Date(9998, 12, 31);
    }
    /**
     * Gets the maximun quantity of day to select. Default qty is 1
     */
    get maxSelectionCount() {
        return this.model.MaxSelectionCount ? this.model.MaxSelectionCount : 1;
    }
    /**
     * Sets the calendar min and max date and focused date
     */
    setCalendarParameters() {
        // The values must be assigned into the component in this way
        // to avoid freeze the kendo component
        this.calendarMinDate = this.minDate;
        this.calendarMaxDate = this.maxDate;
        this.focusedDate =
            this.selectionStart !== null ? new Date(this.selectionStart) : null;
    }
    /**
     * Returns the css class for bolded dates and todays date if apply
     *
     * @param date The date to be evaluated
     * @returns The css class name for bolded dates otherwise empty
     */
    getCssClass(date) {
        let returnClass = '';
        /* c8 ignore else */
        if (this.isBoldedDate(date)) {
            returnClass = 'boldedDate';
        }
        /* c8 ignore else */
        if (this.isTodayDate(date)) {
            returnClass = `${returnClass} todayDate`;
        }
        return returnClass;
    }
    /**
     * Verifies if a date is a bolded date
     *
     * @param date The date to be evaluated
     * @returns True if the date is a bolded date otherwise false
     */
    isBoldedDate(date) {
        const result = this.boldedDates.filter((x) => new Date(x).toLocaleDateString() === date.toLocaleDateString());
        return result && result.length > 0;
    }
    /**
     * Verifies if a date is equals to todays date
     *
     * @param date The date to be evaluated
     * @returns True if the date is today otherwise false
     */
    isTodayDate(date) {
        return date.toLocaleDateString() === this.todayDate.toLocaleDateString();
    }
    /**
     * Calculates the start arg for dateSelected event
     *
     * @returns A date-start in ISO string format
     */
    dateSelectedStartArg() {
        if (this.selectionStart === null)
            return null;
        const tmpStart = new Date(this.selectionStart);
        // The new date must be adjusted with fixMilliseconds because new Date() creates a value with
        // local time because it doesn't contain any offset
        return new Date(tmpStart.getTime() - tmpStart.getTimezoneOffset() * this.fixMilliseconds).toISOString();
    }
    /**
     * Calculates the end arg for dateSelected event
     *
     * @returns A date-end in ISO string format
     */
    dateSelectedEndArg() {
        if (this.selectionEnd === null)
            return null;
        const tmpEnd = new Date(this.selectionEnd);
        // Add one day. Example: dd+1/mm/yy 00:00:00
        tmpEnd.setDate(tmpEnd.getDate() + 1);
        // Substract one second. Example dd/mm/yy 23:59:59
        tmpEnd.setSeconds(tmpEnd.getSeconds() - 1);
        // The new date must be adjusted with fixMilliseconds because new Date() creates a value with
        // local time because it doesn't contain any offset
        return new Date(tmpEnd.getTime() - tmpEnd.getTimezoneOffset() * this.fixMilliseconds).toISOString();
    }
    /**
     * DateSelect event
     */
    dateSelected() {
        const eventData = new EventData$1('DateSelected', this.id);
        const tmpStart = this.dateSelectedStartArg();
        const tmpEnd = this.dateSelectedEndArg();
        eventData.args = {
            start: tmpStart,
            end: tmpEnd
        };
        this.dateSelectedHandler(eventData);
    }
    /**
     * Value change event for kendo-multiviewcalendar single selection
     */
    valueChange(value) {
        const eventData = new EventData$1('DateSelected', this.id);
        // The new date must be adjusted with fixMilliseconds because new Date() creates a value with
        // local time because it doesn't contain any offset
        const tmpDate = new Date(value.getTime() - value.getTimezoneOffset() * this.fixMilliseconds).toISOString();
        eventData.args = {
            start: tmpDate,
            end: tmpDate
        };
        this.dateSelectedHandler(eventData);
    }
    /**
     * DateSelect handler
     *
     * @param event Event args
     */
    dateSelectedHandler(event) {
        this.DateSelected.emit(event);
    }
};
/* c8 ignore stop */
/**
 * MapperId value for current control
 */
MonthCalendarComponent.monthCalendarMapperId = 'monthclr';
MonthCalendarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MonthCalendarComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i1.WebMapService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
MonthCalendarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: MonthCalendarComponent, selector: "wm-monthcalendar", inputs: { model: "model" }, outputs: { DateSelected: "DateSelected" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\">\r\n    <kendo-multiviewcalendar *ngIf=\"selectionMode==='multiple'\" kendoDateRangeSelection [disabled]=!enabled\r\n        [max]=\"calendarMaxDate\" [min]=\"calendarMinDate\" [ngClass]=\"class\" [views]=\"calendarDimensions\"\r\n        [(selectionRange)]=\"selectionRange\" [value]=\"focusedDate\">\r\n        <ng-template kendoCalendarMonthCellTemplate let-date>\r\n            <span [ngClass]=\"getCssClass(date)\">{{date.getDate()}}</span>\r\n        </ng-template>\r\n    </kendo-multiviewcalendar>\r\n    <kendo-multiviewcalendar *ngIf=\"selectionMode==='single'\" [disabled]=!enabled [max]=\"calendarMaxDate\"\r\n        [min]=\"calendarMinDate\" [ngClass]=\"class\" [views]=\"calendarDimensions\" [selection]=\"selectionMode\"\r\n        (valueChange)=\"valueChange($event)\" [value]=\"focusedDate\">\r\n        <ng-template kendoCalendarMonthCellTemplate let-date>\r\n            <span [ngClass]=\"getCssClass(date)\">{{date.getDate()}}</span>\r\n        </ng-template>\r\n    </kendo-multiviewcalendar>\r\n</div>", styles: [".boldedDate{font-weight:800}.todayDate{color:#ff6358}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i6$1.MonthCellTemplateDirective, selector: "[kendoCalendarMonthCellTemplate]" }, { kind: "component", type: i6$1.MultiViewCalendarComponent, selector: "kendo-multiviewcalendar", inputs: ["id", "focusedDate", "min", "max", "rangeValidation", "disabledDatesRangeValidation", "selection", "value", "disabled", "tabindex", "tabIndex", "isActive", "disabledDates", "activeView", "bottomView", "topView", "showViewHeader", "animateNavigation", "weekNumber", "activeRangeEnd", "selectionRange", "views", "orientation", "cellTemplate", "monthCellTemplate", "yearCellTemplate", "decadeCellTemplate", "centuryCellTemplate", "weekNumberTemplate", "headerTitleTemplate"], outputs: ["activeViewChange", "navigate", "cellEnter", "cellLeave", "valueChange", "blur", "focus", "focusCalendar"], exportAs: ["kendo-multiviewcalendar"] }, { kind: "directive", type: i6$1.DateRangeSelectionDirective, selector: "[kendoDateRangeSelection]", inputs: ["autoCorrectOn", "selectionRange", "activeRangeEnd", "shouldSetRange"], outputs: ["activeRangeEndChange", "selectionRangeChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('SelectionStart'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], MonthCalendarComponent.prototype, "selectionStart", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SelectionEnd'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], MonthCalendarComponent.prototype, "selectionEnd", null);
__decorate([
    serverEvent('DateSelected', MonthCalendarComponent_1.DateSelectedExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EventData$1]),
    __metadata("design:returntype", void 0)
], MonthCalendarComponent.prototype, "dateSelectedHandler", null);
MonthCalendarComponent = MonthCalendarComponent_1 = __decorate([
    dataTransfer(['monthclr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        WebMapService,
        BringTopService,
        ContainerInteractionService])
], MonthCalendarComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MonthCalendarComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-monthcalendar', inputs: ['model'], template: "<div *ngIf=\"model\">\r\n    <kendo-multiviewcalendar *ngIf=\"selectionMode==='multiple'\" kendoDateRangeSelection [disabled]=!enabled\r\n        [max]=\"calendarMaxDate\" [min]=\"calendarMinDate\" [ngClass]=\"class\" [views]=\"calendarDimensions\"\r\n        [(selectionRange)]=\"selectionRange\" [value]=\"focusedDate\">\r\n        <ng-template kendoCalendarMonthCellTemplate let-date>\r\n            <span [ngClass]=\"getCssClass(date)\">{{date.getDate()}}</span>\r\n        </ng-template>\r\n    </kendo-multiviewcalendar>\r\n    <kendo-multiviewcalendar *ngIf=\"selectionMode==='single'\" [disabled]=!enabled [max]=\"calendarMaxDate\"\r\n        [min]=\"calendarMinDate\" [ngClass]=\"class\" [views]=\"calendarDimensions\" [selection]=\"selectionMode\"\r\n        (valueChange)=\"valueChange($event)\" [value]=\"focusedDate\">\r\n        <ng-template kendoCalendarMonthCellTemplate let-date>\r\n            <span [ngClass]=\"getCssClass(date)\">{{date.getDate()}}</span>\r\n        </ng-template>\r\n    </kendo-multiviewcalendar>\r\n</div>", styles: [".boldedDate{font-weight:800}.todayDate{color:#ff6358}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i1.WebMapService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { DateSelected: [{
                type: Output
            }], selectionStart: [], selectionEnd: [], dateSelectedHandler: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class ButtonStyle extends Style {
    setBackgroundImage(value) {
        const backgroundImage = 'background-image';
        if (value !== undefined) {
            this[backgroundImage] =
                value !== this[backgroundImage] ? value : this[backgroundImage];
        }
        else if (this['background-color'] !== undefined &&
            this['background-color'] !== null) {
            this[backgroundImage] = 'none';
        }
        else {
            this[backgroundImage] = undefined;
        }
    }
}

var ButtonComponent_1;
/**
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/button/button.html</example-url>
 */
let ButtonComponent = ButtonComponent_1 = class ButtonComponent extends SimpleAutoSizeComponent {
    static eventCallBack(context, event) {
        context.lock = 'auto';
        context.detectChanges();
    }
    /* c8 ignore start */
    constructor(changeDetector, rndr2, element, webComponents, bringTopServ, containerInteraction, service, baseValidatorService, wmWindowService, shortcutsService) {
        super(changeDetector, rndr2, element, webComponents, bringTopServ, containerInteraction, service, shortcutsService);
        this.changeDetector = changeDetector;
        this.rndr2 = rndr2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.service = service;
        this.baseValidatorService = baseValidatorService;
        this.wmWindowService = wmWindowService;
        this.shortcutsService = shortcutsService;
        this.Click = new EventEmitter();
        /**
         * Property that triggers the webForms validation.
         *
         * @memberof ButtonComponent
         */
        this.webFormsIntercepted = false;
        /**
         * Property that enables or disables the showing of the kendotooltip.
         *
         * @memberof ButtonComponent
         */
        this.showOn = 'none';
        /**
         * Property with the validation group.
         *
         * @memberof ButtonComponent
         */
        this.validationGroupInternal = '';
        /**
         * Flag to know if the button has the fakeFocus class
         *
         * @memberof ButtonComponent
         */
        this.fakeFocused = false;
        /**
         * Flag used to lock button when it is in the server, just to avoid multiples clicks request.
         */
        this.lock = 'auto';
        /**
         * Flag to permit or not OnClick event on WebForms
         */
        this.isClickStopped = false;
    }
    /* c8 ignore stop */
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    ngOnInit() {
        super.ngOnInit();
        this.shortcutsService?.registerInstance(this);
        /* c8 ignore next */
        this.windowClickSubscription =
            this.wmWindowService?.windowButtonActionEmitted.subscribe((event) => {
                if (this.id === event.Id) {
                    if ((event.args.action === 'AcceptButton' &&
                        (this.fakeFocused || this.isFocused)) ||
                        event.args.action === 'CancelButton') {
                        this.click(event.event);
                    }
                }
            });
        /* c8 ignore next */
        this.windowFocusButtonSubscription =
            this.wmWindowService?.buttonFakeFocusEmitted.subscribe((event) => {
                if (event.Id === this.id) {
                    this.applyFocusClass();
                }
            });
        /* c8 ignore next */
        this.wmWindowService?.removeFakeFocusEmitted.subscribe((event) => {
            this.removeFakeFocusClass();
        });
        /* c8 ignore next */
        this.wmWindowService?.applyFakeFocusEmitted.subscribe((event) => {
            if (this.id === event.Id) {
                this.applyFocusClass();
            }
        });
        this.style = this.getStyle();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.shortcutsService?.unregisterInstance(this);
        if (this.windowClickSubscription) {
            this.service.core.getEvent().unSubscribe(this.windowClickSubscription);
        }
        if (this.windowFocusButtonSubscription) {
            this.service.core
                .getEvent()
                .unSubscribe(this.windowFocusButtonSubscription);
        }
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        const eventData = new EventData$1({}, this.id);
        eventData['args'] = {};
        eventData.args['action'] = 'AcceptButtonCreated';
        this.wmWindowService?.notifyAcceptButtonCreated(eventData);
    }
    /**
     * Sets/gets the validationGroup property
     *
     * @memberof ButtonComponent
     */
    set validationGroup(value) {
        this.validationGroupInternal = value;
    }
    get validationGroup() {
        return this.model.ValidationGroup ?? this.validationGroupInternal;
    }
    get primary() {
        return this.model.isPrimary;
    }
    set primary(value) {
        this.model.isPrimary = value;
    }
    /**
     * Gets the image that is displayed on a button control.
     */
    get image() {
        return this.model.Image;
    }
    /**
     * Sets the image that is displayed on a button control.
     */
    set image(value) {
        this.model.Image = value;
    }
    set text(value) {
        this.model.Text = value;
    }
    /**
     * Override the property Text to remove the ampersand
     */
    get text() {
        return RemoveAmpersand.remove(this.model.Text, this.showUnderline);
    }
    /**
     * Inherited Style.
     */
    getStyle() {
        return new ButtonStyle();
    }
    /**
     * Method to override the applyFocus
     *
     * This is to remove the initial fake focus for the accept button on a window
     *
     * @memberof ButtonComponent
     */
    applyFocus() {
        const eventData = new EventData$1({}, this.id);
        /* c8 ignore next */
        this.wmWindowService?.notifyWindowButtonFocused(eventData);
        super.applyFocus();
    }
    click(event) {
        /* c8 ignore next */
        if (this.lock === 'auto') {
            this.lock = this.isBindedEvent('Click') ? 'none' : 'auto';
            this.webFormsIntercepted = true;
            /* c8 ignore else */
            if (!this.isClickStopped) {
                this.Click.emit(new EventData$1(event, this.id));
            }
        }
    }
    /**
     * Override the control.component checkErrorProvider to set showOn on hover if there's any error.
     *
     * @memberof ButtonComponent
     */
    checkErrorProvider() {
        super.checkErrorProvider();
        this.showOn =
            this.model.ErrorProviderMessage?.length > 0 || this.tooltip.length > 0
                ? 'hover'
                : 'none';
    }
    /**
     * Remove the fake focus class from button
     *
     * @memberof ButtonComponent
     */
    removeFakeFocusClass() {
        if (this.fakeFocused) {
            this.fakeFocused = false;
            this.rndr2.removeClass(this.displayElement, 'fake-focused');
        }
    }
    /**
     * Method to apply the fake focused style for the accept button of a window
     *
     * @memberof ButtonComponent
     */
    applyFocusClass() {
        this.rndr2.addClass(this.displayElement, 'fake-focused');
        this.fakeFocused = true;
    }
    /**
     * Gets string indicating the type
     * @returns type
     */
    getType() {
        return 'ButtonComponent';
    }
};
ButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ButtonComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: i1.WebMapService, optional: true }, { token: BaseValidatorService, optional: true }, { token: WMWindowService, optional: true }, { token: ShortcutsService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ButtonComponent, selector: "wm-button", inputs: { model: "model" }, outputs: { Click: "Click" }, viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }, { propertyName: "controlDirective", first: true, predicate: ControlsDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div kendoTooltip [showOn]=\"showOn\">\r\n  <button #displayElement *ngIf=\"model\" kendoButton [disabled]=\"disabled\" [imageUrl]=\"image\" [ngClass]=\"class\"\r\n    [ngStyle]=\"setMyStyle()\" [style.pointer-events]=\"lock\" (click)=\"click($event)\" wmControls\r\n    [hostComponent]=\"this\"> <span [innerHTML]=\"text\"></span></button>\r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i6$2.Button, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }, { kind: "directive", type: i10.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('Image'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ButtonComponent.prototype, "image", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Text'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ButtonComponent.prototype, "text", null);
__decorate([
    serverEvent('Click', null, null, ButtonComponent_1.eventCallBack),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ButtonComponent.prototype, "click", null);
ButtonComponent = ButtonComponent_1 = __decorate([
    dataTransfer(['btn']),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService,
        WebMapService,
        BaseValidatorService,
        WMWindowService,
        ShortcutsService])
], ButtonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-button', inputs: ['model'], template: "<div kendoTooltip [showOn]=\"showOn\">\r\n  <button #displayElement *ngIf=\"model\" kendoButton [disabled]=\"disabled\" [imageUrl]=\"image\" [ngClass]=\"class\"\r\n    [ngStyle]=\"setMyStyle()\" [style.pointer-events]=\"lock\" (click)=\"click($event)\" wmControls\r\n    [hostComponent]=\"this\"> <span [innerHTML]=\"text\"></span></button>\r\n</div>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: i1.WebMapService, decorators: [{
                    type: Optional
                }] }, { type: BaseValidatorService, decorators: [{
                    type: Optional
                }] }, { type: WMWindowService, decorators: [{
                    type: Optional
                }] }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], controlDirective: [{
                type: ViewChild,
                args: [ControlsDirective]
            }], Click: [{
                type: Output
            }], image: [], text: [], click: [] } });

/**
 * Angular Component for the Chart Control.
 *
 * @export
 * @class ChartComponent
 * @extends { ControlComponent }
 */
let ChartComponent = class ChartComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, webComponents) {
        super(changeDetector, renderer2, element, webComponents);
        this.service = service;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        /* c8 ignore stop */
        this.loading = false;
        this.defaultDataUrl = 'api/chart';
        this.areas = [];
        this.legends = [];
        this.series = [];
        this.titles = [];
        this.charts = [];
        this.seriesColors = Object.values(ChartColor);
    }
    /**
     * Returns the data source URL of this component.
     *
     * @memberof ChartComponent
     * @type {string}
     */
    get url() {
        /* c8 ignore else */
        if (this.dataUrl && this.dataUrl.length > 0) {
            return this.dataUrl;
        }
        return this.defaultDataUrl;
    }
    /**
     * Angular lifecycle
     *
     * @memberof ChartComponent
     */
    ngOnInit() {
        super.ngOnInit();
        /* c8 ignore else */
        if (this.model) {
            this.fetchItems();
            this.refresh = false;
        }
    }
    /**
     * Checks if a Refresh is required
     *
     * @memberof ChartComponent
     */
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore else */
        if (this.refresh) {
            this.fetchItems();
            this.refresh = false;
        }
    }
    /**
     * Fetchs items
     *
     * @memberof ChartComponent
     */
    fetchItems() {
        this.loading = true;
        this.service
            .fetch(this.url, this.model.id)
            .subscribe(this.loadData.bind(this));
    }
    /**
     * Load data
     *
     * @memberof ChartComponent
     * @param {any} data
     */
    loadData(data) {
        this.areas = data.ChartAreas;
        this.legends = data.Legends;
        this.series = data.Series;
        this.titles = data.Titles;
        this.charts = [];
        this.areas.forEach((area, areaIdx) => {
            const chart = {
                series: this.loadSeries(area, areaIdx)
            };
            this.charts.push(chart);
        });
        this.loading = false;
        this.detectChanges();
    }
    /**
     * Load series for each chart area
     *
     * @memberof ChartComponent
     * @param {any} area
     * @param {number} areaIdx
     */
    loadSeries(area, areaIdx) {
        return this.series
            .filter((serie) => {
            return ((serie.chararea && serie.chararea === area.name) ||
                (!serie.chararea && areaIdx === 0));
        })
            .map((serie) => {
            return {
                name: serie.name,
                type: ChartType[serie.charttype],
                data: serie.points.map((point, index) => {
                    // Validates the color value
                    const defaultColor = this.seriesColors.length > index ? this.seriesColors[index] : '';
                    point.color = this.isValidColor(point.color)
                        ? point.color
                        : defaultColor;
                    return {
                        label: point.label,
                        value: point.yvalues?.length ? point.yvalues[0] : point.yvalues,
                        color: this.isValidColor(point.color) ? point.color : defaultColor
                    };
                }),
                labels: {
                    content: (e) => {
                        return e.dataItem.label;
                    },
                    position: 'center',
                    visible: true
                }
            };
        });
    }
    /**
     * Get style for position of element
     *
     * @memberof ChartComponent
     * @param {any} element
     */
    getElementPosition(element) {
        const style = new Style();
        style.setWidth(element.width ? element.width + '%' : '');
        style.setHeight(element.height ? element.height + '%' : '');
        style.setTop((element.y ?? 0) + '%');
        style.setLeft((element.x ?? 0) + '%');
        style['position'] = element.y || element.x ? 'absolute' : 'relative';
        return style;
    }
    /**
     * Validate if a string is a valid color
     *
     * @memberof ChartComponent
     * @param {string} strColor
     * @returns {boolean}
     */
    isValidColor(strColor) {
        const s = new Option().style;
        s.color = strColor;
        return s.color !== '';
    }
};
ChartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ChartComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }], target: i0.ɵɵFactoryTarget.Component });
ChartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ChartComponent, selector: "wm-chart", inputs: { dataUrl: "dataUrl" }, usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\" *ngIf=\"!loading\">\r\n    <div class=\"chart-container\">\r\n        <!-- Titles -->\r\n        <div class=\"titles\">\r\n            <strong class=\"title\" *ngFor=\"let title of titles\" [ngStyle]=\"getElementPosition(title)\">\r\n                {{ title.text }}\r\n            </strong>\r\n        </div>\r\n        <!-- Content -->\r\n        <div class=\"chart-content\">\r\n            <!-- Chart Areas -->\r\n            <div class=\"areas\">\r\n                <div class=\"area\" *ngFor=\"let area of areas; let idx=index\" [ngStyle]=\"getElementPosition(area)\">\r\n                    <kendo-chart [series]=\"charts[idx].series\" [seriesColors]=\"seriesColors\">\r\n                    </kendo-chart>\r\n                </div>\r\n            </div>\r\n            <!-- Legends -->\r\n            <div class=\"legends\">\r\n                <ng-container *ngFor=\"let legend of legends\">\r\n                    <div class=\"legend\" [ngStyle]=\"getElementPosition(legend)\" *ngIf=\"legend.enabled\">\r\n                        <h4 class=\"title\" *ngIf=\"legend.title\">{{ legend.title }}</h4>\r\n                        <div class=\"series\">\r\n                            <div class=\"serie\" *ngFor=\"let serie of series;let idx = index\">\r\n                                <div class=\"points\" *ngIf=\"serie.legend === legend.name || (!serie.legend && idx === 0)\">\r\n                                    <div\r\n                                        class=\"point\"\r\n                                        [title]=\"point.legendtooltip ? point.legendtooltip : ''\"\r\n                                        *ngFor=\"let point of serie.points\">\r\n                                        <span class=\"color\" [ngStyle]=\"{ 'background-color': point.color }\"></span>\r\n                                        <span>{{ point.legendtext ? point.legendtext : point.label }}</span>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>", styles: [".chart-container{width:100%;height:100%;display:flex;flex-direction:column;padding:1%;box-sizing:border-box;position:relative}.chart-container .titles{display:flex;flex-direction:column;flex:none}.chart-container .titles .title{z-index:1;text-align:center;overflow:hidden}.chart-container .chart-content,.chart-container .chart-content .areas{display:flex;flex-grow:1}.chart-container .chart-content .areas .area{width:100%;height:100%;z-index:0;overflow:hidden}.chart-container .chart-content .areas .area kendo-chart{width:100%;height:100%;border:none;z-index:0}.chart-container .chart-content .legends{display:flex;flex:none}.chart-container .chart-content .legends .legend{display:flex;flex-direction:column;z-index:1;overflow:hidden}.chart-container .chart-content .legends .legend .series{display:flex}.chart-container .chart-content .legends .legend .series .serie{display:flex;width:100%}.chart-container .chart-content .legends .legend .series .serie .points{display:flex;width:100%;flex-direction:column}.chart-container .chart-content .legends .legend .series .serie .points .point{display:flex;flex-direction:row}.chart-container .chart-content .legends .legend .series .serie .points .point .color{height:10px;width:10px;margin:1px;display:block}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i4.ChartComponent, selector: "kendo-chart", inputs: ["pannable", "renderAs", "seriesColors", "subtitle", "title", "transitions", "zoomable", "axisDefaults", "categoryAxis", "chartArea", "legend", "panes", "paneDefaults", "plotArea", "series", "seriesDefaults", "tooltip", "valueAxis", "xAxis", "yAxis", "resizeRateLimit", "popupSettings"], outputs: ["axisLabelClick", "drag", "dragEnd", "dragStart", "legendItemHover", "legendItemLeave", "noteClick", "noteHover", "noteLeave", "paneRender", "plotAreaClick", "plotAreaHover", "plotAreaLeave", "render", "select", "selectEnd", "selectStart", "seriesClick", "seriesHover", "seriesOver", "seriesLeave", "zoom", "zoomEnd", "zoomStart", "legendItemClick"], exportAs: ["kendoChart"] }] });
ChartComponent = __decorate([
    dataTransfer(['chrt']),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService])
], ChartComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ChartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-chart', template: "<div [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\" *ngIf=\"!loading\">\r\n    <div class=\"chart-container\">\r\n        <!-- Titles -->\r\n        <div class=\"titles\">\r\n            <strong class=\"title\" *ngFor=\"let title of titles\" [ngStyle]=\"getElementPosition(title)\">\r\n                {{ title.text }}\r\n            </strong>\r\n        </div>\r\n        <!-- Content -->\r\n        <div class=\"chart-content\">\r\n            <!-- Chart Areas -->\r\n            <div class=\"areas\">\r\n                <div class=\"area\" *ngFor=\"let area of areas; let idx=index\" [ngStyle]=\"getElementPosition(area)\">\r\n                    <kendo-chart [series]=\"charts[idx].series\" [seriesColors]=\"seriesColors\">\r\n                    </kendo-chart>\r\n                </div>\r\n            </div>\r\n            <!-- Legends -->\r\n            <div class=\"legends\">\r\n                <ng-container *ngFor=\"let legend of legends\">\r\n                    <div class=\"legend\" [ngStyle]=\"getElementPosition(legend)\" *ngIf=\"legend.enabled\">\r\n                        <h4 class=\"title\" *ngIf=\"legend.title\">{{ legend.title }}</h4>\r\n                        <div class=\"series\">\r\n                            <div class=\"serie\" *ngFor=\"let serie of series;let idx = index\">\r\n                                <div class=\"points\" *ngIf=\"serie.legend === legend.name || (!serie.legend && idx === 0)\">\r\n                                    <div\r\n                                        class=\"point\"\r\n                                        [title]=\"point.legendtooltip ? point.legendtooltip : ''\"\r\n                                        *ngFor=\"let point of serie.points\">\r\n                                        <span class=\"color\" [ngStyle]=\"{ 'background-color': point.color }\"></span>\r\n                                        <span>{{ point.legendtext ? point.legendtext : point.label }}</span>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>", styles: [".chart-container{width:100%;height:100%;display:flex;flex-direction:column;padding:1%;box-sizing:border-box;position:relative}.chart-container .titles{display:flex;flex-direction:column;flex:none}.chart-container .titles .title{z-index:1;text-align:center;overflow:hidden}.chart-container .chart-content,.chart-container .chart-content .areas{display:flex;flex-grow:1}.chart-container .chart-content .areas .area{width:100%;height:100%;z-index:0;overflow:hidden}.chart-container .chart-content .areas .area kendo-chart{width:100%;height:100%;border:none;z-index:0}.chart-container .chart-content .legends{display:flex;flex:none}.chart-container .chart-content .legends .legend{display:flex;flex-direction:column;z-index:1;overflow:hidden}.chart-container .chart-content .legends .legend .series{display:flex}.chart-container .chart-content .legends .legend .series .serie{display:flex;width:100%}.chart-container .chart-content .legends .legend .series .serie .points{display:flex;width:100%;flex-direction:column}.chart-container .chart-content .legends .legend .series .serie .points .point{display:flex;flex-direction:row}.chart-container .chart-content .legends .legend .series .serie .points .point .color{height:10px;width:10px;margin:1px;display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }]; }, propDecorators: { dataUrl: [{
                type: Input
            }] } });

let AdoDataControlComponent = class AdoDataControlComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(webmapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.webmapService = webmapService;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.FirstClick = new EventEmitter();
        this.LastClick = new EventEmitter();
        this.PreviousClick = new EventEmitter();
        this.NextClick = new EventEmitter();
    }
    /**
     * Moves the associated record to the first row.
     * @param event The event object.
     */
    firstClick(event) {
        this.FirstClick.emit(new EventData$1(event, this.id));
    }
    /**
     * Moves the associated record to the previous row.
     * @param event The event object.
     */
    prevClick(event) {
        this.PreviousClick.emit(new EventData$1(event, this.id));
    }
    /**
     * Moves the associated record to the next row.
     * @param event The event object.
     */
    nextClick(event) {
        this.NextClick.emit(new EventData$1(event, this.id));
    }
    /**
     * Move the associated record to the last row.
     * @param event The event object.
     */
    lastClick(event) {
        this.LastClick.emit(new EventData$1(event, this.id));
    }
};
AdoDataControlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AdoDataControlComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
AdoDataControlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AdoDataControlComponent, selector: "wm-adodatacontrol", inputs: { model: "model", hostComponent: "hostComponent" }, outputs: { FirstClick: "FirstClick", LastClick: "LastClick", PreviousClick: "PreviousClick", NextClick: "NextClick" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\" class=\"adodc\" [ngClass]=\"class\" wmControls [hostComponent] = \"this\"  >\r\n    <button class=\"b_first\" kendoButton (click)=\"firstClick($event)\"><i class=\"material-icons\">skip_previous</i></button>\r\n    <button class=\"b_prev\" kendoButton (click)=\"prevClick($event)\"><i class=\"material-icons icon-flipped\">play_arrow</i></button>\r\n    <input class=\"l_caption\" type=\"text\" kendoTextBox [value]=\"text\" readonly=\"true\" />\r\n    <button class=\"b_next\" kendoButton (click)=\"nextClick($event)\"><i class=\"material-icons\">play_arrow</i></button>\r\n    <button class=\"b_last\" kendoButton (click)=\"lastClick($event)\"><i class=\"material-icons\">skip_next</i></button>\r\n</div>", styles: [".icon-flipped{transform:scaleX(-1)}.b_first{float:left;min-width:18px;width:15%;height:100%;background-image:url(/Resources/images/b_first.png);background-repeat:no-repeat;background-position:center;box-sizing:border-box}.b_prev{float:left;min-width:18px;width:15%;height:100%;background-image:url(/Resources/images/b_prev.png);background-repeat:no-repeat;background-position:center;box-sizing:border-box}.l_caption{float:left;width:40%;height:100%;border:hidden;text-align:center;vertical-align:middle;padding-top:1%}.b_next{float:left;min-width:18px;width:15%;height:100%;background-image:url(/resources/images/b_next.png);background-repeat:no-repeat;background-position:center;box-sizing:border-box}.b_last{float:left;min-width:18px;width:15%;height:100%;background-image:url(/resources/images/b_last.png);background-repeat:no-repeat;background-position:center;box-sizing:border-box}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6$2.Button, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }, { kind: "directive", type: i8.TextBoxDirective, selector: "input[kendoTextBox]", inputs: ["value"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    serverEvent('FirstClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdoDataControlComponent.prototype, "firstClick", null);
__decorate([
    serverEvent('PreviousClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdoDataControlComponent.prototype, "prevClick", null);
__decorate([
    serverEvent('NextClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdoDataControlComponent.prototype, "nextClick", null);
__decorate([
    serverEvent('LastClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdoDataControlComponent.prototype, "lastClick", null);
AdoDataControlComponent = __decorate([
    dataTransfer(['adodc']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], AdoDataControlComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AdoDataControlComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-adodatacontrol', inputs: ['model'], template: "<div *ngIf=\"model\" class=\"adodc\" [ngClass]=\"class\" wmControls [hostComponent] = \"this\"  >\r\n    <button class=\"b_first\" kendoButton (click)=\"firstClick($event)\"><i class=\"material-icons\">skip_previous</i></button>\r\n    <button class=\"b_prev\" kendoButton (click)=\"prevClick($event)\"><i class=\"material-icons icon-flipped\">play_arrow</i></button>\r\n    <input class=\"l_caption\" type=\"text\" kendoTextBox [value]=\"text\" readonly=\"true\" />\r\n    <button class=\"b_next\" kendoButton (click)=\"nextClick($event)\"><i class=\"material-icons\">play_arrow</i></button>\r\n    <button class=\"b_last\" kendoButton (click)=\"lastClick($event)\"><i class=\"material-icons\">skip_next</i></button>\r\n</div>", styles: [".icon-flipped{transform:scaleX(-1)}.b_first{float:left;min-width:18px;width:15%;height:100%;background-image:url(/Resources/images/b_first.png);background-repeat:no-repeat;background-position:center;box-sizing:border-box}.b_prev{float:left;min-width:18px;width:15%;height:100%;background-image:url(/Resources/images/b_prev.png);background-repeat:no-repeat;background-position:center;box-sizing:border-box}.l_caption{float:left;width:40%;height:100%;border:hidden;text-align:center;vertical-align:middle;padding-top:1%}.b_next{float:left;min-width:18px;width:15%;height:100%;background-image:url(/resources/images/b_next.png);background-repeat:no-repeat;background-position:center;box-sizing:border-box}.b_last{float:left;min-width:18px;width:15%;height:100%;background-image:url(/resources/images/b_last.png);background-repeat:no-repeat;background-position:center;box-sizing:border-box}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { hostComponent: [{
                type: Input
            }], FirstClick: [{
                type: Output
            }], LastClick: [{
                type: Output
            }], PreviousClick: [{
                type: Output
            }], NextClick: [{
                type: Output
            }], firstClick: [], prevClick: [], nextClick: [], lastClick: [] } });

/**
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/label/label.html</example-url>
 */
let LabelComponent = class LabelComponent extends SimpleAutoSizeComponent {
    /* c8 ignore start */
    constructor(changeDetector, rndr2, element, webComponents, bringTopServ, containerInteraction, service, shortcutsService) {
        super(changeDetector, rndr2, element, webComponents, bringTopServ, containerInteraction, service, shortcutsService);
        this.changeDetector = changeDetector;
        this.rndr2 = rndr2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.service = service;
        this.shortcutsService = shortcutsService;
        /* c8 ignore stop */
        this.Click = new EventEmitter();
        this.DoubleClick = new EventEmitter();
        this.MouseEnter = new EventEmitter();
        this.MouseLeave = new EventEmitter();
    }
    set displayElementLabel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /**
     * Get the class of the label.
     */
    getClassForLabel() {
        return `${this.class} ${this.newBorderStyleClass()} ${this.getTextAligmentClass()} ${this.wrapTextClass()}`;
    }
    /**
     * Gets image
     */
    get image() {
        return this.model.Image;
    }
    /**
     * Get BorderStyle property of the label.
     */
    get borderStyle() {
        return this.model.BorderStyle != null
            ? this.model.BorderStyle
            : BorderStyle.None;
    }
    /**
     * set the model.BorderStyle
     * @memberof LabelComponent
     */
    set borderStyle(borderStyle) {
        if (borderStyle >= 0) {
            this.model.BorderStyle = borderStyle;
        }
        else {
            this.model.BorderStyle = BorderStyle.None;
        }
    }
    /**
     * Gets the text alignment from model
     *
     * @returns number. Default value 1
     */
    get textAlign() {
        return this.model.TextAlign ? this.model.TextAlign : 1;
    }
    /**
     * Gets the new value of class based on BorderStyle.
     */
    newBorderStyleClass() {
        let border = '';
        if (this.borderStyle && this.borderStyle === BorderStyle.Fixed3D) {
            border = 'fixed3D';
        }
        return border;
    }
    /**
     * Gets the wrap text class if the autosize is true
     */
    wrapTextClass() {
        let wrapText = '';
        /* c8 ignore else */
        if (!this.autosize) {
            wrapText = 'wrapText';
        }
        return wrapText;
    }
    /**
     * Gets the class name for contentAlignment
     * @returns string
     */
    getTextAligmentClass() {
        switch (this.textAlign) {
            case ContentAlignment.TopLeft:
                return 'topLeft';
            case ContentAlignment.TopCenter:
                return 'topCenter';
            case ContentAlignment.TopRight:
                return 'topRight';
            case ContentAlignment.MiddleLeft:
                return 'middleLeft';
            case ContentAlignment.MiddleCenter:
                return 'middleCenter';
            case ContentAlignment.MiddleRight:
                return 'middleRight';
            case ContentAlignment.BottomLeft:
                return 'bottomLeft';
            case ContentAlignment.BottomCenter:
                return 'bottomCenter';
            case ContentAlignment.BottomRight:
                return 'bottomRight';
        }
        return null;
    }
    /**
     * Override the property Text to remove the ampersand
     */
    get text() {
        return Utils.removeLabelSpecial(Utils.toHtmlEntities(this.model.Text), this.showUnderline);
    }
    set text(value) {
        this.model.Text = Utils.fromHtmlEntities(value);
        this.markForCheck();
    }
    /**
     * Servers event
     * @param event the current event javascript object
     */
    click(event) {
        this.Click.emit(new EventData$1(event, this.id));
        Utils.preventPropagation(event);
    }
    /**
     * Handles the double click event.
     * @param event The event object.
     */
    doubleClick(event) {
        this.DoubleClick.emit(new EventData$1(event, this.id));
    }
    /**
     * Handles the mouseEnter event
     * @param event The event object from the DOM.
     */
    mouseEnterHandler(event) {
        this.MouseEnter.emit(new EventData$1(event, this.id));
    }
    /**
     * Handles the mouseLeave event
     * @param event The event object from the DOM.
     */
    mouseLeaveHandler(event) {
        this.MouseLeave.emit(new EventData$1(event, this.id));
    }
    /**
     * Angular lifecycle
     *
     * @memberof LabelComponent
     */
    ngOnInit() {
        super.ngOnInit();
        this.shortcutsService?.registerInstance(this);
    }
    /**
     * Angular lifecycle
     *
     * @memberof LabelComponent
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.shortcutsService?.unregisterInstance(this);
    }
    /**
     * Gets string indicating the type
     * @returns type
     */
    getType() {
        return 'LabelComponent';
    }
};
LabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LabelComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: i1.WebMapService, optional: true }, { token: ShortcutsService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
LabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: LabelComponent, selector: "wm-label", inputs: { model: "model" }, outputs: { Click: "Click", DoubleClick: "DoubleClick", MouseEnter: "MouseEnter", MouseLeave: "MouseLeave" }, viewQueries: [{ propertyName: "displayElementLabel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div kendoTooltip showOn=\"none\" filter='' class=\"labelDiv\" tabindex=\"-1\">\r\n  <ng-container *ngIf=\"image\">\r\n    <div [ngClass]=\"class\">\r\n      <label #displayElement *ngIf=\"model\" [ngClass]=\"getClassForLabel()\" class=\"k-form-field\" (click)=\"click($event)\"\r\n        (dblclick)=\"doubleClick($event)\" [ngStyle]=\"setMyStyle()\" (mouseenter)=\"mouseEnterHandler($event)\"\r\n        (mouseleave)=\"mouseLeaveHandler($event)\" [attr.disabled]=\"disabled\" wmControls [hostComponent]=\"this\"\r\n        [innerHTML]=\"text\"></label>\r\n      <div>\r\n        <img alt='label-image' src=\"{{image}}\" (click)=\"click($event)\">\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"!image\">\r\n    <label #displayElement *ngIf=\"model\" class=\"k-form-field\" [ngClass]=\"getClassForLabel()\" (click)=\"click($event)\"\r\n      (dblclick)=\"doubleClick($event)\" [ngStyle]=\"setMyStyle()\" (mouseenter)=\"mouseEnterHandler($event)\"\r\n      (mouseleave)=\"mouseLeaveHandler($event)\" [attr.disabled]=\"disabled\" wmControls [hostComponent]=\"this\"\r\n      [innerHTML]=\"text\"></label>\r\n  </ng-container>\r\n</div>", styles: ["label:disabled,label[disabled],label.k-disabled,label.state-disabled{opacity:.5;pointer-events:none}.labelDiv{background-color:transparent}.fixed3D{border-style:inset;border-width:thin}.topLeft,.topCenter,.topRight,.middleLeft,.middleCenter,.middleRight,.bottomLeft,.bottomCenter,.bottomRight{display:flex}.topLeft{align-items:flex-start;justify-content:flex-start}.topCenter{align-items:flex-start;justify-content:center}.topRight{align-items:flex-start;justify-content:flex-end}.middleLeft{align-items:center;justify-content:flex-start}.middleCenter{align-items:center;justify-content:center}.middleRight{align-items:center;justify-content:flex-end}.bottomLeft{align-items:flex-end;justify-content:flex-start}.bottomCenter{align-items:flex-end;justify-content:center}.bottomRight{align-items:flex-end;justify-content:flex-end}.wrapText{white-space:normal}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i10.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    NotifyChange('BorderStyle'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], LabelComponent.prototype, "borderStyle", null);
__decorate([
    NotifyChange('Text'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], LabelComponent.prototype, "text", null);
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LabelComponent.prototype, "click", null);
__decorate([
    serverEvent('DoubleClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LabelComponent.prototype, "doubleClick", null);
__decorate([
    serverEvent('MouseEnter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LabelComponent.prototype, "mouseEnterHandler", null);
__decorate([
    serverEvent('MouseLeave'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LabelComponent.prototype, "mouseLeaveHandler", null);
LabelComponent = __decorate([
    dataTransfer(['lbl']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService,
        WebMapService,
        ShortcutsService])
], LabelComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LabelComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-label', inputs: ['model'], template: "<div kendoTooltip showOn=\"none\" filter='' class=\"labelDiv\" tabindex=\"-1\">\r\n  <ng-container *ngIf=\"image\">\r\n    <div [ngClass]=\"class\">\r\n      <label #displayElement *ngIf=\"model\" [ngClass]=\"getClassForLabel()\" class=\"k-form-field\" (click)=\"click($event)\"\r\n        (dblclick)=\"doubleClick($event)\" [ngStyle]=\"setMyStyle()\" (mouseenter)=\"mouseEnterHandler($event)\"\r\n        (mouseleave)=\"mouseLeaveHandler($event)\" [attr.disabled]=\"disabled\" wmControls [hostComponent]=\"this\"\r\n        [innerHTML]=\"text\"></label>\r\n      <div>\r\n        <img alt='label-image' src=\"{{image}}\" (click)=\"click($event)\">\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"!image\">\r\n    <label #displayElement *ngIf=\"model\" class=\"k-form-field\" [ngClass]=\"getClassForLabel()\" (click)=\"click($event)\"\r\n      (dblclick)=\"doubleClick($event)\" [ngStyle]=\"setMyStyle()\" (mouseenter)=\"mouseEnterHandler($event)\"\r\n      (mouseleave)=\"mouseLeaveHandler($event)\" [attr.disabled]=\"disabled\" wmControls [hostComponent]=\"this\"\r\n      [innerHTML]=\"text\"></label>\r\n  </ng-container>\r\n</div>", styles: ["label:disabled,label[disabled],label.k-disabled,label.state-disabled{opacity:.5;pointer-events:none}.labelDiv{background-color:transparent}.fixed3D{border-style:inset;border-width:thin}.topLeft,.topCenter,.topRight,.middleLeft,.middleCenter,.middleRight,.bottomLeft,.bottomCenter,.bottomRight{display:flex}.topLeft{align-items:flex-start;justify-content:flex-start}.topCenter{align-items:flex-start;justify-content:center}.topRight{align-items:flex-start;justify-content:flex-end}.middleLeft{align-items:center;justify-content:flex-start}.middleCenter{align-items:center;justify-content:center}.middleRight{align-items:center;justify-content:flex-end}.bottomLeft{align-items:flex-end;justify-content:flex-start}.bottomCenter{align-items:flex-end;justify-content:center}.bottomRight{align-items:flex-end;justify-content:flex-end}.wrapText{white-space:normal}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: i1.WebMapService, decorators: [{
                    type: Optional
                }] }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { Click: [{
                type: Output
            }], DoubleClick: [{
                type: Output
            }], MouseEnter: [{
                type: Output
            }], MouseLeave: [{
                type: Output
            }], displayElementLabel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], borderStyle: [], text: [], click: [], doubleClick: [], mouseEnterHandler: [], mouseLeaveHandler: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class KeyPressEventArgs extends EventData$1 {
    /**
     * Creates a new EventData object that keeps
     * information about the executed event and
     * the sender component
     * @param event The original javascript event object
     * @param Id The sender component id
     * @param mapperId The sender component mapperId
     */
    constructor(event, Id, target, mapperId) {
        super(event, Id, mapperId);
        this._keyChar = event.key;
        this.target = target;
    }
    /**
     * Get the current key char
     *
     * @type {string}
     * @memberof KeyPressEventArgs
     */
    get keyChar() {
        return this._keyChar;
    }
    /**
     * Sets the current key char
     *
     * @memberof KeyPressEventArgs
     */
    set keyChar(value) {
        this._keyChar = value;
    }
    /**
     * Updates the text if the key char was modified
     * @param target The control to be modified
     */
    updateControl() {
        if (this.event.key != this.keyChar) {
            const start = this.event.target.selectionStart;
            const end = this.event.target.selectionEnd;
            const current = this.target.text;
            this.target.text = this.event.target.value =
                current.substring(0, start) + this.keyChar + current.substring(end);
            this.event.target.setSelectionRange(start + 1, start + 1); // change cursor position
            this.event.preventDefault();
        }
    }
}

var TextBoxComponent_1;
/**
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/text-box/text-box.html</example-url>
 */
let TextBoxComponent = TextBoxComponent_1 = class TextBoxComponent extends TextBoxBaseComponent {
    /**
     * Keys press callback
     * Updates the text value if the server changed the component model
     * in the keypress handler #284645
     * @param event current event callback
     * @param args the arguments received by the callback
     */
    static keyPressCallback(event, args) {
        event.text = event.model.Text;
    }
    /* c8 ignore start */
    constructor(serviceRef, chDetector, rnderer2, elemen, webComponents, baseValidatorService, bringTopServe, containerInteraction) {
        super(chDetector, rnderer2, elemen, webComponents, bringTopServe, containerInteraction);
        this.serviceRef = serviceRef;
        this.chDetector = chDetector;
        this.rnderer2 = rnderer2;
        this.elemen = elemen;
        this.baseValidatorService = baseValidatorService;
        this.bringTopServe = bringTopServe;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        this.Click = new EventEmitter();
        /**
         * Event emitter for double click event
         *
         * @memberof TextBoxComponent
         */
        this.DoubleClick = new EventEmitter();
        /**
         * Url to get the autocomplete string array.
         *
         * @memberof TextBoxComponent
         */
        this.autoCompleteUrl = 'api/textboxautocomplete';
        /**
         * AutoComplete string array.
         *
         * @type {string[]}
         * @memberof TextBoxComponent
         */
        this.autoCompleteData = [];
        /**
         * AutoComplete filter.
         *
         * @memberof TextBoxComponent
         */
        this.autoCompleteFilter = '';
        /**
         * Loading filtered data flag.
         *
         * @memberof TextBoxComponent
         */
        this.loadingFilteredData = false;
        /**
         * Debounce default time.
         *
         * @memberof TextBoxComponent
         */
        this.debounceTime = 500;
    }
    set displayElementPanel(value) {
        /* c8 ignore else */
        if (value instanceof AutoCompleteComponent) {
            this.autoCompleteComponent = value;
        }
        this.displayElement =
            value?.nativeElement ?? value?.wrapper?.querySelector('input') ?? null;
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * AfterViewInit life-cycle hook.
     *
     * @memberof TextBoxComponent
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.setMaxLengthValue(true);
        this.setTypeValue(true);
    }
    /**
     * DoCheck life-cycle hook.
     *
     * @memberof TextBoxComponent
     */
    ngDoCheck() {
        super.ngDoCheck();
        this.setMaxLengthValue();
        this.setTypeValue();
    }
    /**
     * Sets the input maxLength value if the KendoAutoComplete component is rendered.
     *
     * @param {boolean} [initializing=false]
     * @memberof TextBoxComponent
     */
    setMaxLengthValue(initializing = false) {
        /* c8 ignore else */
        if (this.shouldShowAutoComplete() && this.isDisplayElementHTMLInput()) {
            const maxLengthValue = this.displayElementAsInput.maxLength;
            /* c8 ignore else */
            if ((initializing && this.maxLength !== null) ||
                (this.maxLength !== null && maxLengthValue !== this.maxLength)) {
                this.displayElementAsInput.maxLength = this.maxLength;
            }
        }
    }
    /**
     * Sets the input type value if the KendoAutoComplete component is rendered.
     *
     * @param {boolean} [initializing=false]
     * @memberof TextBoxComponent
     */
    setTypeValue(initializing = false) {
        /* c8 ignore else */
        if (this.shouldShowAutoComplete() && this.isDisplayElementHTMLInput()) {
            const typeValue = this.displayElementAsInput.type;
            /* c8 ignore else */
            if (initializing || typeValue !== this.getTextBoxType()) {
                this.displayElementAsInput.type = this.getTextBoxType();
            }
        }
    }
    /**
     * Returns the displayElement as a HTMLInputElement.
     *
     * @readonly
     * @type {HTMLInputElement}
     * @memberof TextBoxComponent
     */
    get displayElementAsInput() {
        return this.displayElement;
    }
    /**
     * Should return true if the displayElement is a HTMLInputElement.
     *
     * @return {*}  {boolean}
     * @memberof TextBoxComponent
     */
    /* c8 ignore start */
    isDisplayElementHTMLInput() {
        return (this.displayElement && this.displayElement instanceof HTMLInputElement);
    }
    /* c8 ignore stop */
    /**
     * Apply focus of the TextBox component
     * @memberof TextBoxComponent
     */
    applyFocus() {
        /* c8 ignore else */
        if (this.displayElement?.value !== this.text) {
            this.displayElement.value = this.text;
        }
        /* c8 ignore else */
        if (this.displayElement) {
            this.displayElement.selectionStart =
                this.selectionStart;
            this.displayElement.selectionEnd =
                this.selectionEnd;
        }
        super.applyFocus();
    }
    /**
     * Gets accepts enter
     */
    get acceptsReturn() {
        return !!this.model?.AcceptsReturn;
    }
    get maxLength() {
        return this.model.MaxLength ? this.model.MaxLength : null;
    }
    set maxLength(value) {
        this.model.MaxLength = value;
    }
    get multiline() {
        return this.model.Multiline;
    }
    set multiline(value) {
        this.model.Multiline = value;
    }
    set passwordChar(value) {
        this.model.PasswordChar = value;
    }
    // Gets or sets the character used to mask characters of a password in a single-line TextBox control.
    get passwordChar() {
        return this.model.PasswordChar;
    }
    getTextBoxType() {
        return this.passwordChar && this.passwordChar === '*' ? 'password' : 'text';
    }
    /**
     * Returns true if the kendo suggest should be applied.
     * Kendo suggest is the same as the Winforms Append.
     *
     * @return {*}  {boolean}
     * @memberof TextBoxComponent
     */
    shouldApplyKendoSuggest() {
        return (this.autoCompleteMode === AutoCompleteMode.Append ||
            this.autoCompleteMode === AutoCompleteMode.SuggestAppend);
    }
    /**
     * Gets/sets the autoComplete source property.
     *
     * @readonly
     * @type {AutoCompleteSource}
     * @memberof TextBoxComponent
     */
    get autoCompleteSource() {
        return this.model.AutoCompleteSource;
    }
    set autoCompleteSource(value) {
        this.model.AutoCompleteSource = value;
    }
    /**
     * Gets/sets the autoComplet mode property.
     *
     * @readonly
     * @type {AutoCompleteMode}
     * @memberof TextBoxComponent
     */
    get autoCompleteMode() {
        return this.model.AutoCompleteMode;
    }
    set autoCompleteMode(value) {
        this.model.AutoCompleteMode = value;
    }
    /**
     * Handles the Click event.
     * @param event the event name.
     */
    click(event) {
        this.Click.emit(new EventData$1(event, this.id));
        this.updateSelect();
    }
    /**
     * Handles the double click event
     * @param event The event object
     */
    doubleClick(event) {
        this.DoubleClick.emit(new EventData$1(event, this.id));
    }
    /**
     * Servers event keypress override
     * @param event current event object
     */
    keyPress(event) {
        if (this.selectionLength === this.text.length || this.text.length == 0) {
            this.selectionLength = 0;
            this.text = '';
        }
        this.modified = true;
        //this data should be refactored to the control.directive in order to be generic.
        const data = new KeyPressEventArgs(event, this.id, this);
        this.KeyPress.emit(data);
        data.updateControl();
    }
    /**
     * Keys down handler
     * @param event
     */
    keyDownHandler(event) {
        if (this.multiline && this.acceptsReturn && event.key === 'Enter') {
            event.stopPropagation();
        }
        this.handlerSelection(event);
    }
    /**
     * Gets selectionEnd according to
     * selectionStart and selectionLength properties
     */
    get selectionEnd() {
        return this.selectionStart + this.selectionLength;
    }
    /**
     * Deselect all the text in the input
     * Set selectionStart and selectionEnd properties
     */
    deselectAll() {
        this.selectionStart = this.text.length;
        this.selectionLength = 0;
    }
    /**
     * Focus handler
     */
    focusHandler() {
        // If the AutoCompleteComponent is being shown, we need to use the settimeout and set the selection
        // at the end of the events cycle or it will be overridden by other logic.
        if (this.shouldShowAutoComplete() && this.autoCompleteComponent) {
            Utils.setTimeoutFunctionExecution(this.setInputSelection.bind(this));
        }
        else {
            this.setInputSelection();
        }
    }
    /**
     * Sets the input selection properties.
     *
     * @memberof TextBoxComponent
     */
    setInputSelection() {
        this.displayElement.selectionStart =
            this.selectionStart;
        this.displayElement.selectionEnd = this.selectionEnd;
    }
    /**
     * Update selectionStart and selectionEnd properties
     * on events (Click , MouseDown, handlerSelection)
     */
    updateSelect() {
        this.model.SelectionStart = this.displayElement.selectionStart;
        this.model.SelectionLength =
            this.displayElement.selectionEnd -
                this.displayElement.selectionStart;
    }
    /**
     * KeyUp handler
     * @param event
     */
    handlerSelection(event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            this.updateSelect();
        }
    }
    /**
     * Returns the parameters for the autocomplete request.
     *
     * @return {*}  {HttpParams}
     * @memberof TextBoxComponent
     */
    getAutocompleteParams() {
        let params = new HttpParams();
        params = params.set('filter', this.autoCompleteFilter);
        return params;
    }
    /**
     * FilterChange event handler.
     *
     * @param {string} filter
     * @memberof TextBoxComponent
     */
    filterChangeHandler(filter) {
        this.autoCompleteFilter = filter;
        clearTimeout(this.filterChangeTimerId);
        this.filterChangeTimerId = Utils.setTimeoutFunctionExecution(this.loadFilteredData.bind(this), this.debounceTime);
    }
    /**
     * Calls the API to load the filtered data.
     *
     * @memberof TextBoxComponent
     */
    loadFilteredData() {
        /* c8 ignore else */
        if (this.autoCompleteSource === AutoCompleteSource.CustomSource) {
            this.loadingFilteredData = true;
            this.serviceRef
                .fetch(this.autoCompleteUrl, this.id, this.getAutocompleteParams())
                .subscribe((data) => {
                this.autoCompleteData = data;
                this.loadingFilteredData = false;
                this.autoCompleteToggleHandler();
                this.detectChanges();
            });
        }
    }
    /**
     * Verifies if the autoComplete component should be shown.
     *
     * @return {*}  {boolean}
     * @memberof TextBoxComponent
     */
    shouldShowAutoComplete() {
        return (this.autoCompleteMode === AutoCompleteMode.Suggest ||
            this.autoCompleteMode === AutoCompleteMode.SuggestAppend);
    }
    /**
     * Handles the popup open/close state.
     *
     * @memberof TextBoxComponent
     */
    autoCompleteToggleHandler() {
        if (this.autoCompleteComponent) {
            /* c8 ignore else */
            if (this.autoCompleteFilter !== '' &&
                !this.autoCompleteComponent.isOpen &&
                this.autoCompleteData?.length > 0 &&
                this.shouldShowAutoComplete()) {
                this.autoCompleteComponent.toggle(true);
            }
            else if ((this.autoCompleteFilter === '' && this.autoCompleteComponent.isOpen) ||
                this.autoCompleteData?.length === 0) {
                this.autoCompleteComponent.toggle(false);
            }
        }
    }
    /**
     * Handles the open event.
     *
     * @param {PreventableEvent} event
     * @memberof TextBoxComponent
     */
    openHandler(event) {
        event.preventDefault();
    }
};
TextBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextBoxComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: BaseValidatorService, optional: true }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TextBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TextBoxComponent, selector: "wm-textbox", inputs: { model: "model" }, outputs: { Click: "Click", DoubleClick: "DoubleClick" }, viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div>\r\n  <input kendoTooltip showOn=\"none\" kendoTextBox #displayElement *ngIf=\"model && !multiline && !shouldShowAutoComplete()\" wmControls\r\n    class=\"k-form-field\" [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\" [ngClass]=\"textBoxInputClass\"\r\n    [maxlength]=\"maxLength\" [ngStyle]=\"setMyStyle()\" [type]=\"getTextBoxType()\" (click)=\"click($event)\"\r\n    [hostComponent]=\"this\" (keyup)=\"handlerSelection($event)\" (mousedown)=\"updateSelect()\" (focus)=\"focusHandler()\"\r\n    [selectionStart]=\"selectionStart\" [selectionEnd]=\"selectionEnd\" (dblclick)=\"doubleClick($event)\" />\r\n\r\n  <kendo-autocomplete kendoTooltip showOn=\"none\" #displayElement *ngIf=\"model && !multiline && shouldShowAutoComplete()\" wmControls\r\n    class=\"k-form-field\" [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\" [ngClass]=\"textBoxInputClass\"\r\n    [ngStyle]=\"setMyStyle()\" (click)=\"click($event)\" [hostComponent]=\"this\" (keyup)=\"handlerSelection($event)\"\r\n    (mousedown)=\"updateSelect()\" (focus)=\"focusHandler($event)\" [data]=\"autoCompleteData\" [suggest]=\"shouldApplyKendoSuggest()\"\r\n    [filterable]=\"true\" (filterChange)=\"filterChangeHandler($event)\" [loading]=\"loadingFilteredData\" [highlightFirst]=\"false\"\r\n    (open)=\"openHandler($event)\"></kendo-autocomplete>\r\n\r\n  <textarea kendoTooltip showOn=\"none\" *ngIf=\"model && multiline\" [ngClass]=\"textBoxInputClass\" [ngStyle]=\"setMyStyle()\"\r\n    kendoTextArea #displayElement wmControls [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\"\r\n    [maxlength]=\"maxLength\" (click)=\"click($event)\" [hostComponent]=\"this\" (keydown)=\"keyDownHandler($event)\"\r\n    (keyup.arrowleft)=\"handlerSelection($event)\" (keyup.arrowright)=\"handlerSelection($event)\"\r\n    (mousedown)=\"updateSelect()\" (focus)=\"focusHandler()\" [selectionStart]=\"selectionStart\"\r\n    [selectionEnd]=\"selectionEnd\"></textarea>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i8.TextAreaDirective, selector: "textarea[kendoTextArea]", inputs: ["autoSize", "value"], outputs: ["valueChange"] }, { kind: "directive", type: i8.TextBoxDirective, selector: "input[kendoTextBox]", inputs: ["value"] }, { kind: "component", type: i8$1.AutoCompleteComponent, selector: "kendo-autocomplete", inputs: ["highlightFirst", "focusableId", "data", "value", "valueField", "placeholder", "popupSettings", "listHeight", "loading", "clearButton", "suggest", "disabled", "itemDisabled", "readonly", "tabindex", "tabIndex", "filterable", "virtual", "size", "rounded", "fillMode"], outputs: ["valueChange", "filterChange", "open", "opened", "close", "closed", "focus", "blur"], exportAs: ["kendoAutoComplete"] }, { kind: "directive", type: i10.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], TextBoxComponent.prototype, "maxLength", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], TextBoxComponent.prototype, "multiline", null);
__decorate([
    MarkForCheck(),
    NotifyChange('PasswordChar'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], TextBoxComponent.prototype, "passwordChar", null);
__decorate([
    MarkForCheck(),
    NotifyChange('AutoCompleteSource'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], TextBoxComponent.prototype, "autoCompleteSource", null);
__decorate([
    MarkForCheck(),
    NotifyChange('AutoCompleteMode'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], TextBoxComponent.prototype, "autoCompleteMode", null);
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TextBoxComponent.prototype, "click", null);
__decorate([
    serverEvent('DoubleClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TextBoxComponent.prototype, "doubleClick", null);
__decorate([
    serverEvent('KeyPress', ControlComponent.keyPressEventArgsExtractor, undefined, TextBoxComponent_1.keyPressCallback),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TextBoxComponent.prototype, "keyPress", null);
TextBoxComponent = TextBoxComponent_1 = __decorate([
    dataTransfer(['txtBx']),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BaseValidatorService,
        BringTopService,
        ContainerInteractionService])
], TextBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextBoxComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-textbox', inputs: ['model'], template: "<div>\r\n  <input kendoTooltip showOn=\"none\" kendoTextBox #displayElement *ngIf=\"model && !multiline && !shouldShowAutoComplete()\" wmControls\r\n    class=\"k-form-field\" [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\" [ngClass]=\"textBoxInputClass\"\r\n    [maxlength]=\"maxLength\" [ngStyle]=\"setMyStyle()\" [type]=\"getTextBoxType()\" (click)=\"click($event)\"\r\n    [hostComponent]=\"this\" (keyup)=\"handlerSelection($event)\" (mousedown)=\"updateSelect()\" (focus)=\"focusHandler()\"\r\n    [selectionStart]=\"selectionStart\" [selectionEnd]=\"selectionEnd\" (dblclick)=\"doubleClick($event)\" />\r\n\r\n  <kendo-autocomplete kendoTooltip showOn=\"none\" #displayElement *ngIf=\"model && !multiline && shouldShowAutoComplete()\" wmControls\r\n    class=\"k-form-field\" [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\" [ngClass]=\"textBoxInputClass\"\r\n    [ngStyle]=\"setMyStyle()\" (click)=\"click($event)\" [hostComponent]=\"this\" (keyup)=\"handlerSelection($event)\"\r\n    (mousedown)=\"updateSelect()\" (focus)=\"focusHandler($event)\" [data]=\"autoCompleteData\" [suggest]=\"shouldApplyKendoSuggest()\"\r\n    [filterable]=\"true\" (filterChange)=\"filterChangeHandler($event)\" [loading]=\"loadingFilteredData\" [highlightFirst]=\"false\"\r\n    (open)=\"openHandler($event)\"></kendo-autocomplete>\r\n\r\n  <textarea kendoTooltip showOn=\"none\" *ngIf=\"model && multiline\" [ngClass]=\"textBoxInputClass\" [ngStyle]=\"setMyStyle()\"\r\n    kendoTextArea #displayElement wmControls [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\"\r\n    [maxlength]=\"maxLength\" (click)=\"click($event)\" [hostComponent]=\"this\" (keydown)=\"keyDownHandler($event)\"\r\n    (keyup.arrowleft)=\"handlerSelection($event)\" (keyup.arrowright)=\"handlerSelection($event)\"\r\n    (mousedown)=\"updateSelect()\" (focus)=\"focusHandler()\" [selectionStart]=\"selectionStart\"\r\n    [selectionEnd]=\"selectionEnd\"></textarea>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: BaseValidatorService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { Click: [{
                type: Output
            }], DoubleClick: [{
                type: Output
            }], displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], maxLength: [], multiline: [], passwordChar: [], autoCompleteSource: [], autoCompleteMode: [], click: [], doubleClick: [], keyPress: [] } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
var MessageBoxIcons;
(function (MessageBoxIcons) {
    MessageBoxIcons[MessageBoxIcons["Asterisk"] = 64] = "Asterisk";
    MessageBoxIcons[MessageBoxIcons["Error"] = 16] = "Error";
    MessageBoxIcons[MessageBoxIcons["Exclamation"] = 48] = "Exclamation";
    MessageBoxIcons[MessageBoxIcons["Hand"] = 16] = "Hand";
    MessageBoxIcons[MessageBoxIcons["Information"] = 64] = "Information";
    MessageBoxIcons[MessageBoxIcons["None"] = 0] = "None";
    MessageBoxIcons[MessageBoxIcons["Question"] = 32] = "Question";
    MessageBoxIcons[MessageBoxIcons["Stop"] = 16] = "Stop";
    MessageBoxIcons[MessageBoxIcons["Warning"] = 48] = "Warning";
})(MessageBoxIcons || (MessageBoxIcons = {}));

let MessageBoxComponent = class MessageBoxComponent extends DialogBaseComponent {
    /* c8 ignore start */
    constructor(wmservice, refChanges, renderer2, element, webComponents, bringTopServ, containerInteraction, focusManager) {
        super(refChanges, renderer2, element, webComponents);
        this.refChanges = refChanges;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.focusManager = focusManager;
        this.webServices = wmservice;
        this.enableButtons = true;
    }
    /**
     * Angular Lifecycle
     *
     * @memberof MessageBoxComponent
     */
    ngAfterViewInit() {
        this.initializeLastFocusElement();
        this.initializeButtonCloseElement();
        this.assignFocusButton(this.model.DefaultButton.UniqueID);
        if (this.currentWebMapService()) {
            this.currentWebMapService()
                .core.getEvent()
                .publish('MessageBoxDisplayed', true);
        }
    }
    /**
     * Angular Lifecycle
     *
     * @memberof MessageBoxComponent
     */
    ngOnDestroy() {
        if (this.currentWebMapService()) {
            this.currentWebMapService()
                .core.getEvent()
                .publish('MessageBoxDisplayed', false);
        }
    }
    click(event, buttonId) {
        this.enableButtons = false;
        this.webServices.invoke(new SendV5(this, 'Click', buttonId, 'Click', undefined, (response) => {
            this.focusActiveComponent();
        }));
    }
    /**
     * Moves focus to close button after leaving last focusable button when
     * the tab key is pressed.
     * @param event Event Data
     */
    tabLeaveAction(event) {
        /* c8 ignore else */
        if (this.buttonClose && this.lastElement === event.currentTarget) {
            Utils.preventPropagation(event);
            this.buttonClose.focus();
        }
    }
    /**
     * Moves focus to the last focusable button after leaving close button when
     * the shift + tab key is pressed.
     * @param event Event Data
     */
    tabShiftLeaveAction(event) {
        /* c8 ignore else */
        if (this.lastElement) {
            Utils.preventPropagation(event);
            this.lastElement.focus();
        }
    }
    get buttonYes() {
        if (this.model && this.model.ButtonYes) {
            return this.model.ButtonYes;
        }
        return undefined;
    }
    get buttonNo() {
        if (this.model && this.model.ButtonNo) {
            return this.model.ButtonNo;
        }
        return undefined;
    }
    get buttonOk() {
        if (this.model && this.model.ButtonOk) {
            return this.model.ButtonOk;
        }
        return undefined;
    }
    get buttonCancel() {
        if (this.model && this.model.ButtonCancel) {
            return this.model.ButtonCancel;
        }
        return undefined;
    }
    get buttonAbort() {
        if (this.model && this.model.ButtonAbort) {
            return this.model.ButtonAbort;
        }
        return undefined;
    }
    get buttonRetry() {
        if (this.model && this.model.ButtonRetry) {
            return this.model.ButtonRetry;
        }
        return undefined;
    }
    get buttonIgnore() {
        if (this.model && this.model.ButtonIgnore) {
            return this.model.ButtonIgnore;
        }
        return undefined;
    }
    get labelMessage() {
        if (this.model && this.model.LabelMessage) {
            return Utils.replaceNewLines(Utils.toHtmlEntities(this.model.LabelMessage.Text));
        }
        return '';
    }
    /**
     * Gets width
     * If undefined, the kendo dialog adjust to the content
     */
    get width() {
        return this.model.Width;
    }
    set width(value) {
        this.model.Width = value;
    }
    /**
     * Gets height
     * If undefined, the kendo dialog adjust to the content
     */
    get height() {
        return this.model.Height;
    }
    set height(value) {
        this.model.Height = value;
    }
    /**
     * Boolean to choose the source icon for the message Box
     */
    get hasIcon() {
        return this.icon !== 0;
    }
    /**
     * Gets Icon
     * If undefined or 0, the kendo dialog adjust to the content
     */
    get icon() {
        return this.model.Icon || 0;
    }
    set icon(value) {
        this.model.Icon = value;
    }
    /**
     * @description
     * Returns the image url to display according to the icons model property.
     * @returns { string }
     */
    get path() {
        let path = '';
        switch (this.model.Icon) {
            case MessageBoxIcons.Asterisk:
            case MessageBoxIcons.Information:
                path = 'assets/images/info.png';
                break;
            case MessageBoxIcons.Error:
            case MessageBoxIcons.Hand:
            case MessageBoxIcons.Stop:
                path = 'assets/images/Error.png';
                break;
            case MessageBoxIcons.Exclamation:
            case MessageBoxIcons.Warning:
                path = 'assets/images/Warning.png';
                break;
            case MessageBoxIcons.Question:
                path = 'assets/images/Question.png';
                break;
            case MessageBoxIcons.None:
            default:
                break;
        }
        return path;
    }
    /**
     * Initializes lastElement field with the last focusable element inside
     * of MessageBox.
     * WARNING: It depends of getLastFocusableElement method, it is a internal
     * method of kendoDialog.
     */
    initializeLastFocusElement() {
        /* c8 ignore else */
        if (this.kendoDialog &&
            this.kendoDialog.getLastFocusableElement &&
            this.element &&
            this.element.nativeElement) {
            this.lastElement = this.kendoDialog.getLastFocusableElement(this.element.nativeElement);
        }
    }
    /**
     * This function assigns the focus depending who is the DefaultButton inside a messageBox.
     * Also, set "Focused" property to the focused element and set DefaultButton as the focused element.
     */
    assignFocusButton(defButton) {
        switch (defButton) {
            case this.buttonYes?.UniqueID:
                this.VCButtonYes?.nativeElement.focus();
                this.buttonYes.Focused = true;
                this.model.DefaultButton = this.model.ButtonYes;
                break;
            case this.buttonNo?.UniqueID:
                this.VCButtonNo?.nativeElement.focus();
                this.buttonNo.Focused = true;
                this.model.DefaultButton = this.model.ButtonNo;
                break;
            case this.buttonOk?.UniqueID:
                this.VCButtonOk?.nativeElement.focus();
                this.buttonOk.Focused = true;
                this.model.DefaultButton = this.model.ButtonOk;
                break;
            case this.buttonCancel?.UniqueID:
                this.VCButtonCancel?.nativeElement.focus();
                this.buttonCancel.Focused = true;
                this.model.DefaultButton = this.model.ButtonCancel;
                break;
            case this.buttonAbort?.UniqueID:
                this.VCButtonAbort?.nativeElement.focus();
                this.buttonAbort.Focused = true;
                this.model.DefaultButton = this.model.ButtonAbort;
                break;
            case this.buttonRetry?.UniqueID:
                this.VCButtonRetry?.nativeElement.focus();
                this.buttonRetry.Focused = true;
                this.model.DefaultButton = this.model.ButtonRetry;
                break;
            case this.buttonIgnore?.UniqueID:
                this.VCButtonIgnore?.nativeElement.focus();
                this.buttonIgnore.Focused = true;
                this.model.DefaultButton = this.model.ButtonIgnore;
                break;
            default:
                break;
        }
    }
    /**
     * Method to execute when the close icon is clicked
     *
     * @memberof MessageBoxComponent
     */
    close(event) {
        this.visible = false;
        const buttonExecutionId = this.buttonCancel?.UniqueID ?? this.buttonOk?.UniqueID;
        // The TitleBar's close button should trigger the click event for the correct button.
        this.click(event, buttonExecutionId);
    }
    /**
     * Focuses the active component from the focusManager service.
     * This should be called when closing the MessageBox component.
     *
     * @memberof MessageBoxComponent
     */
    focusActiveComponent() {
        this.focusManager?.activeComponent?.applyFocus();
    }
    /**
     * Returns true if the titleBar close button should be disabled.
     *
     * @return {*}  {boolean}
     * @memberof MessageBoxComponent
     */
    isCloseButtonDisabled() {
        return !this.buttonCancel && !this.buttonOk;
    }
    /**
     * Returns the titleBar class to be applied.
     *
     * @return {*}  {string}
     * @memberof MessageBoxComponent
     */
    titleBarClass() {
        return this.isCloseButtonDisabled() ? 'titleCloseButtonDisabled' : '';
    }
};
MessageBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MessageBoxComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: FocusManagerService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
MessageBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: MessageBoxComponent, selector: "wm-messagebox", inputs: { model: "model" }, viewQueries: [{ propertyName: "kendoDialog", first: true, predicate: DialogComponent, descendants: true }, { propertyName: "VCButtonYes", first: true, predicate: ["idButtonYes"], descendants: true }, { propertyName: "VCButtonNo", first: true, predicate: ["idButtonNo"], descendants: true }, { propertyName: "VCButtonOk", first: true, predicate: ["idButtonOk"], descendants: true }, { propertyName: "VCButtonCancel", first: true, predicate: ["idButtonCancel"], descendants: true }, { propertyName: "VCButtonAbort", first: true, predicate: ["idButtonAbort"], descendants: true }, { propertyName: "VCButtonRetry", first: true, predicate: ["idButtonRetry"], descendants: true }, { propertyName: "VCButtonIgnore", first: true, predicate: ["idButtonIgnore"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\">\r\n  <kendo-dialog *ngIf=\"visible\" [width]=\"width\" [height]=\"height\" [ngClass]=\"class\" (close)=\"close($event)\">\r\n    <kendo-dialog-titlebar #titleBar (keydown.shift.tab)=\"tabShiftLeaveAction($event)\" [ngClass]=\"titleBarClass()\">\r\n      {{text}}\r\n    </kendo-dialog-titlebar>\r\n    <div class=\"content\">\r\n      <img *ngIf=\"hasIcon\" class=\"Msg_icon\" [src]=\"path\" alt=\"icon\"/>\r\n      <p [innerHTML]=\"labelMessage\" class=\"Msg_message\"></p>\r\n    </div>\r\n    <kendo-dialog-actions>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonYes.UniqueID)\" *ngIf=\"buttonYes\"\r\n        (keydown.tab)=\"tabLeaveAction($event)\" #idButtonYes>{{buttonYes.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonNo.UniqueID)\" *ngIf=\"buttonNo\"\r\n        (keydown.tab)=\"tabLeaveAction($event)\" #idButtonNo>{{buttonNo.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonOk.UniqueID)\" *ngIf=\"buttonOk\"\r\n        (keydown.tab)=\"tabLeaveAction($event)\" #idButtonOk>{{buttonOk.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonAbort.UniqueID)\"\r\n        *ngIf=\"buttonAbort\" (keydown.tab)=\"tabLeaveAction($event)\" #idButtonAbort>{{buttonAbort.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonRetry.UniqueID)\"\r\n        *ngIf=\"buttonRetry\" (keydown.tab)=\"tabLeaveAction($event)\" #idButtonRetry>{{buttonRetry.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonCancel.UniqueID)\"\r\n        *ngIf=\"buttonCancel\" (keydown.tab)=\"tabLeaveAction($event)\" #idButtonCancel>{{buttonCancel.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonIgnore.UniqueID)\"\r\n        *ngIf=\"buttonIgnore\" (keydown.tab)=\"tabLeaveAction($event)\" #idButtonIgnore>{{buttonIgnore.Text}}</button>\r\n    </kendo-dialog-actions>\r\n  </kendo-dialog>\r\n</div>", styles: ["kendo-dialog{z-index:100000}kendo-dialog-actions{flex-wrap:nowrap!important}kendo-dialog-actions>button{width:100%!important}.content{margin:1.2em}.Msg_icon{float:left;padding:.5em;width:40px;height:40px}.Msg_message{float:left;padding:.5em}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7.DialogComponent, selector: "kendo-dialog", inputs: ["actions", "actionsLayout", "autoFocusedElement", "title", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "animation", "themeColor"], outputs: ["action", "close"], exportAs: ["kendoDialog"] }, { kind: "component", type: i7.DialogTitleBarComponent, selector: "kendo-dialog-titlebar", inputs: ["id", "closeTitle"], outputs: ["close"] }, { kind: "component", type: i7.DialogActionsComponent, selector: "kendo-dialog-actions", inputs: ["actions", "layout"], outputs: ["action"] }] });
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], MessageBoxComponent.prototype, "width", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], MessageBoxComponent.prototype, "height", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], MessageBoxComponent.prototype, "icon", null);
MessageBoxComponent = __decorate([
    dataTransfer(['msgBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService,
        FocusManagerService])
], MessageBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MessageBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-messagebox', inputs: ['model'], template: "<div *ngIf=\"model\">\r\n  <kendo-dialog *ngIf=\"visible\" [width]=\"width\" [height]=\"height\" [ngClass]=\"class\" (close)=\"close($event)\">\r\n    <kendo-dialog-titlebar #titleBar (keydown.shift.tab)=\"tabShiftLeaveAction($event)\" [ngClass]=\"titleBarClass()\">\r\n      {{text}}\r\n    </kendo-dialog-titlebar>\r\n    <div class=\"content\">\r\n      <img *ngIf=\"hasIcon\" class=\"Msg_icon\" [src]=\"path\" alt=\"icon\"/>\r\n      <p [innerHTML]=\"labelMessage\" class=\"Msg_message\"></p>\r\n    </div>\r\n    <kendo-dialog-actions>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonYes.UniqueID)\" *ngIf=\"buttonYes\"\r\n        (keydown.tab)=\"tabLeaveAction($event)\" #idButtonYes>{{buttonYes.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonNo.UniqueID)\" *ngIf=\"buttonNo\"\r\n        (keydown.tab)=\"tabLeaveAction($event)\" #idButtonNo>{{buttonNo.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonOk.UniqueID)\" *ngIf=\"buttonOk\"\r\n        (keydown.tab)=\"tabLeaveAction($event)\" #idButtonOk>{{buttonOk.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonAbort.UniqueID)\"\r\n        *ngIf=\"buttonAbort\" (keydown.tab)=\"tabLeaveAction($event)\" #idButtonAbort>{{buttonAbort.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonRetry.UniqueID)\"\r\n        *ngIf=\"buttonRetry\" (keydown.tab)=\"tabLeaveAction($event)\" #idButtonRetry>{{buttonRetry.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonCancel.UniqueID)\"\r\n        *ngIf=\"buttonCancel\" (keydown.tab)=\"tabLeaveAction($event)\" #idButtonCancel>{{buttonCancel.Text}}</button>\r\n      <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonIgnore.UniqueID)\"\r\n        *ngIf=\"buttonIgnore\" (keydown.tab)=\"tabLeaveAction($event)\" #idButtonIgnore>{{buttonIgnore.Text}}</button>\r\n    </kendo-dialog-actions>\r\n  </kendo-dialog>\r\n</div>", styles: ["kendo-dialog{z-index:100000}kendo-dialog-actions{flex-wrap:nowrap!important}kendo-dialog-actions>button{width:100%!important}.content{margin:1.2em}.Msg_icon{float:left;padding:.5em;width:40px;height:40px}.Msg_message{float:left;padding:.5em}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: FocusManagerService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { kendoDialog: [{
                type: ViewChild,
                args: [DialogComponent]
            }], VCButtonYes: [{
                type: ViewChild,
                args: ['idButtonYes']
            }], VCButtonNo: [{
                type: ViewChild,
                args: ['idButtonNo']
            }], VCButtonOk: [{
                type: ViewChild,
                args: ['idButtonOk']
            }], VCButtonCancel: [{
                type: ViewChild,
                args: ['idButtonCancel']
            }], VCButtonAbort: [{
                type: ViewChild,
                args: ['idButtonAbort']
            }], VCButtonRetry: [{
                type: ViewChild,
                args: ['idButtonRetry']
            }], VCButtonIgnore: [{
                type: ViewChild,
                args: ['idButtonIgnore']
            }], width: [], height: [], icon: [] } });

let GroupBoxComponent = class GroupBoxComponent extends ControlContainerComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, containerTOrderService) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.webMapService = webMapService;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.containerTOrderService = containerTOrderService;
        /**
         * Determines that it is a container.
         */
        this.isContainer = true;
    }
    /* c8 ignore stop */
    set displayElementPanel(value) {
        /* c8 ignore next*/
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /**
     * Override
     * Gets tab order
     */
    get tabOrder() {
        return this.calculateTabOrder();
    }
    /**
     * Override
     * Calculates the tabOrder value
     * @returns  any
     */
    calculateTabOrder() {
        /* c8 ignore next 3 */
        return Utils.validateTabOrder(this.model, this.tabindex);
    }
    /**
     * read the mousedown event on the document
     * when the event is outside of displayelement that is fieldset element
     * call the leave method to close the fieldset
     * @returns void
     */
    clickListener(target) {
        /* c8 ignore next 3 */
        if (this.displayElement && !this.displayElement.contains(target)) {
            this.leave(target);
        }
    }
    /**
     * Applies focus to first inner element by tab index
     */
    applyFocus() {
        this.containerTOrderService.enterContainer(false, null, true);
    }
};
GroupBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GroupBoxComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: ContainerTabOrderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
GroupBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: GroupBoxComponent, selector: "wm-groupbox", inputs: { model: "model" }, host: { listeners: { "document:mousedown": "clickListener($event.target)" } }, providers: [ContainerInteractionService, ContainerTabOrderService], viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<fieldset [ngStyle]=\"setMyStyle()\" #displayElement *ngIf=\"model\" [disabled]=\"disabled\" [ngClass]=\"class\" wmControls\r\n    [hostComponent]=\"this\">\r\n    <legend *ngIf=\"model.Text\">{{ text }}</legend>\r\n    <ng-content></ng-content>\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n</fieldset>", styles: ["fieldset{padding:0;box-sizing:border-box}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i3.ContainerComponent, selector: "wm-container", inputs: ["controls"], outputs: ["RemoveControl"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
GroupBoxComponent = __decorate([
    dataTransfer(['grpBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService,
        ContainerTabOrderService])
], GroupBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GroupBoxComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-groupbox', inputs: ['model'], providers: [ContainerInteractionService, ContainerTabOrderService], template: "<fieldset [ngStyle]=\"setMyStyle()\" #displayElement *ngIf=\"model\" [disabled]=\"disabled\" [ngClass]=\"class\" wmControls\r\n    [hostComponent]=\"this\">\r\n    <legend *ngIf=\"model.Text\">{{ text }}</legend>\r\n    <ng-content></ng-content>\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n</fieldset>", styles: ["fieldset{padding:0;box-sizing:border-box}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: ContainerTabOrderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], clickListener: [{
                type: HostListener,
                args: ['document:mousedown', ['$event.target']]
            }] } });

var Appearance;
(function (Appearance) {
    Appearance[Appearance["Normal"] = 0] = "Normal";
    Appearance[Appearance["Button"] = 1] = "Button";
})(Appearance || (Appearance = {}));
let CheckBoxComponent = class CheckBoxComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, bringTopServ, service, containerInteraction, shortcutsService) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, shortcutsService);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.service = service;
        this.containerInteraction = containerInteraction;
        this.shortcutsService = shortcutsService;
        /* c8 ignore stop */
        this.appearanceEnum = Appearance;
        this.CheckedChanged = new EventEmitter();
    }
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    get checked() {
        return this.model.Checked;
    }
    set checked(value) {
        this.model.Checked = value;
    }
    set checkedState(value) {
        this.model.CheckedState = value;
        switch (this.model.CheckedState) {
            case CheckState.Checked:
                this.checked = true;
                break;
            case CheckState.Indeterminate:
                // pending implement in UI
                break;
            case CheckState.Unchecked:
                this.checked = false;
                break;
            default:
                break;
        }
    }
    get checkedState() {
        return this.model.CheckedState;
    }
    change(event) {
        super.change(event);
        this.checked = !this.model.Checked;
        this.CheckedChanged.emit(new EventData$1(event, this.id));
        this.detectChanges();
    }
    get image() {
        return this.model.Image;
    }
    /**
     * Override the property Text to remove the ampersand
     */
    get text() {
        return RemoveAmpersand.remove(this.model.Text, this.showUnderline);
    }
    get appearance() {
        return this.model.Appearance ? this.model.Appearance : Appearance.Normal;
    }
    get checkAlign() {
        return this.model.CheckAlign;
    }
    getAlignmentClass() {
        switch (this.checkAlign) {
            case ContentAlignment.MiddleRight:
                return 'checkMiddleRight';
            case ContentAlignment.MiddleCenter:
                return 'checkMiddleCenter';
            case ContentAlignment.TopCenter:
                return 'checkTopCenter';
            case ContentAlignment.MiddleLeft:
            default:
                return '';
        }
    }
    /**
     * Applies focus to input or selectable element in
     * component. It triggers dom element focus()
     */
    applyFocus() {
        /* c8 ignore else */
        if (this.focusableElement && this.focusableElement.firstElementChild) {
            this.isApplyingFocus = true;
            this.focusableElement.firstElementChild.focus();
            this.isApplyingFocus = false;
        }
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        this.shortcutsService?.registerInstance(this);
        this.checkAlignClass = `${this.class} ${this.getAlignmentClass()}`;
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.shortcutsService?.unregisterInstance(this);
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    /**
     * Gets string indicating the type
     * @returns type
     */
    getType() {
        return 'CheckBoxComponent';
    }
};
CheckBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CheckBoxComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: i1.WebMapService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: ShortcutsService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
CheckBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: CheckBoxComponent, selector: "wm-checkbox", inputs: { model: "model" }, outputs: { CheckedChanged: "CheckedChanged" }, viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div\r\n  #displayElement\r\n  *ngIf=\"model && model.Visible && appearance === appearanceEnum.Normal\"\r\n  [ngClass]=\"checkAlignClass\"\r\n  [ngStyle]=\"setMyStyle()\"\r\n>\r\n  <input\r\n    class=\"k-checkbox\"\r\n    [id]=\"id\"\r\n    type=\"checkbox\"\r\n    [checked]=\"checked\"\r\n    [disabled]=\"disabled\"\r\n    wmControls\r\n    [hostComponent]=\"this\"\r\n  />\r\n  <label class=\"k-checkbox-label\" for=\"{{ id }}\" [innerHTML]=\"text\"></label>\r\n</div>\r\n<div\r\n  #displayElement\r\n  *ngIf=\"model && model.Visible && appearance === appearanceEnum.Button\"\r\n  [ngClass]=\"class\"\r\n  [ngStyle]=\"setMyStyle()\"\r\n>\r\n  <button\r\n    kendoButton\r\n    [look]=\"'bare'\"\r\n    [primary]=\"true\"\r\n    [selected]=\"checked\"\r\n    [togglable]=\"true\"\r\n    [disabled]=\"disabled\"\r\n    (selectedChange)=\"change($event)\"\r\n    wmControls\r\n    [hostComponent]=\"this\"\r\n    [innerHTML]=\"text\"\r\n  >\r\n  </button>\r\n</div>\r\n", styles: [".checkMiddleRight>input{float:right}.checkMiddleRight>input+label{margin-left:0}.checkMiddleCenter>input{display:block;margin:0 auto}.checkMiddleCenter>input+label{text-align:center;position:absolute;margin-top:-17px}.checkTopCenter>input{display:block;margin:0 auto}.checkTopCenter>input+label{text-align:center;position:absolute}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i6$2.Button, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }, { kind: "directive", type: i8$2.LabelDirective, selector: "label[for]", inputs: ["for"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('Checked'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], CheckBoxComponent.prototype, "checked", null);
__decorate([
    MarkForCheck(),
    NotifyChange('CheckedState'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], CheckBoxComponent.prototype, "checkedState", null);
__decorate([
    serverEvent('CheckStateChanged'),
    serverEvent('CheckedChanged'),
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CheckBoxComponent.prototype, "change", null);
CheckBoxComponent = __decorate([
    dataTransfer(['chkBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        WebMapService,
        ContainerInteractionService,
        ShortcutsService])
], CheckBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CheckBoxComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-checkbox', inputs: ['model'], template: "<div\r\n  #displayElement\r\n  *ngIf=\"model && model.Visible && appearance === appearanceEnum.Normal\"\r\n  [ngClass]=\"checkAlignClass\"\r\n  [ngStyle]=\"setMyStyle()\"\r\n>\r\n  <input\r\n    class=\"k-checkbox\"\r\n    [id]=\"id\"\r\n    type=\"checkbox\"\r\n    [checked]=\"checked\"\r\n    [disabled]=\"disabled\"\r\n    wmControls\r\n    [hostComponent]=\"this\"\r\n  />\r\n  <label class=\"k-checkbox-label\" for=\"{{ id }}\" [innerHTML]=\"text\"></label>\r\n</div>\r\n<div\r\n  #displayElement\r\n  *ngIf=\"model && model.Visible && appearance === appearanceEnum.Button\"\r\n  [ngClass]=\"class\"\r\n  [ngStyle]=\"setMyStyle()\"\r\n>\r\n  <button\r\n    kendoButton\r\n    [look]=\"'bare'\"\r\n    [primary]=\"true\"\r\n    [selected]=\"checked\"\r\n    [togglable]=\"true\"\r\n    [disabled]=\"disabled\"\r\n    (selectedChange)=\"change($event)\"\r\n    wmControls\r\n    [hostComponent]=\"this\"\r\n    [innerHTML]=\"text\"\r\n  >\r\n  </button>\r\n</div>\r\n", styles: [".checkMiddleRight>input{float:right}.checkMiddleRight>input+label{margin-left:0}.checkMiddleCenter>input{display:block;margin:0 auto}.checkMiddleCenter>input+label{text-align:center;position:absolute;margin-top:-17px}.checkTopCenter>input{display:block;margin:0 auto}.checkTopCenter>input+label{text-align:center;position:absolute}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: i1.WebMapService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], CheckedChanged: [{
                type: Output
            }], checked: [], checkedState: [], change: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
var DateFormat;
(function (DateFormat) {
    DateFormat[DateFormat["Long"] = 1] = "Long";
    DateFormat[DateFormat["Short"] = 2] = "Short";
    DateFormat[DateFormat["Time"] = 4] = "Time";
    DateFormat[DateFormat["Custom"] = 8] = "Custom";
})(DateFormat || (DateFormat = {}));

let DatetimepickerComponent = class DatetimepickerComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, service) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.service = service;
        /* c8 ignore stop */
        // Events
        this.ValueChanged = new EventEmitter();
        // Events
        this.CloseUp = new EventEmitter();
        // Events
        this.DropDown = new EventEmitter();
        this.dateFormat = DateFormat;
        // Short date format
        this.shortDateFormat = 'd';
        this.longDateFormat = 'D';
        /**
         * Time picker format of datetimepicker component
         * This format is the default for the Time format on Winforms
         */
        this.timePickerFormat = 'hh:mm:ss a';
        this.lastCursorPosition = 0;
    }
    get showCheckBox() {
        return this.model.ShowCheckBox;
    }
    get checked() {
        return this.model.Checked;
    }
    set checked(value) {
        this.model.Checked = value;
        this.isChecked = value;
    }
    get readOnlyInput() {
        return this.showCheckBox && !this.checked;
    }
    /**
     * Gets the display element
     *
     * @memberof DatetimepickerComponent
     */
    get displayElement() {
        if (this.element && this.element.nativeElement) {
            if (!this.showCheckBox) {
                return this.element.nativeElement.querySelector('.k-input-inner');
            }
            else {
                return this.element.nativeElement.querySelector('.k-checkbox');
            }
        }
        return undefined;
    }
    /**
     * Sets the display element
     *
     * @memberof DatetimepickerComponent
     * @param {HTMLElement} value
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * Get the datetimepicker input
     *
     * @memberof DatetimepickerComponent
     * @type {any}
     */
    get dtPickerInput() {
        if (this.element && this.element.nativeElement) {
            return this.element.nativeElement.querySelector('.k-input-inner');
        }
        return undefined;
    }
    /**
     * Get the checkbox input
     *
     * @memberof DatetimepickerComponent
     * @type {any}
     */
    get checkboxInput() {
        if (this.element && this.element.nativeElement) {
            return this.element.nativeElement.querySelector('.k-checkbox');
        }
        return undefined;
    }
    ngOnInit() {
        super.ngOnInit();
        this.isChecked = this.model.Checked;
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Override of the getWrapperElement method.
     * @returns kendo picker wrapper
     */
    getWrapperElement() {
        if (this.element && this.element.nativeElement) {
            return this.element.nativeElement.querySelector('.k-picker-wrap');
        }
        return undefined;
    }
    /**
     * Override of the getExtraElement method.
     * @returns kendo calendar select span.
     */
    getExtraElement() {
        if (this.element && this.element.nativeElement) {
            return this.element.nativeElement.querySelector('.k-select');
        }
        return undefined;
    }
    checkBoxChange(event) {
        this.isChecked = !this.model.Checked;
        this.valueChanged(event);
    }
    valueChanged(event) {
        this.checked = this.isChecked;
        this.ValueChanged.emit(new EventData$1(event, this.id));
    }
    open(event) {
        if (this.showCheckBox) {
            this.checked = true;
        }
        this.DropDown.emit(new EventData$1(event, this.id));
    }
    close(event) {
        this.CloseUp.emit(new EventData$1(event, this.id));
    }
    // Properties
    get value() {
        if (this.model.Value == null) {
            return this.model.Value;
        }
        const newDate = new Date(this.model.Value);
        if (this.date == null || this.date.getTime() !== newDate.getTime()) {
            this.date = newDate;
        }
        this.date = DatesUtils.normalizeDateFromServer(this.date);
        return this.date;
    }
    set value(value) {
        const tempDate = value != null ? DatesUtils.normalizeDateFromClient(value) : value;
        this.model.Value = tempDate != null ? tempDate.toISOString() : tempDate;
    }
    get format() {
        const currentFormat = this.model.Format;
        switch (currentFormat) {
            case DateFormat.Long:
                this.currentFormat = this.longDateFormat;
                this.wmFormat = this.longDateFormat;
                break;
            case DateFormat.Short:
                this.currentFormat = this.shortDateFormat;
                this.wmFormat = this.shortDateFormat;
                break;
            case DateFormat.Custom:
                this.currentFormat = this.model.CustomFormat;
                this.wmFormat = this.model.CustomFormat;
                break;
            default:
                this.currentFormat = this.shortDateFormat;
                this.wmFormat = this.timePickerFormat;
                break;
        }
        return this.model.Format;
    }
    getClassForCheckBoxDateInput() {
        return `datetimePicker ${this.showCheckBox ? 'checkBoxDateInput' : ''}`;
    }
    /**
     * Validate if only Datepicker should be disabled
     *
     * @return {*}  {boolean}
     * @memberof DatetimepickerComponent
     */
    disableDatePicker() {
        if (this.showCheckBox) {
            return !this.checked;
        }
        else {
            return this.disabled;
        }
    }
    /**
     * Handler for key down arrow left event
     *
     * @memberof DatetimepickerComponent
     * @param e
     */
    keyDownArrowLeftHandler(e) {
        e.preventDefault();
        if (document.activeElement === this.dtPickerInput &&
            this.dtPickerInput.selectionStart === 0 &&
            this.dtPickerInput.selectionStart === this.lastCursorPosition) {
            // Apply focus to checkbox when arrow left is pressed
            this.checkboxInput.focus();
        }
        else if (document.activeElement === this.checkboxInput) {
            // Apply focus to datetimepicker when arrow left is pressed
            this.dtPickerInput.focus();
        }
        this.lastCursorPosition = this.dtPickerInput.selectionStart;
    }
    /**
     * Handler for key down arrow right event
     *
     * @memberof DatetimepickerComponent
     * @param e
     */
    keyDownArrowRightHandler(e) {
        e.preventDefault();
        if (document.activeElement === this.dtPickerInput &&
            this.dtPickerInput.selectionEnd === this.dtPickerInput.value.length &&
            this.dtPickerInput.selectionEnd === this.lastCursorPosition) {
            // Apply focus to checkbox
            this.checkboxInput.focus();
        }
        else if (document.activeElement === this.checkboxInput) {
            // Apply focus to datetimepicker
            this.dtPickerInput.focus();
        }
        this.lastCursorPosition = this.dtPickerInput.selectionEnd;
    }
};
DatetimepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DatetimepickerComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: i1.WebMapService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DatetimepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DatetimepickerComponent, selector: "wm-datetimepicker", inputs: { model: "model" }, outputs: { ValueChanged: "ValueChanged", CloseUp: "CloseUp", DropDown: "DropDown" }, host: { listeners: { "keydown.arrowleft": "keyDownArrowLeftHandler($event)", "keydown.arrowright": "keyDownArrowRightHandler($event)" }, properties: { "attr.wm-format": "this.wmFormat" } }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"visible\" [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\">\r\n  <div *ngIf=\"model.ShowCheckBox\" class=\"k-checkbox-container\">\r\n    <input class=\"k-checkbox\" type=\"checkbox\" [disabled]=\"disabled\" [checked]=\"checked\"\r\n      (change)=\"checkBoxChange($event)\" wmTab [hostComponent]=\"this\"/>\r\n  </div>\r\n  <kendo-datepicker *ngIf=\"format != dateFormat.Time\" [(value)]=\"value\" [format]=\"currentFormat\"\r\n    (valueChange)=\"valueChanged($event)\" (open)=\"open($event)\" (close)=\"close($event)\" [readOnlyInput]=\"readOnlyInput\"\r\n    [ngClass]=\"getClassForCheckBoxDateInput()\" [disabled]=\"disableDatePicker()\" wmControls [hostComponent]=\"this\">\r\n  </kendo-datepicker>\r\n  <kendo-timepicker *ngIf=\"format == dateFormat.Time\" [(value)]=\"value\" (valueChange)=\"valueChanged($event)\"\r\n    (open)=\"open($event)\" (close)=\"close($event)\" [readOnlyInput]=\"readOnlyInput\"\r\n    [ngClass]=\"getClassForCheckBoxDateInput()\" [disabled]=\"disableDatePicker()\" [format]=\"timePickerFormat\"\r\n    wmControls [hostComponent]=\"this\">\r\n  </kendo-timepicker>\r\n</div>", styles: [".k-checkbox{margin:2px;z-index:1;position:absolute;width:16px}.checkBoxDateInput{padding-left:18px!important}.datetimePicker{width:100%;height:100%}.k-checkbox-container{width:16px;position:absolute}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i6$1.DatePickerComponent, selector: "kendo-datepicker", inputs: ["focusableId", "cellTemplate", "monthCellTemplate", "yearCellTemplate", "decadeCellTemplate", "centuryCellTemplate", "weekNumberTemplate", "headerTitleTemplate", "navigationItemTemplate", "activeView", "bottomView", "topView", "calendarType", "animateCalendarNavigation", "disabled", "readonly", "readOnlyInput", "popupSettings", "navigation", "min", "max", "incompleteDateValidation", "focusedDate", "value", "format", "twoDigitYearMax", "formatPlaceholder", "placeholder", "tabindex", "tabIndex", "disabledDates", "title", "subtitle", "rangeValidation", "disabledDatesValidation", "weekNumber", "size", "rounded", "fillMode", "adaptiveMode"], outputs: ["valueChange", "focus", "blur", "open", "close"], exportAs: ["kendo-datepicker"] }, { kind: "component", type: i6$1.TimePickerComponent, selector: "kendo-timepicker", inputs: ["focusableId", "disabled", "readonly", "readOnlyInput", "format", "formatPlaceholder", "placeholder", "min", "max", "incompleteDateValidation", "cancelButton", "nowButton", "steps", "popupSettings", "tabindex", "tabIndex", "title", "subtitle", "rangeValidation", "adaptiveMode", "value", "size", "rounded", "fillMode"], outputs: ["valueChange", "focus", "blur", "open", "close"], exportAs: ["kendo-timepicker"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }, { kind: "directive", type: TabDirective, selector: "[wmTab]", inputs: ["hostComponent"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('Checked'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], DatetimepickerComponent.prototype, "checked", null);
__decorate([
    serverEvent('ValueChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DatetimepickerComponent.prototype, "valueChanged", null);
__decorate([
    serverEvent('DropDown'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DatetimepickerComponent.prototype, "open", null);
__decorate([
    serverEvent('CloseUp'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DatetimepickerComponent.prototype, "close", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Value'),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], DatetimepickerComponent.prototype, "value", null);
DatetimepickerComponent = __decorate([
    dataTransfer(['dtp']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService,
        WebMapService])
], DatetimepickerComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DatetimepickerComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-datetimepicker', inputs: ['model'], template: "<div *ngIf=\"visible\" [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\">\r\n  <div *ngIf=\"model.ShowCheckBox\" class=\"k-checkbox-container\">\r\n    <input class=\"k-checkbox\" type=\"checkbox\" [disabled]=\"disabled\" [checked]=\"checked\"\r\n      (change)=\"checkBoxChange($event)\" wmTab [hostComponent]=\"this\"/>\r\n  </div>\r\n  <kendo-datepicker *ngIf=\"format != dateFormat.Time\" [(value)]=\"value\" [format]=\"currentFormat\"\r\n    (valueChange)=\"valueChanged($event)\" (open)=\"open($event)\" (close)=\"close($event)\" [readOnlyInput]=\"readOnlyInput\"\r\n    [ngClass]=\"getClassForCheckBoxDateInput()\" [disabled]=\"disableDatePicker()\" wmControls [hostComponent]=\"this\">\r\n  </kendo-datepicker>\r\n  <kendo-timepicker *ngIf=\"format == dateFormat.Time\" [(value)]=\"value\" (valueChange)=\"valueChanged($event)\"\r\n    (open)=\"open($event)\" (close)=\"close($event)\" [readOnlyInput]=\"readOnlyInput\"\r\n    [ngClass]=\"getClassForCheckBoxDateInput()\" [disabled]=\"disableDatePicker()\" [format]=\"timePickerFormat\"\r\n    wmControls [hostComponent]=\"this\">\r\n  </kendo-timepicker>\r\n</div>", styles: [".k-checkbox{margin:2px;z-index:1;position:absolute;width:16px}.checkBoxDateInput{padding-left:18px!important}.datetimePicker{width:100%;height:100%}.k-checkbox-container{width:16px;position:absolute}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: i1.WebMapService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { ValueChanged: [{
                type: Output
            }], CloseUp: [{
                type: Output
            }], DropDown: [{
                type: Output
            }], wmFormat: [{
                type: HostBinding,
                args: ['attr.wm-format']
            }], checked: [], valueChanged: [], open: [], close: [], value: [], keyDownArrowLeftHandler: [{
                type: HostListener,
                args: ['keydown.arrowleft', ['$event']]
            }], keyDownArrowRightHandler: [{
                type: HostListener,
                args: ['keydown.arrowright', ['$event']]
            }] } });

//
// Summary:
//     Specifies how an image is positioned within a System.Windows.Forms.PictureBox.
var PictureBoxSizeMode;
(function (PictureBoxSizeMode) {
    //
    // Summary:
    //     The image is placed in the upper-left corner of the System.Windows.Forms.PictureBox.
    //     The image is clipped if it is larger than the System.Windows.Forms.PictureBox
    //     it is contained in.
    PictureBoxSizeMode[PictureBoxSizeMode["Normal"] = 0] = "Normal";
    //
    // Summary:
    //     The image within the System.Windows.Forms.PictureBox is stretched or shrunk to
    //     fit the size of the System.Windows.Forms.PictureBox.
    PictureBoxSizeMode[PictureBoxSizeMode["StretchImage"] = 1] = "StretchImage";
    //
    // Summary:
    //     The System.Windows.Forms.PictureBox is sized equal to the size of the image that
    //     it contains.
    PictureBoxSizeMode[PictureBoxSizeMode["AutoSize"] = 2] = "AutoSize";
    //
    // Summary:
    //     The image is displayed in the center if the System.Windows.Forms.PictureBox is
    //     larger than the image. If the image is larger than the System.Windows.Forms.PictureBox,
    //     the picture is placed in the center of the System.Windows.Forms.PictureBox and
    //     the outside edges are clipped.
    PictureBoxSizeMode[PictureBoxSizeMode["CenterImage"] = 3] = "CenterImage";
    //
    // Summary:
    //     The size of the image is increased or decreased maintaining the size ratio.
    PictureBoxSizeMode[PictureBoxSizeMode["Zoom"] = 4] = "Zoom";
})(PictureBoxSizeMode || (PictureBoxSizeMode = {}));

let PictureBoxComponent = class PictureBoxComponent extends ControlContainerComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ);
        this.webMapService = webMapService;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.Click = new EventEmitter();
    }
    /* c8 ignore stop */
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.sizeMode === 2) {
            this.width = null;
            this.height = null;
        }
    }
    get source() {
        return this.model.Image;
    }
    set source(value) {
        this.model.Image = value;
    }
    /**
     * Return the array of CSS classes
     * to apply.
     */
    pictureBoxStyle() {
        const classes = this.class ? [this.class] : [];
        if (this.sizeMode === PictureBoxSizeMode.AutoSize) {
            classes.push('autoSize');
        }
        return classes;
    }
    /**
     * Return the array of CSS classes
     * to apply.
     */
    isValidSource() {
        return !!this.source;
    }
    /**
     * Returns dimension value depends on the size mode of the model
     */
    sizes() {
        switch (this.sizeMode) {
            case PictureBoxSizeMode.Zoom:
                return 'inherit';
            case PictureBoxSizeMode.AutoSize:
            case PictureBoxSizeMode.CenterImage:
            case PictureBoxSizeMode.Normal:
                return null;
            case PictureBoxSizeMode.StretchImage:
            default:
                return '100%';
        }
    }
    /**
     * Get sizeMode property from model
     */
    get sizeMode() {
        return this.model.SizeMode;
    }
    /**
     * Set sizeMode property from model
     */
    set sizeMode(value) {
        this.model.SizeMode = value;
    }
    click(event) {
        this.Click.emit(new EventData$1(event, this.id));
    }
};
PictureBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PictureBoxComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
PictureBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: PictureBoxComponent, selector: "wm-picturebox", inputs: { model: "model" }, outputs: { Click: "Click" }, viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #displayElement mwlDroppable (drop)=\"dragDrop($event)\" *ngIf=\"model\" wmControls [ngClass]=\"pictureBoxStyle()\" [hostComponent]=\"this\">\r\n    <img *ngIf=\"isValidSource()\" [src]=\"source\" [attr.disabled]=\"disabled\" [style.width]=\"sizes()\" [style.height]=\"sizes()\" (click)=\"click($event)\">\r\n    <ng-content></ng-content>\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n</div>\r\n", styles: ["div{overflow:hidden}::ng-deep .autoSize{width:-moz-fit-content!important;width:fit-content!important;height:-moz-fit-content!important;height:fit-content!important}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.DroppableDirective, selector: "[mwlDroppable]", inputs: ["dragOverClass", "dragActiveClass", "validateDrop"], outputs: ["dragEnter", "dragLeave", "dragOver", "drop"] }, { kind: "component", type: i3.ContainerComponent, selector: "wm-container", inputs: ["controls"], outputs: ["RemoveControl"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PictureBoxComponent.prototype, "source", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], PictureBoxComponent.prototype, "sizeMode", null);
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PictureBoxComponent.prototype, "click", null);
PictureBoxComponent = __decorate([
    dataTransfer(['picBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService])
], PictureBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PictureBoxComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-picturebox', inputs: ['model'], template: "<div #displayElement mwlDroppable (drop)=\"dragDrop($event)\" *ngIf=\"model\" wmControls [ngClass]=\"pictureBoxStyle()\" [hostComponent]=\"this\">\r\n    <img *ngIf=\"isValidSource()\" [src]=\"source\" [attr.disabled]=\"disabled\" [style.width]=\"sizes()\" [style.height]=\"sizes()\" (click)=\"click($event)\">\r\n    <ng-content></ng-content>\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n</div>\r\n", styles: ["div{overflow:hidden}::ng-deep .autoSize{width:-moz-fit-content!important;width:fit-content!important;height:-moz-fit-content!important;height:fit-content!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], Click: [{
                type: Output
            }], source: [], sizeMode: [], click: [] } });

let MaskedTextBoxComponent = class MaskedTextBoxComponent extends TextBoxBaseComponent {
    /* c8 ignore start */
    constructor(chDetector, rnderer2, elemt, webComponents, editMaskService, bringTopServi, service, containerInteraction) {
        super(chDetector, rnderer2, elemt, webComponents, bringTopServi);
        this.chDetector = chDetector;
        this.rnderer2 = rnderer2;
        this.elemt = elemt;
        this.editMaskService = editMaskService;
        this.bringTopServi = bringTopServi;
        this.service = service;
        this.containerInteraction = containerInteraction;
        this.DoubleClick = new EventEmitter();
        /**
         * Array of the previous dynamic styles applied
         */
        this.previousStyles = {};
        /**
         * Array of required dynamic properties that need to be applied to other element
         */
        this.dynamicStylesProps = ['background-color'];
        /**
         * Include literals property.
         * Default is true, if we need to support the skipLiterals we may need to change it.
         *
         * @memberof MaskedTextBoxComponent
         */
        this.includeLiterals = true;
    }
    ngAfterViewChecked() {
        this.passwordCharValue = this.passwordChar;
        super.ngAfterViewChecked();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.setDynamicStylesToInput(super.setMyStyle());
        this.toggleType();
        this.initialValueApplyMask();
    }
    ngDoCheck() {
        super.ngDoCheck();
        if (this.passwordCharValue !== this.model.PasswordChar) {
            this.toggleType();
        }
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        this.editMaskService.initializeMaskTransformation(this);
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    getDisplayElement() {
        /* c8 ignore else */
        if (this.elemt && this.elemt.nativeElement) {
            return this.elemt.nativeElement.querySelector('.k-input-inner');
        }
        return null;
    }
    /**
     * Returns a valid converted mask using the editMask service.
     *
     * @type {string}
     * @memberof MaskedTextBoxComponent
     */
    get mask() {
        if (this.editMaskService.serviceMaskChanged()) {
            this.editMaskService.initializeMaskTransformation(this);
        }
        return this.editMaskService.validMask;
    }
    /**
     * Sets the maskedtextbox's maks value in the model.
     */
    set mask(value) {
        this.model.Mask = value;
    }
    /**
     * Sets the maskedtextbox's passwordChar value
     */
    set passwordChar(value) {
        this.model.PasswordChar = value;
    }
    /**
     * Gets the maskedtextbox's passwordChar value
     */
    get passwordChar() {
        return this.model.PasswordChar;
    }
    /**
     * Gets the maskedtextbox's promptChar value
     */
    get promptChar() {
        return this.model.PromptChar ? this.model.PromptChar : '_';
    }
    /**
     * Sets the maskedtextbox's promptChar value
     */
    set promptChar(value) {
        this.model.PromptChar = value;
    }
    /**
     * Gets the maskedtextbox's maxLength value
     */
    get maxLength() {
        return this.model.MaxLength;
    }
    /**
     * Gets the maskedtextbox's readOnly value
     */
    get readOnly() {
        return this.model.ReadOnly;
    }
    /**
     * Sets the maskedtextbox's readOnly value
     */
    set readOnly(value) {
        this.model.ReadOnly = value;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    setMyStyle() {
        return this.model.Style?.Dirty
            ? this.setDynamicStylesToInput(super.setMyStyle())
            : super.setMyStyle();
    }
    /**
     * Sets dynamic styles to MaskedTextBox.
     * Some styles defined in dynamicStylesProps needs to be applied
     * only to input to have the same behavior as original app.
     */
    setDynamicStylesToInput(style) {
        const input = this.maskedTextBox?.input.nativeElement;
        const copyOfStyle = Object.assign({}, style);
        // Verifies that input is displayed and style has styles.
        /* c8 ignore else */
        if (input && copyOfStyle) {
            for (const key of this.dynamicStylesProps) {
                // Verifies that property of style exists.
                if (copyOfStyle[key]) {
                    this.rnderer2.setStyle(input, key, copyOfStyle[key]);
                    // Removes property of style that were added to span.
                    delete copyOfStyle[key];
                }
            }
        }
        return copyOfStyle;
    }
    /**
     * Overrides applyFocus method from Control component to
     * move the cursor to the start of the input.
     */
    applyFocus() {
        let start = this.model?.SelectionStart;
        let end = start + this.model?.SelectionLength > this.model?.Text.length
            ? this.model?.Text.length
            : start + this.model?.SelectionLength;
        if (this.model?.SelectionLength === this.model?.Text.length ||
            this.model?.Text.length === 0) {
            end = 0;
            start = 0;
        }
        if (this.focusableElement) {
            this.isApplyingFocus = true;
            this.focusableElement.setSelectionRange(start, end);
            this.focusableElement.focus();
            this.isApplyingFocus = false;
        }
    }
    /**
     * Changes the 'type' property of the input between text
     * and password if the response has the 'PasswordChar' property.
     */
    toggleType() {
        this.input = this.input
            ? this.input
            : this.maskedTextBox?.input.nativeElement;
        /* c8 ignore else */
        if (this.input != null) {
            if (this.passwordChar === null ||
                this.passwordChar === undefined ||
                this.passwordChar === '\u0000') {
                this.rnderer2.setAttribute(this.input, 'type', 'text');
            }
            else {
                this.rnderer2.setAttribute(this.input, 'type', 'password');
            }
        }
    }
    /**
     * Value change handler.
     *
     * @param {*} event
     * @memberof MaskedTextBoxComponent
     */
    valueChange(event) {
        this.transformAndUpdateValue();
    }
    /**
     * Applies the mask when the component initializes.
     *
     * @memberof MaskedTextBoxComponent
     */
    initialValueApplyMask() {
        this.transformAndUpdateValue(true);
    }
    /**
     * Transforms updates and process mask value.
     *
     * @param {boolean} [initial=false]
     * @memberof MaskedTextBoxComponent
     */
    transformAndUpdateValue(initial = false) {
        if (this.maskedTextBox) {
            const start = this.maskedTextBox.input.nativeElement.selectionStart;
            const end = this.maskedTextBox.input.nativeElement.selectionEnd;
            let valueChanged = this.editMaskService.verifyTransformation(this.maskedTextboxValue());
            const maskedValue = valueChanged;
            valueChanged =
                this.editMaskService.removePlaceholderFromString(valueChanged);
            this.text = maskedValue;
            if (!initial) {
                this.setNonInitialValues(maskedValue, valueChanged);
                this.updateMaskedSelectionString(start, end);
            }
        }
    }
    /**
     * Returns the masked textbox current value.
     *
     * @return {*}  {*}
     * @memberof MaskedTextBoxComponent
     */
    maskedTextboxValue() {
        return this.includeLiterals
            ? this.maskedTextBox.input?.nativeElement?.value
            : this.maskedTextBox.maskedValue;
    }
    /**
     * Sets values for the maskedTextbox when it is not the initial call.
     *
     * @param {string} maskedValue
     * @param {string} valueChanged
     * @memberof MaskedTextBoxComponent
     */
    setNonInitialValues(maskedValue, valueChanged) {
        if (this.maskedTextBox) {
            this.maskedTextBox.input.nativeElement.value = maskedValue;
            this.maskedTextBox.maskedValue = maskedValue;
            this.maskedTextBox.value = valueChanged;
        }
    }
    /**
     * Updates the selection.
     *
     * @param {number} start
     * @param {number} end
     * @memberof MaskedTextBoxComponent
     */
    updateMaskedSelectionString(start, end) {
        this.maskedTextBox.input.nativeElement.selectionEnd = end;
        this.maskedTextBox.input.nativeElement.selectionStart = start;
    }
    /**
     * Returns the mask value from the model.
     *
     * @readonly
     * @type {string}
     * @memberof MaskedTextBoxComponent
     */
    get modelMask() {
        return this.model.Mask;
    }
    /**
     * Handles the double click event.
     * @param event The event object.
     */
    doubleClick(event) {
        this.DoubleClick.emit(new EventData$1(event, this.id));
    }
};
MaskedTextBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MaskedTextBoxComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: EditMaskService }, { token: i3.BringTopService, optional: true }, { token: i1.WebMapService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
MaskedTextBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: MaskedTextBoxComponent, selector: "wm-maskedtextbox", inputs: { model: "model" }, outputs: { DoubleClick: "DoubleClick" }, providers: [EditMaskService], viewQueries: [{ propertyName: "maskedTextBox", first: true, predicate: ["maskedTextBox"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<kendo-maskedtextbox #maskedTextBox *ngIf=\"model\" [includeLiterals]=\"includeLiterals\" [mask]=\"mask\" [value]=\"text\"\r\n  (valueChange)=\"valueChange($event)\" [ngClass]=\"textBoxInputClass\" [disabled]=\"disabled\" [maskValidation]=\"false\"\r\n  [promptPlaceholder]=\"promptChar\" [(prompt)]=\"promptChar\" wmControls [hostComponent]=\"this\" [readonly]=\"readOnly\"\r\n  [ngStyle]=\"setMyStyle()\" (dblclick)=\"doubleClick($event)\" >\r\n</kendo-maskedtextbox>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i8.MaskedTextBoxComponent, selector: "kendo-maskedtextbox", inputs: ["focusableId", "disabled", "readonly", "title", "size", "rounded", "fillMode", "mask", "value", "rules", "prompt", "promptPlaceholder", "includeLiterals", "maskOnFocus", "maskValidation", "tabindex", "tabIndex"], outputs: ["focus", "blur", "valueChange"], exportAs: ["kendoMaskedTextBox"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('ReadOnly'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], MaskedTextBoxComponent.prototype, "readOnly", null);
__decorate([
    serverEvent('DoubleClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MaskedTextBoxComponent.prototype, "doubleClick", null);
MaskedTextBoxComponent = __decorate([
    dataTransfer(['mskTxtBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        EditMaskService,
        BringTopService,
        WebMapService,
        ContainerInteractionService])
], MaskedTextBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MaskedTextBoxComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-maskedtextbox', inputs: ['model'], providers: [EditMaskService], template: "<kendo-maskedtextbox #maskedTextBox *ngIf=\"model\" [includeLiterals]=\"includeLiterals\" [mask]=\"mask\" [value]=\"text\"\r\n  (valueChange)=\"valueChange($event)\" [ngClass]=\"textBoxInputClass\" [disabled]=\"disabled\" [maskValidation]=\"false\"\r\n  [promptPlaceholder]=\"promptChar\" [(prompt)]=\"promptChar\" wmControls [hostComponent]=\"this\" [readonly]=\"readOnly\"\r\n  [ngStyle]=\"setMyStyle()\" (dblclick)=\"doubleClick($event)\" >\r\n</kendo-maskedtextbox>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: EditMaskService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: i1.WebMapService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { maskedTextBox: [{
                type: ViewChild,
                args: ['maskedTextBox', { static: false }]
            }], DoubleClick: [{
                type: Output
            }], readOnly: [], doubleClick: [] } });

let TimerComponent = class TimerComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents) {
        super(changeDetector, renderer2, element, webComponents);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        /* c8 ignore stop */
        this.Tick = new EventEmitter();
    }
    /* c8 ignore next */
    timerTick() {
        if (this.enabled) {
            this.triggerTick({});
        }
    }
    /**
     * Triggers the event to the server  side
     * @param event The event data
     */
    triggerTick(event) {
        this.Tick.emit(new EventData$1(event, this.id));
    }
    // Properties
    get interval() {
        return this.model.Interval;
    }
    ngOnInit() {
        this.internalEnabled = this.enabled;
        /* c8 ignore else*/
        if (this.model && this.enabled) {
            this.timerComponent = setInterval(() => {
                this.timerTick();
            }, this.interval);
        }
    }
    ngOnDestroy() {
        /* c8 ignore else*/
        if (this.timerComponent) {
            clearInterval(this.timerComponent);
        }
    }
    ngDoCheck() {
        super.ngDoCheck();
        // check to verify if the timer model was actually passed
        /* c8 ignore else */
        if (this.model) {
            /* c8 ignore else */
            if (this.enabled !== this.internalEnabled) {
                if (this.enabled) {
                    this.ngOnInit();
                }
                else {
                    /* c8 ignore else */
                    if (this.timerComponent) {
                        clearInterval(this.timerComponent);
                    }
                    this.internalEnabled = this.enabled;
                }
            }
        }
    }
};
TimerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TimerComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }], target: i0.ɵɵFactoryTarget.Component });
TimerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TimerComponent, selector: "wm-timer", inputs: { model: "model" }, outputs: { Tick: "Tick" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"enabled && model\"></div>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    serverEvent('Tick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TimerComponent.prototype, "triggerTick", null);
TimerComponent = __decorate([
    dataTransfer(['tmr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService])
], TimerComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TimerComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-timer', inputs: ['model'], template: "<div *ngIf=\"enabled && model\"></div>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }]; }, propDecorators: { Tick: [{
                type: Output
            }], triggerTick: [] } });

/**
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/panel/panel.html</example-url>
 */
let PanelComponent = class PanelComponent extends ControlContainerComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webMapService, webComponents, bringTopServ) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.webMapService = webMapService;
        this.bringTopServ = bringTopServ;
        /* c8 ignore stop */
        /**
         * Determines that it is a container.
         */
        this.isContainer = true;
        /* Constants */
        this.formElement = null;
        /**
         * Internal id of panel component
         */
        this.internalName = '';
    }
    /**
     * Input  of panel component
     * Gets the id of the current panelcomponent
     * Since we receive the window model then we can
     * get the panel parent model using the id value
     */
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set name(value) {
        this.internalName = value;
    }
    /**
     * Gets id
     */
    get name() {
        return this.internalName;
    }
    /**
     * Gets tab order
     */
    get tabOrder() {
        return this.calculateTabOrder();
    }
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    /**
     * @description
     * It triggers pending views mechanism to reopen windows
     * inside the panel.
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.webMapService.core
            .getEvent()
            .publish(Events.ReloadPendingViews, this.id);
    }
    /**
     * Function to return controls collection for the html bind.
     * @param model The model.
     */
    getControlObjects(model) {
        if (this.windowModel && this.windowModel[this.name]) {
            return this.windowModel[this.name].Controls;
        }
        else if (model.Controls) {
            return model.Controls;
        }
        return null;
    }
};
PanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PanelComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i1.WebMapService }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
PanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: PanelComponent, selector: "wm-panel", inputs: { model: "model", name: ["id", "name"], windowModel: "windowModel" }, providers: [ContainerTabOrderService], viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<fieldset [ngStyle]=\"setMyStyle()\" #displayElement *ngIf=\"model\" [disabled]=\"disabled\" class=\"wm-panel\"\r\n  [ngClass]=\"class\" wmControls [hostComponent]=\"this\">\r\n  <wm-formscontainer [parentId]=\"id\"></wm-formscontainer>\r\n  <ng-content></ng-content>\r\n  <wm-custom-control-container [windowModel]=\"windowModel\" (RemoveControl)=\"removeControlHandler($event)\"\r\n    [controls]=\"getControlObjects(model)\">\r\n  </wm-custom-control-container>\r\n</fieldset>", styles: ["wm-formscontainer{position:absolute;width:100%;height:auto;top:0;left:0;overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i3.FormsContainerComponent, selector: "wm-formscontainer", inputs: ["parentId"], outputs: ["Loaded"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }, { kind: "component", type: CustomControlContainerComponent, selector: "wm-custom-control-container", inputs: ["controls", "containerParent", "windowModel", "controlType"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
PanelComponent = __decorate([
    dataTransfer(['pnl']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebMapService,
        WebComponentsService,
        BringTopService])
], PanelComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PanelComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-panel', inputs: ['model'], providers: [ContainerTabOrderService], template: "<fieldset [ngStyle]=\"setMyStyle()\" #displayElement *ngIf=\"model\" [disabled]=\"disabled\" class=\"wm-panel\"\r\n  [ngClass]=\"class\" wmControls [hostComponent]=\"this\">\r\n  <wm-formscontainer [parentId]=\"id\"></wm-formscontainer>\r\n  <ng-content></ng-content>\r\n  <wm-custom-control-container [windowModel]=\"windowModel\" (RemoveControl)=\"removeControlHandler($event)\"\r\n    [controls]=\"getControlObjects(model)\">\r\n  </wm-custom-control-container>\r\n</fieldset>", styles: ["wm-formscontainer{position:absolute;width:100%;height:auto;top:0;left:0;overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1.WebMapService }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { name: [{
                type: Input,
                args: ['id']
            }], windowModel: [{
                type: Input
            }], displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }] } });

let RadiobuttonComponent = class RadiobuttonComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, webmapService, renderer2, element, webComponents, bringTopServ, containerInteraction, shortcutsService) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, shortcutsService);
        this.changeDetector = changeDetector;
        this.webmapService = webmapService;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.shortcutsService = shortcutsService;
        this.CheckedChanged = new EventEmitter();
    }
    set displayElementRadio(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /* c8 ignore next */
    ngOnInit() {
        super.ngOnInit();
        this.shortcutsService?.registerInstance(this);
        this.uncheckedSubscription = this.webmapService.core
            .getEvent()
            .subscribe('unchecked', (event) => {
            this.uncheckedHandler(event);
        });
    }
    /**
     * On Destroy method
     * Here we need to unsubscribe to all subscriptions of the component to avoid issues
     * @memberof RadiobuttonComponent
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.shortcutsService?.unregisterInstance(this);
        /* c8 ignore next */
        if (this.uncheckedSubscription) {
            this.webmapService.core
                .getEvent()
                .unSubscribe(this.uncheckedSubscription);
            this.webmapService.core.getEvent().subscribe('unchecked', (event) => {
                this.uncheckedHandler(event);
            });
        }
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    // Values
    set checked(checked) {
        this.model.Checked = checked;
    }
    get checked() {
        return this.model.Checked;
    }
    get appearance() {
        return this.model.Appearance;
    }
    // Events
    change(event) {
        super.change(event);
        event['parentName'] = this.parentName;
        this.webmapService.core.getEvent().publish('unchecked', event);
        this.checked = event.target.checked;
        this.CheckedChanged.emit(new EventData$1(event, this.id));
    }
    uncheckedHandler(event) {
        if (event.parentName !== this.parentName) {
            return;
        }
        /* c8 ignore else */
        if (this.checked) {
            this.checked = false;
            this.triggeringUncheckedEvent(event);
        }
    }
    triggeringUncheckedEvent(event) {
        this.CheckedChanged.emit(new EventData$1(event, this.id));
    }
    get checkAlign() {
        return this.model.CheckAlign;
    }
    getAlignmentClass() {
        switch (this.checkAlign) {
            case ContentAlignment.MiddleRight:
                return ' checkMiddleRight';
            case ContentAlignment.BottomRight:
                return ' checkBottomRight';
            default:
                return '';
        }
    }
    getClassForRadioButton() {
        let cssClass = this.class;
        if (this.appearance === 'Button') {
            cssClass += ' radioAsButton';
        }
        cssClass += this.getAlignmentClass();
        return cssClass;
    }
    get image() {
        return this.model.Image;
    }
    /**
     * Override the property Text to remove the ampersand
     */
    get text() {
        return RemoveAmpersand.remove(this.model.Text, this.showUnderline);
    }
    get parentName() {
        return this.model.ParentName;
    }
    /**
     * Gets string indicating the type
     * @returns type
     */
    getType() {
        return 'RadiobuttonComponent';
    }
};
RadiobuttonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RadiobuttonComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.WebMapService }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: ShortcutsService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
RadiobuttonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: RadiobuttonComponent, selector: "wm-radiobutton", inputs: { model: "model" }, outputs: { CheckedChanged: "CheckedChanged" }, viewQueries: [{ propertyName: "displayElementRadio", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #displayElement *ngIf=\"model\" [ngClass]=\"getClassForRadioButton()\" wmControls [hostComponent]=\"this\"\r\n  [ngStyle]=\"setMyStyle()\" tabindex=\"-1\">\r\n  <input type=\"radio\" [name]=\"parentName\" [id]=\"id\" class=\"k-radio\" [disabled]=\"disabled\" [checked]=\"checked\" />\r\n  <label class=\"k-radio-label\" for={{id}} [innerHTML]=\"text\"></label>\r\n</div>", styles: [".radioAsButton label{display:inline-block;background-color:#e4e4e4;text-align:center;padding:5px;border:1px solid rgba(0,0,0,.2);transition:all .1s ease-in-out;width:100%;box-sizing:border-box;height:100%}.radioAsButton label:hover{cursor:pointer}.radioAsButton input:checked+label{background-color:#ff6358;box-shadow:none}.radioAsButton .k-radio-label:before,.radioAsButton .k-radio-label:after{display:none!important}.checkMiddleRight>input{float:right}.checkBottomRight>input{float:right;bottom:-5px}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i8$2.LabelDirective, selector: "label[for]", inputs: ["for"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('Checked'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], RadiobuttonComponent.prototype, "checked", null);
__decorate([
    serverEvent('CheckedChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], RadiobuttonComponent.prototype, "change", null);
__decorate([
    serverEvent('CheckedChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], RadiobuttonComponent.prototype, "triggeringUncheckedEvent", null);
RadiobuttonComponent = __decorate([
    dataTransfer(['rdRtn']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        WebMapService,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService,
        ShortcutsService])
], RadiobuttonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RadiobuttonComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-radiobutton', inputs: ['model'], template: "<div #displayElement *ngIf=\"model\" [ngClass]=\"getClassForRadioButton()\" wmControls [hostComponent]=\"this\"\r\n  [ngStyle]=\"setMyStyle()\" tabindex=\"-1\">\r\n  <input type=\"radio\" [name]=\"parentName\" [id]=\"id\" class=\"k-radio\" [disabled]=\"disabled\" [checked]=\"checked\" />\r\n  <label class=\"k-radio-label\" for={{id}} [innerHTML]=\"text\"></label>\r\n</div>", styles: [".radioAsButton label{display:inline-block;background-color:#e4e4e4;text-align:center;padding:5px;border:1px solid rgba(0,0,0,.2);transition:all .1s ease-in-out;width:100%;box-sizing:border-box;height:100%}.radioAsButton label:hover{cursor:pointer}.radioAsButton input:checked+label{background-color:#ff6358;box-shadow:none}.radioAsButton .k-radio-label:before,.radioAsButton .k-radio-label:after{display:none!important}.checkMiddleRight>input{float:right}.checkBottomRight>input{float:right;bottom:-5px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WebMapService }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementRadio: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], CheckedChanged: [{
                type: Output
            }], checked: [], change: [], triggeringUncheckedEvent: [] } });

let ListViewDetailsComponent = class ListViewDetailsComponent extends ListViewBaseComponent {
    /* c8 ignore start */
    constructor(service1, changeDetector1, renderer1, element1, webComponents1, bringTopServ1, containerInteraction2) {
        super(service1, changeDetector1, renderer1, element1, webComponents1, bringTopServ1, containerInteraction2);
        this.service1 = service1;
        this.changeDetector1 = changeDetector1;
        this.renderer1 = renderer1;
        this.element1 = element1;
        this.bringTopServ1 = bringTopServ1;
        this.containerInteraction2 = containerInteraction2;
        this.isRowSelected = this.isRowSelected.bind(this);
    }
    /* c8 ignore stop */
    ngOnInit() {
        super.ngOnInit();
    }
    /**
     * Get the listview's Columns object
     *@property Columns r
     */
    loadColumns() {
        this.service1.fetch(this.getColumnsUrl, this.id).subscribe((data) => {
            this.columns = data;
            this.detectChanges();
        });
    }
    /**
     * Get the listview's Groups object
     * @property Groups r
     */
    loadGroups() {
        this.service1.fetch(this.getGroupsUrl, this.id).subscribe((data) => {
            this.groupsData = data;
            this.detectChanges();
        });
    }
    get itemData() {
        return this.model.itemData;
    }
    set itemData(value) {
        this.model.itemData = value;
    }
    /**
     * Gets checked
     * @param dataItem
     * @returns true if checked
     */
    getChecked(dataItem) {
        /* To-do: Review if its possible to change the response to send the Checked as boolean.
        Also, review to remove checkedInxInternalObj collection from component (review dataItem binding on template)
        */
        return dataItem.Checked != null && dataItem.Checked === 'true';
    }
    /**
     * Fetchs items
     * @property Items r
     */
    fetchItems() {
        this.loadingData = true;
        this.service1.fetch(this.fetchItemsUrl, this.id).subscribe((data) => {
            this.items = undefined;
            this.imageUrls = [];
            this.itemsId = [];
            if (data && data.length > 0) {
                const dataArray = [];
                const imageUrlsArray = [];
                this.fetchItemsInternal(data, dataArray, imageUrlsArray);
                const dataOptions = {};
                if (this.hasGroups) {
                    dataOptions.group = this.groups;
                }
                else {
                    this.groups = [];
                }
                this.updateSelectedIndices();
                this.itemData = dataArray;
                this.items = process(dataArray, dataOptions);
                this.imageUrls = imageUrlsArray;
                this.itemsId = data;
            }
            this.loadingData = false;
            this.detectChanges();
        });
    }
    fetchItemsInternal(data, dataArray, imageUrlsArray) {
        let item;
        this.selIdxInternalObj = {};
        for (let index = 0; index < data.length; index++) {
            item = data[index];
            if (item.data.Checked == 'true') {
                this.checkedInxInternalObj[index] = index;
            }
            else {
                delete this.checkedInxInternalObj[index];
            }
            if (item.data.Selected == 'true') {
                this.selIdxInternalObj[index] = index;
            }
            else {
                delete this.selIdxInternalObj[index];
            }
            dataArray.push(item.data);
            if (item.imageUrl) {
                imageUrlsArray.push({ Url: item.imageUrl, Index: index });
            }
            delete item.data;
            delete item.imageUrl;
        }
    }
    updateSelectedIndices() {
        const currentIndices = this.selIdxInternalObj;
        this.selectedIndices = Object.keys(currentIndices).map(function (idx) {
            return currentIndices[idx];
        });
    }
    /**
     * Returns the icon for the listviewitem
     * @param rowIndex the rowIndex of the cell
     * @param columnIndex the columnIndex of the cell
     */
    isValidIcon(columnIndex) {
        return columnIndex === 0 && this.imageUrls.length > 0;
    }
    /**
     * Returns the icon for the treenode
     * @param rowIndex the index of the item
     */
    iconStyle(rowIndex) {
        this.iconStyleSize();
        const returnValue = {
            height: this.iconHeight,
            'margin-right': '4px',
            width: this.iconWidth,
            display: 'inline-block'
        };
        const image = this.imageUrls.find((element) => {
            return element.Index === rowIndex;
        });
        if (image && image.Url && image.Url.length > 0) {
            returnValue['background-image'] = image.Url;
        }
        return returnValue;
    }
    /**
     * Sets the treeNode icon dimension
     */
    iconStyleSize() {
        if (this.model.SmallImageListSize !== undefined) {
            const dimSplitted = this.model.SmallImageListSize.split(',');
            if (dimSplitted.length > 1) {
                this.iconWidth = `${dimSplitted[0].trim()}px`;
                this.iconHeight = `${dimSplitted[1].trim()}px`;
            }
        }
    }
    /**
     * Item click handler
     *
     * @param {*} event
     * @memberof ListViewDetailsComponent
     */
    itemClickHandler(event, rowIndex) {
        const eventData = new EventData$1(event, this.id);
        let index;
        if (rowIndex != null) {
            index = rowIndex;
        }
        else if (event.rowIndex != null) {
            index = event.rowIndex;
        }
        else {
            index = event.index;
        }
        eventData['listViewItem'] = this.itemsId[index].Id;
        this.itemClick(eventData);
        this.itemActivationHandler(event, index);
    }
    /**
     * Function to support the "Gridlines" property that
     * hides or shows the grid lines in the "listview".
     *
     * @return {*}  {string}
     * @memberof ListViewDetailsComponent
     */
    gridLinesStyle() {
        return this.model.GridLines ? '' : 'grid-lines-hide';
    }
    /**
     * This manage the hover on the cells
     *
     * @param {*} event
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @memberof ListViewDetailsComponent
     */
    hoverSelectionMechanism(event, rowIndex, columnIndex) {
        event.stopImmediatePropagation();
        if (this.hoverSelection) {
            this.selectOnHover(event, rowIndex, columnIndex);
            this.selectedIndexChanged({});
        }
    }
    /**
     * Method to manage the hover depending on the ctrlKey
     *
     * @param {MouseEvent} event
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @memberof ListViewDetailsComponent
     */
    selectOnHover(event, rowIndex, columnIndex) {
        if (event.ctrlKey) {
            const existingIndex = this.selectedIndices.findIndex((el) => el === rowIndex);
            if (existingIndex === -1) {
                this.selectedIndices.push(rowIndex);
            }
            else {
                this.selectedIndices.splice(existingIndex, 1);
            }
        }
        else {
            this.selectedIndices = [rowIndex];
        }
        this.selIdxInternalObj = this.selectedIndices;
    }
    /**
     * Triggers the events associated with the doubleClick.
     * Events: ItemCheck, itemActivate and doubleClick.
     *
     * @param {MouseEvent} event
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @memberof ListViewDetailsComponent
     */
    triggerDoubleClickEvents(event, rowIndex, columnIndex) {
        /* c8 ignore else */
        if (this.checkboxes && columnIndex === 1) {
            event.stopPropagation();
            this.itemCheck(event, rowIndex);
        }
        this.itemActivationHandler(event, rowIndex, true);
        this.doubleClick(event);
    }
};
ListViewDetailsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListViewDetailsComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ListViewDetailsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ListViewDetailsComponent, selector: "wm-listview-details", usesInheritance: true, ngImport: i0, template: "<kendo-grid [data]=\"items\" *ngIf=\"model\" [group]=\"groups\" [selectable]=\"true\" [ngClass]=\"[class, gridLinesStyle()]\"\r\n  (click)=\"click($event)\" [resizable]=\"true\" [hideHeader]=\"hideHeaders\" \r\n  (selectionChange)=\"itemSelectionChanged($event)\" (cellClick)=\"itemClickHandler($event)\" wmControls\r\n  [hostComponent]=\"this\" [attr.disabled]=\"disabled\" [rowSelected]=\"isRowSelected\" [loading]=\"loadingData\"\r\n  kendoGridSelectBy>\r\n  <kendo-grid-checkbox-column *ngIf=\"checkboxes\" width=\"42\">\r\n    <ng-template kendoGridCellTemplate let-rowIndex=\"rowIndex\" let-dataItem=\"dataItem\">\r\n      <input type=\"checkbox\" [ngModel]=\"getChecked(dataItem)\" (click)=\"itemCheck($event, rowIndex)\" />\r\n    </ng-template>\r\n  </kendo-grid-checkbox-column>\r\n  <kendo-grid-column *ngFor=\"let column of columns\" [field]=\"column.field\" [title]=\"column.title\"\r\n    [hidden]=\"column.hidden\">\r\n    <ng-template kendoGridGroupHeaderTemplate let-value=\"value\">\r\n      {{getGroupHeader(value)}}\r\n    </ng-template>\r\n    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex=\"rowIndex\" let-columnIndex=\"columnIndex\">\r\n      <div (mouseover)=\"hoverSelectionMechanism($event, rowIndex, columnIndex)\" (dblclick)=\"triggerDoubleClickEvents($event, rowIndex, columnIndex)\" [ngClass]=\"getPointerClass()\">\r\n        <span *ngIf=\"isValidIcon(columnIndex)\" [ngStyle]=\"iconStyle(rowIndex)\"></span>\r\n          <a href=\"javascript:;\" *ngIf=\"hasHotTrackingAndSelected(rowIndex)\" [style.text-decoration]=\"'underline'\" (click)=\"itemClickHandler($event, rowIndex)\">{{dataItem[column.field]}}</a>\r\n        <span *ngIf=\"!hasHotTrackingAndSelected(rowIndex)\">{{dataItem[column.field]}}</span>\r\n      </div>\r\n    </ng-template>\r\n  </kendo-grid-column>\r\n</kendo-grid>\r\n", styles: [".pointerCursor *{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i6.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i7$1.GridComponent, selector: "kendo-grid", inputs: ["data", "pageSize", "height", "rowHeight", "detailRowHeight", "skip", "scrollable", "selectable", "sort", "size", "trackBy", "filter", "group", "virtualColumns", "filterable", "sortable", "pageable", "groupable", "navigable", "navigatable", "autoSize", "rowClass", "rowSticky", "rowSelected", "cellSelected", "resizable", "reorderable", "loading", "columnMenu", "hideHeader", "isDetailExpanded", "isGroupExpanded"], outputs: ["filterChange", "pageChange", "groupChange", "sortChange", "selectionChange", "dataStateChange", "groupExpand", "groupCollapse", "detailExpand", "detailCollapse", "edit", "cancel", "save", "remove", "add", "cellClose", "cellClick", "pdfExport", "excelExport", "columnResize", "columnReorder", "columnVisibilityChange", "columnLockedChange", "columnStickyChange", "scrollBottom", "contentScroll"], exportAs: ["kendoGrid"] }, { kind: "directive", type: i7$1.SelectionDirective, selector: "[kendoGridSelectBy]" }, { kind: "directive", type: i7$1.GroupHeaderTemplateDirective, selector: "[kendoGridGroupHeaderTemplate]" }, { kind: "component", type: i7$1.ColumnComponent, selector: "kendo-grid-column", inputs: ["field", "format", "sortable", "groupable", "editor", "filter", "filterable", "editable"] }, { kind: "component", type: i7$1.CheckboxColumnComponent, selector: "kendo-grid-checkbox-column", inputs: ["showSelectAll"] }, { kind: "directive", type: i7$1.CellTemplateDirective, selector: "[kendoGridCellTemplate]" }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
ListViewDetailsComponent = __decorate([
    dataTransfer(['lstVwItm']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], ListViewDetailsComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListViewDetailsComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-listview-details', template: "<kendo-grid [data]=\"items\" *ngIf=\"model\" [group]=\"groups\" [selectable]=\"true\" [ngClass]=\"[class, gridLinesStyle()]\"\r\n  (click)=\"click($event)\" [resizable]=\"true\" [hideHeader]=\"hideHeaders\" \r\n  (selectionChange)=\"itemSelectionChanged($event)\" (cellClick)=\"itemClickHandler($event)\" wmControls\r\n  [hostComponent]=\"this\" [attr.disabled]=\"disabled\" [rowSelected]=\"isRowSelected\" [loading]=\"loadingData\"\r\n  kendoGridSelectBy>\r\n  <kendo-grid-checkbox-column *ngIf=\"checkboxes\" width=\"42\">\r\n    <ng-template kendoGridCellTemplate let-rowIndex=\"rowIndex\" let-dataItem=\"dataItem\">\r\n      <input type=\"checkbox\" [ngModel]=\"getChecked(dataItem)\" (click)=\"itemCheck($event, rowIndex)\" />\r\n    </ng-template>\r\n  </kendo-grid-checkbox-column>\r\n  <kendo-grid-column *ngFor=\"let column of columns\" [field]=\"column.field\" [title]=\"column.title\"\r\n    [hidden]=\"column.hidden\">\r\n    <ng-template kendoGridGroupHeaderTemplate let-value=\"value\">\r\n      {{getGroupHeader(value)}}\r\n    </ng-template>\r\n    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex=\"rowIndex\" let-columnIndex=\"columnIndex\">\r\n      <div (mouseover)=\"hoverSelectionMechanism($event, rowIndex, columnIndex)\" (dblclick)=\"triggerDoubleClickEvents($event, rowIndex, columnIndex)\" [ngClass]=\"getPointerClass()\">\r\n        <span *ngIf=\"isValidIcon(columnIndex)\" [ngStyle]=\"iconStyle(rowIndex)\"></span>\r\n          <a href=\"javascript:;\" *ngIf=\"hasHotTrackingAndSelected(rowIndex)\" [style.text-decoration]=\"'underline'\" (click)=\"itemClickHandler($event, rowIndex)\">{{dataItem[column.field]}}</a>\r\n        <span *ngIf=\"!hasHotTrackingAndSelected(rowIndex)\">{{dataItem[column.field]}}</span>\r\n      </div>\r\n    </ng-template>\r\n  </kendo-grid-column>\r\n</kendo-grid>\r\n", styles: [".pointerCursor *{cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; } });

/* c8 ignore next */
let KendoComponent = class KendoComponent {
    constructor(differs, elementRef, widgetName) {
        this.differs = differs;
        this.elementRef = elementRef;
        this.widgetName = widgetName;
        this.prefix = 'applyRefresh';
        this.isViewInitialized = false;
        this.eventQueue = [];
        this.element = elementRef.nativeElement;
    }
    /**
     * Return boundValue.
     */
    get bound() {
        return this.boundValue;
    }
    /**
     * @param value Cotains a new boundValue.
     */
    set bound(value) {
        this.boundValue = value;
    }
    /**
     * This sets a new model if the model changes
     * @param value Value contains a new modelValue
     */
    set model(value) {
        this.modelValue = value;
        if (!this.differences && this.differs && value) {
            this.differences = this.differs.find(this.modelValue).create();
        }
    }
    /**
     * Render method is the one in charge to set a refecence of k-widget and widget.
     */
    render() {
        this.kWidget = kendo.jQuery(this.element)[this.widgetName](this.bound);
        this.widget = kendo.jQuery(this.element).data(this.widgetName);
    }
    /**
     * This is part of Angular lifecycle hook.
     * By definition this is the one who detect and act upon changes that Angular can not or will not detect on its own.
     * ngDoCheck notifies when model changes and send to applyChanges() method the changes.
     */
    ngDoCheck() {
        if (this.differences) {
            const changes = this.differences.diff(this.modelValue);
            if (changes) {
                this.applyChanges(changes);
            }
        }
    }
    /**
     * This is part of Angular lifecycle hook.
     * By definition this is the one who destroys a component.
     * ngOnDestroy gets the native element reference and destroy its widget.
     */
    ngOnDestroy() {
        const kElement = kendo.jQuery(this.element);
        if (kElement.data(this.widgetName)) {
            kElement.data(this.widgetName).destroy();
            kElement.empty();
        }
    }
    /**
     *  This function is a merge between a component property and a function,
        you have to use registerFunction when you need to execute a function after some property change
     * @param property Contains the name of the property that you want to register,
       this string must has the first letter as a capital letter in order to follow the model's properties structure.
     * @param fn contains the function required to call.
     */
    registerFunction(property, fn) {
        const functionName = this.prefix + property;
        this[functionName] = fn;
    }
    /**
     * This is part of Angular lifecycle hook.
     * By definition this is Called once after the first ngAfterContentChecked().
     * Our ngAfterViewInit is the one incharge to process the eventQueue array whe the view is initialized.
     */
    ngAfterViewInit() {
        this.isViewInitialized = true;
        this.eventQueue.forEach((element) => {
            this[element['functionName']](element['value']);
        });
    }
    /**
     * This method apply changes when any of the following actions in the model is triggered:
       forEachRemovedItem: Something has been removed.
       forEachAddedItem: Something has been added.
       forEachChangedItem: Something has been changed.
     * @param changes Value with any change in the model
     */
    applyChanges(changes) {
        changes.forEachRemovedItem((record) => this.updateComponent(record.key, null));
        changes.forEachAddedItem((record) => this.updateComponent(record.key, record.currentValue));
        changes.forEachChangedItem((record) => this.updateComponent(record.key, record.currentValue));
    }
    /**
     * This function builds a registered function and push it to eventQueue array.
     * @param key KeyValue corresponding to a property Name.
     * @param value CurrentValue of a function.
     */
    updateComponent(key, value) {
        const propertyName = normalizeName(key);
        const functionName = this.prefix + propertyName;
        if (this[functionName]) {
            if (!this.isViewInitialized) {
                this.eventQueue.push({ functionName, value });
            }
            else {
                this[functionName](value);
            }
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], KendoComponent.prototype, "bound", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], KendoComponent.prototype, "model", null);
KendoComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [KeyValueDiffers,
        ElementRef, String])
], KendoComponent);
/**
 * This function sets name with the proper structure to be readed.
 * @param name  property Name
 */
/* c8 ignore next */
function normalizeName(name) {
    let rname = 'dummy';
    try {
        rname = name.replace(/[\./]/g, '_');
    }
    catch (exception) {
        WMLogger.instance().error(exception);
    }
    return rname;
}

let KendoListBoxComponent = class KendoListBoxComponent extends KendoComponent {
    constructor(ref, keyValueDiffer) {
        super(keyValueDiffer, ref, 'kendoListBox');
        this.ref = ref;
        this.keyValueDiffer = keyValueDiffer;
    }
    ngOnInit() {
        this.render();
    }
};
KendoListBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KendoListBoxComponent, deps: [{ token: i0.ElementRef }, { token: i0.KeyValueDiffers }], target: i0.ɵɵFactoryTarget.Component });
KendoListBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: KendoListBoxComponent, selector: "[data-role=listbox]", inputs: { model: "model", bound: "bound", role: "role" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
KendoListBoxComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ElementRef,
        KeyValueDiffers])
], KendoListBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KendoListBoxComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    // tslint:disable-next-line:component-selector
                    // eslint-disable-next-line @angular-eslint/component-selector
                    selector: '[data-role=listbox]',
                    template: '<ng-content></ng-content>',
                    inputs: ['model', 'bound']
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.KeyValueDiffers }]; }, propDecorators: { role: [{
                type: Input
            }] } });

/**
 *Allows selecting only one item.
 *Single = 0,
 *Allows selecting multiple items
 *Multiple = 1
 */
var SelectionMode;
(function (SelectionMode) {
    SelectionMode[SelectionMode["single"] = 0] = "single";
    SelectionMode[SelectionMode["multiple"] = 1] = "multiple";
})(SelectionMode || (SelectionMode = {}));
let ListViewListComponent = class ListViewListComponent extends ListViewBaseComponent {
    /* c8 ignore start */
    constructor(service1, changeDetector1, renderer1, element1, webComponents1, bringTopServ1, containerInteraction2) {
        super(service1, changeDetector1, renderer1, element1, webComponents1, bringTopServ1, containerInteraction2);
        this.service1 = service1;
        this.changeDetector1 = changeDetector1;
        this.renderer1 = renderer1;
        this.element1 = element1;
        this.bringTopServ1 = bringTopServ1;
        this.containerInteraction2 = containerInteraction2;
        this.fetchItems = this.fetchItems.bind(this);
        this.dataurlable = this.dataurlable.bind(this);
        this.selectableFun = this.selectableFun.bind(this);
        this.disabledKendo = this.disabledKendo.bind(this);
        this.itemSelectionChanged = this.itemSelectionChanged.bind(this);
        this.triggerDoubleClickEvents = this.triggerDoubleClickEvents.bind(this);
        changeDetector1.markForCheck();
    }
    ngOnInit() {
        if (this.listboxEl) {
            super.ngOnInit();
            this.registerFunctions();
        }
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.fetchItems();
    }
    /**
     * Fetch listbox items.
     * @property Items r
     */
    fetchItems() {
        this.service1
            .fetch(this.fetchItemsUrl, this.id)
            .subscribe((data) => {
            this.itemsId = [];
            this.items = this.processFetchItemsResponse(data);
            if (this.listboxEl['widget']) {
                this.listboxEl['widget'].setDataSource(this.items);
                this.disabledKendo();
                this.selectableFun();
                this.setSelected();
                this.listboxEl['widget'].wrapper.find('.k-list').off('dblclick');
                this.listboxEl['widget'].wrapper
                    .find('.k-list')
                    .on('dblclick', '.k-list-item', this.triggerDoubleClickEvents);
            }
            this.itemsId = data;
        });
    }
    /**
     * Triggers the events associated with the doubleClick.
     * Events: itemActivate and doubleClick.
     *
     * @param {*} event
     * @memberof ListViewListComponent
     */
    triggerDoubleClickEvents(event) {
        const dataItem = this.listboxEl['widget'].dataItem(event.target);
        const index = this.listboxEl['widget'].dataItems().indexOf(dataItem);
        this.itemActive(event, index);
        this.doubleClick(event);
    }
    /**
     * return model selectable.
     */
    selectionMode() {
        return SelectionMode[this.model.SelectionMode];
    }
    /**
     * Selectable function .
     * @param selection sel could be single or multiple in order to select listbox items.
     */
    selectableFun() {
        this.listboxEl['widget'].selectable.options.multiple =
            SelectionMode[this.selectionMode()];
    }
    /**
     * Disable listbox options.
     */
    disabledKendo() {
        this.listboxEl['widget'].enable('.k-item', this.enabled);
    }
    /**
     * Sets the new dataurl.
     * @param val This variable contains a custom url
     */
    dataurlable(val) {
        this.dataUrl = val;
    }
    /**
     * Refresh listbox.
     */
    refreshable() {
        this.fetchItems();
    }
    setSelected() {
        const reference = this.listboxEl['widget'];
        /* c8 ignore else */
        if (this.selectedIndices) {
            reference.clearSelection();
            this.selectedIndices.forEach((element) => {
                reference.select(reference.items()[element]);
            });
        }
    }
    /**
     * show or hide the control.
     * @param value value from the model.Visible
     */
    applyVisible(value) {
        if (this.listboxEl && this.listboxEl['widget']) {
            if (value) {
                kendo.jQuery(this.listboxEl['widget'].wrapper).show();
            }
            else {
                kendo.jQuery(this.listboxEl['widget'].wrapper).hide();
            }
        }
    }
    /**
     * Retrieve an array SelectedIndices
     */
    getSelectedIndices(obj) {
        const currentIndices = [];
        /* c8 ignore else */
        if (obj.sender.select().length !== 0) {
            const items = obj.sender.items();
            obj.sender.select().each((i, value) => {
                const index = items.index(value);
                currentIndices[index] = index;
            });
        }
        this.selectedIndices = Object.keys(currentIndices).map(function (idx) {
            return currentIndices[idx];
        });
        this.selIdxInternalObj = currentIndices;
    }
    /**
     * Process fetch items response
     * @param data
     * @returns fetch items response
     */
    processFetchItemsResponse(data) {
        return data && data.length > 0
            ? data.map((item) => {
                // The View 'List' only shows the data for the first column
                const header = Object.keys(item.data)[0];
                return { text: item.data[header], value: item.data[header] };
            })
            : [];
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * Gets display element retrieving the k-listbox element from kendo listbox JQuery widget
     * @returns HTML display element or undefined if element is not rendered
     */
    getDisplayElement() {
        if (this.element1) {
            const element = this.element1.nativeElement;
            /* c8 ignore else */
            if (element) {
                const listboxElemRef = element.querySelector('.k-listbox');
                if (listboxElemRef) {
                    return listboxElemRef;
                }
            }
        }
        return undefined;
    }
    registerFunctions() {
        this.listboxEl['registerFunction']('DataUrl', this.dataurlable);
        this.listboxEl['registerFunction']('Enabled', this.disabledKendo);
        this.listboxEl['registerFunction']('Selectable', this.selectableFun);
        this.listboxEl['registerFunction']('Refresh', this.refreshable);
        this.listboxEl['registerFunction']('Visible', this.applyVisible);
        this.registered = true;
    }
};
ListViewListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListViewListComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ListViewListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ListViewListComponent, selector: "wm-listview-list", viewQueries: [{ propertyName: "listboxEl", first: true, predicate: ["listbox"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\" [ngClass]=\"class\">\r\n  <select #listbox [model]='model' class=\"list-component\" (blur)=\"blur($event)\" (focus)=\"focus($event)\"\r\n    data-role=\"listbox\" [bound]=\"{\r\n    dataTextField: 'text',\r\n    dataValueField: 'value',\r\n    disabled: enabled,\r\n    change: itemSelectionChanged,\r\n    selectable: selectionMode()\r\n}\">\r\n  </select>\r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: KendoListBoxComponent, selector: "[data-role=listbox]", inputs: ["model", "bound", "role"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
ListViewListComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], ListViewListComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListViewListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-listview-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"model\" [ngClass]=\"class\">\r\n  <select #listbox [model]='model' class=\"list-component\" (blur)=\"blur($event)\" (focus)=\"focus($event)\"\r\n    data-role=\"listbox\" [bound]=\"{\r\n    dataTextField: 'text',\r\n    dataValueField: 'value',\r\n    disabled: enabled,\r\n    change: itemSelectionChanged,\r\n    selectable: selectionMode()\r\n}\">\r\n  </select>\r\n</div>" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { listboxEl: [{
                type: ViewChild,
                args: ['listbox', { static: false }]
            }] } });

let ListViewComponent = class ListViewComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.service = service;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
    }
    /* c8 ignore stop */
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    get view() {
        return this.model.View;
    }
    set view(value) {
        this.model.View = value;
    }
    /**
     * Determines whether details view is
     * @returns true if details view
     */
    isDetailsView() {
        // In the future, this could be changed to an
        return this.view === 'Details';
    }
    /**
     * Determines whether list view is
     * @returns true if list view
     */
    isListView() {
        return this.view === 'List';
    }
    /**
     * Getter of the listView instance
     *
     * @readonly
     * @type {ListViewBaseComponent}
     * @memberof ListViewComponent
     */
    /* c8 ignore next 3 */
    get listViewInstance() {
        return this.listViewDetails ?? this.listViewList;
    }
};
ListViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListViewComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ListViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ListViewComponent, selector: "wm-listview", inputs: { model: "model" }, viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }, { propertyName: "listViewDetails", first: true, predicate: ["listViewDetails"], descendants: true }, { propertyName: "listViewList", first: true, predicate: ["listViewList"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #displayElement *ngIf=\"model\">\r\n    <wm-listview-details #listViewDetails [model]=\"model\" *ngIf=\"model && isDetailsView()\" [class]=\"class\">\r\n    </wm-listview-details>\r\n    <wm-listview-list #listViewList [model]=\"model\" *ngIf=\"model && isListView()\" [class]=\"class\">\r\n    </wm-listview-list>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ListViewListComponent, selector: "wm-listview-list" }, { kind: "component", type: ListViewDetailsComponent, selector: "wm-listview-details" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
ListViewComponent = __decorate([
    dataTransfer(['lstVw']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], ListViewComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListViewComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-listview', inputs: ['model'], template: "<div #displayElement *ngIf=\"model\">\r\n    <wm-listview-details #listViewDetails [model]=\"model\" *ngIf=\"model && isDetailsView()\" [class]=\"class\">\r\n    </wm-listview-details>\r\n    <wm-listview-list #listViewList [model]=\"model\" *ngIf=\"model && isListView()\" [class]=\"class\">\r\n    </wm-listview-list>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], listViewDetails: [{
                type: ViewChild,
                args: ['listViewDetails']
            }], listViewList: [{
                type: ViewChild,
                args: ['listViewList']
            }] } });

var DataGridViewComponent_1;
var CellType;
(function (CellType) {
    CellType[CellType["TextBoxColumn"] = 0] = "TextBoxColumn";
    CellType[CellType["ButtonColumn"] = 1] = "ButtonColumn";
    CellType[CellType["CheckBoxColumn"] = 2] = "CheckBoxColumn";
    CellType[CellType["ComboBoxColumn"] = 3] = "ComboBoxColumn";
    CellType[CellType["ImageColumn"] = 4] = "ImageColumn";
    CellType[CellType["LinkColumn"] = 5] = "LinkColumn";
    CellType[CellType["DateTimePicker"] = 6] = "DateTimePicker";
})(CellType || (CellType = {}));
/**
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/data-grid-view/data-grid-view.html</example-url>
 */
let DataGridViewComponent = DataGridViewComponent_1 = class DataGridViewComponent extends GridComponent {
    static cellLeaveEventArgsExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: DataGridViewComponent_1.dataGridViewMapperId },
            {
                MapperId: 'dgrdViewCellArgs',
                ColumnIndex: event.args.LastColumnIndex,
                RowIndex: event.args.LastRowIndex
            }
        ];
    }
    static cellEnterEventArgsExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: DataGridViewComponent_1.dataGridViewMapperId },
            {
                MapperId: 'dgrdViewCellArgs',
                ColumnIndex: event.args.ColumnIndex,
                RowIndex: event.args.RowIndex
            }
        ];
    }
    static selectedRowChangeEventArgsExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: DataGridViewComponent_1.dataGridViewMapperId },
            {
                MapperId: 'dgrdViewCellArgs',
                ColumnIndex: event.args.ColumnIndex,
                RowIndex: event.args.RowIndex
            }
        ];
    }
    static cellShowingEventArgsExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: DataGridViewComponent_1.dataGridViewMapperId },
            {
                MapperId: 'dgrdViewEdtingCtrlShwngArgs',
                Control: component.id,
                CellStyle: component.originalStyle(event.args.RowIndex, event.args.ColumnIndex)
            }
        ];
    }
    static cellExtractor(event, component) {
        let columnIndex = -1;
        let rowIndex = -1;
        /* c8 ignore else */
        if (component && component.gridEl) {
            const activeCell = component.gridEl.activeCell;
            /* c8 ignore else */
            if (activeCell) {
                columnIndex = component.rowHeadersVisible
                    ? activeCell.colIndex - 1
                    : activeCell.colIndex;
                rowIndex = component.columnHeadersVisible
                    ? activeCell.rowIndex - 1
                    : activeCell.rowIndex;
            }
            // We need to update currentRow and currentColumn
            /* c8 ignore else */
            if (component.model) {
                component.currentColumn = columnIndex;
                component.currentRow = rowIndex;
            }
        }
        return [];
    }
    /* c8 ignore start */
    constructor(serviceRef, refChange, render2, elem, formBuilderRef, webComponents, bringTopServ1) {
        super(serviceRef, refChange, render2, elem, formBuilderRef, webComponents, bringTopServ1);
        this.serviceRef = serviceRef;
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.formBuilderRef = formBuilderRef;
        this.bringTopServ1 = bringTopServ1;
        /* c8 ignore stop */
        this.defaultDataUrl = 'api/datagridview';
        /**
         * Url to get the page data
         */
        this.getPageDataUrl = `${this.defaultDataUrl}/GetPage`;
        /**
         * Url to get the Grid's Columns set
         */
        this.getColumnsUrl = `${this.defaultDataUrl}/GetColumns`;
        /**
         * URL to get the set of frozen rows in the entire grid
         */
        this.getFrozenRows = `${this.defaultDataUrl}/GetFrozenRows`;
        this.ItemSelectionChanged = new EventEmitter();
        this.DoubleClick = new EventEmitter();
        this.Click = new EventEmitter();
        this.CurrentCellChanged = new EventEmitter();
        this.CellLeave = new EventEmitter();
        this.CellEnter = new EventEmitter();
        this.RowEnter = new EventEmitter();
        this.SelectedRowChange = new EventEmitter();
        this.frozenRows = [];
        this.cellType = CellType;
        this.shortDateFormat = 'd';
        this.longDateFormat = 'D';
        this.gridSelection = [];
        this.isRowSelected = this.isRowSelected.bind(this);
    }
    ngOnInit() {
        super.ngOnInit();
        /* c8 ignore else */
        if (this.model) {
            this.loadColumns();
            this.loadFrozenRows();
            this.fetchItems();
            this.setSelectableSettings();
            this.setSortableSettings();
            this.refresh = false;
            this.refreshColumns = false;
            this.gridSelection = this.selectedRowsIndices;
        }
    }
    setSelectableSettings() {
        this.selectableSettings = {
            mode: this.getSelectionModeFromModel(this.model.SelectionMode)
        };
    }
    getSelectionModeFromModel(modelSelectionMode) {
        /* c8 ignore else */
        if (modelSelectionMode === 3 /* DataGridViewSelectionMode.FullRowSelect */ ||
            modelSelectionMode === 4 /* DataGridViewSelectionMode.RowHeaderSelect */) {
            return 'multiple';
        }
        return 'single';
    }
    ngAfterViewInit() {
        /* c8 ignore else */
        if (this.model) {
            super.ngAfterViewInit();
            this.setRowStyle();
        }
    }
    /**
     * Gets display element retrieving the k-grid element from kendo-grid
     * @returns HTML display element or undefined if element is not rendered
     */
    getDisplayElement() {
        /* c8 ignore else */
        if (this.elem) {
            const element = this.elem.nativeElement;
            /* c8 ignore else */
            if (element) {
                const gridElemRef = element.querySelector('.k-grid');
                /* c8 ignore else */
                if (gridElemRef) {
                    return gridElemRef;
                }
            }
        }
        return undefined;
    }
    fetchItems() {
        this.loadPage();
    }
    /**
     * Get the Grid's Columns object
     * @property Columns r
     */
    loadColumns() {
        this.serviceRef
            .fetch(this.getColumnsUrl, this.id)
            .subscribe((data) => {
            this.columns = data.Columns;
            this.refChange.detectChanges();
        });
    }
    /**
     * Sets the sortableSettings object
     */
    setSortableSettings() {
        this.sortableSettings =
            this.model.SortOrder !== 'None'
                ? {
                    allowUnsort: true,
                    mode: 'single'
                }
                : undefined;
    }
    /**
     * Get the Grid's Frozen rows set
     * @property Frozen r
     */
    loadFrozenRows() {
        this.serviceRef
            .fetch(this.getFrozenRows, this.id)
            .subscribe((data) => {
            this.frozenRows = data.Rows;
            this.refChange.detectChanges();
        });
    }
    loadPage() {
        this.loading = true;
        this.serviceRef
            .fetch(this.getPageDataUrl, this.id, this.getPageParams())
            .subscribe((data) => {
            const anyData = data;
            this.items = [];
            this.frozenRows = this.frozenRows ? this.frozenRows : [];
            // just in case frozenRows is undefined
            let frozenRowsLength = 0;
            this.items = this.items.concat(this.frozenRows);
            frozenRowsLength = this.frozenRows.length;
            // And add check in case rows is undefined
            /* c8 ignore else */
            if (anyData.Rows) {
                this.items = this.items.concat(anyData.Rows);
            }
            this.styles = anyData.Styles;
            this.stylesCalculated = [];
            this.gridView = {
                data: this.items,
                total: anyData.Length
            };
            this.refChange.detectChanges();
            this.bindsFocusOutEventToGrid();
            this.moveFrozenRows(frozenRowsLength);
            this.loading = false;
        });
    }
    getCheckBoxValue(value) {
        return !!value;
    }
    /**
     * Gets the checkbox click and send data to the server, it close the previous cell if it was in edition.
     */
    checkboxCellHandler(event, rowIndex, columnIndex) {
        /* c8 ignore else */
        if (this.gridEl.isEditing()) {
            this.gridEl.closeCell();
        }
        columnIndex = this.rowHeadersVisible ? columnIndex - 1 : columnIndex;
        this.setRowAndColProperties(rowIndex, columnIndex);
        const column = this.columns[columnIndex];
        /* c8 ignore else */
        if (column.editable) {
            const value = event.currentTarget.checked;
            this.triggerEditHandler(value);
        }
    }
    /**
     * Gets the date selected on DatePicker and send the data to the server.
     */
    datePickerCellCloseHandler() {
        const column = this.columns[this.currentColumn];
        /* c8 ignore else */
        if (column.editable &&
            this.datePickerValueOriginal !== this.datePickerValueChanged) {
            const hours = this.datePickerValueChanged.getHours();
            const minutes = this.datePickerValueChanged.getMinutes();
            const seconds = this.datePickerValueChanged.getSeconds();
            let formattedDate = `${this.datePickerValueChanged.getMonth() + 1}/${this.datePickerValueChanged.getDate()}/${this.datePickerValueChanged.getFullYear()}`;
            formattedDate =
                hours > 0 || minutes > 0 || seconds > 0
                    ? `${formattedDate} ${this.datePickerValueChanged.toLocaleTimeString('en-GB')}` // using 24h format
                    : formattedDate;
            this.triggerEditHandler(formattedDate);
            this.gridEl.closeCell();
            this.refChange.detectChanges();
        }
    }
    /**
     * Prepares the data for the server side request which order the dataview
     */
    sortChange(sort) {
        this.sort = sort;
        const eventData = new EventData$1('Sort', this.id);
        eventData.args = {
            direction: this.sort[0].dir,
            field: this.kendoToWebMapColField(this.sort[0].field),
            MapperId: DataGridViewComponent_1.dataGridViewMapperId
        };
        this.sortEventHandler(eventData);
    }
    setRowAndColProperties(rowIndex, colIndex) {
        /* c8 ignore else */
        if (rowIndex !== this.currentRow || colIndex !== this.currentColumn) {
            const eventLeaveData = new EventData$1('CellLeave', this.id);
            eventLeaveData.args = {
                LastRowIndex: this.currentRow,
                LastColumnIndex: this.currentColumn,
                RowIndex: rowIndex,
                ColumnIndex: colIndex
            };
            this.currentRow = rowIndex;
            this.currentColumn = colIndex;
            this.handleCellChangeEvents(eventLeaveData);
        }
    }
    getDisplayValue(column, value) {
        if (column.type === this.cellType.ComboBoxColumn) {
            /* c8 ignore else */
            if (!column.accesibleData) {
                const comboData = column.data;
                const accesibleData = {};
                for (const item of comboData) {
                    accesibleData[item.value.toString()] = item.displayvalue;
                }
                column['accesibleData'] = accesibleData;
            }
            return column.accesibleData[value.toString()];
        }
        else if (column.type === this.cellType.DateTimePicker) {
            let formattedDate = '';
            const date = new Date(value);
            switch (column.format) {
                case DateFormat.Long:
                    formattedDate = formatDate(date, this.longDateFormat);
                    break;
                case DateFormat.Short:
                    formattedDate = formatDate(date, this.shortDateFormat);
                    break;
                case DateFormat.Custom:
                    formattedDate = formatDate(date, column.customFormat);
                    break;
                default:
                    formattedDate = formatDate(date, this.shortDateFormat);
            }
            return value ? formattedDate : '';
        }
        else {
            return value;
        }
    }
    /**
     * This is a function to evaluate if the tooltip needs to be shown or not using the span and column width
     * @param columnW
     * @param spanW
     * @param value
     * @returns
     */
    toolTipFunction(columnW, spanW, value) {
        return columnW < spanW ? value : '';
    }
    getFormat(column) {
        switch (column.format) {
            case DateFormat.Long:
                return this.longDateFormat;
            case DateFormat.Short:
                return this.shortDateFormat;
            case DateFormat.Custom:
                return column.customFormat;
            default:
                return this.shortDateFormat;
        }
    }
    /**
     * Sets the selected rows indices
     */
    set selectedRowsIndices(indexes) {
        this.model.SelectedRowsIndices = indexes;
    }
    get selectedRowsIndices() {
        return this.model.SelectedRowsIndices;
    }
    get readonly() {
        return this.model.ReadOnly;
    }
    /**
     * Gets the Grid's IsInEditionMode value
     */
    get isInEditionMode() {
        return this.model.IsInEditionMode;
    }
    /**
     * Sets the Grid's IsInEditionMode value
     */
    set isInEditionMode(value) {
        this.model.IsInEditionMode = value;
    }
    /**
     * Gets the Grid's SelecteCurrentCellContent value
     */
    get selectCurrentCellContent() {
        return this.model.SelectCurrentCellContent;
    }
    /**
     * Gets the Grid's current row index
     */
    get currentRow() {
        return this.model.CurrentRow;
    }
    /**
     * Sets the Grid's current row index
     */
    set currentRow(value) {
        this.model.CurrentRow = value;
    }
    /**
     * Gets the Grid's current column index
     */
    get currentColumn() {
        return this.model.CurrentColumn;
    }
    /**
     * Sets the Grid's current column index
     */
    set currentColumn(value) {
        this.model.CurrentColumn = value;
    }
    get cellTipsWidth() {
        return this.model.CellTipsWidth;
    }
    get cellTipsDelay() {
        return this.model.CellTipsDelay;
    }
    get rowHeadersVisible() {
        return this.model.RowHeadersVisible;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /* c8 ignore next */
    ngDoCheck() {
        super.ngDoCheck();
        // We validate that we have a model
        if (this.model) {
            if (this.refresh) {
                this.fetchItems();
                this.refresh = false;
            }
            if (this.refreshColumns) {
                this.ngOnInit();
                this.refreshColumns = false;
            }
            this.beginEdit();
            this.detectChanges();
        }
    }
    getSelectedRows(obj) {
        if (this.gridSelection.length !== 0) {
            this.selectedRowsIndices = this.gridSelection;
        }
    }
    /**
     * Handles the double click event.
     * @param event The event object.
     */
    doubleClick(event) {
        this.DoubleClick.emit(new EventData$1(event, this.id));
    }
    /**
     * Handles the row selection of the grid.
     * @param event the event.
     */
    isRowSelected(e) {
        return this.selectedRowsIndices !== undefined
            ? this.selectedRowsIndices.indexOf(e.index) >= 0
            : false;
    }
    /**
     * Opens the editor in the current cell
     */
    beginEdit() {
        /* c8 ignore else */
        if (this.gridEl &&
            this.items &&
            this.isInEditionMode &&
            this.currentRow !== -1 &&
            this.currentColumn !== -1) {
            this.gridEl.editCell(this.currentRow, this.rowHeadersVisible ? this.currentColumn + 1 : this.currentColumn, this.createFormGroup(this.items[this.currentRow]));
            this.refChange.detectChanges();
            this.isInEditionMode = false;
            this.selectsCurrentCellContent();
        }
    }
    /**
     * Selects the current cell content
     */
    selectsCurrentCellContent() {
        /* c8 ignore else */
        if (this.selectCurrentCellContent) {
            const row = this.gridEl.wrapper.nativeElement.querySelectorAll('tr')[this.currentRow + 1];
            const cell = row.querySelectorAll('td')[this.rowHeadersVisible ? this.currentColumn + 1 : this.currentColumn];
            const input = cell.querySelector('input');
            input.select();
        }
    }
    /**
     * Handles the cellClick event.
     * @param event the event name.
     */
    cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }) {
        const colIndex = this.rowHeadersVisible ? columnIndex - 1 : columnIndex;
        const colIndexForEvents = colIndex < 0 ? 0 : colIndex;
        /* c8 ignore else */
        if (rowIndex !== this.currentRow ||
            colIndexForEvents !== this.currentColumn) {
            const eventLeaveData = new EventData$1('CellLeave', this.id);
            eventLeaveData.args = {
                LastRowIndex: this.currentRow,
                LastColumnIndex: this.currentColumn,
                RowIndex: rowIndex,
                ColumnIndex: colIndexForEvents
            };
            this.currentRow = rowIndex;
            this.currentColumn = colIndexForEvents;
            this.handleCellChangeEvents(eventLeaveData);
        }
        /* c8 ignore else */
        if (!isEdited && colIndex > -1 && !this.readonly) {
            const column = this.columns[this.currentColumn];
            this.formGroup = this.createFormGroup(dataItem);
            /* c8 ignore else */
            if (column.type === this.cellType.DateTimePicker) {
                const cellValue = dataItem[this.kendoToWebMapColField(column.field)];
                this.datePickerValueChanged = cellValue ? new Date(cellValue) : null;
                this.datePickerValueOriginal = this.datePickerValueChanged;
            }
            sender.editCell(rowIndex, columnIndex, this.formGroup);
            this.refChange.detectChanges();
            /* c8 ignore else */
            if (column.editable) {
                this.selectsCurrentCellContent();
            }
        }
        this.getSelectedRows(sender);
    }
    cellCloseHandler(args) {
        const { formGroup } = args;
        const { column } = args;
        if (!formGroup.valid) {
            // prevent closing the edited cell if there are invalid values.
            args.preventDefault();
        }
        else if (formGroup.dirty) {
            const eventData = new EventData$1('Edit', this.id);
            // columnIndex of the current editedCell
            // ColumnIndex - 1 to quit the row header
            const columnIndex = this.rowHeadersVisible
                ? column.leafIndex - 1
                : column.leafIndex;
            const columnModel = this.columns[columnIndex];
            const value = formGroup.value[this.kendoToWebMapColField(columnModel.field)];
            eventData.args = {
                newValue: value,
                MapperId: DataGridViewComponent_1.dataGridViewMapperId
            };
            this.updateLocalCellValue(this.formGroup);
            this.editEventHandler(eventData);
        }
        else {
            this.gridEl.cancelCell();
            this.refChange.detectChanges();
        }
        /* c8 ignore else */
        if (args.originalEvent) {
            this.hasTheGridLostFocus(args.originalEvent);
        }
    }
    triggerEditHandler(value) {
        const eventData = new EventData$1('Edit', this.id);
        eventData.args = {
            newValue: value,
            MapperId: DataGridViewComponent_1.dataGridViewMapperId
        };
        this.editEventHandler(eventData);
    }
    /**
     * Handles the Click event.
     * @param event the event name.
     */
    clickEvent(event) {
        this.Click.emit(new EventData$1(event, this.id));
    }
    /**
     * Handles the CurrentCellChanged event.
     * @param event the event name.
     */
    handleCellChangeEvents(eventData) {
        this.CellLeave.emit(eventData);
        this.CurrentCellChanged.emit(eventData);
        this.CellEnter.emit(eventData);
        // If the selected row changed.
        /* c8 ignore else */
        if (eventData.args['LastRowIndex'] != eventData.args['RowIndex']) {
            this.RowEnter.emit(eventData);
        }
        this.SelectedRowChange.emit(eventData);
    }
    /**
     * Keys down handler
     * @param event
     */
    keyDownHandler(event) {
        switch (event.key) {
            case 'Tab':
                this.tabHandler(event);
                break;
            case 'ArrowUp':
                this.arrowUpHandler(event);
                break;
            case 'ArrowDown':
                this.arrowDownHandler(event);
                break;
            default:
                break;
        }
    }
    /**
     * Tabs handler
     * @param event
     */
    /* c8 ignore next */
    tabHandler(event) {
        event.stopPropagation();
        event.preventDefault();
        /* c8 ignore else */
        if (this.gridEl.isEditing()) {
            this.gridEl.closeCell();
        }
        this.gridEl.focusNextCell();
    }
    /**
     * Arrows up handler
     * @param event
     */
    arrowUpHandler(event) {
        this.tryCloseGridEdit();
        /* c8 ignore else */
        if (this.currentRow > 0) {
            this.currentRow -= 1;
        }
        else {
            event.preventDefault();
        }
    }
    /**
     * Arrows down handler
     * @param event
     */
    arrowDownHandler(event) {
        this.tryCloseGridEdit();
        /* c8 ignore else */
        if (this.currentRow + 1 < this.gridEl.data.total) {
            this.currentRow += 1;
        }
    }
    /**
     * Updates local cell value
     * @param formGroup
     */
    updateLocalCellValue(formGroup) {
        const newRowIndex = this.gridView.data.findIndex((row) => row.Id === formGroup.value.Id);
        this.gridView.data[newRowIndex] = formGroup.value;
    }
    /**
     * Returns the columns after updating the field values to be compatible with the KendoGrid.
     *
     * @return {*}  {any[]}
     * @memberof DataGridViewComponent
     */
    getFormattedColumns() {
        return (this.columns?.map((column) => {
            column.field = this.webMapToKendoColField(column.field);
            return column;
        }) ?? []);
    }
    /**
     * Returns the correct data item value.
     *
     * @param {*} dataItem
     * @param {string} kendoColField
     * @return {*}  {string}
     * @memberof DataGridViewComponent
     */
    getItemValue(dataItem, kendoColField) {
        const webMapColField = this.kendoToWebMapColField(kendoColField);
        return dataItem[webMapColField];
    }
};
DataGridViewComponent.dataGridViewMapperId = 'dtGrdVw';
DataGridViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataGridViewComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i6.UntypedFormBuilder }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DataGridViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DataGridViewComponent, selector: "wm-datagridview", inputs: { model: "model" }, outputs: { ItemSelectionChanged: "ItemSelectionChanged", DoubleClick: "DoubleClick", Click: "Click", CurrentCellChanged: "CurrentCellChanged", CellLeave: "CellLeave", CellEnter: "CellEnter", RowEnter: "RowEnter", SelectedRowChange: "SelectedRowChange" }, usesInheritance: true, ngImport: i0, template: "<div #styleContainer></div>\r\n<kendo-grid #grid *ngIf=\"model\" [data]=\"gridView\" [selectable]=\"selectableSettings\" [ngClass]=\"class\"\r\n  [attr.disabled]=\"disabled\" wmControls [hostComponent]=\"this\" (click)=\"clickEvent($event)\"\r\n  [hideHeader]=\"!columnHeadersVisible\" (cellClick)=\"cellClickHandler($event)\" (dblclick)=\"doubleClick($event)\"\r\n  [navigable]=\"true\" (cellClose)=\"cellCloseHandler($event)\" [rowSelected]=\"isRowSelected\" [skip]=\"skip\"\r\n  [pageSize]=\"pageSize\" [scrollable]=\"'virtual'\" [rowHeight]=\"rowHeight\" [height]=\"height\"\r\n  (pageChange)=\"pageChange($event)\" [sort]=\"sort\" [sortable]=\"sortableSettings\" (sortChange)=\"sortChange($event)\"\r\n  (keydown)=\"keyDownHandler($event)\" kendoGridSelectBy [(selectedKeys)]=\"gridSelection\">\r\n  <kendo-grid-checkbox-column *ngIf=\"rowHeadersVisible\" width=\"12\" [resizable]=\"false\">\r\n    <ng-template kendoGridCellTemplate let-idx=\"rowIndex\">\r\n      <svg *ngIf=\"currentRow === idx\" width=\"12\" height=\"12\" viewBox=\"0 0 24 24\">\r\n        <path d=\"M6 0l12 12-12 12z\" />\r\n      </svg>\r\n    </ng-template>\r\n  </kendo-grid-checkbox-column>\r\n  <ng-container *ngFor=\"let column of getFormattedColumns()\">\r\n    <kendo-grid-column field=\"{{column.field}}\" title=\"{{column.title}}\" width=\"{{column.width}}\"\r\n      [style]=\"applyColumnStyle(column)\" [editable]=\"column.editable\" [locked]=\"column.locked\">\r\n\r\n      <ng-template *ngIf=\"!column.data\" kendoGridCellTemplate let-dataItem let-rowIndex=\"rowIndex\"\r\n        let-columnIndex=\"columnIndex\">\r\n        <div *ngIf=\"column.type === cellType.CheckBoxColumn\" kendoTooltip filter=\"span\" [tooltipWidth]=\"cellTipsWidth\"\r\n          [showAfter]=\"cellTipsDelay\" editor=\"boolean\" [ngStyle]=\"applyCellStyle(rowIndex, columnIndex)\">\r\n          <input kendoGridFocusable type=\"checkbox\" (click)=\"checkboxCellHandler($event, rowIndex, columnIndex)\"\r\n            [checked]=\"getCheckBoxValue(getItemValue(dataItem, column.field))\" />\r\n        </div>\r\n        <div *ngIf=\"column.type !== cellType.CheckBoxColumn\" kendoTooltip filter=\"span\"\r\n          [ngStyle]=\"applyCellStyle(rowIndex, columnIndex)\">\r\n          <div *ngIf=\"column.type === cellType.ImageColumn\">\r\n            <img alt=\"{{getItemValue(dataItem, column.field)}}\" [src]=\"getItemValue(dataItem, column.field)\" />\r\n          </div>\r\n          <div *ngIf=\"column.type !== cellType.ImageColumn\">\r\n            <span #span [title]=\"toolTipFunction(column.width, span.offsetWidth, getItemValue(dataItem, column.field))\">{{getDisplayValue(column,\r\n              getItemValue(dataItem, column.field))}}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template *ngIf=\"column.data\" kendoGridCellTemplate let-dataItem let-rowIndex=\"rowIndex\"\r\n        let-columnIndex=\"columnIndex\">\r\n        <div *ngIf=\"!(column.type === cellType.ComboBoxColumn)\" kendoTooltip filter=\"span\"\r\n          [ngStyle]=\"applyCellStyle(rowIndex, columnIndex)\">\r\n          <span [title]=\"getDisplayValue(column, getItemValue(dataItem, column.field))\">{{getDisplayValue(column,\r\n            getItemValue(dataItem, column.field))}}</span>\r\n        </div>\r\n        <select *ngIf=\"column.type === cellType.ComboBoxColumn\" [style.width.%]=\"100\">\r\n          <option *ngFor=\"let option of column.data\" value=\"{{option.value}}\"\r\n            [selected]=\"getItemValue(dataItem, column.field) === option.value\">{{option.displayvalue}}</option>\r\n        </select>\r\n      </ng-template>\r\n      <ng-template *ngIf=\"column.type === cellType.ComboBoxColumn\" kendoGridEditTemplate let-dataItem>\r\n        <select [style.width.%]=\"100\" [formControl]=\"formGroup.get(column.field)\">\r\n          <option *ngFor=\"let option of column.data\" value=\"{{option.value}}\"\r\n            [selected]=\"formGroup.get(column.field).value === option.value\">{{option.displayvalue}}</option>\r\n        </select>\r\n      </ng-template>\r\n      <ng-template *ngIf=\"column.type === cellType.DateTimePicker\" kendoGridEditTemplate let-dataItem>\r\n        <kendo-datepicker [(value)]=\"datePickerValueChanged\" [format]=\"getFormat(column)\"\r\n          (blur)=\"datePickerCellCloseHandler()\" placeholder=\"\" [disabled]=\"disabled\" wmControls [hostComponent]=\"this\">\r\n        </kendo-datepicker>\r\n      </ng-template>\r\n    </kendo-grid-column>\r\n  </ng-container>\r\n</kendo-grid>\r\n<div *ngIf=\"loading\" class=\"k-i-loading\"></div>\r\n", styles: [".k-i-loading{position:absolute;top:50%;left:50%;font-size:64px;background-color:#ffffff4d;color:#ff6757}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i6.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i6.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i6.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i6$1.DatePickerComponent, selector: "kendo-datepicker", inputs: ["focusableId", "cellTemplate", "monthCellTemplate", "yearCellTemplate", "decadeCellTemplate", "centuryCellTemplate", "weekNumberTemplate", "headerTitleTemplate", "navigationItemTemplate", "activeView", "bottomView", "topView", "calendarType", "animateCalendarNavigation", "disabled", "readonly", "readOnlyInput", "popupSettings", "navigation", "min", "max", "incompleteDateValidation", "focusedDate", "value", "format", "twoDigitYearMax", "formatPlaceholder", "placeholder", "tabindex", "tabIndex", "disabledDates", "title", "subtitle", "rangeValidation", "disabledDatesValidation", "weekNumber", "size", "rounded", "fillMode", "adaptiveMode"], outputs: ["valueChange", "focus", "blur", "open", "close"], exportAs: ["kendo-datepicker"] }, { kind: "component", type: i7$1.GridComponent, selector: "kendo-grid", inputs: ["data", "pageSize", "height", "rowHeight", "detailRowHeight", "skip", "scrollable", "selectable", "sort", "size", "trackBy", "filter", "group", "virtualColumns", "filterable", "sortable", "pageable", "groupable", "navigable", "navigatable", "autoSize", "rowClass", "rowSticky", "rowSelected", "cellSelected", "resizable", "reorderable", "loading", "columnMenu", "hideHeader", "isDetailExpanded", "isGroupExpanded"], outputs: ["filterChange", "pageChange", "groupChange", "sortChange", "selectionChange", "dataStateChange", "groupExpand", "groupCollapse", "detailExpand", "detailCollapse", "edit", "cancel", "save", "remove", "add", "cellClose", "cellClick", "pdfExport", "excelExport", "columnResize", "columnReorder", "columnVisibilityChange", "columnLockedChange", "columnStickyChange", "scrollBottom", "contentScroll"], exportAs: ["kendoGrid"] }, { kind: "directive", type: i7$1.SelectionDirective, selector: "[kendoGridSelectBy]" }, { kind: "component", type: i7$1.ColumnComponent, selector: "kendo-grid-column", inputs: ["field", "format", "sortable", "groupable", "editor", "filter", "filterable", "editable"] }, { kind: "directive", type: i7$1.FocusableDirective, selector: "[kendoGridFocusable],        [kendoGridEditCommand],        [kendoGridRemoveCommand],        [kendoGridSaveCommand],        [kendoGridCancelCommand],        [kendoGridSelectionCheckbox]    ", inputs: ["kendoGridFocusable"] }, { kind: "component", type: i7$1.CheckboxColumnComponent, selector: "kendo-grid-checkbox-column", inputs: ["showSelectAll"] }, { kind: "directive", type: i7$1.CellTemplateDirective, selector: "[kendoGridCellTemplate]" }, { kind: "directive", type: i7$1.EditTemplateDirective, selector: "[kendoGridEditTemplate]" }, { kind: "directive", type: i10.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('SelectedRowsIndices'),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], DataGridViewComponent.prototype, "selectedRowsIndices", null);
__decorate([
    NotifyChange('IsInEditionMode'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], DataGridViewComponent.prototype, "isInEditionMode", null);
__decorate([
    MarkForCheck(),
    NotifyChange('CurrentRow'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataGridViewComponent.prototype, "currentRow", null);
__decorate([
    MarkForCheck(),
    NotifyChange('CurrentColumn'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataGridViewComponent.prototype, "currentColumn", null);
__decorate([
    serverEvent('DoubleClick', DataGridViewComponent_1.cellExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DataGridViewComponent.prototype, "doubleClick", null);
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DataGridViewComponent.prototype, "clickEvent", null);
__decorate([
    serverEvent('RowEnter', DataGridViewComponent_1.cellEnterEventArgsExtractor),
    serverEvent('CellEnter', DataGridViewComponent_1.cellEnterEventArgsExtractor),
    serverEvent('SelectedRowChange', DataGridViewComponent_1.selectedRowChangeEventArgsExtractor),
    serverEvent('EditingControlShowing', DataGridViewComponent_1.cellShowingEventArgsExtractor),
    serverEvent('CurrentCellChanged'),
    serverEvent('CellLeave', DataGridViewComponent_1.cellLeaveEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EventData$1]),
    __metadata("design:returntype", void 0)
], DataGridViewComponent.prototype, "handleCellChangeEvents", null);
DataGridViewComponent = DataGridViewComponent_1 = __decorate([
    dataTransfer(['dtGrdVw']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        UntypedFormBuilder,
        WebComponentsService,
        BringTopService])
], DataGridViewComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataGridViewComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-datagridview', inputs: ['model'], template: "<div #styleContainer></div>\r\n<kendo-grid #grid *ngIf=\"model\" [data]=\"gridView\" [selectable]=\"selectableSettings\" [ngClass]=\"class\"\r\n  [attr.disabled]=\"disabled\" wmControls [hostComponent]=\"this\" (click)=\"clickEvent($event)\"\r\n  [hideHeader]=\"!columnHeadersVisible\" (cellClick)=\"cellClickHandler($event)\" (dblclick)=\"doubleClick($event)\"\r\n  [navigable]=\"true\" (cellClose)=\"cellCloseHandler($event)\" [rowSelected]=\"isRowSelected\" [skip]=\"skip\"\r\n  [pageSize]=\"pageSize\" [scrollable]=\"'virtual'\" [rowHeight]=\"rowHeight\" [height]=\"height\"\r\n  (pageChange)=\"pageChange($event)\" [sort]=\"sort\" [sortable]=\"sortableSettings\" (sortChange)=\"sortChange($event)\"\r\n  (keydown)=\"keyDownHandler($event)\" kendoGridSelectBy [(selectedKeys)]=\"gridSelection\">\r\n  <kendo-grid-checkbox-column *ngIf=\"rowHeadersVisible\" width=\"12\" [resizable]=\"false\">\r\n    <ng-template kendoGridCellTemplate let-idx=\"rowIndex\">\r\n      <svg *ngIf=\"currentRow === idx\" width=\"12\" height=\"12\" viewBox=\"0 0 24 24\">\r\n        <path d=\"M6 0l12 12-12 12z\" />\r\n      </svg>\r\n    </ng-template>\r\n  </kendo-grid-checkbox-column>\r\n  <ng-container *ngFor=\"let column of getFormattedColumns()\">\r\n    <kendo-grid-column field=\"{{column.field}}\" title=\"{{column.title}}\" width=\"{{column.width}}\"\r\n      [style]=\"applyColumnStyle(column)\" [editable]=\"column.editable\" [locked]=\"column.locked\">\r\n\r\n      <ng-template *ngIf=\"!column.data\" kendoGridCellTemplate let-dataItem let-rowIndex=\"rowIndex\"\r\n        let-columnIndex=\"columnIndex\">\r\n        <div *ngIf=\"column.type === cellType.CheckBoxColumn\" kendoTooltip filter=\"span\" [tooltipWidth]=\"cellTipsWidth\"\r\n          [showAfter]=\"cellTipsDelay\" editor=\"boolean\" [ngStyle]=\"applyCellStyle(rowIndex, columnIndex)\">\r\n          <input kendoGridFocusable type=\"checkbox\" (click)=\"checkboxCellHandler($event, rowIndex, columnIndex)\"\r\n            [checked]=\"getCheckBoxValue(getItemValue(dataItem, column.field))\" />\r\n        </div>\r\n        <div *ngIf=\"column.type !== cellType.CheckBoxColumn\" kendoTooltip filter=\"span\"\r\n          [ngStyle]=\"applyCellStyle(rowIndex, columnIndex)\">\r\n          <div *ngIf=\"column.type === cellType.ImageColumn\">\r\n            <img alt=\"{{getItemValue(dataItem, column.field)}}\" [src]=\"getItemValue(dataItem, column.field)\" />\r\n          </div>\r\n          <div *ngIf=\"column.type !== cellType.ImageColumn\">\r\n            <span #span [title]=\"toolTipFunction(column.width, span.offsetWidth, getItemValue(dataItem, column.field))\">{{getDisplayValue(column,\r\n              getItemValue(dataItem, column.field))}}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template *ngIf=\"column.data\" kendoGridCellTemplate let-dataItem let-rowIndex=\"rowIndex\"\r\n        let-columnIndex=\"columnIndex\">\r\n        <div *ngIf=\"!(column.type === cellType.ComboBoxColumn)\" kendoTooltip filter=\"span\"\r\n          [ngStyle]=\"applyCellStyle(rowIndex, columnIndex)\">\r\n          <span [title]=\"getDisplayValue(column, getItemValue(dataItem, column.field))\">{{getDisplayValue(column,\r\n            getItemValue(dataItem, column.field))}}</span>\r\n        </div>\r\n        <select *ngIf=\"column.type === cellType.ComboBoxColumn\" [style.width.%]=\"100\">\r\n          <option *ngFor=\"let option of column.data\" value=\"{{option.value}}\"\r\n            [selected]=\"getItemValue(dataItem, column.field) === option.value\">{{option.displayvalue}}</option>\r\n        </select>\r\n      </ng-template>\r\n      <ng-template *ngIf=\"column.type === cellType.ComboBoxColumn\" kendoGridEditTemplate let-dataItem>\r\n        <select [style.width.%]=\"100\" [formControl]=\"formGroup.get(column.field)\">\r\n          <option *ngFor=\"let option of column.data\" value=\"{{option.value}}\"\r\n            [selected]=\"formGroup.get(column.field).value === option.value\">{{option.displayvalue}}</option>\r\n        </select>\r\n      </ng-template>\r\n      <ng-template *ngIf=\"column.type === cellType.DateTimePicker\" kendoGridEditTemplate let-dataItem>\r\n        <kendo-datepicker [(value)]=\"datePickerValueChanged\" [format]=\"getFormat(column)\"\r\n          (blur)=\"datePickerCellCloseHandler()\" placeholder=\"\" [disabled]=\"disabled\" wmControls [hostComponent]=\"this\">\r\n        </kendo-datepicker>\r\n      </ng-template>\r\n    </kendo-grid-column>\r\n  </ng-container>\r\n</kendo-grid>\r\n<div *ngIf=\"loading\" class=\"k-i-loading\"></div>\r\n", styles: [".k-i-loading{position:absolute;top:50%;left:50%;font-size:64px;background-color:#ffffff4d;color:#ff6757}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i6.UntypedFormBuilder }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { ItemSelectionChanged: [{
                type: Output
            }], DoubleClick: [{
                type: Output
            }], Click: [{
                type: Output
            }], CurrentCellChanged: [{
                type: Output
            }], CellLeave: [{
                type: Output
            }], CellEnter: [{
                type: Output
            }], RowEnter: [{
                type: Output
            }], SelectedRowChange: [{
                type: Output
            }], selectedRowsIndices: [], isInEditionMode: [], currentRow: [], currentColumn: [], doubleClick: [], clickEvent: [], handleCellChangeEvents: [] } });

var DataGridViewFlexComponent_1;
var FlexGridAlignmentSettings;
(function (FlexGridAlignmentSettings) {
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignCenterBottom"] = 2] = "flexAlignCenterBottom";
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignCenterCenter"] = 32] = "flexAlignCenterCenter";
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignCenterTop"] = 512] = "flexAlignCenterTop";
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignGeneral"] = 513] = "flexAlignGeneral";
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignLeftBottom"] = 1] = "flexAlignLeftBottom";
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignLeftCenter"] = 16] = "flexAlignLeftCenter";
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignLeftTop"] = 256] = "flexAlignLeftTop";
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignRightBottom"] = 4] = "flexAlignRightBottom";
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignRightCenter"] = 64] = "flexAlignRightCenter";
    FlexGridAlignmentSettings[FlexGridAlignmentSettings["flexAlignRightTop"] = 1024] = "flexAlignRightTop";
})(FlexGridAlignmentSettings || (FlexGridAlignmentSettings = {}));
let DataGridViewFlexComponent = DataGridViewFlexComponent_1 = class DataGridViewFlexComponent extends DataGridViewComponent {
    static MouseEventsExtractor(event, component) {
        return [
            {
                Id: event.Id,
                MapperId: DataGridViewFlexComponent_1.dataGridViewFlexMapperId
            },
            {
                MapperId: 'MouseEventArgs',
                Button: event.button,
                X: event.X,
                Y: event.Y
            }
        ];
    }
    /* c8 ignore next */
    static handleCellAlignment(c) {
        if (c.align) {
            switch (c.align) {
                case FlexGridAlignmentSettings.flexAlignCenterBottom:
                case FlexGridAlignmentSettings.flexAlignCenterCenter:
                case FlexGridAlignmentSettings.flexAlignCenterTop:
                    c.textalign = 'center';
                    break;
                case FlexGridAlignmentSettings.flexAlignLeftBottom:
                case FlexGridAlignmentSettings.flexAlignLeftCenter:
                case FlexGridAlignmentSettings.flexAlignLeftTop:
                    c.textalign = 'left';
                    break;
                case FlexGridAlignmentSettings.flexAlignRightBottom:
                case FlexGridAlignmentSettings.flexAlignRightCenter:
                case FlexGridAlignmentSettings.flexAlignRightTop:
                    c.textalign = 'right';
                    break;
            }
        }
    }
    /* c8 ignore start */
    constructor(serviceRefe, refChange1, render, elem1, formBuilderRef1, webComponents, bringTopServ2) {
        super(serviceRefe, refChange1, render, elem1, formBuilderRef1, webComponents, bringTopServ2);
        this.serviceRefe = serviceRefe;
        this.refChange1 = refChange1;
        this.render = render;
        this.elem1 = elem1;
        this.formBuilderRef1 = formBuilderRef1;
        this.bringTopServ2 = bringTopServ2;
        this.defaultDataUrl = 'api/flexgrid';
        /**
         * rowHeightInternal value to set rows height
         *
         * @memberof DataGridViewFlexComponent
         */
        this.rowHeightInternal = 35;
        /**
         * Url to get the page data
         */
        this.getPageDataUrl = `${this.defaultDataUrl}/GetPage`;
        /**
         * Url to get the Grid's Columns set
         */
        this.getColumnsUrl = `${this.defaultDataUrl}/GetColumns`;
        this.DoubleClick = new EventEmitter();
        this.Click = new EventEmitter();
        this.MouseDown = new EventEmitter();
        this.MouseUp = new EventEmitter();
    }
    get refreshColumns() {
        return this.model.RefreshColumns;
    }
    set refreshColumns(value) {
        this.model.RefreshColumns = value;
    }
    get currentRowIndex() {
        return this.model.CurrentRowIndex;
    }
    set currentRowIndex(value) {
        this.model.CurrentRowIndex = value;
    }
    get currentColumnIndex() {
        return this.model.CurrentColumnIndex;
    }
    set currentColumnIndex(value) {
        this.model.CurrentColumnIndex = value;
    }
    /**
     * Gets/sets the rowHeight GridComponent.
     *
     * @memberof GridComponent
     */
    set rowHeight(value) {
        this.rowHeightInternal = value;
    }
    get rowHeight() {
        /* c8 ignore if */
        if (this.model?.RowHeight === undefined) {
            return this.rowHeightInternal;
        }
        else if (this.model.RowHeight != this.rowHeightInternal &&
            this.model.RowHeight === 0) {
            return this.rowHeightInternal;
        }
        else {
            return this.model.RowHeight;
        }
    }
    ngOnInit() {
        this.loadColumns();
        this.fetchItems();
        this.setSelectableSettings();
        this.refreshColumns = false;
        this.refresh = false;
    }
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore else */
        if (this.refreshColumns) {
            this.loadColumns();
            this.fetchItems();
            this.refreshColumns = false;
            this.refresh = false;
        }
        /* c8 ignore else */
        if (this.refresh) {
            this.fetchItems();
            this.refresh = false;
        }
    }
    /**
     * Handles the double click event.
     * @param event The event object.
     */
    doubleClick(event) {
        this.DoubleClick.emit(new EventData$1(event, this.id));
    }
    /**
     * Handles the cellClick event.
     * @param event the event name.
     */
    cellClickEvent(event) {
        this.clickedCell = event;
        this.currentRowIndex = this.clickedCell.rowIndex + 1;
        this.currentColumnIndex = this.clickedCell.columnIndex;
        this.triggerMouseEvents(this.lastClickedEvent);
    }
    /**
     * Validates if the row should be considered as selected.
     * Currently the criteria is that the row index is the same as the CurrentRowIndex
     * @param e
     */
    isRowSelected(e) {
        return (this.model && e.index >= 0 && e.index + 1 === this.model.CurrentRowIndex);
    }
    /**
     * Indicates if the event happened on a header
     * The header could be a TH or in case that the current target is not a TH
     * we search if it is a tag enclosed inside a TH
     * @param event
     */
    isInHeader(event) {
        /* c8 ignore else */
        if (event.target.tagName === 'TH') {
            return event.target;
        }
        /* c8 ignore else */
        const targetTH = event.target.closest('TH');
        if (targetTH) {
            return targetTH;
        }
        return undefined;
    }
    /**
     * Handles the Click event.
     * @param event the event name.
     */
    clickEvent(event) {
        this.lastClickedEvent = new EventData$1(event, this.id);
        const header = this.isInHeader(event);
        /* c8 ignore else */
        if (header) {
            this.currentRowIndex = 0;
            this.currentColumnIndex = event.target.cellIndex;
            this.triggerMouseEvents(this.lastClickedEvent);
        }
    }
    triggerMouseDownEvent(event) {
        this.MouseDown.emit(event);
    }
    triggerMouseClickEvent(event) {
        this.Click.emit(event);
    }
    triggerMouseUpEvent(event) {
        this.MouseUp.emit(event);
    }
    triggerMouseEvents(event) {
        this.triggerMouseDownEvent(event);
        this.triggerMouseClickEvent(event);
        this.triggerMouseUpEvent(event);
    }
    /**
     * Returns the width of the column with the given index or 0 if not found
     * @param columnIndex
     */
    getColumnWidth(columnIndex) {
        for (const c of this.columns) {
            /* c8 ignore else */
            if (c.field === columnIndex) {
                return c.width;
            }
        }
        return 0;
    }
    /**
     * Processes the columns in the model and returns an array of columns that will
     * be used to build the grid
     * It filters columns with no width
     * It checks columns for alignment
     */
    getFilteredColumns() {
        /* c8 ignore else */
        if (this.model && this.columns) {
            const filtered = [];
            let index = 0;
            for (const c of this.columns) {
                // We filter columns with no width
                if (c.width > 0) {
                    filtered.push(c);
                }
                // We also need to check if there are FixedRows
                // In order to set the locked property
                c.locked = index < this.model.FixedColumns;
                // And to support alignment
                DataGridViewFlexComponent_1.handleCellAlignment(c);
                index++;
            }
            return filtered;
        }
        else {
            return [];
        }
    }
};
DataGridViewFlexComponent.dataGridViewFlexMapperId = 'flxGrd';
DataGridViewFlexComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataGridViewFlexComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i6.UntypedFormBuilder }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DataGridViewFlexComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DataGridViewFlexComponent, selector: "wm-datagridviewflex", inputs: { model: "model", rowHeight: "rowHeight" }, outputs: { DoubleClick: "DoubleClick", Click: "Click", MouseDown: "MouseDown", MouseUp: "MouseUp" }, viewQueries: [{ propertyName: "grid", first: true, predicate: GridComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #styleContainer></div>\r\n<kendo-grid #grid *ngIf=\"model\" [data]=\"gridView\" [selectable]=\"selectableSettings\" [ngClass]=\"class\" [attr.disabled]=\"disabled\" wmControls [hostComponent]=\"this\" (click)=\"clickEvent($event)\" (cellClick)=\"cellClickEvent($event)\" (dblclick)=\"doubleClick($event)\" [skip]=\"skip\"\r\n    [pageSize]=\"pageSize\" [scrollable]=\"'virtual'\" [rowHeight]=\"rowHeight\" [rowSelected]=\"isRowSelected\" [height]=\"height\" (pageChange)=\"pageChange($event)\" [resizable]=\"true\">\r\n    <ng-container *ngFor=\"let column of getFilteredColumns()\">\r\n        <kendo-grid-column field=\"column.field\" width=\"{{column.width}}\" [resizable]=\"true\" [locked]=\"column.locked\">\r\n            <ng-template kendoGridHeaderTemplate>\r\n                <pre *ngIf=\"model.WordWrap\" [style.text-align]=\"column.textalign\">{{column.title}}</pre>\r\n                <div *ngIf=\"!model.WordWrap\" [style.text-align]=\"column.textalign\">{{column.title}}</div>\r\n            </ng-template>\r\n            <ng-template kendoGridCellTemplate let-dataItem>\r\n                <pre *ngIf=\"model.WordWrap\" [style.background-color]=\"dataItem[column.field].Back\" [style.color]=\"dataItem[column.field].Fore\" [style.text-align]=\"column.textalign\">{{dataItem[column.field].Text != undefined ?dataItem[column.field].Text:dataItem[column.field]}}</pre>\r\n                <div *ngIf=\"!model.WordWrap\" [style.background-color]=\"dataItem[column.field].Back\" [style.color]=\"dataItem[column.field].Fore\" [style.display]=\"'block'\" [style.text-align]=\"column.textalign\">{{dataItem[column.field].Text != undefined?dataItem[column.field].Text:dataItem[column.field]}}</div>\r\n            </ng-template>\r\n        </kendo-grid-column>\r\n    </ng-container>\r\n</kendo-grid>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7$1.GridComponent, selector: "kendo-grid", inputs: ["data", "pageSize", "height", "rowHeight", "detailRowHeight", "skip", "scrollable", "selectable", "sort", "size", "trackBy", "filter", "group", "virtualColumns", "filterable", "sortable", "pageable", "groupable", "navigable", "navigatable", "autoSize", "rowClass", "rowSticky", "rowSelected", "cellSelected", "resizable", "reorderable", "loading", "columnMenu", "hideHeader", "isDetailExpanded", "isGroupExpanded"], outputs: ["filterChange", "pageChange", "groupChange", "sortChange", "selectionChange", "dataStateChange", "groupExpand", "groupCollapse", "detailExpand", "detailCollapse", "edit", "cancel", "save", "remove", "add", "cellClose", "cellClick", "pdfExport", "excelExport", "columnResize", "columnReorder", "columnVisibilityChange", "columnLockedChange", "columnStickyChange", "scrollBottom", "contentScroll"], exportAs: ["kendoGrid"] }, { kind: "component", type: i7$1.ColumnComponent, selector: "kendo-grid-column", inputs: ["field", "format", "sortable", "groupable", "editor", "filter", "filterable", "editable"] }, { kind: "directive", type: i7$1.CellTemplateDirective, selector: "[kendoGridCellTemplate]" }, { kind: "directive", type: i7$1.HeaderTemplateDirective, selector: "[kendoGridHeaderTemplate]" }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('CurrentRowIndex'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataGridViewFlexComponent.prototype, "currentRowIndex", null);
__decorate([
    MarkForCheck(),
    NotifyChange('CurrentColumnIndex'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataGridViewFlexComponent.prototype, "currentColumnIndex", null);
__decorate([
    MarkForCheck(),
    NotifyChange('RowHeight'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataGridViewFlexComponent.prototype, "rowHeight", null);
__decorate([
    serverEvent('DoubleClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DataGridViewFlexComponent.prototype, "doubleClick", null);
__decorate([
    serverEvent('MouseDown', DataGridViewFlexComponent_1.MouseEventsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DataGridViewFlexComponent.prototype, "triggerMouseDownEvent", null);
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DataGridViewFlexComponent.prototype, "triggerMouseClickEvent", null);
__decorate([
    serverEvent('MouseUp', DataGridViewFlexComponent_1.MouseEventsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DataGridViewFlexComponent.prototype, "triggerMouseUpEvent", null);
DataGridViewFlexComponent = DataGridViewFlexComponent_1 = __decorate([
    dataTransfer(['flxGrd']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        UntypedFormBuilder,
        WebComponentsService,
        BringTopService])
], DataGridViewFlexComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataGridViewFlexComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-datagridviewflex', inputs: ['model'], template: "<div #styleContainer></div>\r\n<kendo-grid #grid *ngIf=\"model\" [data]=\"gridView\" [selectable]=\"selectableSettings\" [ngClass]=\"class\" [attr.disabled]=\"disabled\" wmControls [hostComponent]=\"this\" (click)=\"clickEvent($event)\" (cellClick)=\"cellClickEvent($event)\" (dblclick)=\"doubleClick($event)\" [skip]=\"skip\"\r\n    [pageSize]=\"pageSize\" [scrollable]=\"'virtual'\" [rowHeight]=\"rowHeight\" [rowSelected]=\"isRowSelected\" [height]=\"height\" (pageChange)=\"pageChange($event)\" [resizable]=\"true\">\r\n    <ng-container *ngFor=\"let column of getFilteredColumns()\">\r\n        <kendo-grid-column field=\"column.field\" width=\"{{column.width}}\" [resizable]=\"true\" [locked]=\"column.locked\">\r\n            <ng-template kendoGridHeaderTemplate>\r\n                <pre *ngIf=\"model.WordWrap\" [style.text-align]=\"column.textalign\">{{column.title}}</pre>\r\n                <div *ngIf=\"!model.WordWrap\" [style.text-align]=\"column.textalign\">{{column.title}}</div>\r\n            </ng-template>\r\n            <ng-template kendoGridCellTemplate let-dataItem>\r\n                <pre *ngIf=\"model.WordWrap\" [style.background-color]=\"dataItem[column.field].Back\" [style.color]=\"dataItem[column.field].Fore\" [style.text-align]=\"column.textalign\">{{dataItem[column.field].Text != undefined ?dataItem[column.field].Text:dataItem[column.field]}}</pre>\r\n                <div *ngIf=\"!model.WordWrap\" [style.background-color]=\"dataItem[column.field].Back\" [style.color]=\"dataItem[column.field].Fore\" [style.display]=\"'block'\" [style.text-align]=\"column.textalign\">{{dataItem[column.field].Text != undefined?dataItem[column.field].Text:dataItem[column.field]}}</div>\r\n            </ng-template>\r\n        </kendo-grid-column>\r\n    </ng-container>\r\n</kendo-grid>" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i6.UntypedFormBuilder }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { grid: [{
                type: ViewChild,
                args: [GridComponent, { static: false }]
            }], DoubleClick: [{
                type: Output
            }], Click: [{
                type: Output
            }], MouseDown: [{
                type: Output
            }], MouseUp: [{
                type: Output
            }], currentRowIndex: [], currentColumnIndex: [], rowHeight: [{
                type: Input
            }], doubleClick: [], triggerMouseDownEvent: [], triggerMouseClickEvent: [], triggerMouseUpEvent: [] } });

/**
 * ListBox Component this is an Angular Kendo jquery component .
 */
let ListBoxComponent = class ListBoxComponent extends ListBoxBaseComponent {
    /**
     * Binded functions are declared here.
     */
    /* c8 ignore start */
    constructor(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1, tabOrderService) {
        super(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1);
        this.serviceRef = serviceRef;
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        this.tabOrderService = tabOrderService;
        this.defaultDataUrl = 'api/listbox';
    }
    ApplyVisible() {
        return { display: this.visible ? '' : 'none' };
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        kendo
            .jQuery(this.listboxEl['widget'].wrapper)
            .on('dblclick', this.dblClick);
    }
    onMouseHover(event) {
        this.mouseEnter(event);
    }
    onMouseLeave(event) {
        this.mouseLeave(event);
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * Set enable property for component and their children
     * Property EnabledInternal: is a read-only property that is used to check the original enabled state of any control.
     * IMPORTANT: This property shouldn't be modify
     * @memberof ListBoxComponent
     */
    set enabled(value) {
        if (value === this.model.Enabled) {
            return;
        }
        const parent = WebMapService.currentService.core.getModel(this.model.Parent);
        /* c8 ignore if */
        if (value && !parent.Enabled) {
            return;
        }
        this.model.Enabled = value;
    }
    /**
     * Gets enabled property according my value and the value of my parent
     * @memberof ListBoxComponent
     */
    get enabled() {
        const parent = WebMapService.currentService.core.getModel(this.model.Parent);
        const childEnabled = this.model.Enabled;
        const isEnabled = childEnabled && parent ? parent.Enabled : childEnabled;
        if (this.listboxEl !== undefined) {
            this.listboxEl['widget'].enable('.k-list-item', isEnabled);
        }
        return isEnabled;
    }
    /**
     * Gets display element retrieving the k-list element from kendo listbox JQuery widget
     * @returns HTML display element or undefined
     */
    getDisplayElement() {
        if (this.elem) {
            const element = this.elem.nativeElement;
            if (element) {
                const listboxElemRef = element.querySelector('.k-list');
                if (listboxElemRef) {
                    listboxElemRef.setAttribute('tabindex', 0);
                    return listboxElemRef;
                }
            }
        }
        return undefined;
    }
};
ListBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListBoxComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: MainTabOrderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ListBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ListBoxComponent, selector: "wm-listbox", inputs: { model: "model" }, host: { listeners: { "mouseover": "onMouseHover($event)", "mouseleave": "onMouseLeave($event)" } }, viewQueries: [{ propertyName: "listboxEl", first: true, predicate: ["listbox"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div\r\n  *ngIf=\"model\"\r\n  [ngClass]=\"class\"\r\n  [ngStyle]=\"setMyStyle()\"\r\n  wmControls\r\n  [hostComponent]=\"this\"\r\n>\r\n  <select\r\n    #listbox\r\n    [model]=\"model\"\r\n    (blur)=\"blur($event)\"\r\n    (focus)=\"focus($event)\"\r\n    data-role=\"listbox\"\r\n    [bound]=\"{\r\n      change: selectionChange,\r\n      dataTextField: dataTextField,\r\n      dataValueField: dataValueField,\r\n      disabled: enabled,\r\n      selectable: selectionMode(),\r\n      draggable: draggable\r\n    }\"\r\n  ></select>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: KendoListBoxComponent, selector: "[data-role=listbox]", inputs: ["model", "bound", "role"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('Enabled'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ListBoxComponent.prototype, "enabled", null);
ListBoxComponent = __decorate([
    dataTransfer(['lstBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        MainTabOrderService])
], ListBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ListBoxComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-listbox', inputs: ['model'], template: "<div\r\n  *ngIf=\"model\"\r\n  [ngClass]=\"class\"\r\n  [ngStyle]=\"setMyStyle()\"\r\n  wmControls\r\n  [hostComponent]=\"this\"\r\n>\r\n  <select\r\n    #listbox\r\n    [model]=\"model\"\r\n    (blur)=\"blur($event)\"\r\n    (focus)=\"focus($event)\"\r\n    data-role=\"listbox\"\r\n    [bound]=\"{\r\n      change: selectionChange,\r\n      dataTextField: dataTextField,\r\n      dataValueField: dataValueField,\r\n      disabled: enabled,\r\n      selectable: selectionMode(),\r\n      draggable: draggable\r\n    }\"\r\n  ></select>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: MainTabOrderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { listboxEl: [{
                type: ViewChild,
                args: ['listbox', { static: false }]
            }], onMouseHover: [{
                type: HostListener,
                args: ['mouseover', ['$event']]
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave', ['$event']]
            }], enabled: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Class to standarize the structure of the suggestions
 */
class Suggestion {
    constructor(userInput, suggestion, index) {
        this._userInput = userInput;
        this._suggestion = suggestion;
        this._index = index;
    }
    /**
     * Sets the _suggestion attribute of the class
     *
     * @memberof Suggestion
     */
    set suggestion(suggestion) {
        this._suggestion = suggestion;
    }
    /**
     * Returns de _suggestion attribute of the class
     *
     * @type {string}
     * @memberof Suggestion
     */
    get suggestion() {
        return this._suggestion;
    }
    /**
     * Sets the _index attribute of the class
     * This index indicates in which position of the source array it was
     *
     * @memberof Suggestion
     */
    set index(index) {
        this._index = index;
    }
    /**
     * Returns the _index attribute of the class
     *
     * @memberof Suggestion
     */
    get index() {
        return this._index;
    }
    /**
     * Sets the _userInput attribute of the class
     * It indicated the original input which resulted in the current suggestion
     *
     * @memberof Suggestion
     */
    set userInput(userInput) {
        this._userInput = userInput;
    }
    /**
     * Returns the _userInput attribute of the class
     *
     * @memberof Suggestion
     */
    get userInput() {
        return this._userInput;
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class SearchSuggestionService {
    constructor() { }
    /**
     * Method in charge of returning a suggestion if possible
     * @param value
     * @param items
     * @returns Suggestion | null
     */
    getSuggestion(value, items) {
        if (items.length == 0) {
            return null;
        }
        else if (items[0].text.toLowerCase().indexOf(value.toLowerCase()) == 0) {
            return new Suggestion(value, items[0].text, 0);
        }
        else {
            return this.searchSuggestionInList(value, items);
        }
    }
    /**
     * Iterates the items array to find a valid suggestion and index
     * @param value
     * @param items
     * @returns Suggestion
     */
    searchSuggestionInList(value, items) {
        for (const [index, option] of items.entries()) {
            if (option.text.toLowerCase().indexOf(value.toLowerCase()) === 0) {
                return new Suggestion(value, option.text, index);
            }
        }
    }
}
SearchSuggestionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SearchSuggestionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SearchSuggestionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SearchSuggestionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SearchSuggestionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/**
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/combo-box/combo-box.html</example-url>
 */
let ComboBoxComponent = class ComboBoxComponent extends ComboBoxBaseComponent {
    /* c8 ignore start */
    constructor(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1, searchSuggestionService, containerInteraction) {
        super(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1, containerInteraction);
        this.serviceRef = serviceRef;
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        this.searchSuggestionService = searchSuggestionService;
        this.containerInteraction = containerInteraction;
        this.items = [];
        /* original retrieved Data Source */
        this.source = [];
        this.defaultDataUrl = 'api/combobox';
        this.customValue = {};
        /* Array of required dynamic properties that need to be applied to other element */
        this.dynamicStylesProps = ['color', 'background-color'];
        this.virtual = {
            itemHeight: 28
        };
        /**
         * default height  is 200px.
         */
        this.integralheight = 200;
        this.previousUserInput = '';
        this.suggestionSubject = new Subject();
        /**
         * Allows to disable filtering behaviour.
         *
         * @type {string}
         * @memberof ComboBoxComponent
         */
        this.filterable = true;
        this.SelectedIndexChanged = new EventEmitter();
        this.SelectionChangeCommitted = new EventEmitter();
        this.valueNormalizer = (text) => text.pipe(map((txt) => {
            return {
                value: -1,
                text: txt
            };
        }));
    }
    /* c8 ignore stop */
    set displayElementPanel(value) {
        if (value === null || value === undefined) {
            this.displayElement = null;
        }
        else if (value.nativeElement.firstElementChild) {
            this.displayElement = value.nativeElement.firstElementChild;
        }
        else {
            this.displayElement = null;
        }
    }
    /**
     * Fetchs items
     * @property Items r
     */
    fetchItems() {
        this.loading = true;
        this.serviceRef.fetch(this.url, this.id).subscribe((data) => {
            this.items = data;
            this.source = data;
            this.loading = false;
            this.detectChanges();
        });
    }
    ngOnInit() {
        super.ngOnInit();
        /* c8 ignore else */
        if (this.model) {
            this.refresh = false;
            this.fetchItems();
        }
        this.suggestionSubscription = this.getSuggestionSubscription();
    }
    ngDoCheck() {
        super.ngDoCheck();
        this.synchronizing = true;
        // we add the model validation to
        // avoid exceptions if the model was not sent
        /* c8 ignore else */
        if (this.model && this.refresh) {
            this.fetchItems();
            this.refresh = false;
        }
        // solution for pending bug resolution from the kendo team
        // combobox component is not triggering selectionchange event when selectedItem is changed programmatically
        // bug id 1337660
        /* c8 ignore else */
        if (this.combo &&
            (!this.combo.value !== !this.selectedItem || // using xor sacampos !A && B || A && !B ==> !A !== !B
                (this.combo.value &&
                    this.selectedItem &&
                    this.combo.value.value !== this.selectedItem.value))) {
            const kendoCombo = this.combo;
            kendoCombo._filtering = !1;
            let item = kendoCombo.data[this.model.SelectedIndex];
            /* c8 ignore else */
            if (item === undefined) {
                item = this.source[this.model.SelectedIndex];
            }
            kendoCombo.change(item);
            kendoCombo.disabled = this.disabled;
        }
        this.synchronizing = false;
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.setDynamicStylesComboBox(super.setMyStyle());
        if (this.combo) {
            /* c8 ignore next reason: This function is override to avoid the combo box toggle the pop up after search */
            this.combo.searchBarChange = (text) => {
                const currentTextLength = this.combo.text ? this.combo.text.length : 0;
                this.combo['backspacePressed'] =
                    text.length < currentTextLength ? true : false;
                this.combo.text = text;
                this.combo['selectionService'].resetSelection([]);
                this.combo['_filtering'] = true;
                if (this.combo.filterable && this.combo['_filtering'] !== text) {
                    this.combo['_filtering'] = text;
                    this.combo.filterChange.emit(text);
                }
                else {
                    this.combo['search'](text);
                }
            };
        }
    }
    /**
     * Return the AutoCompleteSource from the model
     */
    get autoCompleteSource() {
        return this.model.AutoCompleteSource;
    }
    /**
     * Returns the data source URL of this component.
     */
    get url() {
        /* c8 ignore else */
        if (this.dataUrl && this.dataUrl.length > 0) {
            return this.dataUrl;
        }
        return this.defaultDataUrl;
    }
    /**
     * Returns the Selected Item
     */
    get selectedItem() {
        /* c8 ignore else */
        if (this.model) {
            /* c8 ignore else */ if (this.model.SelectedIndex > -1 &&
                this.source != null &&
                this.source.length > this.model.SelectedIndex) {
                /* c8 ignore else */
                if (this.customValue &&
                    this.dropDownStyle === DropDownStyle.DropDown &&
                    this.text !== null &&
                    this.source[this.model.SelectedIndex].text !== this.text) {
                    this.customValue.text = this.text;
                    this.setTextToCombo(this.text);
                    return this.customValue;
                }
                const item = this.source[this.model.SelectedIndex];
                this.setTextWithDisplayText(item);
                return item;
            }
            else if (this.model.SelectedIndex === -1 &&
                this.dropDownStyle === DropDownStyle.DropDown &&
                this.customValue) {
                /* c8 ignore else */
                if (this.text !== this.customValue.text) {
                    this.customValue.text = this.text;
                    this.setTextToCombo(this.text);
                }
                return this.customValue;
            }
        }
        return null;
    }
    set selectedItem(value) {
        const currentValue = value;
        this.model.SelectedIndex =
            this.source !== null ? this.source.indexOf(currentValue) : null;
        if (this.model.SelectedIndex === -1 &&
            this.dropDownStyle === DropDownStyle.DropDown &&
            currentValue &&
            !!currentValue.text) {
            this.text = currentValue.text;
            this.customValue = currentValue;
        }
        else {
            this.customValue = {};
        }
    }
    /**
     * Set the Selected Index
     */
    set selectedIndex(index) {
        /* c8 ignore else */
        if (this.source && index < this.source.length && index >= 0) {
            this.model.SelectedIndex = index;
            const item = this.source[index];
            this.text = item.text;
        }
        else if (index === -1) {
            this.model.SelectedIndex = index;
            this.text = '';
        }
    }
    /**
     * Returns the Selected Index
     */
    get selectedIndex() {
        return this.model.SelectedIndex ?? -1;
    }
    /**
     * Gets text of current combo box, return null as default value to validate against
     * empty values.
     */
    get text() {
        return this.model ? this.model.Text : null;
    }
    /**
     * Sets text for current combo box
     */
    set text(value) {
        this.model.Text = value;
    }
    get dropDownStyle() {
        return this.model.DropDownStyle;
    }
    /**
     * Gets the AutoComplete value flag
     */
    get autoCompleteMode() {
        return this.model.AutoCompleteMode;
    }
    /**
     * Gets the showSuggestionList value flag
     */
    /* c8 ignore next */
    get showSuggestionList() {
        return (this.autoCompleteMode === AutoCompleteMode.Suggest ||
            this.autoCompleteMode === AutoCompleteMode.SuggestAppend);
    }
    /**
     * Determines whether append auto complete is
     * @returns
     */
    get isAppendAutoComplete() {
        return this.autoCompleteMode === AutoCompleteMode.Append;
    }
    executeChangeEvents(event) {
        this.SelectedIndexChanged.emit(new EventData$1(event, this.id));
        this.SelectedValueChanged.emit(new EventData$1(event, this.id));
        this.TextChanged.emit(new EventData$1(event, this.id));
        this.SelectionChangeCommitted.emit(new EventData$1(event, this.id));
    }
    executeTextChange(event) {
        this.TextChanged.emit(new EventData$1(event, this.id));
    }
    valueChange(event) {
        /* c8 ignore else */
        if (!event || this.synchronizing) {
            return;
        }
        this.selectedItem = event;
        this.text = event.text;
        if (event.value === -1) {
            this.executeTextChange(event);
        }
        else {
            this.executeChangeEvents(event);
        }
    }
    /**
     * Handles filter
     * @param value the string to apply filtering
     */
    handleFilter(value) {
        this.items = this.source.filter((s) => s.text.toLowerCase().indexOf(value.toLowerCase()) !== -1);
        /* c8 ignore else */
        if (this.autoCompleteSource === AutoCompleteSource.ListItems &&
            this.showSuggestionList) {
            this.combo.toggle(this.items.length > 0);
        }
        if (this.shouldSuggest(value)) {
            const suggestion = this.searchSuggestionService.getSuggestion(value, this.items);
            if (suggestion) {
                this.suggestionSubject.next(suggestion);
            }
        }
        this.previousUserInput = value;
    }
    /**
     * Method to verify if the component should suggest a result
     * @param value
     * @returns boolean
     */
    shouldSuggest(value) {
        return (this.dropDownStyle == DropDownStyle.DropDown &&
            (this.autoCompleteMode == AutoCompleteMode.Append ||
                this.autoCompleteMode == AutoCompleteMode.SuggestAppend) &&
            value != '' &&
            (this.previousUserInput.length < value.length ||
                this.previousUserInput != value) &&
            this.items.length > 0);
    }
    /**
     * Sets the suggestion subscription.
     * When it's trigered sets the suggestion value, selected text and focused combo item
     * @readonly
     * @type {Subscription}
     * @memberof ComboBoxComponent
     */
    getSuggestionSubscription() {
        return this.suggestionSubject
            .asObservable()
            .pipe(debounceTime(50))
            .subscribe((suggestionResult) => {
            this.combo.searchbar.input.nativeElement.value =
                suggestionResult.userInput +
                    suggestionResult.suggestion.substring(suggestionResult.userInput.length, suggestionResult.suggestion.length);
            this.combo.searchbar.input.nativeElement.setSelectionRange(suggestionResult.userInput.length, suggestionResult.suggestion.length);
            this.combo['selectionService'].focus(suggestionResult.index);
        });
    }
    change(event) {
        /// overriding base class behavior
    }
    /**
     * Applies focus to input or selectable element in
     * component. It triggers dom element focus()
     */
    applyFocus() {
        this.isApplyingFocus = true;
        this.combo ? this.combo?.focus() : this.dropDown?.focus();
        this.isApplyingFocus = false;
    }
    setMyStyle() {
        /* c8 ignore else */
        if (this.model.Style?.Dirty) {
            this.setDynamicStylesComboBox(super.setMyStyle());
        }
        return this.removesStylesAppliedToCustomCombo(super.setMyStyle());
    }
    /**
     * Sets dynamic styles to ComboBox.
     * Some styles defined in dynamicStylesProps needs to be applied
     * only to span to have the same behavior as original app.
     */
    setDynamicStylesComboBox(style) {
        const comboItem = this.dropDownStyle === DropDownStyle.DropDownList
            ? this.dropDown
            : this.combo;
        let span = comboItem?.wrapper.nativeElement;
        span =
            span !== undefined && this.dropDownStyle === DropDownStyle.DropDownList
                ? span.querySelector('.k-input-inner')
                : span;
        const copyOfStyle = Object.assign({}, style);
        // Verifies that span is displayed and style has styles.
        /* c8 ignore else */
        if (span && copyOfStyle) {
            for (const key of this.dynamicStylesProps) {
                // Verifies that property of style exist.
                /* c8 ignore else */
                if (copyOfStyle[key]) {
                    this.render2.setStyle(span, key, copyOfStyle[key]);
                }
            }
        }
    }
    /**
     * removes the styles that don't need to be applied to the combo element and that
     * were previosuly applied to the span element.
     */
    removesStylesAppliedToCustomCombo(style) {
        const copyOfStyle = Object.assign({}, style);
        // Verifies that span is displayed and style has styles.
        /* c8 ignore else */
        if (copyOfStyle) {
            for (const key of this.dynamicStylesProps) {
                // Verifies that property of style exist.
                /* c8 ignore else */
                if (copyOfStyle[key]) {
                    // Removes property of style that were added to span.
                    delete copyOfStyle[key];
                }
            }
        }
        return copyOfStyle;
    }
    /**
     * Opens handler
     * @param event
     */
    openHandler(event) {
        if (this.combo['filterText'] !== '' &&
            this.isAppendAutoComplete &&
            this.dropDownStyle === DropDownStyle.DropDown) {
            event.preventDefault();
        }
        else {
            this.open(event);
        }
    }
    /**
     * KeyDown handler for the DropDownList style combo.
     * The kendo component opens the popUp when the enter key is pressed
     * This is not the behavior in the winforms control, so we need to close it.
     * @param event
     */
    keyDownHandler(event) {
        if (this.dropDownStyle === DropDownStyle.DropDownList &&
            event.key === 'Enter') {
            this.dropDown.toggle(false);
        }
    }
    /**
     * Sets the text to combobox if the property text
     * is different from the customValue text.
     * Solution for bug ComboBox not refreshing the SelectedValue after loading information.
     * Bug id 422453
     */
    setTextToCombo(value) {
        /* c8 ignore else */
        if (this.combo) {
            this.combo.text = value;
            this.combo.value = { text: value };
        }
        else if (this.dropDown) {
            this.dropDown.text = value;
        }
    }
    /**
     * Selects the text of the combobox on focus
     */
    selectText() {
        this.combo.searchbar.input.nativeElement.select();
    }
    /**
     * Gets the kendo-pop up settings to customize the dropDown item's display.
     *
     * @returns the kendo-popup settings.
     */
    getPopupSettings() {
        const settings = {};
        /* c8 ignore else */
        if (this.model?.DropDownWidth != undefined) {
            settings['width'] = this.model.DropDownWidth;
        }
        settings['popupClass'] = this.getPopupClass();
        return settings;
    }
    /**
     * Gets the kendo-popup class to customize the dropDown item's display.
     *
     * @returns the kendo-popup settings.
     */
    getPopupClass() {
        if ((this.model?.FontStyle & FontStyle.bold) == FontStyle.bold) {
            return 'bold';
        }
        if ((this.model?.FontStyle & FontStyle.italic) == FontStyle.italic) {
            return 'italic';
        }
        return '';
    }
    /**
     * Gets the kendo-dropdownlist class to customize the dropDown seleted item.
     *
     * @returns the kendo-dropdownlist class
     */
    getComboboxClass() {
        let comboboxClass = this.class == undefined ? '' : this.class;
        if (this.model?.FontStyle == FontStyle.bold) {
            comboboxClass += ' comboboxBold';
        }
        if (this.model?.FontStyle == FontStyle.italic) {
            comboboxClass += ' comboboxItalic';
        }
        return comboboxClass;
    }
    /**
     * Apply text to input when has display text
     * @param currentValue The current selected value
     */
    setTextWithDisplayText(currentValue) {
        /* c8 ignore else */
        if (currentValue.displayText !== undefined &&
            this.selectedIndex !== -1 &&
            this.dropDownStyle === DropDownStyle.DropDownList) {
            this.setTextToCombo(currentValue.displayText);
        }
    }
    ngOnDestroy() {
        if (this.suggestionSubscription) {
            this.suggestionSubscription.unsubscribe();
        }
    }
};
ComboBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ComboBoxComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: SearchSuggestionService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ComboBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ComboBoxComponent, selector: "wm-combobox", inputs: { model: "model", dataUrl: "dataUrl", filterable: "filterable" }, outputs: { SelectedIndexChanged: "SelectedIndexChanged", SelectionChangeCommitted: "SelectionChangeCommitted" }, viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }, { propertyName: "combo", first: true, predicate: ["comboBox"], descendants: true }, { propertyName: "dropDown", first: true, predicate: ["dropDown"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #displayElement *ngIf=\"model\">\r\n  <kendo-dropdownlist #dropDown [data]=\"items\" [textField]=\"'text'\" [virtual]=\"virtual\" [valueField]=\"'value'\"\r\n    [filterable]=\"filterable\" [loading]=\"loading\" [(ngModel)]=\"selectedItem\" (valueChange)=\"valueChange($event)\"\r\n    (open)=\"open($event)\" (close)=\"close($event)\" (keydown)=\"keyDownHandler($event)\" wmControls [hostComponent]=\"this\"\r\n    (filterChange)=\"handleFilter($event)\" *ngIf=\"dropDownStyle == 'DropDownList'\" [disabled]=\"disabled\"\r\n    [ngClass]=\"getComboboxClass()\" [ngStyle]=\"setMyStyle()\" data-mobilize=\"combobox\" [popupSettings]=\"getPopupSettings()\">\r\n    <ng-template kendoDropDownListItemTemplate let-dataItem>\r\n      <span>{{\r\n        dataItem.displayText ? dataItem.displayText : dataItem.text\r\n        }}</span>\r\n    </ng-template>\r\n  </kendo-dropdownlist>\r\n\r\n  <kendo-combobox #comboBox [data]=\"items\" [virtual]=\"virtual\" [textField]=\"'text'\" [filterable]=\"filterable\"\r\n    [loading]=\"loading\" [valueField]=\"'value'\" [(ngModel)]=\"selectedItem\" (valueChange)=\"valueChange($event)\"\r\n    (open)=\"openHandler($event)\" (close)=\"close($event)\" (focus)=\"selectText($event)\" wmControls [hostComponent]=\"this\"\r\n    *ngIf=\"dropDownStyle == 'DropDown'\" [disabled]=\"disabled\" [ngClass]=\"getComboboxClass()\" [allowCustom]=\"'true'\"\r\n    [valueNormalizer]=\"valueNormalizer\" (filterChange)=\"handleFilter($event)\" [clearButton]=\"false\"\r\n    [suggest]=\"false\" [ngStyle]=\"setMyStyle()\" [popupSettings]=\"getPopupSettings()\"\r\n    data-mobilize=\"combobox\">\r\n    <ng-template kendoDropDownListItemTemplate let-dataItem>\r\n      <span>{{\r\n        dataItem.displayText ? dataItem.displayText : dataItem.text\r\n        }}</span>\r\n    </ng-template>\r\n  </kendo-combobox>\r\n</div>", styles: ["::ng-deep .k-disabled{padding:unset}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i8$1.ItemTemplateDirective, selector: "[kendoDropDownListItemTemplate],[kendoComboBoxItemTemplate],[kendoAutoCompleteItemTemplate],[kendoMultiSelectItemTemplate]" }, { kind: "component", type: i8$1.ComboBoxComponent, selector: "kendo-combobox", inputs: ["focusableId", "allowCustom", "data", "value", "textField", "valueField", "valuePrimitive", "valueNormalizer", "placeholder", "popupSettings", "listHeight", "iconClass", "loading", "suggest", "clearButton", "disabled", "itemDisabled", "readonly", "tabindex", "tabIndex", "filterable", "virtual", "size", "rounded", "fillMode"], outputs: ["valueChange", "selectionChange", "filterChange", "open", "opened", "close", "closed", "focus", "blur"], exportAs: ["kendoComboBox"] }, { kind: "component", type: i8$1.DropDownListComponent, selector: "kendo-dropdownlist", inputs: ["iconClass", "loading", "data", "value", "textField", "valueField", "popupSettings", "listHeight", "defaultItem", "disabled", "itemDisabled", "readonly", "filterable", "virtual", "ignoreCase", "delay", "valuePrimitive", "tabindex", "tabIndex", "size", "rounded", "fillMode", "id"], outputs: ["valueChange", "filterChange", "selectionChange", "open", "opened", "close", "closed", "focus", "blur"], exportAs: ["kendoDropDownList"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    MarkForCheck(),
    NotifyChange('SelectedIndex'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], ComboBoxComponent.prototype, "selectedItem", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SelectedIndex'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ComboBoxComponent.prototype, "selectedIndex", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Text'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ComboBoxComponent.prototype, "text", null);
__decorate([
    serverEvent('DataManagerPositionChanged'),
    serverEvent('SelectedIndexChanged'),
    serverEvent('SelectedValueChanged'),
    serverEvent('TextChanged'),
    serverEvent('SelectionChangeCommitted'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ComboBoxComponent.prototype, "executeChangeEvents", null);
__decorate([
    serverEvent('TextChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ComboBoxComponent.prototype, "executeTextChange", null);
ComboBoxComponent = __decorate([
    dataTransfer(['cmbBox']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        SearchSuggestionService,
        ContainerInteractionService])
], ComboBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ComboBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-combobox', inputs: ['model'], template: "<div #displayElement *ngIf=\"model\">\r\n  <kendo-dropdownlist #dropDown [data]=\"items\" [textField]=\"'text'\" [virtual]=\"virtual\" [valueField]=\"'value'\"\r\n    [filterable]=\"filterable\" [loading]=\"loading\" [(ngModel)]=\"selectedItem\" (valueChange)=\"valueChange($event)\"\r\n    (open)=\"open($event)\" (close)=\"close($event)\" (keydown)=\"keyDownHandler($event)\" wmControls [hostComponent]=\"this\"\r\n    (filterChange)=\"handleFilter($event)\" *ngIf=\"dropDownStyle == 'DropDownList'\" [disabled]=\"disabled\"\r\n    [ngClass]=\"getComboboxClass()\" [ngStyle]=\"setMyStyle()\" data-mobilize=\"combobox\" [popupSettings]=\"getPopupSettings()\">\r\n    <ng-template kendoDropDownListItemTemplate let-dataItem>\r\n      <span>{{\r\n        dataItem.displayText ? dataItem.displayText : dataItem.text\r\n        }}</span>\r\n    </ng-template>\r\n  </kendo-dropdownlist>\r\n\r\n  <kendo-combobox #comboBox [data]=\"items\" [virtual]=\"virtual\" [textField]=\"'text'\" [filterable]=\"filterable\"\r\n    [loading]=\"loading\" [valueField]=\"'value'\" [(ngModel)]=\"selectedItem\" (valueChange)=\"valueChange($event)\"\r\n    (open)=\"openHandler($event)\" (close)=\"close($event)\" (focus)=\"selectText($event)\" wmControls [hostComponent]=\"this\"\r\n    *ngIf=\"dropDownStyle == 'DropDown'\" [disabled]=\"disabled\" [ngClass]=\"getComboboxClass()\" [allowCustom]=\"'true'\"\r\n    [valueNormalizer]=\"valueNormalizer\" (filterChange)=\"handleFilter($event)\" [clearButton]=\"false\"\r\n    [suggest]=\"false\" [ngStyle]=\"setMyStyle()\" [popupSettings]=\"getPopupSettings()\"\r\n    data-mobilize=\"combobox\">\r\n    <ng-template kendoDropDownListItemTemplate let-dataItem>\r\n      <span>{{\r\n        dataItem.displayText ? dataItem.displayText : dataItem.text\r\n        }}</span>\r\n    </ng-template>\r\n  </kendo-combobox>\r\n</div>", styles: ["::ng-deep .k-disabled{padding:unset}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: SearchSuggestionService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], combo: [{
                type: ViewChild,
                args: ['comboBox', { static: false }]
            }], dropDown: [{
                type: ViewChild,
                args: ['dropDown', { static: false }]
            }], dataUrl: [{
                type: Input
            }], filterable: [{
                type: Input
            }], SelectedIndexChanged: [{
                type: Output
            }], SelectionChangeCommitted: [{
                type: Output
            }], selectedItem: [], selectedIndex: [], text: [], executeChangeEvents: [], executeTextChange: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class ToolstripInteractionService {
    constructor() {
        /**
         * Event emitted of toolstrip interaction service
         * Subject statement
         */
        this.eventEmitted = new Subject();
    }
    /**
     * Gets event emitted notification
     */
    get toolstripEventNotification() {
        return this.eventEmitted.asObservable();
    }
    /**
     * Notifies an event to the container
     * component
     * @param event The current event data
     */
    toolStripOnSelect(event) {
        this.eventEmitted.next(event);
    }
}
ToolstripInteractionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolstripInteractionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ToolstripInteractionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolstripInteractionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolstripInteractionService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class BindingNavigatorService {
    constructor() {
        /**
         * Event emitted of Binding Navigator service
         * Subject statement
         */
        this.eventEmitted = new Subject();
    }
    /**
     * Gets event emitted notification
     */
    get bindingNavigatorEventNotification() {
        return this.eventEmitted.asObservable();
    }
    /**
     * Notifies an event to the container
     * component
     * @param event The current event data
     */
    bindingNavigatorOnClick(event) {
        this.eventEmitted.next(event);
    }
}
BindingNavigatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BindingNavigatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BindingNavigatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BindingNavigatorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BindingNavigatorService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
// Summary:
// Specifies the behaviors of a link in a LinkLabel
var LinkBehavior;
(function (LinkBehavior) {
    // Summary:
    //The behavior of this setting depends on the browser.
    LinkBehavior[LinkBehavior["SystemDefault"] = 0] = "SystemDefault";
    // Summary:
    // The link always displays with underlined text.
    LinkBehavior[LinkBehavior["AlwaysUnderline"] = 1] = "AlwaysUnderline";
    // Summary:
    // The link displays underlined text only when the mouse is hovered over the link text.
    LinkBehavior[LinkBehavior["HoverUnderline"] = 2] = "HoverUnderline";
    // Summary:
    // The link text is never underlined. The link can still be distinguished from other
    // text by use of the LinkColor property of the LinkLabel control.
    LinkBehavior[LinkBehavior["NeverUnderline"] = 3] = "NeverUnderline";
})(LinkBehavior || (LinkBehavior = {}));

let LinkLabelComponent = class LinkLabelComponent extends SimpleAutoSizeComponent {
    /* c8 ignore start */
    constructor(changeDetector, rndr2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, rndr2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.rndr2 = rndr2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /**
         * Output  of link label component
         */
        this.Click = new EventEmitter();
        this.LinkClicked = new EventEmitter();
    }
    /* c8 ignore stop */
    /**
     * Gets linkBehavior property from model
     */
    get linkBehavior() {
        return this.model.LinkBehavior;
    }
    /**
     * Gets isHoverUnderlineClass based on the LinkBevahoir property to set class
     */
    get isHoverUnderlineClass() {
        return this.model.LinkBehavior === LinkBehavior.HoverUnderline;
    }
    /**
     * Gets isNeverUnderlineClass based on the LinkBevahoir property to set class
     */
    get isNeverUnderlineClass() {
        return this.model.LinkBehavior === LinkBehavior.NeverUnderline;
    }
    set displayElementLabel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /**
     * Retrieves the border style css class name
     */
    get borderStyle() {
        if (this.model.BorderStyle === FormBorderStyles.FixedSingle) {
            return ' borderFixedSingle';
        }
        else if (this.model.BorderStyle === FormBorderStyles.Fixed3D) {
            return ' borderFixed3D';
        }
        return '';
    }
    /**
     * Gets the css classes to be applied
     */
    get linkLabelClass() {
        return `${this.class}${this.borderStyle}`;
    }
    /**
     * Servers event
     * @param event the current event javascript object
     */
    click(event) {
        this.linkClicked(event);
        this.Click.emit(new EventData$1(event, this.id));
    }
    linkClicked(event) {
        this.LinkClicked.emit(new EventData$1(event, this.id));
    }
};
LinkLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LinkLabelComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
LinkLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: LinkLabelComponent, selector: "wm-link-label", inputs: { model: "model" }, outputs: { Click: "Click", LinkClicked: "LinkClicked" }, viewQueries: [{ propertyName: "displayElementLabel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<a #displayElement *ngIf=\"model\" href=\"#\" class=\"k-form-field\" (click)=\"click($event)\" [ngClass]=\"linkLabelClass\"\r\n    [class.hoverUnderlineClass]=\"isHoverUnderlineClass\" [class.neverUnderlineClass]=\"isNeverUnderlineClass\"\r\n    [class.disabledClass]=\"disabled\" [ngStyle]=\"setMyStyle()\" [attr.disabled]=\"disabled\" wmControls\r\n    [hostComponent]=\"this\">{{text}}</a>", styles: [".hoverUnderlineClass:hover{text-decoration:underline}.neverUnderlineClass,.hoverUnderlineClass{text-decoration:none}.disabledClass{color:gray;cursor:not-allowed;text-decoration:none;pointer-events:none}a{border-width:thin}a.borderFixedSingle{border-style:solid;border-color:#00000047}a.borderFixed3D{border-style:inset}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LinkLabelComponent.prototype, "click", null);
__decorate([
    serverEvent('LinkClicked'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LinkLabelComponent.prototype, "linkClicked", null);
LinkLabelComponent = __decorate([
    dataTransfer(['lnkLbl']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], LinkLabelComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LinkLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-link-label', inputs: ['model'], template: "<a #displayElement *ngIf=\"model\" href=\"#\" class=\"k-form-field\" (click)=\"click($event)\" [ngClass]=\"linkLabelClass\"\r\n    [class.hoverUnderlineClass]=\"isHoverUnderlineClass\" [class.neverUnderlineClass]=\"isNeverUnderlineClass\"\r\n    [class.disabledClass]=\"disabled\" [ngStyle]=\"setMyStyle()\" [attr.disabled]=\"disabled\" wmControls\r\n    [hostComponent]=\"this\">{{text}}</a>", styles: [".hoverUnderlineClass:hover{text-decoration:underline}.neverUnderlineClass,.hoverUnderlineClass{text-decoration:none}.disabledClass{color:gray;cursor:not-allowed;text-decoration:none;pointer-events:none}a{border-width:thin}a.borderFixedSingle{border-style:solid;border-color:#00000047}a.borderFixed3D{border-style:inset}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementLabel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], Click: [{
                type: Output
            }], LinkClicked: [{
                type: Output
            }], click: [], linkClicked: [] } });

let ToolStripLabelComponent = class ToolStripLabelComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, service, bringTopServ, bindingNavServ, containerInteraction, toolstripIntServ) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.service = service;
        this.bringTopServ = bringTopServ;
        this.bindingNavServ = bindingNavServ;
        this.containerInteraction = containerInteraction;
        this.toolstripIntServ = toolstripIntServ;
        /* c8 ignore stop */
        this.LinkClicked = new EventEmitter();
    }
    linkClicked(event) {
        /* c8 ignore else */
        if (this.bindingNavServ) {
            this.bindingNavServ.bindingNavigatorOnClick(event);
        }
        else if (this.toolstripIntServ != null) {
            const args = { item: this.model, index: '0' };
            this.toolstripIntServ.toolStripOnSelect(args);
        }
        this.LinkClicked.emit(new EventData$1(event, this.id));
        event.stopPropagation();
    }
    /**
     * Gets the IsLink value.
     */
    get isLink() {
        return this.model.IsLink;
    }
    /**
     * Sets the IsLink value.
     */
    set isLink(value) {
        this.model.IsLink = value;
    }
    /**
     * Gets the ToolTipText value.
     */
    get toolTipText() {
        return this.model.ToolTipText;
    }
    /**
     * Sets the ToolTipText value.
     */
    set toolTipText(value) {
        this.model.ToolTipText = value;
    }
    /**
     * Auto tooltip property
     *
     * @memberof ToolStripLabelComponent
     */
    set autoToolTip(value) {
        this.model.AutoToolTip = value;
    }
    /**
     * Auto tooltip property
     *
     * @type {boolean}
     * @memberof ToolStripLabelComponent
     */
    get autoToolTip() {
        return this.model.AutoToolTip;
    }
    /**
     * Gets Class name for dynamic components.
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.cssClass = `${this.class ? this.class : this.model.Name}`;
        this.changeDetector.detectChanges();
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    /**
     * Set default toolTipText.
     *
     * @memberof ToolStripLabelComponent
     */
    setDefaultTooltip() {
        /* c8 ignore else */
        if (this.model && this.autoToolTip !== false) {
            return this.toolTipText ?? this.text;
        }
    }
};
ToolStripLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripLabelComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i1.WebMapService }, { token: i3.BringTopService, optional: true }, { token: BindingNavigatorService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: ToolstripInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ToolStripLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ToolStripLabelComponent, selector: "wm-toolstrip-label", outputs: { LinkClicked: "LinkClicked" }, usesInheritance: true, ngImport: i0, template: "<wm-label *ngIf=\"!isLink\" [model]=\"model\" [tooltip]=\"setDefaultTooltip()\" [ngClass]=\"cssClass\"></wm-label>\r\n<wm-link-label *ngIf=\"isLink\" [model]=\"model\" (click)=\"linkClicked($event)\" [tooltip]=\"setDefaultTooltip()\"\r\n    [ngClass]=\"cssClass\">\r\n</wm-link-label>", styles: [".labelLinkUnderline{text-decoration:underline}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: LabelComponent, selector: "wm-label", inputs: ["model"], outputs: ["Click", "DoubleClick", "MouseEnter", "MouseLeave"] }, { kind: "component", type: LinkLabelComponent, selector: "wm-link-label", inputs: ["model"], outputs: ["Click", "LinkClicked"] }] });
__decorate([
    serverEvent('LinkClicked'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ToolStripLabelComponent.prototype, "linkClicked", null);
ToolStripLabelComponent = __decorate([
    dataTransfer(['tlStrpLbl']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        WebMapService,
        BringTopService,
        BindingNavigatorService,
        ContainerInteractionService,
        ToolstripInteractionService])
], ToolStripLabelComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-toolstrip-label', template: "<wm-label *ngIf=\"!isLink\" [model]=\"model\" [tooltip]=\"setDefaultTooltip()\" [ngClass]=\"cssClass\"></wm-label>\r\n<wm-link-label *ngIf=\"isLink\" [model]=\"model\" (click)=\"linkClicked($event)\" [tooltip]=\"setDefaultTooltip()\"\r\n    [ngClass]=\"cssClass\">\r\n</wm-link-label>", styles: [".labelLinkUnderline{text-decoration:underline}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i1.WebMapService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: BindingNavigatorService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: ToolstripInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { LinkClicked: [{
                type: Output
            }], linkClicked: [] } });

let ToolStripTextBoxComponent = class ToolStripTextBoxComponent extends TextBoxComponent {
    /**
     * Gets the AutoSize value
     */
    get autosize() {
        return this.model.AutoSize;
    }
    /**
     * Sets the AutoSize value
     */
    set autosize(value) {
        this.model.AutoSize = value;
    }
    /**
     * Return the size regarding to AutoSize value.
     */
    sizes() {
        return this.autosize ? '100%' : null;
    }
    ngOnInit() {
        this.cssClass = `${this.class ? this.class : this.model.Name}`;
    }
};
ToolStripTextBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripTextBoxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
ToolStripTextBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ToolStripTextBoxComponent, selector: "wm-toolstrip-textbox", usesInheritance: true, ngImport: i0, template: "<wm-textbox [model]=\"model\" [ngClass]=\"cssClass\"></wm-textbox>", styles: [".l_caption{float:right}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: TextBoxComponent, selector: "wm-textbox", inputs: ["model"], outputs: ["Click", "DoubleClick"] }] });
ToolStripTextBoxComponent = __decorate([
    dataTransfer(['tlStrpTxtBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], ToolStripTextBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripTextBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-toolstrip-textbox', template: "<wm-textbox [model]=\"model\" [ngClass]=\"cssClass\"></wm-textbox>", styles: [".l_caption{float:right}\n"] }]
        }] });

let ToolStripMenuItemComponent = class ToolStripMenuItemComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, shortcutsService) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.service = service;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.shortcutsService = shortcutsService;
        /* c8 ignore stop */
        this.anchorAlign = { horizontal: 'right', vertical: 'top' };
        this.popupAlign = { horizontal: 'left', vertical: 'top' };
        this.dropdownitems = [];
        /**
         * Indicates if the component is inside a wm-contextMenuStrip
         *
         * @memberof ToolStripMenuItemComponent
         */
        this.BelongsToContextMenu = false;
        this.Click = new EventEmitter();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        this.shortcutsService?.unregisterInstance(this);
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        this.shortcutsService?.registerInstance(this);
        /* c8 ignore next */
        this.triggerShortcutUnderlineSubscription = this.UnderlineSubscription;
    }
    get image() {
        return this.model.Image;
    }
    /**
     * Sets the text for ToolStripMenuItemComponent
     */
    /* c8 ignore next */
    set text(value) {
        this.model.Text = value;
    }
    /**
     * Override the property Text to remove the ampersand
     */
    get text() {
        return RemoveAmpersand.remove(this.model.Text, this.showUnderline);
    }
    clickHandler(event) {
        if (this.model.CheckOnClick) {
            this.CheckState =
                this.CheckState === CheckState.Checked
                    ? CheckState.Unchecked
                    : CheckState.Checked;
        }
        this.Click.emit(new EventData$1(event, this.id));
        return this.BelongsToContextMenu; //Cancel serverEvent if the item belongs to a contextMenu (the context menu fires the event).
    }
    /**
     * Performs a click to the tool strip menu item component from
     * external shortcuts service
     * @param event Event argument triggered from shortcuts service
     */
    click(event) {
        this.element?.nativeElement.firstElementChild.click();
    }
    /**
     * Gets/Sets the CheckState
     *
     * @readonly
     * @type {CheckState}
     * @memberof ToolStripMenuItemComponent
     */
    get CheckState() {
        return this.model.CheckState ?? CheckState.Indeterminate;
    }
    set CheckState(value) {
        this.model.CheckState = value;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * Gets height
     * @returns height if exists in model, otherwise return default value 16px.
     */
    getHeight() {
        return this.model.Style ? this.model.Style.Height : '16px';
    }
    /**
     * Gets width
     * @returns width if exists in model, otherwise return default value 16px.
     */
    getWidth() {
        return this.model.Style ? this.model.Style.Width : '16px';
    }
    /**
     * Gets color
     * @returns ForeColor if exists in model, otherwise return default 'inherit'.
     */
    getColor() {
        return this.model.Style ? this.model.Style.ForeColor : 'inherit';
    }
    /**
     * Gets string indicating the type
     * @returns type
     */
    getType() {
        return 'ToolStripMenuItemComponent';
    }
    /**
     * Gets display element
     * @returns HTML display element or undefined if element is not rendered
     */
    getDisplayElement() {
        return this.element?.nativeElement;
    }
};
ToolStripMenuItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripMenuItemComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService, optional: true }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: ShortcutsService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ToolStripMenuItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ToolStripMenuItemComponent, selector: "wm-toolstrip-menuitem", inputs: { BelongsToContextMenu: "BelongsToContextMenu" }, outputs: { Click: "Click" }, usesInheritance: true, ngImport: i0, template: "<div #anchor (click)=\"clickHandler($event)\" [ngClass]=\"{'k-disabled': disabled}\"\r\n    [ngStyle]=\"{'pointer-events': disabled ? 'none' : 'auto'}\" [attr.disabled]=\"disabled\" class=\"clickable\">\r\n    <img *ngIf=\"!!image\" [style.height]=\"getHeight()\" [style.width]=\"getWidth()\" src=\"{{image}}\" />\r\n    <div *ngIf=\"!!text\" [style.color]=\"getColor()\" style=\"display: inline-block;\" [innerHTML]=\"text\"></div>\r\n</div>", styles: [".separator-horizontal{align-content:center;border-bottom:1px solid;width:100%}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
__decorate([
    NotifyChange('Text'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ToolStripMenuItemComponent.prototype, "text", null);
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Boolean)
], ToolStripMenuItemComponent.prototype, "clickHandler", null);
__decorate([
    MarkForCheck(),
    NotifyChange('CheckState'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ToolStripMenuItemComponent.prototype, "CheckState", null);
ToolStripMenuItemComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService,
        ShortcutsService])
], ToolStripMenuItemComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripMenuItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-toolstrip-menuitem', template: "<div #anchor (click)=\"clickHandler($event)\" [ngClass]=\"{'k-disabled': disabled}\"\r\n    [ngStyle]=\"{'pointer-events': disabled ? 'none' : 'auto'}\" [attr.disabled]=\"disabled\" class=\"clickable\">\r\n    <img *ngIf=\"!!image\" [style.height]=\"getHeight()\" [style.width]=\"getWidth()\" src=\"{{image}}\" />\r\n    <div *ngIf=\"!!text\" [style.color]=\"getColor()\" style=\"display: inline-block;\" [innerHTML]=\"text\"></div>\r\n</div>", styles: [".separator-horizontal{align-content:center;border-bottom:1px solid;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { BelongsToContextMenu: [{
                type: Input
            }], Click: [{
                type: Output
            }], text: [], clickHandler: [], CheckState: [] } });

let ToolStripComboBoxComponent = class ToolStripComboBoxComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        this.dataUrl = 'api/toolstripcombobox';
    }
};
ToolStripComboBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripComboBoxComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ToolStripComboBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ToolStripComboBoxComponent, selector: "wm-toolstrip-combobox", inputs: { dataUrl: "dataUrl" }, usesInheritance: true, ngImport: i0, template: "<wm-combobox [model]=\"model\" [dataUrl]=\"dataUrl\"></wm-combobox>", styles: [""], dependencies: [{ kind: "component", type: ComboBoxComponent, selector: "wm-combobox", inputs: ["model", "dataUrl", "filterable"], outputs: ["SelectedIndexChanged", "SelectionChangeCommitted"] }] });
ToolStripComboBoxComponent = __decorate([
    dataTransfer(['tlStrpCbo']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], ToolStripComboBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripComboBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-toolstrip-combobox', template: "<wm-combobox [model]=\"model\" [dataUrl]=\"dataUrl\"></wm-combobox>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { dataUrl: [{
                type: Input
            }] } });

let ToolStripButtonComponent = class ToolStripButtonComponent extends ButtonComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, bindingNavServ, bringTopServ1) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ1);
        this.bindingNavServ = bindingNavServ;
        this.bringTopServ1 = bringTopServ1;
        /* c8 ignore stop */
        this.Click = new EventEmitter();
        /**
         * Mouse hover of tool strip button component
         */
        this.MouseHover = new EventEmitter();
    }
    /**
     * Gets the RightToLeftAutoMirrorImage value.
     */
    get rightToLeftAutoMirrarImage() {
        return this.model.RightToLeftAutoMirrorImage;
    }
    /**
     * Gets the image value.
     */
    get image() {
        return this.model.Image;
    }
    /**
     * Gets the Checked flag value.
     */
    get checked() {
        return this.model.Checked;
    }
    /**
     * Gets the DisplayStyle value.
     */
    get displayStyle() {
        return this.model.DisplayStyle;
    }
    /**
     * Gets the Text value.
     */
    get text() {
        return RemoveAmpersand.remove(this.model.Text);
    }
    /**
     * Gets the Enable value.
     */
    get enable() {
        return this.model.Enabled;
    }
    /**
     * Apply the enable style for the control.
     */
    ApplyEnableStyle() {
        return this.enable ? ' enabledStyle' : ' disabledStyle';
    }
    /**
     * Apply style to internal div text
     *
     * @return {*}  {*}
     * @memberof ToolStripButtonComponent
     */
    ApplyDivStyle() {
        return this.enable ? ' enabledStyle' : ' disabledDivStyle';
    }
    /**
     * Apply the necessary styles for the control.
     */
    /* c8 ignore next */
    ApplyButtonStyle() {
        return {
            transform: this.rightToLeftAutoMirrarImage ? 'scaleX(-1)' : '',
            opacity: this.enable ? 1 : 0.5
        };
    }
    /**
     * Return true is the image should be displayed otherwise false.
     */
    DisplayImage() {
        return (!!this.image &&
            (this.displayStyle === 'Image' || this.displayStyle === 'ImageAndText'));
    }
    /**
     * Override  base tooltip to apply a default custom configuration
     *
     * @readonly
     * @type {string}
     * @memberof ToolStripButtonComponent
     */
    get tooltip() {
        return this.model?.Tooltip ? this.model.Tooltip : this.text;
    }
    click(event) {
        /* c8 ignore else */
        if (this.bindingNavServ) {
            this.bindingNavServ.bindingNavigatorOnClick(event);
            event.stopPropagation();
        }
        this.Click.emit(new EventData$1(event, this.id));
    }
    /**
     * Mouses enter
     * @param event
     */
    mouseEnter(event) {
        this.MouseHover.emit(new EventData$1(event, this.id));
    }
    /**
     * Gets string indicating the type
     * @returns type
     */
    getType() {
        return 'ToolStripButtonComponent';
    }
};
ToolStripButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripButtonComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: BindingNavigatorService, optional: true }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ToolStripButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ToolStripButtonComponent, selector: "wm-toolstrip-button", outputs: { Click: "Click", MouseHover: "MouseHover" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\" (click)=\"click($event)\" [ngClass]=\"ApplyEnableStyle()\" [attr.disabled]=\"!enable\" wmControls\r\n  [hostComponent]=\"this\">\r\n  <img *ngIf=\"DisplayImage()\" src=\"{{image}}\" [ngStyle]=\"ApplyButtonStyle()\" />\r\n  <div *ngIf=\"displayStyle=='Text' || displayStyle=='ImageAndText'\" style=\"display: inline-block;\" [ngClass]=\"ApplyDivStyle()\" >{{text}}</div>\r\n</div>", styles: ["div.enabledStyle{opacity:1;pointer-events:auto}div.disabledStyle{opacity:.5;pointer-events:auto;cursor:default}div.disabledStyle:active{pointer-events:none}.disabledDivStyle{pointer-events:none;color:#424242}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ToolStripButtonComponent.prototype, "click", null);
__decorate([
    serverEvent('MouseHover'),
    serverEvent('MouseEnter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ToolStripButtonComponent.prototype, "mouseEnter", null);
ToolStripButtonComponent = __decorate([
    dataTransfer(['tlStrpBtn']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BindingNavigatorService,
        BringTopService])
], ToolStripButtonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-toolstrip-button', template: "<div *ngIf=\"model\" (click)=\"click($event)\" [ngClass]=\"ApplyEnableStyle()\" [attr.disabled]=\"!enable\" wmControls\r\n  [hostComponent]=\"this\">\r\n  <img *ngIf=\"DisplayImage()\" src=\"{{image}}\" [ngStyle]=\"ApplyButtonStyle()\" />\r\n  <div *ngIf=\"displayStyle=='Text' || displayStyle=='ImageAndText'\" style=\"display: inline-block;\" [ngClass]=\"ApplyDivStyle()\" >{{text}}</div>\r\n</div>", styles: ["div.enabledStyle{opacity:1;pointer-events:auto}div.disabledStyle{opacity:.5;pointer-events:auto;cursor:default}div.disabledStyle:active{pointer-events:none}.disabledDivStyle{pointer-events:none;color:#424242}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: BindingNavigatorService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { Click: [{
                type: Output
            }], MouseHover: [{
                type: Output
            }], click: [], mouseEnter: [] } });

let ToolStripDropdownButtonComponent = class ToolStripDropdownButtonComponent extends ControlComponent {
    /* c8 ignore next*/
    constructor(service, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, shortcutsService) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, shortcutsService);
        this.service = service;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.shortcutsService = shortcutsService;
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        this.shortcutsService?.registerInstance(this);
        /* c8 ignore next */
        this.triggerShortcutUnderlineSubscription = this.UnderlineSubscription;
    }
    /**
     * AfterViewInit life-cycle hook
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.applyDisabled();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        this.shortcutsService?.unregisterInstance(this);
    }
    /**
     * Gets the DisplayStyle value.
     */
    get displayStyle() {
        return this.model.DisplayStyle;
    }
    /**
     * Gets the image value.
     */
    get image() {
        return this.model.Image;
    }
    /**
     * Gets the Alignment value.
     */
    get alignment() {
        return this.model.Alignment;
    }
    /**
     * Gets string indicating the type
     * @returns type
     */
    getType() {
        return 'ToolStripDropdownButtonComponent';
    }
    /**
     * Generates a property into the model to be retrieved by
     * the kendo-toolbar component
     */
    applyDisabled() {
        if (this.model && this.model.disabled === undefined) {
            Object.defineProperty(this.model, 'disabled', {
                get: function () {
                    return !this.Enabled;
                }
            });
        }
    }
    /**
     * Return true if the image should be displayed otherwise false.
     */
    displayImage() {
        return (!!this.image &&
            (this.displayStyle === 'Image' || this.displayStyle === 'ImageAndText'));
    }
    /**
     * Return true if the text should be displayed otherwise false.
     */
    displayText() {
        return this.displayStyle === 'Text' || this.displayStyle === 'ImageAndText';
    }
    /**
     * Performs a click to the tool strip dropdown button component from
     * external shortcuts service
     * @param event Event argument triggered from shortcuts service
     */
    click(event) {
        this.element?.nativeElement.click();
    }
    /**
     * Sets the text for ToolStripDropDownButton
     */
    set text(value) {
        this.model.Text = value;
    }
    /**
     * Override the property Text to remove the ampersand
     */
    get text() {
        return RemoveAmpersand.remove(this.model.Text, this.showUnderline);
    }
};
ToolStripDropdownButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripDropdownButtonComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: ShortcutsService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ToolStripDropdownButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ToolStripDropdownButtonComponent, selector: "wm-toolstrip-dropdownbutton", usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\" [ngClass]=\"{'k-disabled': disabled}\"\r\n    [ngStyle]=\"{'pointer-events': disabled ? 'none' : 'auto'}\">\r\n    <img *ngIf=\"displayImage()\" src=\"{{image}}\" class=\"dropdownimage\" title=\"{{text}}\" />\r\n    <div *ngIf=\"displayText()\" class=\"dropdownbuttontext\" [innerHTML]=\"text\"></div>\r\n</div>", styles: [".dropdownbuttontext{display:inline-block;vertical-align:text-bottom;pointer-events:auto}.separator-horizontal{align-content:center;border-bottom:1px solid;width:100%;pointer-events:auto}.dropdownimage{pointer-events:auto}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
__decorate([
    NotifyChange('Text'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ToolStripDropdownButtonComponent.prototype, "text", null);
ToolStripDropdownButtonComponent = __decorate([
    dataTransfer(['tlStrpDrpDwnbBtn']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService,
        ShortcutsService])
], ToolStripDropdownButtonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripDropdownButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-toolstrip-dropdownbutton', template: "<div *ngIf=\"model\" [ngClass]=\"{'k-disabled': disabled}\"\r\n    [ngStyle]=\"{'pointer-events': disabled ? 'none' : 'auto'}\">\r\n    <img *ngIf=\"displayImage()\" src=\"{{image}}\" class=\"dropdownimage\" title=\"{{text}}\" />\r\n    <div *ngIf=\"displayText()\" class=\"dropdownbuttontext\" [innerHTML]=\"text\"></div>\r\n</div>", styles: [".dropdownbuttontext{display:inline-block;vertical-align:text-bottom;pointer-events:auto}.separator-horizontal{align-content:center;border-bottom:1px solid;width:100%;pointer-events:auto}.dropdownimage{pointer-events:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: ShortcutsService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { text: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class TopLevelToolstripItemComponent extends ToolBarToolComponent {
    /* c8 ignore next 3 */
    constructor(toolstripService) {
        super();
        this.toolstripService = toolstripService;
    }
    /**
     * Applies style to item
     * @param item the current menu item
     * @returns style
     */
    ApplyStyle(item) {
        return { outline: item.Checked ? 'solid 1px #1589FF' : '' };
    }
    /**
     * Determines whether menu item type is visible or not
     * @param item the current item to be displayed
     * @param expected the expected mapperId
     * @returns  true if the menu item is the expected type
     */
    isMenuItemType(item, expected) {
        return item.mapperId === expected;
    }
    /**
     * Select event handler
     * @param event
     */
    onSelect(event) {
        this.toolstripService.toolStripOnSelect(event);
        this.clickInternalItem(event);
    }
    /** Get the height of separator.
     * Calc is performed to set height to DIV and leave a space between the top and bottom of separator.
     */
    getSeparatorHeight(item) {
        /* c8 ignore else */
        if (item.level !== 1) {
            return '0px';
        }
        return item.Style ? `calc(${item.Style.Height} - 6px)` : '15px';
    }
    /**
     * Clicks internal item to trigger click event after keyboard interaction
     * @param event MenuStateEvent from kendo menu component
     * @memberof TopLevelToolstripItemComponent
     */
    clickInternalItem(event) {
        const keyDownEvent = event?.originalEvent;
        /* c8 ignore else */
        if (keyDownEvent &&
            (keyDownEvent.keyCode === 32 || keyDownEvent.keyCode === 13)) {
            // Add class clickable to element that can receive click event
            const internalElement = keyDownEvent.target.querySelector('.clickable');
            /* c8 ignore else */
            if (internalElement) {
                internalElement.click();
            }
        }
    }
}
TopLevelToolstripItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TopLevelToolstripItemComponent, deps: [{ token: ToolstripInteractionService }], target: i0.ɵɵFactoryTarget.Component });
TopLevelToolstripItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TopLevelToolstripItemComponent, selector: "wm-top-level-toolstrip-item", inputs: { items: "items" }, providers: [
        {
            provide: ToolBarToolComponent,
            useExisting: forwardRef(() => TopLevelToolstripItemComponent)
        }
    ], viewQueries: [{ propertyName: "toolbarTemplate", first: true, predicate: ["toolbarTemplate"], descendants: true, static: true }, { propertyName: "toolbarElement", first: true, predicate: ["toolbarElement"], descendants: true }, { propertyName: "popupTemplate", first: true, predicate: ["popupTemplate"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<ng-template #toolbarTemplate>\r\n    <span #toolbarElement>\r\n        <kendo-menu [items]=\"items\" (select)=\"onSelect($event)\" [ngClass]=\"{'right': items[0].Alignment === 'Right'}\" \r\n        [openOnClick]=\"{ toggle: 'click' }\">\r\n            <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n                <wm-toolstrip-button *ngIf=\"isMenuItemType(item, 'tlStrpBtn') && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\">\r\n                </wm-toolstrip-button>\r\n                <wm-toolstrip-textbox *ngIf=\"isMenuItemType(item, 'tlStrpTxtBx') && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\"></wm-toolstrip-textbox>\r\n                <wm-toolstrip-label *ngIf=\"isMenuItemType(item, 'tlStrpLbl') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-label>\r\n                <div *ngIf=\"isMenuItemType(item,'tlStrpSprtr') && item.Visible\"\r\n                    [ngClass]=\"{'separator-vertical': item.level === 1, 'separator-horizontal': item.level !== 1}\"\r\n                    [style.height]=\"getSeparatorHeight(item)\">\r\n                </div>\r\n                <wm-toolstrip-combobox *ngIf=\"isMenuItemType(item, 'tlStrpCbo') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-combobox>\r\n                <wm-toolstrip-dropdownbutton *ngIf=\"isMenuItemType(item,'tlStrpDrpDwnbBtn') && item.Visible\"\r\n                    [model]=\"item\">\r\n                </wm-toolstrip-dropdownbutton>\r\n                <wm-toolstrip-menuitem *ngIf=\"isMenuItemType(item, 'tlStrpMnuItm') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-menuitem>\r\n            </ng-template>\r\n        </kendo-menu>\r\n    </span>\r\n</ng-template>\r\n<ng-template #popupTemplate>\r\n    <span #popupElement>\r\n        <kendo-menu [vertical]=\"true\" [items]=\"items\" (select)=\"onSelect($event)\" [openOnClick]=\"{ toggle: 'click' }\">\r\n            <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n                <wm-toolstrip-button *ngIf=\"isMenuItemType(item, 'tlStrpBtn') && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\">\r\n                </wm-toolstrip-button>\r\n                <wm-toolstrip-textbox *ngIf=\"isMenuItemType(item, 'tlStrpTxtBx') && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\"></wm-toolstrip-textbox>\r\n                <wm-toolstrip-label *ngIf=\"isMenuItemType(item, 'tlStrpLbl') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-label>\r\n                <div *ngIf=\"isMenuItemType(item,'tlStrpSprtr') && item.Visible\"\r\n                    [ngClass]=\"{'separator-vertical': item.level === 1, 'separator-horizontal': item.level !== 1}\"\r\n                    [style.height]=\"getSeparatorHeight(item)\">\r\n                </div>\r\n                <wm-toolstrip-combobox *ngIf=\"isMenuItemType(item, 'tlStrpCbo') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-combobox>\r\n                <wm-toolstrip-dropdownbutton *ngIf=\"isMenuItemType(item,'tlStrpDrpDwnbBtn') && item.Visible\"\r\n                    [model]=\"item\">\r\n                </wm-toolstrip-dropdownbutton>\r\n                <wm-toolstrip-menuitem *ngIf=\"isMenuItemType(item, 'tlStrpMnuItm') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-menuitem>\r\n            </ng-template>\r\n        </kendo-menu>\r\n    </span>\r\n</ng-template>", styles: [".separator-vertical{align-content:center;border-left:1px solid;border-right:1px solid white;height:15px;color:#a9a9a9}.separator-horizontal{align-content:center;border-bottom:1px solid;width:100%}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i3$1.MenuComponent, selector: "kendo-menu", inputs: ["menuItemTemplate", "ariaRole", "menuItemLinkTemplate"], outputs: ["select", "open", "close"], exportAs: ["kendoMenu"] }, { kind: "directive", type: i3$1.ItemTemplateDirective, selector: "[kendoMenuItemTemplate]" }, { kind: "component", type: ToolStripLabelComponent, selector: "wm-toolstrip-label", outputs: ["LinkClicked"] }, { kind: "component", type: ToolStripTextBoxComponent, selector: "wm-toolstrip-textbox" }, { kind: "component", type: ToolStripMenuItemComponent, selector: "wm-toolstrip-menuitem", inputs: ["BelongsToContextMenu"], outputs: ["Click"] }, { kind: "component", type: ToolStripComboBoxComponent, selector: "wm-toolstrip-combobox", inputs: ["dataUrl"] }, { kind: "component", type: ToolStripButtonComponent, selector: "wm-toolstrip-button", outputs: ["Click", "MouseHover"] }, { kind: "component", type: ToolStripDropdownButtonComponent, selector: "wm-toolstrip-dropdownbutton" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TopLevelToolstripItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-top-level-toolstrip-item', providers: [
                        {
                            provide: ToolBarToolComponent,
                            useExisting: forwardRef(() => TopLevelToolstripItemComponent)
                        }
                    ], template: "<ng-template #toolbarTemplate>\r\n    <span #toolbarElement>\r\n        <kendo-menu [items]=\"items\" (select)=\"onSelect($event)\" [ngClass]=\"{'right': items[0].Alignment === 'Right'}\" \r\n        [openOnClick]=\"{ toggle: 'click' }\">\r\n            <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n                <wm-toolstrip-button *ngIf=\"isMenuItemType(item, 'tlStrpBtn') && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\">\r\n                </wm-toolstrip-button>\r\n                <wm-toolstrip-textbox *ngIf=\"isMenuItemType(item, 'tlStrpTxtBx') && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\"></wm-toolstrip-textbox>\r\n                <wm-toolstrip-label *ngIf=\"isMenuItemType(item, 'tlStrpLbl') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-label>\r\n                <div *ngIf=\"isMenuItemType(item,'tlStrpSprtr') && item.Visible\"\r\n                    [ngClass]=\"{'separator-vertical': item.level === 1, 'separator-horizontal': item.level !== 1}\"\r\n                    [style.height]=\"getSeparatorHeight(item)\">\r\n                </div>\r\n                <wm-toolstrip-combobox *ngIf=\"isMenuItemType(item, 'tlStrpCbo') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-combobox>\r\n                <wm-toolstrip-dropdownbutton *ngIf=\"isMenuItemType(item,'tlStrpDrpDwnbBtn') && item.Visible\"\r\n                    [model]=\"item\">\r\n                </wm-toolstrip-dropdownbutton>\r\n                <wm-toolstrip-menuitem *ngIf=\"isMenuItemType(item, 'tlStrpMnuItm') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-menuitem>\r\n            </ng-template>\r\n        </kendo-menu>\r\n    </span>\r\n</ng-template>\r\n<ng-template #popupTemplate>\r\n    <span #popupElement>\r\n        <kendo-menu [vertical]=\"true\" [items]=\"items\" (select)=\"onSelect($event)\" [openOnClick]=\"{ toggle: 'click' }\">\r\n            <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n                <wm-toolstrip-button *ngIf=\"isMenuItemType(item, 'tlStrpBtn') && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\">\r\n                </wm-toolstrip-button>\r\n                <wm-toolstrip-textbox *ngIf=\"isMenuItemType(item, 'tlStrpTxtBx') && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\"></wm-toolstrip-textbox>\r\n                <wm-toolstrip-label *ngIf=\"isMenuItemType(item, 'tlStrpLbl') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-label>\r\n                <div *ngIf=\"isMenuItemType(item,'tlStrpSprtr') && item.Visible\"\r\n                    [ngClass]=\"{'separator-vertical': item.level === 1, 'separator-horizontal': item.level !== 1}\"\r\n                    [style.height]=\"getSeparatorHeight(item)\">\r\n                </div>\r\n                <wm-toolstrip-combobox *ngIf=\"isMenuItemType(item, 'tlStrpCbo') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-combobox>\r\n                <wm-toolstrip-dropdownbutton *ngIf=\"isMenuItemType(item,'tlStrpDrpDwnbBtn') && item.Visible\"\r\n                    [model]=\"item\">\r\n                </wm-toolstrip-dropdownbutton>\r\n                <wm-toolstrip-menuitem *ngIf=\"isMenuItemType(item, 'tlStrpMnuItm') && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-menuitem>\r\n            </ng-template>\r\n        </kendo-menu>\r\n    </span>\r\n</ng-template>", styles: [".separator-vertical{align-content:center;border-left:1px solid;border-right:1px solid white;height:15px;color:#a9a9a9}.separator-horizontal{align-content:center;border-bottom:1px solid;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: ToolstripInteractionService }]; }, propDecorators: { toolbarTemplate: [{
                type: ViewChild,
                args: ['toolbarTemplate', { static: true }]
            }], toolbarElement: [{
                type: ViewChild,
                args: ['toolbarElement', { static: false }]
            }], popupTemplate: [{
                type: ViewChild,
                args: ['popupTemplate', { static: true }]
            }], items: [{
                type: Input
            }] } });

var ToolStripComponent_1;
let ToolStripComponent = ToolStripComponent_1 = class ToolStripComponent extends ControlComponent {
    /**
     *
     * @param event event to call
     * @param component component used to get the id.
     */
    static menuItemExtractor(event, component) {
        component.currentItem.id = component.currentItem.UniqueID;
        const item = component.currentItem;
        component.currentItem = undefined;
        return item;
    }
    static menuItemClickedEventArgsExtractor(event, component) {
        component.currentItem.id = component.currentItem.UniqueID;
        const item = component.currentItem;
        return [
            { Id: component.model.UniqueID, MapperId: component.model.mapperId },
            {
                references: { ClickedItem: item.UniqueID },
                MapperId: 'ToolStripItemClickedEventArgs'
            }
        ];
    }
    static menuItemClickEventArgsExtractor(event, component) {
        component.currentItem.id = component.currentItem.UniqueID;
        const item = component.currentItem;
        return [{ Id: item.UniqueID, MapperId: item.MapperId }, null];
    }
    /**
     * Constructor for the toolStripComponent
     * @param changeDetector service to track the change in the model
     * @param service service to use the Mobilize core
     */
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, webComponents, toolstripService, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.service = service;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.toolstripService = toolstripService;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        /**
         * When any item was clicked is set as the current item.
         */
        this.currentItem = {};
        /**
         * The items which have to be loaded
         */
        this.items = [];
        /**
         * Determines when the toolbar needs to calculate the width and displays the items.
         */
        this.doResize = true;
        /**
         * EventEmitter to trigger the Click event.
         */
        this.Click = new EventEmitter();
        /**
         * Occurs when the ToolStripItem is clicked.
         */
        this.ItemClicked = new EventEmitter();
    }
    /**
     * Gets whether can overflow
     */
    get canOverflow() {
        return this.model.CanOverflow == null || this.model.CanOverflow;
    }
    /**
     * Get Items for the menu datasource
     */
    get itemsid() {
        return this.model.Items;
    }
    /**
     * Set Items for the menu datasource
     */
    set itemsid(value) {
        this.model.Items = value;
    }
    /**
     * Gets items aligned to the right.
     */
    get itemsRight() {
        return this.model.ItemsRight;
    }
    /**
     * Sets items aligned to the right.
     */
    set itemsRight(value) {
        this.model.ItemsRight = value;
    }
    /**
     * Gets items aligned to the left.
     */
    get itemsLeft() {
        return this.model.ItemsLeft;
    }
    /**
     * Sets the items aligned to the left.
     */
    set itemsLeft(value) {
        this.model.ItemsLeft = value;
    }
    /**
     * Gets tab order
     */
    get tabOrder() {
        return -1;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * Promise.all returns a promise when all the promises in "promises" value have been completed successfully.
     * @property Items r
     */
    loadItemsModels() {
        const itms = [];
        const itemsR = [];
        const itemsL = [];
        this.itemsid?.forEach((element) => {
            const elmnt = this.service?.core?.getModel(element);
            /* c8 ignore else */
            if (elmnt) {
                /* c8 ignore else */
                if (this.isSeparator(elmnt)) {
                    elmnt.level = 1;
                }
                if (elmnt.Alignment === 'Right') {
                    elmnt.level = 1;
                    this.retrieveInnerItems(elmnt);
                    itemsR.push(elmnt);
                }
                else {
                    this.retrieveInnerItems(elmnt);
                    itemsL.push(elmnt);
                }
                itms.push(elmnt);
            }
        });
        this.itemsLeft = itemsL;
        this.itemsRight = itemsR;
        this.items = itms;
        this.detectChanges();
    }
    /**
     * Retrieves inner items
     * Process inner menuItem Children to display the menu items according to the expected
     * templates without using extra inner menus.
     * @param menuItemModel The current item model to be processed
     * @returns inner items
     */
    retrieveInnerItems(menuItemModel) {
        const children = menuItemModel.DropDownItems;
        menuItemModel.items = [];
        /* c8 ignore else */
        if (children) {
            children.forEach((child) => {
                const childModel = this.service.core.getModel(child);
                /* c8 ignore else */
                if (childModel) {
                    menuItemModel.items.push(childModel);
                    this.retrieveInnerItems(childModel);
                }
            });
        }
        return menuItemModel;
    }
    /**
     * Add Alignment Style for toolbar elements
     *
     * @returns void
     */
    itemsAlignment(renderer) {
        /* c8 ignore else */
        if (this.toolbar && this.toolbar.renderedTools) {
            this.toolbar.renderedTools.toArray().forEach((ele, idx) => {
                /* c8 ignore else */
                if (ele.tool.items.length > 0) {
                    if (ele.tool.items[0].Alignment === 'Right') {
                        // Adding html5 Alignment style for kendo-toolbar-renderer elements
                        renderer.setStyle(ele.element.nativeElement, 'float', 'right');
                    }
                    else {
                        renderer.setStyle(ele.element.nativeElement, 'float', 'left');
                    }
                    // Preserve the width of the content to avoid overlapping
                    /* c8 ignore else */
                    if (ele.tool.items[0].Style?.Width) {
                        renderer.setStyle(ele.element.nativeElement, 'width', ele.tool.items[0].Style.Width);
                    }
                }
            });
        }
    }
    /**
     * Add Alignment Style for toolbar elements
     *
     * @returns void
     */
    disableMenuItems(renderer) {
        /* c8 ignore else */
        if (this.toolbar && this.toolbar.renderedTools) {
            this.toolbar.renderedTools.toArray().forEach((ele, idx) => {
                /* c8 ignore else */
                if (ele.tool.items.length > 0) {
                    renderer.setStyle(ele.element.nativeElement.querySelector('kendo-menu'), 'pointer-events', ele.tool.items[0].Enabled ? 'all' : 'none');
                }
            });
        }
    }
    ngDoCheck() {
        super.ngDoCheck();
        // To avoid null reference when getting refresh
        /* c8 ignore else */
        if (this.model && this.refresh) {
            this.loadItemsModels();
            this.disableMenuItems(this.renderer2);
            this.refresh = false;
        }
        if (this.doResize && this.toolbar?.element.nativeElement.offsetWidth > 0) {
            this.toolbar.onResize();
            this.doResize = false;
        }
    }
    ngAfterViewInit() {
        this.loadItemsModels();
        this.itemsAlignment(this.renderer2);
        this.disableMenuItems(this.renderer2);
    }
    /**
     *  Method called by the Angular lifecycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        // To avoid null reference when setting refresh
        /* c8 ignore else */
        if (this.model) {
            this.refresh = false;
        }
        this.eventEmitterSubscription =
            this.toolstripService.toolstripEventNotification.subscribe((event) => {
                this.onSelect(event);
            });
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        this.eventEmitterSubscription?.unsubscribe();
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    /**
     * Trigger the Click event when a menu item was clicked.
     */
    onItemClicked(event, UniqueId) {
        this.ItemClicked.emit(new EventData$1(event, UniqueId));
    }
    /**
     * Trigger the Click event when a menu item was clicked.
     */
    onSelect(event) {
        const id = event.item.UniqueID;
        this.currentItem = event.item;
        this.Click.emit(new EventData$1(event, id));
        /* c8 ignore else */
        if (!isNaN(+event.index)) {
            this.onItemClicked(event, id);
        }
    }
    ApplyStyle(item) {
        return { outline: item.Checked ? 'solid 1px #1589FF' : '' };
    }
    isButton(item) {
        return item.mapperId === 'tlStrpBtn';
    }
    isTextBox(item) {
        return item.mapperId === 'tlStrpTxtBx';
    }
    isLabel(item) {
        return item.mapperId === 'tlStrpLbl';
    }
    isComboBox(item) {
        return item.mapperId === 'tlStrpCbo';
    }
    isDropDown(item) {
        return item.mapperId === 'tlStrpDrpDwnbBtn';
    }
    isMenuItem(item) {
        return item.mapperId === 'tlStrpMnuItm';
    }
    isSeparator(item) {
        return item.mapperId === 'tlStrpSprtr';
    }
    /**
     * Gets display element
     * @returns HTML display element or undefined if element is not rendered
     */
    getDisplayElement() {
        return this.element?.nativeElement;
    }
};
ToolStripComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: ToolstripInteractionService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ToolStripComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ToolStripComponent, selector: "wm-toolstrip", inputs: { model: "model" }, outputs: { Click: "Click", ItemClicked: "ItemClicked" }, providers: [ToolstripInteractionService], viewQueries: [{ propertyName: "toolbar", first: true, predicate: ["toolbar"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model && !canOverflow\"\r\n    style=\"display: flex;background-color: rgba(239, 234, 234, 1);width: 100%;justify-content: space-between;\"\r\n    wmControls [hostComponent]=\"this\">\r\n    <span>\r\n        <kendo-menu *ngIf=\"model\" [items]=\"itemsLeft\" wmControls [hostComponent]=\"this\" (select)=\"onSelect($event)\">\r\n            <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n                <wm-toolstrip-button *ngIf=\"isButton(item) && item.Visible\" [model]=\"item\" [ngStyle]=\"ApplyStyle(item)\">\r\n                </wm-toolstrip-button>\r\n                <wm-toolstrip-textbox *ngIf=\"isTextBox(item) && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\"></wm-toolstrip-textbox>\r\n                <wm-toolstrip-label *ngIf=\"isLabel(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-label>\r\n                <div *ngIf=\"isSeparator(item) && item.Visible\"\r\n                    [ngClass]=\"{'separator-vertical': item.level === 1, 'separator-horizontal': item.level !== 1}\">\r\n                </div>\r\n                <wm-toolstrip-combobox *ngIf=\"isComboBox(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-combobox>\r\n                <wm-toolstrip-dropdownbutton *ngIf=\"isDropDown(item) && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-dropdownbutton>\r\n                <wm-toolstrip-menuitem *ngIf=\"isMenuItem(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-menuitem>\r\n            </ng-template>\r\n        </kendo-menu>\r\n    </span>\r\n    <span>\r\n        <kendo-menu *ngIf=\"model\" [items]=\"itemsRight\" class=\"right\" wmControls [hostComponent]=\"this\"\r\n            (select)=\"onSelect($event)\">\r\n            <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n                <wm-toolstrip-button *ngIf=\"isButton(item) && item.Visible\" [model]=\"item\" [ngStyle]=\"ApplyStyle(item)\">\r\n                </wm-toolstrip-button>\r\n                <wm-toolstrip-textbox *ngIf=\"isTextBox(item) && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\"></wm-toolstrip-textbox>\r\n                <wm-toolstrip-label *ngIf=\"isLabel(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-label>\r\n                <div *ngIf=\"isSeparator(item) && item.Visible\"\r\n                    [ngClass]=\"{'separator-vertical': item.level === 1, 'separator-horizontal': item.level !== 1}\">\r\n                </div>\r\n                <wm-toolstrip-combobox *ngIf=\"isComboBox(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-combobox>\r\n                <wm-toolstrip-dropdownbutton *ngIf=\"isDropDown(item) && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-dropdownbutton>\r\n                <wm-toolstrip-menuitem *ngIf=\"isMenuItem(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-menuitem>\r\n            </ng-template>\r\n        </kendo-menu>\r\n    </span>\r\n</div>\r\n<kendo-toolbar #toolbar *ngIf=\"model && model.Visible && canOverflow\" [overflow]=\"true\" wmControls [hostComponent]=\"this\">\r\n    <ng-container *ngFor=\"let item of itemsLeft\">\r\n        <wm-top-level-toolstrip-item *ngIf=\"item.Visible\" [items]=\"[item]\"></wm-top-level-toolstrip-item>\r\n    </ng-container>\r\n    <ng-container *ngFor=\"let item of itemsRight\">\r\n        <wm-top-level-toolstrip-item *ngIf=\"item.Visible\" [items]=\"[item]\"></wm-top-level-toolstrip-item>\r\n    </ng-container>\r\n</kendo-toolbar>", styles: [".before{width:100%;height:100%;text-align:center;display:contents}.above{width:100%;height:100%;text-align:center}.left .k-menu-horizontal{flex-direction:row-reverse;right:0}.separator-vertical{align-content:center;border-left:1px solid;height:15px}.separator-horizontal{align-content:center;border-bottom:1px solid;width:100%}.k-toolbar{padding:0}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i3$1.MenuComponent, selector: "kendo-menu", inputs: ["menuItemTemplate", "ariaRole", "menuItemLinkTemplate"], outputs: ["select", "open", "close"], exportAs: ["kendoMenu"] }, { kind: "directive", type: i3$1.ItemTemplateDirective, selector: "[kendoMenuItemTemplate]" }, { kind: "component", type: i8$3.ToolBarComponent, selector: "kendo-toolbar", inputs: ["overflow", "resizable", "popupSettings", "tabindex", "size", "tabIndex"], outputs: ["open", "close"], exportAs: ["kendoToolBar"] }, { kind: "component", type: TopLevelToolstripItemComponent, selector: "wm-top-level-toolstrip-item", inputs: ["items"] }, { kind: "component", type: ToolStripLabelComponent, selector: "wm-toolstrip-label", outputs: ["LinkClicked"] }, { kind: "component", type: ToolStripTextBoxComponent, selector: "wm-toolstrip-textbox" }, { kind: "component", type: ToolStripMenuItemComponent, selector: "wm-toolstrip-menuitem", inputs: ["BelongsToContextMenu"], outputs: ["Click"] }, { kind: "component", type: ToolStripComboBoxComponent, selector: "wm-toolstrip-combobox", inputs: ["dataUrl"] }, { kind: "component", type: ToolStripButtonComponent, selector: "wm-toolstrip-button", outputs: ["Click", "MouseHover"] }, { kind: "component", type: ToolStripDropdownButtonComponent, selector: "wm-toolstrip-dropdownbutton" }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], ToolStripComponent.prototype, "itemsid", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], ToolStripComponent.prototype, "itemsRight", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], ToolStripComponent.prototype, "itemsLeft", null);
__decorate([
    serverEvent('ItemClicked', ToolStripComponent_1.menuItemClickedEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ToolStripComponent.prototype, "onItemClicked", null);
__decorate([
    serverEvent('Click', ToolStripComponent_1.menuItemClickEventArgsExtractor, ToolStripComponent_1.menuItemExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ToolStripComponent.prototype, "onSelect", null);
ToolStripComponent = ToolStripComponent_1 = __decorate([
    dataTransfer(['tlStrp']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        ToolstripInteractionService,
        BringTopService,
        ContainerInteractionService])
], ToolStripComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-toolstrip', inputs: ['model'], providers: [ToolstripInteractionService], template: "<div *ngIf=\"model && !canOverflow\"\r\n    style=\"display: flex;background-color: rgba(239, 234, 234, 1);width: 100%;justify-content: space-between;\"\r\n    wmControls [hostComponent]=\"this\">\r\n    <span>\r\n        <kendo-menu *ngIf=\"model\" [items]=\"itemsLeft\" wmControls [hostComponent]=\"this\" (select)=\"onSelect($event)\">\r\n            <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n                <wm-toolstrip-button *ngIf=\"isButton(item) && item.Visible\" [model]=\"item\" [ngStyle]=\"ApplyStyle(item)\">\r\n                </wm-toolstrip-button>\r\n                <wm-toolstrip-textbox *ngIf=\"isTextBox(item) && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\"></wm-toolstrip-textbox>\r\n                <wm-toolstrip-label *ngIf=\"isLabel(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-label>\r\n                <div *ngIf=\"isSeparator(item) && item.Visible\"\r\n                    [ngClass]=\"{'separator-vertical': item.level === 1, 'separator-horizontal': item.level !== 1}\">\r\n                </div>\r\n                <wm-toolstrip-combobox *ngIf=\"isComboBox(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-combobox>\r\n                <wm-toolstrip-dropdownbutton *ngIf=\"isDropDown(item) && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-dropdownbutton>\r\n                <wm-toolstrip-menuitem *ngIf=\"isMenuItem(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-menuitem>\r\n            </ng-template>\r\n        </kendo-menu>\r\n    </span>\r\n    <span>\r\n        <kendo-menu *ngIf=\"model\" [items]=\"itemsRight\" class=\"right\" wmControls [hostComponent]=\"this\"\r\n            (select)=\"onSelect($event)\">\r\n            <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n                <wm-toolstrip-button *ngIf=\"isButton(item) && item.Visible\" [model]=\"item\" [ngStyle]=\"ApplyStyle(item)\">\r\n                </wm-toolstrip-button>\r\n                <wm-toolstrip-textbox *ngIf=\"isTextBox(item) && item.Visible\" [model]=\"item\"\r\n                    [ngStyle]=\"ApplyStyle(item)\"></wm-toolstrip-textbox>\r\n                <wm-toolstrip-label *ngIf=\"isLabel(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-label>\r\n                <div *ngIf=\"isSeparator(item) && item.Visible\"\r\n                    [ngClass]=\"{'separator-vertical': item.level === 1, 'separator-horizontal': item.level !== 1}\">\r\n                </div>\r\n                <wm-toolstrip-combobox *ngIf=\"isComboBox(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-combobox>\r\n                <wm-toolstrip-dropdownbutton *ngIf=\"isDropDown(item) && item.Visible\" [model]=\"item\">\r\n                </wm-toolstrip-dropdownbutton>\r\n                <wm-toolstrip-menuitem *ngIf=\"isMenuItem(item) && item.Visible\" [model]=\"item\"></wm-toolstrip-menuitem>\r\n            </ng-template>\r\n        </kendo-menu>\r\n    </span>\r\n</div>\r\n<kendo-toolbar #toolbar *ngIf=\"model && model.Visible && canOverflow\" [overflow]=\"true\" wmControls [hostComponent]=\"this\">\r\n    <ng-container *ngFor=\"let item of itemsLeft\">\r\n        <wm-top-level-toolstrip-item *ngIf=\"item.Visible\" [items]=\"[item]\"></wm-top-level-toolstrip-item>\r\n    </ng-container>\r\n    <ng-container *ngFor=\"let item of itemsRight\">\r\n        <wm-top-level-toolstrip-item *ngIf=\"item.Visible\" [items]=\"[item]\"></wm-top-level-toolstrip-item>\r\n    </ng-container>\r\n</kendo-toolbar>", styles: [".before{width:100%;height:100%;text-align:center;display:contents}.above{width:100%;height:100%;text-align:center}.left .k-menu-horizontal{flex-direction:row-reverse;right:0}.separator-vertical{align-content:center;border-left:1px solid;height:15px}.separator-horizontal{align-content:center;border-bottom:1px solid;width:100%}.k-toolbar{padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: ToolstripInteractionService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { toolbar: [{
                type: ViewChild,
                args: ['toolbar', { static: false }]
            }], itemsid: [], itemsRight: [], itemsLeft: [], Click: [{
                type: Output
            }], ItemClicked: [{
                type: Output
            }], onItemClicked: [], onSelect: [] } });

let KendoMenuComponent = class KendoMenuComponent extends KendoComponent {
    /* c8 ignore next 3 */
    constructor(differs, elementRef) {
        super(differs, elementRef, 'kendoMenu');
        this.differs = differs;
    }
    /* c8 ignore next */
    ngOnInit() {
        this.render();
    }
};
KendoMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KendoMenuComponent, deps: [{ token: i0.KeyValueDiffers }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
KendoMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: KendoMenuComponent, selector: "[data-role=menu]", inputs: { model: "model", bound: "bound", role: "role" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
KendoMenuComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [KeyValueDiffers, ElementRef])
], KendoMenuComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KendoMenuComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    // tslint:disable-next-line:component-selector
                    // eslint-disable-next-line @angular-eslint/component-selector
                    selector: '[data-role=menu]',
                    template: '<ng-content></ng-content>',
                    inputs: ['model', 'bound']
                }]
        }], ctorParameters: function () { return [{ type: i0.KeyValueDiffers }, { type: i0.ElementRef }]; }, propDecorators: { role: [{
                type: Input
            }] } });

let KendoComboboxComponent = class KendoComboboxComponent extends KendoComponent {
    /* c8 ignore next 3 */
    constructor(differs, elementRef) {
        super(differs, elementRef, 'kendoComboBox');
        this.differs = differs;
    }
    /* c8 ignore next */
    ngOnInit() {
        this.render();
    }
};
KendoComboboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KendoComboboxComponent, deps: [{ token: i0.KeyValueDiffers }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
KendoComboboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: KendoComboboxComponent, selector: "[data-role=dropdownlist]", inputs: { model: "model", bound: "bound", role: "role" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
KendoComboboxComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [KeyValueDiffers, ElementRef])
], KendoComboboxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KendoComboboxComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    // tslint:disable-next-line:component-selector
                    // eslint-disable-next-line @angular-eslint/component-selector
                    selector: '[data-role=dropdownlist]',
                    template: '<ng-content></ng-content>',
                    inputs: ['model', 'bound']
                }]
        }], ctorParameters: function () { return [{ type: i0.KeyValueDiffers }, { type: i0.ElementRef }]; }, propDecorators: { role: [{
                type: Input
            }] } });

let KendoDropDownListComponent = class KendoDropDownListComponent extends KendoComponent {
    /* c8 ignore next 3 */
    constructor(differs, elementRef) {
        super(differs, elementRef, 'kendoDropDownList');
        this.differs = differs;
    }
    /* c8 ignore next */
    ngOnInit() {
        this.render();
    }
};
KendoDropDownListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KendoDropDownListComponent, deps: [{ token: i0.KeyValueDiffers }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
KendoDropDownListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: KendoDropDownListComponent, selector: "[data-role=combobox]", inputs: { model: "model", bound: "bound", role: "role" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
KendoDropDownListComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [KeyValueDiffers, ElementRef])
], KendoDropDownListComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KendoDropDownListComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    // tslint:disable-next-line:component-selector
                    // eslint-disable-next-line @angular-eslint/component-selector
                    selector: '[data-role=combobox]',
                    template: '<ng-content></ng-content>',
                    inputs: ['model', 'bound']
                }]
        }], ctorParameters: function () { return [{ type: i0.KeyValueDiffers }, { type: i0.ElementRef }]; }, propDecorators: { role: [{
                type: Input
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
// Summary:
// Specifies the behaviors of a link in a LinkLabel
var ToolStripStatusLabelBorderSides;
(function (ToolStripStatusLabelBorderSides) {
    ToolStripStatusLabelBorderSides[ToolStripStatusLabelBorderSides["None"] = 0] = "None";
    ToolStripStatusLabelBorderSides[ToolStripStatusLabelBorderSides["Left"] = 1] = "Left";
    ToolStripStatusLabelBorderSides[ToolStripStatusLabelBorderSides["Top"] = 2] = "Top";
    ToolStripStatusLabelBorderSides[ToolStripStatusLabelBorderSides["Right"] = 4] = "Right";
    ToolStripStatusLabelBorderSides[ToolStripStatusLabelBorderSides["Bottom"] = 8] = "Bottom";
})(ToolStripStatusLabelBorderSides || (ToolStripStatusLabelBorderSides = {}));

let ToolStripStatusLabelComponent = class ToolStripStatusLabelComponent extends ToolStripLabelComponent {
    /* c8 ignore start */
    constructor(changeDetect, render2, elmt, webComponents, service, bringTopSvc, bindingNavSvc, containerInteraction) {
        super(changeDetect, render2, elmt, webComponents, service, bringTopSvc, bindingNavSvc, containerInteraction);
        this.changeDetect = changeDetect;
        this.render2 = render2;
        this.elmt = elmt;
        this.bringTopSvc = bringTopSvc;
        this.bindingNavSvc = bindingNavSvc;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        this.Click = new EventEmitter();
    }
    /**
     * Servers event
     * @param event the current event javascript object
     */
    click(event) {
        this.Click.emit(new EventData$1(event, this.id));
    }
    /**
     * Gets borderSides property from model
     */
    get borderSides() {
        return this.model.BorderSides;
    }
    /**
     * Gets Spring property from model
     */
    get spring() {
        return this.model.Spring;
    }
    /**
     * Gets borderTopClass based on the ToolStripStatusLabelBorderSides property to set class
     */
    get isBorderTopClass() {
        return this.model.BorderSides === ToolStripStatusLabelBorderSides.Top;
    }
    /**
     * Gets borderBottomClass based on the ToolStripStatusLabelBorderSides property to set class
     */
    get isBorderBottomClass() {
        return this.model.BorderSides === ToolStripStatusLabelBorderSides.Bottom;
    }
    /**
     * Gets borderRightClass based on the ToolStripStatusLabelBorderSides property to set class
     */
    get isBorderRightClass() {
        return this.model.BorderSides === ToolStripStatusLabelBorderSides.Right;
    }
    /**
     * Gets borderLeftClass based on the ToolStripStatusLabelBorderSides property to set class
     */
    get isBorderLeftClass() {
        return this.model.BorderSides === ToolStripStatusLabelBorderSides.Left;
    }
};
ToolStripStatusLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripStatusLabelComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i1.WebMapService, optional: true }, { token: i3.BringTopService, optional: true }, { token: BindingNavigatorService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ToolStripStatusLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ToolStripStatusLabelComponent, selector: "wm-toolstrip-statuslabel", outputs: { Click: "Click" }, usesInheritance: true, ngImport: i0, template: "<wm-label *ngIf=\"!isLink\" [model]=\"model\" [ngClass]=\"cssClass\" [class.borderTop]=\"isBorderTopClass\"\r\n    [class.borderBottom]=\"isBorderBottomClass\" [class.borderRight]=\"isBorderRightClass\"\r\n    [class.borderLeft]=\"isBorderLeftClass\" (click)=\"click($event)\"></wm-label>\r\n<wm-link-label *ngIf=\"isLink\" [model]=\"model\" (click)=\"click($event)\" [ngClass]=\"cssClass\"></wm-link-label>", styles: [".borderTop{border-top:1px solid darkgray}.borderBottom{border-bottom:1px solid darkgray}.borderRight{border-right:1px solid darkgray}.borderLeft{border-left:1px solid darkgray}wm-label{display:block}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: LabelComponent, selector: "wm-label", inputs: ["model"], outputs: ["Click", "DoubleClick", "MouseEnter", "MouseLeave"] }, { kind: "component", type: LinkLabelComponent, selector: "wm-link-label", inputs: ["model"], outputs: ["Click", "LinkClicked"] }] });
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ToolStripStatusLabelComponent.prototype, "click", null);
ToolStripStatusLabelComponent = __decorate([
    dataTransfer(['tlStrpStLbl']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        WebMapService,
        BringTopService,
        BindingNavigatorService,
        ContainerInteractionService])
], ToolStripStatusLabelComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToolStripStatusLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-toolstrip-statuslabel', template: "<wm-label *ngIf=\"!isLink\" [model]=\"model\" [ngClass]=\"cssClass\" [class.borderTop]=\"isBorderTopClass\"\r\n    [class.borderBottom]=\"isBorderBottomClass\" [class.borderRight]=\"isBorderRightClass\"\r\n    [class.borderLeft]=\"isBorderLeftClass\" (click)=\"click($event)\"></wm-label>\r\n<wm-link-label *ngIf=\"isLink\" [model]=\"model\" (click)=\"click($event)\" [ngClass]=\"cssClass\"></wm-link-label>", styles: [".borderTop{border-top:1px solid darkgray}.borderBottom{border-bottom:1px solid darkgray}.borderRight{border-right:1px solid darkgray}.borderLeft{border-left:1px solid darkgray}wm-label{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i1.WebMapService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: BindingNavigatorService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { Click: [{
                type: Output
            }], click: [] } });

/**
 * StatuStrip Component is used on forms as an area, usually displayed at the bottom of a window.
 */
let StatusStripComponent = class StatusStripComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, service, renderer2, webComponents, element, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.service = service;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
    }
    /**
     * Get Items for the menu datasource
     */
    get itemsid() {
        return this.model.Items;
    }
    /**
     * Fetchs items
     * @property Items r
     */
    /* c8 ignore next */
    loadItemsModels() {
        const promises = [];
        /* c8 ignore else */
        if (this.itemsid !== undefined) {
            this.itemsid.forEach((element) => {
                promises.push(this.service.getModel(element));
            });
            Promise.all(promises).then((result) => {
                this.items = result;
                this.detectChanges();
            });
        }
    }
    /**
     *  Method called by the Angular lifecycle hook
     */
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.loadItemsModels();
    }
    /* c8 ignore next */
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore else */
        if (this.model && this.refresh) {
            this.loadItemsModels();
            this.refresh = false;
        }
    }
    /* c8 ignore next 3 */
    isStatusLabel(item) {
        return item.mapperId === 'tlStrpStLbl';
    }
    /* c8 ignore next 3 */
    isLabel(item) {
        return item.mapperId === 'tlStrpLbl';
    }
};
StatusStripComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: StatusStripComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.WebMapService }, { token: i0.Renderer2 }, { token: WebComponentsService }, { token: i0.ElementRef }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
StatusStripComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: StatusStripComponent, selector: "wm-statusstrip", inputs: { model: "model" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\" class=\"contain\" style=\"z-index: 10500\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\">\r\n    <kendo-menu [items]=\"items\" wmControls [hostComponent]=\"this\">\r\n        <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n            <wm-toolstrip-label *ngIf=\"isLabel(item)\" [model]=\"item\"></wm-toolstrip-label>\r\n            <wm-toolstrip-statuslabel *ngIf=\"isStatusLabel(item)\" [model]=\"item\"></wm-toolstrip-statuslabel>\r\n        </ng-template>\r\n    </kendo-menu>\r\n</div>", styles: [".contain{border:1px solid gray;width:calc(100% - 2px)}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MenuComponent, selector: "kendo-menu", inputs: ["menuItemTemplate", "ariaRole", "menuItemLinkTemplate"], outputs: ["select", "open", "close"], exportAs: ["kendoMenu"] }, { kind: "directive", type: i3$1.ItemTemplateDirective, selector: "[kendoMenuItemTemplate]" }, { kind: "component", type: ToolStripLabelComponent, selector: "wm-toolstrip-label", outputs: ["LinkClicked"] }, { kind: "component", type: ToolStripStatusLabelComponent, selector: "wm-toolstrip-statuslabel", outputs: ["Click"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
StatusStripComponent = __decorate([
    dataTransfer(['stStp']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        WebMapService,
        Renderer2,
        WebComponentsService,
        ElementRef,
        BringTopService,
        ContainerInteractionService])
], StatusStripComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: StatusStripComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-statusstrip', inputs: ['model'], template: "<div *ngIf=\"model\" class=\"contain\" style=\"z-index: 10500\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\">\r\n    <kendo-menu [items]=\"items\" wmControls [hostComponent]=\"this\">\r\n        <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n            <wm-toolstrip-label *ngIf=\"isLabel(item)\" [model]=\"item\"></wm-toolstrip-label>\r\n            <wm-toolstrip-statuslabel *ngIf=\"isStatusLabel(item)\" [model]=\"item\"></wm-toolstrip-statuslabel>\r\n        </ng-template>\r\n    </kendo-menu>\r\n</div>", styles: [".contain{border:1px solid gray;width:calc(100% - 2px)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WebMapService }, { type: i0.Renderer2 }, { type: WebComponentsService }, { type: i0.ElementRef }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; } });

let TabPageComponent = class TabPageComponent extends ControlContainerComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ);
        this.webMapService = webMapService;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        /**
         * Determines that it is a container.
         */
        this.isContainer = true;
    }
    /* c8 ignore stop */
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /**
     * tab name
     */
    get name() {
        return RemoveAmpersand.remove(this.model.Name);
    }
    /**
     * Gets display element
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets display element
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * Override
     * Gets tab order
     */
    get tabOrder() {
        return this.calculateTabOrder();
    }
    /**
     * Gets display element that is highest visual element inside component
     * @returns HTMLElement or undefined, DOM visual element
     */
    getDisplayElement() {
        if (this.element && this.element.nativeElement) {
            return this.element.nativeElement.firstElementChild;
        }
        return undefined;
    }
    /**
     * Override
     * Calculates the tabOrder value
     * @returns  any
     */
    calculateTabOrder() {
        return Utils.validateTabOrder(this.model, this.tabindex);
    }
};
TabPageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TabPageComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TabPageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TabPageComponent, selector: "wm-tabpage", inputs: { model: "model" }, providers: [ContainerTabOrderService], viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #displayElement *ngIf=\"model\" [hidden]=\"!visible\" [ngClass]=\"class\" class=\"custom-tabpage\" wmTab\r\n    [hostComponent]=\"this\">\r\n    <ng-content></ng-content>\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n</div>", styles: [".custom-tabpage{position:absolute;width:100%;height:100%}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.ContainerComponent, selector: "wm-container", inputs: ["controls"], outputs: ["RemoveControl"] }, { kind: "directive", type: TabDirective, selector: "[wmTab]", inputs: ["hostComponent"] }] });
TabPageComponent = __decorate([
    dataTransfer(['tabpage']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService])
], TabPageComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TabPageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-tabpage', inputs: ['model'], providers: [ContainerTabOrderService], template: "<div #displayElement *ngIf=\"model\" [hidden]=\"!visible\" [ngClass]=\"class\" class=\"custom-tabpage\" wmTab\r\n    [hostComponent]=\"this\">\r\n    <ng-content></ng-content>\r\n    <wm-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\"></wm-container>\r\n</div>", styles: [".custom-tabpage{position:absolute;width:100%;height:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class ContainerDirective extends ControlsDirective {
    /* c8 ignore start */
    constructor(elRef, vRef, focusManagerServ, tabOrderServ, containerTabOrderServ, webComponentsServ, ajaxInteractionBServ, wmWindowServ, loadingStatService) {
        super(elRef, vRef, focusManagerServ, tabOrderServ, containerTabOrderServ, webComponentsServ, ajaxInteractionBServ, wmWindowServ, loadingStatService);
        this.elRef = elRef;
        this.vRef = vRef;
        this.focusManagerServ = focusManagerServ;
        this.tabOrderServ = tabOrderServ;
        this.containerTabOrderServ = containerTabOrderServ;
        this.webComponentsServ = webComponentsServ;
        this.ajaxInteractionBServ = ajaxInteractionBServ;
        this.wmWindowServ = wmWindowServ;
        this.loadingStatService = loadingStatService;
    }
    /* c8 ignore stop */
    focusIn(e) {
        // The isElementValidToFocus should be defined on each container component
        if (this.component.isElementValidToFocus(e.target)) {
            this.focus(e);
        }
    }
    /**
     * Method to handle the tab navigation on the container marked with this directive
     *
     * @param {*} event
     * @memberof ContainerDirective
     */
    tabKeyHandler(event) {
        Utils.preventPropagation(event);
        if (!!this.component.focused) {
            this.containerTabOrderServ.enterContainer(event.shiftKey, event, false);
        }
        else {
            super.tabKeyHandler(event);
        }
    }
}
ContainerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerDirective, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: FocusManagerService, optional: true }, { token: MainTabOrderService, optional: true }, { token: ContainerTabOrderService, optional: true }, { token: WebComponentsService, optional: true }, { token: AjaxInteractionBaseService, optional: true }, { token: WMWindowService, optional: true }, { token: i3.LoadingStateService, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
ContainerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: ContainerDirective, selector: "[wmContainer]", host: { listeners: { "focusin": "focusIn($event)" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[wmContainer]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: FocusManagerService, decorators: [{
                    type: Optional
                }] }, { type: MainTabOrderService, decorators: [{
                    type: Optional
                }] }, { type: ContainerTabOrderService, decorators: [{
                    type: Optional
                }] }, { type: WebComponentsService, decorators: [{
                    type: Optional
                }] }, { type: AjaxInteractionBaseService, decorators: [{
                    type: Optional
                }] }, { type: WMWindowService, decorators: [{
                    type: Optional
                }] }, { type: i3.LoadingStateService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { focusIn: [{
                type: HostListener,
                args: ['focusin', ['$event']]
            }] } });

var TabControlComponent_1;
var TabControlAction;
(function (TabControlAction) {
    TabControlAction[TabControlAction["Selecting"] = 0] = "Selecting";
    TabControlAction[TabControlAction["Selected"] = 1] = "Selected";
    TabControlAction[TabControlAction["Deselecting"] = 2] = "Deselecting";
    TabControlAction[TabControlAction["Deselected"] = 3] = "Deselected";
})(TabControlAction || (TabControlAction = {}));
/**
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/tab-control/tab-control.html</example-url>
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/tab-control/tab-control-us.html</example-url>
 */
let TabControlComponent = TabControlComponent_1 = class TabControlComponent extends ControlContainerComponent {
    static getSelectedIndexArgs(event, extractor) {
        return extractor.selectedIndex;
    }
    static TabControlEventArgsSelected(event, component) {
        return [
            {
                Id: component.id,
                MapperId: TabControlComponent_1.tabControlMapperId
            },
            {
                MapperId: 'tbcntrlvntrgs',
                TabPageIndex: component.selectedIndex,
                Action: TabControlAction.Selected,
                references: {
                    TabPage: component.tabModels[component.selectedIndex].UniqueID
                }
            }
        ];
    }
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, webComponents, bringTopServ) {
        super(service, changeDetector, renderer2, element, webComponents, bringTopServ);
        this.service = service;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        /* c8 ignore stop */
        this.defaultDataUrl = 'api/tabcontrol';
        /**
         * Url to get the page data
         */
        this.getTabs = `${this.defaultDataUrl}/GetTabs`;
        /**
         * Internal id of tab control component
         */
        this.internalName = '';
        /**
         * Marks the component as container for the tab order service
         *
         * @memberof TabControlComponent
         */
        this.isContainer = true;
        this.MouseDown = new EventEmitter();
        this.TabSelect = new EventEmitter();
        this.Selected = new EventEmitter();
        this.Deselected = new EventEmitter();
        /* Constants */
        this.formElement = null;
        /**
         * Tab ids of tab control component
         * Contains the set of tabpages ids associated to this
         * tabcontrol component
         */
        this.tabIds = [];
        /**
         * Tab models of tab control component
         * An array that contains the set of models of the current tabs
         * retrieved by the api call
         */
        this.tabModels = [];
    }
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /**
     * Applys focus
     */
    /* c8 ignore start */
    applyFocus() {
        const element = this.displayElement?.querySelectorAll('kendo-tabstrip li');
        /* c8 ignore else */
        if (element?.length <= 0) {
            return;
        }
        this.isApplyingFocus = true;
        element[this.selectedIndex]?.focus();
        this.isApplyingFocus = false;
    }
    /* c8 ignore stop /*
  
    /**
     * Method to know if the element is the correct element to focus when the focusIn is triggered.
     *
     * @param {*} elem
     * @return {*}  {boolean}
     * @memberof TabControlComponent
     */
    /* c8 ignore start */
    isElementValidToFocus(elem) {
        const itemsWrapper = this.displayElement?.querySelector('.k-tabstrip-items-wrapper');
        return itemsWrapper.contains(elem);
    }
    /* c8 ignore stop /*
  
    /**
     * Input  of tab control component
     * Gets the id of the current tabcontrol
     * Since we receive the window model then we can
     * get the tabcontrol model using the id value
     */
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set name(value) {
        this.internalName = value;
    }
    /**
     * Gets id
     */
    get name() {
        if (this.internalName === '') {
            return this.model ? this.model.Name : '';
        }
        return this.internalName;
    }
    /**
     * Gets the TabStop property from the model
     *
     * @readonly
     * @type {boolean}
     * @memberof TabControlComponent
     */
    get tabStop() {
        return this.model.TabStop ?? true;
    }
    /**
     * on init
     * Set the current control model
     */
    ngOnInit() {
        /* c8 ignore else */
        if (this.windowModel && this.name) {
            this.model = this.windowModel[this.name];
        }
        // this super is call here because the web-Components needs the model to process the component
        super.ngOnInit();
        this.loadTabComponents();
    }
    /**
     * do check
     * Handles refresh action to load the tabpages collection
     * when it changes
     */
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore else */
        if (this.refresh) {
            this.selectedIndex = 0;
            this.loadTabComponents();
            this.refresh = false;
        }
    }
    ngAfterViewChecked() {
        /* c8 ignore else */
        if (this.element && this.element.nativeElement) {
            const kendoElement = this.element.nativeElement.firstElementChild;
            /* c8 ignore else */
            if (kendoElement && kendoElement !== this.displayElement) {
                this.displayElement = kendoElement;
            }
        }
        super.ngAfterViewChecked();
    }
    /**
     * Gets the tabOrder
     *
     * @readonly
     * @type {*}
     * @memberof TabControlComponent
     */
    get tabOrder() {
        return this.calculateTabOrder();
    }
    /**
     * Get the tabs collection
     * @property TabPages r
     */
    loadTabComponents() {
        this.service.fetch(this.getTabs, this.id).subscribe((data) => {
            this.tabIds = data ? data['Tabs'] : undefined;
            this.selectedIndex = data ? data['SelectedIndex'] : undefined;
            /* c8 ignore else */
            if (this.tabIds) {
                this.loadTabModels();
            }
        });
    }
    /**
     * Method to extract information from mouse events
     * @param event
     * @param component
     * @returns object
     */
    static MouseEventsExtractor(event, component) {
        return [
            {
                Id: event.Id,
                MapperId: TabControlComponent_1.tabControlMapperId
            },
            {
                MapperId: 'MouseEventArgs',
                Button: event.button,
                X: event.X,
                Y: event.Y
            }
        ];
    }
    /**
     * Triggers the Mouse Down event
     */
    mouseDownHandler(event) {
        this.triggerMouseDownEvent(new EventData$1(event, this.id));
    }
    /**
     * Occurs when a tab in the control is clicked
     */
    triggerMouseDownEvent(event) {
        this.MouseDown.emit(event);
    }
    /**
     * Occurs before the selected tab changed
     */
    deselectedHandler(event) {
        this.Deselected.emit(event);
    }
    /**
     * Loads tab models
     * After receiving the tabs ids we can get
     * the models associated with each tabpage
     */
    loadTabModels() {
        this.tabModels = [];
        for (const tab of this.tabIds) {
            const tabmodel = this.service.core.getModel(tab);
            this.tabModels.push(tabmodel);
        }
        this.detectChanges();
    }
    /**
     * Occurs when the selectedIndex property has changed.
     */
    selectedIndexChanged() {
        this.tabModels.forEach((currentTab) => (currentTab.Visible = false));
        /* c8 ignore else */
        if (this.selectedIndex >= 0 && this.selectedIndex < this.tabModels.length) {
            this.tabModels[this.selectedIndex].Visible = true;
        }
        return this.selectedIndex;
    }
    /**
     * Occurs when a tab is selected and the index changes
     * @param event
     */
    selectedIndexChangeHandler(event) {
        this.TabSelect.emit(new EventData$1(event, this.id));
        this.Selected.emit(new EventData$1(event, this.id));
    }
    /**
     * Occurs when a tab is selected.
     * Also  publish funrefresh function that is subscribed by RichTextBoxComponent
     * @param tab value with selected tab
     */
    selected(tab) {
        const mouseDownTriggered = this.selectedIndex === tab.index ||
            !this.isBindedEvent('SelectedIndexChanged');
        if (mouseDownTriggered) {
            this.mouseDownHandler(tab);
        }
        if (!mouseDownTriggered) {
            this.deselectedHandler(tab);
        }
        this.selectedIndex = tab.index;
        this.selectedIndexChanged();
        if (!mouseDownTriggered) {
            this.selectedIndexChangeHandler(tab);
        }
        this.service.core.getEvent().publish('funRefresh', true);
        /* c8 ignore else */
        if (this.webComponents) {
            setTimeout(() => {
                this.webComponents.dockChange(this);
            }, 200);
        }
    }
    /**
     * @param value Contains  the index of the currently selected tab page.
     */
    set selectedIndex(value) {
        this.model.SelectedIndex = value;
    }
    get selectedIndex() {
        return this.model.SelectedIndex || 0;
    }
    getControlObject(tab) {
        const controlArray = {};
        controlArray[tab.id] = true;
        return controlArray;
    }
    /**
     * Moves to tab page
     * This method build custom args for selected method to match the arguments
     * @param event
     * @param index
     */
    moveToTabPage(event, index) {
        /* c8 ignore else */
        if (index >= 0 && index < this.tabModels.length) {
            const tabObject = {
                index: index,
                title: '',
                prevented: false,
                preventDefault: () => { },
                isDefaultPrevented: false
            };
            this.selected(tabObject);
            this.focusTabContentIndex(this.selectedIndex);
        }
    }
    /**
     * Focus tab content index
     * This is to assure that the next keydown for navigation is going to be triggered from inside the control
     * @param tabIndexPosition
     */
    focusTabContentIndex(tabIndexPosition) {
        const tabLi = this.element?.nativeElement?.querySelectorAll('kendo-tabstrip li')[tabIndexPosition];
        tabLi?.click();
    }
    /**
     * Gets the Control type as a string
     *
     * @return {*}  {string}
     * @memberof TabControlComponent
     */
    getType() {
        return 'TabControl';
    }
};
/**
 * MapperId value for current control
 */
TabControlComponent.tabControlMapperId = 'tabcrl';
TabControlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TabControlComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TabControlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TabControlComponent, selector: "wm-tabcontrol", inputs: { model: "model", name: ["id", "name"], windowModel: "windowModel" }, outputs: { MouseDown: "MouseDown", TabSelect: "TabSelect", Selected: "Selected", Deselected: "Deselected" }, providers: [ContainerTabOrderService], queries: [{ propertyName: "allTabs", predicate: TabPageComponent }], viewQueries: [{ propertyName: "container", first: true, predicate: ["container"], descendants: true }, { propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<kendo-tabstrip *ngIf=\"model && model.Visible\" #displayElement (tabSelect)=\"selected($event)\" [animate]=\"false\"\r\n  [ngClass]=\"class\" wmContainer [hostComponent]=\"this\">\r\n  <kendo-tabstrip-tab *ngFor=\"let tab of tabModels let i=index\" [title]=\"tab.Text\" [disabled]=\"!model.Enabled || !tab.Enabled\"\r\n    [selected]=\"i==selectedIndexChanged()\">\r\n    <ng-template kendoTabContent>\r\n      <wm-custom-control-container *ngIf=\"windowModel\" [windowModel]=\"windowModel\" [containerParent]=\"name\"\r\n        (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"getControlObject(tab)\">\r\n      </wm-custom-control-container>\r\n      <wm-container *ngIf=\"!windowModel\" (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\">\r\n      </wm-container>\r\n    </ng-template>\r\n  </kendo-tabstrip-tab>\r\n</kendo-tabstrip>\r\n", styles: ["::ng-deep .k-tabstrip .k-tabstrip-items{display:block;overflow-x:auto;overflow-y:hidden;white-space:nowrap}::ng-deep .k-tabstrip-items .k-item{display:inline-block}kendo-tabstrip{height:calc(100% - 12px)}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6$3.TabStripComponent, selector: "kendo-tabstrip", inputs: ["height", "animate", "tabAlignment", "tabPosition", "keepTabContent", "closable", "scrollable", "closeIcon", "closeIconClass", "closeSVGIcon"], outputs: ["tabSelect", "tabClose", "tabScroll"], exportAs: ["kendoTabStrip"] }, { kind: "component", type: i6$3.TabStripTabComponent, selector: "kendo-tabstrip-tab", inputs: ["title", "disabled", "cssClass", "cssStyle", "selected", "closable", "closeIcon", "closeIconClass", "closeSVGIcon"], exportAs: ["kendoTabStripTab"] }, { kind: "directive", type: i6$3.TabContentDirective, selector: "[kendoTabContent]" }, { kind: "component", type: i3.ContainerComponent, selector: "wm-container", inputs: ["controls"], outputs: ["RemoveControl"] }, { kind: "component", type: CustomControlContainerComponent, selector: "wm-custom-control-container", inputs: ["controls", "containerParent", "windowModel", "controlType"] }, { kind: "directive", type: ContainerDirective, selector: "[wmContainer]" }] });
__decorate([
    serverEvent('MouseDown', TabControlComponent_1.MouseEventsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TabControlComponent.prototype, "triggerMouseDownEvent", null);
__decorate([
    serverEvent('Deselected', TabControlComponent_1.getSelectedIndexArgs),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TabControlComponent.prototype, "deselectedHandler", null);
__decorate([
    serverEvent('Selected', TabControlComponent_1.TabControlEventArgsSelected),
    serverEvent('SelectedIndexChanged', TabControlComponent_1.getSelectedIndexArgs),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SelectEvent]),
    __metadata("design:returntype", void 0)
], TabControlComponent.prototype, "selectedIndexChangeHandler", null);
__decorate([
    NotifyChange('SelectedIndex'),
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], TabControlComponent.prototype, "selectedIndex", null);
TabControlComponent = TabControlComponent_1 = __decorate([
    dataTransfer(['tabcrl']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService])
], TabControlComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TabControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-tabcontrol', inputs: ['model'], providers: [ContainerTabOrderService], template: "<kendo-tabstrip *ngIf=\"model && model.Visible\" #displayElement (tabSelect)=\"selected($event)\" [animate]=\"false\"\r\n  [ngClass]=\"class\" wmContainer [hostComponent]=\"this\">\r\n  <kendo-tabstrip-tab *ngFor=\"let tab of tabModels let i=index\" [title]=\"tab.Text\" [disabled]=\"!model.Enabled || !tab.Enabled\"\r\n    [selected]=\"i==selectedIndexChanged()\">\r\n    <ng-template kendoTabContent>\r\n      <wm-custom-control-container *ngIf=\"windowModel\" [windowModel]=\"windowModel\" [containerParent]=\"name\"\r\n        (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"getControlObject(tab)\">\r\n      </wm-custom-control-container>\r\n      <wm-container *ngIf=\"!windowModel\" (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\">\r\n      </wm-container>\r\n    </ng-template>\r\n  </kendo-tabstrip-tab>\r\n</kendo-tabstrip>\r\n", styles: ["::ng-deep .k-tabstrip .k-tabstrip-items{display:block;overflow-x:auto;overflow-y:hidden;white-space:nowrap}::ng-deep .k-tabstrip-items .k-item{display:inline-block}kendo-tabstrip{height:calc(100% - 12px)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { container: [{
                type: ViewChild,
                args: ['container', { static: false }]
            }], displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], MouseDown: [{
                type: Output
            }], TabSelect: [{
                type: Output
            }], Selected: [{
                type: Output
            }], Deselected: [{
                type: Output
            }], allTabs: [{
                type: ContentChildren,
                args: [TabPageComponent]
            }], name: [{
                type: Input,
                args: ['id']
            }], windowModel: [{
                type: Input
            }], triggerMouseDownEvent: [], deselectedHandler: [], selectedIndexChangeHandler: [], selectedIndex: [] } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
class TreeNode {
    /**
     * Constructor for the tree node item
     * @param node Model node to create a new tree node item.
     * @param parent TreeNode parent of the current node, if is a top node the parent is null.
     * @param index WebMap format index, consist the node levels separated by underscores (0_1_3)
     */
    constructor(node, parent, index) {
        this.internalNode = node ? node : {};
        this.parent = parent;
        this.nodes = [];
        this.webMapIndex = index;
    }
    /**
     * WebMap's unique id
     */
    get id() {
        return this.internalNode.Id;
    }
    /**
     * WebMap's type identificator to map the object type for serialization and create dynamic instances
     */
    get mapperId() {
        return this.internalNode.MapperId || null;
    }
    /**
     * Gets the text displayed in the label of the tree node.
     */
    get text() {
        return this.internalNode.text || null;
    }
    /**
     * Sets the text displayed in the label of the tree node.
     */
    set text(value) {
        this.internalNode.text = value;
    }
    /**
     * Gets a value indicating whether the tree node is visible or partially visible.
     */
    get isVisible() {
        return this.internalNode.visible !== false;
    }
    /**
     * Gets a value indicating whether the tree node is in a checked state.
     */
    get checked() {
        return this.internalNode.Checked || false;
    }
    /**
     * Sets a value indicating whether the tree node is in a checked state.
     */
    set checked(value) {
        this.internalNode.Checked = value;
    }
    /**
     * Gets the foreground color of the tree node.
     */
    get foreColor() {
        return this.internalNode.color;
    }
    /**
     * Sets the foreground color of the tree node.
     */
    set foreColor(value) {
        this.internalNode.color = value;
    }
    /**
     * Gets the background color of the tree node.
     */
    get backColor() {
        return this.internalNode.backcolor;
    }
    /**
     * Sets the background color of the tree node.
     */
    set backColor(value) {
        this.internalNode.backcolor = value;
    }
    /**
     * Gets image string associated with the tree node
     */
    get image() {
        return this.internalNode.image;
    }
    /**
     * Sets image string associated with the tree node
     */
    set image(value) {
        this.internalNode.image = value;
    }
    /**
     * Gets the text that appears when the mouse pointer hovers over a tree node.
     */
    get tooltipText() {
        return this.internalNode.tooltipText;
    }
    /**
     * Sets the text that appears when the mouse pointer hovers over a tree node.
     */
    set tooltipText(value) {
        this.internalNode.tooltipText = value;
    }
}

var TreeViewComponent_1;
var TreeViewAction;
(function (TreeViewAction) {
    TreeViewAction[TreeViewAction["Unknown"] = 0] = "Unknown";
    TreeViewAction[TreeViewAction["ByKeyboard"] = 1] = "ByKeyboard";
    TreeViewAction[TreeViewAction["ByMouse"] = 2] = "ByMouse";
    TreeViewAction[TreeViewAction["Collapse"] = 3] = "Collapse";
    TreeViewAction[TreeViewAction["Expand"] = 4] = "Expand";
})(TreeViewAction || (TreeViewAction = {}));
/**
 * <example-url>https://webmap-livedemo.azurewebsites.net/assets/live-demos/tree-view/tree-view.html</example-url>
 */
let TreeViewComponent = TreeViewComponent_1 = class TreeViewComponent extends ControlComponent {
    static TreeViewEventArgsExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: 'trvw' },
            {
                MapperId: 'TreeViewEventArgs',
                Action: TreeViewAction.ByMouse,
                References: { Node: event.args.NodeId }
            }
        ];
    }
    static InitEventsSequenceActionEventArgsExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: 'trvw' },
            {
                MapperId: 'TreeViewInitEventsSequenceActionEventArgs',
                Action: TreeViewAction.ByMouse,
                References: { Node: event.args.NodeId }
            }
        ];
    }
    static TreeNodeMouseClickEventArgs(event, component) {
        return [
            { Id: event.Id, MapperId: 'trvw' },
            {
                MapperId: 'TreeNodeMouseClickEventArgs',
                Button: event.args.button,
                X: event.args.x,
                Y: event.args.y,
                References: { Node: event.args.NodeId }
            }
        ];
    }
    static MouseDownExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: 'trvw' },
            {
                MapperId: 'MouseEventArgs',
                Button: event.button,
                x: event.x,
                y: event.y
            }
        ];
    }
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.service = service;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        this.defaultDataUrl = 'api/treeview/FetchItems';
        this.Click = new EventEmitter();
        this.DblClick = new EventEmitter();
        this.MouseDown = new EventEmitter();
        this.InitEventsSequenceAction = new EventEmitter();
        this.AfterExpand = new EventEmitter();
        this.AfterCollapse = new EventEmitter();
        this.AfterCheck = new EventEmitter();
        this.NodeMouseClick = new EventEmitter();
        this.NodeMouseDoubleClick = new EventEmitter();
        /**
         * The field that holds the keys of the expanded nodes.
         */
        this.isExpanded = (dataItem, index) => {
            return this.expandedKeys.indexOf(index) > -1;
        };
        /**
         * The visible state of the node in the parent tree nodes.
         */
        this.isVisible = (dataItem, index) => {
            const node = dataItem;
            return node.isVisible;
        };
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        this.fetchTreeNodes();
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    ngDoCheck() {
        super.ngDoCheck();
        if (this.refresh) {
            this.fetchTreeNodes();
            this.refresh = false;
        }
        if (this.refreshExpandedKeys) {
            this.updateExpandedKeys();
            this.refreshExpandedKeys = false;
        }
    }
    getDisplayElement() {
        if (this.element && this.element.nativeElement) {
            return this.element.nativeElement.querySelector('.k-treeview');
        }
        return undefined;
    }
    /**
     * the parent node's items collection as children
     * @param node the node item
     */
    fetchChildren(node) {
        return of(node.nodes);
    }
    /**
     * check if the parent node has children
     * @param node the current node
     */
    hasChildren(node) {
        return node.nodes && node.nodes.length > 0;
    }
    /**
     * Fetchs tree nodes
     * @property Nodes r
     */
    fetchTreeNodes() {
        this.service.fetch(this.url, this.id).subscribe((data) => {
            this.nodes = this.processTreeNodes(data.Nodes);
            this.expandedKeys = data.ExpandedKeys;
            this.disabledKeys = data.DisabledKeys;
            this.checkedKeys = data.CheckedKeys;
            this.detectChanges();
        });
    }
    /**
     * Updates the expandedKey collection.
     * A time-out is required to wait until the dom is updated
     */
    updateExpandedKeys() {
        this.detectChanges();
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * Sets/Gets expandedKeys.
     *
     * @memberof TreeViewComponent
     */
    set expandedKeys(value) {
        this.model.ExpandedKeys = value;
    }
    get expandedKeys() {
        return this.model.ExpandedKeys ?? [];
    }
    /**
     * Sets/Gets disabledKeys.
     *
     * @memberof TreeViewComponent
     */
    set disabledKeys(value) {
        this.model.DisabledKeys = value;
    }
    get disabledKeys() {
        return this.model.DisabledKeys ?? [];
    }
    /**
     * Sets/Gets nodes.
     *
     * @memberof TreeViewComponent
     */
    set nodes(value) {
        this.model.Items = value;
    }
    get nodes() {
        return this.model.Items ?? [];
    }
    /**
     * Gets tree css class
     */
    get treeClass() {
        return `${this.class} ${!this.showPlusMinus ? 'hide-plus-minus' : ''}`;
    }
    /**
     * Gets property to show plus minus expandable tree
     */
    get showPlusMinus() {
        return Utils.isDefaultValue(this.model.ShowPlusMinus, true);
    }
    /**
     * Returns the data source URL of this component.
     */
    get url() {
        if (this.dataUrl && this.dataUrl.length > 0) {
            return this.dataUrl;
        }
        return this.defaultDataUrl;
    }
    /**
     * Returns the delay time to move the scrollbar ensuring the node visibility
     */
    get scrollDelay() {
        /* c8 ignore else */
        if (this.scrollTime === undefined) {
            this.scrollTime = 300;
        }
        return this.scrollTime;
    }
    /**
     * Returns the settings for the checkboxes property
     */
    get checkableSettings() {
        return {
            checkChildren: this.checkChildren,
            checkParents: this.checkParents,
            enabled: this.checkboxes,
            mode: 'multiple'
        };
    }
    /**
     * Get the checkboxes property value
     */
    get checkboxes() {
        return this.model.CheckBoxes === true;
    }
    /**
     * Set the checkboxes property value
     */
    set checkboxes(value) {
        this.model.CheckBoxes = value;
    }
    /**
     * Get the selectedNode array to bind Kendo property value
     */
    get selectedNodeBind() {
        return this.selectedNodeInfo ? [this.selectedNodeInfo] : [];
    }
    /**
     * Set the selectedNode array to bind Kendo property value
     */
    set selectedNodeBind(value) {
        this.selectedNodeInfo = value[0];
    }
    /**
     * Get the selectedNodeInfo property value
     */
    get selectedNodeInfo() {
        return this.model.SelectedNodeInfo;
    }
    /**
     * Set the selectedNodeInfo property value
     */
    set selectedNodeInfo(value) {
        this.model.SelectedNodeInfo = value;
    }
    /**
     * Get the selectedNode property value
     */
    get selectedNode() {
        let node = null;
        if (this.selectedNodeInfo) {
            node = this.obtainNodeByKey(this.selectedNodeInfo);
        }
        return node;
    }
    /**
     * Set the selectedNode property value
     */
    set selectedNode(value) {
        this.selectedNodeInfo = value.webMapIndex;
    }
    /**
     * Get the refresh ExpandedKeys property value
     */
    get refreshExpandedKeys() {
        return this.model.RefreshExpandedKeys;
    }
    /**
     * Set the refresh ExpandedKeys property value
     */
    set refreshExpandedKeys(value) {
        this.model.RefreshExpandedKeys = value;
    }
    /**
     * Get checkedKeys
     */
    get checkedKeys() {
        return this.model.CheckedKeys ? this.model.CheckedKeys : [];
    }
    /**
     * Sets checkedKeys
     */
    set checkedKeys(value) {
        this.model.CheckedKeys = value;
    }
    /**
     * Returns the color inline style for the treeNode
     * @param item Node from TreeView
     */
    nodeStyle(item) {
        return {
            color: item.foreColor,
            'background-color': item.backColor
        };
    }
    /**
     * Sets the treeNode icon dimension
     */
    iconStyleSize() {
        if (this.model.ImageListSize !== undefined) {
            const dimSplitted = this.model.ImageListSize.split(',');
            if (dimSplitted.length > 1) {
                this.iconWidth = `${dimSplitted[0].trim()}px`;
                this.iconHeight = `${dimSplitted[1].trim()}px`;
            }
        }
    }
    /**
     * Returns the icon for the treenode
     * @param item Node from TreeView
     */
    iconStyle(item) {
        let returnValue;
        if (item.image !== undefined) {
            this.iconStyleSize();
            returnValue = {
                'background-image': item.image,
                height: this.iconHeight,
                'margin-right': '4px',
                width: this.iconWidth
            };
        }
        return returnValue;
    }
    /**
     * Returns the icon for the treenode
     * @param item Node from TreeView
     */
    isValidIcon(item) {
        return !!item.image && item.image.length > 0;
    }
    /**
     * Trigger the Click event when an item was clicked.
     */
    selectionChange(event) {
        if (event.index) {
            this.selectedNodeBind = [event.index];
            const node = event.dataItem;
            const nodeClickEventData = new EventData$1('NodeMouseClick', this.id);
            if (this.mouseDownNativeEvent) {
                nodeClickEventData.args = {
                    NodeId: node.id,
                    x: this.mouseDownNativeEvent.x,
                    y: this.mouseDownNativeEvent.y,
                    button: this.mouseDownNativeEvent.button
                };
            }
            this.nodeMouseClickEventHandler(nodeClickEventData);
            this.clickEventHandler(event);
            // Before select and after select execution.
            const initEventsSequenceActionEventData = new EventData$1('InitEventsSequenceAction', this.id);
            initEventsSequenceActionEventData.args = {
                NodeId: node.id
            };
            this.initEventsSequenceActionHandler(initEventsSequenceActionEventData);
        }
    }
    /**
     * Trigger the expand event when a node is expanded.
     */
    expand(event) {
        const expandedNodeKey = event.index || this.selectedNodeInfo;
        const node = event.dataItem;
        if (expandedNodeKey && node) {
            this.selectedNodeInfo = expandedNodeKey;
            this.addExpandedNode(expandedNodeKey);
            const eventData = new EventData$1('AfterExpand', this.id);
            eventData.args = { NodeId: node.id };
            this.afterExpandEventHandler(eventData);
        }
    }
    /**
     * Trigger the collapse event when a node is collapsed.
     */
    collapse(event) {
        const collapsedNodeKey = event.index || this.selectedNodeInfo;
        const node = event.dataItem;
        if (collapsedNodeKey && node) {
            this.selectedNodeInfo = collapsedNodeKey;
            this.removeExpandedNode(collapsedNodeKey);
            const eventData = new EventData$1('AfterCollapse', this.id);
            eventData.args = { NodeId: node.id };
            this.afterCollapseEventHandler(eventData);
        }
    }
    /**
     * Trigger the AfterCheck event when an item was checked.
     */
    afterCheck(event) {
        /* c8 ignore else */
        if (event.item && event.item.index) {
            this.selectedNodeBind = [event.item.index];
            const node = this.obtainNodeByKey(this.selectedNodeInfo);
            const eventData = new EventData$1('AfterCheck', this.id);
            eventData.args = { NodeId: node.id };
            this.afterCheckEventHandler(eventData);
        }
    }
    /**
     * Trigger the DoubleClick event when an item was clicked.
     */
    dblclick(event) {
        /* c8 ignore else */
        if (this.selectedNodeInfo) {
            const node = this.obtainNodeByKey(this.selectedNodeInfo);
            event.dataItem = node;
            if (this.isExpanded({}, this.selectedNodeInfo)) {
                this.collapse(event);
            }
            else {
                this.expand(event);
            }
            const nodeClickEventData = new EventData$1('NodeMouseDoubleClick', this.id);
            nodeClickEventData.args = { NodeId: node.id };
            this.nodeMouseDoubleClickEventHandler(nodeClickEventData);
        }
        this.doubleClickEventHandler(event);
    }
    /**
     * Trigger the DoubleClick event when an item was clicked.
     */
    mousedown(event) {
        event.Id = this.model.id;
        this.mouseDownNativeEvent = event;
        this.trySetNodeClicked(event);
        this.MouseDown.emit(new EventData$1(event, this.selectedNodeInfo));
        event.stopPropagation();
    }
    initEventsSequenceActionHandler(event) {
        this.InitEventsSequenceAction.emit(new EventData$1(event, this.selectedNodeInfo));
    }
    afterExpandEventHandler(event) {
        this.AfterExpand.emit(new EventData$1(event, event.args.NodeId));
    }
    afterCollapseEventHandler(event) {
        this.AfterCollapse.emit(new EventData$1(event, event.args.NodeId));
    }
    afterCheckEventHandler(event) {
        this.AfterCheck.emit(new EventData$1(event, this.selectedNodeInfo));
    }
    doubleClickEventHandler(event) {
        // Adding model id to event
        // to make sure that the id will
        // get to the model extractor
        event.Id = this.model.id;
        this.DblClick.emit(new EventData$1(event, this.selectedNodeInfo));
    }
    clickEventHandler(event) {
        this.Click.emit(new EventData$1(event, this.selectedNodeInfo));
    }
    nodeMouseClickEventHandler(event) {
        this.NodeMouseClick.emit(new EventData$1(event, this.selectedNodeInfo));
    }
    nodeMouseDoubleClickEventHandler(event) {
        this.NodeMouseDoubleClick.emit(new EventData$1(event, this.selectedNodeInfo));
    }
    obtainNodeByKey(nodeKey) {
        const nodesIndexes = nodeKey.split('_');
        let currentIndex = nodesIndexes[0];
        let currentNode = this.nodes[currentIndex];
        for (let i = 1; i < nodesIndexes.length; i++) {
            currentIndex = nodesIndexes[i];
            currentNode = currentNode.nodes[currentIndex];
        }
        return currentNode;
    }
    /**
     * Returns the index path of a clicked node
     * @param domTarget the target of the event
     */
    trySetNodeClicked(event) {
        const selector = 'span[kendotreeviewitemcontent]';
        let selectedDOMNode = event.target.closest(selector);
        if (!selectedDOMNode && this.mightBeATreeExpandOrCollapse(event.target)) {
            selectedDOMNode = event.target.nextElementSibling.closest(selector);
        }
        if (selectedDOMNode) {
            this.selectedNodeInfo = selectedDOMNode.getAttribute('data-treeindex');
        }
    }
    /**
     * Iterates the node tree models and create the TreeNodes
     * @param nodeModels Node models received by API call
     * @param parentNode Root node to create the tree structure
     * @param isRoot Determines if is a root node to set parent to null
     */
    buildTreeNodes(nodeModels, parentNode, isRoot) {
        for (let i = 0; i < nodeModels.length; i++) {
            const nodeModel = nodeModels[i];
            const index = isRoot ? i.toString() : `${parentNode.webMapIndex}_${i}`;
            const treeNode = new TreeNode(nodeModel, isRoot ? null : parentNode, index);
            parentNode.nodes.push(treeNode);
            if (nodeModel.items?.length > 0) {
                this.buildTreeNodes(nodeModel.items, treeNode, false);
            }
        }
    }
    /**
     * Creates root node and call buildTreeNodes to build the tree structure
     * @param nodeModels Node models received by API call
     * @returns The tree represented by TreeNodes objects
     */
    processTreeNodes(nodeModels) {
        const rootNode = new TreeNode();
        this.buildTreeNodes(nodeModels, rootNode, true);
        return rootNode.nodes;
    }
    /**
     * Adds expanded node to expandedKeys collection
     * @param keyNode String key parameter
     */
    addExpandedNode(keyNode) {
        const tempExpandedKeys = this.expandedKeys;
        tempExpandedKeys.push(keyNode);
        tempExpandedKeys.sort();
        this.expandedKeys = tempExpandedKeys;
    }
    /**
     * Removes expanded node from expandedKeys collection
     * @param keyNode String key parameter
     */
    removeExpandedNode(keyNode) {
        const index = this.expandedKeys.indexOf(keyNode);
        /* c8 ignore else */
        if (index > -1) {
            const tempExpandedKeys = this.expandedKeys;
            tempExpandedKeys.splice(index, 1);
            this.expandedKeys = tempExpandedKeys;
        }
    }
    mightBeATreeExpandOrCollapse(elem) {
        if (elem && elem.tagName === 'SPAN') {
            const classAttr = elem.getAttribute('class');
            return (classAttr.indexOf('k-icon') !== -1 &&
                (classAttr.indexOf('k-i-expand') !== -1 ||
                    classAttr.indexOf('k-i-collapse') !== -1));
        }
        return false;
    }
    /**
     * Gets the tooltip text of the given node.
     *
     * @param item
     * @returns
     */
    nodeTooltip(item) {
        return item.tooltipText ?? '';
    }
};
TreeViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TreeViewComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TreeViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TreeViewComponent, selector: "wm-treeview", inputs: { model: "model", dataUrl: "dataUrl", scrollTime: "scrollTime", checkChildren: "checkChildren", checkParents: "checkParents" }, outputs: { Click: "Click", DblClick: "DblClick", MouseDown: "MouseDown", InitEventsSequenceAction: "InitEventsSequenceAction", AfterExpand: "AfterExpand", AfterCollapse: "AfterCollapse", AfterCheck: "AfterCheck", NodeMouseClick: "NodeMouseClick", NodeMouseDoubleClick: "NodeMouseDoubleClick" }, viewQueries: [{ propertyName: "kendoTreeView", first: true, predicate: TreeViewComponent$1, descendants: true }], usesInheritance: true, ngImport: i0, template: "<kendo-treeview wmControls *ngIf=\"model\" [ngClass]=\"treeClass\" [nodes]=\"nodes\" textField=\"text\" kendoTreeViewSelectable\r\n    kendoTreeViewHierarchyBinding kendoTreeViewDisable [children]=\"fetchChildren\" [hasChildren]=\"hasChildren\"\r\n    [disabledKeys]=\"disabledKeys\" [kendoTreeViewCheckable]=\"checkableSettings\" [(checkedKeys)]=\"checkedKeys\"\r\n    [(selectedKeys)]=\"selectedNodeBind\" (selectionChange)=\"selectionChange($event)\" (checkedChange)=\"afterCheck($event)\"\r\n    (mousedown)=\"mousedown($event)\" (dblclick)=\"dblclick($event)\" [isExpanded]=\"isExpanded\" [isVisible]=\"isVisible\"\r\n    (expand)=\"expand($event)\" [hostComponent]=\"this\" [ngStyle]=\"setMyStyle()\" (collapse)=\"collapse($event)\"\r\n    tabindex=\"-1\">\r\n    <ng-template kendoTreeViewNodeTemplate let-dataItem>\r\n        <div kendoTooltip [title]=\"nodeTooltip(dataItem)\" (mousedown)=\"mousedown($event)\" mwlDraggable\r\n            [dropData]=\"dataItem\" class=\"inline-flex-parent\">\r\n            <span *ngIf=\"isValidIcon(dataItem)\" [ngStyle]=\"iconStyle(dataItem)\"></span>\r\n            <label [ngStyle]=\"nodeStyle(dataItem)\">{{dataItem.text}}</label>\r\n        </div>\r\n    </ng-template>\r\n</kendo-treeview>", styles: ["@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){::ng-deep .k-in{display:inline!important}::ng-deep .k-in span{display:inline-block}}.inline-flex-parent{display:inline-flex;padding:4px 8px}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i5$1.DraggableDirective, selector: "[mwlDraggable]", inputs: ["dropData", "dragAxis", "dragSnapGrid", "ghostDragEnabled", "showOriginalElementWhileDragging", "validateDrag", "dragCursor", "dragActiveClass", "ghostElementAppendTo", "ghostElementTemplate", "touchStartLongPress", "autoScroll"], outputs: ["dragPointerDown", "dragStart", "ghostElementCreated", "dragging", "dragEnd"] }, { kind: "component", type: i7$2.TreeViewComponent, selector: "kendo-treeview", inputs: ["filterInputPlaceholder", "expandDisabledNodes", "animate", "nodeTemplate", "loadMoreButtonTemplate", "trackBy", "nodes", "textField", "hasChildren", "isChecked", "isDisabled", "isExpanded", "isSelected", "isVisible", "navigable", "children", "loadOnDemand", "filterable", "filter", "size", "disableParentNodesOnly"], outputs: ["childrenLoaded", "blur", "focus", "expand", "collapse", "nodeDragStart", "nodeDrag", "filterStateChange", "nodeDrop", "nodeDragEnd", "addItem", "removeItem", "checkedChange", "selectionChange", "filterChange", "nodeClick", "nodeDblClick"], exportAs: ["kendoTreeView"] }, { kind: "directive", type: i7$2.NodeTemplateDirective, selector: "[kendoTreeViewNodeTemplate]" }, { kind: "directive", type: i7$2.CheckDirective, selector: "[kendoTreeViewCheckable]", inputs: ["isChecked", "checkBy", "checkedKeys", "kendoTreeViewCheckable"], outputs: ["checkedKeysChange"] }, { kind: "directive", type: i7$2.DisableDirective, selector: "[kendoTreeViewDisable]", inputs: ["isDisabled", "kendoTreeViewDisable", "disabledKeys"] }, { kind: "directive", type: i7$2.SelectDirective, selector: "[kendoTreeViewSelectable]", inputs: ["isSelected", "selectBy", "kendoTreeViewSelectable", "selectedKeys"], outputs: ["selectedKeysChange"] }, { kind: "directive", type: i7$2.HierarchyBindingDirective, selector: "[kendoTreeViewHierarchyBinding]", inputs: ["childrenField", "nodes", "isVisible", "loadOnDemand"] }, { kind: "directive", type: i10.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    NotifyChange('ExpandedKeys'),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], TreeViewComponent.prototype, "expandedKeys", null);
__decorate([
    NotifyChange('SelectedNodeInfo'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], TreeViewComponent.prototype, "selectedNodeInfo", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", TreeNode),
    __metadata("design:paramtypes", [TreeNode])
], TreeViewComponent.prototype, "selectedNode", null);
__decorate([
    NotifyChange('RefreshExpandedKeys'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], TreeViewComponent.prototype, "refreshExpandedKeys", null);
__decorate([
    NotifyChange('CheckedKeys'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], TreeViewComponent.prototype, "checkedKeys", null);
__decorate([
    serverEvent('MouseDown', TreeViewComponent_1.MouseDownExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TreeViewComponent.prototype, "mousedown", null);
__decorate([
    serverEvent('InitEventsSequenceAction', TreeViewComponent_1.InitEventsSequenceActionEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TreeViewComponent.prototype, "initEventsSequenceActionHandler", null);
__decorate([
    serverEvent('AfterExpand', TreeViewComponent_1.TreeViewEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TreeViewComponent.prototype, "afterExpandEventHandler", null);
__decorate([
    serverEvent('AfterCollapse', TreeViewComponent_1.TreeViewEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TreeViewComponent.prototype, "afterCollapseEventHandler", null);
__decorate([
    serverEvent('AfterCheck', TreeViewComponent_1.TreeViewEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TreeViewComponent.prototype, "afterCheckEventHandler", null);
__decorate([
    serverEvent('DoubleClick'),
    serverEvent('MouseDoubleClick'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TreeViewComponent.prototype, "doubleClickEventHandler", null);
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TreeViewComponent.prototype, "clickEventHandler", null);
__decorate([
    serverEvent('NodeMouseClick', TreeViewComponent_1.TreeNodeMouseClickEventArgs),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TreeViewComponent.prototype, "nodeMouseClickEventHandler", null);
__decorate([
    serverEvent('NodeMouseDoubleClick', TreeViewComponent_1.TreeNodeMouseClickEventArgs),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TreeViewComponent.prototype, "nodeMouseDoubleClickEventHandler", null);
TreeViewComponent = TreeViewComponent_1 = __decorate([
    dataTransfer(['trvw']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], TreeViewComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TreeViewComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-treeview', inputs: ['model'], template: "<kendo-treeview wmControls *ngIf=\"model\" [ngClass]=\"treeClass\" [nodes]=\"nodes\" textField=\"text\" kendoTreeViewSelectable\r\n    kendoTreeViewHierarchyBinding kendoTreeViewDisable [children]=\"fetchChildren\" [hasChildren]=\"hasChildren\"\r\n    [disabledKeys]=\"disabledKeys\" [kendoTreeViewCheckable]=\"checkableSettings\" [(checkedKeys)]=\"checkedKeys\"\r\n    [(selectedKeys)]=\"selectedNodeBind\" (selectionChange)=\"selectionChange($event)\" (checkedChange)=\"afterCheck($event)\"\r\n    (mousedown)=\"mousedown($event)\" (dblclick)=\"dblclick($event)\" [isExpanded]=\"isExpanded\" [isVisible]=\"isVisible\"\r\n    (expand)=\"expand($event)\" [hostComponent]=\"this\" [ngStyle]=\"setMyStyle()\" (collapse)=\"collapse($event)\"\r\n    tabindex=\"-1\">\r\n    <ng-template kendoTreeViewNodeTemplate let-dataItem>\r\n        <div kendoTooltip [title]=\"nodeTooltip(dataItem)\" (mousedown)=\"mousedown($event)\" mwlDraggable\r\n            [dropData]=\"dataItem\" class=\"inline-flex-parent\">\r\n            <span *ngIf=\"isValidIcon(dataItem)\" [ngStyle]=\"iconStyle(dataItem)\"></span>\r\n            <label [ngStyle]=\"nodeStyle(dataItem)\">{{dataItem.text}}</label>\r\n        </div>\r\n    </ng-template>\r\n</kendo-treeview>", styles: ["@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){::ng-deep .k-in{display:inline!important}::ng-deep .k-in span{display:inline-block}}.inline-flex-parent{display:inline-flex;padding:4px 8px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { kendoTreeView: [{
                type: ViewChild,
                args: [TreeViewComponent$1, { static: false }]
            }], dataUrl: [{
                type: Input
            }], scrollTime: [{
                type: Input
            }], checkChildren: [{
                type: Input
            }], checkParents: [{
                type: Input
            }], Click: [{
                type: Output
            }], DblClick: [{
                type: Output
            }], MouseDown: [{
                type: Output
            }], InitEventsSequenceAction: [{
                type: Output
            }], AfterExpand: [{
                type: Output
            }], AfterCollapse: [{
                type: Output
            }], AfterCheck: [{
                type: Output
            }], NodeMouseClick: [{
                type: Output
            }], NodeMouseDoubleClick: [{
                type: Output
            }], expandedKeys: [], selectedNodeInfo: [], selectedNode: [], refreshExpandedKeys: [], checkedKeys: [], mousedown: [], initEventsSequenceActionHandler: [], afterExpandEventHandler: [], afterCollapseEventHandler: [], afterCheckEventHandler: [], doubleClickEventHandler: [], clickEventHandler: [], nodeMouseClickEventHandler: [], nodeMouseDoubleClickEventHandler: [] } });

let NumericUpDownComponent = class NumericUpDownComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        this.ValueChanged = new EventEmitter();
    }
    /**
     * Init Angular life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        this.internalThousandsSeparator = this.thousandsSeparator;
        this.setFormatOptions();
    }
    /**
     * DoCheck Angular life-cycle hook
     */
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore else */
        if (this.internalThousandsSeparator !== this.thousandsSeparator) {
            this.setFormatOptions();
            this.internalThousandsSeparator = this.thousandsSeparator;
        }
    }
    getDisplayElement() {
        if (this.element && this.element.nativeElement) {
            return this.element.nativeElement.querySelector('.k-input');
        }
        return undefined;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * @param value Contains the number of decimal places to display.
     */
    set decimalPlaces(value) {
        this.model.DecimalPlaces = value;
    }
    get decimalPlaces() {
        return this.model.DecimalPlaces;
    }
    /**
     * @param value  the value to increment or decrement the spin box.
     */
    set increment(value) {
        this.model.Increment = value;
    }
    get increment() {
        return this.model.Increment || 1;
    }
    /**
     * @param value Contains the maximum value for the spin box.
     */
    set maximum(value) {
        this.model.Maximum = value;
    }
    get maximum() {
        return this.model.Maximum;
    }
    /**
     * @param value Contains the minimum allowed value for the spin box.
     */
    set minimum(value) {
        this.model.Minimum = value;
    }
    get minimum() {
        return this.model.Minimum;
    }
    /**
     * Gets the numericupdown readonly value
     */
    get readOnly() {
        return this.model.ReadOnly;
    }
    /**
     * @param value Contains the value assigned to the spin box.
     */
    set value(value) {
        this.model.Value = value;
    }
    get value() {
        return this.model.Value;
    }
    /**
     * Gets thousands separator from model, otherwise false
     */
    get thousandsSeparator() {
        return this.model.ThousandsSeparator || false;
    }
    /**
     * Sets the format options for control
     */
    setFormatOptions() {
        this.formatOptions = {
            style: 'decimal',
            maximumFractionDigits: this.decimalPlaces,
            minimumFractionDigits: this.decimalPlaces,
            useGrouping: this.thousandsSeparator
        };
    }
    /**
     * ValueChange event handler
     * @param event
     */
    valueChanged(event) {
        this.ValueChanged.emit(new EventData$1(event, this.id));
    }
};
NumericUpDownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NumericUpDownComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
NumericUpDownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: NumericUpDownComponent, selector: "wm-numericupdown", inputs: { model: "model" }, outputs: { ValueChanged: "ValueChanged" }, usesInheritance: true, ngImport: i0, template: "<kendo-numerictextbox *ngIf=\"model && visible\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\"\r\n    [format]=\"formatOptions\" [disabled]=\"disabled\" [(value)]=\"value\" [min]=\"minimum\" [max]=\"maximum\" [step]=\"increment\"\r\n    [readonly]=\"readOnly\" (valueChange)=\"valueChanged($event)\">\r\n</kendo-numerictextbox>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i8.NumericTextBoxComponent, selector: "kendo-numerictextbox", inputs: ["focusableId", "disabled", "readonly", "title", "autoCorrect", "format", "max", "min", "decimals", "placeholder", "step", "spinners", "rangeValidation", "tabindex", "tabIndex", "changeValueOnScroll", "selectOnFocus", "value", "maxlength", "size", "rounded", "fillMode"], outputs: ["valueChange", "focus", "blur"], exportAs: ["kendoNumericTextBox"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    MarkForCheck(),
    NotifyChange('Value'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], NumericUpDownComponent.prototype, "value", null);
__decorate([
    serverEvent('ValueChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NumericUpDownComponent.prototype, "valueChanged", null);
NumericUpDownComponent = __decorate([
    dataTransfer(['nmrupdwn']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], NumericUpDownComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NumericUpDownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-numericupdown', inputs: ['model'], template: "<kendo-numerictextbox *ngIf=\"model && visible\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\"\r\n    [format]=\"formatOptions\" [disabled]=\"disabled\" [(value)]=\"value\" [min]=\"minimum\" [max]=\"maximum\" [step]=\"increment\"\r\n    [readonly]=\"readOnly\" (valueChange)=\"valueChanged($event)\">\r\n</kendo-numerictextbox>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { ValueChanged: [{
                type: Output
            }], value: [], valueChanged: [] } });

var ContextMenuStripComponent_1;
let ContextMenuStripComponent = ContextMenuStripComponent_1 = class ContextMenuStripComponent extends ControlComponent {
    /**
     * Menu item extractor
     * @param event
     * @param component
     * @returns item extractor
     */
    static menuItemExtractor(event, component) {
        component.currentItem.id = component.currentItem.UniqueID;
        const item = component.currentItem;
        component.currentItem = undefined;
        return item;
    }
    /**
     * Menus item click event args extractor
     * @param event
     * @param component
     * @returns item click event args extractor
     */
    static menuItemClickEventArgsExtractor(event, component) {
        component.currentItem.id = component.currentItem.UniqueID;
        const item = component.currentItem;
        return [{ Id: item.UniqueID, MapperId: item.MapperId }, null];
    }
    /* c8 ignore start */
    constructor(service, changeDetector, renderer2, element, webComponents, popupService, bringTopServ, containerInteraction, focusManager) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.service = service;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.popupService = popupService;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.focusManager = focusManager;
        /* c8 ignore stop */
        /**
         * When any item was clicked is set as the current item.
         */
        this.currentItem = {};
        /**
         * Used to position the contextmenu in the clicked point
         */
        this.offset = { left: 0, top: 0 };
        /**
         * Array of data of the contextmenu
         */
        this.items = [];
        /**
         * Determines whether if the component
         * should have absolute positioning when
         * shown by server side action
         */
        this.isServerShown = false;
        /**
         * Determines whether the component should have the focus when it's open.
         */
        this.hasFocus = false;
        /**
         * Event opening emitted when the contextmenu is displayed
         */
        this.Opening = new EventEmitter();
        /**
         * Event Click emitted when an item of the contextmenu is clicked
         */
        this.Click = new EventEmitter();
        /**
         * Event ItemClicked emitted when a menu item is clicked.
         *
         * @type {EventEmitter<EventData>}
         * @memberof ContextMenuStripComponent
         */
        this.ItemClicked = new EventEmitter();
        this.visibleInternal = false;
        this.onContextMenu = this.onContextMenu.bind(this);
        this.documentClickSubscription = this.renderer2.listen('document', 'click', this.hideContextMenuStrip.bind(this));
        this.contextMenuSubscription = this.renderer2.listen('document', 'contextmenu', this.closePrevious.bind(this));
    }
    open(event) {
        this.Opening.emit(new EventData$1(event, this.id));
    }
    /**
     * Gets visible
     */
    get visible() {
        return this.visibleInternal;
    }
    /**
     * Sets visible
     */
    set visible(value) {
        this.visibleInternal = value;
    }
    /**
     * Used to close or open the contextmenu
     */
    get show() {
        return this.model.Show;
    }
    set show(value) {
        this.model.Show = value;
    }
    /**
     * Returns the position in X axis
     */
    get x() {
        return this.model.Style && this.model.Style.Left
            ? parseInt(this.model.Style.Left, 10)
            : 0;
    }
    /**
     * Returns the position in the y axis
     */
    get y() {
        return this.model.Style && this.model.Style.Top
            ? parseInt(this.model.Style.Top, 10)
            : 0;
    }
    /**
     * Get Items for the menu datasource
     */
    get itemsid() {
        return this.model.Items;
    }
    /**
     * Gets show image margin
     */
    get showCheckMargin() {
        return !!this.model.ShowCheckMargin;
    }
    /**
     * Gets the kendo popup settings
     */
    get popupSettings() {
        return {
            content: this.templatePopup,
            offset: this.offset,
            popupClass: this.class,
            positionMode: this.isServerShown ? 'absolute' : 'fixed'
        };
    }
    /**
     * Gets the control container id
     * @memberof ContextMenuStrip
     */
    get containerId() {
        return this.model.ContainerId;
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        this.fetchItems();
        this.clickSubscription = this.service.core
            .getEvent()
            .subscribe('ctxMenu', (event) => {
            if (event.event.ctxId === this.id) {
                this.onContextMenu(event);
            }
        });
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    /**
     * Fetchs items
     * @property Items r
     */
    fetchItems() {
        const promises = [];
        this.items = [];
        this.itemsid.forEach((element) => {
            const dataItem = this.formatNode(this.service.core.getModel(element));
            /* c8 ignore else */
            if (dataItem && dataItem.Visible !== false) {
                this.items.push(dataItem);
            }
        });
        this.handleShowFromServer();
        this.markForCheck();
        /* c8 ignore else */
        if (this.visible) {
            this.forceSetOffset();
        }
    }
    /**
     * Force set offset
     * Sets the left and top properties directly in the style
     * for special cases.
     */
    forceSetOffset() {
        const kendoPopup = document.documentElement.getElementsByTagName('kendo-popup');
        if (kendoPopup[0]?.closest('.k-grid-virtual')) {
            this.changeDetector.detectChanges();
            const popup = document.documentElement
                .getElementsByTagName('kendo-popup')
                ?.item(0);
            /* c8 ignore else */
            if (popup) {
                popup.style.left = `${this.offset.left}px`;
                popup.style.top = `${this.offset.top}px`;
            }
        }
    }
    /**
     * Formats node
     * Extracts information to be used by the kendo menu component
     * directly from model structure.
     * @param itemModel the current node to be formatted.
     */
    formatNode(itemModel) {
        itemModel.text = itemModel.Text;
        itemModel.disabled = !itemModel.Enabled;
        itemModel.EventChanges = itemModel.events;
        itemModel.MapperId = itemModel.mapperId;
        itemModel.items = [];
        const itemRefs = itemModel.DropDownItems;
        if (itemRefs && itemRefs.length > 0) {
            itemRefs.forEach((element) => {
                const childNode = this.service.core.getModel(element);
                /* c8 ignore else */
                if (childNode && childNode.Visible !== false) {
                    this.formatNode(childNode);
                    itemModel.items.push(childNode);
                }
            });
        }
        return itemModel;
    }
    ngDoCheck() {
        super.ngDoCheck();
        if (this.refresh) {
            this.fetchItems();
            this.refresh = false;
            return;
        }
        this.handleShowFromServer();
        this.kendoMenuFocus();
    }
    ngOnDestroy() {
        if (this.popupRef) {
            this.popupRef.close();
        }
        this.unsubscribe();
        this.documentClickSubscription();
        this.contextMenuSubscription();
    }
    /**
     * Trigger the Click event when a context menu item was clicked.
     */
    menuItemSelected(event) {
        const id = event.item.UniqueID;
        this.currentItem = event.item;
        this.Click.emit(new EventData$1(event, id));
        /* c8 ignore else */
        if (!isNaN(+event.index)) {
            this.onItemClicked(event, id);
        }
    }
    /**
     * Override the method to check if any Item was clicked
     * @param event event to trigger.
     */
    isBindedEvent(event) {
        const containsEvent = this.events && this.events[event];
        if (this.currentItem && this.currentItem.EventChanges) {
            if (this.currentItem.EventChanges[event]) {
                return true;
            }
        }
        return containsEvent;
    }
    /**
     * Keys down handler
     * @param event
     */
    keyDownHandler(event) {
        switch (event.key) {
            case 'Tab':
            case 'Esc':
            case 'ArrowRight':
            case 'ArrowLeft':
                this.hideContextMenuStrip();
                break;
            default:
                break;
        }
    }
    /**
     * Sets the focus to the kendo menu when it opens.
     */
    kendoMenuFocus() {
        if (this.kendoMenu && this.visible && !this.hasFocus) {
            this.kendoMenu.focus();
            this.hasFocus = true;
        }
    }
    /**
     * Determines whether selected item is
     * @param item thw item WebMapModel formated
     * @returns true if selected item
     */
    isCheckedItem(item) {
        return item.CheckState === CheckState.Checked;
    }
    /**
     * Method that set values of the contextmenu to show it on each right click
     */
    /* c8 ignore next */
    onContextMenu(e) {
        e.event.preventDefault();
        this.open(e);
        this.isServerShown = false;
        this.offset = { left: e.event.pageX, top: e.event.pageY };
        this.visible = true;
        this.openContextMenu();
        this.markForCheck();
    }
    handleShowFromServer() {
        if (this.show) {
            this.showFromServerImpl();
            this.show = false;
        }
    }
    /**
     * Open the context menu
     *
     * @memberof ContextMenuStripComponent
     */
    openContextMenu() {
        if (this.popupRef) {
            this.popupRef.close();
            this.popupRef = null;
        }
        this.popupRef = this.popupService.open(this.popupSettings);
        ContextMenuStripComponent_1.currentCtxMenu = this.id;
    }
    /**
     * Close previous context menus
     *
     * @memberof ContextMenuStripComponent
     */
    closePrevious() {
        if (ContextMenuStripComponent_1.currentCtxMenu !== this.id) {
            this.hideContextMenuStrip();
        }
    }
    /**
     * Used to reset subscription of the component
     */
    /* c8 ignore next */
    unsubscribe() {
        if (this.clickSubscription) {
            this.service.core.getEvent().unSubscribe(this.clickSubscription);
            this.clickSubscription = null;
        }
    }
    /**
     * Shows from server impl
     */
    showFromServerImpl() {
        this.visible = true;
        this.isServerShown = true;
        this.offset = this.calculateOffset();
        this.openContextMenu();
    }
    /**
     * Checks if the item is a tlStrpMnuItm.
     *
     * @param item
     * @returns true if tlStrpMnuItm.
     */
    isMenuItem(item) {
        return item.mapperId === 'tlStrpMnuItm';
    }
    /**
     * Triggers the itemClicked event when a menu item was clicked.
     *
     * @param {*} event
     * @param {*} UniqueId
     * @memberof ContextMenuStripComponent
     */
    onItemClicked(event, UniqueId) {
        this.ItemClicked.emit(new EventData$1(event, UniqueId));
    }
    /**
     * Hide the context menu strip
     *
     * @memberof ContextMenuStripComponent
     * @param {any} event
     */
    hideContextMenuStrip() {
        if (this.visible) {
            this.visible = this.isServerShown = this.show = this.hasFocus = false;
            this.popupRef.close();
            this.popupRef = null;
            this.markForCheck();
            this.focusActiveComponent();
        }
    }
    /**
     * Focuses the active component from the focusManager service.
     * This should be called when closing the ContextMenuStrip component.
     *
     * @memberof ContextMenuStripComponent
     */
    focusActiveComponent() {
        this.focusManager?.activeComponent?.applyFocus();
    }
    /**
     * Calculates the offset for the popup menu
     * @memberof ContextMenuStrip
     */
    calculateOffset() {
        const containerElem = this.element.nativeElement;
        const containerRect = containerElem
            ? containerElem.getBoundingClientRect()
            : null;
        return {
            top: containerRect ? containerRect.top + this.y : this.y,
            left: containerRect ? containerRect.left + this.x : this.x
        };
    }
};
ContextMenuStripComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContextMenuStripComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3$2.PopupService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: FocusManagerService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ContextMenuStripComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ContextMenuStripComponent, selector: "wm-contextmenustrip", inputs: { model: "model", dataUrl: "dataUrl" }, outputs: { Opening: "Opening", Click: "Click", ItemClicked: "ItemClicked" }, viewQueries: [{ propertyName: "kendoMenu", first: true, predicate: ["kendoMenu"], descendants: true }, { propertyName: "templatePopup", first: true, predicate: ["templatePopup"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-template #templatePopup>\r\n  <kendo-menu *ngIf=\"!showCheckMargin\" wmControls [hostComponent]=\"this\" [items]=\"items\" [vertical]=\"true\"\r\n    style=\"display:inline-block;\" (select)=\"menuItemSelected($event)\">\r\n  </kendo-menu>\r\n  <kendo-menu #kendoMenu *ngIf=\"showCheckMargin\" wmControls [hostComponent]=\"this\" [vertical]=\"true\" [items]=\"items\"\r\n    style=\"display:inline-block;\" (select)=\"menuItemSelected($event)\" (keydown)=\"keyDownHandler($event)\">\r\n    <ng-template kendoMenuItemTemplate let-item=\"item\" let-index=\"index\">\r\n      <svg *ngIf=\"isCheckedItem(item)\" xmlns=\"http://www.w3.org/2000/svg\" width=\"7\" height=\"7\" viewBox=\"0 0 24 24\">\r\n        <path d=\"M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z\" />\r\n      </svg>\r\n      <ng-container *ngIf=\"!isMenuItem(item)\">\r\n        {{item.text}}\r\n      </ng-container>\r\n      <wm-toolstrip-menuitem *ngIf=\"isMenuItem(item)\" BelongsToContextMenu=\"true\"\r\n        [model]=\"item\"></wm-toolstrip-menuitem>\r\n    </ng-template>\r\n  </kendo-menu>\r\n</ng-template>", styles: [".popup-server{position:absolute!important}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MenuComponent, selector: "kendo-menu", inputs: ["menuItemTemplate", "ariaRole", "menuItemLinkTemplate"], outputs: ["select", "open", "close"], exportAs: ["kendoMenu"] }, { kind: "directive", type: i3$1.ItemTemplateDirective, selector: "[kendoMenuItemTemplate]" }, { kind: "component", type: ToolStripMenuItemComponent, selector: "wm-toolstrip-menuitem", inputs: ["BelongsToContextMenu"], outputs: ["Click"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    serverEvent('Opening'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ContextMenuStripComponent.prototype, "open", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Show'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ContextMenuStripComponent.prototype, "show", null);
__decorate([
    serverEvent('Click', ContextMenuStripComponent_1.menuItemClickEventArgsExtractor, ContextMenuStripComponent_1.menuItemExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ContextMenuStripComponent.prototype, "menuItemSelected", null);
__decorate([
    serverEvent('ItemClicked', ToolStripComponent.menuItemClickedEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContextMenuStripComponent.prototype, "onItemClicked", null);
ContextMenuStripComponent = ContextMenuStripComponent_1 = __decorate([
    dataTransfer(['ctxStrp']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        PopupService,
        BringTopService,
        ContainerInteractionService,
        FocusManagerService])
], ContextMenuStripComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContextMenuStripComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-contextmenustrip', inputs: ['model'], template: "<ng-template #templatePopup>\r\n  <kendo-menu *ngIf=\"!showCheckMargin\" wmControls [hostComponent]=\"this\" [items]=\"items\" [vertical]=\"true\"\r\n    style=\"display:inline-block;\" (select)=\"menuItemSelected($event)\">\r\n  </kendo-menu>\r\n  <kendo-menu #kendoMenu *ngIf=\"showCheckMargin\" wmControls [hostComponent]=\"this\" [vertical]=\"true\" [items]=\"items\"\r\n    style=\"display:inline-block;\" (select)=\"menuItemSelected($event)\" (keydown)=\"keyDownHandler($event)\">\r\n    <ng-template kendoMenuItemTemplate let-item=\"item\" let-index=\"index\">\r\n      <svg *ngIf=\"isCheckedItem(item)\" xmlns=\"http://www.w3.org/2000/svg\" width=\"7\" height=\"7\" viewBox=\"0 0 24 24\">\r\n        <path d=\"M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z\" />\r\n      </svg>\r\n      <ng-container *ngIf=\"!isMenuItem(item)\">\r\n        {{item.text}}\r\n      </ng-container>\r\n      <wm-toolstrip-menuitem *ngIf=\"isMenuItem(item)\" BelongsToContextMenu=\"true\"\r\n        [model]=\"item\"></wm-toolstrip-menuitem>\r\n    </ng-template>\r\n  </kendo-menu>\r\n</ng-template>", styles: [".popup-server{position:absolute!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3$2.PopupService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: FocusManagerService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { kendoMenu: [{
                type: ViewChild,
                args: ['kendoMenu']
            }], templatePopup: [{
                type: ViewChild,
                args: ['templatePopup', { static: false }]
            }], Opening: [{
                type: Output
            }], Click: [{
                type: Output
            }], ItemClicked: [{
                type: Output
            }], dataUrl: [{
                type: Input
            }], open: [], show: [], menuItemSelected: [], onItemClicked: [] } });

let ColorDialogComponent = class ColorDialogComponent extends DialogBaseComponent {
    /* c8 ignore start */
    constructor(wmservice, refChanges, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(refChanges, renderer2, element, webComponents);
        this.refChanges = refChanges;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /**
         * Settings of kendo color dialog component
         */
        this.settings = {
            opacity: true
        };
        /**
         * Close event emitter of color dialog component
         */
        this.Close = new EventEmitter();
        this.Ok = new EventEmitter();
    }
    /* c8 ignore next */
    ngAfterViewInit() {
        this.kendoColorPicker.toggle();
        this.internalColor = this.color;
        this.detectChanges();
    }
    /**
     * Gets view for the kendo color picker
     */
    get view() {
        return this.model && this.model.FullOpen ? 'gradient' : 'palette';
    }
    /**
     * Gets colorfrom the model
     */
    get color() {
        return this.model?.Color ?? '#ffffff';
    }
    /**
     * Sets color to the model
     */
    set color(value) {
        this.model.Color = value;
    }
    /**
     * Gets FullOpen value from the model
     * @memberof ColorDialogComponent
     */
    get fullOpen() {
        return this.model?.FullOpen ?? false;
    }
    /**
     * Sets FullOpen value
     * @memberof ColorDialogComponent
     */
    set fullOpen(value) {
        this.model.FullOpen = value;
    }
    /**
     * Gets the width of the component. Default value 315
     */
    get width() {
        return this.model.Width ? this.model.Width : 315;
    }
    /**
     * Gets the height of the component. Default value 505
     */
    get height() {
        return this.model.FullOpen ? 430 : 330;
    }
    /**
     * Closes handler
     * @param event
     */
    closeHandler(event) {
        event.preventDefault();
    }
    /**
     * Closes color dialog component
     * @param event
     */
    close(event) {
        this.Close.emit(new EventData$1(event, this.id));
    }
    /**
     * OK action over color dialog component
     * @param event
     */
    ok(event) {
        // This is to send the color only when ok button is pressed
        this.color = this.internalColor;
        this.Ok.emit(new EventData$1(event, this.id));
    }
    /**
     * Active View Change event handler
     * @memberof ColorDialogComponent
     */
    activeViewChangeHandler(event) {
        this.fullOpen = event === 'gradient' ? true : false;
    }
};
ColorDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ColorDialogComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ColorDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ColorDialogComponent, selector: "wm-colordialog", inputs: { model: "model" }, outputs: { Close: "Close", Ok: "Ok" }, viewQueries: [{ propertyName: "kendoColorPicker", first: true, predicate: ["kendoColorpicker"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\">\r\n  <kendo-dialog *ngIf=\"visible\" [width]=\"width\" [height]=\"height\" [ngClass]=\"class\" (close)=\"close($event)\" wmControls\r\n    [hostComponent]=\"this\">\r\n    <kendo-colorpicker #kendoColorpicker [style.width]=\"'300px'\" [activeView]=\"view\" [(value)]=\"internalColor\"\r\n      (close)=\"closeHandler($event)\" [format]=\"'hex'\" [gradientSettings]=\"settings\" [clearButton]=\"true\"\r\n      (activeViewChange)=\"activeViewChangeHandler($event)\">\r\n    </kendo-colorpicker>\r\n    <kendo-dialog-actions>\r\n      <button kendoButton (click)=\"ok($event)\">Ok</button>\r\n      <button kendoButton (click)=\"close($event)\" primary=\"true\">Cancel</button>\r\n    </kendo-dialog-actions>\r\n  </kendo-dialog>\r\n</div>", styles: [".k-dialog-wrapper{z-index:100000}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6$2.Button, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }, { kind: "component", type: i7.DialogComponent, selector: "kendo-dialog", inputs: ["actions", "actionsLayout", "autoFocusedElement", "title", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "animation", "themeColor"], outputs: ["action", "close"], exportAs: ["kendoDialog"] }, { kind: "component", type: i7.DialogActionsComponent, selector: "kendo-dialog-actions", inputs: ["actions", "layout"], outputs: ["action"] }, { kind: "component", type: i8.ColorPickerComponent, selector: "kendo-colorpicker", inputs: ["views", "view", "activeView", "readonly", "disabled", "format", "value", "popupSettings", "paletteSettings", "gradientSettings", "icon", "iconClass", "svgIcon", "clearButton", "tabindex", "preview", "actionsLayout", "size", "rounded", "fillMode"], outputs: ["valueChange", "open", "close", "focus", "blur", "cancel", "activeColorClick", "clearButtonClick", "activeViewChange"], exportAs: ["kendoColorPicker"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    MarkForCheck(),
    NotifyChange('Color'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ColorDialogComponent.prototype, "color", null);
__decorate([
    serverEvent('FormClose'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ColorDialogComponent.prototype, "close", null);
__decorate([
    serverEvent('FormOk'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ColorDialogComponent.prototype, "ok", null);
ColorDialogComponent = __decorate([
    dataTransfer(['clrdlg']),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], ColorDialogComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ColorDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-colordialog', inputs: ['model'], template: "<div *ngIf=\"model\">\r\n  <kendo-dialog *ngIf=\"visible\" [width]=\"width\" [height]=\"height\" [ngClass]=\"class\" (close)=\"close($event)\" wmControls\r\n    [hostComponent]=\"this\">\r\n    <kendo-colorpicker #kendoColorpicker [style.width]=\"'300px'\" [activeView]=\"view\" [(value)]=\"internalColor\"\r\n      (close)=\"closeHandler($event)\" [format]=\"'hex'\" [gradientSettings]=\"settings\" [clearButton]=\"true\"\r\n      (activeViewChange)=\"activeViewChangeHandler($event)\">\r\n    </kendo-colorpicker>\r\n    <kendo-dialog-actions>\r\n      <button kendoButton (click)=\"ok($event)\">Ok</button>\r\n      <button kendoButton (click)=\"close($event)\" primary=\"true\">Cancel</button>\r\n    </kendo-dialog-actions>\r\n  </kendo-dialog>\r\n</div>", styles: [".k-dialog-wrapper{z-index:100000}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { kendoColorPicker: [{
                type: ViewChild,
                args: ['kendoColorpicker']
            }], Close: [{
                type: Output
            }], Ok: [{
                type: Output
            }], color: [], close: [], ok: [] } });

var FileDialogComponent_1;
let FileDialogComponent = FileDialogComponent_1 = class FileDialogComponent extends WMWindowComponent {
    static UploadEventArgsExtractor(event, component) {
        return [
            null,
            {
                FileName: event.args.filename,
                FileNames: event.args.filenames,
                MapperId: 'FileEventArgs'
            }
        ];
    }
    /* c8 ignore start */
    constructor(wmservice, changeDetectorFile, rendererFile, elementRf, webComponents, wmWindowService, windowsManager2) {
        super(wmservice, elementRf, changeDetectorFile, rendererFile, webComponents, windowsManager2, null, null, wmWindowService);
        this.wmservice = wmservice;
        this.changeDetectorFile = changeDetectorFile;
        this.rendererFile = rendererFile;
        this.elementRf = elementRf;
        /* c8 ignore stop */
        /** Output event */
        this.Upload = new EventEmitter();
        this.defaultDataUrl = 'api/openfiledialog';
        /**
         * Url to upload the file
         */
        this.UploadFileUrl = `${this.defaultDataUrl}/UploadFile`;
    }
    getFiles(event) {
        this.fileList = event.target.files;
    }
    /**
     * This upload the file name to the server side
     * using an specialized controller.
     */
    uploadFile() {
        const formData = new FormData();
        if (this.fileList && this.fileList.length > 0) {
            for (const file of this.fileList) {
                formData.append('fileKey', file);
            }
            this.wmservice.post(this.UploadFileUrl, formData).subscribe((data) => {
                if (data.success) {
                    const eventData = new EventData$1('Upload', this.id);
                    eventData.args = {
                        filename: data.filename,
                        filenames: data.filenames
                    };
                    this.triggerUpload(eventData);
                }
            });
        }
    }
    triggerUpload(event) {
        this.Upload.emit(new EventData$1(event, this.id));
    }
    /**
     * Returns the name of the selected file.
     */
    get fileName() {
        return this.fileList[0].name;
    }
    /**
     * Set the name of the selected file
     */
    set fileName(value) {
        this.model.FileName = value;
    }
};
FileDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FileDialogComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: WMWindowService }, { token: WindowsManagerService }], target: i0.ɵɵFactoryTarget.Component });
FileDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: FileDialogComponent, selector: "wm-file-dialog", inputs: { model: "model" }, outputs: { Upload: "Upload" }, providers: [WMWindowService], usesInheritance: true, ngImport: i0, template: "<!-- Block UI Div-->\r\n<div id=\"blockUI\" #blockUI *ngIf=\"dialogModeVisible()\" class=\"modal-overlay\"></div>\r\n<kendo-window [title]=\"text\" *ngIf=\"dialogModeVisible() && !isMdiContainer\" (close)=\"close($event)\" [ngClass]=\"class\">\r\n    <kendo-window-titlebar>\r\n        <div class=\"custom-title-bar\">\r\n            <img src=\"{{icon}}\"\r\n                onerror=\"this.style.display='none'\" width=\"18em\">\r\n            <span class=\"k-window-title\">{{text}}</span>\r\n        </div>\r\n        <button kendoWindowCloseAction></button>\r\n    </kendo-window-titlebar>\r\n    <input type=\"file\" id=\"fileInput\" [accept]=\"model.Filter\" (change)=\"getFiles($event)\"\r\n        [multiple]=\"model.Multiselect\" />\r\n    <button id=\"uploadButton\" kendoButton (click)=\"uploadFile()\" [primary]=\"true\">Upload</button>\r\n</kendo-window>", styles: ["#uploadButton{float:right;margin-top:10px}.fieldset{border-width:1px 1px 1px;border-color:#00000047;border-style:solid;padding-bottom:10px;padding-left:2px}.custom-title-bar{flex:1}.modal-overlay{width:100%;height:100%;position:absolute;overflow:hidden;top:0;left:0;background:rgba(0,0,0,.5)!important}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6$2.Button, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }, { kind: "component", type: i7.WindowComponent, selector: "kendo-window", inputs: ["autoFocusedElement", "title", "draggable", "resizable", "themeColor", "keepContent", "state", "minWidth", "minHeight", "width", "height", "top", "left"], outputs: ["dragStart", "dragEnd", "resizeStart", "resizeEnd", "close", "widthChange", "heightChange", "topChange", "leftChange", "stateChange"], exportAs: ["kendoWindow"] }, { kind: "component", type: i7.WindowCloseActionDirective, selector: "button[kendoWindowCloseAction]", inputs: ["window"], exportAs: ["kendoWindowCloseAction"] }, { kind: "component", type: i7.WindowTitleBarComponent, selector: "kendo-window-titlebar", inputs: ["template", "id"] }] });
__decorate([
    serverEvent('Upload', FileDialogComponent_1.UploadEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FileDialogComponent.prototype, "triggerUpload", null);
FileDialogComponent = FileDialogComponent_1 = __decorate([
    dataTransfer(['ofdg']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        WMWindowService,
        WindowsManagerService])
], FileDialogComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FileDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-file-dialog', inputs: ['model'], providers: [WMWindowService], template: "<!-- Block UI Div-->\r\n<div id=\"blockUI\" #blockUI *ngIf=\"dialogModeVisible()\" class=\"modal-overlay\"></div>\r\n<kendo-window [title]=\"text\" *ngIf=\"dialogModeVisible() && !isMdiContainer\" (close)=\"close($event)\" [ngClass]=\"class\">\r\n    <kendo-window-titlebar>\r\n        <div class=\"custom-title-bar\">\r\n            <img src=\"{{icon}}\"\r\n                onerror=\"this.style.display='none'\" width=\"18em\">\r\n            <span class=\"k-window-title\">{{text}}</span>\r\n        </div>\r\n        <button kendoWindowCloseAction></button>\r\n    </kendo-window-titlebar>\r\n    <input type=\"file\" id=\"fileInput\" [accept]=\"model.Filter\" (change)=\"getFiles($event)\"\r\n        [multiple]=\"model.Multiselect\" />\r\n    <button id=\"uploadButton\" kendoButton (click)=\"uploadFile()\" [primary]=\"true\">Upload</button>\r\n</kendo-window>", styles: ["#uploadButton{float:right;margin-top:10px}.fieldset{border-width:1px 1px 1px;border-color:#00000047;border-style:solid;padding-bottom:10px;padding-left:2px}.custom-title-bar{flex:1}.modal-overlay{width:100%;height:100%;position:absolute;overflow:hidden;top:0;left:0;background:rgba(0,0,0,.5)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: WMWindowService }, { type: WindowsManagerService }]; }, propDecorators: { Upload: [{
                type: Output
            }], triggerUpload: [] } });

let PrintDialogComponent = class PrintDialogComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
    }
    /* c8 ignore stop */
    ngAfterViewInit() {
        this.printDialog();
    }
    printDialog() {
        const doc = window;
        doc.print();
    }
};
PrintDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PrintDialogComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
PrintDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: PrintDialogComponent, selector: "wm-print-dialog", inputs: { model: "model" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model && visible\"></div>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
PrintDialogComponent = __decorate([
    dataTransfer(['prtdg']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], PrintDialogComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PrintDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-print-dialog', inputs: ['model'], template: "<div *ngIf=\"model && visible\"></div>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; } });

let WebBrowserComponent = class WebBrowserComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, sanitizer, renderer2, element, webComponents, bringTopServ, containerInteraction, tabOrderService) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.sanitizer = sanitizer;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.tabOrderService = tabOrderService;
        this.currentURL = this.sanitizer.bypassSecurityTrustResourceUrl('');
        this.currentSrcDoc = null;
        this.internalUrl = '';
    }
    /* c8 ignore stop */
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /**
     * This function uses DomSanitizer that is an Angular class that brings functions that help preventing
     * the Cross Site Scripting (XSS).
     * url : https://angular.io/api/platform-browser/DomSanitizer
     * The function bypassSecurityTrustResourceUrl returns a save object that contains url validated by
     * DomSanitizer.
     */
    getUrl() {
        if (this.refresh ||
            (this.model.Url !== undefined && this.model.Url !== this.internalUrl)) {
            this.internalUrl = this.model.Url;
            this.currentURL = this.goUrl();
            this.applySrcDoc();
            this.refresh = false;
            this.markForCheck();
        }
    }
    /**
     * Returns an url validated by angular sanitizer to avoid cross site scripting
     * @returns url validated
     */
    goUrl() {
        return this.model.Url
            ? this.sanitizer.bypassSecurityTrustResourceUrl(this.model.Url)
            : this.sanitizer.bypassSecurityTrustResourceUrl('');
    }
    /**
     * Returns a document validated by angular sanitizer to avoid cross site scripting
     * @returns HTML document validated
     */
    goSrcDoc() {
        return this.model.DocumentText && this.model.DocumentText.length > 0
            ? this.sanitizer.bypassSecurityTrustHtml(this.model.DocumentText)
            : null;
    }
    ngDoCheck() {
        super.ngDoCheck();
        const targetUrl = this.isUrl(this.model.Url)
            ? `${this.model.Url}`
            : `${window.location}/${this.model.Url}`;
        if (this.openFile) {
            window.open(targetUrl);
            this.openFile = false;
        }
        this.getUrl();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.markForCheck();
    }
    ngOnInit() {
        this.applySrcDoc();
    }
    /**
     * Get the OpenFile property value
     */
    get openFile() {
        return this.model.OpenFile;
    }
    /**
     * Set the OpenFile ExpandedKeys property value
     */
    set openFile(value) {
        this.model.OpenFile = value;
    }
    /**
     * Determines if the url is a URL or a file path
     */
    isUrl(url) {
        const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        return regexp.test(url);
    }
    /**
     * Applies the srcDoc value to the iframe srcdoc property.
     */
    applySrcDoc() {
        this.currentSrcDoc = this.goSrcDoc();
    }
};
WebBrowserComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebBrowserComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1$1.DomSanitizer }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService, optional: true }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: MainTabOrderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
WebBrowserComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: WebBrowserComponent, selector: "wm-webbrowser", inputs: { model: "model" }, viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #displayElement *ngIf=\"model && visible\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\" tabindex=\"-1\">\r\n    <iframe *ngIf=\"currentSrcDoc\" [src]=\"currentURL\" [srcdoc]=\"currentSrcDoc\"></iframe>\r\n    <iframe *ngIf=\"!currentSrcDoc\" [src]=\"currentURL\"></iframe>\r\n</div>", styles: ["iframe{width:calc(100% - 10px);height:calc(100% - 10px);position:absolute}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    NotifyChange('OpenFile'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], WebBrowserComponent.prototype, "openFile", null);
WebBrowserComponent = __decorate([
    dataTransfer(['webbwr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        DomSanitizer,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService,
        MainTabOrderService])
], WebBrowserComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebBrowserComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-webbrowser', inputs: ['model'], template: "<div #displayElement *ngIf=\"model && visible\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\" tabindex=\"-1\">\r\n    <iframe *ngIf=\"currentSrcDoc\" [src]=\"currentURL\" [srcdoc]=\"currentSrcDoc\"></iframe>\r\n    <iframe *ngIf=\"!currentSrcDoc\" [src]=\"currentURL\"></iframe>\r\n</div>", styles: ["iframe{width:calc(100% - 10px);height:calc(100% - 10px);position:absolute}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$1.DomSanitizer }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: MainTabOrderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], openFile: [] } });

var CheckedListBoxComponent_1;
/**
 * ListBox Component this is an Angular Kendo jquery component .
 */
let CheckedListBoxComponent = CheckedListBoxComponent_1 = class CheckedListBoxComponent extends ListBoxBaseComponent {
    /**
     * Binded functions are declared here.
     */
    /* c8 ignore start */
    constructor(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1, tabOrderService) {
        super(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1);
        this.serviceRef = serviceRef;
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        this.tabOrderService = tabOrderService;
        /* c8 ignore stop */
        /**
         * This is a template with the html structure of a checkedlistbox
         */
        this.customerTemplate = kendo.format('<div class="k-checkbox-div"><label class="k-checkbox-label"><input  class="k-checkbox" id="#:value#" type="checkbox" >#: text #  </label></div>');
        this.defaultDataUrl = 'api/checkedlistbox';
        /**
         * Emit SelectedValueChanged event
         */
        this.SelectedValueChanged = new EventEmitter();
        /**
         * Emit SelectedIndexChanged event
         */
        this.SelectedIndexChanged = new EventEmitter();
        /**
         * Emit ItemCheck event
         */
        this.ItemCheck = new EventEmitter();
        this.selectionChange = this.selectionChange.bind(this);
        this.itemCheck = this.itemCheck.bind(this);
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.fetchItems();
    }
    ngAfterViewChecked() {
        this.focusElement = this.getFocusableElement();
        super.ngAfterViewChecked();
    }
    /**
     * Gets display element retrieving the k-listbox element from kendo listbox JQuery widget
     * @returns HTML display element or undefined if element is not rendered
     */
    getDisplayElement() {
        if (this.elem && this.elem.nativeElement) {
            return this.elem.nativeElement.querySelector('.k-listbox');
        }
        return undefined;
    }
    /**
     * Returns the element that is going to receive the focus.
     */
    getFocusableElement() {
        if (this.elem && this.elem.nativeElement) {
            return this.elem.nativeElement.querySelector('.k-list');
        }
        return undefined;
    }
    /**
     * Overrides applyFocus method from Control component to
     * properly focus the element.
     */
    applyFocus() {
        if (this.focusElement) {
            this.isApplyingFocus = true;
            this.focusElement.focus();
            this.isApplyingFocus = false;
        }
    }
    /**
     * Gets a value indicating whether the button should toggle its pressed state when it is clicked.
     */
    get checkOnClick() {
        return this.model.CheckOnClick;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /* c8 ignore next */
    ngDoCheck() {
        super.ngDoCheck();
        if (this.refresh) {
            this.fetchItems();
            this.refresh = false;
            this.refreshSelectedIndices = false;
            this.refreshCheckedIndices = false;
        }
        if (this.refreshSelectedIndices) {
            this.setSelected();
            this.refreshSelectedIndices = false;
        }
        if (this.refreshCheckedIndices) {
            this.updateKendoCheckListBox();
            this.refreshCheckedIndices = false;
        }
    }
    /**
     *  Query checkedListbx data
     * @property Items r
     */
    fetchItems() {
        this.serviceRef
            .fetch(this.url, this.id)
            .subscribe((fetch) => {
            this.items = new ObjectCollection(fetch);
            this.listboxEl['widget'].setDataSource(this.items);
            this.itemCheck();
            this.disabledKendo();
            this.updateKendoCheckListBox();
            this.setSelected();
            this.isInitializing = false;
        });
    }
    /**
     * Change event of checkboxes
     */
    itemCheck() {
        kendo
            .jQuery(this.listboxEl['widget'].wrapper)
            .find('.k-checkbox')
            .change((event) => {
            this.checkedIndices = this.getCheckedIndices(event);
            this.TriggerItemCheck(event);
            this.TriggerSelectedValueChanged(event);
            this.TriggerSelectedIndexChanged(event);
        });
        kendo
            .jQuery(this.listboxEl['widget'].wrapper)
            .find('.k-checkbox-label')
            .click((event) => {
            /* c8 ignore else */
            if (event.target.tagName === 'LABEL' && !this.checkOnClick) {
                this.TriggerSelectedValueChanged(event);
                this.TriggerSelectedIndexChanged(event);
                event.preventDefault();
            }
        });
    }
    /**
     * Set the array of CheckedIndices
     * @param indexes The indices
     */
    set checkedIndices(indexes) {
        this.model.CheckedIndices = indexes;
    }
    /**
     * Get the array of CheckedIndices
     */
    get checkedIndices() {
        return this.model.CheckedIndices;
    }
    get refreshCheckedIndices() {
        return this.model.RefreshCheckedIndices;
    }
    set refreshCheckedIndices(value) {
        this.model.RefreshCheckedIndices = value;
    }
    /**
     * Retrieve an array CheckedIndices
     */
    getCheckedIndices(obj) {
        const auxArray = [];
        const checkboxes = kendo
            .jQuery(this.elem.nativeElement)
            .find('input.k-checkbox');
        checkboxes.each((i, v) => {
            if (v.checked) {
                auxArray.push(i);
            }
        });
        return auxArray;
    }
    /**
     * Retrieve the index of the checked item
     */
    getCheckedIndex(obj) {
        let index = 0;
        const checkboxes = kendo
            .jQuery(this.elem.nativeElement)
            .find('input.k-checkbox');
        checkboxes.each((i, v) => {
            if (v.id == obj.target.id) {
                index = i;
            }
        });
        return index;
    }
    /**
     * Sets CheckState for the item at the specified checkedIndices to Checked.
     */
    updateKendoCheckListBox() {
        if (this.checkedIndices) {
            const checkboxes = kendo
                .jQuery(this.elem.nativeElement)
                .find('input.k-checkbox');
            checkboxes.each((index, element) => {
                element.checked = this.checkedIndices.indexOf(index) > -1;
            });
        }
    }
    /**
     *
     *
     * @param {number} itemIndex
     * @param {boolean} check
     * @return {*}
     * @memberof CheckedListBoxComponent
     */
    setItemChecked(itemIndex, check) {
        if (this.items.count < itemIndex || itemIndex < 0) {
            return;
        }
        const indexFound = this.findCheckedIndex(itemIndex);
        const indices = this.checkedIndices;
        if (indexFound === -1 && check) {
            indices.push(itemIndex);
        }
        if (indexFound > -1 && !check) {
            indices.splice(indexFound, 1);
        }
        this.checkedIndices = indices;
        this.updateKendoCheckListBox();
    }
    /**
     * It returns the index of the element checked inside the CheckedIndices array
     * Also if the checked indices is undefined it initializes the array
     *
     * @param {number} itemIndex
     * @return {*}  {number}
     * @memberof CheckedListBoxComponent
     */
    findCheckedIndex(itemIndex) {
        if (!this.model.CheckedIndices) {
            this.checkedIndices = [];
            return -1;
        }
        else {
            return this.model.CheckedIndices.findIndex((index) => index === itemIndex);
        }
    }
    /**
     It's  return a boolean is true if the itemIndex is check
     It's false when not exist item checked
     *
     * @param {number} index
     * @return {boolean}
     * @memberof CheckedListBoxComponent
     */
    getItemChecked(itemIndex) {
        const checkedIndices = this.model.CheckedIndices;
        if (checkedIndices && checkedIndices.length > 0 && itemIndex >= 0) {
            return checkedIndices.some((indexCheck) => indexCheck === itemIndex);
        }
        else {
            return false;
        }
    }
    /**
     *
     * @param event Handles the item check event.
     * @param component CheckedListBox
     * @returns index, new value and current value of the selected checkbox.
     */
    static ItemCheckEventArgsExtractor(event, component) {
        return [
            { Id: component.id, MapperId: 'checkedLstBx' },
            {
                MapperId: 'ItemCheckEventArgs',
                Index: component.getCheckedIndex(event),
                NewValue: event.target.checked
                    ? CheckState$1.Checked
                    : CheckState$1.Unchecked,
                CurrentValue: !event.target.checked
                    ? CheckState$1.Checked
                    : CheckState$1.Unchecked
            }
        ];
    }
    TriggerSelectedValueChanged(event) {
        this.SelectedValueChanged.emit(new EventData$1(event, this.id));
    }
    TriggerSelectedIndexChanged(event) {
        this.SelectedIndexChanged.emit(new EventData$1(event, this.id));
    }
    TriggerItemCheck(event) {
        this.ItemCheck.emit(new EventData$1(event, this.id));
    }
};
CheckedListBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CheckedListBoxComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: MainTabOrderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
CheckedListBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: CheckedListBoxComponent, selector: "wm-checkedlistbox", inputs: { model: "model" }, outputs: { SelectedValueChanged: "SelectedValueChanged", SelectedIndexChanged: "SelectedIndexChanged", ItemCheck: "ItemCheck" }, viewQueries: [{ propertyName: "listboxEl", first: true, predicate: ["checkedlistbox"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\" [ngStyle]=\"setMyStyle()\">\r\n  <select #checkedlistbox [model]=\"model\" (focus)=\"focus($event)\" data-role=\"listbox\" [bound]=\"{\r\n      disabled: enabled,\r\n      draggable: draggable,\r\n      selectable: selectionMode(),\r\n      template: customerTemplate\r\n    }\"></select>\r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: KendoListBoxComponent, selector: "[data-role=listbox]", inputs: ["model", "bound", "role"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('CheckedIndices'),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], CheckedListBoxComponent.prototype, "checkedIndices", null);
__decorate([
    MarkForCheck(),
    NotifyChange('RefreshCheckedIndices'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], CheckedListBoxComponent.prototype, "refreshCheckedIndices", null);
__decorate([
    serverEvent('SelectedValueChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CheckedListBoxComponent.prototype, "TriggerSelectedValueChanged", null);
__decorate([
    serverEvent('SelectedIndexChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CheckedListBoxComponent.prototype, "TriggerSelectedIndexChanged", null);
__decorate([
    serverEvent('ItemCheck', CheckedListBoxComponent_1.ItemCheckEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CheckedListBoxComponent.prototype, "TriggerItemCheck", null);
CheckedListBoxComponent = CheckedListBoxComponent_1 = __decorate([
    dataTransfer(['checkedLstBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        MainTabOrderService])
], CheckedListBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CheckedListBoxComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-checkedlistbox', inputs: ['model'], template: "<div *ngIf=\"model\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\" [ngStyle]=\"setMyStyle()\">\r\n  <select #checkedlistbox [model]=\"model\" (focus)=\"focus($event)\" data-role=\"listbox\" [bound]=\"{\r\n      disabled: enabled,\r\n      draggable: draggable,\r\n      selectable: selectionMode(),\r\n      template: customerTemplate\r\n    }\"></select>\r\n</div>" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: MainTabOrderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { listboxEl: [{
                type: ViewChild,
                args: ['checkedlistbox', { static: false }]
            }], SelectedValueChanged: [{
                type: Output
            }], SelectedIndexChanged: [{
                type: Output
            }], ItemCheck: [{
                type: Output
            }], checkedIndices: [], refreshCheckedIndices: [], TriggerSelectedValueChanged: [], TriggerSelectedIndexChanged: [], TriggerItemCheck: [] } });

var ThreadExceptionDialogOptions;
(function (ThreadExceptionDialogOptions) {
    ThreadExceptionDialogOptions[ThreadExceptionDialogOptions["displayContinue"] = 1] = "displayContinue";
    ThreadExceptionDialogOptions[ThreadExceptionDialogOptions["displayDetails"] = 2] = "displayDetails";
    ThreadExceptionDialogOptions[ThreadExceptionDialogOptions["displayHelp"] = 4] = "displayHelp";
    ThreadExceptionDialogOptions[ThreadExceptionDialogOptions["displayQuit"] = 8] = "displayQuit";
})(ThreadExceptionDialogOptions || (ThreadExceptionDialogOptions = {}));
let ThreadexceptiondialogComponent = class ThreadexceptiondialogComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(wmservice, refChanges, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(refChanges, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.refChanges = refChanges;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        this.showDetails = false;
        this.webServices = wmservice;
    }
    click(event, actionName) {
        this.webServices.invoke(new SendV5(this, actionName, this.model.UniqueID, actionName));
    }
    showDetailsPanel() {
        this.showDetails = !this.showDetails;
    }
    showHelp() {
        // Pending Implementation
    }
    get buttonContinue() {
        if (this.model && this.model.Buttons) {
            // tslint:disable-next-line:no-bitwise
            return ((this.model.Buttons & ThreadExceptionDialogOptions.displayContinue) ===
                ThreadExceptionDialogOptions.displayContinue);
        }
        return false;
    }
    get buttonDetails() {
        if (this.model && this.model.Buttons) {
            // tslint:disable-next-line:no-bitwise
            return ((this.model.Buttons & ThreadExceptionDialogOptions.displayDetails) ===
                ThreadExceptionDialogOptions.displayDetails);
        }
        return false;
    }
    get buttonHelp() {
        if (this.model && this.model.Buttons) {
            // tslint:disable-next-line:no-bitwise
            return ((this.model.Buttons & ThreadExceptionDialogOptions.displayHelp) ===
                ThreadExceptionDialogOptions.displayHelp);
        }
        return false;
    }
    get buttonQuit() {
        if (this.model && this.model.Buttons) {
            // tslint:disable-next-line:no-bitwise
            return ((this.model.Buttons & ThreadExceptionDialogOptions.displayQuit) ===
                ThreadExceptionDialogOptions.displayQuit);
        }
        return false;
    }
    get labelMessage() {
        if (this.model && this.model.Message) {
            return this.model.Message;
        }
        return '';
    }
    get labelDetails() {
        if (this.model && this.model.Details) {
            return this.model.Details;
        }
        return '';
    }
    get width() {
        return 600;
    }
};
ThreadexceptiondialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ThreadexceptiondialogComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ThreadexceptiondialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ThreadexceptiondialogComponent, selector: "wm-threadexceptiondialog", inputs: { model: "model" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\">    \r\n    <kendo-dialog [title]=\"text\" *ngIf=\"visible\" [width]=\"width\" height=\"auto\" [ngClass] =\"class\">\r\n      <div class=\"divhoz\">\r\n        <div style=\"vertical-align:top; width:15%; min-width: 60px; text-align: center;\">\r\n            <i class=\"material-icons md-64 error icon \">&#xE000;</i>\r\n        </div>\r\n        <div class=\"ex-lbl-message\">\r\n          <p>{{labelMessage}}</p>\r\n        </div>\r\n      </div>\r\n      <div class=\"ex-btn-container\">\r\n        <button class=\"ex-btn-details k-button\" (click)=\"showDetailsPanel()\" *ngIf=\"buttonDetails\">\r\n            <i class=\"material-icons\" *ngIf=\"!showDetails\">&#xE5C5;</i>\r\n            <i class=\"material-icons\" *ngIf=\"showDetails\">&#xE5C7;</i>\r\n            Details\r\n        </button>\r\n        <button class=\"ex-btn-help k-button\" (click)=\"showHelp()\" *ngIf=\"buttonHelp\">Help</button>\r\n        <button class=\"ex-btn-continue k-button\" (click)=\"click($event, 'Continue')\" *ngIf=\"buttonContinue\">Continue</button>          \r\n        <button class=\"ex-btn-quit k-button\" (click)=\"click($event, 'Quit')\" *ngIf=\"buttonQuit\">Quit</button>            \r\n      </div>\r\n      <textarea readonly class=\"details\" *ngIf=\"showDetails\">{{labelDetails}}</textarea>\r\n    </kendo-dialog>    \r\n  </div>", styles: ["kendo-dialog{z-index:100000}kendo-dialog .k-dialog-actions{visibility:hidden}.divhoz{padding:1em}.divhoz>div{display:inline-block}.details{width:95%;height:200px;margin-top:5px;margin-bottom:10px;margin-left:10px}.material-icons.md-64{font-size:64px}.material-icons.error{color:red}.ex-lbl-message{width:80%}.ex-lbl-message>p{white-space:pre-wrap}.ex-btn-container{transform:translateY(-1px) translate(-1px);height:40px;margin-left:10px;margin-right:10px}.ex-btn-details{width:24%;height:35px;position:absolute;left:0%}.ex-btn-help{width:24%;height:35px;position:absolute;left:25%}.ex-btn-continue{width:24%;height:35px;position:absolute;left:50%}.ex-btn-quit{width:24%;height:35px;position:absolute;left:75%}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7.DialogComponent, selector: "kendo-dialog", inputs: ["actions", "actionsLayout", "autoFocusedElement", "title", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "animation", "themeColor"], outputs: ["action", "close"], exportAs: ["kendoDialog"] }] });
ThreadexceptiondialogComponent = __decorate([
    dataTransfer(['thrdxcptndlg']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], ThreadexceptiondialogComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ThreadexceptiondialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-threadexceptiondialog', inputs: ['model'], template: "<div *ngIf=\"model\">    \r\n    <kendo-dialog [title]=\"text\" *ngIf=\"visible\" [width]=\"width\" height=\"auto\" [ngClass] =\"class\">\r\n      <div class=\"divhoz\">\r\n        <div style=\"vertical-align:top; width:15%; min-width: 60px; text-align: center;\">\r\n            <i class=\"material-icons md-64 error icon \">&#xE000;</i>\r\n        </div>\r\n        <div class=\"ex-lbl-message\">\r\n          <p>{{labelMessage}}</p>\r\n        </div>\r\n      </div>\r\n      <div class=\"ex-btn-container\">\r\n        <button class=\"ex-btn-details k-button\" (click)=\"showDetailsPanel()\" *ngIf=\"buttonDetails\">\r\n            <i class=\"material-icons\" *ngIf=\"!showDetails\">&#xE5C5;</i>\r\n            <i class=\"material-icons\" *ngIf=\"showDetails\">&#xE5C7;</i>\r\n            Details\r\n        </button>\r\n        <button class=\"ex-btn-help k-button\" (click)=\"showHelp()\" *ngIf=\"buttonHelp\">Help</button>\r\n        <button class=\"ex-btn-continue k-button\" (click)=\"click($event, 'Continue')\" *ngIf=\"buttonContinue\">Continue</button>          \r\n        <button class=\"ex-btn-quit k-button\" (click)=\"click($event, 'Quit')\" *ngIf=\"buttonQuit\">Quit</button>            \r\n      </div>\r\n      <textarea readonly class=\"details\" *ngIf=\"showDetails\">{{labelDetails}}</textarea>\r\n    </kendo-dialog>    \r\n  </div>", styles: ["kendo-dialog{z-index:100000}kendo-dialog .k-dialog-actions{visibility:hidden}.divhoz{padding:1em}.divhoz>div{display:inline-block}.details{width:95%;height:200px;margin-top:5px;margin-bottom:10px;margin-left:10px}.material-icons.md-64{font-size:64px}.material-icons.error{color:red}.ex-lbl-message{width:80%}.ex-lbl-message>p{white-space:pre-wrap}.ex-btn-container{transform:translateY(-1px) translate(-1px);height:40px;margin-left:10px;margin-right:10px}.ex-btn-details{width:24%;height:35px;position:absolute;left:0%}.ex-btn-help{width:24%;height:35px;position:absolute;left:25%}.ex-btn-continue{width:24%;height:35px;position:absolute;left:50%}.ex-btn-quit{width:24%;height:35px;position:absolute;left:75%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * AfterValueChangedDirective Class manage afterValueChanged event and property bindings.
 */
class AfterValueChangedDirective {
    /**
     * the events subscription.
     *
     * @private
     * @type {Subscription}
     * @memberof AfterValueChangedDirective
     */
    constructor() {
        /**
         * Emits afterValueChanged event.
         *
         * @type {EventEmitter<any>}
         * @memberof AfterValueChangedDirective
         */
        this.afterValueChanged = new EventEmitter();
    }
    /**
     * Occurs when the value changes.
     */
    onRichTextBoxChange(event) {
        this.afterValueChanged.emit(event);
    }
}
AfterValueChangedDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AfterValueChangedDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
AfterValueChangedDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: AfterValueChangedDirective, selector: "[afterValueChanged]", outputs: { afterValueChanged: "afterValueChanged" }, host: { listeners: { "keyup": "onRichTextBoxChange($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AfterValueChangedDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[afterValueChanged]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { afterValueChanged: [{
                type: Output
            }], onRichTextBoxChange: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

var RichtextboxComponent_1;
let RichtextboxComponent = RichtextboxComponent_1 = class RichtextboxComponent extends TextBoxBaseComponent {
    /* c8 ignore start */
    constructor(changeDetector, service, renderer1, element1, webComponents, bringTopService1, containerInteraction) {
        super(changeDetector, renderer1, element1, webComponents, bringTopService1, containerInteraction);
        this.changeDetector = changeDetector;
        this.service = service;
        this.renderer1 = renderer1;
        this.element1 = element1;
        this.bringTopService1 = bringTopService1;
        this.containerInteraction = containerInteraction;
        /**
         * Default richtextbox API name.
         *
         * @private
         * @memberof RichtextboxComponent
         */
        this.defaultUrl = 'api/richtextbox';
        /**
         * Property to save the debounceTime.
         *
         * @private
         * @memberof RichtextboxComponent
         */
        this.richTextBoxChangeDelay = 500;
        /**
         * Url to get the html content.
         *
         * @memberof RichtextboxComponent
         */
        this.getHtmlContentUrl = `${this.defaultUrl}/GetHtmlContent`;
        /**
         * Emmits TextChanged event.
         *
         * @type {EventEmitter<EventData>}
         * @memberof RichtextboxComponent
         */
        this.TextChanged = new EventEmitter();
        /**
         * Output to emit the event Richtextbox.
         *
         * @type {EventEmitter<EventData>}
         * @memberof RichtextboxComponent
         */
        this.RichTextBoxChanged = new EventEmitter();
        this.refreshSubscription = this.service.core
            .getEvent()
            .subscribe('funRefresh', (show) => {
            this.funRefresh();
        });
        changeDetector.markForCheck();
    }
    set htmlText(value) {
        this.HTMLcontentMirror = value;
        this.model.HtmlText = value;
    }
    /**
     * RichTextBoxChanged extractor.
     *
     * @static
     * @param {*} event
     * @param {RichtextboxComponent} component
     * @return {*}  {*}
     * @memberof RichtextboxComponent
     */
    static RichTextBoxChangedExtractor(htmlValue, component) {
        return [
            {
                Id: component.id,
                MapperId: RichtextboxComponent_1.RichTextBoxMapperId
            },
            {
                MapperId: RichtextboxComponent_1.RichTextBoxChangedMapperId,
                HtmlValue: htmlValue
            }
        ];
    }
    /**
     * OnInit lifecycle hook.
     *
     * @memberof RichtextboxComponent
     */
    ngOnInit() {
        super.ngOnInit();
        this.loadRtfHtmlValue();
        this.refresh = false;
    }
    /**
     * AfterViewInit lifecycle hook.
     *
     * @memberof RichtextboxComponent
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.addToolbarStateSubscription();
    }
    /**
     * Adds the toolbar state subscription to keep the state updated in every change.
     *
     * @memberof RichtextboxComponent
     */
    addToolbarStateSubscription() {
        this.toolbarStateSubscription = this.kendoEditor?.stateChange.subscribe((toolbarState) => {
            this.toolbarState = toolbarState;
        });
    }
    /**
     * Occurs when the Text property value changes.
     *
     * @param {*} value
     * @memberof RichtextboxComponent
     */
    onRichTextBoxChange(value) {
        if (this.HTMLcontentMirror !== value) {
            this.htmlText = value;
        }
    }
    /**
     * Handler for the richtextbox value change.
     *
     * @param {*} value
     * @memberof RichtextboxComponent
     */
    onRichTextBoxKeyUp(event) {
        const value = event.target.innerHTML;
        this.updateSelect();
        if (this.HTMLcontentMirror !== value) {
            this.htmlText = value;
            this.valueChangedCallback = () => {
                this.richTextBoxChangedEventHandler(value);
            };
            clearTimeout(this.valueChangedTimerId);
            this.valueChangedTimerId = setTimeout(this.valueChangedCallback, this.richTextBoxChangeDelay);
        }
        this.modified = true;
        super.keyUp(event);
    }
    /**
     * RichTextBoxChangedEventHandler emitter.
     *
     * @param {*} value
     * @memberof RichtextboxComponent
     */
    richTextBoxChangedEventHandler(value) {
        this.RichTextBoxChanged.emit(new EventData$1(value, this.id));
    }
    /*
     * Checks if a Refresh is required
     */
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore else */
        if (this.refresh) {
            this.loadRtfHtmlValue();
            this.refresh = false;
        }
    }
    /**
     * Execute the detectChanges() function on the subscription of the detectChanges,
     * this subscription is in the control.component.ts WinForms
     */
    detectChangesExecution() {
        this.detectChanges();
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * Gets/sets the selection alignment property.
     *
     * @readonly
     * @type {HorizontalAlignment}
     * @memberof RichtextboxComponent
     */
    get selectionAlignment() {
        /* c8 ignore else */
        if (this.kendoEditor) {
            /* c8 ignore else */
            if (isAligned(this.kendoEditor.view.state, alignCenterRules)) {
                return HorizontalAlignment.Center;
            }
            /* c8 ignore else */
            if (isAligned(this.kendoEditor.view.state, alignRightRules)) {
                return HorizontalAlignment.Right;
            }
        }
        return HorizontalAlignment.Left;
    }
    set selectionAlignment(value) {
        this.model.SelectionAlignment = value;
        this.updateSelectionAlignment(value);
    }
    /**
     * Returns the selection alignment with the correct text align format.
     *
     * @readonly
     * @type {string}
     * @memberof RichtextboxComponent
     */
    get textAlignValue() {
        /* c8 ignore else */
        if (this.model.BorderStyle !== BorderStyle.FixedSingle) {
            return HorizontalAlignment[this.selectionAlignment];
        }
    }
    /**
     * Gets/sets the selection color property.
     *
     * @readonly
     * @type {string}
     * @memberof RichtextboxComponent
     */
    get selectionColor() {
        const from = this.kendoEditor?.view.state.selection.from;
        const to = this.kendoEditor?.view.state.selection.to;
        let color = 'black';
        let marks;
        /* c8 ignore next */
        if (from && to) {
            this.kendoEditor?.view.state.tr.doc.nodesBetween(from, to, (node, pos, parent) => {
                marks = node.marks;
            });
            for (const mark of marks) {
                if (mark?.attrs?.style.includes('color')) {
                    const initPos = mark.attrs.style.indexOf('color:') + 'color:'.length;
                    const endPos = mark.attrs.style.indexOf(';');
                    color = mark.attrs.style.substring(initPos, endPos);
                }
            }
        }
        return color.trim().toLowerCase();
    }
    set selectionColor(value) {
        this.model.SelectionColor = value;
        // The kendoEditor foreColor command supports string, hex and RGB values.
        this.kendoEditor?.exec(KendoEditorCommand.foreColor, value);
    }
    /**
     * Gets/sets the border style property.
     *
     * @readonly
     * @type {BorderStyle}
     * @memberof RichtextboxComponent
     */
    get borderStyle() {
        return this.model.BorderStyle ?? BorderStyle.Fixed3D;
    }
    set borderStyle(value) {
        this.model.BorderStyle = value;
    }
    /**
     * Returns the class name to be used for the border styles.
     *
     * @return {*}  {string}
     * @memberof RichtextboxComponent
     */
    getBorderStyleClass() {
        return `${BorderStyle[this.borderStyle].toLowerCase()}Border`;
    }
    /**
     * Gets/sets the selected text property.
     *
     * @readonly
     * @type {string}
     * @memberof RichtextboxComponent
     */
    get selectedText() {
        return getSelection().toString();
    }
    set selectedText(value) {
        this.model.SelectedText = value;
    }
    /**
     * Gets/sets the wordwrap property.
     *
     * @readonly
     * @type {boolean}
     * @memberof RichtextboxComponent
     */
    get wordWrap() {
        return this.model.WordWrap === false ? false : true;
    }
    set wordWrap(value) {
        this.model.WordWrap = value;
    }
    /**
     * Returns the correct wordwrap class.
     *
     * @return {*}  {string}
     * @memberof RichtextboxComponent
     */
    getWordWrapClass() {
        return this.wordWrap ? 'wordwrap' : '';
    }
    /**
     * Gets/sets the readOnly property.
     *
     * @readonly
     * @type {boolean}
     * @memberof RichtextboxComponent
     */
    get readOnly() {
        return this.model.ReadOnly === true ? true : false;
    }
    set readOnly(value) {
        this.model.ReadOnly = value;
    }
    /**
     * Gets/sets the scroll bars property.
     *
     * @readonly
     * @type {RichTextBoxScrollBars}
     * @memberof RichtextboxComponent
     */
    get scrollBars() {
        return this.model.ScrollBars ?? RichTextBoxScrollBars.Both;
    }
    set scrollBars(value) {
        this.model.ScrollBars = value;
    }
    /**
     * Return the correct scrollbars class.
     *
     * @return {*}  {string}
     * @memberof RichtextboxComponent
     */
    getScrollBarsClass() {
        return `${RichTextBoxScrollBars[this.scrollBars].toLocaleLowerCase()}ScrollBars`;
    }
    /**
     * Loads the HTML value to be rendered in the editor.
     *
     * @memberof RichtextboxComponent
     */
    loadRtfHtmlValue() {
        this.service
            .fetch(this.getHtmlContentUrl, this.id)
            .subscribe((data) => {
            this.HTMLcontent = data.HTML;
            this.HTMLcontentMirror = data.HTML;
            this.detectChanges();
            this.removeTheDIVInsideOfProseMirrorDIV();
            this.detectChanges();
        });
    }
    /**
     * this method is used for delete the html div that exist
     * Inside proseMirror Div. We remove this DIV for calculated
     * the rigth selectionStart, with this DIV our ecuation to
     * calculate selection start is not working rigth.
     *
     * @return {*}
     * @memberof RichtextboxComponent
     */
    /* c8 ignore next */
    removeTheDIVInsideOfProseMirrorDIV() {
        //↓↓↓ Get the only one ProseMirror to extract the DIV inside it for remove
        const proseMirrorElement = this.element1.nativeElement.querySelector('.ProseMirror');
        const firstDivToRemove = proseMirrorElement.querySelector('div');
        //↓↓↓ in this part avoid remove the first DIV because is empty.
        if (firstDivToRemove?.children.length === 0) {
            return;
        }
        //↓↓↓ if exist the DIV so remove it, save the html existing.
        if (firstDivToRemove) {
            proseMirrorElement.style.cssText = firstDivToRemove.style.cssText;
            const htmlWithOutDiv = firstDivToRemove.innerHTML;
            firstDivToRemove.remove();
            proseMirrorElement.innerHTML = htmlWithOutDiv; // nosemgrep
        }
    }
    /**
     * this return the selectionStart Property from kendo
     *
     * @return {*}  {number}
     * @memberof RichtextboxComponent
     */
    calculateSelectionStart() {
        if (this.kendoEditor) {
            const { $from } = this.kendoEditor.view.state.selection;
            const depth = $from.depth;
            // ↓↓↓ the array path has one position that offer the breakline number
            //↓↓↓ but the position change depend the depth, for this reason use
            // ↓↓↓ reverse to keep the same position always to get the value
            let pathCopy = [...($from['path'] ?? [])];
            pathCopy = pathCopy.reverse();
            const numBreakLinesToRemove = pathCopy[4] ?? 0;
            const selectionFrom = this.text === ''
                ? 0
                : this.kendoEditor.view.state.selection.from - depth;
            return selectionFrom - numBreakLinesToRemove ?? 0;
        }
        else {
            return 0;
        }
    }
    /**
     * Gets/sets the selection start property.
     *
     * @readonly
     * @type {number}
     * @memberof RichtextboxComponent
     */
    get selectionStart() {
        return this.model.SelectionStart;
    }
    set selectionStart(value) {
        this.model.SelectionStart = value;
    }
    /**
     * this return the selectionStart Property from kendo
     *
     * @return {*}  {number}
     * @memberof RichtextboxComponent
     */
    calculateSelectionLength() {
        const from = this.kendoEditor?.view.state.selection.from;
        const to = this.kendoEditor?.view.state.selection.to;
        return to - from ? to - from : 0;
    }
    /**
     * Gets/sets the selection length property.
     *
     * @readonly
     * @type {number}
     * @memberof RichtextboxComponent
     */
    get selectionLength() {
        return this.model.SelectionLength;
    }
    set selectionLength(value) {
        this.model.SelectionLength = value;
    }
    /**
     * Gets/sets the selection font property.
     *
     * @readonly
     * @type {*}
     * @memberof RichtextboxComponent
     */
    get selectionFont() {
        const font = {
            bold: false,
            italic: false,
            strikeout: false,
            underline: false,
            name: '',
            sizeInPoints: 0
        };
        /* c8 ignore else */
        if (this.toolbarState) {
            font.bold = this.toolbarState[KendoEditorCommand.bold].selected;
            font.italic = this.toolbarState[KendoEditorCommand.italic].selected;
            font.strikeout =
                this.toolbarState[KendoEditorCommand.strikethrough].selected;
            font.underline = this.toolbarState[KendoEditorCommand.underline].selected;
            const selectedFontFamily = this.getUniqueStyleValues(this.toolbarState.style.selected, 'font-family');
            font.name = selectedFontFamily
                ? selectedFontFamily
                : getComputedStyle(this.element1.nativeElement.querySelector('.k-editor-toolbar'))
                    .fontFamily.split(',')
                    .shift()
                    .toLowerCase();
            const selectedFontSize = this.getUniqueStyleValues(this.toolbarState.style.selected, 'font-size');
            const fontSizePx = selectedFontSize
                ? selectedFontSize
                : getComputedStyle(this.element1.nativeElement.querySelector('.k-editor-toolbar')).fontSize;
            font.sizeInPoints = this.pixelsToPoints(fontSizePx);
        }
        return font;
    }
    set selectionFont(value) {
        this.model.SelectionFont = value;
        this.updateSelectionFont(value);
    }
    /**
     * Helper to convert from pixels to points.
     *
     * @example
     * pixelsToPoints('1px')
     *  returns: 0.75.
     *
     * @param {string} pixels
     * @return {*}  {number}
     * @memberof RichtextboxComponent
     */
    pixelsToPoints(pixels) {
        return parseFloat(pixels) * 0.75;
    }
    /**
     * Helper to convert from points to pixels.
     * @example
     * pointsToPixels('1')
     *  returns 1.33px.
     *
     * @param {number} points
     * @return {*}  {string}
     * @memberof RichtextboxComponent
     */
    pointsToPixels(points) {
        return `${points / 0.75}px`;
    }
    /**
     * Helper to get the styles values from the selected element.
     * This helper is based on the getUniqueStyleValues from progres-kendo-angular-editor utils.js.
     *
     * @param {*} stateSelectedStyle - Selected style from the toolbar state.
     * @param {string} cssStyle - css style name.
     * @return {*}
     * @memberof RichtextboxComponent
     */
    getUniqueStyleValues(stateSelectedStyle, cssStyle) {
        /* c8 ignore else */
        if (stateSelectedStyle.hasNodesWithoutMarks) {
            return '';
        }
        /* c8 ignore next */
        const uniqueMarkValues = stateSelectedStyle.marks
            ?.filter((m) => {
            return m.type.name === 'style';
        })
            .map((m) => {
            return m.attrs.style;
        })
            .map((m) => m.split(';'))
            .map((m) => {
            return m.filter((n) => {
                return n.includes(cssStyle);
            });
        })
            // empty array
            .map((cssStyleValues) => {
            return cssStyleValues.length !== 0
                ? cssStyleValues
                : [cssStyle + ': INVALID'];
        })
            .map((m) => m.shift()?.split(':')?.pop()?.trim())
            .reduce((acc, curr) => {
            return acc.indexOf(curr) > -1 ? acc : acc.concat([curr]);
        }, []);
        /* c8 ignore else */
        if (uniqueMarkValues.indexOf('INVALID') > -1 ||
            uniqueMarkValues.length !== 1) {
            return '';
        }
        return uniqueMarkValues[0];
    }
    /**
     * Returns all the necessary classes for the editor.
     *
     * @return {*}  {string}
     * @memberof RichtextboxComponent
     */
    classes() {
        return `
      ${this.class}
      ${this.getBorderStyleClass()}
      ${this.getWordWrapClass()}
      ${this.getScrollBarsClass()}
    `;
    }
    /**
     * Returns the custom display element.
     *
     * @return {*}  {*}
     * @memberof RichtextboxComponent
     */
    getDisplayElement() {
        /* c8 ignore else */
        if (this.element1 && this.element1.nativeElement) {
            return this.element1.nativeElement.querySelector('div.ProseMirror');
        }
        return null;
    }
    /**
     * funRefresh function triggers a refresh mehod when a tab is selected.
     *
     * @memberof RichtextboxComponent
     */
    funRefresh() {
        /* c8 ignore else */
        if (this.kendoEditor) {
            this.kendoEditor.value = this.text;
        }
    }
    /**
     * Updates the alignment for the selected text.
     *
     * @param {HorizontalAlignment} selectionAlignment
     * @memberof RichtextboxComponent
     */
    updateSelectionAlignment(selectionAlignment) {
        let alignmentCommand;
        const alignment = +selectionAlignment
            ? +selectionAlignment
            : HorizontalAlignment[selectionAlignment];
        switch (alignment) {
            case HorizontalAlignment.Center:
                alignmentCommand = KendoEditorCommand.alignCenter;
                break;
            case HorizontalAlignment.Right:
                alignmentCommand = KendoEditorCommand.alignRight;
                break;
            case HorizontalAlignment.Left:
            default:
                alignmentCommand = KendoEditorCommand.alignLeft;
                break;
        }
        try {
            /* c8 ignore else */
            if (this.toolbarState &&
                this.toolbarState[alignmentCommand] &&
                this.toolbarState[alignmentCommand].selected === false) {
                this.kendoEditor.exec(alignmentCommand);
            }
        }
        catch (error) { }
    }
    /**
     * Updates the font for the selected text.
     *
     * @param {FontData} selectionFont
     * @memberof RichtextboxComponent
     */
    updateSelectionFont(selectionFont) {
        const currentSelectionFont = this.selectionFont;
        /* c8 ignore else */
        if (selectionFont.bold &&
            selectionFont.bold !== currentSelectionFont.bold) {
            this.kendoEditor.exec(KendoEditorCommand.bold);
        }
        /* c8 ignore else */
        if (selectionFont.italic &&
            selectionFont.italic !== currentSelectionFont.italic) {
            this.kendoEditor.exec(KendoEditorCommand.italic);
        }
        /* c8 ignore else */
        if (selectionFont.strikeout &&
            selectionFont.strikeout !== currentSelectionFont.strikeout) {
            this.kendoEditor.exec(KendoEditorCommand.strikethrough);
        }
        /* c8 ignore else */
        if (selectionFont.underline &&
            selectionFont.underline !== currentSelectionFont.underline) {
            this.kendoEditor.exec(KendoEditorCommand.underline);
        }
        /* c8 ignore else */
        if (selectionFont.name !== currentSelectionFont.name) {
            this.kendoEditor.exec(KendoEditorCommand.fontFamily, selectionFont.name);
        }
        /* c8 ignore else */
        if (selectionFont.sizeInPoints &&
            selectionFont.sizeInPoints !== currentSelectionFont.sizeInPoints) {
            this.kendoEditor.exec(KendoEditorCommand.fontSize, this.pointsToPixels(selectionFont.sizeInPoints));
        }
    }
    /**
     * click event calls the updateSelect for update the
     * selectionStart and selectionLength
     *
     * @param {*} event
     * @memberof RichtextboxComponent
     */
    click(event) {
        this.updateSelect();
        event.stopPropagation();
    }
    /**
     * Update selectionStart and selectionEnd properties
     * on events (Click , MouseDown, handlerSelection)
     *
     * @memberof RichtextboxComponent
     */
    /* c8 ignore next */
    updateSelect() {
        this.selectionStart = this.calculateSelectionStart(); // set selectionStart to update the model
        this.selectionLength = this.calculateSelectionLength(); // set selectionLength to update the model
    }
    /**
     * KeyUp handler recive the keyboardEvent
     * just wait for ctrl + a
     * to update the selection
     *
     * @param {*} event
     * @memberof RichtextboxComponent
     */
    handlerSelection(event) {
        if (event.ctrlKey && event.key.toLowerCase() === 'a') {
            this.updateSelect();
        }
    }
    /* c8 ignore start */
    keyUp(event) {
        //leave empty on purpose
        //keyup event is now handled by the afterValueChanged directive instead of the controls directive, keyup is now being called in onRichTextBoxKeyUp method.
    } /* c8 ignore stop */
    /**
     * OnDestroy lifecycle hook.
     *
     * @memberof RichtextboxComponent
     */
    /* c8 ignore next */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.blurUnlisten?.();
        this.toolbarStateSubscription?.unsubscribe();
        /* c8 ignore else */
        if (WebMapService.currentService) {
            WebMapService.currentService.core
                .getEvent()
                .unSubscribe(this.refreshSubscription);
        }
    }
};
/* c8 ignore stop */
/**
 * MapperId value for RichtextboxComponent
 */
RichtextboxComponent.RichTextBoxMapperId = 'rchTxtBx';
/**
 * MapperId value for the RichTextBoxChanged event.
 *
 * @static
 * @memberof RichtextboxComponent
 */
RichtextboxComponent.RichTextBoxChangedMapperId = 'rchTxtBxChngdvntrgs';
RichtextboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RichtextboxComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.WebMapService }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
RichtextboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: RichtextboxComponent, selector: "wm-richtextbox", inputs: { model: "model" }, outputs: { TextChanged: "TextChanged", RichTextBoxChanged: "RichTextBoxChanged" }, viewQueries: [{ propertyName: "kendoEditor", first: true, predicate: ["editor"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<kendo-editor *ngIf=\"visible\" #displayElement #editor [ngStyle]=\"setMyStyle()\" [ngClass]=\"classes()\"\r\n  [value]=\"HTMLcontent\" [iframe]=\"false\" wmControls [hostComponent]=\"this\"\r\n  (afterValueChanged)=\"onRichTextBoxKeyUp($event)\" [readonly]=\"readOnly\" [disabled]=\"disabled\"\r\n  (click)=\"click($event)\" (keyup)=\"handlerSelection($event)\">\r\n</kendo-editor>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i6$4.EditorComponent, selector: "kendo-editor", inputs: ["value", "disabled", "readonly", "iframe", "iframeCss", "applyToWord", "schema", "plugins", "placeholder", "preserveWhitespace", "pasteCleanupSettings", "resizable"], outputs: ["valueChange", "focus", "paste", "blur"] }, { kind: "directive", type: AfterValueChangedDirective, selector: "[afterValueChanged]", outputs: ["afterValueChanged"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('HtmlText'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], RichtextboxComponent.prototype, "htmlText", null);
__decorate([
    serverEvent('RichTextBoxChanged', RichtextboxComponent_1.RichTextBoxChangedExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], RichtextboxComponent.prototype, "richTextBoxChangedEventHandler", null);
__decorate([
    NotifyChange('selectionAlignment'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], RichtextboxComponent.prototype, "selectionAlignment", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SelectionColor'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], RichtextboxComponent.prototype, "selectionColor", null);
__decorate([
    MarkForCheck(),
    NotifyChange('BorderStyle'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], RichtextboxComponent.prototype, "borderStyle", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SelectedText'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], RichtextboxComponent.prototype, "selectedText", null);
__decorate([
    MarkForCheck(),
    NotifyChange('WordWrap'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], RichtextboxComponent.prototype, "wordWrap", null);
__decorate([
    MarkForCheck(),
    NotifyChange('ReadOnly'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], RichtextboxComponent.prototype, "readOnly", null);
__decorate([
    MarkForCheck(),
    NotifyChange('ScrollBars'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], RichtextboxComponent.prototype, "scrollBars", null);
__decorate([
    NotifyChange('SelectionStart'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], RichtextboxComponent.prototype, "selectionStart", null);
__decorate([
    NotifyChange('SelectionLength'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], RichtextboxComponent.prototype, "selectionLength", null);
__decorate([
    NotifyChange('SelectionFont'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], RichtextboxComponent.prototype, "selectionFont", null);
RichtextboxComponent = RichtextboxComponent_1 = __decorate([
    dataTransfer(['rchTxtBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        WebMapService,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], RichtextboxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RichtextboxComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-richtextbox', inputs: ['model'], template: "<kendo-editor *ngIf=\"visible\" #displayElement #editor [ngStyle]=\"setMyStyle()\" [ngClass]=\"classes()\"\r\n  [value]=\"HTMLcontent\" [iframe]=\"false\" wmControls [hostComponent]=\"this\"\r\n  (afterValueChanged)=\"onRichTextBoxKeyUp($event)\" [readonly]=\"readOnly\" [disabled]=\"disabled\"\r\n  (click)=\"click($event)\" (keyup)=\"handlerSelection($event)\">\r\n</kendo-editor>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WebMapService }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { htmlText: [], kendoEditor: [{
                type: ViewChild,
                args: ['editor', { static: false }]
            }], TextChanged: [{
                type: Output
            }], RichTextBoxChanged: [{
                type: Output
            }], richTextBoxChangedEventHandler: [], selectionAlignment: [], selectionColor: [], borderStyle: [], selectedText: [], wordWrap: [], readOnly: [], scrollBars: [], selectionStart: [], selectionLength: [], selectionFont: [] } });

let ComboBoxJqueryComponent = class ComboBoxJqueryComponent extends ComboBoxBaseComponent {
    /* c8 ignore start */
    constructor(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1, tabOrderService) {
        super(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1);
        this.serviceRef = serviceRef;
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        this.tabOrderService = tabOrderService;
        /* c8 ignore stop */
        this.registered = false;
        this.items = [];
        this.defaultDataUrl = 'api/comboboxjquery';
        this.urlPage = `${this.defaultDataUrl}/GetPage`;
        this.urlselectedIndex = `${this.defaultDataUrl}/GetSelectedIndex`;
        /**
         * Emit SelectedIndexChanged event
         */
        this.SelectedIndexChanged = new EventEmitter();
        this.SelectedValueChanged = new EventEmitter();
        this.DropDown = new EventEmitter();
        this.DropDownClosed = new EventEmitter();
        this.selectionChange = this.selectionChange.bind(this);
        this.valueChange = this.valueChange.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.valueMapperFunction = this.valueMapperFunction.bind(this);
        this.disabling = this.disabling.bind(this);
        changeDetectorRef.markForCheck();
    }
    /**
     * Sets the SelectedIndex
     */
    set selectedItem(value) {
        this.model.SelectedIndex = value;
        this.internalIndex = value;
    }
    get selectedItem() {
        return this.internalIndex;
    }
    /**
     * Function used to call the server to find the index of the selectedItem
     */
    valueMapperFunction(options) {
        kendo.jQuery.ajax({
            headers: { 'WM-API': true },
            dataType: 'json',
            data: { value: this.selectedIndex },
            url: `${this.urlselectedIndex}/${this.id}`,
            type: 'GET',
            success(data) {
                options.success(data);
            }
        });
    }
    /**
     * Function used to assign a datasource for the Jquery component
     * @property Items r
     */
    fetchItems() {
        const dataSource = {
            transport: {
                type: 'GET',
                read: {
                    url: `${this.urlPage}/${this.id}`,
                    headers: { 'WM-API': true },
                    dataType: 'json',
                    cache: false,
                    complete: () => {
                        if (this.internalIndex === undefined) {
                            this.internalIndex = this.selectedIndex;
                        }
                    }
                }
            },
            schema: {
                data: 'data',
                total: 'total'
            },
            pageSize: 80,
            serverPaging: true,
            serverFiltering: true
        };
        dataSource.transport.read.complete =
            dataSource.transport.read.complete.bind(this);
        const comboBox = this.comboboxJqueryEl['widget'];
        comboBox.setDataSource(dataSource);
        comboBox.dataSource.read();
        this.loading = false;
        this.detectChanges();
    }
    /**
     * First lifecycle hook of Angular
     */
    ngOnInit() {
        if (this.comboboxJqueryEl) {
            this.registerFunctions();
        }
    }
    /**
     * Returns the data source URL of this component.
     */
    get url() {
        if (this.dataUrl && this.dataUrl.length > 0) {
            return this.dataUrl;
        }
        return this.defaultDataUrl;
    }
    /*
     * Checks if a Refresh is required
     */
    ngDoCheck() {
        super.ngDoCheck();
        if (this.comboboxJqueryEl) {
            if (this.refresh) {
                this.fetchItems();
                this.refresh = false;
            }
            else if (this.comboboxJqueryEl['widget'] &&
                this.internalIndex !== undefined &&
                this.internalIndex !== this.selectedIndex) {
                this.updateSelection();
            }
        }
    }
    /**
     * get the current Index from the model, otherwise return de default -1
     */
    get selectedIndex() {
        return !isNaN(this.model.SelectedIndex) ? this.model.SelectedIndex : -1;
    }
    /**
     * Call the value method of the Jquery Component, used to update the selectedIndex
     */
    updateSelection() {
        this.comboboxJqueryEl['widget'].value(this.selectedIndex);
        this.internalIndex = this.selectedIndex;
    }
    /**
     * Call the fechItems when the refresh property is true.
     */
    refreshable() {
        if (this.comboboxJqueryEl) {
            this.fetchItems();
        }
    }
    /**
     * Modifies the enabled state of the combobox
     */
    disabling() {
        this.comboboxJqueryEl['widget'].enable(this.model.Enabled);
    }
    /**
     * register the function for the Jquery Component
     */
    registerFunctions() {
        this.comboboxJqueryEl['registerFunction']('Refresh', this.refreshable);
        this.comboboxJqueryEl['registerFunction']('Enabled', this.disabling);
        this.registered = true;
    }
    /**
     * LifeCycle hook of Angular to call the AfterView if the element exist.
     */
    ngAfterViewInit() {
        if (this.comboboxJqueryEl) {
            super.ngAfterViewInit();
            this.registerFunctions();
            this.disabling();
            if (this.tabOrderService) {
                this.tabOrderService.registerInstance(this);
            }
        }
    }
    /**
     * Trigger the selectedValueChanged Event, also update the property selectedItem
     */
    selectionChange(event) {
        if (!this.refresh) {
            this.selectedItem = event.sender.selectedIndex;
            this.SelectedIndexChanged.emit(new EventData$1(event, this.id));
        }
    }
    /**
     * Override the detectChange from the ControlComponent
     * to call the updateSelection method when the core has a new request
     */
    detectChanges() {
        super.detectChanges();
    }
    /**
     * Tab key handler to manage tab behavior.
     * MaintTabOrder service determines which action
     * should be performed after a tab key event.
     * @param event TabKey event.
     */
    tabKeyHandler(event) {
        Utils.preventPropagation(event);
        if (this && this.tabOrderService) {
            this.tabOrderService.resolveTab(this.tabNodeReference, event.shiftKey, event);
        }
    }
};
ComboBoxJqueryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ComboBoxJqueryComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: MainTabOrderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ComboBoxJqueryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ComboBoxJqueryComponent, selector: "wm-combobox-jquery", inputs: { model: "model", dataUrl: "dataUrl" }, outputs: { SelectedIndexChanged: "SelectedIndexChanged", SelectedValueChanged: "SelectedValueChanged", DropDown: "DropDown", DropDownClosed: "DropDownClosed" }, viewQueries: [{ propertyName: "comboboxJqueryEl", first: true, predicate: ["combobox"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\" [ngStyle]=\"setMyStyle()\" [ngClass]=\"class\">\r\n  <div #combobox [model]='model' data-role=\"combobox\" [bound]=\"{\r\n    autoBind: false,\r\n    virtual: {valueMapper: valueMapperFunction},\r\n    dataTextField: 'text',\r\n     dataValueField:'value',\r\n     change: selectionChange,\r\n     select: valueChange,\r\n     open: open,\r\n     close: close\r\n}\"></div>\r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: KendoDropDownListComponent, selector: "[data-role=combobox]", inputs: ["model", "bound", "role"] }] });
__decorate([
    MarkForCheck(),
    NotifyChange('SelectedIndex'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Object])
], ComboBoxJqueryComponent.prototype, "selectedItem", null);
__decorate([
    serverEvent('SelectedIndexChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ComboBoxJqueryComponent.prototype, "selectionChange", null);
ComboBoxJqueryComponent = __decorate([
    dataTransfer(['cmbBoxJq']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        MainTabOrderService])
], ComboBoxJqueryComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ComboBoxJqueryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-combobox-jquery', inputs: ['model'], template: "<div *ngIf=\"model\" [ngStyle]=\"setMyStyle()\" [ngClass]=\"class\">\r\n  <div #combobox [model]='model' data-role=\"combobox\" [bound]=\"{\r\n    autoBind: false,\r\n    virtual: {valueMapper: valueMapperFunction},\r\n    dataTextField: 'text',\r\n     dataValueField:'value',\r\n     change: selectionChange,\r\n     select: valueChange,\r\n     open: open,\r\n     close: close\r\n}\"></div>\r\n</div>" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: MainTabOrderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { dataUrl: [{
                type: Input
            }], comboboxJqueryEl: [{
                type: ViewChild,
                args: ['combobox', { static: false }]
            }], SelectedIndexChanged: [{
                type: Output
            }], SelectedValueChanged: [{
                type: Output
            }], DropDown: [{
                type: Output
            }], DropDownClosed: [{
                type: Output
            }], selectedItem: [], selectionChange: [] } });

var SizeType;
(function (SizeType) {
    SizeType[SizeType["AutoSize"] = 0] = "AutoSize";
    SizeType[SizeType["Absolute"] = 1] = "Absolute";
    SizeType[SizeType["Percent"] = 2] = "Percent";
})(SizeType || (SizeType = {}));
let TableLayoutPanelComponent = class TableLayoutPanelComponent extends ControlContainerComponent {
    /* c8 ignore start */
    constructor(changeDetector, webMapService, renderer2, element, webComponents, bringTopServ) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ);
        this.changeDetector = changeDetector;
        this.webMapService = webMapService;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        /* c8 ignore stop */
        this.defaultDataUrl = 'api/tablelayoutpanel';
        this.rows = [];
        this.columns = [];
        this.controlsInternal = [];
        this.controlsRendererCollection = {};
        this.tableClass = '';
        this.applyRowHeight = true;
        this.penultRowAutoSize = false;
        /* Indicates if the table-fixed class will be applied */
        this.shouldApplyClassFixed = false;
        /* Indicates if the table has at least one column span */
        this.hasColSpan = false;
        /* Indicates if the width should be applied to the last col */
        this.shouldApplyWidthToLastCol = true;
        /**
         * Gets special dock.
         * Override the default value to process the dock.
         */
        this.specialDock = true;
    }
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /* c8 ignore next */
    processSpecialDock(component, size, offsets) {
        if (this.allData && this.allData.controls) {
            const position = this.controlsRendererCollection[component.id];
            if (position && this.displayElement) {
                const table = this.displayElement.firstElementChild;
                const cell = table.rows[position.row].cells[position.col];
                this.renderer2.setStyle(cell, 'position', 'relative');
                this.renderer2.setStyle(cell.firstElementChild, 'position', 'absolute');
                size.width = getComputedValue(cell, 'width', 0);
                size.height = getComputedValue(cell, 'height', 0);
                this.renderer2.removeStyle(cell.firstElementChild, 'position');
                offsets = { top: 0, bottom: 0, left: 0, right: 0 };
                return { size, offsets };
            }
        }
        return { size, offsets };
    }
    get usedRows() {
        return this.rows.slice(0, this.rowCount);
    }
    get rowCount() {
        return this.model.RowCount;
    }
    get columnCount() {
        return this.model.ColumnCount;
    }
    get tableHeight() {
        return this.model.Style ? this.model.Style.Height : '';
    }
    get tableWidth() {
        return this.model.Style ? this.model.Style.Width : '';
    }
    /**
     * Gets cell border style from model
     *
     * @returns number. Default value 0
     */
    get cellBorderStyle() {
        return this.model.CellBorderStyle ? this.model.CellBorderStyle : 0;
    }
    loadAllData() {
        this.webMapService
            .fetch(this.defaultDataUrl, this.id)
            .subscribe((data) => {
            this.allData = data;
            this.controlsRendererCollection = {};
            if (this.allData) {
                if (this.allData.rows) {
                    this.loadRows();
                }
                if (this.allData.columns) {
                    this.loadColumns();
                }
                this.processColSpan();
                this.calculateShouldApplyClassFixed();
                this.calculateShouldApplyWidthToLastCol();
                this.calculateClass();
            }
        });
    }
    /**
     * Loads rows models
     * After receiving the tabs ids we can get
     * the models associated with each row
     */
    loadRows() {
        this.rows = [];
        for (const row of this.allData.rows) {
            const rowModel = this.webMapService.core.getModel(row);
            this.rows.push(rowModel);
        }
        // If the penultimate row is autoSize
        /* c8 ignore else */
        if (this.rows.length > 1) {
            this.penultRowAutoSize =
                this.rows[this.rows.length - 2].SizeType === SizeType.AutoSize;
        }
        this.detectChanges();
    }
    /**
     * Loads columns models
     * After receiving the tabs ids we can get
     * the models associated with each column
     */
    loadColumns() {
        this.columns = [];
        for (const column of this.allData.columns) {
            const columnModel = this.webMapService.core.getModel(column);
            this.columns.push(columnModel);
        }
        this.detectChanges();
    }
    /**
     * Calculates the value to verify if the table-fixed css class should be applied
     */
    calculateShouldApplyClassFixed() {
        const res = this.columns.filter((x) => x.SizeType === SizeType.AutoSize);
        this.shouldApplyClassFixed = res.length > 1 || this.hasColSpan;
    }
    /**
     * Cacultates if the latest column width should be applied
     */
    calculateShouldApplyWidthToLastCol() {
        /* c8 ignore else */
        if (this.columns) {
            const totalCol = this.columns.length;
            const lastCol = this.columns[totalCol - 1];
            this.shouldApplyWidthToLastCol = !(totalCol > 1 &&
                lastCol.SizeType === SizeType.Percent &&
                lastCol.Width === 100);
        }
    }
    /**
     * Gets the columns to be rendered
     *
     * @param  {number} row
     * @returns any
     */
    getUsedColumns(row) {
        return this.controlsInternal[row];
    }
    getControlId(i, j) {
        if (this.controlsInternal[i][j]) {
            const item = this.controlsInternal[i][j].controlId;
            this.controlsRendererCollection[item] = { row: i, col: j };
            return item;
        }
        else {
            return undefined;
        }
    }
    isControl(i, j) {
        if (this.controlsInternal && this.controlsInternal[i]) {
            return this.controlsInternal[i][j].controlId !== '';
        }
        return false;
    }
    /**
     * Gets the colsSpan value for a cell
     *
     * @param  {number} row Row index
     * @param  {number} column Column index
     * @returns string. Default value 1
     */
    getColSpan(row, column) {
        if (this.controlsInternal &&
            this.controlsInternal[row] &&
            this.controlsInternal[row][column]) {
            return this.controlsInternal[row][column].colSpan;
        }
        return 1;
    }
    /**
     * Returns dynamic id object
     * @param quickId command id
     */
    dataItemContainerId(itemId) {
        const idObject = {};
        idObject[itemId] = true;
        return idObject;
    }
    /**
     * OnInit life-cycle hook
     */
    ngOnInit() {
        super.ngOnInit();
        this.loadAllData();
    }
    /**
     * DoCheck life-cycle hook
     */
    ngDoCheck() {
        super.ngDoCheck();
        // This is to apply the row height once the controls are already added
        /* c8 ignore else */
        if (this.applyRowHeight) {
            /* c8 ignore else */
            if (this.displayElement &&
                this.controlsInternal.length > 0 &&
                this.displayElement.querySelector('wm-custom-control-container > *')) {
                this.applyRowHeight = false;
                this.detectChanges();
            }
        }
    }
    /**
     * Generates the row height value
     *
     * @param index The row index
     * @returns The value of height
     */
    setRowStyle(index) {
        if (this.rows[index].SizeType === SizeType.AutoSize) {
            return this.rowAutoSize(index);
        }
        else {
            const chr = this.rows[index].SizeType === SizeType.Absolute ? 'px' : '%';
            return `${this.calculateRowHeight(index)}${chr}`;
        }
    }
    calculateRowHeight(index) {
        // This is to match the table height
        /* c8 ignore else */
        if (index === this.rows.length - 1 &&
            this.rows[index].SizeType === SizeType.Absolute &&
            this.penultRowAutoSize) {
            const prevRowHeight = this.getPreviousRowsHeight(index);
            const tblHeight = parseInt(getComputedValue(this.displayElement, 'height', 0));
            /* c8 ignore else */
            if (tblHeight > 0) {
                // Current Row Height + (full table height - (current row height + all previous rows height ))
                return (this.rows[index].Height +
                    (tblHeight - (this.rows[index].Height + prevRowHeight)));
            }
        }
        return this.rows[index].Height;
    }
    /**
     * Applies the colSpan effect in the table
     *
     * @returns void
     */
    processColSpan() {
        for (let r = 0; r < this.rowCount; r++) {
            let avoidCells = 0;
            this.controlsInternal.push([]);
            for (let c = 0; c < this.columnCount; c++) {
                const col = this.allData.controls[r][c];
                /* c8 ignore else */
                if (c === 0 || avoidCells === 0) {
                    this.controlsInternal[r].push(col);
                    /* c8 ignore else */
                    if (avoidCells === 0) {
                        avoidCells = col.colSpan;
                    }
                    /* c8 ignore else */
                    if (col.colSpan > 1) {
                        this.hasColSpan = true;
                    }
                }
                avoidCells -= 1;
            }
        }
        this.detectChanges();
    }
    /**
     * Generates the column width value
     */
    setColStyle(colindex, rowIndex) {
        // Getting the column index
        const colIdx = this.controlsInternal[rowIndex][colindex].col;
        if (this.columnCount - 1 === colIdx) {
            return this.calculateLastColWidth(rowIndex, colIdx);
        }
        else if (this.columns[colIdx].SizeType === SizeType.AutoSize) {
            return this.columnAutoSize(this.columns[colIdx], this.getControlId(rowIndex, colIdx), rowIndex, colIdx);
        }
        else {
            return this.generateFixedWidthValue(colIdx);
        }
    }
    /**
     * Gets the formatted value for column
     *
     * @param colIdx The column index
     * @returns The value in px or %
     */
    generateFixedWidthValue(colIdx) {
        return `${this.columns[colIdx].Width}${this.columns[colIdx].SizeType === SizeType.Absolute ? 'px' : '%'}`;
    }
    /**
     * Generates the css class considering the cell border style
     *
     * @returns void
     */
    calculateClass() {
        let tmpClass = null;
        switch (this.cellBorderStyle) {
            case TableLayoutPanelCellBorderStyle.Single:
                tmpClass = 'singleCellBorder';
                break;
            case TableLayoutPanelCellBorderStyle.Inset:
                tmpClass = 'insetCellBorder';
                break;
            case TableLayoutPanelCellBorderStyle.InsetDouble:
                tmpClass = 'insetDoubleCellBorder';
                break;
            case TableLayoutPanelCellBorderStyle.Outset:
                tmpClass = 'outsetCellBorder';
                break;
            case TableLayoutPanelCellBorderStyle.OutsetDouble:
                tmpClass = 'outsetDoubleCellBorder';
                break;
            case TableLayoutPanelCellBorderStyle.OutsetPartial:
                tmpClass = 'outsetPartialCellBorder';
                break;
            case TableLayoutPanelCellBorderStyle.None:
            default:
                tmpClass = '';
                break;
        }
        this.tableClass = `table-panel ${tmpClass}${this.calculateFixedClass()}`;
    }
    /**
     * Gets the fixed css class
     *
     * @returns The table-fixed if it should be applied otherwise false
     */
    calculateFixedClass() {
        return this.shouldApplyClassFixed ? '' : ' table-fixed';
    }
    /**
     * Gets the acummulated rows height
     * @param rowIndex The row index value
     * @returns The acummulated rows height of the previous rows
     */
    getPreviousRowsHeight(rowIndex) {
        let sumHeight = 0;
        for (let r = 0; r < rowIndex; r++) {
            sumHeight += parseInt(getComputedStyle(this.displayElement.firstChild.rows[r]).height);
        }
        return sumHeight;
    }
    /**
     * Returns the left value of the element
     *
     * @param element The dom element
     * @param previousColWidth The previous accumulated cols width
     * @returns The left value of the dom element otherwise the previous accumulated cols width
     */
    getLeftValue(element, previousColWidth) {
        let leftElement = parseInt(getComputedStyle(element).left, 10);
        /* c8 ignore else */
        if (isNaN(leftElement) || leftElement === 0) {
            leftElement = previousColWidth;
        }
        return leftElement;
    }
    /**
     * Returns the width value of the element
     *
     * @param element The dom element
     * @param componentInstance The component instance related to the dom element
     * @returns The width value of the dom element otherwise the width from the component model
     */
    getWidthValue(element, componentInstance) {
        let widthElement = parseInt(getComputedStyle(element).width, 10);
        /* c8 ignore else */
        if (isNaN(widthElement) || widthElement === 0) {
            widthElement = parseInt(componentInstance.model.Style?.Width, 10);
        }
        return widthElement;
    }
    /**
     * Gets a factor to adjust the cell width
     * @param componentInstance The component instance
     * @param colIndex The column index
     * @returns A const of 5 for docked controls otherwise a calculated value
     */
    getColAutoSizeFactor(componentInstance, colIndex) {
        if (componentInstance['initial']) {
            // This is for docked controls to avoid increase the cell width
            return 5;
        }
        else {
            // The number 4 is related to the td padding and border
            return colIndex !== 0 ? 4 * (colIndex + 1) : 0;
        }
    }
    /**
     * Gets the accumulated sum width of the previous columns for the current row index
     *
     * @param rowIndex The row index
     * @param colIndex The colum index
     * @returns The accomulated columns width
     */
    getPreviousColsWidth(rowIndex, colIndex) {
        let sumWidth = 0;
        for (let c = 0; c < colIndex; c++) {
            const cell = this.displayElement.firstChild.rows[rowIndex].cells[c];
            /* c8 ignore else */
            if (cell) {
                sumWidth += parseInt(getComputedStyle(cell).width);
            }
        }
        return sumWidth;
    }
    /**
     * Calculates the width for the latest column
     *
     * @param rowIndex The row index
     * @param colIndex The column index
     * @returns The fixed width for the latest column
     */
    calculateLastColWidth(rowIndex, colIndex) {
        if (this.getColSpan(rowIndex, colIndex) === 1 &&
            this.columns[colIndex].SizeType === SizeType.Absolute) {
            const prevColsWidth = this.getPreviousColsWidth(rowIndex, colIndex);
            const tblWidth = parseInt(getComputedValue(this.displayElement, 'width', 0));
            const currentWidth = this.columns[colIndex].Width;
            // Current col Width + (full table width - (current col width + all previous cols width))
            return `${currentWidth + (tblWidth - (currentWidth + prevColsWidth))}px`;
        }
        else if (this.columns[colIndex].SizeType === SizeType.Percent &&
            this.shouldApplyWidthToLastCol) {
            return this.generateFixedWidthValue(colIndex);
        }
        else {
            return null;
        }
    }
    /**
     * Columns auto size
     * @param columnModel current column model
     * @param childId id of the control inside the cell
     * @param rowindex the row index
     * @param colIndex the column index
     * @returns new adjusted size value
     */
    columnAutoSize(columnModel, childId, rowIndex, colIndex) {
        const componentInstance = this.webComponents.componentsCollection[childId];
        const colSpan = this.getColSpan(rowIndex, colIndex);
        // if column has a colSpan greater than 1 then it will be ommited
        if (colSpan === 1 &&
            componentInstance &&
            componentInstance.displayElement) {
            const componentChildren = Array.from(componentInstance.displayElement.querySelectorAll('[wmcontrols]'));
            // if there is no wmcontrols then the displayElement will be evaluated
            /* c8 ignore else */
            if (componentChildren.length === 0) {
                componentChildren.push(componentInstance.displayElement);
            }
            const previousColWidth = colIndex > 0 ? this.getPreviousColsWidth(rowIndex, colIndex) : 0;
            let maxWidth = 0;
            componentChildren.forEach((element) => {
                const leftElement = this.getLeftValue(element, previousColWidth);
                const widthElement = this.getWidthValue(element, componentInstance);
                // Factor to adjust the width.
                const factor = this.getColAutoSizeFactor(componentInstance, colIndex);
                const currentWidth = leftElement + widthElement - (factor + previousColWidth);
                maxWidth = Math.max(currentWidth, maxWidth);
            });
            return `${maxWidth}px`;
        }
        else {
            return null;
        }
    }
    /**
     * Calculates the row height value
     *
     * @param rowIndex The row index
     * @returns The row height value
     */
    rowAutoSize(rowIndex) {
        let maxHeigth = 0;
        // If controls are already resolved
        /* c8 ignore else */
        if (this.controlsInternal.length > 0) {
            const colsPerRow = this.getUsedColumns(rowIndex).length;
            let previousRowHeight = 0;
            // if it is not the initial row
            /* c8 ignore else */
            if (rowIndex > 0) {
                // Getting the previous rows height to calculate the current one
                previousRowHeight = this.getPreviousRowsHeight(rowIndex);
            }
            // For each col of the row
            maxHeigth = this.rowAutoSizeVerifyColumn(colsPerRow, rowIndex, previousRowHeight);
            return `${maxHeigth}px`;
        }
        return null;
    }
    /**
     * Iterates each column of the row to verify the content height
     *
     * @param colsPerRow The number of columns of the row
     * @param rowIndex The row index
     * @param previousRowHeight The previous row height
     * @returns The new row height
     */
    rowAutoSizeVerifyColumn(colsPerRow, rowIndex, previousRowHeight) {
        let maxHeigth = 0;
        for (let colIdx = 0; colIdx < colsPerRow; colIdx++) {
            const childId = this.getControlId(rowIndex, colIdx);
            // Getting the component in the cell
            const componentInstance = this.webComponents.componentsCollection[childId];
            /* c8 ignore else */
            if (componentInstance && componentInstance.displayElement) {
                const element = componentInstance.displayElement;
                let topElement = parseInt(getComputedStyle(element).top, 10);
                /* c8 ignore else */
                if (isNaN(topElement)) {
                    topElement = previousRowHeight;
                }
                let heightElement = parseInt(getComputedStyle(element).height, 10);
                /* c8 ignore else */
                if (isNaN(heightElement)) {
                    heightElement = parseInt(componentInstance.model.Style?.Height, 10);
                }
                let additionalMeasure = 3;
                /* c8 ignore else */
                if (componentInstance['initial']) {
                    additionalMeasure = 0;
                }
                const currentHeight = topElement + heightElement + additionalMeasure - previousRowHeight;
                maxHeigth = Math.max(currentHeight, maxHeigth);
            }
        }
        return maxHeigth;
    }
};
TableLayoutPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableLayoutPanelComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.WebMapService }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TableLayoutPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TableLayoutPanelComponent, selector: "wm-table-layout-panel", inputs: { model: "model", windowModel: "windowModel" }, viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #displayElement [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\">\r\n  <table [ngClass]=\"tableClass\">\r\n    <tr *ngFor=\"let row of usedRows let i=index\" [style.height]='setRowStyle(i)'>\r\n      <td *ngFor=\"let col of getUsedColumns(i) let j=index\" [style.width]='setColStyle(j, i)'\r\n        [attr.colspan]='getColSpan(i, j)' class=\"cell-content\">\r\n        <div class=\"cell-content div-cell\">\r\n          <wm-custom-control-container *ngIf=\" isControl(i, j)\" [windowModel]=\"windowModel\"\r\n            (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"dataItemContainerId(getControlId(i, j))\">\r\n          </wm-custom-control-container>\r\n        </div>\r\n      </td>\r\n    </tr>\r\n  </table>\r\n</div>", styles: [".cell-content{overflow:hidden;vertical-align:top}.table-panel{width:100%;height:100%;border-spacing:0px;border-collapse:collapse}.table-fixed{table-layout:fixed}.div-cell{width:100%;height:100%}.singleCellBorder td{border-style:solid;border-width:2px}.insetCellBorder td{border-style:groove}.insetDoubleCellBorder td{border-style:inset}.outsetCellBorder td{border-style:ridge}.outsetPartialCellBorder td,.outsetDoubleCellBorder td{border-style:outset}.table-panel .topRight,.table-panel .bottomRight,.table-panel .middleRight{margin-left:-4px!important}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: CustomControlContainerComponent, selector: "wm-custom-control-container", inputs: ["controls", "containerParent", "windowModel", "controlType"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
TableLayoutPanelComponent = __decorate([
    dataTransfer(['tblLytPnl']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        WebMapService,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService])
], TableLayoutPanelComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableLayoutPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-table-layout-panel', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, inputs: ['model'], template: "<div #displayElement [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\">\r\n  <table [ngClass]=\"tableClass\">\r\n    <tr *ngFor=\"let row of usedRows let i=index\" [style.height]='setRowStyle(i)'>\r\n      <td *ngFor=\"let col of getUsedColumns(i) let j=index\" [style.width]='setColStyle(j, i)'\r\n        [attr.colspan]='getColSpan(i, j)' class=\"cell-content\">\r\n        <div class=\"cell-content div-cell\">\r\n          <wm-custom-control-container *ngIf=\" isControl(i, j)\" [windowModel]=\"windowModel\"\r\n            (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"dataItemContainerId(getControlId(i, j))\">\r\n          </wm-custom-control-container>\r\n        </div>\r\n      </td>\r\n    </tr>\r\n  </table>\r\n</div>", styles: [".cell-content{overflow:hidden;vertical-align:top}.table-panel{width:100%;height:100%;border-spacing:0px;border-collapse:collapse}.table-fixed{table-layout:fixed}.div-cell{width:100%;height:100%}.singleCellBorder td{border-style:solid;border-width:2px}.insetCellBorder td{border-style:groove}.insetDoubleCellBorder td{border-style:inset}.outsetCellBorder td{border-style:ridge}.outsetPartialCellBorder td,.outsetDoubleCellBorder td{border-style:outset}.table-panel .topRight,.table-panel .bottomRight,.table-panel .middleRight{margin-left:-4px!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WebMapService }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { windowModel: [{
                type: Input
            }], displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }] } });

let TableRowComponent = class TableRowComponent {
    constructor() { }
    /**
     * Gets templates
     * Returns a set of columns templates for the component
     */
    get columns() {
        return this.columnTemplates ? this.columnTemplates.toArray() : [];
    }
};
TableRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TableRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TableRowComponent, selector: "wm-table-row", inputs: { model: "model" }, queries: [{ propertyName: "columnTemplates", predicate: ["cell"] }], ngImport: i0, template: "<tr>\r\n  <td *ngFor=\"let col of columns\">\r\n    <ng-template [ngTemplateOutlet]=\"col\"></ng-template>\r\n  </td>\r\n</tr>", styles: ["tr{display:table}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
TableRowComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [])
], TableRowComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-table-row', inputs: ['model'], template: "<tr>\r\n  <td *ngFor=\"let col of columns\">\r\n    <ng-template [ngTemplateOutlet]=\"col\"></ng-template>\r\n  </td>\r\n</tr>", styles: ["tr{display:table}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { columnTemplates: [{
                type: ContentChildren,
                args: ['cell']
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
var TickStyle;
(function (TickStyle) {
    TickStyle[TickStyle["none"] = 0] = "none";
    TickStyle[TickStyle["before"] = 1] = "before";
    TickStyle[TickStyle["after"] = 2] = "after";
    TickStyle[TickStyle["both"] = 3] = "both";
})(TickStyle || (TickStyle = {}));

let TrackbarComponent = class TrackbarComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        this.ValueChange = new EventEmitter();
    }
    /**
     * Gets or sets the value added to or subtracted from the Value property when the scroll box is moved a small distance.
     */
    get smallChange() {
        return this.model.SmallChange;
    }
    /**
     *Gets or sets a value to be added to or subtracted from the Value property when the scroll box is moved a large distance.
     */
    get largeChange() {
        return this.model.LargeChange;
    }
    /**
     * Gets or sets the lower limit of the range this TrackBar is working with.
     */
    get minimum() {
        return this.model.Minimum;
    }
    /**
     * Gets or sets the upper limit of the range this TrackBar is working with.
     */
    get maximum() {
        return this.model.Maximum;
    }
    /**
     * Gets or sets a numeric value that represents the current position of the scroll box on the track bar.
     */
    get value() {
        return this.model.Value;
    }
    /**
     * Gets or sets a numeric value that represents the current position of the scroll box on the track bar.
     */
    set value(value) {
        this.model.Value = value;
    }
    /**
     * Specifies the location of tick marks in a TrackBar control.
     */
    get tickStyle() {
        return TickStyle[this.model.TickStyle];
    }
    /**
     * Occurs when the Value property of a track bar changes, either by movement of the scroll box or by manipulation in code.
     * @param event Event information
     */
    valueChange(event) {
        this.ValueChange.emit(new EventData$1(event, this.id));
    }
};
TrackbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TrackbarComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TrackbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TrackbarComponent, selector: "wm-trackbar", inputs: { model: "model" }, outputs: { ValueChange: "ValueChange" }, usesInheritance: true, ngImport: i0, template: "<kendo-slider *ngIf=\"model && visible\"\r\n[showButtons]=\"false\"\r\n[smallStep]=\"smallChange\"\r\n[largeStep] = \"largeChange\"\r\n[min]=\"minimum\"\r\n[max]=\"maximum\"\r\n[(ngModel)] = \"value\"\r\n[tickPlacement]=\"tickStyle\"\r\n[disabled]= \"disabled\"\r\n[ngClass]=\"class\"\r\n[ngStyle]=\"setMyStyle()\"\r\n(valueChange)=\"valueChange($event)\"\r\nwmControls [hostComponent]=\"this\"\r\n></kendo-slider>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i8.SliderComponent, selector: "kendo-slider", inputs: ["focusableId", "dragHandleTitle", "incrementTitle", "animate", "decrementTitle", "showButtons", "value", "tabIndex"], exportAs: ["kendoSlider"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    NotifyChange('Value'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], TrackbarComponent.prototype, "value", null);
__decorate([
    serverEvent('ValueChange'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TrackbarComponent.prototype, "valueChange", null);
TrackbarComponent = __decorate([
    dataTransfer(['trckbr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], TrackbarComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TrackbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-trackbar', inputs: ['model'], template: "<kendo-slider *ngIf=\"model && visible\"\r\n[showButtons]=\"false\"\r\n[smallStep]=\"smallChange\"\r\n[largeStep] = \"largeChange\"\r\n[min]=\"minimum\"\r\n[max]=\"maximum\"\r\n[(ngModel)] = \"value\"\r\n[tickPlacement]=\"tickStyle\"\r\n[disabled]= \"disabled\"\r\n[ngClass]=\"class\"\r\n[ngStyle]=\"setMyStyle()\"\r\n(valueChange)=\"valueChange($event)\"\r\nwmControls [hostComponent]=\"this\"\r\n></kendo-slider>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { ValueChange: [{
                type: Output
            }], value: [], valueChange: [] } });

var NotifyIconComponent_1;
var ToolTipIcon;
(function (ToolTipIcon) {
    ToolTipIcon[ToolTipIcon["None"] = 0] = "None";
    ToolTipIcon[ToolTipIcon["Info"] = 1] = "Info";
    ToolTipIcon[ToolTipIcon["Warning"] = 2] = "Warning";
    ToolTipIcon[ToolTipIcon["Error"] = 3] = "Error";
})(ToolTipIcon || (ToolTipIcon = {}));
let NotifyIconComponent = NotifyIconComponent_1 = class NotifyIconComponent extends ControlComponent {
    static balloonToolTipClickCallback(component, event) {
        setTimeout(() => {
            component.applcationRef.tick();
        });
    }
    /* c8 ignore start */
    constructor(applcationRef, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.applcationRef = applcationRef;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        this.BalloonTipClicked = new EventEmitter();
    }
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore start */
        if ('serviceWorker' in navigator && this.showNotification) {
            webNotification.showNotification(this.balloonTipTitle, {
                body: this.balloonTipText,
                icon: this.balloonTipIcon,
                onClick: () => {
                    this.balloonTipClicked(new EventData$1(this.id, 'BalloonTipClicked'));
                }
            }, (error, hide) => {
                this.hideFunction = hide;
            });
            this.showNotification = false;
        }
        /* c8 ignore stop */
        if (!this.visible && this.hideFunction) {
            this.hideFunction();
        }
    }
    get balloonTipText() {
        return this.model.BalloonTipText;
    }
    get balloonTipTitle() {
        return this.model.BalloonTipTitle;
    }
    get balloonTipIcon() {
        return this.model.BalloonTipIcon;
    }
    get showNotification() {
        return this.model.ShowNotification;
    }
    /**
     * @param value Contains the value assigned to the shownotification property.
     */
    set showNotification(value) {
        this.model.ShowNotification = value;
    }
    get visible() {
        return this.model.Visible;
    }
    balloonTipClicked(event) {
        this.BalloonTipClicked.emit(new EventData$1(event, this.id));
    }
};
NotifyIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotifyIconComponent, deps: [{ token: i0.ApplicationRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
NotifyIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: NotifyIconComponent, selector: "wm-notify-icon", outputs: { BalloonTipClicked: "BalloonTipClicked" }, usesInheritance: true, ngImport: i0, template: "", styles: [""] });
__decorate([
    MarkForCheck(),
    NotifyChange('ShowNotification'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], NotifyIconComponent.prototype, "showNotification", null);
__decorate([
    serverEvent('BalloonTipClicked', null, null, NotifyIconComponent_1.balloonToolTipClickCallback),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NotifyIconComponent.prototype, "balloonTipClicked", null);
NotifyIconComponent = NotifyIconComponent_1 = __decorate([
    dataTransfer(['ntfy']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ApplicationRef,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], NotifyIconComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotifyIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-notify-icon', template: "" }]
        }], ctorParameters: function () { return [{ type: i0.ApplicationRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { BalloonTipClicked: [{
                type: Output
            }], showNotification: [], balloonTipClicked: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
var Orientation;
(function (Orientation) {
    Orientation[Orientation["horizontal"] = 0] = "horizontal";
    Orientation[Orientation["vertical"] = 1] = "vertical";
})(Orientation || (Orientation = {}));

class SplitContainerBaseComponent extends ControlContainerComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerTOrderService) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ);
        this.webMapService = webMapService;
        this.containerTOrderService = containerTOrderService;
        this.isContainer = true;
        this.containerTabOrderService = containerTOrderService;
    }
    ngOnInit() {
        super.ngOnInit();
        this.panelModel1 = this.webMapService.core.getModel(this.model.Panel1);
        this.panelModel2 = this.webMapService.core.getModel(this.model.Panel2);
        this.stylePanelModel1 = this.setSplitContainerPanelStyle(this.panelModel1);
        this.stylePanelModel2 = this.setSplitContainerPanelStyle(this.panelModel2);
        this.detectChanges();
    }
    /**
     * Gets the minimum size for the first panel, in pixels.
     */
    get panel1MinSize() {
        return this.model.Panel1MinSize;
    }
    /**
     * Gets the minimum size for the second panel, in pixels.
     */
    get panel2MinSize() {
        return this.model.Panel2MinSize;
    }
    /**
     * Indicates if the panels will be set in a horizontal or vertical way
     * kendo-splitter's orientation works opposite to the winforms.
     * if orientation is set to horizontal the panels will be displayed one next to the other and the separator will be in a vertical way
     * else if orientation is set to the panels will be displayed one over the other and the separator will be in a horizontal way.
     */
    get orientation() {
        return this.model.Orientation === Orientation.horizontal
            ? 'vertical'
            : 'horizontal';
    }
    /**
     * Gets the location of the splitter, in pixels
     */
    get splitterDistance() {
        return this.panel2Collapsed ? `${this.model.SplitterDistance}px` : null;
    }
    /**
     * Sets the location of the splitter, in pixels
     */
    set splitterDistance(value) {
        this.model.SplitterDistance = Number(value.replace('px', ''));
    }
    /**
     * Indicates if the splitter can move
     */
    get isSplitterFixed() {
        return this.model ? this.model.IsSplitterFixed : false;
    }
    /**
     *Indicates if the first panel shows the scrollbars
     */
    get panel1AutoScroll() {
        return this.model && this.panelModel1 ? this.panelModel1.AutoScroll : false;
    }
    /**
     * Indicates if the second panel shows the scrollbars
     */
    get panel2AutoScroll() {
        return this.model && this.panelModel2 ? this.panelModel2.AutoScroll : false;
    }
    /**
     * Gets panel1 controls
     */
    get panel1Controls() {
        return this.panelModel1?.Controls ?? {};
    }
    /**
     * Gets panel2 controls
     */
    get panel2Controls() {
        return this.panelModel2?.Controls ?? {};
    }
    /**
     * Gets panel1 collapsed, if returns true the panel is shown.
     */
    get panel1Collapsed() {
        return !this.model.Panel1Collapsed;
    }
    /**
     * Gets panel2 collapsed, if returns true the panel is shown.
     */
    get panel2Collapsed() {
        return !this.model.Panel2Collapsed;
    }
    /**
     * Gets panel1 Style
     */
    get panel1Style() {
        return this.stylePanelModel1;
    }
    /**
     * Gets panel2 Style
     */
    get panel2Style() {
        return this.stylePanelModel2;
    }
    /**
     * Returns a valid style object to
     * be applied according to the styling information set in the
     * Panel model
     */
    setSplitContainerPanelStyle(contextModel) {
        if (contextModel &&
            contextModel.Style &&
            !ValidateObject.isEmptyObject(contextModel.Style)) {
            const styleStorage = new Style();
            styleStorage.update(contextModel.Style);
            return FilterObject.cleanCopy(styleStorage);
        }
        return undefined;
    }
    /**
     * Override
     * Gets tab order
     */
    get tabOrder() {
        return this.calculateTabOrder();
    }
    /**
     * Override
     * Calculates the tabOrder value
     * @returns  any
     */
    calculateTabOrder() {
        return Utils.validateTabOrder(this.model, this.tabindex);
    }
    /**
     * Applies focus to first inner element by tab index
     */
    applyFocus() {
        this.containerTabOrderService.enterContainer(false, null, true);
    }
}
SplitContainerBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitContainerBaseComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerTabOrderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SplitContainerBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SplitContainerBaseComponent, selector: "ng-component", inputs: { windowModel: "windowModel" }, viewQueries: [{ propertyName: "kendoSplitter", first: true, predicate: ["kendoSplitter"], descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], SplitContainerBaseComponent.prototype, "splitterDistance", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitContainerBaseComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerTabOrderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { kendoSplitter: [{
                type: ViewChild,
                args: ['kendoSplitter']
            }], windowModel: [{
                type: Input
            }], splitterDistance: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class SplitContainerPanelBaseComponent extends ControlContainerComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.webMapService = webMapService;
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        /**
         * Determines that it is a container.
         */
        this.isContainer = true;
        /**
         * Determines if the tab component should be registered
         */
        this.isTabRegister = false;
        /**
         * Override. A reference for managing component registration manually
         */
        this.registerManually = true;
    }
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.webComponents && this.model) {
            this.webComponents.registerComponent(this);
        }
    }
    /**
     * Angular life cycle hook
     */
    ngAfterViewChecked() {
        /* c8 ignore else */
        if (!this.isTabRegister && this.tabDir && this.model) {
            this.webComponents.registerComponent(this);
            this.tabDir.registerComponent();
            this.isTabRegister = true;
        }
        super.ngAfterViewChecked();
    }
    /**
     * Override
     * Gets tab order
     */
    get tabOrder() {
        return this.tabIndex;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * Gets display element
     * @returns HTML display element or undefined if element is not rendered
     */
    getDisplayElement() {
        return this.element?.nativeElement?.firstElementChild;
    }
}
SplitContainerPanelBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitContainerPanelBaseComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SplitContainerPanelBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SplitContainerPanelBaseComponent, selector: "ng-component", inputs: { windowModel: "windowModel", panelControls: "panelControls", tabIndex: "tabIndex" }, viewQueries: [{ propertyName: "tabDir", first: true, predicate: TabDirective, descendants: true }, { propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitContainerPanelBaseComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { windowModel: [{
                type: Input
            }], panelControls: [{
                type: Input
            }], tabDir: [{
                type: ViewChild,
                args: [TabDirective]
            }], tabIndex: [{
                type: Input
            }], displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }] } });

let SplitContainerPanelComponent = class SplitContainerPanelComponent extends SplitContainerPanelBaseComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
    }
};
SplitContainerPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitContainerPanelComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SplitContainerPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SplitContainerPanelComponent, selector: "wm-split-container-panel", inputs: { model: "model" }, providers: [ContainerTabOrderService, ContainerInteractionService], usesInheritance: true, ngImport: i0, template: "<div #displayElement wmTab [hostComponent]=\"this\">\r\n  <ng-content></ng-content>\r\n  <wm-custom-control-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"panelControls\"\r\n    [containerParent]=\"id\" [windowModel]=\"windowModel\" [controlType]=\"'split-container'\">\r\n  </wm-custom-control-container>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: TabDirective, selector: "[wmTab]", inputs: ["hostComponent"] }, { kind: "component", type: CustomControlContainerComponent, selector: "wm-custom-control-container", inputs: ["controls", "containerParent", "windowModel", "controlType"] }] });
SplitContainerPanelComponent = __decorate([
    dataTransfer(['splttrPnl']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], SplitContainerPanelComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitContainerPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-split-container-panel', inputs: ['model'], providers: [ContainerTabOrderService, ContainerInteractionService], template: "<div #displayElement wmTab [hostComponent]=\"this\">\r\n  <ng-content></ng-content>\r\n  <wm-custom-control-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"panelControls\"\r\n    [containerParent]=\"id\" [windowModel]=\"windowModel\" [controlType]=\"'split-container'\">\r\n  </wm-custom-control-container>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; } });

let SplitContainerComponent = class SplitContainerComponent extends SplitContainerBaseComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerTOrderService) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerTOrderService);
    }
};
SplitContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitContainerComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerTabOrderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SplitContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SplitContainerComponent, selector: "wm-split-container", providers: [ContainerTabOrderService, ContainerInteractionService], usesInheritance: true, ngImport: i0, template: "<kendo-splitter #kendoSplitter [ngClass]=\"class\" [orientation]=\"orientation\" wmTab [hostComponent]=\"this\">\r\n\r\n  <kendo-splitter-pane [ngStyle]=\"panel1Style\" *ngIf=\"panel1Collapsed\" [min]=\"panel1MinSize\" [(size)]=\"splitterDistance\"\r\n    [resizable]=\"!isSplitterFixed\" [scrollable]=\"panel1AutoScroll\">\r\n    <wm-split-container-panel [windowModel]=\"windowModel\" [panelControls]=\"panel1Controls\" [tabIndex]=\"tabOrder\"\r\n      [model]=\"panelModel1\">\r\n    </wm-split-container-panel>\r\n  </kendo-splitter-pane>\r\n\r\n  <kendo-splitter-pane [ngStyle]=\"panel2Style\" *ngIf=\"panel2Collapsed\" [min]=\"panel2MinSize\"\r\n    [scrollable]=\"panel2AutoScroll\">\r\n    <wm-split-container-panel [windowModel]=\"windowModel\" [panelControls]=\"panel2Controls\" [tabIndex]=\"tabOrder\"\r\n      [model]=\"panelModel2\">\r\n    </wm-split-container-panel>\r\n  </kendo-splitter-pane>\r\n</kendo-splitter>\r\n", styles: [".k-splitter-flex{height:100%!important}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i6$3.SplitterComponent, selector: "kendo-splitter", inputs: ["orientation", "resizeStep"], outputs: ["layoutChange"], exportAs: ["kendoSplitter"] }, { kind: "component", type: i6$3.SplitterPaneComponent, selector: "kendo-splitter-pane", inputs: ["order", "size", "separatorLabel", "min", "max", "resizable", "collapsible", "scrollable", "collapsed", "orientation", "containsSplitter", "overlayContent"], outputs: ["sizeChange", "collapsedChange"], exportAs: ["kendoSplitterPane"] }, { kind: "directive", type: TabDirective, selector: "[wmTab]", inputs: ["hostComponent"] }, { kind: "component", type: SplitContainerPanelComponent, selector: "wm-split-container-panel", inputs: ["model"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
SplitContainerComponent = __decorate([
    dataTransfer(['spltCntnr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerTabOrderService])
], SplitContainerComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitContainerComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-split-container', providers: [ContainerTabOrderService, ContainerInteractionService], template: "<kendo-splitter #kendoSplitter [ngClass]=\"class\" [orientation]=\"orientation\" wmTab [hostComponent]=\"this\">\r\n\r\n  <kendo-splitter-pane [ngStyle]=\"panel1Style\" *ngIf=\"panel1Collapsed\" [min]=\"panel1MinSize\" [(size)]=\"splitterDistance\"\r\n    [resizable]=\"!isSplitterFixed\" [scrollable]=\"panel1AutoScroll\">\r\n    <wm-split-container-panel [windowModel]=\"windowModel\" [panelControls]=\"panel1Controls\" [tabIndex]=\"tabOrder\"\r\n      [model]=\"panelModel1\">\r\n    </wm-split-container-panel>\r\n  </kendo-splitter-pane>\r\n\r\n  <kendo-splitter-pane [ngStyle]=\"panel2Style\" *ngIf=\"panel2Collapsed\" [min]=\"panel2MinSize\"\r\n    [scrollable]=\"panel2AutoScroll\">\r\n    <wm-split-container-panel [windowModel]=\"windowModel\" [panelControls]=\"panel2Controls\" [tabIndex]=\"tabOrder\"\r\n      [model]=\"panelModel2\">\r\n    </wm-split-container-panel>\r\n  </kendo-splitter-pane>\r\n</kendo-splitter>\r\n", styles: [".k-splitter-flex{height:100%!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerTabOrderService, decorators: [{
                    type: Optional
                }] }]; } });

let SplitterStaticPanelComponent = class SplitterStaticPanelComponent extends SplitContainerPanelBaseComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
    }
};
SplitterStaticPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitterStaticPanelComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SplitterStaticPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SplitterStaticPanelComponent, selector: "wm-splitter-static-panel", inputs: { model: "model" }, providers: [ContainerTabOrderService, ContainerInteractionService], usesInheritance: true, ngImport: i0, template: "<div #displayElement wmTab [hostComponent]=\"this\">\r\n  <ng-content></ng-content>\r\n  <wm-custom-control-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"panelControls\"\r\n    [containerParent]=\"id\" [windowModel]=\"windowModel\" [controlType]=\"'split-container'\">\r\n  </wm-custom-control-container>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: TabDirective, selector: "[wmTab]", inputs: ["hostComponent"] }, { kind: "component", type: CustomControlContainerComponent, selector: "wm-custom-control-container", inputs: ["controls", "containerParent", "windowModel", "controlType"] }] });
SplitterStaticPanelComponent = __decorate([
    dataTransfer(['splttrStaticPnl']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], SplitterStaticPanelComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitterStaticPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-splitter-static-panel', inputs: ['model'], providers: [ContainerTabOrderService, ContainerInteractionService], template: "<div #displayElement wmTab [hostComponent]=\"this\">\r\n  <ng-content></ng-content>\r\n  <wm-custom-control-container (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"panelControls\"\r\n    [containerParent]=\"id\" [windowModel]=\"windowModel\" [controlType]=\"'split-container'\">\r\n  </wm-custom-control-container>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; } });

let SplitStaticContainerComponent = class SplitStaticContainerComponent extends SplitContainerBaseComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerTOrderService) {
        super(webMapService, changeDetector, renderer2, element, webComponents, bringTopServ, containerTOrderService);
    }
    /**
     * Returns the class css name for each Splitter Panel inside the split container.
     * @param panelNum A number that indicates the number of the panel.
     * @return string
     */
    getPanelClassCss(panelNum) {
        return `${this.name}_Panel${panelNum}`;
    }
};
SplitStaticContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitStaticContainerComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerTabOrderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SplitStaticContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SplitStaticContainerComponent, selector: "wm-split-static-container", providers: [ContainerTabOrderService, ContainerInteractionService], queries: [{ propertyName: "panels", predicate: TemplateRef }], usesInheritance: true, ngImport: i0, template: "<kendo-splitter #kendoSplitter [ngClass]=\"class\" [orientation]=\"orientation\" wmTab [hostComponent]=\"this\">\r\n\r\n  <kendo-splitter-pane [ngStyle]=\"panel1Style\" class=\"{{ getPanelClassCss(1) }}\" *ngIf=\"panel1Collapsed\" [min]=\"panel1MinSize\" [(size)]=\"splitterDistance\"\r\n    [resizable]=\"!isSplitterFixed\" [scrollable]=\"panel1AutoScroll\">\r\n    <wm-splitter-static-panel [windowModel]=\"windowModel\" [panelControls]=\"panel1Controls\" [tabIndex]=\"tabOrder\"\r\n      [model]=\"panelModel1\">\r\n      <ng-template [ngTemplateOutlet]=\"panels?.toArray()[1]\"></ng-template>\r\n    </wm-splitter-static-panel>\r\n  </kendo-splitter-pane>\r\n\r\n  <kendo-splitter-pane [ngStyle]=\"panel2Style\" class=\"{{ getPanelClassCss(2) }}\" *ngIf=\"panel2Collapsed\" [min]=\"panel2MinSize\"\r\n    [scrollable]=\"panel2AutoScroll\">\r\n    <wm-splitter-static-panel [windowModel]=\"windowModel\" [panelControls]=\"panel2Controls\" [tabIndex]=\"tabOrder\"\r\n      [model]=\"panelModel2\">\r\n      <ng-template [ngTemplateOutlet]=\"panels?.toArray()[0]\"></ng-template>\r\n    </wm-splitter-static-panel>\r\n  </kendo-splitter-pane>\r\n\r\n</kendo-splitter>\r\n", styles: [".k-splitter-flex{height:100%!important}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i6$3.SplitterComponent, selector: "kendo-splitter", inputs: ["orientation", "resizeStep"], outputs: ["layoutChange"], exportAs: ["kendoSplitter"] }, { kind: "component", type: i6$3.SplitterPaneComponent, selector: "kendo-splitter-pane", inputs: ["order", "size", "separatorLabel", "min", "max", "resizable", "collapsible", "scrollable", "collapsed", "orientation", "containsSplitter", "overlayContent"], outputs: ["sizeChange", "collapsedChange"], exportAs: ["kendoSplitterPane"] }, { kind: "directive", type: TabDirective, selector: "[wmTab]", inputs: ["hostComponent"] }, { kind: "component", type: SplitterStaticPanelComponent, selector: "wm-splitter-static-panel", inputs: ["model"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
SplitStaticContainerComponent = __decorate([
    dataTransfer(['spltStaticCntnr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerTabOrderService])
], SplitStaticContainerComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SplitStaticContainerComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-split-static-container', providers: [ContainerTabOrderService, ContainerInteractionService], template: "<kendo-splitter #kendoSplitter [ngClass]=\"class\" [orientation]=\"orientation\" wmTab [hostComponent]=\"this\">\r\n\r\n  <kendo-splitter-pane [ngStyle]=\"panel1Style\" class=\"{{ getPanelClassCss(1) }}\" *ngIf=\"panel1Collapsed\" [min]=\"panel1MinSize\" [(size)]=\"splitterDistance\"\r\n    [resizable]=\"!isSplitterFixed\" [scrollable]=\"panel1AutoScroll\">\r\n    <wm-splitter-static-panel [windowModel]=\"windowModel\" [panelControls]=\"panel1Controls\" [tabIndex]=\"tabOrder\"\r\n      [model]=\"panelModel1\">\r\n      <ng-template [ngTemplateOutlet]=\"panels?.toArray()[1]\"></ng-template>\r\n    </wm-splitter-static-panel>\r\n  </kendo-splitter-pane>\r\n\r\n  <kendo-splitter-pane [ngStyle]=\"panel2Style\" class=\"{{ getPanelClassCss(2) }}\" *ngIf=\"panel2Collapsed\" [min]=\"panel2MinSize\"\r\n    [scrollable]=\"panel2AutoScroll\">\r\n    <wm-splitter-static-panel [windowModel]=\"windowModel\" [panelControls]=\"panel2Controls\" [tabIndex]=\"tabOrder\"\r\n      [model]=\"panelModel2\">\r\n      <ng-template [ngTemplateOutlet]=\"panels?.toArray()[0]\"></ng-template>\r\n    </wm-splitter-static-panel>\r\n  </kendo-splitter-pane>\r\n\r\n</kendo-splitter>\r\n", styles: [".k-splitter-flex{height:100%!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerTabOrderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { panels: [{
                type: ContentChildren,
                args: [TemplateRef]
            }] } });

let InputBoxComponent = class InputBoxComponent extends DialogBaseComponent {
    /* c8 ignore start */
    constructor(wmservice, refChanges, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(refChanges, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.refChanges = refChanges;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /**
         * Variable that checks if the textbox content should be selected
         */
        this.selectContent = true;
        this.webServices = wmservice;
        this.enableButtons = true;
    }
    ngDoCheck() {
        super.ngDoCheck();
        if (this.input && this.selectContent) {
            this.selectsTextBoxContent();
            this.selectContent = false;
        }
    }
    ngAfterViewInit() {
        this.initializeButtonCloseElement();
    }
    click(event, buttonId) {
        this.enableButtons = false;
        this.webServices.invoke(new SendV5(this, 'Click', buttonId, 'Click'));
    }
    /**
     * Gets the inputbox's buttonOk model
     */
    get buttonOk() {
        return this.model && this.model.ButtonOk ? this.model.ButtonOk : undefined;
    }
    /**
     * Gets the inputbox's buttonCancel model
     */
    get buttonCancel() {
        return this.model && this.model.ButtonCancel
            ? this.model.ButtonCancel
            : undefined;
    }
    /**
     * Gets the inputbox's LabelMessage value
     */
    get labelMessage() {
        return this.model.LabelMessage;
    }
    /**
     * Sets the inputbox's defaultResponse value
     */
    set defaultResponse(value) {
        this.model.DefaultResponse = value;
    }
    /**
     * Gets the inputbox's defaultResponse value
     */
    get defaultResponse() {
        return this.model.DefaultResponse;
    }
    /**
     * Moves focus to close button after leaving input box when
     * the tab key is pressed.
     * @param event Event Data
     */
    tabLeaveAction(event) {
        /* c8 ignore else */
        if (this.buttonClose) {
            Utils.preventPropagation(event);
            this.buttonClose.focus();
        }
    }
    /**
     * Moves focus to the input box after leaving close button when
     * the shift + tab key is pressed.
     * @param event Event Data
     */
    tabShiftLeaveAction(event) {
        /* c8 ignore else */
        if (this.input && this.input.nativeElement) {
            Utils.preventPropagation(event);
            this.input.nativeElement.focus();
        }
    }
    /**
     * Selects the textbox content
     */
    selectsTextBoxContent() {
        this.input.nativeElement.select();
    }
};
InputBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InputBoxComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
InputBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: InputBoxComponent, selector: "wm-inputbox", viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\">\r\n    <kendo-dialog *ngIf=\"visible\" [width]=\"400\" (close)=\"click($event, buttonCancel.UniqueID)\">\r\n        <kendo-dialog-titlebar #titleBar (keydown.shift.tab)=\"tabShiftLeaveAction($event)\">\r\n            {{text}}\r\n        </kendo-dialog-titlebar>\r\n        <div class=\"labelMessage\">\r\n            <p>{{labelMessage}}</p>\r\n        </div>\r\n        <div class=\"buttons\">\r\n            <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonOk.UniqueID)\"\r\n                *ngIf=\"buttonOk\">{{buttonOk.Text}}</button>\r\n            <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonCancel.UniqueID)\"\r\n                *ngIf=\"buttonCancel\">{{buttonCancel.Text}}</button>\r\n        </div>\r\n        <input #input kendoTextBox class=\"k-form-field\" [(ngModel)]=\"defaultResponse\" (keydown.tab)=\"tabLeaveAction($event)\"/>\r\n    </kendo-dialog>\r\n</div>", styles: ["kendo-dialog{z-index:100000}kendo-dialog-actions{flex-wrap:nowrap!important}kendo-dialog-actions>button{width:100%!important}.labelMessage{width:278px;margin:5px;float:left}.buttons{float:left;width:100px}.buttons button{margin:5px;width:80px}input{width:388px;margin:5px}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i7.DialogComponent, selector: "kendo-dialog", inputs: ["actions", "actionsLayout", "autoFocusedElement", "title", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "animation", "themeColor"], outputs: ["action", "close"], exportAs: ["kendoDialog"] }, { kind: "component", type: i7.DialogTitleBarComponent, selector: "kendo-dialog-titlebar", inputs: ["id", "closeTitle"], outputs: ["close"] }, { kind: "directive", type: i8.TextBoxDirective, selector: "input[kendoTextBox]", inputs: ["value"] }] });
__decorate([
    NotifyChange('DefaultResponse'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], InputBoxComponent.prototype, "defaultResponse", null);
InputBoxComponent = __decorate([
    dataTransfer(['inptBx']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], InputBoxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InputBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-inputbox', template: "<div *ngIf=\"model\">\r\n    <kendo-dialog *ngIf=\"visible\" [width]=\"400\" (close)=\"click($event, buttonCancel.UniqueID)\">\r\n        <kendo-dialog-titlebar #titleBar (keydown.shift.tab)=\"tabShiftLeaveAction($event)\">\r\n            {{text}}\r\n        </kendo-dialog-titlebar>\r\n        <div class=\"labelMessage\">\r\n            <p>{{labelMessage}}</p>\r\n        </div>\r\n        <div class=\"buttons\">\r\n            <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonOk.UniqueID)\"\r\n                *ngIf=\"buttonOk\">{{buttonOk.Text}}</button>\r\n            <button [disabled]=\"!enableButtons\" class='k-button' (click)=\"click($event, buttonCancel.UniqueID)\"\r\n                *ngIf=\"buttonCancel\">{{buttonCancel.Text}}</button>\r\n        </div>\r\n        <input #input kendoTextBox class=\"k-form-field\" [(ngModel)]=\"defaultResponse\" (keydown.tab)=\"tabLeaveAction($event)\"/>\r\n    </kendo-dialog>\r\n</div>", styles: ["kendo-dialog{z-index:100000}kendo-dialog-actions{flex-wrap:nowrap!important}kendo-dialog-actions>button{width:100%!important}.labelMessage{width:278px;margin:5px;float:left}.buttons{float:left;width:100px}.buttons button{margin:5px;width:80px}input{width:388px;margin:5px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { input: [{
                type: ViewChild,
                args: ['input', { static: false }]
            }], defaultResponse: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
var Shape;
(function (Shape) {
    Shape[Shape["Rectangle"] = 0] = "Rectangle";
    Shape[Shape["Square"] = 1] = "Square";
    Shape[Shape["Oval"] = 2] = "Oval";
    Shape[Shape["Circle"] = 3] = "Circle";
    Shape[Shape["RoundRectangle"] = 4] = "RoundRectangle";
    Shape[Shape["RoundSquare"] = 5] = "RoundSquare";
})(Shape || (Shape = {}));

/**
 * Constants
 */
const strokeDasharray = 'stroke-dasharray';
const backgroundColor = 'background-color';
let ShapeComponent = class ShapeComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        /* c8 ignore stop */
        this.shapeEnum = Shape;
    }
    /**
     * Returns the backstyle
     */
    get backStyle() {
        return this.model.BackStyle === 0
            ? 0 /* BackStyle.Transparent */
            : 1 /* BackStyle.Opaque */;
    }
    /**
     * Returns the borderstyle
     */
    get borderStyle() {
        return this.model.BorderStyle;
    }
    /**
     * Returns the shape
     */
    get shape() {
        return this.model.Shape;
    }
    /**
     * Returns the fillstyle
     */
    get fillStyle() {
        return this.model.FillStyle;
    }
    /**
     * Returns the fillcolor
     */
    get fillColor() {
        return this.model.FillColor;
    }
    /**
     * Calculates the svg element style based on the component properties
     */
    calculateSvgStyle() {
        return this.fillStyle !== 1 /* FillStyle.Transparent */
            ? this.calculateFillStyle()
            : this.calculateBackStyle();
    }
    /**
     * Calculates the second svg element style based on the component properties,
     * this second svg tag is used when the fillstyle is cross or diagonalcross
     */
    calculateSvgStyleSecondShape() {
        return this.calculateFillStyleSecondShape();
    }
    /**
     * Calculates the svg style based on the backstyle property
     */
    calculateBackStyle() {
        const temp = {};
        /* c8 ignore else */
        if (this.backStyle === 0 /* BackStyle.Transparent */) {
            temp[backgroundColor] = 'transparent';
        }
        return temp;
    }
    /**
     * Calculates the shape (rect, circle, ellipsis) style based on the model properties
     */
    calculateShapeStyle() {
        const style = { opacity: 1, fill: 'transparent' };
        this.calculateBorderStyle(style);
        return style;
    }
    /**
     * Calculates the shape (rect, circle, ellipsis) border style based on the borderstyle property
     */
    calculateBorderStyle(currentStyle) {
        let borderIsVisible = true;
        switch (this.borderStyle) {
            case 0 /* BorderStyle.Transparent */:
                borderIsVisible = false;
                break;
            case 2 /* BorderStyle.Dash */:
                currentStyle[strokeDasharray] = '10 5';
                break;
            case 3 /* BorderStyle.Dot */:
                currentStyle[strokeDasharray] = '3 3';
                break;
            case 4 /* BorderStyle.DashDot */:
                currentStyle[strokeDasharray] = '10 5 2 3';
                break;
            case 5 /* BorderStyle.DashDotDot */:
                currentStyle[strokeDasharray] = '10 5 2 3 2 3';
                break;
            case 1 /* BorderStyle.Solid */:
            case 6 /* BorderStyle.InsideSolid */:
            default:
                // nothing to do
                break;
        }
        /* c8 ignore else */
        if (borderIsVisible) {
            currentStyle['stroke-width'] = '2';
            currentStyle['stroke'] = 'rgb(0,0,0)';
        }
        return currentStyle;
    }
    /**
     * Calculates the svg element style based on the fillstyle property
     */
    calculateFillStyle() {
        const temp = {};
        switch (this.fillStyle) {
            case 0 /* FillStyle.Solid */:
                temp[backgroundColor] = this.fillColor;
                return temp;
            case 1 /* FillStyle.Transparent */:
                temp[backgroundColor] = 'transparent';
                return temp;
            case 2 /* FillStyle.HorizontalLine */:
                return {
                    background: `repeating-linear-gradient(180deg, ${this.fillColor} 0px, ${this.fillColor} 0px, transparent 2px, transparent 10px)`
                };
            case 6 /* FillStyle.Cross */:
            case 3 /* FillStyle.VerticalLine */:
                return {
                    background: `repeating-linear-gradient(90deg, ${this.fillColor} 0px, ${this.fillColor} 0px, transparent 2px, transparent 10px)`
                };
            case 7 /* FillStyle.DiagonalCross */:
            case 4 /* FillStyle.DownwardDiagonal */:
                return {
                    background: `repeating-linear-gradient(45deg, ${this.fillColor} 0px, ${this.fillColor} 0px, transparent 2px, transparent 10px)`
                };
            case 5 /* FillStyle.UpwardDiagonal */:
                return {
                    background: `repeating-linear-gradient(-45deg, ${this.fillColor} 0px, ${this.fillColor} 0px, transparent 2px, transparent 10px)`
                };
            default:
                return {};
        }
    }
    /**
     * Calculates the second svg element style based on the fillstyle property,
     * the second svg element is required just for the Cross and DiagonalCross
     * FillStyle cases
     */
    calculateFillStyleSecondShape() {
        switch (this.fillStyle) {
            case 6 /* FillStyle.Cross */:
                return {
                    background: `repeating-linear-gradient(180deg, ${this.fillColor} 0px, ${this.fillColor} 0px, transparent 2px, transparent 10px)`
                };
            case 7 /* FillStyle.DiagonalCross */:
                return {
                    background: `repeating-linear-gradient(-45deg, ${this.fillColor} 0px, ${this.fillColor} 0px, transparent 2px, transparent 10px)`
                };
            default:
                return {};
        }
    }
    /**
     * Return a boolean value which indicates if is required a second svg element in the html, this second element is because
     * Cross and DiagonalCross fillstyles requires two elements overlapped with opposite gradients
     */
    requiresSecondShape() {
        return (this.model &&
            (this.fillStyle === 6 /* FillStyle.Cross */ ||
                this.fillStyle === 7 /* FillStyle.DiagonalCross */));
    }
};
ShapeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShapeComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ShapeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ShapeComponent, selector: "wm-shape", usesInheritance: true, ngImport: i0, template: "<svg *ngIf=\"model && model.Visible\" [ngClass]=\"class\" [ngStyle]=\"calculateSvgStyle()\">\r\n        <rect *ngIf=\"shape === shapeEnum.Rectangle\" width=\"100%\" height=\"100%\" [ngStyle]=\"calculateShapeStyle()\"></rect>\r\n</svg>\r\n<svg *ngIf=\"requiresSecondShape() && model.Visible\" [ngClass]=\"class\" [ngStyle]=\"calculateSvgStyleSecondShape()\">\r\n        <rect *ngIf=\"shape === shapeEnum.Rectangle\" width=\"100%\" height=\"100%\" [ngStyle]=\"calculateShapeStyle()\"></rect>\r\n</svg>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
ShapeComponent = __decorate([
    dataTransfer(['shphlpr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], ShapeComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShapeComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-shape', template: "<svg *ngIf=\"model && model.Visible\" [ngClass]=\"class\" [ngStyle]=\"calculateSvgStyle()\">\r\n        <rect *ngIf=\"shape === shapeEnum.Rectangle\" width=\"100%\" height=\"100%\" [ngStyle]=\"calculateShapeStyle()\"></rect>\r\n</svg>\r\n<svg *ngIf=\"requiresSecondShape() && model.Visible\" [ngClass]=\"class\" [ngStyle]=\"calculateSvgStyleSecondShape()\">\r\n        <rect *ngIf=\"shape === shapeEnum.Rectangle\" width=\"100%\" height=\"100%\" [ngStyle]=\"calculateShapeStyle()\"></rect>\r\n</svg>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class WmusercontrolComponent extends ControlContainerComponent {
    /* c8 ignore start */
    constructor(serviceRef1, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction, containerTOrderService) {
        super(serviceRef1, changeDetector, renderer2, element, webComponents, bringTopServ, containerInteraction);
        this.serviceRef1 = serviceRef1;
        this.element = element;
        this.containerInteraction = containerInteraction;
        this.containerTOrderService = containerTOrderService;
        /* c8 ignore stop */
        /**
         * Determines that it is a container.
         */
        this.isContainer = true;
        /**
         * Flag that indicates whether dynamic controls should be rendered or not.
         */
        this.dynamicControls = true;
    }
    /**
     * Gets tab order
     */
    get tabOrder() {
        return this.calculateTabOrder();
    }
    /**
     * Overrides the interaction event in order to left the inner
     * container without Docking mechanism
     */
    ngOnInit() {
        this.containerInteractionSubscription();
    }
    /**
     * AfterViewInit life-cycle hook
     */
    ngAfterViewInit() {
        // Checks if it is a custom user control, if so, makes the user control visible.
        if (this.isCustomControl()) {
            this.model.Visible = true;
            this.applyFocus();
        }
    }
    /**
     * Applies focus to first inner element by tab index
     */
    applyFocus() {
        this.containerTOrderService.enterContainer(false, null, true);
    }
    /**
     * Determines whether controls collection is defined and has controls
     * @returns true if controls collection is defined and has controls
     */
    hasControls() {
        return (this.dynamicControls &&
            this.model.Controls &&
            Object.keys(this.model.Controls).length > 0);
    }
}
WmusercontrolComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WmusercontrolComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }, { token: ContainerTabOrderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
WmusercontrolComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: WmusercontrolComponent, selector: "wm-usercontrol", inputs: { dynamicClass: "dynamicClass", dynamicControls: "dynamicControls" }, providers: [ContainerInteractionService, ContainerTabOrderService], usesInheritance: true, ngImport: i0, template: "<ng-container wmTab [hostComponent]=\"this\">\r\n  <ng-content>\r\n  </ng-content>\r\n  <wm-container *ngIf=\"hasControls()\" (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\" [ngClass]=\"class\" [class]=\"dynamicClass\">\r\n  </wm-container>\r\n</ng-container>", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.ContainerComponent, selector: "wm-container", inputs: ["controls"], outputs: ["RemoveControl"] }, { kind: "directive", type: TabDirective, selector: "[wmTab]", inputs: ["hostComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WmusercontrolComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-usercontrol', providers: [ContainerInteractionService, ContainerTabOrderService], template: "<ng-container wmTab [hostComponent]=\"this\">\r\n  <ng-content>\r\n  </ng-content>\r\n  <wm-container *ngIf=\"hasControls()\" (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"model.Controls\" [ngClass]=\"class\" [class]=\"dynamicClass\">\r\n  </wm-container>\r\n</ng-container>" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: ContainerTabOrderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { dynamicClass: [{
                type: Input
            }], dynamicControls: [{
                type: Input
            }] } });

class UserControlComponent extends FormComponent {
    /* c8 ignore start */
    constructor(webMapService, changeDetector, renderer2, elementUC, webComponents) {
        super(webMapService, changeDetector, renderer2, elementUC, webComponents);
        this.webMapService = webMapService;
        this.elementUC = elementUC;
    }
    /**
     * AfterViewInit method of UserControlComponent
     *
     * @memberof UserControlComponent
     */
    /* c8 ignore start */
    ngAfterViewInit() {
        // Here is assigned the first found element of the QueryList
        if (this.innerWmControl == null &&
            this.innerWmControlQueryList.length > 0) {
            this.innerWmControl = this.innerWmControlQueryList.first;
        }
        super.ngAfterViewInit();
    }
    /* c8 ignore stop */
    /**
     * Gets if is usercontrol or not
     */
    isUserControl() {
        return true;
    }
    /**
     * Set enable property for user control component
     *
     * @memberof UserControlComponent
     */
    set enabled(value) {
        this.model.Enabled = value;
        this.changeReferencesEnabledStatus(value);
    }
    /**
     * Gets enabled property for user control component
     */
    get enabled() {
        return super.enabled;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    /* c8 ignore start */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /* c8 ignore end */
    /**
     * Iterates over references control models and update their values
     *
     * @param {boolean} value
     * @memberof UserControlComponent
     */
    changeReferencesEnabledStatus(value) {
        if (this.model.references) {
            for (const property in this.model.references) {
                if (!property.includes('ParentInternal')) {
                    const reference = this.model.references[property];
                    const model = this.webMapService.core.getModel(reference);
                    /* c8 ignore else */
                    if (model) {
                        model.Enabled = value;
                    }
                }
            }
        }
    }
    /**
     * Gets display element with third deepest element inside of user-control if it exists.
     * By convention third deepest element should be the a valid content, however this is the default value
     * displayElement should be set by UserControl developers with the representative visual
     * element of UserControl
     * @returns HTMLElement with display element of User Control
     */
    getDisplayElement() {
        return this.elementUC?.nativeElement?.firstElementChild?.firstElementChild
            ?.firstElementChild;
    }
}
UserControlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UserControlComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }], target: i0.ɵɵFactoryTarget.Component });
UserControlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: UserControlComponent, selector: "ng-component", viewQueries: [{ propertyName: "innerWmControl", first: true, predicate: WmusercontrolComponent, descendants: true, static: true }, { propertyName: "innerWmControlQueryList", predicate: WmusercontrolComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('Enabled'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], UserControlComponent.prototype, "enabled", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UserControlComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }]; }, propDecorators: { innerWmControl: [{
                type: ViewChild,
                args: [WmusercontrolComponent, { static: true }]
            }], innerWmControlQueryList: [{
                type: ViewChildren,
                args: [WmusercontrolComponent]
            }], enabled: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class DisabledItemDirective {
    /* c8 ignore next */
    constructor(el) {
        this.el = el;
    }
    ngAfterViewChecked() {
        /* c8 ignore next 4 */
        if (this.wmDisabledItem !== undefined && !this.wmDisabledItem) {
            this.el.nativeElement.parentNode.parentNode.style.pointerEvents = 'none';
            this.el.nativeElement.parentNode.parentNode.style.opacity = '0.5';
        }
    }
}
DisabledItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DisabledItemDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
DisabledItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: DisabledItemDirective, selector: "[wmDisabledItem]", inputs: { wmDisabledItem: "wmDisabledItem" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DisabledItemDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[wmDisabledItem]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { wmDisabledItem: [{
                type: Input
            }] } });

let BindingnavigatorComponent = class BindingnavigatorComponent extends ToolStripComponent {
    /* c8 ignore start */
    constructor(srvc, chngDetector, rend2, elmnt, webCoCmpnts, toolstripSrvc, bindingNavSrvc, bringTopSrvc, ctnrInteraction) {
        super(srvc, chngDetector, rend2, elmnt, webCoCmpnts, toolstripSrvc, bringTopSrvc, ctnrInteraction);
        this.srvc = srvc;
        this.chngDetector = chngDetector;
        this.rend2 = rend2;
        this.elmnt = elmnt;
        this.toolstripSrvc = toolstripSrvc;
        this.bindingNavSrvc = bindingNavSrvc;
        this.bringTopSrvc = bringTopSrvc;
        this.ctnrInteraction = ctnrInteraction;
        this.Click = new EventEmitter();
    }
    /**
     * Indicates if component should allow item reorder from model
     *
     * @returns boolean
     */
    get allowItemReorder() {
        return this.model.AllowItemReorder;
    }
    /**
     * Gets the disabled css class name if it is required
     *
     * @returns string
     */
    get disabledClass() {
        return `${this.enabled ? '' : 'disabled'}`;
    }
    /**
     * Gets the backgroundimage url from model
     *
     * @returns string
     */
    get backgroundImage() {
        return this.model.Style?.BackgroundImage != null
            ? `url(${this.model.Style.BackgroundImage})`
            : 'none';
    }
    /**
     * Gets if the component has and background image
     *
     * @returns boolean true if has and backgroundImage otherwise false
     */
    get hasBackgroundImage() {
        return !!this.model.Style?.BackgroundImage != null;
    }
    click(event) {
        this.Click.emit(new EventData$1(event, this.id));
    }
    /**
     *  Method called by the Angular lifecycle hook
     */
    /* c8 ignore next */
    ngOnInit() {
        super.ngOnInit();
        this.eventEmitterSubscription =
            this.bindingNavSrvc.bindingNavigatorEventNotification.subscribe((event) => {
                this.click(event);
            });
    }
    /**
     *  Method called by the Angular lifecycle hook
     */
    ngOnDestroy() {
        this.eventEmitterSubscription.unsubscribe();
        this.dragDropActionsUnsubscribe();
        super.ngOnDestroy();
    }
    /**
     * OnDragover handler.
     * This event is fired as the mouse is moved over an element when a drag is occurring.
     *
     * @param  {any} event
     * @returns void
     */
    allowDropThis(event) {
        event.preventDefault();
    }
    /**
     * OnDragStart handler
     *
     * @param  {any} event event args from event
     * @returns void
     */
    dragThis(event) {
        event.dataTransfer.effectAllowed = 'move';
        // Storing the dragged kendo-toolbar-renderer
        this.draggedElement = this.getKendoToolBarRendererElement(event.target);
    }
    /**
     * OnDrop handler
     *
     * @param  {any} event event args from event
     * @returns void
     */
    dropThis(event) {
        event.preventDefault();
        // Getting the kendo-toolbar-renderer where the drop action is executed
        const posItm = this.getKendoToolBarRendererElement(event.target);
        /* c8 ignore else */
        if (posItm != null) {
            // The draggedElement will be inserted into the kendo-toolbar component
            this.toolbar.element.nativeElement.insertBefore(this.draggedElement, posItm === this.draggedElement.previousElementSibling
                ? posItm
                : posItm.nextElementSibling);
        }
    }
    /**
     * @param  {any} target
     * @returns any
     */
    getKendoToolBarRendererElement(target) {
        /* c8 ignore else */
        if (target.localName !== 'kendo-toolbar-renderer') {
            return target.closest('kendo-toolbar-renderer');
        }
        return target;
    }
    /**
     * Subscribe dragDrop handlers if it is required
     *
     * @returns void
     */
    /* c8 ignore next */
    dragDropActionsSubscribe() {
        /* c8 ignore else */
        if (this.toolbar && this.allowItemReorder && this.toolbar.renderedTools) {
            this.toolbar.renderedTools.toArray().forEach((ele) => {
                // Adding html5 attribute to kendo-toolbar-renderer elements
                this.rend2.setAttribute(ele.element.nativeElement, 'draggable', 'true');
                // Adding handler
                this.dragstartSubscription = this.rend2.listen(ele.element.nativeElement, 'dragstart', (event) => {
                    this.dragThis(event);
                });
            });
        }
    }
    /**
     * Unsubscribe dragDrop hanldlers if it is required
     *
     * @returns void
     */
    dragDropActionsUnsubscribe() {
        /* c8 ignore else */
        if (this.toolbar && this.allowItemReorder) {
            this.dragstartSubscription();
        }
    }
    /**
     * Override
     * Load items from model and subscribe the dragDrop handlers if it is required
     * loadItemsModels is called from toolstrip component
     *
     * @returns void
     */
    loadItemsModels() {
        super.loadItemsModels();
        this.dragDropActionsSubscribe();
        this.itemsAlignment(this.rend2);
    }
};
BindingnavigatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BindingnavigatorComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: ToolstripInteractionService }, { token: BindingNavigatorService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
BindingnavigatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BindingnavigatorComponent, selector: "wm-bindingnavigator", inputs: { model: "model" }, outputs: { Click: "Click" }, providers: [ToolstripInteractionService, BindingNavigatorService], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model && model.Visible\" [ngClass]=\"disabledClass\" class=\"bindingStyle\" [ngStyle]=\"setMyStyle()\"\r\n    (drop)=\"dropThis($event)\" (dragover)=\"allowDropThis($event)\" [style.background-image]=\"backgroundImage\"\r\n    [attr.data-hasImage]=\"hasBackgroundImage\" (click)=\"click($event)\">\r\n    <kendo-toolbar #toolbar [overflow]=\"canOverflow\" wmControls [hostComponent]=\"this\">\r\n        <ng-container *ngFor=\"let item of items\">\r\n            <wm-top-level-toolstrip-item *ngIf=\"item.Visible\" [items]=\"[item]\">\r\n            </wm-top-level-toolstrip-item>\r\n        </ng-container>\r\n    </kendo-toolbar>\r\n</div>", styles: ["div.bindingStyle,.k-toolbar.k-toolbar-resizable{height:inherit}div.bindingStyle .k-menu-link{padding:unset!important}div.disabled{opacity:.5;pointer-events:none}div.separator-vertical{align-content:center;border-left:1px solid;height:15px}div.separator-horizontal{align-content:center;border-bottom:1px solid;width:100%}div[data-hasImage=true]>kendo-toolbar{background-color:transparent}div[data-hasImage=true]{background-size:contain}div.bindingStyle .k-toolbar div.bindingStyle .k-button,div.bindingStyle .k-toolbar div.bindingStyle .k-split-button,div.bindingStyle .k-toolbar div.bindingStyle .k-button-group,div.bindingStyle .k-toolbar div.bindingStyle .k-widget,div.bindingStyle .k-toolbar span:not(.k-maskedtextbox) div.bindingStyle .k-textbox,div.bindingStyle .k-toolbar label,div.bindingStyle .k-toolbar div.bindingStyle .k-separator{margin:unset!important}wm-bindingnavigator kendo-toolbar{display:block!important;padding:0!important}wm-bindingnavigator kendo-toolbar-renderer{margin:4px}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i8$3.ToolBarComponent, selector: "kendo-toolbar", inputs: ["overflow", "resizable", "popupSettings", "tabindex", "size", "tabIndex"], outputs: ["open", "close"], exportAs: ["kendoToolBar"] }, { kind: "component", type: TopLevelToolstripItemComponent, selector: "wm-top-level-toolstrip-item", inputs: ["items"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
__decorate([
    serverEvent('Click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BindingnavigatorComponent.prototype, "click", null);
BindingnavigatorComponent = __decorate([
    dataTransfer(['bndNgr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        ToolstripInteractionService,
        BindingNavigatorService,
        BringTopService,
        ContainerInteractionService])
], BindingnavigatorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BindingnavigatorComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-bindingnavigator', inputs: ['model'], providers: [ToolstripInteractionService, BindingNavigatorService], encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"model && model.Visible\" [ngClass]=\"disabledClass\" class=\"bindingStyle\" [ngStyle]=\"setMyStyle()\"\r\n    (drop)=\"dropThis($event)\" (dragover)=\"allowDropThis($event)\" [style.background-image]=\"backgroundImage\"\r\n    [attr.data-hasImage]=\"hasBackgroundImage\" (click)=\"click($event)\">\r\n    <kendo-toolbar #toolbar [overflow]=\"canOverflow\" wmControls [hostComponent]=\"this\">\r\n        <ng-container *ngFor=\"let item of items\">\r\n            <wm-top-level-toolstrip-item *ngIf=\"item.Visible\" [items]=\"[item]\">\r\n            </wm-top-level-toolstrip-item>\r\n        </ng-container>\r\n    </kendo-toolbar>\r\n</div>", styles: ["div.bindingStyle,.k-toolbar.k-toolbar-resizable{height:inherit}div.bindingStyle .k-menu-link{padding:unset!important}div.disabled{opacity:.5;pointer-events:none}div.separator-vertical{align-content:center;border-left:1px solid;height:15px}div.separator-horizontal{align-content:center;border-bottom:1px solid;width:100%}div[data-hasImage=true]>kendo-toolbar{background-color:transparent}div[data-hasImage=true]{background-size:contain}div.bindingStyle .k-toolbar div.bindingStyle .k-button,div.bindingStyle .k-toolbar div.bindingStyle .k-split-button,div.bindingStyle .k-toolbar div.bindingStyle .k-button-group,div.bindingStyle .k-toolbar div.bindingStyle .k-widget,div.bindingStyle .k-toolbar span:not(.k-maskedtextbox) div.bindingStyle .k-textbox,div.bindingStyle .k-toolbar label,div.bindingStyle .k-toolbar div.bindingStyle .k-separator{margin:unset!important}wm-bindingnavigator kendo-toolbar{display:block!important;padding:0!important}wm-bindingnavigator kendo-toolbar-renderer{margin:4px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: ToolstripInteractionService }, { type: BindingNavigatorService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { Click: [{
                type: Output
            }], click: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * ScrollOrientation Enum that contains the 2 possible orientations of the ScrollBar Component
 *
 * @export
 * @enum {number}
 */
var ScrollOrientation;
(function (ScrollOrientation) {
    /**
     *  HorizontalScroll Value
     */
    ScrollOrientation[ScrollOrientation["HorizontalScroll"] = 0] = "HorizontalScroll";
    /**
     * VerticalScroll Value
     */
    ScrollOrientation[ScrollOrientation["VerticalScroll"] = 1] = "VerticalScroll";
})(ScrollOrientation || (ScrollOrientation = {}));

/**
 * Horizontal Scroll Bar component
 *
 * @export
 * @class HscrollbarComponent
 * @extends {ScrollBarComponent}
 */
let HscrollbarComponent = class HscrollbarComponent extends ScrollBarComponent {
    /* c8 ignore start */
    /**
     * Creates an instance of HscrollbarComponent.
     * @param {ChangeDetectorRef} refChangeDetector
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} [bringTService]
     * @param {ContainerInteractionService} [contInteraction]
     * @memberof HscrollbarComponent
     */
    constructor(refChangeDetector, render2, elem, webComponents, bringTService, contInteraction) {
        super(refChangeDetector, render2, elem, webComponents, bringTService, contInteraction);
        this.orientation = ScrollOrientation.HorizontalScroll;
    }
};
HscrollbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HscrollbarComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
HscrollbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: HscrollbarComponent, selector: "wm-hscrollbar", usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\">\r\n  <kendo-slider [tickPlacement]=\"'none'\" [min]=\"minimum\" [max]=\"maximum\" [smallStep]=\"smallChange\" [(ngModel)]=\"newValue\"\r\n  [disabled]=\"disabled\" [tabIndex]=\"tabindex\" (valueChange) = \"valueChanged($event)\">\r\n  </kendo-slider>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i8.SliderComponent, selector: "kendo-slider", inputs: ["focusableId", "dragHandleTitle", "incrementTitle", "animate", "decrementTitle", "showButtons", "value", "tabIndex"], exportAs: ["kendoSlider"] }] });
HscrollbarComponent = __decorate([
    dataTransfer(['hscrllbr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], HscrollbarComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HscrollbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-hscrollbar', template: "<div [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\">\r\n  <kendo-slider [tickPlacement]=\"'none'\" [min]=\"minimum\" [max]=\"maximum\" [smallStep]=\"smallChange\" [(ngModel)]=\"newValue\"\r\n  [disabled]=\"disabled\" [tabIndex]=\"tabindex\" (valueChange) = \"valueChanged($event)\">\r\n  </kendo-slider>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; } });

/**
 * Vertical Scroll Bar component
 *
 * @export
 * @class VscrollbarComponent
 * @extends {ScrollBarComponent}
 */
let VscrollbarComponent = class VscrollbarComponent extends ScrollBarComponent {
    /* c8 ignore start */
    /**
     * Creates an instance of VscrollbarComponent.
     * @param {ChangeDetectorRef} refChangeDetector
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} [bringTService]
     * @param {ContainerInteractionService} [contInteraction]
     * @memberof VscrollbarComponent
     */
    constructor(refChangeDetector, render2, elem, webComponents, bringTService, contInteraction) {
        super(refChangeDetector, render2, elem, webComponents, bringTService, contInteraction);
        this.orientation = ScrollOrientation.VerticalScroll;
    }
    /* c8 ignore stop */
    /**
     * Getter to make the inverted value so the kendo-slider is inverted
     *
     * @type {number}
     * @memberof VscrollbarComponent
     */
    get invertedValue() {
        return this.newValue * -1;
    }
    /**
     * Setter to make the inverted value so the kendo-slider is inverted
     *
     * @type {number}
     * @memberof VscrollbarComponent
     */
    set invertedValue(value) {
        this.newValue = value * -1;
    }
};
VscrollbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: VscrollbarComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
VscrollbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: VscrollbarComponent, selector: "wm-vscrollbar", usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\">\r\n  <kendo-slider [vertical]=\"true\" [tickPlacement]=\"'none'\" [min]=\"maximum*-1\" [max]=\"minimum*-1\" [smallStep]=\"1\" [(ngModel)]=\"invertedValue\"\r\n  [disabled]=\"disabled\" [tabIndex]=\"tabindex\" (valueChange)=\"valueChanged($event)\">\r\n  </kendo-slider>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i8.SliderComponent, selector: "kendo-slider", inputs: ["focusableId", "dragHandleTitle", "incrementTitle", "animate", "decrementTitle", "showButtons", "value", "tabIndex"], exportAs: ["kendoSlider"] }] });
VscrollbarComponent = __decorate([
    dataTransfer(['vscrllbr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], VscrollbarComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: VscrollbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-vscrollbar', template: "<div [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\">\r\n  <kendo-slider [vertical]=\"true\" [tickPlacement]=\"'none'\" [min]=\"maximum*-1\" [max]=\"minimum*-1\" [smallStep]=\"1\" [(ngModel)]=\"invertedValue\"\r\n  [disabled]=\"disabled\" [tabIndex]=\"tabindex\" (valueChange)=\"valueChanged($event)\">\r\n  </kendo-slider>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; } });

var ProgressBarStyle;
(function (ProgressBarStyle) {
    ProgressBarStyle[ProgressBarStyle["Blocks"] = 0] = "Blocks";
    ProgressBarStyle[ProgressBarStyle["Continuous"] = 1] = "Continuous";
    ProgressBarStyle[ProgressBarStyle["Marquee"] = 2] = "Marquee";
})(ProgressBarStyle || (ProgressBarStyle = {}));
let ProgressBarComponent = class ProgressBarComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(service, changeDetector, rndr2, element, webComponents, bringTopServ, containerInteraction) {
        super(changeDetector, rndr2, element, webComponents, bringTopServ, containerInteraction);
        this.service = service;
        this.changeDetector = changeDetector;
        this.rndr2 = rndr2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.defaultDataUrl = 'api/progressbar';
        /**
         * Optional input parameter to specify a request time of data. Three seconds it's the default value.
         */
        this.timeout = 3000;
    }
    ngAfterViewInit() {
        this.isMarquee = this.model.Style === ProgressBarStyle.Marquee;
        /* c8 ignore else */
        if (!this.isMarquee) {
            this.interval = setInterval(() => {
                this.service.fetch(this.url, this.id).subscribe((data) => {
                    this.value = data.Value;
                    this.detectChanges();
                });
                /* c8 ignore else */
                if (this.value >= this.maximum) {
                    clearInterval(this.interval);
                }
            }, this.timeout);
        }
    }
    /**
     * OnDestroy life-cycle hook
     */
    ngOnDestroy() {
        clearInterval(this.interval);
        super.ngOnDestroy();
    }
    /**
     * Returns the data source URL of this component.
     */
    get url() {
        /* c8 ignore else */
        if (this.dataUrl && this.dataUrl.length > 0) {
            return this.dataUrl;
        }
        return this.defaultDataUrl;
    }
    /**
     * Gets maximum value property
     */
    get maximum() {
        return this.model.Maximum;
    }
    /**
     * Sets maximum value property
     */
    set maximum(value) {
        this.model.Maximum = value;
    }
    /**
     * Gets minimum value property
     */
    get minimum() {
        return this.model.Minimum;
    }
    /**
     * Sets maximum value property
     */
    set minimum(value) {
        this.model.Minimum = value;
    }
    /**
     * Gets value property
     */
    get value() {
        return this.model.Value;
    }
    /**
     * Sets value property
     */
    set value(num) {
        this.model.Value = num;
    }
};
ProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ProgressBarComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ProgressBarComponent, selector: "wm-progressbar", inputs: { model: "model" }, usesInheritance: true, ngImport: i0, template: "<kendo-progressbar #progressBar *ngIf=\"model\" class=\"k-form-field\" wmControls [hostComponent]=\"this\" [value]=\"value\"\r\n    [min]=\"minimum\" [max]=\"maximum\" [indeterminate]=\"'isMarquee'\" [style.width.%]=\"100\">\r\n</kendo-progressbar>", styles: ["::ng-deep .k-gauge svg{animation:animate-glow 1.7s ease-out infinite}@keyframes animate-glow{0%{opacity:.3}50%{opacity:1}to{opacity:.3}}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6$5.ProgressBarComponent, selector: "kendo-progressbar", inputs: ["label", "progressCssStyle", "progressCssClass", "emptyCssStyle", "emptyCssClass", "animation"], outputs: ["animationEnd"], exportAs: ["kendoProgressBar"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ProgressBarComponent.prototype, "maximum", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ProgressBarComponent.prototype, "minimum", null);
__decorate([
    MarkForCheck(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ProgressBarComponent.prototype, "value", null);
ProgressBarComponent = __decorate([
    dataTransfer(['pgrsbr']),
    ExceptionHandlerClass(ErrorCodes.Winforms),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], ProgressBarComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ProgressBarComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-progressbar', inputs: ['model'], template: "<kendo-progressbar #progressBar *ngIf=\"model\" class=\"k-form-field\" wmControls [hostComponent]=\"this\" [value]=\"value\"\r\n    [min]=\"minimum\" [max]=\"maximum\" [indeterminate]=\"'isMarquee'\" [style.width.%]=\"100\">\r\n</kendo-progressbar>", styles: ["::ng-deep .k-gauge svg{animation:animate-glow 1.7s ease-out infinite}@keyframes animate-glow{0%{opacity:.3}50%{opacity:1}to{opacity:.3}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { maximum: [], minimum: [], value: [] } });

/**
 * Class for handling the FontDialog component
 */
let FontDialogComponent = class FontDialogComponent extends DialogBaseComponent {
    /* c8 ignore start */
    constructor(wmservice, refChanges, renderer2, element, webComponents, bringTopServ, containerInteraction) {
        super(refChanges, renderer2, element, webComponents);
        this.refChanges = refChanges;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        this.containerInteraction = containerInteraction;
        this.sampleStyle = {
            'font-family': '',
            'font-weight': 'normal',
            'font-style': 'normal',
            'font-size': '8',
            'text-decoration': ''
        };
        this.selectedFont = '';
        // These are the default values in the component in windows forms
        this.sizes = [
            '8',
            '9',
            '10',
            '11',
            '12',
            '14',
            '16',
            '18',
            '20',
            '22',
            '24',
            '26',
            '28',
            '36',
            '48',
            '72'
        ];
        /**
         * Close event emitter of font dialog component
         */
        this.Close = new EventEmitter();
        this.Ok = new EventEmitter();
    }
    ngOnInit() {
        this.internalFont = this.mainFont;
        this.onFontNameChange(this.fonts[0]);
    }
    /* c8 ignore next 3 */
    ngAfterViewInit() {
        this.detectChanges();
    }
    /**
     * Gets fontfrom the model
     */
    get mainFont() {
        return (this.model?.Font ??
            new InternalFont(this.fonts[0], 8, false, false, false, false));
    }
    /**
     * Sets font to the model
     */
    set mainFont(value) {
        this.model.Font = value.ToJson();
    }
    get fonts() {
        return JSON.parse(this.model.Fonts);
    }
    /**
     * Gets the width of the component. Default value 350
     */
    get width() {
        return this.model.Width ? this.model.Width : 350;
    }
    /**
     * Gets the height of the component. Default value 505
     */
    get height() {
        return this.model.FullOpen ? 505 : 350;
    }
    /**
     * Closes font dialog component
     * @param event
     */
    close(event) {
        this.Close.emit(new EventData$1(event, this.id));
    }
    /**
     * OK action over font dialog component
     * @param event
     */
    ok(event) {
        // This is to send the font only when ok button is pressed
        this.mainFont = this.internalFont;
        this.Ok.emit(new EventData$1(event, this.id));
    }
    /**
     * Changes the font family
     * @param fontName
     */
    onFontNameChange(fontName) {
        this.internalFont.Name = fontName;
        this.sampleStyle['font-family'] = fontName;
    }
    /**
     * Changes the bold value
     * @param event
     */
    checkBold(event) {
        this.internalFont.Bold = !!event?.target?.checked;
        this.sampleStyle['font-weight'] = this.internalFont.Bold
            ? 'bold'
            : 'normal';
    }
    /**
     * Changes the style value
     * @param event
     */
    checkStyle(event) {
        this.internalFont.Italic = !!event?.target?.checked;
        this.sampleStyle['font-style'] = this.internalFont.Italic
            ? 'italic'
            : 'normal';
    }
    /**
     * Changes the size value
     * @param size
     */
    onSizeChange(size) {
        this.internalFont.Size = size;
        this.sampleStyle['font-size'] = size + 'px';
    }
    /**
     * Changes the Strikeout value
     * @param event
     */
    checkStrikeout(event) {
        this.internalFont.Strikeout = !!event?.target?.checked;
        this.changeTextDecoration();
    }
    /**
     * Changes the Underline value
     * @param event
     */
    checkUnderline(event) {
        this.internalFont.Underline = !!event?.target?.checked;
        this.changeTextDecoration();
    }
    /**
     * Changes the TextDecoration value
     */
    changeTextDecoration() {
        this.sampleStyle['text-decoration'] = '';
        if (this.internalFont.Strikeout) {
            this.sampleStyle['text-decoration'] = 'line-through';
        }
        if (this.internalFont.Underline) {
            this.sampleStyle['text-decoration'] += ' underline';
        }
    }
};
FontDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FontDialogComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
FontDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: FontDialogComponent, selector: "wm-fontdialog", inputs: { model: "model" }, outputs: { Close: "Close", Ok: "Ok" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\">\r\n    <kendo-dialog *ngIf=\"visible\" [width]=\"width\" [height]=\"height\" [ngClass]=\"class\" (close)=\"close($event)\" wmControls\r\n        [hostComponent]=\"this\">\r\n        <kendo-dialog-titlebar #titleBar>\r\n            {{text}}\r\n        </kendo-dialog-titlebar>\r\n\r\n        <p class=\"fontTitle\">Font:</p>\r\n        <select size=\"4\" name=\"LBFonts\" class=\"LBFonts\" (change)=\"onFontNameChange($event.target.value)\">\r\n            <option *ngFor=\"let font of fonts\" value=\"{{font}}\" style=\"font-family: {{font}}\"\r\n                [selected]=\"font===fonts[0]\">{{font}}</option>\r\n        </select>\r\n\r\n        <fieldset class=\"fsFontStyles\">\r\n            <legend>Font style</legend>\r\n            <div>\r\n                <input class=\"k-checkbox\" id=\"CBBold\" type=\"checkbox\" (change)=\"checkBold($event)\" />\r\n                <label class=\"k-checkbox-label\" for=\"CBBold\" style=\"font-family: {{internalFont.Name}}\"\r\n                    class=\"bold\">Bold</label>\r\n            </div>\r\n            <div>\r\n                <input class=\"k-checkbox\" id=\"CBItalic\" type=\"checkbox\" (change)=\"checkStyle($event)\" />\r\n                <label class=\"k-checkbox-label\" for=\"CBItalic\" style=\"font-family: {{internalFont.Name}}\"\r\n                    class=\"italic\">Italic</label>\r\n            </div>\r\n        </fieldset>\r\n\r\n        <p class=\"sizeTitle\">Size:</p>\r\n        <input type=\"number\" class=\"TxtSize\" [(ngModel)]=\"internalFont.Size\" (change)=\"onSizeChange($event.target.value)\">\r\n        <select size=\"4\" name=\"LBSizes\" class=\"LBSizes\" (change)=\"onSizeChange($event.target.value)\"\r\n            [(value)]=\"internalFont.Size\">\r\n            <option *ngFor=\"let size of sizes\" value=\"{{size}}\" [selected]=\"size===8\">{{size}}</option>\r\n        </select>\r\n\r\n        <fieldset *ngIf=\"model.ShowEffects\" class=\"fsShowEffects\">\r\n            <legend>Effects</legend>\r\n            <div>\r\n                <input class=\"k-checkbox\" id=\"CBStrikeout\" type=\"checkbox\" (change)=\"checkStrikeout($event)\" />\r\n                <label class=\"k-checkbox-label\" for=\"CBStrikeout\">Strikeout</label>\r\n            </div>\r\n            <div>\r\n                <input class=\"k-checkbox\" id=\"CBUnderline\" type=\"checkbox\" (change)=\"checkUnderline($event)\" />\r\n                <label class=\"k-checkbox-label\" for=\"CBUnderline\">Underline</label>\r\n            </div>\r\n        </fieldset>\r\n\r\n        <fieldset class=\"fsSample\">\r\n            <legend>Sample</legend>\r\n            <p [ngStyle]=\"sampleStyle\">AaBbYyZz</p>\r\n        </fieldset>\r\n\r\n        <kendo-dialog-actions>\r\n            <button kendoButton (click)=\"ok($event)\">Ok</button>\r\n            <button kendoButton (click)=\"close($event)\" primary=\"true\">Cancel</button>\r\n        </kendo-dialog-actions>\r\n    </kendo-dialog>\r\n</div>", styles: [".k-dialog-wrapper{z-index:100000}.LBFonts{left:12px;top:30px;width:143px;height:117px;position:absolute}.fontTitle{left:12px;position:absolute}.fontStyleTitle{left:164px;position:absolute}.TxtFontStyle{left:164px;top:29px;width:101px;height:14px;position:absolute}.fsFontStyles{left:162px;top:24px;width:90px;height:42px;position:absolute}.sizeTitle{left:283px;position:absolute}.TxtSize{left:283px;top:29px;width:45px;height:14px;position:absolute}.LBSizes{left:283px;top:49px;width:53px;height:98px;position:absolute}.fsShowEffects{left:162px;top:90px;width:90px;height:42px;position:absolute}.fsSample{left:9px;top:160px;width:304px;height:94px;display:flex;justify-content:center;align-items:center;position:absolute}.bold{font-weight:700}.italic{font-style:italic}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i6.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i6.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i6$2.Button, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }, { kind: "directive", type: i8$2.LabelDirective, selector: "label[for]", inputs: ["for"] }, { kind: "component", type: i7.DialogComponent, selector: "kendo-dialog", inputs: ["actions", "actionsLayout", "autoFocusedElement", "title", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "animation", "themeColor"], outputs: ["action", "close"], exportAs: ["kendoDialog"] }, { kind: "component", type: i7.DialogTitleBarComponent, selector: "kendo-dialog-titlebar", inputs: ["id", "closeTitle"], outputs: ["close"] }, { kind: "component", type: i7.DialogActionsComponent, selector: "kendo-dialog-actions", inputs: ["actions", "layout"], outputs: ["action"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    MarkForCheck(),
    NotifyChange('Font'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], FontDialogComponent.prototype, "mainFont", null);
__decorate([
    serverEvent('FormClose'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FontDialogComponent.prototype, "close", null);
__decorate([
    serverEvent('FormOk'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FontDialogComponent.prototype, "ok", null);
FontDialogComponent = __decorate([
    dataTransfer(['fntdlg']),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        BringTopService,
        ContainerInteractionService])
], FontDialogComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FontDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-fontdialog', inputs: ['model'], template: "<div *ngIf=\"model\">\r\n    <kendo-dialog *ngIf=\"visible\" [width]=\"width\" [height]=\"height\" [ngClass]=\"class\" (close)=\"close($event)\" wmControls\r\n        [hostComponent]=\"this\">\r\n        <kendo-dialog-titlebar #titleBar>\r\n            {{text}}\r\n        </kendo-dialog-titlebar>\r\n\r\n        <p class=\"fontTitle\">Font:</p>\r\n        <select size=\"4\" name=\"LBFonts\" class=\"LBFonts\" (change)=\"onFontNameChange($event.target.value)\">\r\n            <option *ngFor=\"let font of fonts\" value=\"{{font}}\" style=\"font-family: {{font}}\"\r\n                [selected]=\"font===fonts[0]\">{{font}}</option>\r\n        </select>\r\n\r\n        <fieldset class=\"fsFontStyles\">\r\n            <legend>Font style</legend>\r\n            <div>\r\n                <input class=\"k-checkbox\" id=\"CBBold\" type=\"checkbox\" (change)=\"checkBold($event)\" />\r\n                <label class=\"k-checkbox-label\" for=\"CBBold\" style=\"font-family: {{internalFont.Name}}\"\r\n                    class=\"bold\">Bold</label>\r\n            </div>\r\n            <div>\r\n                <input class=\"k-checkbox\" id=\"CBItalic\" type=\"checkbox\" (change)=\"checkStyle($event)\" />\r\n                <label class=\"k-checkbox-label\" for=\"CBItalic\" style=\"font-family: {{internalFont.Name}}\"\r\n                    class=\"italic\">Italic</label>\r\n            </div>\r\n        </fieldset>\r\n\r\n        <p class=\"sizeTitle\">Size:</p>\r\n        <input type=\"number\" class=\"TxtSize\" [(ngModel)]=\"internalFont.Size\" (change)=\"onSizeChange($event.target.value)\">\r\n        <select size=\"4\" name=\"LBSizes\" class=\"LBSizes\" (change)=\"onSizeChange($event.target.value)\"\r\n            [(value)]=\"internalFont.Size\">\r\n            <option *ngFor=\"let size of sizes\" value=\"{{size}}\" [selected]=\"size===8\">{{size}}</option>\r\n        </select>\r\n\r\n        <fieldset *ngIf=\"model.ShowEffects\" class=\"fsShowEffects\">\r\n            <legend>Effects</legend>\r\n            <div>\r\n                <input class=\"k-checkbox\" id=\"CBStrikeout\" type=\"checkbox\" (change)=\"checkStrikeout($event)\" />\r\n                <label class=\"k-checkbox-label\" for=\"CBStrikeout\">Strikeout</label>\r\n            </div>\r\n            <div>\r\n                <input class=\"k-checkbox\" id=\"CBUnderline\" type=\"checkbox\" (change)=\"checkUnderline($event)\" />\r\n                <label class=\"k-checkbox-label\" for=\"CBUnderline\">Underline</label>\r\n            </div>\r\n        </fieldset>\r\n\r\n        <fieldset class=\"fsSample\">\r\n            <legend>Sample</legend>\r\n            <p [ngStyle]=\"sampleStyle\">AaBbYyZz</p>\r\n        </fieldset>\r\n\r\n        <kendo-dialog-actions>\r\n            <button kendoButton (click)=\"ok($event)\">Ok</button>\r\n            <button kendoButton (click)=\"close($event)\" primary=\"true\">Cancel</button>\r\n        </kendo-dialog-actions>\r\n    </kendo-dialog>\r\n</div>", styles: [".k-dialog-wrapper{z-index:100000}.LBFonts{left:12px;top:30px;width:143px;height:117px;position:absolute}.fontTitle{left:12px;position:absolute}.fontStyleTitle{left:164px;position:absolute}.TxtFontStyle{left:164px;top:29px;width:101px;height:14px;position:absolute}.fsFontStyles{left:162px;top:24px;width:90px;height:42px;position:absolute}.sizeTitle{left:283px;position:absolute}.TxtSize{left:283px;top:29px;width:45px;height:14px;position:absolute}.LBSizes{left:283px;top:49px;width:53px;height:98px;position:absolute}.fsShowEffects{left:162px;top:90px;width:90px;height:42px;position:absolute}.fsSample{left:9px;top:160px;width:304px;height:94px;display:flex;justify-content:center;align-items:center;position:absolute}.bold{font-weight:700}.italic{font-style:italic}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { Close: [{
                type: Output
            }], Ok: [{
                type: Output
            }], mainFont: [], close: [], ok: [] } });
/**
 * Helper class for handling fonts
 */
class InternalFont {
    constructor(name, size, bold, italic, strikeout, underline) {
        this.Name = name;
        this.Size = size;
        this.Bold = bold;
        this.Italic = italic;
        this.Strikeout = strikeout;
        this.Underline = underline;
    }
    ToJson() {
        return JSON.stringify(this);
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 

/**
 * Stores a four integers that represent the location and size of a rectangle
 * left, right, bottom, top
 *
 * @export
 * @class Rectangle
 */
class Rectangle {
    /* c8 ignore start */
    constructor(x, y, width, height) {
        this._width = width;
        this._height = height;
        this._x = x * width;
        this._y = y * height;
    }
    /* c8 ignore stop */
    /**
     * Gets the y-coordinate of the upper-left corner of this Rectangle structure.
     *
     * @readonly
     * @type {number}
     * @memberof Rectangle
     */
    get width() {
        return this._width;
    }
    /**
     * Gets the height of this Rectangle structure.
     *
     * @readonly
     * @type {number}
     * @memberof Rectangle
     */
    get height() {
        return this._height;
    }
    /**
     * Gets the x-coordinate of the left edge of this Rectangle structure.
     *
     * @readonly
     * @type {number}
     * @memberof Rectangle
     */
    get left() {
        return this.x;
    }
    /**
     * Gets the x-coordinate that is the sum of X and Width property values of this Rectangle structure.
     *
     * @readonly
     * @type {number}
     * @memberof Rectangle
     */
    get right() {
        return this.x + this.width;
    }
    /**
     * Gets the y-coordinate of the top edge of this Rectangle structure.
     *
     * @readonly
     * @type {number}
     * @memberof Rectangle
     */
    get top() {
        return this.y;
    }
    /**
     * Gets the y-coordinate that is the sum of the Y and Height property values of this Rectangle structure.
     *
     * @readonly
     * @type {number}
     * @memberof Rectangle
     */
    get bottom() {
        return this.y + this.height;
    }
    /**
     * Gets the x-coordinate of the upper-left corner of this Rectangle structure.
     *
     * @readonly
     * @type {number}
     * @memberof Rectangle
     */
    get x() {
        return this._x;
    }
    /**
     * Gets the y-coordinate of the upper-left corner of this Rectangle structure.
     *
     * @readonly
     * @type {number}
     * @memberof Rectangle
     */
    get y() {
        return this._y;
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
var DialogResult;
(function (DialogResult) {
    /**
     * Nothing is returned from the dialog box. This means that the modal dialog continues
     * running.
     */
    DialogResult[DialogResult["None"] = 0] = "None";
    /**
     * The dialog box return value is OK (usually sent from a button labeled OK).
     */
    DialogResult[DialogResult["OK"] = 1] = "OK";
    /**
     * The dialog box return value is Cancel (usually sent from a button labeled Cancel).
     */
    DialogResult[DialogResult["Cancel"] = 2] = "Cancel";
    /**
     * The dialog box return value is Abort (usually sent from a button labeled Abort).
     */
    DialogResult[DialogResult["Abort"] = 3] = "Abort";
    /**
     * The dialog box return value is Retry (usually sent from a button labeled Retry).
     */
    DialogResult[DialogResult["Retry"] = 4] = "Retry";
    /**
     * The dialog box return value is Ignore (usually sent from a button labeled Ignore).
     */
    DialogResult[DialogResult["Ignore"] = 5] = "Ignore";
    /**
     * The dialog box return value is Yes (usually sent from a button labeled Yes).
     */
    DialogResult[DialogResult["Yes"] = 6] = "Yes";
    /**
     * The dialog box return value is No (usually sent from a button labeled No).
     */
    DialogResult[DialogResult["No"] = 7] = "No";
})(DialogResult || (DialogResult = {}));

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
var MessageBoxButtons;
(function (MessageBoxButtons) {
    /**
     * The message box contains an OK button.
     */
    MessageBoxButtons[MessageBoxButtons["OK"] = 0] = "OK";
    /**
     * The message box contains OK and Cancel buttons.
     */
    MessageBoxButtons[MessageBoxButtons["OKCancel"] = 1] = "OKCancel";
    /**
     * The message box contains Abort, Retry, and Ignore buttons.
     */
    MessageBoxButtons[MessageBoxButtons["AbortRetryIgnore"] = 2] = "AbortRetryIgnore";
    /**
     * The message box contains Yes, No, and Cancel buttons.
     */
    MessageBoxButtons[MessageBoxButtons["YesNoCancel"] = 3] = "YesNoCancel";
    /**
     * The message box contains Yes and No buttons.
     */
    MessageBoxButtons[MessageBoxButtons["YesNo"] = 4] = "YesNo";
    /**
     *The message box contains Retry and Cancel buttons.
     */
    MessageBoxButtons[MessageBoxButtons["RetryCancel"] = 5] = "RetryCancel";
})(MessageBoxButtons || (MessageBoxButtons = {}));

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
class MessageBoxAlert {
    static Show(messageBoxText, caption, button, icon) {
        if (messageBoxText && !caption && !button && !icon) {
            alert(messageBoxText);
            return DialogResult.OK;
        }
        if (messageBoxText && caption && button === MessageBoxButtons.OK) {
            const message = `${caption} \n ${messageBoxText}`;
            alert(message);
            return DialogResult.OK;
        }
        if (messageBoxText && caption && button === MessageBoxButtons.OKCancel) {
            const message = `${caption} \n ${messageBoxText}`;
            return confirm(message) ? DialogResult.OK : DialogResult.Cancel;
        }
        // Button Combination not supported
        return undefined;
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * The extractor for the TDBNumber events
 *
 * @export
 * @class TDNumberExtractor
 */
class TDNumberExtractor {
    /**
     * KeyDown event args extractor
     *
     * @static
     * @param {EventData} event
     * @param {TDBNumberComponent} component
     * @return {*}  {*}
     * @memberof TDNumberExtractor
     */
    static KeyDownArgsExtractor(event, component) {
        const args = event.args;
        return [
            { Id: event.Id, MapperId: event.mapperId },
            {
                MapperId: TDNumberExtractor.keyDownMapperId,
                KeyCode: args.KeyCode,
                Shift: args.Shift
            }
        ];
    }
    /**
     * KeyPress event args extractor
     *
     * @static
     * @param {EventData} event
     * @param {TDBNumberComponent} component
     * @return {*}  {*}
     * @memberof TDNumberExtractor
     */
    static KeyPressArgsExtractor(event, component) {
        const args = event.args;
        return [
            { Id: event.Id, MapperId: event.mapperId },
            {
                MapperId: TDNumberExtractor.KeyPressArgsExtractor,
                KeyAscii: args.KeyAscii
            }
        ];
    }
    /**
     * Change event args extractor
     *
     * @static
     * @param {EventData} event
     * @param {TDBNumberComponent} component
     * @return {*}
     * @memberof TDBNumberComponent
     */
    static changeEventArgsExtractor(event, component) {
        return [{ Id: event.Id, MapperId: event.mapperId }, null];
    }
}
/**
 * KeyDown event args mapperId
 *
 * @static
 * @memberof TDNumberExtractor
 */
TDNumberExtractor.keyDownMapperId = 'xtdbkydwnvntrgs';
/**
 * KeyPress event args mapperId
 *
 * @static
 * @memberof TDNumberExtractor
 */
TDNumberExtractor.keyPressMapperId = 'xtdbkyprssvntrgs';

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Base class for formats
 *
 * @export
 * @class PatternFormatBase
 */
class PatternFormatBase {
    /**
     * Masked value
     *
     * @type {string}
     * @memberof PatternFormatBase
     */
    get maskedValue() {
        return this._maskedValue;
    }
    /**
     * Masked value
     *
     * @memberof PatternFormatBase
     */
    set maskedValue(maskedValue) {
        this._maskedValue = maskedValue;
    }
    /**
     * suffix
     *
     * @type {string}
     * @memberof PatternFormatBase
     */
    get suffix() {
        return this._suffix;
    }
    /**
     * suffix
     *
     * @memberof PatternFormatBase
     */
    set suffix(suffix) {
        this._suffix = suffix;
    }
    /**
     * prefix
     *
     * @type {string}
     * @memberof PatternFormatBase
     */
    get prefix() {
        return this._prefix;
    }
    /**
     * prefix
     *
     * @memberof PatternFormatBase
     */
    set prefix(preffix) {
        this._prefix = preffix;
    }
    /**
     * Pattern Positive.
     *
     * @type {string}
     * @memberof PatternFormatBase
     */
    get patternPositive() {
        return this._patternPositive;
    }
    /**
     * Pattern Positive.
     *
     * @memberof PatternFormatBase
     */
    set patternPositive(patternPositive) {
        this._patternPositive = patternPositive;
    }
    /**
     * Pattern Negative.
     *
     * @type {string}
     * @memberof PatternFormatBase
     */
    get patternNegative() {
        return this._patternNegative;
    }
    /**
     * Pattern Negaive.
     *
     * @memberof PatternFormatBase
     */
    set patternNegative(patternNegative) {
        this._patternNegative = patternNegative;
    }
    /**
     * Pattern zero.
     *
     * @type {string}
     * @memberof PatternFormatBase
     */
    get patternZero() {
        return this._patternZero;
    }
    /**
     * Pattern zero.
     *
     * @memberof PatternFormatBase
     */
    set patternZero(patternZero) {
        this._patternZero = patternZero;
    }
    /**
     * Pattern null.
     *
     * @type {string}
     * @memberof PatternFormatBase
     */
    get patternNull() {
        return this._patternNull;
    }
    /**
     * Pattern Null.
     *
     * @memberof PatternFormatBase
     */
    set patternNull(patternNull) {
        this._patternNull = patternNull;
    }
    /**
     * Complete Mask.
     *
     * @type {string}
     * @memberof PatternFormatBase
     */
    get completeMask() {
        return this._completeMask;
    }
    /**
     * Complete Mask.
     *
     * @memberof PatternFormatBase
     */
    set completeMask(validMask) {
        this._completeMask = validMask;
    }
    /**
     * Current Mask.
     *
     * @type {string}
     * @memberof PatternFormatBase
     */
    get currentMask() {
        return this._currentMask;
    }
    /**
     * Current Mask.
     *
     * @memberof PatternFormatBase
     */
    set currentMask(currentdMask) {
        this._currentMask = currentdMask;
    }
    /**
     * InitialiceFormat with initial values
     *
     * @param {string} currentMask
     * @memberof PatternFormatBase
     */
    initialice(currentMask) {
        this.completeMask = currentMask;
        this.splitRules(currentMask);
    }
    /**
     * Takes current mask and split into diffent internal rules, if only one pattern is deffined, it should be appied to all
     *
     * @protected
     * @param {string} currentMask
     * @memberof PatternFormatBase
     */
    splitRules(currentMask) {
        if (currentMask != null) {
            const chunks = currentMask.split(';');
            this.patternPositive = chunks[0] ? chunks[0] : undefined;
            this.patternNegative = chunks[1] ? chunks[1] : `-${this.patternPositive}`;
            this.patternZero = chunks[3] ? chunks[3] : this.patternPositive;
            this.patternNull = this.nullPattern(chunks[2], this.patternPositive);
        }
    }
    /**
     * Null pattern rule formating
     *
     * @protected
     * @param {string} rule
     * @param {string} positiveParent
     * @return {*}  {string}
     * @memberof PatternFormatBase
     */
    nullPattern(rule, positiveParent) {
        return rule ? rule : positiveParent;
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Represent display format class
 *
 * @export
 * @class DisplayFormat
 * @extends {PatternFormatBase}
 */
class DisplayFormat extends PatternFormatBase {
    /**
     * Takes current mask and split into diffent internal rules, if only one pattern is defined, it should be appied to all
     *
     * @protected
     * @param {string} currentMask
     * @memberof DisplayFormat
     */
    splitRules(currentMask) {
        if (currentMask != null) {
            const chunks = currentMask.split(';');
            this.patternPositive = chunks[0] ? chunks[0] : undefined;
            this.patternNegative = chunks[1] ? chunks[1] : `-${this.patternPositive}`;
            this.patternZero = chunks[3] ? chunks[3] : this.patternPositive;
            this.patternNull = this.nullPattern(chunks[2], '');
        }
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 *Format class for tdbnumber control
 *
 * @export
 * @class Format
 * @extends {PatternFormatBase}
 */
class Format extends PatternFormatBase {
    constructor() {
        super(...arguments);
        /**
         *Default mask size
         *
         * @memberof Format
         */
        this.maxNumberMask = '#####';
    }
    /**
     * Overrides split Rules
     *
     * @protected
     * @param {string} currentMask
     * @memberof Format
     */
    splitRules(currentMask) {
        super.splitRules(currentMask == null || currentMask === ''
            ? this.maxNumberMask
            : currentMask);
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Mask service to handle format and displayFormat
 *
 * @export
 * @class MaskService
 */
class MaskService {
    constructor() {
        /**
         * Format.
         *
         * @private
         * @type {Format}
         * @memberof MaskService
         */
        this._format = new Format();
        /**
         *DisplayFormat
         *
         * @private
         * @type {DisplayFormat}
         * @memberof MaskService
         */
        this._displayFormat = new DisplayFormat();
    }
    /**
     * Format
     *
     * @type {Format}
     * @memberof MaskService
     */
    get format() {
        return this._format;
    }
    /**
     * Format
     *
     * @memberof MaskService
     */
    set format(format) {
        this._format = format;
    }
    /**
     * Display format
     *
     * @type {DisplayFormat}
     * @memberof MaskService
     */
    get displayFormat() {
        return this._displayFormat;
    }
    /**
     * Display format
     *
     * @memberof MaskService
     */
    set displayFormat(displayFormat) {
        this._displayFormat = displayFormat;
    }
    /**
     *  Service should be initialiced with current mask values to split into rules
     */
    initialiceMaskService(format, displayFormat, value) {
        this.format.initialice(format);
        this.displayFormat.initialice(displayFormat);
        this.selectMaskRule(value, this.format);
        this.selectMaskRule(value, this.displayFormat);
    }
    /**
     * Selects mask rule depending of the value and the type of format.
     *
     * @param {number} maskedTexboxValue
     * @param {PatternFormatBase} formats
     * @return {*}  {string}
     * @memberof MaskService
     */
    selectMaskRule(maskedTexboxValue, formats) {
        const numbericValue = maskedTexboxValue;
        switch (true) {
            case isNaN(numbericValue):
                return this.validateSuffixPreffixMaskedValue(formats, formats.patternNull);
            case numbericValue > 0:
                return this.validateSuffixPreffixMaskedValue(formats, formats.patternPositive);
            case numbericValue === 0:
                return this.validateSuffixPreffixMaskedValue(formats, formats.patternZero);
            case numbericValue < 0:
                return this.validateSuffixPreffixMaskedValue(formats, formats.patternNegative);
            default:
                return null;
        }
    }
    /**
     * Validate and assign only negative format for special cases
     *
     * @param {PatternFormatBase} formats
     * @return {*}  {string}
     * @memberof MaskService
     */
    validateNegativeFormat(formats) {
        return this.validateSuffixPreffixMaskedValue(formats, formats.patternNegative);
    }
    /**
     * Validate and assign  only negative format for special cases
     *
     * @param {PatternFormatBase} formats
     * @return {*}  {string}
     * @memberof MaskService
     */
    validatePositiveFormat(formats) {
        return this.validateSuffixPreffixMaskedValue(formats, formats.patternPositive);
    }
    /**
     * Performance Validation current mask agains new requested to assign or not suffixPrefix
     *
     * @private
     * @param {PatternFormatBase} formats
     * @param {string} newMask
     * @return {*}  {string}
     * @memberof MaskService
     */
    validateSuffixPreffixMaskedValue(formats, newMask) {
        if (formats.currentMask !== newMask) {
            formats.currentMask = newMask;
            this.assignSuffixPrefix(formats);
            formats.maskedValue = this.fillMaskedValue(formats.currentMask, formats.suffix, formats.prefix);
        }
        return formats.currentMask;
    }
    /**
     * Assing suffix and prefix to current format
     *
     * @private
     * @param {PatternFormatBase} formats
     * @memberof MaskService
     */
    assignSuffixPrefix(formats) {
        formats.prefix =
            formats.currentMask != null
                ? this.splitStringPrefix(formats.currentMask)
                : undefined;
        formats.suffix =
            formats.currentMask != null
                ? this.splitStringSuffix(formats.currentMask)
                : undefined;
        formats.suffix =
            formats.suffix === formats.currentMask ? '' : formats.suffix;
    }
    /**
     * Reverse string to analyze string right to lef in order to detect if suffix and return it
     *
     * @private
     * @param {*} string
     * @return {*}  {string}
     * @memberof MaskService
     */
    splitStringSuffix(string) {
        const reversedString = string.split('').reverse().join('');
        const reversedSplitArray = reversedString.split(/(?=[0#])/);
        let splitTextReversed = reversedSplitArray[0];
        splitTextReversed = splitTextReversed.match(/[#0]/g)
            ? ''
            : splitTextReversed;
        return splitTextReversed.split('').reverse().join('');
    }
    /**
     * Analize string left to right looking for a prefix and return it
     *
     * @private
     * @param {string} string
     * @return {*}  {string}
     * @memberof MaskService
     */
    splitStringPrefix(string) {
        const splitArray = string?.split(/(?=[0#])/);
        let firstCH = splitArray[0];
        firstCH = firstCH.match(/[#0]/g) ? '' : firstCH;
        return firstCH;
    }
    /**
     * it escapes any characters that have special meanings in regular expressions using the replace method and a regular expression pattern.
     * This ensures that the patterns are treated as literal strings when constructing the regular expressions.
     *
     * @param {*} string
     * @return {*}
     * @memberof MaskService
     */
    escapeRegExp(string) {
        return string?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    /**
     *  Assign a valid maskedValue
     *
     * @param {string} string
     * @param {string} suffix
     * @param {string} prefix
     * @return {*}
     * @memberof MaskService
     */
    fillMaskedValue(string, suffix, prefix) {
        const regex1 = new RegExp(this.escapeRegExp(suffix), 'g'); // nosemgrep
        const regex2 = new RegExp(this.escapeRegExp(prefix), 'g'); // nosemgrep
        string = string?.replace(regex1, '');
        string = string?.replace(regex2, '');
        return string;
    }
}
MaskService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MaskService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
MaskService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MaskService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MaskService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Directive to control afterValueChange on TdbNumber
 *
 * @export
 * @class AfterValueChangedDirective
 * @implements {OnDestroy}
 */
class AfterValueChangedTdbNumberDirective {
    /**
     * Creates an instance of AfterValueChangedTdbNumberDirective.
     * @memberof AfterValueChangedTdbNumberDirective
     */
    constructor() {
        this.afterValueChangedTDB = new EventEmitter();
        /**
         * In case we need to delay after value change
         *
         * @memberof AfterValueChangedTdbNumberDirective
         */
        this.valueChangeDelay = 0;
        /**
         * Stream subscription
         *
         * @private
         * @type {Subject<number>}
         * @memberof AfterValueChangedTdbNumberDirective
         */
        this.stream = new Subject();
        this.subscription = this.stream
            .pipe(debounceTime(this.valueChangeDelay))
            .subscribe((value) => this.afterValueChangedTDB.next(value));
    }
    /**
     * OnDestroy
     *
     * @memberof AfterValueChangedTdbNumberDirective
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * On value change
     *
     * @param {number} value
     * @memberof AfterValueChangedTdbNumberDirective
     */
    onValueChange(value) {
        this.stream.next(value);
    }
}
AfterValueChangedTdbNumberDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AfterValueChangedTdbNumberDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
AfterValueChangedTdbNumberDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: AfterValueChangedTdbNumberDirective, selector: "[afterValueChangedTDB]", inputs: { valueChangeDelay: "valueChangeDelay" }, outputs: { afterValueChangedTDB: "afterValueChangedTDB" }, host: { listeners: { "valueChange": "onValueChange($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AfterValueChangedTdbNumberDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[afterValueChangedTDB]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { afterValueChangedTDB: [{
                type: Output
            }], valueChangeDelay: [{
                type: Input
            }], onValueChange: [{
                type: HostListener,
                args: ['valueChange', ['$event']]
            }] } });

var TDBNumberComponent_1;
/**
 * Class for the TDBNumberComponent of Apex
 *
 * @export
 * @class TDBNumberComponent
 * @extends {ControlComponent}
 * @implements {AfterViewInit}
 */
let TDBNumberComponent = TDBNumberComponent_1 = class TDBNumberComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(chDetector, rnderer2, elemen, webComponents, maskservice, intl, baseValidatorService, bringTopServe, containerInteraction) {
        super(chDetector, rnderer2, elemen, webComponents, bringTopServe, containerInteraction);
        this.chDetector = chDetector;
        this.rnderer2 = rnderer2;
        this.elemen = elemen;
        this.maskservice = maskservice;
        this.intl = intl;
        this.baseValidatorService = baseValidatorService;
        this.bringTopServe = bringTopServe;
        this.containerInteraction = containerInteraction;
        /**
         * Event emitter for change event
         *
         * @memberof TDBNumberComponent
         */
        this.Change = new EventEmitter();
        /**
         * Is used to validate if popup should be opened
         */
        this.show = false;
        /**
         * This is switched between the value and text of the control
         *
         * @memberof TDBNumberComponent
         */
        this.controlValue = '';
        /**
         * Current text value
         *
         * @memberof TDBNumberComponent
         */
        this.currentText = '';
        /**
         * Caret value of texbox
         *
         * @memberof TDBNumberComponent
         */
        this.caret = 0;
        /**
         * Backspace validation
         * Validation created because when input applies mask format, caret is incorrectly positioned.
         *
         * @memberof TDBNumberComponent
         */
        this.backspace = false;
        /**
         * Delete validation.
         * Validation created because when input applies mask format, caret is incorrectly positioned.
         *
         * @memberof TDBNumberComponent
         */
        this.deleteValidation = false;
        /**
         * Flag to check when a decimal point is added
         *
         * @memberof TDBNumberComponent
         */
        this.decimalPointAdded = false;
    }
    /**
     * Format Masked value length
     *
     * @readonly
     * @type {number}
     * @memberof TDBNumberComponent
     */
    get formatMaskedValueLength() {
        return this.maskservice.format.maskedValue?.length;
    }
    /**
     * Suffix mask
     *
     * @type {string}
     * @memberof TDBNumberComponent
     */
    get suffix() {
        return this._suffix;
    }
    /**
     * suffix mask.
     *
     * @memberof TDBNumberComponent
     */
    set suffix(suffix) {
        this._suffix = suffix;
    }
    /**
     * Prefix mask
     *
     * @type {string}
     * @memberof TDBNumberComponent
     */
    get prefix() {
        return this._prefix;
    }
    /**
     * Prefix mask
     *
     * @memberof TDBNumberComponent
     */
    set prefix(prefix) {
        this._prefix = prefix;
    }
    /**
     * Get Text
     *
     * @memberof TDBNumberComponent
     */
    get text() {
        return this.model.Text;
    }
    /**
     * Set Text
     *
     * @memberof TDBNumberComponent
     */
    set text(text) {
        this.model.Text = text;
    }
    /**
     * Gets the CtlText value from the model
     *
     * @readonly
     * @type {string}
     * @memberof TDBNumberComponent
     */
    get ctlText() {
        return this.model?.CtlText ?? '';
    }
    /**
     * Sets the value of CtlText in the model
     *
     * @readonly
     * @type {string}
     * @memberof TDBNumberComponent
     */
    set ctlText(value) {
        this.model.CtlText = value;
    }
    /**
     * Gets the CtlText value from the model
     *
     * @readonly
     * @type {string}
     * @memberof TDBNumberComponent
     */
    get negativeColor() {
        return this.model?.NegativeColor ?? TDBNumberComponent_1.defaultNegativeColor;
    }
    /**
     * Get Mask format.
     *
     * @memberof TDBNumberComponent
     */
    get format() {
        return this.model?.Format ?? '';
    }
    /**
     * Set mask format.
     *
     * @memberof TDBNumberComponent
     */
    set format(format) {
        this.model.Format = format;
    }
    /**
     * Gets the value of the component
     *
     * @readonly
     * @type {number}
     * @memberof TDBNumberComponent
     */
    get value() {
        return this.model?.Value;
    }
    /**
     * Sets the value of the component
     *
     * @memberof TDBNumberComponent
     */
    set value(value) {
        this.model.Value = value;
    }
    /**
     * Gets the Enabled value from the model
     *
     * @readonly
     * @type {boolean}
     * @memberof TDBNumberComponent
     */
    get enabled() {
        return this.model?.Enabled;
    }
    /**
     * Gets the SelStart from the model
     *
     * @readonly
     * @type {number}
     * @memberof TDBNumberComponent
     */
    get selStart() {
        return this.model?.SelStart;
    }
    /**
     * sets selectionStart.
     *
     * @memberof TDBNumberComponent
     */
    set selStart(value) {
        this.model.SelStart = value;
    }
    /**
     * Gets the SelLength from the model
     *
     * @readonly
     * @type {number}
     * @memberof TDBNumberComponent
     */
    get selLength() {
        return this.model?.SelLength;
    }
    /**
     * Gets the minValue from the model
     *
     * @readonly
     * @type {*}
     * @memberof TDBNumberComponent
     */
    get minValue() {
        return this.model?.MinValue != null ? this.model?.MinValue : -99999;
    }
    /**
     * Gets the MaxValue from the model
     *
     * @readonly
     * @type {*}
     * @memberof TDBNumberComponent
     */
    get maxValue() {
        return this.model?.MaxValue ? this.model?.MaxValue : 99999;
    }
    /**
     * Gets display element calculated using getDisplayElement function
     */
    get displayElement() {
        return this.getDisplayElement();
    }
    /**
     * Sets displayElement innerProperty
     */
    set displayElement(value) {
        this.displayElementInner = value;
    }
    /**
     * ClassValue style
     *
     * @return {*}  {string}
     * @memberof TDBNumberComponent
     */
    valueStyle() {
        if (this.value < 0 &&
            this.negativeColor === TDBNumberComponent_1.defaultNegativeColor) {
            return `${this.class} defaultNegativeColor`;
        }
        else {
            return this.class;
        }
    }
    /**
     * Get the display element
     *
     * @memberof TDBNumberComponent
     * @returns
     */
    getDisplayElement() {
        return this.textBox?.input?.nativeElement;
    }
    /**
     * ngAfterContentInit cycle
     *
     * @memberof TDBNumberComponent
     */
    ngAfterContentInit() {
        this.assignDisplayFormat();
        this.validateSelstart();
    }
    /**
     * Validates selection start. if default value is set, cursor must be moved to a friendly position when user start to write.
     *
     * @memberof TDBNumberComponent
     */
    validateSelstart() {
        this.selStart = this.selStart === 0 ? null : this.selStart;
    }
    /**
     * After view checked event
     *
     * @memberof TDBNumber
     */
    ngAfterViewChecked() {
        this.validateValueTextChanged();
        super.ngAfterViewChecked();
    }
    /**
     * Verifies all values sync
     *
     * @memberof TDBNumberComponent
     */
    validateValueTextChanged() {
        if (this.ctlText != this.currentText) {
            this.value = this.ctlText === '' ? undefined : this.value;
            this.assignDisplayFormat();
        }
    }
    /**
     * Assign displayFormat
     *
     * @memberof TDBNumberComponent
     */
    assignDisplayFormat() {
        this.maskservice.initialiceMaskService(this.format, this.model.DisplayFormat, this.value);
        this.assignSuffixPrefixDisplayFormat();
        let texFormated = this.intl.formatNumber(this.value, this.maskservice.displayFormat.maskedValue);
        texFormated = texFormated
            ? texFormated
            : this.maskservice.displayFormat.maskedValue;
        const prefix = this.prefix ? this.prefix : '';
        const suffix = this.suffix ? this.suffix : '';
        // removes - sign because prefix
        texFormated = texFormated.replace(/[-]/g, '');
        this.ctlText = prefix + texFormated + suffix;
        this.currentText = this.ctlText;
        if (this.textBox) {
            this.textBox.value = this.ctlText;
            this.textBox.input.nativeElement.value = this.textBox.value;
        }
        this.controlValue = this.currentText;
    }
    /**
     * Checks for current display format suffix and prefix
     *
     * @memberof TDBNumberComponent
     */
    assignSuffixPrefixDisplayFormat() {
        this.suffix = this.maskservice.displayFormat.suffix;
        this.prefix = this.maskservice.displayFormat.prefix;
    }
    /**
     * Checks for current format suffix and prefix
     *
     * @memberof TDBNumberComponent
     */
    assignSuffixPrefixFormat() {
        this.suffix = this.maskservice.format.suffix;
        this.prefix = this.maskservice.format.prefix;
    }
    /**
     * Value change is triggered when textbox value has changed
     *
     * @param {*} event
     * @memberof TDBNumberComponent
     */
    valueChange(event) {
        const previousValue = this.value;
        event = this.deleteDecimalWhendot(event, this.currentText);
        this.valueChangeValidateFormat(event);
        if (previousValue != this.value) {
            const data = new EventData$1(event, this.id, this.model.mapperId);
            this.changeServerEvent(data);
        }
    }
    /**
     * Validates deleting before dot
     *
     * @param {string} newValue
     * @param {string} previousValue
     * @return {*}  {string}
     * @memberof TDBNumberComponent
     */
    deleteDecimalWhendot(newValue, previousValue) {
        const elmStart = this.textBox.input.nativeElement.selectionStart;
        if (this.deleteValidation && previousValue.indexOf('.') === elmStart) {
            newValue =
                newValue.slice(0, elmStart) + '.' + newValue.slice(elmStart + 1);
        }
        return newValue;
    }
    /**
     *Applies validate format and adjust caret when valueChange
     *
     * @param {string} event
     * @memberof TDBNumberComponent
     */
    valueChangeValidateFormat(event) {
        this.setCaretWhenvalueChange();
        this.validateFormat(event);
    }
    /**
     * When value change sets caret using right to left, using negative number.
     *
     * @memberof TDBNumberComponent
     */
    setCaretWhenvalueChange() {
        this.caret = -(this.textBox.input.nativeElement.value.length -
            this.textBox.input.nativeElement.selectionStart);
    }
    /**
     * Method to send the change event to the server
     *
     * @param {EventData} event
     * @memberof TDNumberExtractor
     */
    changeServerEvent(event) {
        this.Change.emit(event);
    }
    /**
     * Validates last character of string when decimals to avoid automatinc kendo rounding.
     *
     * @param {string} trueNumber
     * @return {*}
     * @memberof TDBNumberComponent
     */
    manualRoundValidation(trueNumber) {
        if (this.textBox.input.nativeElement.selectionStart ===
            this.textBox.input.nativeElement.selectionEnd &&
            this.selectionInDecimal(this.textBox.input.nativeElement.selectionStart) &&
            this.decimalOverflow(trueNumber)) {
            return trueNumber.toString().slice(0, -1);
        }
        else {
            return trueNumber;
        }
    }
    /**
     * Verifies if decimals are overflow
     *
     * @param {string} trueNumber
     * @return {*}
     * @memberof TDBNumberComponent
     */
    decimalOverflow(trueNumber) {
        const maskDecimals = this.maskservice.format.maskedValue.length -
            1 -
            this.maskservice.format.maskedValue.indexOf('.');
        const numberDecimals = trueNumber.length - 1 - trueNumber.indexOf('.');
        return numberDecimals > maskDecimals;
    }
    /**
     * Validates format in runtime.
     *
     * @param {string} event
     * @memberof TDBNumberComponent
     */
    validateFormat(event) {
        let textNumber = event || '';
        if (this.prefix.length > 0) {
            // remove prefix from value.
            const regex2 = new RegExp(this.maskservice.escapeRegExp(this.prefix), 'g');
            textNumber = textNumber.replace(regex2, '');
        }
        //remove any letter
        textNumber = textNumber.replace(/[^\d.]/g, '');
        textNumber = this.manualRoundValidation(textNumber);
        // obtain real number
        let trueNumber = parseFloat(textNumber);
        // validate if is a valid number to continue
        if (isNaN(trueNumber)) {
            trueNumber = 0;
        }
        // transform number into valid text format
        let texFormated = this.intl.formatNumber(trueNumber, this.maskservice.format.maskedValue);
        // parse to a valid float number
        let newNumericValue;
        if (this.maskservice.format.currentMask ===
            this.maskservice.format.patternNegative) {
            // assign value model with valid value number format
            newNumericValue = -parseFloat(texFormated.replace(/,/g, ''));
        }
        else {
            newNumericValue = parseFloat(texFormated.replace(/,/g, ''));
        }
        texFormated = this.validateTexFormatMaxMin(newNumericValue, texFormated);
        // Check if decimal point was added, if yes then add it to end
        if (this.decimalPointAdded && this.areDecimalsOptional(this.format)) {
            this.currentText += '.';
            texFormated += '.';
        }
        ///Assing value formated to input
        const preTxFr = texFormated;
        if (preTxFr.length > this.formatMaskedValueLength) {
            this.textBox.value = this.currentText;
            this.textBox.input.nativeElement.value = this.currentText;
        }
        else {
            this.textBox.value = this.prefix + texFormated + this.suffix;
            this.textBox.input.nativeElement.value = this.textBox.value;
            this.currentText = this.textBox.value;
        }
        // assing textProperty
        this.ctlText = this.currentText;
        this.controlValue = this.ctlText;
    }
    /**
     * Validates if max min is correct
     *
     * @param {number} value
     * @param {string} texFormated
     * @return {*}
     * @memberof TDBNumberComponent
     */
    validateTexFormatMaxMin(value, texFormated) {
        // if value is correct no transformation required
        if (this.validateMinMax(value)) {
            this.value = value;
            return texFormated;
        }
        else {
            // if value is incorrect text format should be transformed
            return this.intl.formatNumber(Math.abs(this.value), this.maskservice.format.maskedValue);
        }
    }
    /**
     * afterValueChange Cycle
     *
     * @param {*} event
     * @memberof TDBNumberComponent
     */
    afterValueChange(event) {
        this.adjustCaret();
    }
    /**
     * Adjust caret position after value modified
     *
     * @memberof TDBNumberComponent
     */
    adjustCaret() {
        //  set caret position starting from end.
        let caretPosRtL = this.textBox.input.nativeElement.value.length + this.caret;
        caretPosRtL = this.checkCaretForDecimalPlaces(caretPosRtL);
        caretPosRtL = caretPosRtL < 0 ? 0 : caretPosRtL;
        this.updateDeleteValidations();
        this.textBox.input.nativeElement.selectionStart = caretPosRtL;
        this.textBox.input.nativeElement.selectionEnd = caretPosRtL;
    }
    /**
     *  Sets delete validations to default state.
     *
     * @memberof TDBNumberComponent
     */
    updateDeleteValidations() {
        this.deleteValidation = false;
        this.backspace = false;
        this.decimalPointAdded = false;
    }
    /**
     * Checks for cursor on decimal places and moves to convenient position
     *
     * @memberof TDBNumberComponent
     */
    checkCaretForDecimalPlaces(pos) {
        if (this.selectionInDecimal(pos) &&
            !this.backspace &&
            !this.deleteValidation) {
            return pos + 1;
        }
        if (this.selectionInDecimal(pos) &&
            (this.backspace || this.deleteValidation)) {
            //checks if current mask has 0 to be replaced
            return /\..*0/.test(this.maskservice.format.currentMask) ? pos - 1 : pos;
        }
        // Validate if a decimal point was added, in that case return the position
        if (this.decimalPointAdded) {
            return this.textBox.input.nativeElement.value.indexOf('.') + 1;
        }
        return pos;
    }
    /**
     * Verifies user is in decimal spaces.
     *
     * @return {*}  {boolean}
     * @memberof TDBNumberComponent
     */
    selectionInDecimal(pos) {
        const decimalIndex = this.textBox.input.nativeElement.value.indexOf('.');
        if (decimalIndex > -1) {
            return pos > decimalIndex;
        }
        else {
            return false;
        }
    }
    /**
     * Method to handle the keydown event
     *
     * @param {KeyboardEvent} event
     * @memberof TDBNumberComponent
     */
    keyDown(event) {
        const data = new EventData$1(event, this.id, this.model.mapperId);
        data['args'] = {
            KeyCode: event.code,
            Shift: event.shiftKey ? 1 : 0
        };
        this.keyDownServerEvent(data);
        if (event.key === '-') {
            if (this.validateMinMax(-parseFloat(this.value.toString()))) {
                this.value = -parseFloat(this.value.toString());
                this.maskservice.validateNegativeFormat(this.maskservice.format);
                this.assignSuffixPrefixFormat();
                this.textBox.maxlength =
                    this.formatMaskedValueLength + this.prefix.length + 1; //adding one aditional to avoid usser stop typing
                this.currentText = this.currentText.slice(1);
                this.valueChangeValidateFormat(this.value.toString());
                this.adjustCaret();
            }
        }
        if (event.key === '+') {
            if (this.validateMinMax(-parseFloat(this.value.toString()))) {
                this.value = parseFloat(this.value.toString());
                this.maskservice.validatePositiveFormat(this.maskservice.format);
                this.assignSuffixPrefixFormat();
                this.textBox.maxlength =
                    this.formatMaskedValueLength + this.prefix.length + 1; //adding one aditional to avoid usser stop typing
                this.valueChangeValidateFormat(this.value.toString());
            }
        }
        if (event.key === 'Backspace') {
            if (this.selectionInDecimal(this.textBox.input.nativeElement.selectionStart)) {
                this.backspace = true;
            }
        }
        if (event.key === 'Delete') {
            this.deleteValidation = true;
        }
        if (event.key === '.') {
            this.decimalPointAdded = true;
        }
    }
    /**
     * Validates if the decimal places of the mask are optional
     *
     * @memberof TDBNumber
     * @param {string} mask to validate
     * @returns {boolean}
     */
    areDecimalsOptional(mask) {
        return !mask.includes('0', mask.indexOf('.'));
    }
    /**
     * Method to handle the blur of the component
     *
     * @param {*} event
     * @memberof TDBNumberComponent
     */
    blur(event) {
        super.blur(event);
        // when leave component updates selection start
        this.selStart = this.textBox.input.nativeElement.selectionStart;
        this.assignDisplayFormat();
    }
    /**
     * Focus event handler
     * Here the selStart and selEnd are setted to the input
     *
     * @param {*} event
     * @memberof TDBNumberComponent
     */
    focus(event) {
        super.focus(event);
        this.assignSuffixPrefixFormat();
        this.textBox.maxlength =
            this.formatMaskedValueLength + this.prefix.length + 1; //ading one aditional to avoid usser stop typing
        this.valueChangeValidateFormat(this.value?.toString());
        /* c8 ignore else */
        this.adjustSelStartWHenFocus();
    }
    /**
     * When component got focus adjust SelStart.
     *
     * @memberof TDBNumberComponent
     */
    adjustSelStartWHenFocus() {
        this.selStart =
            this.selStart >= 0
                ? this.selStart
                : this.textBox.input.nativeElement.value.indexOf('.');
        this.textBox.input.nativeElement.selectionStart = this.selStart;
        this.textBox.input.nativeElement.selectionEnd = this.selStart;
        if (this.textBox.input && this.selLength > 0) {
            this.textBox.input.nativeElement.selectionEnd =
                this.selStart + this.selLength;
        }
    }
    /**
     *Method to handle the keyPress event
     *
     * @param {KeyboardEvent} event
     * @memberof TDBNumberComponent
     */
    keyPress(event) {
        const data = new EventData$1(event, this.id, this.model.mapperId);
        data['args'] = {
            KeyAscii: parseInt(event.key.charAt(0))
        };
        this.keyPressServerEvent(data);
    }
    /**
     * Method to send the keyDown to the server
     *
     * @param {EventData} event
     * @memberof TDBNumberComponent
     */
    keyDownServerEvent(event) {
        this.KeyDown.emit(new KeyEventArgs(event.event, this.id, this, 'xtdbkydwnvntrgs'));
    }
    /**
     * Method to send the keypress to the server
     *
     * @param {EventData} event
     * @memberof TDBNumberComponent
     */
    keyPressServerEvent(event) {
        this.KeyPress.emit(event);
    }
    /**
     * Method to validate the value is between the MinValue and MaxValue
     *
     * @return {*}  {boolean}
     * @memberof TDBNumberComponent
     */
    validateMinMax(value) {
        return value >= this.minValue && value <= this.maxValue;
    }
};
/**
 * TDnumber defaultNegativeColor
 *
 * @static
 * @memberof TDBNumberComponent
 */
TDBNumberComponent.defaultNegativeColor = 'red';
TDBNumberComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TDBNumberComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }, { token: MaskService }, { token: i3$3.IntlService }, { token: BaseValidatorService, optional: true }, { token: i3.BringTopService, optional: true }, { token: ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TDBNumberComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TDBNumberComponent, selector: "wm-tdbnumber", inputs: { model: "model" }, outputs: { Change: "Change" }, providers: [MaskService], viewQueries: [{ propertyName: "textBox", first: true, predicate: TextBoxComponent$1, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\">\r\n  <input #anchor class=\"input-hidden\" [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\" />\r\n  <kendo-textbox wmControls [hostComponent]=\"this\" [(value)]=\"controlValue\" [disabled]=\"!enabled\" [ngClass]=\"valueStyle()\"\r\n    [ngStyle]=\"setMyStyle()\" (valueChange)=\"valueChange($event)\" (afterValueChangedTDB)=\"afterValueChange($event)\"></kendo-textbox>\r\n\r\n  <kendo-popup [anchor]=\"anchor\" class=\"popup-tdbnumber\" *ngIf=\"show\">\r\n    <div class='dddw-content'>\r\n      <div class='base'>\r\n        <div class='maindisplay'>\r\n          <div class=\"subdisplay\">{{ subText }}</div>\r\n        </div>\r\n\r\n        <div class=\"keypad\">\r\n          <table style=\"width: 100%;\">\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\" aria-disabled=\"true\"></td>\r\n              <td class=\"keys ackey\" colspan=\"1\" (click)=\"allClear($event)\">C</td>\r\n              <td class=\"keys opkey\" colspan=\"2\" (click)=\"pressOperatorKey($event, '/')\">CE</td>\r\n              <td class=\"keys opkey\" colspan=\"1\" aria-disabled=\"true\"></td>\r\n              <td class=\"keys opkey\" colspan=\"1\">BS</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\">MC</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '7')\">7</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '8')\">8</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '9')\">9</td>\r\n              <td class=\"keys opkey\" (click)=\"pressOperatorKey($event, '*')\">/</td>\r\n              <td class=\"keys opkey\" colspan=\"1\">%</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\">MR</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '4')\">4</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '5')\">5</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '6')\">6</td>\r\n              <td class=\"keys opkey\" (click)=\"pressOperatorKey($event, '-')\">*</td>\r\n              <td class=\"keys opkey\" colspan=\"1\">1/X</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\">MS</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '1')\">1</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '2')\">2</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '3')\">3</td>\r\n              <td class=\"keys opkey\" (click)=\"pressOperatorKey($event, '+')\">-</td>\r\n              <td class=\"keys equalkey\" rowspan=\"2\" (click)=\"getAnswer($event)\">=</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\">M+</td>\r\n              <td colspan=\"1\" class=\"keys numkey\" (click)=\"pressKey($event, '0')\">0</td>\r\n              <td class=\"keys opkey\" colspan=\"1\">+/-</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '.')\">.</td>\r\n              <td class=\"keys opkey\" (click)=\"pressOperatorKey($event, '+')\">+</td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </kendo-popup>\r\n</div>\r\n", styles: [".defaultNegativeColor{color:red}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i8.TextBoxComponent, selector: "kendo-textbox", inputs: ["focusableId", "title", "disabled", "readonly", "tabindex", "value", "selectOnFocus", "showSuccessIcon", "showErrorIcon", "clearButton", "successIcon", "errorIcon", "clearButtonIcon", "size", "rounded", "fillMode", "tabIndex", "placeholder", "maxlength"], outputs: ["valueChange", "inputFocus", "inputBlur", "focus", "blur"], exportAs: ["kendoTextBox"] }, { kind: "component", type: i3$2.PopupComponent, selector: "kendo-popup", inputs: ["animate", "anchor", "anchorAlign", "collision", "popupAlign", "copyAnchorStyles", "popupClass", "positionMode", "offset", "margin"], outputs: ["anchorViewportLeave", "close", "open", "positionChange"], exportAs: ["kendo-popup"] }, { kind: "directive", type: ControlsDirective, selector: "[wmControls]" }, { kind: "directive", type: AfterValueChangedTdbNumberDirective, selector: "[afterValueChangedTDB]", inputs: ["valueChangeDelay"], outputs: ["afterValueChangedTDB"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('Text'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], TDBNumberComponent.prototype, "text", null);
__decorate([
    MarkForCheck(),
    NotifyChange('CtlText'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], TDBNumberComponent.prototype, "ctlText", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Value'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], TDBNumberComponent.prototype, "value", null);
__decorate([
    serverEvent('Change', TDNumberExtractor.changeEventArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EventData$1]),
    __metadata("design:returntype", void 0)
], TDBNumberComponent.prototype, "changeServerEvent", null);
__decorate([
    serverEvent('KeyDownEvent', TDNumberExtractor.KeyDownArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EventData$1]),
    __metadata("design:returntype", void 0)
], TDBNumberComponent.prototype, "keyDownServerEvent", null);
__decorate([
    serverEvent('KeyPressEvent', TDNumberExtractor.KeyPressArgsExtractor),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EventData$1]),
    __metadata("design:returntype", void 0)
], TDBNumberComponent.prototype, "keyPressServerEvent", null);
TDBNumberComponent = TDBNumberComponent_1 = __decorate([
    dataTransfer(['xtdbnmbr']),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        Renderer2,
        ElementRef,
        WebComponentsService,
        MaskService,
        IntlService,
        BaseValidatorService,
        BringTopService,
        ContainerInteractionService])
], TDBNumberComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TDBNumberComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-tdbnumber', inputs: ['model'], providers: [MaskService], template: "<div *ngIf=\"model\">\r\n  <input #anchor class=\"input-hidden\" [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\" />\r\n  <kendo-textbox wmControls [hostComponent]=\"this\" [(value)]=\"controlValue\" [disabled]=\"!enabled\" [ngClass]=\"valueStyle()\"\r\n    [ngStyle]=\"setMyStyle()\" (valueChange)=\"valueChange($event)\" (afterValueChangedTDB)=\"afterValueChange($event)\"></kendo-textbox>\r\n\r\n  <kendo-popup [anchor]=\"anchor\" class=\"popup-tdbnumber\" *ngIf=\"show\">\r\n    <div class='dddw-content'>\r\n      <div class='base'>\r\n        <div class='maindisplay'>\r\n          <div class=\"subdisplay\">{{ subText }}</div>\r\n        </div>\r\n\r\n        <div class=\"keypad\">\r\n          <table style=\"width: 100%;\">\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\" aria-disabled=\"true\"></td>\r\n              <td class=\"keys ackey\" colspan=\"1\" (click)=\"allClear($event)\">C</td>\r\n              <td class=\"keys opkey\" colspan=\"2\" (click)=\"pressOperatorKey($event, '/')\">CE</td>\r\n              <td class=\"keys opkey\" colspan=\"1\" aria-disabled=\"true\"></td>\r\n              <td class=\"keys opkey\" colspan=\"1\">BS</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\">MC</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '7')\">7</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '8')\">8</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '9')\">9</td>\r\n              <td class=\"keys opkey\" (click)=\"pressOperatorKey($event, '*')\">/</td>\r\n              <td class=\"keys opkey\" colspan=\"1\">%</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\">MR</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '4')\">4</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '5')\">5</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '6')\">6</td>\r\n              <td class=\"keys opkey\" (click)=\"pressOperatorKey($event, '-')\">*</td>\r\n              <td class=\"keys opkey\" colspan=\"1\">1/X</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\">MS</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '1')\">1</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '2')\">2</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '3')\">3</td>\r\n              <td class=\"keys opkey\" (click)=\"pressOperatorKey($event, '+')\">-</td>\r\n              <td class=\"keys equalkey\" rowspan=\"2\" (click)=\"getAnswer($event)\">=</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"keys opkey\" colspan=\"1\">M+</td>\r\n              <td colspan=\"1\" class=\"keys numkey\" (click)=\"pressKey($event, '0')\">0</td>\r\n              <td class=\"keys opkey\" colspan=\"1\">+/-</td>\r\n              <td class=\"keys numkey\" (click)=\"pressKey($event, '.')\">.</td>\r\n              <td class=\"keys opkey\" (click)=\"pressOperatorKey($event, '+')\">+</td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </kendo-popup>\r\n</div>\r\n", styles: [".defaultNegativeColor{color:red}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }, { type: MaskService }, { type: i3$3.IntlService }, { type: BaseValidatorService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { textBox: [{
                type: ViewChild,
                args: [TextBoxComponent$1]
            }], Change: [{
                type: Output
            }], text: [], ctlText: [], value: [], changeServerEvent: [], keyDownServerEvent: [], keyPressServerEvent: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
var CompareMethod;
(function (CompareMethod) {
    /**
     * Binary option.
     */
    CompareMethod[CompareMethod["Binary"] = 0] = "Binary";
    /**
     * Text option.
     */
    CompareMethod[CompareMethod["Text"] = 1] = "Text";
})(CompareMethod || (CompareMethod = {}));

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * @export
 * @class String
 */
class Strings {
    /**
     * Returns the asc code for the first char in the value.
     * @param value The string value.
     * @returns The asc code.
     */
    static asc(value) {
        if (!value || value.length == 0) {
            throw new Error('Invalid value argument.');
        }
        return value.charCodeAt(0);
    }
    /**
     * Converts the input to a char.
     * @param charCode The char code.
     * @returns The resulting string value.
     */
    static chr(charCode) {
        if (charCode < 0 || charCode > 255) {
            throw new Error('Invalid CharCode argument.');
        }
        return String.fromCharCode(charCode);
    }
    /**
     * Determines whether string1 contains the string2.
     * @param string1 The first string value that contains the target.
     * @param string2 The second string value to be found.
     * @returns The index where the value was found.
     */
    static inStr(string1, string2, compare = CompareMethod.Binary) {
        return Strings.inStr1(1, string1, string2, compare);
    }
    /**
     * Determines whether string1 contains the string2.
     * @param start The index position where start to find.
     * @param string1 The first string value that contains the target.
     * @param string2 The second string value to be found.
     * @returns The index where the value was found.
     */
    static inStr1(start, string1, string2, compare = CompareMethod.Binary) {
        if (start < 1) {
            throw new Error('Invalid Start argument.');
        }
        const num = string1 != null ? string1.length : 0;
        if (start - 1 > num || num == 0) {
            return 0;
        }
        else if (string2 == null || string2.length == 0) {
            return start;
        }
        if (start > 1) {
            string1 = string1.substring(start - 1);
        }
        Utils.regexReDosValidation(string2, false);
        const test = compare == CompareMethod.Text
            ? new RegExp(string2, 'i') // nosemgrep
            : new RegExp(string2); // nosemgrep
        const result = string1.search(test);
        if (result < 0) {
            return 0;
        }
        return result + start;
    }
    /**
     * len method, return the length of the string *
     * @static
     * @param {string} string
     * @return {number}  {number}
     * @memberof String
     */
    static len(string) {
        if (typeof string === 'string') {
            return string.length;
        }
        else {
            throw new Error('You must provide a string');
        }
    }
    /**
     * strConv just support upperCase and return the text in upperCase
     * @static
     * @param {string} string
     * @param {VbStrConv} VbStrConv
     * @return {string}  {string}
     * @memberof String
     */
    static strConv(string, vbStrConv) {
        let strConvNewText;
        if (typeof string === 'string') {
            switch (vbStrConv) {
                case 1:
                    strConvNewText = string.toUpperCase();
                    break;
                case 2:
                    // case 2 is not support yet
                    strConvNewText = '';
                    break;
                case 3:
                    // case 3 is not support yet
                    strConvNewText = '';
                    break;
                default:
                    strConvNewText = '';
            }
            return strConvNewText;
        }
        else {
            throw new Error('You must provide a string');
        }
    }
    /**
     * Replace the find value with the replacement value into the given expression.
     * @param expression The original expression.
     * @param find The value to be found.
     * @param replacement The value to replace.
     * @param [start] The positive index in the expression where the replacement should start.
     * @param [count] The maximun number of replacements.
     * @param [compare] The compare method.
     * @returns The new expression with the replacements.
     */
    static replace(expression, find, replacement, start = 1, count = -1, compare = CompareMethod.Binary) {
        let result;
        Strings.validatReplaceCount(count);
        Strings.validateReplaceStart(start);
        if (expression == null || start > expression.length) {
            result = null;
        }
        else {
            if (start != 1) {
                expression = expression.substring(start - 1);
                start = 1;
            }
            if (find == null || find.length == 0 || count == 0) {
                result = expression;
            }
            else {
                count = count == -1 ? expression.length : count;
                replacement = !replacement ? '' : replacement;
                result = Strings.replaceInternal(expression, find, replacement, start - 1, count, compare);
            }
        }
        return result;
    }
    /**
     * Validates replace start number is greather than 1.
     * @param start The start value.
     */
    static validateReplaceStart(start) {
        if (start <= 0) {
            throw new Error('Invalid Start argument.');
        }
    }
    /**
     * Validats replace count is positive
     * @param count The count of replacements.
     */
    static validatReplaceCount(count) {
        if (count < -1) {
            throw new Error('Invalid Count argument.');
        }
    }
    /**
     * Replaces the given find with the replacement in the expression.
     * The replament can indicates custom values as start, count and compare method.
     * @param expression The expression where the action should be applied.
     * @param find The statement to be found.
     * @param replacement The statement to replace.
     * @param start Indicates the index where the algorithm should start.
     * @param count Indicates the number of replacements.
     * @param compare The compare method.
     * @returns The new expression with the replacements.
     */
    static replaceInternal(expression, find, replacement, start, count, compare) {
        let counter = 0;
        function convert(str, p1, offset, s) {
            if (p1 < start || counter == count) {
                return str;
            }
            counter++;
            return replacement;
        }
        function escapeRegExp(str) {
            return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
        }
        Utils.regexReDosValidation(find, false);
        const test = compare == CompareMethod.Text
            ? new RegExp(escapeRegExp(find), 'gi') // nosemgrep
            : new RegExp(escapeRegExp(find), 'g'); // nosemgrep
        return expression.replace(test, convert);
    }
}
/**
 *
 *
 * @export
 * @class Information
 */
class Information {
    /**
     * isNumeric return a boolean if exist a number or not.
     * @static
     * @param {object} any
     * @return {boolean}
     * @memberof Information
     */
    static isNumeric(object) {
        const num = Number(object);
        return !isNaN(num);
    }
}
/**
 * Contains the procedures used to perform various conversion operations.
 * @export
 * @class Conversion
 */
class Conversion {
    /**
     * Returns a String representation of a number.
     * @static
     * @param number An Object containing any valid numeric expression.
     * @returns A String representation of a number.
     */
    static str(number) {
        if (number === null) {
            throw new Error('number is null');
        }
        if (!isNaN(number)) {
            return number >= 0 ? ' ' + number : number.toString();
        }
        else {
            throw new Error("Argument 'number' cannot be converted to a numeric value.");
        }
    }
    /**
     * Returns the numbers contained in a string as a numeric value of appropriate type.
     * @param inputStr String containing a number.
     * @returns The numbers contained in a string as a numeric value of appropriate type.
     */
    static val(inputStr) {
        if (this.isStringNullOrEmpty(inputStr)) {
            return 0;
        }
        let result = '';
        for (let i = 0; i < inputStr.length; i++) {
            const char = inputStr.charAt(i);
            if (char != ' ') {
                if (this.isCharInStringACorrectNumber(char, result)) {
                    result += char;
                }
                else {
                    return this.isStringNullOrEmpty(result) ? 0 : Number(result);
                }
            }
        }
        return this.isStringNullOrEmpty(result) ? 0 : Number(result);
    }
    /**
     * Determines if a string is null or empty.
     * @param string string.
     * @returns True if the string is null or empty.
     */
    static isStringNullOrEmpty(string) {
        return !string || !string.trim() ? true : false;
    }
    /**
     * Determines if a character within a string corresponds to a number or a point.
     * @param char Character within string
     * @param string String to be checked
     * @returns True if a character within a string corresponds to a number or a point.
     */
    static isCharInStringACorrectNumber(char, string) {
        return !isNaN(Number(char)) || (char == '.' && !string.includes('.'))
            ? true
            : false;
    }
    /**
     * Returns the integer portion of a number.
     * @param number A number or any valid numeric expression.
     * @returns The integer portion of a number.
     */
    static int(number) {
        return Math.floor(number);
    }
}
/**
 * Provides information about, and means to manipulate,
 * the current environment and platform.
 *
 * @export
 * @class Environment
 */
class Environment {
}
/**
 * Gets the newline string defined for this environment.
 *
 * @memberof Environment
 */
Environment.newLine = '\r\n';

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
var VbStrConv;
(function (VbStrConv) {
    /**
     *Performs no conversion.
     */
    VbStrConv[VbStrConv["None"] = 0] = "None";
    /**
     * Converts the string to uppercase characters
     */
    VbStrConv[VbStrConv["Uppercase"] = 1] = "Uppercase";
    /**
     *Converts the string to lowercase characters
     */
    VbStrConv[VbStrConv["Lowercase"] = 2] = "Lowercase";
    /**
     * Converts the first letter of every word in the string to uppercase
     */
    VbStrConv[VbStrConv["ProperCase"] = 3] = "ProperCase";
    /**
     * Converts narrow (single-byte) characters in the string to wide (double-byte) characters
     */
    VbStrConv[VbStrConv["Wide"] = 4] = "Wide";
    /**
     * Converts wide (double-byte) characters in the string to narrow (single-byte) characters
     */
    VbStrConv[VbStrConv["Narrow"] = 8] = "Narrow";
    /**
     * Converts Hiragana characters in the string to Katakana characters
     */
    VbStrConv[VbStrConv["Katakana"] = 16] = "Katakana";
    /**
     * Converts Katakana characters in the string to Hiragana character
     */
    VbStrConv[VbStrConv["Hiragana"] = 32] = "Hiragana";
    /**
     * Converts the string to Simplified Chinese characters
     */
    VbStrConv[VbStrConv["SimplifiedChinese"] = 256] = "SimplifiedChinese";
    /**
     * Converts the string to Traditional Chinese characters
     */
    VbStrConv[VbStrConv["TraditionalChinese"] = 512] = "TraditionalChinese";
    /**
     * Converts the string from file system rules for casing to linguistic rules
     */
    VbStrConv[VbStrConv["LinguisticCasing"] = 1024] = "LinguisticCasing";
})(VbStrConv || (VbStrConv = {}));

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class StubComponent extends ControlComponent {
    /* c8 ignore start */
    constructor(changeDetector, renderer2, element, webComponents) {
        super(changeDetector, renderer2, element, webComponents);
        this.changeDetector = changeDetector;
        this.renderer2 = renderer2;
        this.element = element;
    }
}
StubComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: StubComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WebComponentsService }], target: i0.ɵɵFactoryTarget.Component });
StubComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: StubComponent, selector: "wm-stub", usesInheritance: true, ngImport: i0, template: "<div class=\"stub-component-borde\" [ngClass]=\"class\">\r\n  <h1>Under construction</h1>\r\n  <p>Hold tight as we get our working robots together and produce the most astonishing product.</p>\r\n  <p>&copy;Mobilize.net</p>\r\n</div>", styles: [".stub-component-border{border-style:solid;overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: StubComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-stub', template: "<div class=\"stub-component-borde\" [ngClass]=\"class\">\r\n  <h1>Under construction</h1>\r\n  <p>Hold tight as we get our working robots together and produce the most astonishing product.</p>\r\n  <p>&copy;Mobilize.net</p>\r\n</div>", styles: [".stub-component-border{border-style:solid;overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WebComponentsService }]; } });

class WebMapKendoModule {
    /**
     * Creates an instance of Web Map kendo module.
     * Sets the version of the Web Map app.
     * @param webMapSevice Service to set wmSourceVersion.
     */
    /* c8 ignore next 3 */
    constructor(webMapSevice) {
        this.webMapSevice = webMapSevice;
        this.webMapSevice.config.wmSourceVersion = WMConstants.sourceVersionWin;
    }
}
WebMapKendoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebMapKendoModule, deps: [{ token: i1.WebMapService }], target: i0.ɵɵFactoryTarget.NgModule });
WebMapKendoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: WebMapKendoModule, bootstrap: [MonthCalendarComponent,
        UserControlComponent,
        LabelComponent,
        WMWindowComponent,
        ButtonComponent,
        TextBoxComponent,
        MessageBoxComponent,
        CheckBoxComponent,
        DatetimepickerComponent,
        PictureBoxComponent,
        TimerComponent,
        DatetimepickerComponent,
        GroupBoxComponent,
        PanelComponent,
        MaskedTextBoxComponent,
        RadiobuttonComponent,
        ListViewComponent,
        ListViewBaseComponent,
        ListViewListComponent,
        ListViewDetailsComponent,
        DataGridViewFlexComponent,
        ListBoxComponent,
        AdoDataControlComponent,
        ComboBoxComponent,
        KendoMenuComponent,
        KendoListBoxComponent,
        KendoDropDownListComponent,
        ToolStripComponent,
        StatusStripComponent,
        DataGridViewComponent,
        PrintDialogComponent,
        FileDialogComponent,
        TreeViewComponent,
        TabPageComponent,
        TabControlComponent,
        NumericUpDownComponent,
        ContextMenuStripComponent,
        WebBrowserComponent,
        CheckedListBoxComponent,
        SessionExpiredComponent,
        ThreadexceptiondialogComponent,
        ComboBoxJqueryComponent,
        TableLayoutPanelComponent,
        TableRowComponent,
        LinkLabelComponent,
        TrackbarComponent,
        NotifyIconComponent,
        SplitContainerBaseComponent,
        SplitContainerComponent,
        SplitStaticContainerComponent,
        InputBoxComponent,
        ShapeComponent,
        ToolStripLabelComponent,
        ToolStripTextBoxComponent,
        ToolStripMenuItemComponent,
        ToolStripComboBoxComponent,
        ToolStripButtonComponent,
        ToolStripDropdownButtonComponent,
        ToolStripStatusLabelComponent,
        SimpleAutoSizeComponent,
        WmusercontrolComponent,
        BackgroundWorkerComponent,
        ControlContainerComponent,
        CustomControlContainerComponent,
        StubComponent,
        DialogBaseComponent,
        BindingnavigatorComponent,
        SplitContainerPanelBaseComponent,
        SplitContainerPanelComponent,
        SplitterStaticPanelComponent,
        ColorDialogComponent,
        FontDialogComponent,
        HscrollbarComponent,
        ScrollBarComponent,
        VscrollbarComponent,
        TDBNumberComponent], declarations: [MonthCalendarComponent,
        UserControlComponent,
        FormComponent,
        GridComponent,
        ListBoxBaseComponent,
        TextBoxBaseComponent,
        SessionExpiredComponent,
        LabelComponent,
        WMWindowComponent,
        ButtonComponent,
        TextBoxComponent,
        MessageBoxComponent,
        CheckBoxComponent,
        DatetimepickerComponent,
        PictureBoxComponent,
        TimerComponent,
        GroupBoxComponent,
        PanelComponent,
        RadiobuttonComponent,
        MaskedTextBoxComponent,
        ListViewComponent,
        ListViewBaseComponent,
        ListViewListComponent,
        ListViewDetailsComponent,
        DataGridViewFlexComponent,
        ListBoxComponent,
        AdoDataControlComponent,
        ComboBoxComponent,
        KendoMenuComponent,
        TopLevelToolstripItemComponent,
        KendoListBoxComponent,
        KendoComboboxComponent,
        KendoDropDownListComponent,
        ToolStripComponent,
        StatusStripComponent,
        DataGridViewComponent,
        FileDialogComponent,
        PrintDialogComponent,
        TreeViewComponent,
        TabPageComponent,
        TabControlComponent,
        NumericUpDownComponent,
        ContextMenuStripComponent,
        WebBrowserComponent,
        CheckedListBoxComponent,
        DisabledItemDirective,
        ThreadexceptiondialogComponent,
        ProgressBarComponent,
        RichtextboxComponent,
        AfterValueChangedDirective,
        ComboBoxJqueryComponent,
        ComboBoxBaseComponent,
        TableLayoutPanelComponent,
        TableRowComponent,
        LinkLabelComponent,
        TrackbarComponent,
        NotifyIconComponent,
        SplitContainerBaseComponent,
        SplitContainerComponent,
        SplitStaticContainerComponent,
        InputBoxComponent,
        ShapeComponent,
        ToolStripLabelComponent,
        ToolStripTextBoxComponent,
        ToolStripMenuItemComponent,
        ToolStripComboBoxComponent,
        ToolStripButtonComponent,
        ToolStripDropdownButtonComponent,
        ToolStripStatusLabelComponent,
        SimpleAutoSizeComponent,
        WmusercontrolComponent,
        BackgroundWorkerComponent,
        ControlContainerComponent,
        ControlComponentBaseComponent,
        ControlComponent,
        StubComponent,
        ControlsDirective,
        TabDirective,
        CustomControlContainerComponent,
        DialogBaseComponent,
        BindingnavigatorComponent,
        SplitContainerPanelBaseComponent,
        SplitContainerPanelComponent,
        SplitterStaticPanelComponent,
        ColorDialogComponent,
        FontDialogComponent,
        HscrollbarComponent,
        ScrollBarComponent,
        VscrollbarComponent,
        ContainerDirective,
        TDBNumberComponent,
        ChartComponent,
        AfterValueChangedTdbNumberDirective], imports: [CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        ButtonsModule,
        ChartsModule,
        DragAndDropModule,
        DateInputsModule,
        LabelModule,
        DialogsModule,
        LayoutModule,
        WebMapModule,
        BaseComponentsModule,
        GridModule,
        InputsModule,
        DropDownsModule,
        TreeViewModule,
        PopupModule,
        MenuModule,
        GaugesModule,
        TooltipModule,
        ProgressBarModule,
        ToolBarModule,
        EditorModule,
        ChartsModule], exports: [MonthCalendarComponent,
        UserControlComponent,
        LabelComponent,
        WMWindowComponent,
        ButtonComponent,
        TextBoxComponent,
        MessageBoxComponent,
        CheckBoxComponent,
        DatetimepickerComponent,
        PictureBoxComponent,
        TimerComponent,
        DatetimepickerComponent,
        GroupBoxComponent,
        PanelComponent,
        MaskedTextBoxComponent,
        RadiobuttonComponent,
        ListViewComponent,
        ListViewComponent,
        ListViewBaseComponent,
        ListViewListComponent,
        ListViewDetailsComponent,
        DataGridViewFlexComponent,
        ListBoxComponent,
        AdoDataControlComponent,
        ComboBoxComponent,
        KendoMenuComponent,
        KendoListBoxComponent,
        KendoDropDownListComponent,
        ToolStripComponent,
        StatusStripComponent,
        DataGridViewComponent,
        PrintDialogComponent,
        FileDialogComponent,
        TreeViewComponent,
        TabPageComponent,
        TabControlComponent,
        NumericUpDownComponent,
        ContextMenuStripComponent,
        WebBrowserComponent,
        CheckedListBoxComponent,
        DisabledItemDirective,
        SessionExpiredComponent,
        ThreadexceptiondialogComponent,
        ProgressBarComponent,
        RichtextboxComponent,
        ComboBoxJqueryComponent,
        TableLayoutPanelComponent,
        TableRowComponent,
        LinkLabelComponent,
        TrackbarComponent,
        NotifyIconComponent,
        SplitContainerBaseComponent,
        SplitContainerComponent,
        SplitStaticContainerComponent,
        InputBoxComponent,
        ShapeComponent,
        ToolStripLabelComponent,
        ToolStripTextBoxComponent,
        ToolStripMenuItemComponent,
        ToolStripComboBoxComponent,
        ToolStripButtonComponent,
        ToolStripDropdownButtonComponent,
        ToolStripStatusLabelComponent,
        UserControlComponent,
        CustomControlContainerComponent,
        SimpleAutoSizeComponent,
        WmusercontrolComponent,
        BackgroundWorkerComponent,
        ControlComponent,
        ControlsDirective,
        TabDirective,
        DialogBaseComponent,
        BindingnavigatorComponent,
        SplitContainerPanelBaseComponent,
        SplitterStaticPanelComponent,
        SplitContainerPanelComponent,
        ColorDialogComponent,
        FontDialogComponent,
        HscrollbarComponent,
        ScrollBarComponent,
        VscrollbarComponent,
        ContainerDirective,
        TDBNumberComponent,
        ChartComponent] });
WebMapKendoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebMapKendoModule, providers: [
        WebMapService,
        FocusManagerService,
        WebComponentsService,
        AnchorService,
        MainTabOrderService,
        ToolstripInteractionService,
        ClientCustomUpdateService
    ], imports: [CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        ButtonsModule,
        ChartsModule,
        DragAndDropModule,
        DateInputsModule,
        LabelModule,
        DialogsModule,
        LayoutModule,
        WebMapModule,
        BaseComponentsModule,
        GridModule,
        InputsModule,
        DropDownsModule,
        TreeViewModule,
        PopupModule,
        MenuModule,
        GaugesModule,
        TooltipModule,
        ProgressBarModule,
        ToolBarModule,
        EditorModule,
        ChartsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebMapKendoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        MonthCalendarComponent,
                        UserControlComponent,
                        FormComponent,
                        GridComponent,
                        ListBoxBaseComponent,
                        TextBoxBaseComponent,
                        SessionExpiredComponent,
                        LabelComponent,
                        WMWindowComponent,
                        ButtonComponent,
                        TextBoxComponent,
                        MessageBoxComponent,
                        CheckBoxComponent,
                        DatetimepickerComponent,
                        PictureBoxComponent,
                        TimerComponent,
                        GroupBoxComponent,
                        PanelComponent,
                        RadiobuttonComponent,
                        MaskedTextBoxComponent,
                        ListViewComponent,
                        ListViewBaseComponent,
                        ListViewListComponent,
                        ListViewDetailsComponent,
                        DataGridViewFlexComponent,
                        ListBoxComponent,
                        AdoDataControlComponent,
                        ComboBoxComponent,
                        KendoMenuComponent,
                        TopLevelToolstripItemComponent,
                        KendoListBoxComponent,
                        KendoComboboxComponent,
                        KendoDropDownListComponent,
                        ToolStripComponent,
                        StatusStripComponent,
                        DataGridViewComponent,
                        FileDialogComponent,
                        PrintDialogComponent,
                        TreeViewComponent,
                        TabPageComponent,
                        TabControlComponent,
                        NumericUpDownComponent,
                        ContextMenuStripComponent,
                        WebBrowserComponent,
                        CheckedListBoxComponent,
                        DisabledItemDirective,
                        ThreadexceptiondialogComponent,
                        ProgressBarComponent,
                        RichtextboxComponent,
                        AfterValueChangedDirective,
                        ComboBoxJqueryComponent,
                        ComboBoxBaseComponent,
                        TableLayoutPanelComponent,
                        TableRowComponent,
                        LinkLabelComponent,
                        TrackbarComponent,
                        NotifyIconComponent,
                        SplitContainerBaseComponent,
                        SplitContainerComponent,
                        SplitStaticContainerComponent,
                        InputBoxComponent,
                        ShapeComponent,
                        ToolStripLabelComponent,
                        ToolStripTextBoxComponent,
                        ToolStripMenuItemComponent,
                        ToolStripComboBoxComponent,
                        ToolStripButtonComponent,
                        ToolStripDropdownButtonComponent,
                        ToolStripStatusLabelComponent,
                        SimpleAutoSizeComponent,
                        WmusercontrolComponent,
                        BackgroundWorkerComponent,
                        ControlContainerComponent,
                        ControlComponentBaseComponent,
                        ControlComponent,
                        StubComponent,
                        ControlsDirective,
                        TabDirective,
                        CustomControlContainerComponent,
                        DialogBaseComponent,
                        BindingnavigatorComponent,
                        SplitContainerPanelBaseComponent,
                        SplitContainerPanelComponent,
                        SplitterStaticPanelComponent,
                        ColorDialogComponent,
                        FontDialogComponent,
                        HscrollbarComponent,
                        ScrollBarComponent,
                        VscrollbarComponent,
                        ContainerDirective,
                        TDBNumberComponent,
                        ChartComponent,
                        AfterValueChangedTdbNumberDirective
                    ],
                    exports: [
                        MonthCalendarComponent,
                        UserControlComponent,
                        LabelComponent,
                        WMWindowComponent,
                        ButtonComponent,
                        TextBoxComponent,
                        MessageBoxComponent,
                        CheckBoxComponent,
                        DatetimepickerComponent,
                        PictureBoxComponent,
                        TimerComponent,
                        DatetimepickerComponent,
                        GroupBoxComponent,
                        PanelComponent,
                        MaskedTextBoxComponent,
                        RadiobuttonComponent,
                        ListViewComponent,
                        ListViewComponent,
                        ListViewBaseComponent,
                        ListViewListComponent,
                        ListViewDetailsComponent,
                        DataGridViewFlexComponent,
                        ListBoxComponent,
                        AdoDataControlComponent,
                        ComboBoxComponent,
                        KendoMenuComponent,
                        KendoListBoxComponent,
                        KendoDropDownListComponent,
                        ToolStripComponent,
                        StatusStripComponent,
                        DataGridViewComponent,
                        PrintDialogComponent,
                        FileDialogComponent,
                        TreeViewComponent,
                        TabPageComponent,
                        TabControlComponent,
                        NumericUpDownComponent,
                        ContextMenuStripComponent,
                        WebBrowserComponent,
                        CheckedListBoxComponent,
                        DisabledItemDirective,
                        SessionExpiredComponent,
                        ThreadexceptiondialogComponent,
                        ProgressBarComponent,
                        RichtextboxComponent,
                        ComboBoxJqueryComponent,
                        TableLayoutPanelComponent,
                        TableRowComponent,
                        LinkLabelComponent,
                        TrackbarComponent,
                        NotifyIconComponent,
                        SplitContainerBaseComponent,
                        SplitContainerComponent,
                        SplitStaticContainerComponent,
                        InputBoxComponent,
                        ShapeComponent,
                        ToolStripLabelComponent,
                        ToolStripTextBoxComponent,
                        ToolStripMenuItemComponent,
                        ToolStripComboBoxComponent,
                        ToolStripButtonComponent,
                        ToolStripDropdownButtonComponent,
                        ToolStripStatusLabelComponent,
                        UserControlComponent,
                        CustomControlContainerComponent,
                        SimpleAutoSizeComponent,
                        WmusercontrolComponent,
                        BackgroundWorkerComponent,
                        ControlComponent,
                        ControlsDirective,
                        TabDirective,
                        DialogBaseComponent,
                        BindingnavigatorComponent,
                        SplitContainerPanelBaseComponent,
                        SplitterStaticPanelComponent,
                        SplitContainerPanelComponent,
                        ColorDialogComponent,
                        FontDialogComponent,
                        HscrollbarComponent,
                        ScrollBarComponent,
                        VscrollbarComponent,
                        ContainerDirective,
                        TDBNumberComponent,
                        ChartComponent
                    ],
                    bootstrap: [
                        MonthCalendarComponent,
                        UserControlComponent,
                        LabelComponent,
                        WMWindowComponent,
                        ButtonComponent,
                        TextBoxComponent,
                        MessageBoxComponent,
                        CheckBoxComponent,
                        DatetimepickerComponent,
                        PictureBoxComponent,
                        TimerComponent,
                        DatetimepickerComponent,
                        GroupBoxComponent,
                        PanelComponent,
                        MaskedTextBoxComponent,
                        RadiobuttonComponent,
                        ListViewComponent,
                        ListViewBaseComponent,
                        ListViewListComponent,
                        ListViewDetailsComponent,
                        DataGridViewFlexComponent,
                        ListBoxComponent,
                        AdoDataControlComponent,
                        ComboBoxComponent,
                        KendoMenuComponent,
                        KendoListBoxComponent,
                        KendoDropDownListComponent,
                        ToolStripComponent,
                        StatusStripComponent,
                        DataGridViewComponent,
                        PrintDialogComponent,
                        FileDialogComponent,
                        TreeViewComponent,
                        TabPageComponent,
                        TabControlComponent,
                        NumericUpDownComponent,
                        ContextMenuStripComponent,
                        WebBrowserComponent,
                        CheckedListBoxComponent,
                        SessionExpiredComponent,
                        ThreadexceptiondialogComponent,
                        ComboBoxJqueryComponent,
                        TableLayoutPanelComponent,
                        TableRowComponent,
                        LinkLabelComponent,
                        TrackbarComponent,
                        NotifyIconComponent,
                        SplitContainerBaseComponent,
                        SplitContainerComponent,
                        SplitStaticContainerComponent,
                        InputBoxComponent,
                        ShapeComponent,
                        ToolStripLabelComponent,
                        ToolStripTextBoxComponent,
                        ToolStripMenuItemComponent,
                        ToolStripComboBoxComponent,
                        ToolStripButtonComponent,
                        ToolStripDropdownButtonComponent,
                        ToolStripStatusLabelComponent,
                        SimpleAutoSizeComponent,
                        WmusercontrolComponent,
                        BackgroundWorkerComponent,
                        ControlContainerComponent,
                        CustomControlContainerComponent,
                        StubComponent,
                        DialogBaseComponent,
                        BindingnavigatorComponent,
                        SplitContainerPanelBaseComponent,
                        SplitContainerPanelComponent,
                        SplitterStaticPanelComponent,
                        ColorDialogComponent,
                        FontDialogComponent,
                        HscrollbarComponent,
                        ScrollBarComponent,
                        VscrollbarComponent,
                        TDBNumberComponent
                    ],
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        FormsModule,
                        ReactiveFormsModule,
                        BrowserModule,
                        BrowserAnimationsModule,
                        ButtonsModule,
                        ChartsModule,
                        DragAndDropModule,
                        DateInputsModule,
                        LabelModule,
                        DialogsModule,
                        LayoutModule,
                        WebMapModule,
                        BaseComponentsModule,
                        GridModule,
                        InputsModule,
                        DropDownsModule,
                        TreeViewModule,
                        PopupModule,
                        MenuModule,
                        GaugesModule,
                        TooltipModule,
                        ProgressBarModule,
                        ToolBarModule,
                        EditorModule,
                        ChartsModule
                    ],
                    providers: [
                        WebMapService,
                        FocusManagerService,
                        WebComponentsService,
                        AnchorService,
                        MainTabOrderService,
                        ToolstripInteractionService,
                        ClientCustomUpdateService
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { AdoDataControlComponent, AjaxInteractionBaseService, AnchorService, AnchorStyles, AutoCompleteMode, AutoCompleteSource, AutoSizeMode, BackgroundWorkerComponent, BaseValidatorService, BindingnavigatorComponent, BorderStyle, ButtonComponent, ChartColor, ChartComponent, ChartType, CheckBoxComponent, CheckState, CheckedListBoxComponent, ClientCustomUpdateService, Color, ColorDialogComponent, ColorTranslator, ColumnHeaderStyle, ComboBoxBaseComponent, ComboBoxComponent, ComboBoxJqueryComponent, CompareMethod, ContainerDirective, ContainerInteractionService, ContainerTabOrderService, ContentAlignment, ContextMenuStripComponent, ControlComponent, ControlComponentBaseComponent, ControlContainerComponent, ControlsDirective, Conversion, CustomControlContainerComponent, DataGridViewComponent, DataGridViewFlexComponent, DatesUtils, DatetimepickerComponent, DialogBaseComponent, DisabledItemDirective, DockStyle, DropDownStyle, EditMaskService, Environment, ErrorProvider, EventData, FileDialogComponent, FocusManagerService, Font, FontDialogComponent, FontFamily, FontStyle, FormComponent, GridComponent, GridCustomEditorInteractionService, GridStyle, GroupBoxComponent, HorizontalAlignment, HscrollbarComponent, Information, InputBoxComponent, ItemActivation, KendoComboboxComponent, KendoComponent, KendoDropDownListComponent, KendoEditorCommand, KendoListBoxComponent, KendoMenuComponent, KeyEventArgs, KeyUtils, Keys, LabelComponent, LinkLabelComponent, ListBoxBaseComponent, ListBoxComponent, ListViewBaseComponent, ListViewComponent, ListViewDetailsComponent, ListViewListComponent, MainTabOrderService, MarkForCheck, MaskedTextBoxComponent, MessageBoxAlert, MessageBoxButtons, MessageBoxComponent, MockService, MonthCalendarComponent, MouseButtons, MouseEventArgs, NotifyIconComponent, NumericUpDownComponent, PanelComponent, PictureBoxComponent, Point, PrintDialogComponent, ProgressBarComponent, RadiobuttonComponent, Rectangle, RichTextBoxScrollBars, RichtextboxComponent, ScrollBarComponent, SendKeys, SendKeysService, SessionExpiredComponent, ShapeComponent, ShortcutsService, SimpleAutoSizeComponent, SplitContainerBaseComponent, SplitContainerComponent, SplitContainerPanelBaseComponent, SplitContainerPanelComponent, SplitStaticContainerComponent, SplitterStaticPanelComponent, StatusStripComponent, Strings, Style, TDBNumberComponent, TabControlComponent, TabDirective, TabNode, TabPageComponent, TableLayoutPanelCellBorderStyle, TableLayoutPanelComponent, TableRowComponent, TextAlignEnum, TextBoxBaseComponent, TextBoxComponent, ThreadexceptiondialogComponent, TimerComponent, ToolStripButtonComponent, ToolStripComboBoxComponent, ToolStripComponent, ToolStripDropdownButtonComponent, ToolStripLabelComponent, ToolStripMenuItemComponent, ToolStripStatusLabelComponent, ToolStripTextBoxComponent, TrackbarComponent, TreeNode, TreeViewComponent, UserControlComponent, Utils, VbStrConv, VscrollbarComponent, WMWindowComponent, WMWindowService, WebBrowserComponent, WebComponentsService, WebMapKendoModule, WindowsManagerService, WmusercontrolComponent, getComputedValue };
